webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uniqid = __webpack_require__(62);

var _uniqid2 = _interopRequireDefault(_uniqid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        id: {
            type: String,
            'default': null
        }
    },
    data: function data() {
        return {
            localId_: null,
            uniqueId: (0, _uniqid2['default'])()
        };
    },
    mounted: function mounted() {
        if (!this.$isServer && !this.id && typeof this._uid !== 'undefined') {
            this.localId_ = '__BVID__' + this._uid + '_';
        }
    },

    methods: {
        safeId: function safeId() {
            var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var id = this.id || this.localId_ || null;

            if (!id) {
                return null;
            }

            suffix = String(suffix).replace(/\s+/g, '_');
            return suffix ? id + '_' + suffix + '_' + this.uniqueId : id + ('_' + this.uniqueId);
        }
    }
};

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = new _vue2['default']();

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.debounce = debounce;
exports.browserDetails = browserDetails;
function debounce(func, wait, immediate) {
    var timeout;

    return function () {
        var context = this;
        var args = arguments;
        var callNow = immediate && !timeout;
        var later = function later() {
            timeout = null;

            if (!immediate) {
                func.apply(context, args);
            }
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
            func.apply(context, args);
        }
    };
}

function browserDetails() {
    var ua = navigator.userAgent;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    var tem = void 0;
    var mobile = ua.match(/(Mobile|mobile)/);

    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {
            name: 'IE',
            version: tem[1] || ''
        };
    }

    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(?:OPR|Edge)\/(\d+)/);

        if (tem != null) {
            return {
                name: 'Opera',
                version: tem[1]
            };
        }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }

    return {
        name: M[0],
        version: parseFloat(M[1], 10),
        mobile: mobile !== null
    };
}

var isString = exports.isString = function isString(value) {
    return typeof value === 'string';
};

var isBoolean = exports.isBoolean = function isBoolean(value) {
    return typeof value === 'boolean';
};

var isObject = exports.isObject = function isObject(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
};

var has = exports.has = function has(object, key) {
    return isObject(object) && object.hasOwnProperty(key);
};

var get = exports.get = function get(object, key, defaultValue) {
    return has(object, key) ? object[key] : defaultValue;
};

var px = exports.px = function px(value) {
    return value + 'px';
};

var translate = exports.translate = function translate(x, y) {
    return 'translate(' + x + ', ' + y + ')';
};

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3393d9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_loading_spinner_vue__ = __webpack_require__(286);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_loading_spinner_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3393d9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_loading_spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
var Cookie = {
    cookieExist: function cookieExist(cookieName) {
        var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
        if (match) {
            //console.log(match[2]);
            return true;
        } else {
            //console.log('-- cookie does\'t exist ---');
            //prompt to enter search
            return false;
        }
    },
    getCookieValue: function getCookieValue(cookieName) {
        var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
        if (match) {
            //console.log(match[2]);
            return match[2];
        } else {
            //console.log('-- cookie does\'t exist ---');
            //prompt to enter search
            return false;
        }
    },
    setCookie: function setCookie(cookieName, zipcode) {
        document.cookie = cookieName + '=' + zipcode;
    },
    setPageCookie: function setPageCookie(cName, cValue, expDays) {
        expDays = expDays || 30; // set to 30 days as default
        var date = new Date();
        date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + ";";
    },
    deleteCookie: function deleteCookie(cookieName) {
        document.cookie = cookieName + '=; ' + 'expires = Thu, 01 Jan 1970 00:00:00 GMT';
    },
    getAllCookies: function getAllCookies() {
        console.log(document.cookie);
    }
};

exports.Cookie = Cookie;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initStore = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable no-console */
/* eslint-disable no-undef */


var _lodash = __webpack_require__(23);

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(48);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_vue2['default'].use(_vuex2['default']);

var sessionKey = '.card-selector-data';

var mutations = {
    setItems: function setItems(state, items) {
        state.items = items;
    },
    setState: function setState(state, initState) {
        state = initState;
    },
    updateFilter: function updateFilter(state, filter) {
        var name = filter.name,
            isSelected = filter.isSelected;

        if (isSelected) {
            if (!state.filters.includes(name)) {
                state.filters.push(name);
            }
        } else {
            state.filters = state.filters.filter(function (x) {
                return x !== name;
            });
        }
        state.selectedIds = getters.selectedItems(state).map(function (x) {
            return x.id;
        });
    },
    itemSelectionChanged: function itemSelectionChanged(state, selection) {
        var id = selection.id,
            isSelected = selection.isSelected;

        if (isSelected) {
            if (!state.selectedIds.includes(id)) {
                state.selectedIds.push(id);
            }
        } else {
            state.selectedIds = state.selectedIds.filter(function (x) {
                return x !== id;
            });
        }
        state.selectedIds = state.selectedIds.filter(function (id) {
            return state.items.some(function (x) {
                return x.id === id;
            });
        });
    },
    initialiseStore: function initialiseStore(state) {
        if (sessionStorage.getItem(sessionKey)) {
            this.replaceState(_extends(state, JSON.parse(sessionStorage.getItem(sessionKey))));
        }
    }
};

var getters = {
    availableItems: function availableItems(state) {
        if (state.filters.length === 0) {
            return (0, _lodash.filter)(state.items, function (x) {
                return !(0, _lodash.isEmpty)(x.flags) && x.flags.includes('adults');
            });
        }
        var items = (0, _lodash.filter)(state.items, function (x) {
            if ((0, _lodash.isEmpty)(state.filters) || (0, _lodash.isEmpty)(x.flags)) {
                return true;
            }
            return (0, _lodash.every)(state.filters, function (filter) {
                return x.flags.includes(filter);
            });
        });

        return items;
    },
    selectedItems: function selectedItems(state) {
        var items = getters.availableItems(state);
        return (0, _lodash.filter)(items, function (x) {
            return (0, _lodash.includes)(state.selectedIds, x.id);
        });
    }
};

var actions = {
    addItem: function addItem(context, item) {
        context.commit('setItem', item);
    },
    updateFilter: function updateFilter(context, filter) {
        context.commit('setFilter', filter);
    }
};

var CardSelectorModule = {
    state: {
        items: [],
        selectedIds: [],
        filters: []
    },
    mutations: mutations,
    getters: getters,
    actions: actions
};
var initStore = exports.initStore = function initStore() {
    var store = new _vuex2['default'].Store(CardSelectorModule);
    store.subscribe(function (mutation, state) {
        sessionStorage.setItem(sessionKey, JSON.stringify(state));
    });
    return store;
};
exports['default'] = CardSelectorModule;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_scd_calculator_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_scd_calculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_scd_calculator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_scd_calculator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_scd_calculator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24a4697b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcm_scd_calculator_vue__ = __webpack_require__(483);
function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24a4697b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_scd_calculator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24a4697b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcm_scd_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_kids_primacy_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_kids_primacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_kids_primacy_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_kids_primacy_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_kids_primacy_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0833781a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_risk_kids_primacy_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_kids_primacy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0833781a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_risk_kids_primacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atomic_pagination_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atomic_pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atomic_pagination_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atomic_pagination_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atomic_pagination_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621cb218_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_atomic_pagination_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atomic_pagination_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621cb218_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_atomic_pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _popper = __webpack_require__(53);

var _popper2 = _interopRequireDefault(_popper);

var _clickout = __webpack_require__(219);

var _clickout2 = _interopRequireDefault(_clickout);

var _listenOnRoot = __webpack_require__(220);

var _listenOnRoot2 = _interopRequireDefault(_listenOnRoot);

var _array = __webpack_require__(30);

var _utils = __webpack_require__(18);

var _dom = __webpack_require__(25);

var _keyCodes = __webpack_require__(75);

var _keyCodes2 = _interopRequireDefault(_keyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Dropdown item CSS selectors
var ITEM_SELECTOR = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]';

// eslint-disable-next-line
var VISIBLE_EVENT_TYPES = {
    MOUSE: 'mouse',
    KEYBOARD: 'keyboard'
};

// Popper attachment positions
var AttachmentMap = {
    BOTTOM: 'bottom',
    // Dropdown left Align
    BOTTOMSTART: 'bottom-start',
    // Dropdown Right Align
    BOTTOMEND: 'bottom-end'
};

exports['default'] = {
    mixins: [_clickout2['default'], _listenOnRoot2['default']],
    props: {
        text: {
            // Button label
            type: String,
            'default': ''
        },
        dropup: {
            // place on top if possible
            type: Boolean,
            'default': false
        },
        position: {
            // Right align menu (default is left align)
            type: String,
            'default': AttachmentMap.BOTTOMSTART
        },
        offset: {
            // Number of pixels to offset menu, or a CSS unit value (i.e. 1px, 1rem, etc)
            type: [Number, String],
            'default': 0
        },
        popperOpts: {
            type: Object,
            'default': function _default() {}
        },
        disableMenuEvents: {
            type: Boolean,
            'default': false
        }
    },
    data: function data() {
        return {
            visible: false,
            inNavbar: null,
            visibleEventType: null
        };
    },
    created: function created() {
        // Create non-reactive property
        this._popper = null;
    },
    mounted: function mounted() {
        // To keep one dropdown opened on page
        this.listenOnRoot('bv::dropdown::shown', this.rootCloseListener);
        // Hide when clicked on links
        this.listenOnRoot('clicked::link', this.rootCloseListener);
        // Use new namespaced events
        this.listenOnRoot('bv::link::clicked', this.rootCloseListener);
    },

    /* istanbul ignore next: not easy to test */
    deactivated: function deactivated() {
        // In case we are inside a `<keep-alive>`
        this.visible = false;
        this.setTouchStart(false);
        this.removePopper();
    },

    /* istanbul ignore next: not easy to test */
    beforeDestroy: function beforeDestroy() {
        this.visible = false;
        this.setTouchStart(false);
        this.removePopper();
    },

    watch: {
        visible: function visible(state, old) {
            var _this = this;

            if (state === old) {
                // Avoid duplicated emits
                return;
            }

            // IE11 loves to flicker so we need to actually show the menu after popperJS has calculated the position
            if (state) {
                this.$refs.menu.classList.add('is-shown');

                this.showMenu();

                this.$nextTick(function () {
                    _this.$refs.menu.classList.add('is-visible');
                });
            } else {
                this.hideMenu();
                this.$refs.menu.classList.remove('is-shown');
                this.$refs.menu.classList.remove('is-visible');
            }
        },
        disabled: function disabled(state, old) {
            if (state !== old && state && this.visible) {
                // Hide dropdown if disabled changes to true
                this.visible = false;
            }
        }
    },
    computed: {
        toggler: function toggler() {
            return this.$refs.toggle.$el || this.$refs.toggle;
        }
    },
    methods: {
        showMenu: function showMenu() {
            if (this.disabled) {
                return;
            }
            // TODO: move emit show to visible watcher, to allow cancelling of show
            this.$emit('show');

            // Ensure other menus are closed
            this.emitOnRoot('bv::dropdown::shown', this);

            if (this.position !== 'none') {
                /* istnbul ignore next: can't test popper in JSDOM */
                if (typeof _popper2['default'] === 'undefined') {
                    (0, _utils.warn)('b-dropdown: Popper.js not found. Falling back to CSS positioning.');
                } else {
                    // for dropup with alignment we use the parent element as popper container
                    var element = this.$refs.toggle;

                    // Make sure we have a reference to an element, not a component!
                    element = element.$el || element;

                    // Instantiate popper.js
                    this.createPopper(element);
                }
            } else {
                var arrow = this.$refs.arrow;
                var toggle = this.$refs.toggle;

                this.$nextTick(function () {
                    var arrowPosition = arrow.getBoundingClientRect();
                    var togglePosition = toggle.getBoundingClientRect();

                    arrow.style.left = toggle.offsetLeft + togglePosition.width / 2 - arrowPosition.width / 2 + 'px';
                });
            }

            this.setTouchStart(true);
            this.$emit('shown');
            this.showMenuFocus();
        },
        showMenuFocus: function showMenuFocus() {
            var _this2 = this;

            // Only Focus on the first item if it's a keyboard event
            if (this.visibleEventType === VISIBLE_EVENT_TYPES.KEYBOARD) {
                this.$nextTick(function () {
                    _this2.$nextTick(_this2.focusFirstItem);
                });
            }
        },
        hideMenu: function hideMenu() {
            // TODO: move emit hide to visible watcher, to allow cancelling of hide
            this.$emit('hide');
            this.setTouchStart(false);
            this.emitOnRoot('bv::dropdown::hidden', this);
            this.$emit('hidden');
            this.removePopper();
        },
        createPopper: function createPopper(element) {
            this.removePopper();

            this._popper = new _popper2['default'](element, this.$refs.menu, this.getPopperConfig());
        },
        removePopper: function removePopper() {
            if (this._popper) {
                // Ensure popper event listeners are removed cleanly
                this._popper.destroy();
            }
            this._popper = null;
        },
        getPopperConfig: function getPopperConfig() {
            var placement = AttachmentMap.BOTTOMSTART;

            if (this.position === 'right') {
                // dropdown + right
                placement = AttachmentMap.BOTTOMEND;
            }

            if (this.position === 'center') {
                placement = AttachmentMap.BOTTOM;
            }

            var popperConfig = {
                placement: placement,
                modifiers: {
                    computeStyle: {
                        gpuAcceleration: false
                    },
                    flip: {
                        enabled: false
                    },
                    preventOverflow: {
                        enabled: true,
                        escapeWithReference: true
                    }
                }
            };

            return popperConfig;
        },
        setTouchStart: function setTouchStart(on) {
            var _this3 = this;

            /*
             * If this is a touch-enabled device we add extra
             * empty mouseover listeners to the body's immediate children;
             * only needed because of broken event delegation on iOS
             * https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
             */
            if ('ontouchstart' in document.documentElement) {
                var children = (0, _array.from)(document.body.children);
                children.forEach(function (el) {
                    if (on) {
                        (0, _dom.eventOn)('mouseover', _this3._noop);
                    } else {
                        (0, _dom.eventOff)('mouseover', _this3._noop);
                    }
                });
            }
        },

        /* istanbul ignore next: not easy to test */
        _noop: function _noop() {
            // Do nothing event handler (used in touchstart event handler)
        },
        rootCloseListener: function rootCloseListener(vm) {
            if (vm !== this) {
                this.visible = false;
            }
        },
        clickOutListener: function clickOutListener() {
            this.visible = false;
        },
        show: function show() {
            // Public method to show dropdown
            if (this.disabled) {
                return;
            }
            this.visible = true;
        },
        hide: function hide() {
            // Public method to hide dropdown
            if (this.disabled) {
                return;
            }

            this.visible = false;
        },
        toggle: function toggle(evt) {
            // Called only by a button that toggles the menu
            evt = evt || {};
            var type = evt.type;
            var key = evt.keyCode;

            // make sure to close the dropdown if we're on the toggle button
            if (type === 'keydown' && key === _keyCodes2['default'].ESC) {
                this.visible = false;
                return;
            }

            if (type !== 'click' && !(type === 'keydown' && (key === _keyCodes2['default'].ENTER || key === _keyCodes2['default'].SPACE || key === _keyCodes2['default'].DOWN || key === _keyCodes2['default'].UP))) {
                // We only toggle on Click, Enter, Space, Arrow Down and Arrow Up
                return;
            }

            if (typeof evt.keyCode === 'undefined' && this.visible === false) {
                this.visibleEventType = VISIBLE_EVENT_TYPES.MOUSE;
            } else {
                this.visibleEventType = VISIBLE_EVENT_TYPES.KEYBOARD;
            }

            evt.preventDefault();
            evt.stopPropagation();

            if (this.disabled) {
                this.visible = false;
                return;
            }

            // Toggle visibility
            this.visible = !this.visible;
        },
        click: function click(evt) {
            // Calle only in split button mode, for the split button
            if (this.disabled) {
                this.visible = false;
                return;
            }
            this.$emit('click', evt);
        },

        /* istanbul ignore next: not easy to test */
        onKeydown: function onKeydown(evt) {
            // Called from dropdown menu context
            var key = evt.keyCode;
            var target = evt.target;

            if (key === _keyCodes2['default'].ESC || key === _keyCodes2['default'].SPACE) {
                // Close on ESC or space
                this.onEsc(evt);
            }

            if (!this.disableMenuEvents) {
                if (key === _keyCodes2['default'].TAB) {
                    // Close on tab out
                    this.onTab(evt);
                } else if (key === _keyCodes2['default'].DOWN) {
                    // Down Arrow
                    this.focusNext(evt, false);
                } else if (key === _keyCodes2['default'].UP) {
                    // Up Arrow
                    this.focusNext(evt, true);
                }
            }

            // If menu events are disabled, still close the dropdown when tabbing off
            if (this.disableMenuEvents) {
                var firstItem = this.getFirstItem();
                var lastItem = this.getLastItem();

                if (target === firstItem && key === _keyCodes2['default'].TAB && evt.shiftKey) {
                    this.visible = false;
                }

                if (target === lastItem && key === _keyCodes2['default'].TAB && !(key === _keyCodes2['default'].TAB && evt.shiftKey)) {
                    this.visible = false;
                }
            }
        },

        /* istanbul ignore next: not easy to test */
        onEsc: function onEsc(evt) {
            if (this.visible) {
                this.visible = false;
                evt.preventDefault();
                evt.stopPropagation();

                // Return focus to original trigger button
                this.$nextTick(this.focusToggler);
            }
        },

        /* istanbul ignore next: not easy to test */
        onTab: function onTab(evt) {
            if (this.visible) {
                // TODO: Need special handler for dealing with form inputs
                // Tab, if in a text-like input, we should just focus next item in the dropdown
                // Note: Inputs are in a special .dropdown-form container
                this.visible = false;
            }
        },
        onFocusOut: function onFocusOut(evt) {
            if (this.$refs.menu.contains(evt.relatedTarget)) {
                return;
            }

            this.visible = false;
        },
        focusNext: function focusNext(evt, up) {
            var _this4 = this;

            if (!this.visible) {
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();

            this.$nextTick(function () {
                var items = _this4.getItems();
                if (items.length < 1) {
                    return;
                }

                var index = items.indexOf(evt.target);

                if (up && index > 0) {
                    index--;
                } else if (!up && index < items.length - 1) {
                    index++;
                }

                if (index < 0) {
                    index = 0;
                }

                _this4.focusItem(index, items);
            });
        },
        focusItem: function focusItem(idx, items) {
            var el = items.find(function (el, i) {
                return i === idx;
            });

            if (el && (0, _dom.getAttr)(el, 'tabindex') !== '-1') {
                el.focus();
            }
        },
        getItems: function getItems() {
            // Get all items
            return this.filterVisible((0, _dom.selectAll)(ITEM_SELECTOR, this.$refs.menu));
        },
        getFirstItem: function getFirstItem() {
            // Get the first non-disabled item
            var item = this.getItems()[0];
            return item || null;
        },
        getLastItem: function getLastItem() {
            var items = this.getItems();
            // Get the first non-disabled item
            var item = items[items.length - 1];
            return item || null;
        },
        focusFirstItem: function focusFirstItem() {
            var item = this.getFirstItem();

            if (item) {
                this.focusItem(0, [item]);
            }
        },
        focusToggler: function focusToggler() {
            var toggler = this.toggler;

            if (toggler && toggler.focus) {
                toggler.focus();
            }
        },
        filterVisible: function filterVisible(els) {
            return (els || []).filter(_dom.isVisible);
        }
    }
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Key Codes (events)
 */

exports["default"] = {
    SPACE: 32,
    ENTER: 13,
    ESC: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PAGEUP: 33,
    PAGEDOWN: 34,
    HOME: 36,
    END: 35,
    TAB: 9
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _triggerPageGoals2 = __webpack_require__(323);

var _triggerPageGoals3 = _interopRequireDefault(_triggerPageGoals2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable */


exports['default'] = {
    methods: {
        triggerPageGoals: function triggerPageGoals(dataTrackingString) {
            // this.goalsObj = JSON.parse(this.goals.replace(/'/g, '"'));
            var data = JSON.parse(dataTrackingString.replace(/'/g, '"'));

            var goalId = data.goalId,
                pageEvent = _objectWithoutProperties(data, ['goalId']);

            var goalObj = { 'goalId': goalId };
            var pageEventObj = pageEvent;

            _triggerPageGoals3['default'].post('/aha-service/analytics/TriggerGoal', goalObj);
            _triggerPageGoals3['default'].post('/aha-service/analytics/trackevent', pageEventObj);
        }
    }
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    post: function post(itemId, text, datasourceId) {
        var endpoint = '/aha-service/Promo/RegisterEvent';

        // Add analytics call
        return (0, _axios2['default'])({
            method: 'post',
            url: endpoint,
            responseType: 'text',
            data: {
                'itemID': itemId,
                'text': text,
                'datasourceId': datasourceId
            }
        })['catch'](function (error) {
            // eslint-disable-next-line
            console.log('RegisterEvent error: ' + error);
        });
    }
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// const STORAGE_KEY = 'grocery-list';

var itemsStorageFunc = exports.itemsStorageFunc = {
    fetch: function fetch(key) {
        var items = JSON.parse(window.localStorage.getItem(key)) || [];
        items.forEach(function (item, index) {
            item.id = index;
        });
        itemsStorageFunc.uid = items.length;
        return items;
    },
    save: function save(key, items) {
        window.localStorage.setItem(key, JSON.stringify(items));
    }
};

var itemsStorageFilters = exports.itemsStorageFilters = {
    all: function all(items) {
        return items;
    },
    active: function active(items) {
        return items.filter(function (item) {
            return !item.completed;
        });
    },
    completed: function completed(items) {
        return items.filter(function (item) {
            return item.completed;
        });
    }
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


exports.__esModule = true;
exports.age_oth_spline = exports.age_scd_spline = exports.grad_scd_spline = exports.la_scd_spline = exports.lvpwd_scd_spline = exports.ivsd_scd_spline = void 0;
function ivsd_scd_spline(x) {
    var value = -0.1719752 + 0.0095584661 * x + +0.00059326221 * Math.pow(Math.max(x - 2.1238109, 0), 3) - 0.0010151615 * Math.pow(Math.max(x - 3.1601452, 0), 3) + 0.00075740801 * Math.pow(Math.max(x - 4.1964794, 0), 3) - 0.00052619578 * Math.pow(Math.max(x - 5.2328137, 0), 3) + 0.00021416819 * Math.pow(Math.max(x - 6.269148, 0), 3) - 0.00011679878 * Math.pow(Math.max(x - 7.3054823, 0), 3) + 5.4269628e-5 * Math.pow(Math.max(x - 8.3418166, 0), 3) - 8.0894406e-5 * Math.pow(Math.max(x - 9.3781509, 0), 3) + 2.6776315e-5 * Math.pow(Math.max(x - 10.414485, 0), 3) - 1.5420039e-5 * Math.pow(Math.max(x - 11.450819, 0), 3) + 1.8179375e-5 * Math.pow(Math.max(x - 12.487154, 0), 3) + 4.7685688e-6 * Math.pow(Math.max(x - 13.523488, 0), 3) - 4.4384636e-6 * Math.pow(Math.max(x - 14.559822, 0), 3) + 9.7867605e-6 * Math.pow(Math.max(x - 15.596157, 0), 3) + 5.688403e-5 * Math.pow(Math.max(x - 16.632491, 0), 3) + 3.4342318e-6 * Math.pow(Math.max(x - 17.668825, 0), 3) - 1.67964e-5 * Math.pow(Math.max(x - 18.705159, 0), 3) + 6.9468377e-5 * Math.pow(Math.max(x - 19.741494, 0), 3) + 5.450879e-5 * Math.pow(Math.max(x - 20.777828, 0), 3) - 1.6772112e-5 * Math.pow(Math.max(x - 21.814162, 0), 3) + 7.0124764e-6 * Math.pow(Math.max(x - 22.850497, 0), 3) + 2.1331621e-6 * Math.pow(Math.max(x - 23.886831, 0), 3) - 3.2612304e-6 * Math.pow(Math.max(x - 24.923165, 0), 3) + 1.0373722e-5 * Math.pow(Math.max(x - 25.959499, 0), 3) - 3.7393924e-5 * Math.pow(Math.max(x - 26.995834, 0), 3) - 4.4130474e-5 * Math.pow(Math.max(x - 28.032168, 0), 3) + 1.3229505e-5 * Math.pow(Math.max(x - 29.068502, 0), 3) - 7.2795609e-6 * Math.pow(Math.max(x - 30.104837, 0), 3) + 6.1515528e-6 * Math.pow(Math.max(x - 31.141171, 0), 3) - 6.0109449e-6 * Math.pow(Math.max(x - 32.177505, 0), 3) + 9.050903e-6 * Math.pow(Math.max(x - 33.213839, 0), 3) - 1.5117855e-5 * Math.pow(Math.max(x - 34.250174, 0), 3) + 3.377287e-5 * Math.pow(Math.max(x - 35.286508, 0), 3) - 5.805769e-5 * Math.pow(Math.max(x - 36.322842, 0), 3) + 0.00010756232 * Math.pow(Math.max(x - 37.359177, 0), 3) - 0.00022329268 * Math.pow(Math.max(x - 38.395511, 0), 3) + 0.00030500188 * Math.pow(Math.max(x - 39.431845, 0), 3) - 0.00042136726 * Math.pow(Math.max(x - 40.468179, 0), 3) + 0.00025118619 * Math.pow(Math.max(x - 41.504514, 0), 3);
    return value;
}
exports.ivsd_scd_spline = ivsd_scd_spline;
function lvpwd_scd_spline(x) {
    var value = -0.027004954 + 0.011195731 * x - 6.8557693e-5 * Math.pow(Math.max(x + 2.0704811, 0), 3) + 0.00011854387 * Math.pow(Math.max(x + 1.2953533, 0), 3) - 8.6817774e-5 * Math.pow(Math.max(x + 0.52022546, 0), 3) + 4.8161685e-5 * Math.pow(Math.max(x - 0.25490235, 0), 3) - 3.0935023e-5 * Math.pow(Math.max(x - 1.0300302, 0), 3) + 1.6235797e-5 * Math.pow(Math.max(x - 1.805158, 0), 3) - 8.6688756e-6 * Math.pow(Math.max(x - 2.5802858, 0), 3) + 4.6415571e-6 * Math.pow(Math.max(x - 3.3554136, 0), 3) - 2.4918127e-6 * Math.pow(Math.max(x - 4.1305414, 0), 3) + 1.3480155e-6 * Math.pow(Math.max(x - 4.9056692, 0), 3) - 7.4818395e-7 * Math.pow(Math.max(x - 5.680797, 0), 3) + 4.5040065e-7 * Math.pow(Math.max(x - 6.4559248, 0), 3) - 3.3578093e-7 * Math.pow(Math.max(x - 7.2310527, 0), 3) + 3.6857401e-7 * Math.pow(Math.max(x - 8.0061805, 0), 3) - 6.6481417e-7 * Math.pow(Math.max(x - 8.7813083, 0), 3) + 1.2539256e-5 * Math.pow(Math.max(x - 9.5564361, 0), 3) + 6.694915e-7 * Math.pow(Math.max(x - 10.331564, 0), 3) - 2.7297155e-7 * Math.pow(Math.max(x - 11.106692, 0), 3) + 1.3844041e-7 * Math.pow(Math.max(x - 11.88182, 0), 3) - 7.4855658e-8 * Math.pow(Math.max(x - 12.656947, 0), 3) + 4.3289963e-8 * Math.pow(Math.max(x - 13.432075, 0), 3) - 2.9416363e-8 * Math.pow(Math.max(x - 14.207203, 0), 3) + 2.7470098e-8 * Math.pow(Math.max(x - 14.982331, 0), 3) - 3.6869316e-8 * Math.pow(Math.max(x - 15.757459, 0), 3) + 6.3262374e-8 * Math.pow(Math.max(x - 16.532586, 0), 3) - 1.329433e-7 * Math.pow(Math.max(x - 17.307714, 0), 3) + 4.5385762e-7 * Math.pow(Math.max(x - 18.082842, 0), 3) + 2.825631e-6 * Math.pow(Math.max(x - 18.85797, 0), 3) - 1.2362917e-6 * Math.pow(Math.max(x - 19.633098, 0), 3) + 1.7314106e-6 * Math.pow(Math.max(x - 20.408225, 0), 3) - 2.9852091e-6 * Math.pow(Math.max(x - 21.183353, 0), 3) + 5.4497048e-6 * Math.pow(Math.max(x - 21.958481, 0), 3) - 1.0111043e-5 * Math.pow(Math.max(x - 22.733609, 0), 3) + 1.8829846e-5 * Math.pow(Math.max(x - 23.508737, 0), 3) - 3.4965962e-5 * Math.pow(Math.max(x - 24.283865, 0), 3) + 6.3746251e-5 * Math.pow(Math.max(x - 25.058992, 0), 3) - 0.00010672746 * Math.pow(Math.max(x - 25.83412, 0), 3) + 0.00014481086 * Math.pow(Math.max(x - 26.609248, 0), 3) - 8.5285693e-5 * Math.pow(Math.max(x - 27.384376, 0), 3);
    return value;
}
exports.lvpwd_scd_spline = lvpwd_scd_spline;
function la_scd_spline(x) {
    var value = -0.21805112 + 0.047516419 * x + 0.0093078902 * Math.pow(Math.max(x + 4.0063473, 0), 3) - 0.016935438 * Math.pow(Math.max(x + 3.7812342, 0), 3) + 0.012512384 * Math.pow(Math.max(x + 3.5561212, 0), 3) - 0.0077411302 * Math.pow(Math.max(x + 3.3310082, 0), 3) + 0.0041185853 * Math.pow(Math.max(x + 3.1058951, 0), 3) - 0.0021751721 * Math.pow(Math.max(x + 2.8807821, 0), 3) + 0.0010820931 * Math.pow(Math.max(x + 2.6556691, 0), 3) - 0.00029264911 * Math.pow(Math.max(x + 2.430556, 0), 3) + 0.0010388125 * Math.pow(Math.max(x + 2.205443, 0), 3) - 0.00042894972 * Math.pow(Math.max(x + 1.98033, 0), 3) + 0.00034161592 * Math.pow(Math.max(x + 1.7552169, 0), 3) - 0.0004530398 * Math.pow(Math.max(x + 1.5301039, 0), 3) + 0.0014570471 * Math.pow(Math.max(x + 1.3049909, 0), 3) + 0.00090558632 * Math.pow(Math.max(x + 1.0798778, 0), 3) - 0.00028835013 * Math.pow(Math.max(x + 0.8547648, 0), 3) + 0.00013275668 * Math.pow(Math.max(x + 0.62965176, 0), 3) - 5.4265851e-5 * Math.pow(Math.max(x + 0.40453873, 0), 3) - 0.00011234727 * Math.pow(Math.max(x + 0.1794257, 0), 3) - 5.5509775e-5 * Math.pow(Math.max(x - 0.045687336, 0), 3) + 3.0398034e-5 * Math.pow(Math.max(x - 0.27080037, 0), 3) - 2.5075571e-5 * Math.pow(Math.max(x - 0.4959134, 0), 3) + 2.5634435e-5 * Math.pow(Math.max(x - 0.72102644, 0), 3) - 0.00045747664 * Math.pow(Math.max(x - 0.94613947, 0), 3) + 0.00016787124 * Math.pow(Math.max(x - 1.1712525, 0), 3) - 0.00028858155 * Math.pow(Math.max(x - 1.3963655, 0), 3) + 0.0005737415 * Math.pow(Math.max(x - 1.6214786, 0), 3) - 0.0016059076 * Math.pow(Math.max(x - 1.8465916, 0), 3) - 0.0042292393 * Math.pow(Math.max(x - 2.0717046, 0), 3) + 0.0010017089 * Math.pow(Math.max(x - 2.2968177, 0), 3) - 0.00068226512 * Math.pow(Math.max(x - 2.5219307, 0), 3) + 0.00078135618 * Math.pow(Math.max(x - 2.7470437, 0), 3) - 0.001633778 * Math.pow(Math.max(x - 2.9721568, 0), 3) + 0.00024048835 * Math.pow(Math.max(x - 3.1972698, 0), 3) - 0.0017523196 * Math.pow(Math.max(x - 3.4223828, 0), 3) + 0.0035930259 * Math.pow(Math.max(x - 3.6474959, 0), 3) - 0.0067820921 * Math.pow(Math.max(x - 3.8726089, 0), 3) + 0.01325814 * Math.pow(Math.max(x - 4.0977219, 0), 3) - 0.013752452 * Math.pow(Math.max(x - 4.322835, 0), 3) + 0.009176904 * Math.pow(Math.max(x - 4.547948, 0), 3);
    return value;
}
exports.la_scd_spline = la_scd_spline;
function grad_scd_spline(x) {
    var value = 0.03126626 - 0.002967774 * x + 1.9395512e-6 * Math.pow(Math.max(x - 3.7485, 0), 3) - 2.0214409e-6 * Math.pow(Math.max(x - 7.497, 0), 3) + 3.2452346e-6 * Math.pow(Math.max(x - 11.2455, 0), 3) - 1.2719091e-6 * Math.pow(Math.max(x - 14.994, 0), 3) - 1.2470431e-7 * Math.pow(Math.max(x - 18.7425, 0), 3) - 8.8556458e-7 * Math.pow(Math.max(x - 22.491, 0), 3) + 4.1128411e-7 * Math.pow(Math.max(x - 26.2395, 0), 3) - 2.6761851e-6 * Math.pow(Math.max(x - 29.988, 0), 3) + 1.861422e-7 * Math.pow(Math.max(x - 33.7365, 0), 3) - 2.949494e-7 * Math.pow(Math.max(x - 37.485, 0), 3) - 3.7687407e-7 * Math.pow(Math.max(x - 41.2335, 0), 3) - 1.5755578e-8 * Math.pow(Math.max(x - 44.982, 0), 3) + 3.9381325e-7 * Math.pow(Math.max(x - 48.7305, 0), 3) + 2.1273289e-7 * Math.pow(Math.max(x - 52.479, 0), 3) - 4.6970192e-8 * Math.pow(Math.max(x - 56.2275, 0), 3) - 8.0613377e-7 * Math.pow(Math.max(x - 59.976, 0), 3) + 9.3334693e-8 * Math.pow(Math.max(x - 63.7245, 0), 3) - 2.7626543e-7 * Math.pow(Math.max(x - 67.473, 0), 3) - 2.0704704e-7 * Math.pow(Math.max(x - 71.2215, 0), 3) - 3.3336145e-7 * Math.pow(Math.max(x - 74.97, 0), 3) + 1.8101318e-6 * Math.pow(Math.max(x - 78.7185, 0), 3) + 9.7428693e-7 * Math.pow(Math.max(x - 82.467, 0), 3) - 3.5286429e-7 * Math.pow(Math.max(x - 86.2155, 0), 3) + 1.4518211e-6 * Math.pow(Math.max(x - 89.964, 0), 3) - 8.6538967e-8 * Math.pow(Math.max(x - 93.7125, 0), 3) + 8.2417514e-8 * Math.pow(Math.max(x - 97.461, 0), 3) + 1.4074831e-7 * Math.pow(Math.max(x - 101.2095, 0), 3) - 9.3365891e-8 * Math.pow(Math.max(x - 104.958, 0), 3) + 3.4059009e-7 * Math.pow(Math.max(x - 108.7065, 0), 3) + 1.704081e-7 * Math.pow(Math.max(x - 112.455, 0), 3) - 5.7955812e-8 * Math.pow(Math.max(x - 116.2035, 0), 3) - 4.4915466e-7 * Math.pow(Math.max(x - 119.952, 0), 3) - 3.3601658e-8 * Math.pow(Math.max(x - 123.7005, 0), 3) - 3.7149094e-8 * Math.pow(Math.max(x - 127.449, 0), 3) - 7.6023537e-7 * Math.pow(Math.max(x - 131.1975, 0), 3) + 6.6188775e-7 * Math.pow(Math.max(x - 134.946, 0), 3) - 1.1743111e-6 * Math.pow(Math.max(x - 138.6945, 0), 3) + 9.8485466e-7 * Math.pow(Math.max(x - 142.443, 0), 3) - 7.1690146e-7 * Math.pow(Math.max(x - 146.1915, 0), 3);
    return value;
}
exports.grad_scd_spline = grad_scd_spline;
function age_scd_spline(x) {
    var value = -0.24864109 - 0.056752646 * x + 0.0072648507 * Math.pow(Math.max(x - 0.45249005, 0), 3) - 0.0096067153 * Math.pow(Math.max(x - 0.90224225, 0), 3) + 0.0070744081 * Math.pow(Math.max(x - 1.3519944, 0), 3) - 0.0050659281 * Math.pow(Math.max(x - 1.8017466, 0), 3) + 0.0021085265 * Math.pow(Math.max(x - 2.2514988, 0), 3) - 0.0018796947 * Math.pow(Math.max(x - 2.701251, 0), 3) + 0.00025518588 * Math.pow(Math.max(x - 3.1510032, 0), 3) - 0.00084580704 * Math.pow(Math.max(x - 3.6007554, 0), 3) - 0.0008525365 * Math.pow(Math.max(x - 4.0505076, 0), 3) - 2.0163686e-5 * Math.pow(Math.max(x - 4.5002598, 0), 3) - 0.00090456457 * Math.pow(Math.max(x - 4.950012, 0), 3) + 0.00026220773 * Math.pow(Math.max(x - 5.3997642, 0), 3) + 0.00074300654 * Math.pow(Math.max(x - 5.8495164, 0), 3) - 8.2120683e-5 * Math.pow(Math.max(x - 6.2992686, 0), 3) + 0.0014409415 * Math.pow(Math.max(x - 6.7490208, 0), 3) + 0.00010274299 * Math.pow(Math.max(x - 7.198773, 0), 3) - 0.00011118759 * Math.pow(Math.max(x - 7.6485252, 0), 3) + 9.6971335e-5 * Math.pow(Math.max(x - 8.0982774, 0), 3) - 0.00057944958 * Math.pow(Math.max(x - 8.5480296, 0), 3) - 0.00071840786 * Math.pow(Math.max(x - 8.9977818, 0), 3) + 0.0011267962 * Math.pow(Math.max(x - 9.447534, 0), 3) + 0.00061857851 * Math.pow(Math.max(x - 9.8972862, 0), 3) + 0.00045409532 * Math.pow(Math.max(x - 10.347038, 0), 3) + 0.0016700387 * Math.pow(Math.max(x - 10.796791, 0), 3) - 0.00064876787 * Math.pow(Math.max(x - 11.246543, 0), 3) - 0.00088696891 * Math.pow(Math.max(x - 11.696295, 0), 3) + 6.6059614e-6 * Math.pow(Math.max(x - 12.146047, 0), 3) - 0.0013022799 * Math.pow(Math.max(x - 12.595799, 0), 3) + 3.0140968e-6 * Math.pow(Math.max(x - 13.045552, 0), 3) + 0.00064755576 * Math.pow(Math.max(x - 13.495304, 0), 3) + 0.00015066302 * Math.pow(Math.max(x - 13.945056, 0), 3) + 5.0248324e-5 * Math.pow(Math.max(x - 14.394808, 0), 3) + 0.00058617184 * Math.pow(Math.max(x - 14.84456, 0), 3) - 0.0018771192 * Math.pow(Math.max(x - 15.294313, 0), 3) - 0.0015062246 * Math.pow(Math.max(x - 15.744065, 0), 3) + 0.00082022983 * Math.pow(Math.max(x - 16.193817, 0), 3) - 0.00029485706 * Math.pow(Math.max(x - 16.643569, 0), 3) + 0.00060587897 * Math.pow(Math.max(x - 17.093321, 0), 3) + 0.0010940752 * Math.pow(Math.max(x - 17.543074, 0), 3);
    return value;
}
exports.age_scd_spline = age_scd_spline;
function age_oth_spline(x) {
    var value = 1.2556848 - 0.41210237 * x + 0.022546978 * Math.pow(Math.max(x - 0.45249005, 0), 3) - 0.032253322 * Math.pow(Math.max(x - 0.90224225, 0), 3) + 0.021971447 * Math.pow(Math.max(x - 1.3519944, 0), 3) - 0.015173718 * Math.pow(Math.max(x - 1.8017466, 0), 3) + 0.0064286581 * Math.pow(Math.max(x - 2.2514988, 0), 3) - 0.0045769696 * Math.pow(Math.max(x - 2.701251, 0), 3) + 0.0011369458 * Math.pow(Math.max(x - 3.1510032, 0), 3) - 0.0011218285 * Math.pow(Math.max(x - 3.6007554, 0), 3) - 0.000112082 * Math.pow(Math.max(x - 4.0505076, 0), 3) - 0.00019283669 * Math.pow(Math.max(x - 4.5002598, 0), 3) - 0.0003018066 * Math.pow(Math.max(x - 4.950012, 0), 3) + 2.2567184e-5 * Math.pow(Math.max(x - 5.3997642, 0), 3) - 0.00011730883 * Math.pow(Math.max(x - 5.8495164, 0), 3) + 2.9251356e-6 * Math.pow(Math.max(x - 6.2992686, 0), 3) + 6.8766369e-5 * Math.pow(Math.max(x - 6.7490208, 0), 3) - 3.4577542e-5 * Math.pow(Math.max(x - 7.198773, 0), 3) + 0.00018183354 * Math.pow(Math.max(x - 7.6485252, 0), 3) - 3.2039427e-5 * Math.pow(Math.max(x - 8.0982774, 0), 3) + 0.00024373467 * Math.pow(Math.max(x - 8.5480296, 0), 3) + 5.8357118e-5 * Math.pow(Math.max(x - 8.9977818, 0), 3) + 0.00017599358 * Math.pow(Math.max(x - 9.447534, 0), 3) + 0.0001797059 * Math.pow(Math.max(x - 9.8972862, 0), 3) + 6.2203499e-5 * Math.pow(Math.max(x - 10.347038, 0), 3) + 0.0002630895 * Math.pow(Math.max(x - 10.796791, 0), 3) - 2.596397e-5 * Math.pow(Math.max(x - 11.246543, 0), 3) + 0.00025041989 * Math.pow(Math.max(x - 11.696295, 0), 3) - 4.585296e-5 * Math.pow(Math.max(x - 12.146047, 0), 3) + 0.00022911074 * Math.pow(Math.max(x - 12.595799, 0), 3) - 3.1166354e-5 * Math.pow(Math.max(x - 13.045552, 0), 3) + 0.00011698762 * Math.pow(Math.max(x - 13.495304, 0), 3) - 1.3930075e-6 * Math.pow(Math.max(x - 13.945056, 0), 3) + 4.9303845e-5 * Math.pow(Math.max(x - 14.394808, 0), 3) + 2.4453737e-5 * Math.pow(Math.max(x - 14.84456, 0), 3) - 1.8680796e-5 * Math.pow(Math.max(x - 15.294313, 0), 3) + 8.708712e-6 * Math.pow(Math.max(x - 15.744065, 0), 3) - 1.7404542e-5 * Math.pow(Math.max(x - 16.193817, 0), 3) + 2.7861472e-5 * Math.pow(Math.max(x - 16.643569, 0), 3) - 3.0711824e-5 * Math.pow(Math.max(x - 17.093321, 0), 3) + 3.7610188e-5 * Math.pow(Math.max(x - 17.543074, 0), 3);
    return value;
}
exports.age_oth_spline = age_oth_spline;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


exports.__esModule = true;
exports.cif_scd = void 0;
var cif_scd = [{
    idx: 1,
    day: 1,
    day_prev_evt: 0,
    hazard0_scd: 0.00090238400408900561,
    surv0_prev: 1,
    cif0_scd: 0.00090238400408900561,
    cumhaz0_scd: 0.00090238400408900561,
    cumhaz0_oth: 0
}, {
    idx: 2,
    day: 2,
    day_prev_evt: 1,
    hazard0_scd: 0,
    surv0_prev: 0.99909761599591096,
    cif0_scd: 0.00090238400408900561,
    cumhaz0_scd: 0.00090238400408900561,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 3,
    day: 9,
    day_prev_evt: 2,
    hazard0_scd: 0.00092240543065620249,
    surv0_prev: 0.99908828339193234,
    cif0_scd: 0.0018239484623947069,
    cumhaz0_scd: 0.001824789434745208,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 4,
    day: 10,
    day_prev_evt: 9,
    hazard0_scd: 0.00093792217859084599,
    surv0_prev: 0.99816671893362663,
    cif0_scd: 0.002760151166013811,
    cumhaz0_scd: 0.002762711613336054,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 5,
    day: 18,
    day_prev_evt: 10,
    hazard0_scd: 0.00098092658379803077,
    surv0_prev: 0.99723051623000747,
    cif0_scd: 0.0037383610895584587,
    cumhaz0_scd: 0.0037436381971340848,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 6,
    day: 30,
    day_prev_evt: 18,
    hazard0_scd: 0.00099996846516481352,
    surv0_prev: 0.99625230630646289,
    cif0_scd: 0.0047345819792126379,
    cumhaz0_scd: 0.0047436066622988981,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 7,
    day: 36,
    day_prev_evt: 30,
    hazard0_scd: 0.0010060576739282965,
    surv0_prev: 0.99525608541680866,
    cif0_scd: 0.0057358670014700545,
    cumhaz0_scd: 0.0057496643362271943,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 8,
    day: 38,
    day_prev_evt: 36,
    hazard0_scd: 0.0010065815565374395,
    surv0_prev: 0.99425480039455127,
    cif0_scd: 0.0067366655460460237,
    cumhaz0_scd: 0.0067562458927646341,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 9,
    day: 43,
    day_prev_evt: 38,
    hazard0_scd: 0.0010196286705253424,
    surv0_prev: 0.99325400184997537,
    cif0_scd: 0.0077494158034462895,
    cumhaz0_scd: 0.0077758745632899766,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 10,
    day: 60,
    day_prev_evt: 43,
    hazard0_scd: 0.0010430462417174333,
    surv0_prev: 0.99224125159257515,
    cif0_scd: 0.008784369311796927,
    cumhaz0_scd: 0.0088189208050074106,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 11,
    day: 67,
    day_prev_evt: 60,
    hazard0_scd: 0.0010486206071063547,
    surv0_prev: 0.99120629808422445,
    cif0_scd: 0.0098237686618616489,
    cumhaz0_scd: 0.0098675414121137655,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 12,
    day: 105,
    day_prev_evt: 67,
    hazard0_scd: 0.0011958234396538636,
    surv0_prev: 0.99016689873415975,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 13,
    day: 147,
    day_prev_evt: 105,
    hazard0_scd: 0,
    surv0_prev: 0.9889828339474841,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 2.0055142557807993e-5
}, {
    idx: 14,
    day: 148,
    day_prev_evt: 147,
    hazard0_scd: 0,
    surv0_prev: 0.98897223787722599,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 3.0782825178681222e-5
}, {
    idx: 15,
    day: 155,
    day_prev_evt: 148,
    hazard0_scd: 0,
    surv0_prev: 0.98896162849693714,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 4.1665279129259625e-5
}, {
    idx: 16,
    day: 162,
    day_prev_evt: 155,
    hazard0_scd: 0,
    surv0_prev: 0.98895086616755623,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 17,
    day: 190,
    day_prev_evt: 162,
    hazard0_scd: 0.0012572204997870534,
    surv0_prev: 0.98893985305600207,
    cif0_scd: 0.012251148904855734,
    cumhaz0_scd: 0.012320585351554683,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 18,
    day: 213,
    day_prev_evt: 190,
    hazard0_scd: 0.0012920533045831487,
    surv0_prev: 0.98769653759968368,
    cif0_scd: 0.013527305480186737,
    cumhaz0_scd: 0.013612638656137831,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 19,
    day: 316,
    day_prev_evt: 213,
    hazard0_scd: 0.0013942778254217162,
    surv0_prev: 0.9864203810243527,
    cif0_scd: 0.014902649543993033,
    cumhaz0_scd: 0.015006916481559548,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 20,
    day: 319,
    day_prev_evt: 316,
    hazard0_scd: 0.0013981427601633925,
    surv0_prev: 0.98504503696054635,
    cif0_scd: 0.016279883130854302,
    cumhaz0_scd: 0.01640505924172294,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 21,
    day: 370,
    day_prev_evt: 319,
    hazard0_scd: 0.0014395251912546602,
    surv0_prev: 0.9836678033736852,
    cif0_scd: 0.01769589771363686,
    cumhaz0_scd: 0.017844584432977602,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 22,
    day: 372,
    day_prev_evt: 370,
    hazard0_scd: 0,
    surv0_prev: 0.98225178879090258,
    cif0_scd: 0.01769589771363686,
    cumhaz0_scd: 0.017844584432977602,
    cumhaz0_oth: 6.5690202969835644e-5
}, {
    idx: 23,
    day: 406,
    day_prev_evt: 372,
    hazard0_scd: 0.0014678377485702527,
    surv0_prev: 0.98223912877606512,
    cif0_scd: 0.019137665384977125,
    cumhaz0_scd: 0.019312422181547856,
    cumhaz0_oth: 6.5690202969835644e-5
}, {
    idx: 24,
    day: 422,
    day_prev_evt: 406,
    hazard0_scd: 0.001478693187654038,
    surv0_prev: 0.98079736110472482,
    cif0_scd: 0.02058796376131174,
    cumhaz0_scd: 0.020791115369201894,
    cumhaz0_oth: 6.5690202969835644e-5
}, {
    idx: 25,
    day: 447,
    day_prev_evt: 422,
    hazard0_scd: 0,
    surv0_prev: 0.97934706272839023,
    cif0_scd: 0.02058796376131174,
    cumhaz0_scd: 0.020791115369201894,
    cumhaz0_oth: 8.0064893329423521e-5
}, {
    idx: 26,
    day: 471,
    day_prev_evt: 447,
    hazard0_scd: 0,
    surv0_prev: 0.9793329849176089,
    cif0_scd: 0.02058796376131174,
    cumhaz0_scd: 0.020791115369201894,
    cumhaz0_oth: 9.4978832789226344e-5
}, {
    idx: 27,
    day: 503,
    day_prev_evt: 471,
    hazard0_scd: 0.0015187911761224103,
    surv0_prev: 0.97931837920476084,
    cif0_scd: 0.022075343874262431,
    cumhaz0_scd: 0.022309906545324304,
    cumhaz0_oth: 9.4978832789226344e-5
}, {
    idx: 28,
    day: 517,
    day_prev_evt: 503,
    hazard0_scd: 0.0015361083858285163,
    surv0_prev: 0.97783099909181015,
    cif0_scd: 0.023577398271890437,
    cumhaz0_scd: 0.02384601493115282,
    cumhaz0_oth: 9.4978832789226344e-5
}, {
    idx: 29,
    day: 536,
    day_prev_evt: 517,
    hazard0_scd: 0,
    surv0_prev: 0.97632894469418208,
    cif0_scd: 0.023577398271890437,
    cumhaz0_scd: 0.02384601493115282,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 30,
    day: 560,
    day_prev_evt: 536,
    hazard0_scd: 0.001610346291560554,
    surv0_prev: 0.97631393227302921,
    cif0_scd: 0.02514960179212521,
    cumhaz0_scd: 0.025456361222713376,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 31,
    day: 597,
    day_prev_evt: 560,
    hazard0_scd: 0.0017208295661744542,
    surv0_prev: 0.97474172875279441,
    cif0_scd: 0.026826966178347018,
    cumhaz0_scd: 0.02717719078888783,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 32,
    day: 606,
    day_prev_evt: 597,
    hazard0_scd: 0.0017248567941370461,
    surv0_prev: 0.97306436436657262,
    cif0_scd: 0.028505362858357346,
    cumhaz0_scd: 0.028902047583024875,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 33,
    day: 655,
    day_prev_evt: 606,
    hazard0_scd: 0.0017664959232422648,
    surv0_prev: 0.97138596768656227,
    cif0_scd: 0.030221312210170402,
    cumhaz0_scd: 0.030668543506267139,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 34,
    day: 666,
    day_prev_evt: 655,
    hazard0_scd: 0.0018035471486557613,
    surv0_prev: 0.9696700183347492,
    cif0_scd: 0.031970157806875017,
    cumhaz0_scd: 0.032472090654922903,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 35,
    day: 674,
    day_prev_evt: 666,
    hazard0_scd: 0.0018110588664977134,
    surv0_prev: 0.96792117273804468,
    cif0_scd: 0.033723120028833119,
    cumhaz0_scd: 0.034283149521420614,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 36,
    day: 804,
    day_prev_evt: 674,
    hazard0_scd: 0.0019724166880940954,
    surv0_prev: 0.96616821051608659,
    cif0_scd: 0.035628806330761056,
    cumhaz0_scd: 0.036255566209514707,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 37,
    day: 819,
    day_prev_evt: 804,
    hazard0_scd: 0.0020185181749401222,
    surv0_prev: 0.96426252421415859,
    cif0_scd: 0.037575187761300977,
    cumhaz0_scd: 0.038274084384454829,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 38,
    day: 876,
    day_prev_evt: 819,
    hazard0_scd: 0.0041662302341108435,
    surv0_prev: 0.96231614278361866,
    cif0_scd: 0.041584418370139015,
    cumhaz0_scd: 0.042440314618565671,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 39,
    day: 950,
    day_prev_evt: 876,
    hazard0_scd: 0.0021320849763656752,
    surv0_prev: 0.95830691217478059,
    cif0_scd: 0.043627610140334248,
    cumhaz0_scd: 0.044572399594931346,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 40,
    day: 982,
    day_prev_evt: 950,
    hazard0_scd: 0.0021488102854200085,
    surv0_prev: 0.9562637204045854,
    cif0_scd: 0.045682439458313621,
    cumhaz0_scd: 0.046721209880351354,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 41,
    day: 990,
    day_prev_evt: 982,
    hazard0_scd: 0.0021560276274581757,
    surv0_prev: 0.954208891086606,
    cif0_scd: 0.047739740189862573,
    cumhaz0_scd: 0.048877237507809528,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 42,
    day: 1102,
    day_prev_evt: 990,
    hazard0_scd: 0.0023683659082828134,
    surv0_prev: 0.95215159035505703,
    cif0_scd: 0.049994783555976752,
    cumhaz0_scd: 0.051245603416092342,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 43,
    day: 1123,
    day_prev_evt: 1102,
    hazard0_scd: 0.0023800782420519131,
    surv0_prev: 0.94989654698894288,
    cif0_scd: 0.052255611659665378,
    cumhaz0_scd: 0.053625681658144256,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 44,
    day: 1243,
    day_prev_evt: 1123,
    hazard0_scd: 0.0025260454905649864,
    surv0_prev: 0.94763571888525433,
    cif0_scd: 0.054649382594053789,
    cumhaz0_scd: 0.056151727148709245,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 45,
    day: 1439,
    day_prev_evt: 1243,
    hazard0_scd: 0.0028678702524820468,
    surv0_prev: 0.94524194795086591,
    cif0_scd: 0.057360213857980256,
    cumhaz0_scd: 0.059019597401191289,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 46,
    day: 1630,
    day_prev_evt: 1439,
    hazard0_scd: 0.0030958639680622839,
    surv0_prev: 0.94253111668693945,
    cif0_scd: 0.060278161980908865,
    cumhaz0_scd: 0.062115461369253569,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 47,
    day: 1806,
    day_prev_evt: 1630,
    hazard0_scd: 0.0035862802624046473,
    surv0_prev: 0.93961316856401078,
    cif0_scd: 0.063647878141625466,
    cumhaz0_scd: 0.06570174163165822,
    cumhaz0_oth: 0.00011035522947862124
}];
exports.cif_scd = cif_scd;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


Object.defineProperty(exports, "__esModule", { value: true });
exports.la_systole_z_fml = exports.lvpwd_z_fml = exports.ivsd_z_fml = exports.bsa_fml = void 0;
// Calculates Body Surface Area of Patient
function bsa_fml(w, h) {
    return Math.exp(0.3964 * Math.log(h)) * Math.exp(0.5378 * Math.log(w)) * 0.024265;
}
exports.bsa_fml = bsa_fml;
// Calculates Z-Score of Interventricular Septal Diameter
function ivsd_z_fml(ivsd, bsa) {
    return (ivsd - (0.45686 * Math.pow(bsa, 0.59577) + 0.18722)) / (0.02033 + 0.04698 * bsa);
}
exports.ivsd_z_fml = ivsd_z_fml;
// Calculates Z-Score of Left Ventricular Posterior Wall Diameter
function lvpwd_z_fml(lvpwd, bsa) {
    return (lvpwd - (0.3767 * Math.pow(bsa, 0.72326) + 0.243)) / (0.0371 + 0.02776 * bsa);
}
exports.lvpwd_z_fml = lvpwd_z_fml;
// Calculates Z-Score of Left Atrial Diameter at End Systole
function la_systole_z_fml(la, bsa) {
    return (Math.log10(la) - Math.log10(Math.pow(10, 0.81375 * Math.pow(bsa, 0.20444) - 0.43308))) / (0.07447 - 0.01478 * bsa);
}
exports.la_systole_z_fml = la_systole_z_fml;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


Object.defineProperty(exports, "__esModule", { value: true });
exports.genotype_genotype_scd_spline = exports.genotype_age_oth_spline = exports.genotype_syncope_scd_spline = exports.genotype_nsvt_scd_spline = exports.genotype_age_scd_spline = exports.genotype_grad_scd_spline = exports.genotype_la_scd_spline = exports.genotype_lvpwd_scd_spline = exports.genotype_ivsd_scd_spline = void 0;
function genotype_ivsd_scd_spline(x) {
    var value = -0.14132113 + 0.0087066505 * x + 0.00044088821 * Math.pow(Math.max(x - 2.1238109, 0), 3) - 0.00075732106 * Math.pow(Math.max(x - 3.1601452, 0), 3) + 0.0005652658 * Math.pow(Math.max(x - 4.1964794, 0), 3) - 0.00039345793 * Math.pow(Math.max(x - 5.2328137, 0), 3) + 0.00015962931 * Math.pow(Math.max(x - 6.269148, 0), 3) - 8.7232854e-05 * Math.pow(Math.max(x - 7.3054823, 0), 3) + 4.0917637e-05 * Math.pow(Math.max(x - 8.3418166, 0), 3) - 5.8469264e-05 * Math.pow(Math.max(x - 9.3781509, 0), 3) + 1.9703661e-05 * Math.pow(Math.max(x - 10.414485, 0), 3) - 1.1432966e-05 * Math.pow(Math.max(x - 11.450819, 0), 3) + 1.3778297e-05 * Math.pow(Math.max(x - 12.487154, 0), 3) + 3.7429907e-06 * Math.pow(Math.max(x - 13.523488, 0), 3) - 3.3833302e-06 * Math.pow(Math.max(x - 14.559822, 0), 3) + 7.3319836e-06 * Math.pow(Math.max(x - 15.596157, 0), 3) + 4.2127255e-05 * Math.pow(Math.max(x - 16.632491, 0), 3) + 2.6822845e-06 * Math.pow(Math.max(x - 17.668825, 0), 3) - 1.2731455e-05 * Math.pow(Math.max(x - 18.705159, 0), 3) + 5.2518974e-05 * Math.pow(Math.max(x - 19.741494, 0), 3) + 4.1194632e-05 * Math.pow(Math.max(x - 20.777828, 0), 3) - 1.2685976e-05 * Math.pow(Math.max(x - 21.814162, 0), 3) + 5.3250115e-06 * Math.pow(Math.max(x - 22.850497, 0), 3) + 1.2603302e-06 * Math.pow(Math.max(x - 23.886831, 0), 3) - 2.3434777e-06 * Math.pow(Math.max(x - 24.923165, 0), 3) + 7.5936572e-06 * Math.pow(Math.max(x - 25.959499, 0), 3) - 2.7460806e-05 * Math.pow(Math.max(x - 26.995834, 0), 3) - 3.2446701e-05 * Math.pow(Math.max(x - 28.032168, 0), 3) + 9.7431784e-06 * Math.pow(Math.max(x - 29.068502, 0), 3) - 5.3938806e-06 * Math.pow(Math.max(x - 30.104837, 0), 3) + 5.2968175e-06 * Math.pow(Math.max(x - 31.141171, 0), 3) - 4.3183623e-06 * Math.pow(Math.max(x - 32.177505, 0), 3) + 6.5800402e-06 * Math.pow(Math.max(x - 33.213839, 0), 3) - 1.1277054e-05 * Math.pow(Math.max(x - 34.250174, 0), 3) + 2.2610935e-05 * Math.pow(Math.max(x - 35.286508, 0), 3) - 4.0508946e-05 * Math.pow(Math.max(x - 36.322842, 0), 3) + 7.5482945e-05 * Math.pow(Math.max(x - 37.359177, 0), 3) - 0.0001586563 * Math.pow(Math.max(x - 38.395511, 0), 3) + 0.00021298915 * Math.pow(Math.max(x - 39.431845, 0), 3) - 0.00029497387 * Math.pow(Math.max(x - 40.468179, 0), 3) + 0.00017743113 * Math.pow(Math.max(x - 41.504514, 0), 3);
    return value;
}
exports.genotype_ivsd_scd_spline = genotype_ivsd_scd_spline;
function genotype_lvpwd_scd_spline(x) {
    var value = -0.040131474 + 0.016039118 * x - 9.3644754e-05 * Math.pow(Math.max(x + 2.0704811, 0), 3) + 0.00016191524 * Math.pow(Math.max(x + 1.2953533, 0), 3) - 0.00011869362 * Math.pow(Math.max(x + 0.52022546, 0), 3) + 6.6496916e-05 * Math.pow(Math.max(x - 0.25490235, 0), 3) - 4.1854559e-05 * Math.pow(Math.max(x - 1.0300302, 0), 3) + 2.2033994e-05 * Math.pow(Math.max(x - 1.805158, 0), 3) - 1.1770378e-05 * Math.pow(Math.max(x - 2.5802858, 0), 3) + 6.3025649e-06 * Math.pow(Math.max(x - 3.3554136, 0), 3) - 3.3830228e-06 * Math.pow(Math.max(x - 4.1305414, 0), 3) + 1.8290629e-06 * Math.pow(Math.max(x - 4.9056692, 0), 3) - 1.0131664e-06 * Math.pow(Math.max(x - 5.680797, 0), 3) + 6.0627881e-07 * Math.pow(Math.max(x - 6.4559248, 0), 3) - 4.4585132e-07 * Math.pow(Math.max(x - 7.2310527, 0), 3) + 4.8060112e-07 * Math.pow(Math.max(x - 8.0061805, 0), 3) - 8.5624607e-07 * Math.pow(Math.max(x - 8.7813083, 0), 3) + 1.6066127e-05 * Math.pow(Math.max(x - 9.5564361, 0), 3) + 8.5606508e-07 * Math.pow(Math.max(x - 10.331564, 0), 3) - 3.4842877e-07 * Math.pow(Math.max(x - 11.106692, 0), 3) + 1.7590603e-07 * Math.pow(Math.max(x - 11.88182, 0), 3) - 9.3687124e-08 * Math.pow(Math.max(x - 12.656947, 0), 3) + 5.1595794e-08 * Math.pow(Math.max(x - 13.432075, 0), 3) - 3.0610203e-08 * Math.pow(Math.max(x - 14.207203, 0), 3) + 2.2041717e-08 * Math.pow(Math.max(x - 14.982331, 0), 3) - 2.2633124e-08 * Math.pow(Math.max(x - 15.757459, 0), 3) + 3.4504242e-08 * Math.pow(Math.max(x - 16.532586, 0), 3) - 7.8307837e-08 * Math.pow(Math.max(x - 17.307714, 0), 3) + 3.5405312e-07 * Math.pow(Math.max(x - 18.082842, 0), 3) + 3.0635571e-06 * Math.pow(Math.max(x - 18.85797, 0), 3) - 1.6246596e-06 * Math.pow(Math.max(x - 19.633098, 0), 3) + 2.4489895e-06 * Math.pow(Math.max(x - 20.408225, 0), 3) - 4.3223325e-06 * Math.pow(Math.max(x - 21.183353, 0), 3) + 7.9457871e-06 * Math.pow(Math.max(x - 21.958481, 0), 3) - 1.4771909e-05 * Math.pow(Math.max(x - 22.733609, 0), 3) + 2.752572e-05 * Math.pow(Math.max(x - 23.508737, 0), 3) - 5.112165e-05 * Math.pow(Math.max(x - 24.283865, 0), 3) + 9.3199287e-05 * Math.pow(Math.max(x - 25.058992, 0), 3) - 0.00015600275 * Math.pow(Math.max(x - 25.83412, 0), 3) + 0.00021144589 * Math.pow(Math.max(x - 26.609248, 0), 3) - 0.00012277562 * Math.pow(Math.max(x - 27.384376, 0), 3);
    return value;
}
exports.genotype_lvpwd_scd_spline = genotype_lvpwd_scd_spline;
function genotype_la_scd_spline(x) {
    var value = -0.21117294 + 0.044649443 * x + 0.0089636577 * Math.pow(Math.max(x + 4.0063473, 0), 3) - 0.016286903 * Math.pow(Math.max(x + 3.7812342, 0), 3) + 0.012034376 * Math.pow(Math.max(x + 3.5561212, 0), 3) - 0.0074221367 * Math.pow(Math.max(x + 3.3310082, 0), 3) + 0.0039581375 * Math.pow(Math.max(x + 3.1058951, 0), 3) - 0.0020913386 * Math.pow(Math.max(x + 2.8807821, 0), 3) + 0.0010419055 * Math.pow(Math.max(x + 2.6556691, 0), 3) - 0.00028746993 * Math.pow(Math.max(x + 2.430556, 0), 3) + 0.00098487146 * Math.pow(Math.max(x + 2.205443, 0), 3) - 0.00040675012 * Math.pow(Math.max(x + 1.98033, 0), 3) + 0.00032202053 * Math.pow(Math.max(x + 1.7552169, 0), 3) - 0.00042422617 * Math.pow(Math.max(x + 1.5301039, 0), 3) + 0.0013596289 * Math.pow(Math.max(x + 1.3049909, 0), 3) + 0.00084470454 * Math.pow(Math.max(x + 1.0798778, 0), 3) - 0.00026980857 * Math.pow(Math.max(x + 0.8547648, 0), 3) + 0.00012591521 * Math.pow(Math.max(x + 0.62965176, 0), 3) - 5.5572862e-05 * Math.pow(Math.max(x + 0.40453873, 0), 3) - 6.792335e-05 * Math.pow(Math.max(x + 0.1794257, 0), 3) - 4.4767072e-05 * Math.pow(Math.max(x - 0.045687336, 0), 3) + 2.6098166e-05 * Math.pow(Math.max(x - 0.27080037, 0), 3) - 2.3064754e-05 * Math.pow(Math.max(x - 0.4959134, 0), 3) + 2.522656e-05 * Math.pow(Math.max(x - 0.72102644, 0), 3) - 0.00042860478 * Math.pow(Math.max(x - 0.94613947, 0), 3) + 0.00016324052 * Math.pow(Math.max(x - 1.1712525, 0), 3) - 0.00028226437 * Math.pow(Math.max(x - 1.3963655, 0), 3) + 0.00056199893 * Math.pow(Math.max(x - 1.6214786, 0), 3) - 0.0015731875 * Math.pow(Math.max(x - 1.8465916, 0), 3) - 0.0041387553 * Math.pow(Math.max(x - 2.0717046, 0), 3) + 0.00097699402 * Math.pow(Math.max(x - 2.2968177, 0), 3) - 0.00066058551 * Math.pow(Math.max(x - 2.5219307, 0), 3) + 0.00074814352 * Math.pow(Math.max(x - 2.7470437, 0), 3) - 0.001524476 * Math.pow(Math.max(x - 2.9721568, 0), 3) + 0.00035868274 * Math.pow(Math.max(x - 3.1972698, 0), 3) - 0.0018094993 * Math.pow(Math.max(x - 3.4223828, 0), 3) + 0.0036555805 * Math.pow(Math.max(x - 3.6474959, 0), 3) - 0.0068722006 * Math.pow(Math.max(x - 3.8726089, 0), 3) + 0.013305343 * Math.pow(Math.max(x - 4.0977219, 0), 3) - 0.014025057 * Math.pow(Math.max(x - 4.322835, 0), 3) + 0.0092380667 * Math.pow(Math.max(x - 4.547948, 0), 3);
    return value;
}
exports.genotype_la_scd_spline = genotype_la_scd_spline;
function genotype_grad_scd_spline(x) {
    var value = 0.025053719 - 0.0023354457 * x + 2.0468284e-06 * Math.pow(Math.max(x - 3.7485, 0), 3) - 2.4279426e-06 * Math.pow(Math.max(x - 7.497, 0), 3) + 2.9588899e-06 * Math.pow(Math.max(x - 11.2455, 0), 3) - 1.3004378e-06 * Math.pow(Math.max(x - 14.994, 0), 3) + 7.5728717e-08 * Math.pow(Math.max(x - 18.7425, 0), 3) - 7.825573e-07 * Math.pow(Math.max(x - 22.491, 0), 3) + 3.6990056e-07 * Math.pow(Math.max(x - 26.2395, 0), 3) - 2.0470628e-06 * Math.pow(Math.max(x - 29.988, 0), 3) + 1.5902967e-07 * Math.pow(Math.max(x - 33.7365, 0), 3) - 2.3728219e-07 * Math.pow(Math.max(x - 37.485, 0), 3) - 2.9754027e-07 * Math.pow(Math.max(x - 41.2335, 0), 3) - 4.8342581e-09 * Math.pow(Math.max(x - 44.982, 0), 3) + 2.709004e-07 * Math.pow(Math.max(x - 48.7305, 0), 3) + 1.4984299e-07 * Math.pow(Math.max(x - 52.479, 0), 3) - 3.4605612e-08 * Math.pow(Math.max(x - 56.2275, 0), 3) - 5.9326429e-07 * Math.pow(Math.max(x - 59.976, 0), 3) + 5.8101958e-08 * Math.pow(Math.max(x - 63.7245, 0), 3) - 1.6934479e-07 * Math.pow(Math.max(x - 67.473, 0), 3) - 6.2733673e-08 * Math.pow(Math.max(x - 71.2215, 0), 3) - 2.8094305e-07 * Math.pow(Math.max(x - 74.97, 0), 3) + 1.416057e-06 * Math.pow(Math.max(x - 78.7185, 0), 3) + 7.5090155e-07 * Math.pow(Math.max(x - 82.467, 0), 3) - 2.7024565e-07 * Math.pow(Math.max(x - 86.2155, 0), 3) + 1.0344746e-06 * Math.pow(Math.max(x - 89.964, 0), 3) - 6.6682066e-08 * Math.pow(Math.max(x - 93.7125, 0), 3) + 6.31547e-08 * Math.pow(Math.max(x - 97.461, 0), 3) + 1.1411714e-07 * Math.pow(Math.max(x - 101.2095, 0), 3) - 7.9290254e-08 * Math.pow(Math.max(x - 104.958, 0), 3) + 2.8971917e-07 * Math.pow(Math.max(x - 108.7065, 0), 3) + 1.406945e-07 * Math.pow(Math.max(x - 112.455, 0), 3) - 4.2615246e-08 * Math.pow(Math.max(x - 116.2035, 0), 3) - 3.2277938e-07 * Math.pow(Math.max(x - 119.952, 0), 3) - 2.3594516e-09 * Math.pow(Math.max(x - 123.7005, 0), 3) - 7.6095773e-08 * Math.pow(Math.max(x - 127.449, 0), 3) - 5.2856189e-07 * Math.pow(Math.max(x - 131.1975, 0), 3) + 3.7930298e-07 * Math.pow(Math.max(x - 134.946, 0), 3) - 7.0000865e-07 * Math.pow(Math.max(x - 138.6945, 0), 3) + 4.2579889e-07 * Math.pow(Math.max(x - 142.443, 0), 3) - 3.7625621e-07 * Math.pow(Math.max(x - 146.1915, 0), 3);
    return value;
}
exports.genotype_grad_scd_spline = genotype_grad_scd_spline;
function genotype_age_scd_spline(x) {
    var value = -0.23491254 - 0.055171045 * x + 0.0068457361 * Math.pow(Math.max(x - 0.45249005, 0), 3) - 0.0090439349 * Math.pow(Math.max(x - 0.90224225, 0), 3) + 0.0066650648 * Math.pow(Math.max(x - 1.3519944, 0), 3) - 0.0047773367 * Math.pow(Math.max(x - 1.8017466, 0), 3) + 0.0019813685 * Math.pow(Math.max(x - 2.2514988, 0), 3) - 0.001765765 * Math.pow(Math.max(x - 2.701251, 0), 3) + 0.00023083049 * Math.pow(Math.max(x - 3.1510032, 0), 3) - 0.00077002367 * Math.pow(Math.max(x - 3.6007554, 0), 3) - 0.00076519645 * Math.pow(Math.max(x - 4.0505076, 0), 3) - 2.5618868e-05 * Math.pow(Math.max(x - 4.5002598, 0), 3) - 0.00083359975 * Math.pow(Math.max(x - 4.950012, 0), 3) + 0.00023877462 * Math.pow(Math.max(x - 5.3997642, 0), 3) + 0.00066180862 * Math.pow(Math.max(x - 5.8495164, 0), 3) - 7.2977217e-05 * Math.pow(Math.max(x - 6.2992686, 0), 3) + 0.0013066694 * Math.pow(Math.max(x - 6.7490208, 0), 3) + 9.4610639e-05 * Math.pow(Math.max(x - 7.198773, 0), 3) - 0.00011307047 * Math.pow(Math.max(x - 7.6485252, 0), 3) + 8.0121926e-05 * Math.pow(Math.max(x - 8.0982774, 0), 3) - 0.00051270812 * Math.pow(Math.max(x - 8.5480296, 0), 3) - 0.00066116463 * Math.pow(Math.max(x - 8.9977818, 0), 3) + 0.0010630305 * Math.pow(Math.max(x - 9.447534, 0), 3) + 0.00060971628 * Math.pow(Math.max(x - 9.8972862, 0), 3) + 0.00039022778 * Math.pow(Math.max(x - 10.347038, 0), 3) + 0.0015138923 * Math.pow(Math.max(x - 10.796791, 0), 3) - 0.00060092256 * Math.pow(Math.max(x - 11.246543, 0), 3) - 0.00085427114 * Math.pow(Math.max(x - 11.696295, 0), 3) + 1.1317874e-05 * Math.pow(Math.max(x - 12.146047, 0), 3) - 0.0012087247 * Math.pow(Math.max(x - 12.595799, 0), 3) + 1.1336257e-06 * Math.pow(Math.max(x - 13.045552, 0), 3) + 0.00063152174 * Math.pow(Math.max(x - 13.495304, 0), 3) + 0.00014340749 * Math.pow(Math.max(x - 13.945056, 0), 3) + 5.3100802e-05 * Math.pow(Math.max(x - 14.394808, 0), 3) + 0.00055229587 * Math.pow(Math.max(x - 14.84456, 0), 3) - 0.0017348524 * Math.pow(Math.max(x - 15.294313, 0), 3) - 0.0013336704 * Math.pow(Math.max(x - 15.744065, 0), 3) + 0.00067941492 * Math.pow(Math.max(x - 16.193817, 0), 3) - 0.00013992824 * Math.pow(Math.max(x - 16.643569, 0), 3) + 0.00038486785 * Math.pow(Math.max(x - 17.093321, 0), 3) + 0.0010748531 * Math.pow(Math.max(x - 17.543074, 0), 3);
    return value;
}
exports.genotype_age_scd_spline = genotype_age_scd_spline;
function genotype_nsvt_scd_spline(x) {
    return 0.948489490309587 * x;
}
exports.genotype_nsvt_scd_spline = genotype_nsvt_scd_spline;
function genotype_syncope_scd_spline(x) {
    return 1.977733751914049 * x;
}
exports.genotype_syncope_scd_spline = genotype_syncope_scd_spline;
function genotype_age_oth_spline(x) {
    var value = 1.2556848 - 0.41210237 * x + 0.022546978 * Math.pow(Math.max(x - 0.45249005, 0), 3) - 0.032253322 * Math.pow(Math.max(x - 0.90224225, 0), 3) + 0.021971447 * Math.pow(Math.max(x - 1.3519944, 0), 3) - 0.015173718 * Math.pow(Math.max(x - 1.8017466, 0), 3) + 0.0064286581 * Math.pow(Math.max(x - 2.2514988, 0), 3) - 0.0045769696 * Math.pow(Math.max(x - 2.701251, 0), 3) + 0.0011369458 * Math.pow(Math.max(x - 3.1510032, 0), 3) - 0.0011218285 * Math.pow(Math.max(x - 3.6007554, 0), 3) - 0.000112082 * Math.pow(Math.max(x - 4.0505076, 0), 3) - 0.0001928367 * Math.pow(Math.max(x - 4.5002598, 0), 3) - 0.0003018066 * Math.pow(Math.max(x - 4.950012, 0), 3) + 2.2567183e-05 * Math.pow(Math.max(x - 5.3997642, 0), 3) - 0.00011730883 * Math.pow(Math.max(x - 5.8495164, 0), 3) + 2.9251352e-06 * Math.pow(Math.max(x - 6.2992686, 0), 3) + 6.8766369e-05 * Math.pow(Math.max(x - 6.7490208, 0), 3) - 3.4577542e-05 * Math.pow(Math.max(x - 7.198773, 0), 3) + 0.00018183354 * Math.pow(Math.max(x - 7.6485252, 0), 3) - 3.2039428e-05 * Math.pow(Math.max(x - 8.0982774, 0), 3) + 0.00024373467 * Math.pow(Math.max(x - 8.5480296, 0), 3) + 5.8357117e-05 * Math.pow(Math.max(x - 8.9977818, 0), 3) + 0.00017599358 * Math.pow(Math.max(x - 9.447534, 0), 3) + 0.0001797059 * Math.pow(Math.max(x - 9.8972862, 0), 3) + 6.2203499e-05 * Math.pow(Math.max(x - 10.347038, 0), 3) + 0.0002630895 * Math.pow(Math.max(x - 10.796791, 0), 3) - 2.596397e-05 * Math.pow(Math.max(x - 11.246543, 0), 3) + 0.00025041989 * Math.pow(Math.max(x - 11.696295, 0), 3) - 4.585296e-05 * Math.pow(Math.max(x - 12.146047, 0), 3) + 0.00022911074 * Math.pow(Math.max(x - 12.595799, 0), 3) - 3.1166354e-05 * Math.pow(Math.max(x - 13.045552, 0), 3) + 0.00011698762 * Math.pow(Math.max(x - 13.495304, 0), 3) - 1.3930075e-06 * Math.pow(Math.max(x - 13.945056, 0), 3) + 4.9303845e-05 * Math.pow(Math.max(x - 14.394808, 0), 3) + 2.4453737e-05 * Math.pow(Math.max(x - 14.84456, 0), 3) - 1.8680796e-05 * Math.pow(Math.max(x - 15.294313, 0), 3) + 8.7087121e-06 * Math.pow(Math.max(x - 15.744065, 0), 3) - 1.7404542e-05 * Math.pow(Math.max(x - 16.193817, 0), 3) + 2.7861472e-05 * Math.pow(Math.max(x - 16.643569, 0), 3) - 3.0711824e-05 * Math.pow(Math.max(x - 17.093321, 0), 3) + 3.7610188e-05 * Math.pow(Math.max(x - 17.543074, 0), 3);
    return value;
}
exports.genotype_age_oth_spline = genotype_age_oth_spline;
function genotype_genotype_scd_spline(x) {
    if (x) {
        return 0.28052145890574648;
    } else {
        return 0;
    }
}
exports.genotype_genotype_scd_spline = genotype_genotype_scd_spline;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


Object.defineProperty(exports, "__esModule", { value: true });
exports.no_genotype_age_oth_spline = exports.no_genotype_genotype_scd_spline = exports.no_genotype_syncope_scd_spline = exports.no_genotype_nsvt_scd_spline = exports.no_genotype_age_scd_spline = exports.no_genotype_grad_scd_spline = exports.no_genotype_la_scd_spline = exports.no_genotype_lvpwd_scd_spline = exports.no_genotype_ivsd_scd_spline = void 0;
function no_genotype_ivsd_scd_spline(x) {
    var value = -0.1719752 + 0.0095584661 * x + +0.00059326221 * Math.pow(Math.max(x - 2.1238109, 0), 3) - 0.0010151615 * Math.pow(Math.max(x - 3.1601452, 0), 3) + 0.00075740801 * Math.pow(Math.max(x - 4.1964794, 0), 3) - 0.00052619578 * Math.pow(Math.max(x - 5.2328137, 0), 3) + 0.00021416819 * Math.pow(Math.max(x - 6.269148, 0), 3) - 0.00011679878 * Math.pow(Math.max(x - 7.3054823, 0), 3) + 5.4269628e-5 * Math.pow(Math.max(x - 8.3418166, 0), 3) - 8.0894406e-5 * Math.pow(Math.max(x - 9.3781509, 0), 3) + 2.6776315e-5 * Math.pow(Math.max(x - 10.414485, 0), 3) - 1.5420039e-5 * Math.pow(Math.max(x - 11.450819, 0), 3) + 1.8179375e-5 * Math.pow(Math.max(x - 12.487154, 0), 3) + 4.7685688e-6 * Math.pow(Math.max(x - 13.523488, 0), 3) - 4.4384636e-6 * Math.pow(Math.max(x - 14.559822, 0), 3) + 9.7867605e-6 * Math.pow(Math.max(x - 15.596157, 0), 3) + 5.688403e-5 * Math.pow(Math.max(x - 16.632491, 0), 3) + 3.4342318e-6 * Math.pow(Math.max(x - 17.668825, 0), 3) - 1.67964e-5 * Math.pow(Math.max(x - 18.705159, 0), 3) + 6.9468377e-5 * Math.pow(Math.max(x - 19.741494, 0), 3) + 5.450879e-5 * Math.pow(Math.max(x - 20.777828, 0), 3) - 1.6772112e-5 * Math.pow(Math.max(x - 21.814162, 0), 3) + 7.0124764e-6 * Math.pow(Math.max(x - 22.850497, 0), 3) + 2.1331621e-6 * Math.pow(Math.max(x - 23.886831, 0), 3) - 3.2612304e-6 * Math.pow(Math.max(x - 24.923165, 0), 3) + 1.0373722e-5 * Math.pow(Math.max(x - 25.959499, 0), 3) - 3.7393924e-5 * Math.pow(Math.max(x - 26.995834, 0), 3) - 4.4130474e-5 * Math.pow(Math.max(x - 28.032168, 0), 3) + 1.3229505e-5 * Math.pow(Math.max(x - 29.068502, 0), 3) - 7.2795609e-6 * Math.pow(Math.max(x - 30.104837, 0), 3) + 6.1515528e-6 * Math.pow(Math.max(x - 31.141171, 0), 3) - 6.0109449e-6 * Math.pow(Math.max(x - 32.177505, 0), 3) + 9.050903e-6 * Math.pow(Math.max(x - 33.213839, 0), 3) - 1.5117855e-5 * Math.pow(Math.max(x - 34.250174, 0), 3) + 3.377287e-5 * Math.pow(Math.max(x - 35.286508, 0), 3) - 5.805769e-5 * Math.pow(Math.max(x - 36.322842, 0), 3) + 0.00010756232 * Math.pow(Math.max(x - 37.359177, 0), 3) - 0.00022329268 * Math.pow(Math.max(x - 38.395511, 0), 3) + 0.00030500188 * Math.pow(Math.max(x - 39.431845, 0), 3) - 0.00042136726 * Math.pow(Math.max(x - 40.468179, 0), 3) + 0.00025118619 * Math.pow(Math.max(x - 41.504514, 0), 3);
    return value;
}
exports.no_genotype_ivsd_scd_spline = no_genotype_ivsd_scd_spline;
function no_genotype_lvpwd_scd_spline(x) {
    var value = -0.027004954 + 0.011195731 * x - 6.8557693e-5 * Math.pow(Math.max(x + 2.0704811, 0), 3) + 0.00011854387 * Math.pow(Math.max(x + 1.2953533, 0), 3) - 8.6817774e-5 * Math.pow(Math.max(x + 0.52022546, 0), 3) + 4.8161685e-5 * Math.pow(Math.max(x - 0.25490235, 0), 3) - 3.0935023e-5 * Math.pow(Math.max(x - 1.0300302, 0), 3) + 1.6235797e-5 * Math.pow(Math.max(x - 1.805158, 0), 3) - 8.6688756e-6 * Math.pow(Math.max(x - 2.5802858, 0), 3) + 4.6415571e-6 * Math.pow(Math.max(x - 3.3554136, 0), 3) - 2.4918127e-6 * Math.pow(Math.max(x - 4.1305414, 0), 3) + 1.3480155e-6 * Math.pow(Math.max(x - 4.9056692, 0), 3) - 7.4818395e-7 * Math.pow(Math.max(x - 5.680797, 0), 3) + 4.5040065e-7 * Math.pow(Math.max(x - 6.4559248, 0), 3) - 3.3578093e-7 * Math.pow(Math.max(x - 7.2310527, 0), 3) + 3.6857401e-7 * Math.pow(Math.max(x - 8.0061805, 0), 3) - 6.6481417e-7 * Math.pow(Math.max(x - 8.7813083, 0), 3) + 1.2539256e-5 * Math.pow(Math.max(x - 9.5564361, 0), 3) + 6.694915e-7 * Math.pow(Math.max(x - 10.331564, 0), 3) - 2.7297155e-7 * Math.pow(Math.max(x - 11.106692, 0), 3) + 1.3844041e-7 * Math.pow(Math.max(x - 11.88182, 0), 3) - 7.4855658e-8 * Math.pow(Math.max(x - 12.656947, 0), 3) + 4.3289963e-8 * Math.pow(Math.max(x - 13.432075, 0), 3) - 2.9416363e-8 * Math.pow(Math.max(x - 14.207203, 0), 3) + 2.7470098e-8 * Math.pow(Math.max(x - 14.982331, 0), 3) - 3.6869316e-8 * Math.pow(Math.max(x - 15.757459, 0), 3) + 6.3262374e-8 * Math.pow(Math.max(x - 16.532586, 0), 3) - 1.329433e-7 * Math.pow(Math.max(x - 17.307714, 0), 3) + 4.5385762e-7 * Math.pow(Math.max(x - 18.082842, 0), 3) + 2.825631e-6 * Math.pow(Math.max(x - 18.85797, 0), 3) - 1.2362917e-6 * Math.pow(Math.max(x - 19.633098, 0), 3) + 1.7314106e-6 * Math.pow(Math.max(x - 20.408225, 0), 3) - 2.9852091e-6 * Math.pow(Math.max(x - 21.183353, 0), 3) + 5.4497048e-6 * Math.pow(Math.max(x - 21.958481, 0), 3) - 1.0111043e-5 * Math.pow(Math.max(x - 22.733609, 0), 3) + 1.8829846e-5 * Math.pow(Math.max(x - 23.508737, 0), 3) - 3.4965962e-5 * Math.pow(Math.max(x - 24.283865, 0), 3) + 6.3746251e-5 * Math.pow(Math.max(x - 25.058992, 0), 3) - 0.00010672746 * Math.pow(Math.max(x - 25.83412, 0), 3) + 0.00014481086 * Math.pow(Math.max(x - 26.609248, 0), 3) - 8.5285693e-5 * Math.pow(Math.max(x - 27.384376, 0), 3);
    return value;
}
exports.no_genotype_lvpwd_scd_spline = no_genotype_lvpwd_scd_spline;
function no_genotype_la_scd_spline(x) {
    var value = -0.21805112 + 0.047516419 * x + 0.0093078902 * Math.pow(Math.max(x + 4.0063473, 0), 3) - 0.016935438 * Math.pow(Math.max(x + 3.7812342, 0), 3) + 0.012512384 * Math.pow(Math.max(x + 3.5561212, 0), 3) - 0.0077411302 * Math.pow(Math.max(x + 3.3310082, 0), 3) + 0.0041185853 * Math.pow(Math.max(x + 3.1058951, 0), 3) - 0.0021751721 * Math.pow(Math.max(x + 2.8807821, 0), 3) + 0.0010820931 * Math.pow(Math.max(x + 2.6556691, 0), 3) - 0.00029264911 * Math.pow(Math.max(x + 2.430556, 0), 3) + 0.0010388125 * Math.pow(Math.max(x + 2.205443, 0), 3) - 0.00042894972 * Math.pow(Math.max(x + 1.98033, 0), 3) + 0.00034161592 * Math.pow(Math.max(x + 1.7552169, 0), 3) - 0.0004530398 * Math.pow(Math.max(x + 1.5301039, 0), 3) + 0.0014570471 * Math.pow(Math.max(x + 1.3049909, 0), 3) + 0.00090558632 * Math.pow(Math.max(x + 1.0798778, 0), 3) - 0.00028835013 * Math.pow(Math.max(x + 0.8547648, 0), 3) + 0.00013275668 * Math.pow(Math.max(x + 0.62965176, 0), 3) - 5.4265851e-5 * Math.pow(Math.max(x + 0.40453873, 0), 3) - 0.00011234727 * Math.pow(Math.max(x + 0.1794257, 0), 3) - 5.5509775e-5 * Math.pow(Math.max(x - 0.045687336, 0), 3) + 3.0398034e-5 * Math.pow(Math.max(x - 0.27080037, 0), 3) - 2.5075571e-5 * Math.pow(Math.max(x - 0.4959134, 0), 3) + 2.5634435e-5 * Math.pow(Math.max(x - 0.72102644, 0), 3) - 0.00045747664 * Math.pow(Math.max(x - 0.94613947, 0), 3) + 0.00016787124 * Math.pow(Math.max(x - 1.1712525, 0), 3) - 0.00028858155 * Math.pow(Math.max(x - 1.3963655, 0), 3) + 0.0005737415 * Math.pow(Math.max(x - 1.6214786, 0), 3) - 0.0016059076 * Math.pow(Math.max(x - 1.8465916, 0), 3) - 0.0042292393 * Math.pow(Math.max(x - 2.0717046, 0), 3) + 0.0010017089 * Math.pow(Math.max(x - 2.2968177, 0), 3) - 0.00068226512 * Math.pow(Math.max(x - 2.5219307, 0), 3) + 0.00078135618 * Math.pow(Math.max(x - 2.7470437, 0), 3) - 0.001633778 * Math.pow(Math.max(x - 2.9721568, 0), 3) + 0.00024048835 * Math.pow(Math.max(x - 3.1972698, 0), 3) - 0.0017523196 * Math.pow(Math.max(x - 3.4223828, 0), 3) + 0.0035930259 * Math.pow(Math.max(x - 3.6474959, 0), 3) - 0.0067820921 * Math.pow(Math.max(x - 3.8726089, 0), 3) + 0.01325814 * Math.pow(Math.max(x - 4.0977219, 0), 3) - 0.013752452 * Math.pow(Math.max(x - 4.322835, 0), 3) + 0.009176904 * Math.pow(Math.max(x - 4.547948, 0), 3);
    return value;
}
exports.no_genotype_la_scd_spline = no_genotype_la_scd_spline;
function no_genotype_grad_scd_spline(x) {
    var value = 0.03126626 - 0.002967774 * x + 1.9395512e-6 * Math.pow(Math.max(x - 3.7485, 0), 3) - 2.0214409e-6 * Math.pow(Math.max(x - 7.497, 0), 3) + 3.2452346e-6 * Math.pow(Math.max(x - 11.2455, 0), 3) - 1.2719091e-6 * Math.pow(Math.max(x - 14.994, 0), 3) - 1.2470431e-7 * Math.pow(Math.max(x - 18.7425, 0), 3) - 8.8556458e-7 * Math.pow(Math.max(x - 22.491, 0), 3) + 4.1128411e-7 * Math.pow(Math.max(x - 26.2395, 0), 3) - 2.6761851e-6 * Math.pow(Math.max(x - 29.988, 0), 3) + 1.861422e-7 * Math.pow(Math.max(x - 33.7365, 0), 3) - 2.949494e-7 * Math.pow(Math.max(x - 37.485, 0), 3) - 3.7687407e-7 * Math.pow(Math.max(x - 41.2335, 0), 3) - 1.5755578e-8 * Math.pow(Math.max(x - 44.982, 0), 3) + 3.9381325e-7 * Math.pow(Math.max(x - 48.7305, 0), 3) + 2.1273289e-7 * Math.pow(Math.max(x - 52.479, 0), 3) - 4.6970192e-8 * Math.pow(Math.max(x - 56.2275, 0), 3) - 8.0613377e-7 * Math.pow(Math.max(x - 59.976, 0), 3) + 9.3334693e-8 * Math.pow(Math.max(x - 63.7245, 0), 3) - 2.7626543e-7 * Math.pow(Math.max(x - 67.473, 0), 3) - 2.0704704e-7 * Math.pow(Math.max(x - 71.2215, 0), 3) - 3.3336145e-7 * Math.pow(Math.max(x - 74.97, 0), 3) + 1.8101318e-6 * Math.pow(Math.max(x - 78.7185, 0), 3) + 9.7428693e-7 * Math.pow(Math.max(x - 82.467, 0), 3) - 3.5286429e-7 * Math.pow(Math.max(x - 86.2155, 0), 3) + 1.4518211e-6 * Math.pow(Math.max(x - 89.964, 0), 3) - 8.6538967e-8 * Math.pow(Math.max(x - 93.7125, 0), 3) + 8.2417514e-8 * Math.pow(Math.max(x - 97.461, 0), 3) + 1.4074831e-7 * Math.pow(Math.max(x - 101.2095, 0), 3) - 9.3365891e-8 * Math.pow(Math.max(x - 104.958, 0), 3) + 3.4059009e-7 * Math.pow(Math.max(x - 108.7065, 0), 3) + 1.704081e-7 * Math.pow(Math.max(x - 112.455, 0), 3) - 5.7955812e-8 * Math.pow(Math.max(x - 116.2035, 0), 3) - 4.4915466e-7 * Math.pow(Math.max(x - 119.952, 0), 3) - 3.3601658e-8 * Math.pow(Math.max(x - 123.7005, 0), 3) - 3.7149094e-8 * Math.pow(Math.max(x - 127.449, 0), 3) - 7.6023537e-7 * Math.pow(Math.max(x - 131.1975, 0), 3) + 6.6188775e-7 * Math.pow(Math.max(x - 134.946, 0), 3) - 1.1743111e-6 * Math.pow(Math.max(x - 138.6945, 0), 3) + 9.8485466e-7 * Math.pow(Math.max(x - 142.443, 0), 3) - 7.1690146e-7 * Math.pow(Math.max(x - 146.1915, 0), 3);
    return value;
}
exports.no_genotype_grad_scd_spline = no_genotype_grad_scd_spline;
function no_genotype_age_scd_spline(x) {
    var value = -0.24864109 - 0.056752646 * x + 0.0072648507 * Math.pow(Math.max(x - 0.45249005, 0), 3) - 0.0096067153 * Math.pow(Math.max(x - 0.90224225, 0), 3) + 0.0070744081 * Math.pow(Math.max(x - 1.3519944, 0), 3) - 0.0050659281 * Math.pow(Math.max(x - 1.8017466, 0), 3) + 0.0021085265 * Math.pow(Math.max(x - 2.2514988, 0), 3) - 0.0018796947 * Math.pow(Math.max(x - 2.701251, 0), 3) + 0.00025518588 * Math.pow(Math.max(x - 3.1510032, 0), 3) - 0.00084580704 * Math.pow(Math.max(x - 3.6007554, 0), 3) - 0.0008525365 * Math.pow(Math.max(x - 4.0505076, 0), 3) - 2.0163686e-5 * Math.pow(Math.max(x - 4.5002598, 0), 3) - 0.00090456457 * Math.pow(Math.max(x - 4.950012, 0), 3) + 0.00026220773 * Math.pow(Math.max(x - 5.3997642, 0), 3) + 0.00074300654 * Math.pow(Math.max(x - 5.8495164, 0), 3) - 8.2120683e-5 * Math.pow(Math.max(x - 6.2992686, 0), 3) + 0.0014409415 * Math.pow(Math.max(x - 6.7490208, 0), 3) + 0.00010274299 * Math.pow(Math.max(x - 7.198773, 0), 3) - 0.00011118759 * Math.pow(Math.max(x - 7.6485252, 0), 3) + 9.6971335e-5 * Math.pow(Math.max(x - 8.0982774, 0), 3) - 0.00057944958 * Math.pow(Math.max(x - 8.5480296, 0), 3) - 0.00071840786 * Math.pow(Math.max(x - 8.9977818, 0), 3) + 0.0011267962 * Math.pow(Math.max(x - 9.447534, 0), 3) + 0.00061857851 * Math.pow(Math.max(x - 9.8972862, 0), 3) + 0.00045409532 * Math.pow(Math.max(x - 10.347038, 0), 3) + 0.0016700387 * Math.pow(Math.max(x - 10.796791, 0), 3) - 0.00064876787 * Math.pow(Math.max(x - 11.246543, 0), 3) - 0.00088696891 * Math.pow(Math.max(x - 11.696295, 0), 3) + 6.6059614e-6 * Math.pow(Math.max(x - 12.146047, 0), 3) - 0.0013022799 * Math.pow(Math.max(x - 12.595799, 0), 3) + 3.0140968e-6 * Math.pow(Math.max(x - 13.045552, 0), 3) + 0.00064755576 * Math.pow(Math.max(x - 13.495304, 0), 3) + 0.00015066302 * Math.pow(Math.max(x - 13.945056, 0), 3) + 5.0248324e-5 * Math.pow(Math.max(x - 14.394808, 0), 3) + 0.00058617184 * Math.pow(Math.max(x - 14.84456, 0), 3) - 0.0018771192 * Math.pow(Math.max(x - 15.294313, 0), 3) - 0.0015062246 * Math.pow(Math.max(x - 15.744065, 0), 3) + 0.00082022983 * Math.pow(Math.max(x - 16.193817, 0), 3) - 0.00029485706 * Math.pow(Math.max(x - 16.643569, 0), 3) + 0.00060587897 * Math.pow(Math.max(x - 17.093321, 0), 3) + 0.0010940752 * Math.pow(Math.max(x - 17.543074, 0), 3);
    return value;
}
exports.no_genotype_age_scd_spline = no_genotype_age_scd_spline;
function no_genotype_nsvt_scd_spline(x) {
    return 1.055781637 * x;
}
exports.no_genotype_nsvt_scd_spline = no_genotype_nsvt_scd_spline;
function no_genotype_syncope_scd_spline(x) {
    return 2.002072082 * x;
}
exports.no_genotype_syncope_scd_spline = no_genotype_syncope_scd_spline;
function no_genotype_genotype_scd_spline(x) {
    return 0;
}
exports.no_genotype_genotype_scd_spline = no_genotype_genotype_scd_spline;
function no_genotype_age_oth_spline(x) {
    var value = 1.2556848 - 0.41210237 * x + 0.022546978 * Math.pow(Math.max(x - 0.45249005, 0), 3) - 0.032253322 * Math.pow(Math.max(x - 0.90224225, 0), 3) + 0.021971447 * Math.pow(Math.max(x - 1.3519944, 0), 3) - 0.015173718 * Math.pow(Math.max(x - 1.8017466, 0), 3) + 0.0064286581 * Math.pow(Math.max(x - 2.2514988, 0), 3) - 0.0045769696 * Math.pow(Math.max(x - 2.701251, 0), 3) + 0.0011369458 * Math.pow(Math.max(x - 3.1510032, 0), 3) - 0.0011218285 * Math.pow(Math.max(x - 3.6007554, 0), 3) - 0.000112082 * Math.pow(Math.max(x - 4.0505076, 0), 3) - 0.00019283669 * Math.pow(Math.max(x - 4.5002598, 0), 3) - 0.0003018066 * Math.pow(Math.max(x - 4.950012, 0), 3) + 2.2567184e-5 * Math.pow(Math.max(x - 5.3997642, 0), 3) - 0.00011730883 * Math.pow(Math.max(x - 5.8495164, 0), 3) + 2.9251356e-6 * Math.pow(Math.max(x - 6.2992686, 0), 3) + 6.8766369e-5 * Math.pow(Math.max(x - 6.7490208, 0), 3) - 3.4577542e-5 * Math.pow(Math.max(x - 7.198773, 0), 3) + 0.00018183354 * Math.pow(Math.max(x - 7.6485252, 0), 3) - 3.2039427e-5 * Math.pow(Math.max(x - 8.0982774, 0), 3) + 0.00024373467 * Math.pow(Math.max(x - 8.5480296, 0), 3) + 5.8357118e-5 * Math.pow(Math.max(x - 8.9977818, 0), 3) + 0.00017599358 * Math.pow(Math.max(x - 9.447534, 0), 3) + 0.0001797059 * Math.pow(Math.max(x - 9.8972862, 0), 3) + 6.2203499e-5 * Math.pow(Math.max(x - 10.347038, 0), 3) + 0.0002630895 * Math.pow(Math.max(x - 10.796791, 0), 3) - 2.596397e-5 * Math.pow(Math.max(x - 11.246543, 0), 3) + 0.00025041989 * Math.pow(Math.max(x - 11.696295, 0), 3) - 4.585296e-5 * Math.pow(Math.max(x - 12.146047, 0), 3) + 0.00022911074 * Math.pow(Math.max(x - 12.595799, 0), 3) - 3.1166354e-5 * Math.pow(Math.max(x - 13.045552, 0), 3) + 0.00011698762 * Math.pow(Math.max(x - 13.495304, 0), 3) - 1.3930075e-6 * Math.pow(Math.max(x - 13.945056, 0), 3) + 4.9303845e-5 * Math.pow(Math.max(x - 14.394808, 0), 3) + 2.4453737e-5 * Math.pow(Math.max(x - 14.84456, 0), 3) - 1.8680796e-5 * Math.pow(Math.max(x - 15.294313, 0), 3) + 8.708712e-6 * Math.pow(Math.max(x - 15.744065, 0), 3) - 1.7404542e-5 * Math.pow(Math.max(x - 16.193817, 0), 3) + 2.7861472e-5 * Math.pow(Math.max(x - 16.643569, 0), 3) - 3.0711824e-5 * Math.pow(Math.max(x - 17.093321, 0), 3) + 3.7610188e-5 * Math.pow(Math.max(x - 17.543074, 0), 3);
    return value;
}
exports.no_genotype_age_oth_spline = no_genotype_age_oth_spline;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


Object.defineProperty(exports, "__esModule", { value: true });
exports.genotype_cif_scd = void 0;
var genotype_cif_scd = [{
    idx: 1,
    day: 1,
    day_prev_evt: 0,
    hazard0_scd: 0.00085866032815686206,
    surv0_prev: 1,
    cif0_scd: 0.00085866032815686206,
    cumhaz0_scd: 0.00085866032815686206,
    cumhaz0_oth: 0
}, {
    idx: 2,
    day: 2,
    day_prev_evt: 1,
    hazard0_scd: 0,
    surv0_prev: 0.99914133967184315,
    cif0_scd: 0.00085866032815686206,
    cumhaz0_scd: 0.00085866032815686206,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 3,
    day: 9,
    day_prev_evt: 2,
    hazard0_scd: 0.00087754589002571662,
    surv0_prev: 0.99913200665944024,
    cif0_scd: 0.0017354445141940008,
    cumhaz0_scd: 0.0017362062181825787,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 4,
    day: 10,
    day_prev_evt: 9,
    hazard0_scd: 0.00089161910526891085,
    surv0_prev: 0.99825522247340304,
    cif0_scd: 0.002625507942485754,
    cumhaz0_scd: 0.0026278253234514894,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 5,
    day: 18,
    day_prev_evt: 10,
    hazard0_scd: 0.00092544902026700168,
    surv0_prev: 0.99736515904511136,
    cif0_scd: 0.0035485185517724945,
    cumhaz0_scd: 0.0035532743437184911,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 6,
    day: 30,
    day_prev_evt: 18,
    hazard0_scd: 0.00094080890628173218,
    surv0_prev: 0.99644214843582457,
    cif0_scd: 0.0044859801996154219,
    cumhaz0_scd: 0.0044940832500002231,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 7,
    day: 36,
    day_prev_evt: 30,
    hazard0_scd: 0.00094541836687532901,
    surv0_prev: 0.99550468678798165,
    cif0_scd: 0.0054271486148152514,
    cumhaz0_scd: 0.0054395016168755517,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 8,
    day: 38,
    day_prev_evt: 36,
    hazard0_scd: 0.0009458930845585023,
    surv0_prev: 0.99456351837278179,
    cif0_scd: 0.0063678993689982389,
    cumhaz0_scd: 0.006385394701434054,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 9,
    day: 43,
    day_prev_evt: 38,
    hazard0_scd: 0.00095686464968055304,
    surv0_prev: 0.9936227676185988,
    cif0_scd: 0.0073186618704502307,
    cumhaz0_scd: 0.0073422593511146073,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 10,
    day: 60,
    day_prev_evt: 43,
    hazard0_scd: 0.00097597860784877561,
    surv0_prev: 0.99267200511714682,
    cif0_scd: 0.0082874885120549167,
    cumhaz0_scd: 0.0083182379589633836,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 11,
    day: 67,
    day_prev_evt: 60,
    hazard0_scd: 0.00098035887799076513,
    surv0_prev: 0.99170317847554212,
    cif0_scd: 0.0092597135274050738,
    cumhaz0_scd: 0.0092985968369541493,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 12,
    day: 105,
    day_prev_evt: 67,
    hazard0_scd: 0.0011236910688447771,
    surv0_prev: 0.99073095346019191,
    cif0_scd: 0.010372989051436363,
    cumhaz0_scd: 0.010422287905798926,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 13,
    day: 147,
    day_prev_evt: 105,
    hazard0_scd: 0,
    surv0_prev: 0.98961767793616062,
    cif0_scd: 0.010372989051436363,
    cumhaz0_scd: 0.010422287905798926,
    cumhaz0_oth: 2.0055142557807993e-5
}, {
    idx: 14,
    day: 148,
    day_prev_evt: 147,
    hazard0_scd: 0,
    surv0_prev: 0.98960707506411461,
    cif0_scd: 0.010372989051436363,
    cumhaz0_scd: 0.010422287905798926,
    cumhaz0_oth: 3.0782825178681222e-5
}, {
    idx: 15,
    day: 155,
    day_prev_evt: 148,
    hazard0_scd: 0,
    surv0_prev: 0.9895964588734939,
    cif0_scd: 0.010372989051436363,
    cumhaz0_scd: 0.010422287905798926,
    cumhaz0_oth: 4.1665279129259625e-5
}, {
    idx: 16,
    day: 162,
    day_prev_evt: 155,
    hazard0_scd: 0,
    surv0_prev: 0.98958568963560067,
    cif0_scd: 0.010372989051436363,
    cumhaz0_scd: 0.010422287905798926,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 17,
    day: 190,
    day_prev_evt: 162,
    hazard0_scd: 0.0011799479356477522,
    surv0_prev: 0.98957466945455308,
    cif0_scd: 0.011540635639828569,
    cumhaz0_scd: 0.011602235841446679,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 18,
    day: 213,
    day_prev_evt: 190,
    hazard0_scd: 0.0012115692442531971,
    surv0_prev: 0.98840702286616078,
    cif0_scd: 0.012738159189537076,
    cumhaz0_scd: 0.012813805085699875,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 19,
    day: 316,
    day_prev_evt: 213,
    hazard0_scd: 0.0013170704035664125,
    surv0_prev: 0.9872094993164523,
    cif0_scd: 0.014038383603206393,
    cumhaz0_scd: 0.014130875489266288,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 20,
    day: 319,
    day_prev_evt: 316,
    hazard0_scd: 0.0013220518840424541,
    surv0_prev: 0.98590927490278302,
    cif0_scd: 0.015341806817586547,
    cumhaz0_scd: 0.015452927373308743,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 21,
    day: 370,
    day_prev_evt: 319,
    hazard0_scd: 0.0013565091193994366,
    surv0_prev: 0.98460585168840287,
    cif0_scd: 0.016677433634415914,
    cumhaz0_scd: 0.01680943649270818,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 22,
    day: 372,
    day_prev_evt: 370,
    hazard0_scd: 0,
    surv0_prev: 0.98327022487157345,
    cif0_scd: 0.016677433634415914,
    cumhaz0_scd: 0.01680943649270818,
    cumhaz0_oth: 6.5690202969835644e-5
}, {
    idx: 23,
    day: 406,
    day_prev_evt: 372,
    hazard0_scd: 0.0013785198828266789,
    surv0_prev: 0.98325755173035023,
    cif0_scd: 0.018032873719415685,
    cumhaz0_scd: 0.018187956375534858,
    cumhaz0_oth: 6.5690202969835644e-5
}, {
    idx: 24,
    day: 422,
    day_prev_evt: 406,
    hazard0_scd: 0.0013869812602269717,
    surv0_prev: 0.98190211164535046,
    cif0_scd: 0.019394753547645076,
    cumhaz0_scd: 0.019574937635761829,
    cumhaz0_oth: 6.5690202969835644e-5
}, {
    idx: 25,
    day: 447,
    day_prev_evt: 422,
    hazard0_scd: 0,
    surv0_prev: 0.98054023181712113,
    cif0_scd: 0.019394753547645076,
    cumhaz0_scd: 0.019574937635761829,
    cumhaz0_oth: 8.0064893329423521e-5
}, {
    idx: 26,
    day: 471,
    day_prev_evt: 447,
    hazard0_scd: 0,
    surv0_prev: 0.98052613685490364,
    cif0_scd: 0.019394753547645076,
    cumhaz0_scd: 0.019574937635761829,
    cumhaz0_oth: 9.4978832789226344e-5
}, {
    idx: 27,
    day: 503,
    day_prev_evt: 471,
    hazard0_scd: 0.0014265544458127602,
    surv0_prev: 0.98051151334745978,
    cif0_scd: 0.020793506606181494,
    cumhaz0_scd: 0.021001492081574591,
    cumhaz0_oth: 9.4978832789226344e-5
}, {
    idx: 28,
    day: 517,
    day_prev_evt: 503,
    hazard0_scd: 0.0014437430054563458,
    surv0_prev: 0.97911276028892336,
    cif0_scd: 0.02220709380540168,
    cumhaz0_scd: 0.022445235087030935,
    cumhaz0_oth: 9.4978832789226344e-5
}, {
    idx: 29,
    day: 536,
    day_prev_evt: 517,
    hazard0_scd: 0,
    surv0_prev: 0.97769917308970322,
    cif0_scd: 0.02220709380540168,
    cumhaz0_scd: 0.022445235087030935,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 30,
    day: 560,
    day_prev_evt: 536,
    hazard0_scd: 0.0015196134105925165,
    surv0_prev: 0.97768413959937484,
    cif0_scd: 0.023692795735260497,
    cumhaz0_scd: 0.023964848497623453,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 31,
    day: 597,
    day_prev_evt: 560,
    hazard0_scd: 0.0016582941068662355,
    surv0_prev: 0.97619843766951608,
    cif0_scd: 0.025311619851579883,
    cumhaz0_scd: 0.025623142604489689,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 32,
    day: 606,
    day_prev_evt: 597,
    hazard0_scd: 0.0016615107972562937,
    surv0_prev: 0.97457961355319667,
    cif0_scd: 0.026930894402284383,
    cumhaz0_scd: 0.027284653401745983,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 33,
    day: 655,
    day_prev_evt: 606,
    hazard0_scd: 0.0017024341708149048,
    surv0_prev: 0.97296033900249224,
    cif0_scd: 0.028587295330249882,
    cumhaz0_scd: 0.028987087572560889,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 34,
    day: 666,
    day_prev_evt: 655,
    hazard0_scd: 0.0017468896456341127,
    surv0_prev: 0.97130393807452664,
    cif0_scd: 0.030284056122435909,
    cumhaz0_scd: 0.030733977218195003,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 35,
    day: 674,
    day_prev_evt: 666,
    hazard0_scd: 0.0017526118502129955,
    surv0_prev: 0.96960717728234069,
    cif0_scd: 0.031983401151392511,
    cumhaz0_scd: 0.032486589068407998,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 36,
    day: 804,
    day_prev_evt: 674,
    hazard0_scd: 0.0019084132007811082,
    surv0_prev: 0.96790783225338406,
    cif0_scd: 0.033830569235604298,
    cumhaz0_scd: 0.034395002269189109,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 37,
    day: 819,
    day_prev_evt: 804,
    hazard0_scd: 0.0019463559491782745,
    surv0_prev: 0.96606066416917225,
    cif0_scd: 0.035710867156577078,
    cumhaz0_scd: 0.036341358218367384,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 38,
    day: 876,
    day_prev_evt: 819,
    hazard0_scd: 0.0040261285059291687,
    surv0_prev: 0.96418036624819947,
    cif0_scd: 0.039592781213986183,
    cumhaz0_scd: 0.040367486724296554,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 39,
    day: 950,
    day_prev_evt: 876,
    hazard0_scd: 0.0020594118146593614,
    surv0_prev: 0.96029845219079035,
    cif0_scd: 0.041570431192026996,
    cumhaz0_scd: 0.042426898538955912,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 40,
    day: 982,
    day_prev_evt: 950,
    hazard0_scd: 0.0020738135588832603,
    surv0_prev: 0.9583208022127494,
    cif0_scd: 0.04355780986541568,
    cumhaz0_scd: 0.044500712097839172,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 41,
    day: 990,
    day_prev_evt: 982,
    hazard0_scd: 0.0020818606026016709,
    surv0_prev: 0.95633342353936079,
    cif0_scd: 0.045548762742833447,
    cumhaz0_scd: 0.04658257270044084,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 42,
    day: 1102,
    day_prev_evt: 990,
    hazard0_scd: 0.0023015725697145459,
    surv0_prev: 0.954342470661943,
    cif0_scd: 0.047745251195422583,
    cumhaz0_scd: 0.048884145270155388,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 43,
    day: 1123,
    day_prev_evt: 1102,
    hazard0_scd: 0.0023109788757970668,
    surv0_prev: 0.95214598220935398,
    cif0_scd: 0.04994564044698345,
    cumhaz0_scd: 0.051195124145952453,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 44,
    day: 1243,
    day_prev_evt: 1123,
    hazard0_scd: 0.0024705588059381824,
    surv0_prev: 0.94994559295779302,
    cif0_scd: 0.052292536896827495,
    cumhaz0_scd: 0.053665682951890635,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 45,
    day: 1439,
    day_prev_evt: 1243,
    hazard0_scd: 0.0027988873827550901,
    surv0_prev: 0.94759869650794903,
    cif0_scd: 0.054944758932398766,
    cumhaz0_scd: 0.056464570334645726,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 46,
    day: 1630,
    day_prev_evt: 1439,
    hazard0_scd: 0.0030031510004927863,
    surv0_prev: 0.94494647447237767,
    cif0_scd: 0.057782575882622617,
    cumhaz0_scd: 0.059467721335138515,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 47,
    day: 1806,
    day_prev_evt: 1630,
    hazard0_scd: 0.0035514213195051033,
    surv0_prev: 0.94210865752215389,
    cif0_scd: 0.061128400654237122,
    cumhaz0_scd: 0.063019142654643617,
    cumhaz0_oth: 0.00011035522947862124
}];
exports.genotype_cif_scd = genotype_cif_scd;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


Object.defineProperty(exports, "__esModule", { value: true });
exports.no_genotype_cif_scd = void 0;
var no_genotype_cif_scd = [{
    idx: 1,
    day: 1,
    day_prev_evt: 0,
    hazard0_scd: 0.00090238400408900561,
    surv0_prev: 1,
    cif0_scd: 0.00090238400408900561,
    cumhaz0_scd: 0.00090238400408900561,
    cumhaz0_oth: 0
}, {
    idx: 2,
    day: 2,
    day_prev_evt: 1,
    hazard0_scd: 0,
    surv0_prev: 0.99909761599591096,
    cif0_scd: 0.00090238400408900561,
    cumhaz0_scd: 0.00090238400408900561,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 3,
    day: 9,
    day_prev_evt: 2,
    hazard0_scd: 0.00092240543065620249,
    surv0_prev: 0.99908828339193234,
    cif0_scd: 0.0018239484623947069,
    cumhaz0_scd: 0.001824789434745208,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 4,
    day: 10,
    day_prev_evt: 9,
    hazard0_scd: 0.00093792217859084599,
    surv0_prev: 0.99816671893362663,
    cif0_scd: 0.002760151166013811,
    cumhaz0_scd: 0.002762711613336054,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 5,
    day: 18,
    day_prev_evt: 10,
    hazard0_scd: 0.00098092658379803077,
    surv0_prev: 0.99723051623000747,
    cif0_scd: 0.0037383610895584587,
    cumhaz0_scd: 0.0037436381971340848,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 6,
    day: 30,
    day_prev_evt: 18,
    hazard0_scd: 0.00099996846516481352,
    surv0_prev: 0.99625230630646289,
    cif0_scd: 0.0047345819792126379,
    cumhaz0_scd: 0.0047436066622988981,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 7,
    day: 36,
    day_prev_evt: 30,
    hazard0_scd: 0.0010060576739282965,
    surv0_prev: 0.99525608541680866,
    cif0_scd: 0.0057358670014700545,
    cumhaz0_scd: 0.0057496643362271943,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 8,
    day: 38,
    day_prev_evt: 36,
    hazard0_scd: 0.0010065815565374395,
    surv0_prev: 0.99425480039455127,
    cif0_scd: 0.0067366655460460237,
    cumhaz0_scd: 0.0067562458927646341,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 9,
    day: 43,
    day_prev_evt: 38,
    hazard0_scd: 0.0010196286705253424,
    surv0_prev: 0.99325400184997537,
    cif0_scd: 0.0077494158034462895,
    cumhaz0_scd: 0.0077758745632899766,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 10,
    day: 60,
    day_prev_evt: 43,
    hazard0_scd: 0.0010430462417174333,
    surv0_prev: 0.99224125159257515,
    cif0_scd: 0.008784369311796927,
    cumhaz0_scd: 0.0088189208050074106,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 11,
    day: 67,
    day_prev_evt: 60,
    hazard0_scd: 0.0010486206071063547,
    surv0_prev: 0.99120629808422445,
    cif0_scd: 0.0098237686618616489,
    cumhaz0_scd: 0.0098675414121137655,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 12,
    day: 105,
    day_prev_evt: 67,
    hazard0_scd: 0.0011958234396538636,
    surv0_prev: 0.99016689873415975,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 9.341033177538588e-6
}, {
    idx: 13,
    day: 147,
    day_prev_evt: 105,
    hazard0_scd: 0,
    surv0_prev: 0.9889828339474841,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 2.0055142557807993e-5
}, {
    idx: 14,
    day: 148,
    day_prev_evt: 147,
    hazard0_scd: 0,
    surv0_prev: 0.98897223787722599,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 3.0782825178681222e-5
}, {
    idx: 15,
    day: 155,
    day_prev_evt: 148,
    hazard0_scd: 0,
    surv0_prev: 0.98896162849693714,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 4.1665279129259625e-5
}, {
    idx: 16,
    day: 162,
    day_prev_evt: 155,
    hazard0_scd: 0,
    surv0_prev: 0.98895086616755623,
    cif0_scd: 0.01100783344853733,
    cumhaz0_scd: 0.01106336485176763,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 17,
    day: 190,
    day_prev_evt: 162,
    hazard0_scd: 0.0012572204997870534,
    surv0_prev: 0.98893985305600207,
    cif0_scd: 0.012251148904855734,
    cumhaz0_scd: 0.012320585351554683,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 18,
    day: 213,
    day_prev_evt: 190,
    hazard0_scd: 0.0012920533045831487,
    surv0_prev: 0.98769653759968368,
    cif0_scd: 0.013527305480186737,
    cumhaz0_scd: 0.013612638656137831,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 19,
    day: 316,
    day_prev_evt: 213,
    hazard0_scd: 0.0013942778254217162,
    surv0_prev: 0.9864203810243527,
    cif0_scd: 0.014902649543993033,
    cumhaz0_scd: 0.015006916481559548,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 20,
    day: 319,
    day_prev_evt: 316,
    hazard0_scd: 0.0013981427601633925,
    surv0_prev: 0.98504503696054635,
    cif0_scd: 0.016279883130854302,
    cumhaz0_scd: 0.01640505924172294,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 21,
    day: 370,
    day_prev_evt: 319,
    hazard0_scd: 0.0014395251912546602,
    surv0_prev: 0.9836678033736852,
    cif0_scd: 0.01769589771363686,
    cumhaz0_scd: 0.017844584432977602,
    cumhaz0_oth: 5.2801435566229743e-5
}, {
    idx: 22,
    day: 372,
    day_prev_evt: 370,
    hazard0_scd: 0,
    surv0_prev: 0.98225178879090258,
    cif0_scd: 0.01769589771363686,
    cumhaz0_scd: 0.017844584432977602,
    cumhaz0_oth: 6.5690202969835644e-5
}, {
    idx: 23,
    day: 406,
    day_prev_evt: 372,
    hazard0_scd: 0.0014678377485702527,
    surv0_prev: 0.98223912877606512,
    cif0_scd: 0.019137665384977125,
    cumhaz0_scd: 0.019312422181547856,
    cumhaz0_oth: 6.5690202969835644e-5
}, {
    idx: 24,
    day: 422,
    day_prev_evt: 406,
    hazard0_scd: 0.001478693187654038,
    surv0_prev: 0.98079736110472482,
    cif0_scd: 0.02058796376131174,
    cumhaz0_scd: 0.020791115369201894,
    cumhaz0_oth: 6.5690202969835644e-5
}, {
    idx: 25,
    day: 447,
    day_prev_evt: 422,
    hazard0_scd: 0,
    surv0_prev: 0.97934706272839023,
    cif0_scd: 0.02058796376131174,
    cumhaz0_scd: 0.020791115369201894,
    cumhaz0_oth: 8.0064893329423521e-5
}, {
    idx: 26,
    day: 471,
    day_prev_evt: 447,
    hazard0_scd: 0,
    surv0_prev: 0.9793329849176089,
    cif0_scd: 0.02058796376131174,
    cumhaz0_scd: 0.020791115369201894,
    cumhaz0_oth: 9.4978832789226344e-5
}, {
    idx: 27,
    day: 503,
    day_prev_evt: 471,
    hazard0_scd: 0.0015187911761224103,
    surv0_prev: 0.97931837920476084,
    cif0_scd: 0.022075343874262431,
    cumhaz0_scd: 0.022309906545324304,
    cumhaz0_oth: 9.4978832789226344e-5
}, {
    idx: 28,
    day: 517,
    day_prev_evt: 503,
    hazard0_scd: 0.0015361083858285163,
    surv0_prev: 0.97783099909181015,
    cif0_scd: 0.023577398271890437,
    cumhaz0_scd: 0.02384601493115282,
    cumhaz0_oth: 9.4978832789226344e-5
}, {
    idx: 29,
    day: 536,
    day_prev_evt: 517,
    hazard0_scd: 0,
    surv0_prev: 0.97632894469418208,
    cif0_scd: 0.023577398271890437,
    cumhaz0_scd: 0.02384601493115282,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 30,
    day: 560,
    day_prev_evt: 536,
    hazard0_scd: 0.001610346291560554,
    surv0_prev: 0.97631393227302921,
    cif0_scd: 0.02514960179212521,
    cumhaz0_scd: 0.025456361222713376,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 31,
    day: 597,
    day_prev_evt: 560,
    hazard0_scd: 0.0017208295661744542,
    surv0_prev: 0.97474172875279441,
    cif0_scd: 0.026826966178347018,
    cumhaz0_scd: 0.02717719078888783,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 32,
    day: 606,
    day_prev_evt: 597,
    hazard0_scd: 0.0017248567941370461,
    surv0_prev: 0.97306436436657262,
    cif0_scd: 0.028505362858357346,
    cumhaz0_scd: 0.028902047583024875,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 33,
    day: 655,
    day_prev_evt: 606,
    hazard0_scd: 0.0017664959232422648,
    surv0_prev: 0.97138596768656227,
    cif0_scd: 0.030221312210170402,
    cumhaz0_scd: 0.030668543506267139,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 34,
    day: 666,
    day_prev_evt: 655,
    hazard0_scd: 0.0018035471486557613,
    surv0_prev: 0.9696700183347492,
    cif0_scd: 0.031970157806875017,
    cumhaz0_scd: 0.032472090654922903,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 35,
    day: 674,
    day_prev_evt: 666,
    hazard0_scd: 0.0018110588664977134,
    surv0_prev: 0.96792117273804468,
    cif0_scd: 0.033723120028833119,
    cumhaz0_scd: 0.034283149521420614,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 36,
    day: 804,
    day_prev_evt: 674,
    hazard0_scd: 0.0019724166880940954,
    surv0_prev: 0.96616821051608659,
    cif0_scd: 0.035628806330761056,
    cumhaz0_scd: 0.036255566209514707,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 37,
    day: 819,
    day_prev_evt: 804,
    hazard0_scd: 0.0020185181749401222,
    surv0_prev: 0.96426252421415859,
    cif0_scd: 0.037575187761300977,
    cumhaz0_scd: 0.038274084384454829,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 38,
    day: 876,
    day_prev_evt: 819,
    hazard0_scd: 0.0041662302341108435,
    surv0_prev: 0.96231614278361866,
    cif0_scd: 0.041584418370139015,
    cumhaz0_scd: 0.042440314618565671,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 39,
    day: 950,
    day_prev_evt: 876,
    hazard0_scd: 0.0021320849763656752,
    surv0_prev: 0.95830691217478059,
    cif0_scd: 0.043627610140334248,
    cumhaz0_scd: 0.044572399594931346,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 40,
    day: 982,
    day_prev_evt: 950,
    hazard0_scd: 0.0021488102854200085,
    surv0_prev: 0.9562637204045854,
    cif0_scd: 0.045682439458313621,
    cumhaz0_scd: 0.046721209880351354,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 41,
    day: 990,
    day_prev_evt: 982,
    hazard0_scd: 0.0021560276274581757,
    surv0_prev: 0.954208891086606,
    cif0_scd: 0.047739740189862573,
    cumhaz0_scd: 0.048877237507809528,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 42,
    day: 1102,
    day_prev_evt: 990,
    hazard0_scd: 0.0023683659082828134,
    surv0_prev: 0.95215159035505703,
    cif0_scd: 0.049994783555976752,
    cumhaz0_scd: 0.051245603416092342,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 43,
    day: 1123,
    day_prev_evt: 1102,
    hazard0_scd: 0.0023800782420519131,
    surv0_prev: 0.94989654698894288,
    cif0_scd: 0.052255611659665378,
    cumhaz0_scd: 0.053625681658144256,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 44,
    day: 1243,
    day_prev_evt: 1123,
    hazard0_scd: 0.0025260454905649864,
    surv0_prev: 0.94763571888525433,
    cif0_scd: 0.054649382594053789,
    cumhaz0_scd: 0.056151727148709245,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 45,
    day: 1439,
    day_prev_evt: 1243,
    hazard0_scd: 0.0028678702524820468,
    surv0_prev: 0.94524194795086591,
    cif0_scd: 0.057360213857980256,
    cumhaz0_scd: 0.059019597401191289,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 46,
    day: 1630,
    day_prev_evt: 1439,
    hazard0_scd: 0.0030958639680622839,
    surv0_prev: 0.94253111668693945,
    cif0_scd: 0.060278161980908865,
    cumhaz0_scd: 0.062115461369253569,
    cumhaz0_oth: 0.00011035522947862124
}, {
    idx: 47,
    day: 1806,
    day_prev_evt: 1630,
    hazard0_scd: 0.0035862802624046473,
    surv0_prev: 0.93961316856401078,
    cif0_scd: 0.063647878141625466,
    cumhaz0_scd: 0.06570174163165822,
    cumhaz0_oth: 0.00011035522947862124
}];
exports.no_genotype_cif_scd = no_genotype_cif_scd;

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable */
/* ! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-objectfit-setclasses !*/

!function (e, n, t) {
  function r(e, n) {
    return (typeof e === "undefined" ? "undefined" : _typeof(e)) === n;
  }function o() {
    var e, n, t, o, i, s, a;for (var l in C) {
      if (C.hasOwnProperty(l)) {
        if (e = [], n = C[l], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++) {
          e.push(n.options.aliases[t].toLowerCase());
        }for (o = r(n.fn, "function") ? n.fn() : n.fn, i = 0; i < e.length; i++) {
          s = e[i], a = s.split("."), 1 === a.length ? Modernizr[a[0]] = o : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = o), h.push((o ? "" : "no-") + a.join("-"));
        }
      }
    }
  }function i(e) {
    var n = _.className,
        t = Modernizr._config.classPrefix || "";if (w && (n = n.baseVal), Modernizr._config.enableJSClass) {
      var r = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");n = n.replace(r, "$1" + t + "js$2");
    }Modernizr._config.enableClasses && (n += " " + t + e.join(" " + t), w ? _.className.baseVal = n : _.className = n);
  }function s(e) {
    return e.replace(/([a-z])-([a-z])/g, function (e, n, t) {
      return n + t.toUpperCase();
    }).replace(/^-/, "");
  }function a(e, n) {
    return !!~("" + e).indexOf(n);
  }function l() {
    return "function" != typeof n.createElement ? n.createElement(arguments[0]) : w ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments);
  }function f(e, n) {
    return function () {
      return e.apply(n, arguments);
    };
  }function u(e, n, t) {
    var o;for (var i in e) {
      if (e[i] in n) return t === !1 ? e[i] : (o = n[e[i]], r(o, "function") ? f(o, t || n) : o);
    }return !1;
  }function p(e) {
    return e.replace(/([A-Z])/g, function (e, n) {
      return "-" + n.toLowerCase();
    }).replace(/^ms-/, "-ms-");
  }function c(n, t, r) {
    var o;if ("getComputedStyle" in e) {
      o = getComputedStyle.call(e, n, t);var i = e.console;if (null !== o) r && (o = o.getPropertyValue(r));else if (i) {
        var s = i.error ? "error" : "log";i[s].call(i, "getComputedStyle returning null, its possible modernizr test results are inaccurate");
      }
    } else o = !t && n.currentStyle && n.currentStyle[r];return o;
  }function d() {
    var e = n.body;return e || (e = l(w ? "svg" : "body"), e.fake = !0), e;
  }function m(e, t, r, o) {
    var i,
        s,
        a,
        f,
        u = "modernizr",
        p = l("div"),
        c = d();if (parseInt(r, 10)) for (; r--;) {
      a = l("div"), a.id = o ? o[r] : u + (r + 1), p.appendChild(a);
    }return i = l("style"), i.type = "text/css", i.id = "s" + u, (c.fake ? c : p).appendChild(i), c.appendChild(p), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(n.createTextNode(e)), p.id = u, c.fake && (c.style.background = "", c.style.overflow = "hidden", f = _.style.overflow, _.style.overflow = "hidden", _.appendChild(c)), s = t(p, e), c.fake ? (c.parentNode.removeChild(c), _.style.overflow = f, _.offsetHeight) : p.parentNode.removeChild(p), !!s;
  }function v(n, r) {
    var o = n.length;if ("CSS" in e && "supports" in e.CSS) {
      for (; o--;) {
        if (e.CSS.supports(p(n[o]), r)) return !0;
      }return !1;
    }if ("CSSSupportsRule" in e) {
      for (var i = []; o--;) {
        i.push("(" + p(n[o]) + ":" + r + ")");
      }return i = i.join(" or "), m("@supports (" + i + ") { #modernizr { position: absolute; } }", function (e) {
        return "absolute" == c(e, null, "position");
      });
    }return t;
  }function y(e, n, o, i) {
    function f() {
      p && (delete P.style, delete P.modElem);
    }if (i = r(i, "undefined") ? !1 : i, !r(o, "undefined")) {
      var u = v(e, o);if (!r(u, "undefined")) return u;
    }for (var p, c, d, m, y, g = ["modernizr", "tspan", "samp"]; !P.style && g.length;) {
      p = !0, P.modElem = l(g.shift()), P.style = P.modElem.style;
    }for (d = e.length, c = 0; d > c; c++) {
      if (m = e[c], y = P.style[m], a(m, "-") && (m = s(m)), P.style[m] !== t) {
        if (i || r(o, "undefined")) return f(), "pfx" == n ? m : !0;try {
          P.style[m] = o;
        } catch (h) {}if (P.style[m] != y) return f(), "pfx" == n ? m : !0;
      }
    }return f(), !1;
  }function g(e, n, t, o, i) {
    var s = e.charAt(0).toUpperCase() + e.slice(1),
        a = (e + " " + b.join(s + " ") + s).split(" ");return r(n, "string") || r(n, "undefined") ? y(a, n, o, i) : (a = (e + " " + j.join(s + " ") + s).split(" "), u(a, n, t));
  }var h = [],
      C = [],
      S = { _version: "3.6.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, n) {
      var t = this;setTimeout(function () {
        n(t[e]);
      }, 0);
    }, addTest: function addTest(e, n, t) {
      C.push({ name: e, fn: n, options: t });
    }, addAsyncTest: function addAsyncTest(e) {
      C.push({ name: null, fn: e });
    } },
      Modernizr = function Modernizr() {};Modernizr.prototype = S, Modernizr = new Modernizr();var _ = n.documentElement,
      w = "svg" === _.nodeName.toLowerCase(),
      x = "Moz O ms Webkit",
      b = S._config.usePrefixes ? x.split(" ") : [];S._cssomPrefixes = b;var E = function E(n) {
    var r,
        o = prefixes.length,
        i = e.CSSRule;if ("undefined" == typeof i) return t;if (!n) return !1;if (n = n.replace(/^@/, ""), r = n.replace(/-/g, "_").toUpperCase() + "_RULE", r in i) return "@" + n;for (var s = 0; o > s; s++) {
      var a = prefixes[s],
          l = a.toUpperCase() + "_" + r;if (l in i) return "@-" + a.toLowerCase() + "-" + n;
    }return !1;
  };S.atRule = E;var j = S._config.usePrefixes ? x.toLowerCase().split(" ") : [];S._domPrefixes = j;var z = { elem: l("modernizr") };Modernizr._q.push(function () {
    delete z.elem;
  });var P = { style: z.elem.style };Modernizr._q.unshift(function () {
    delete P.style;
  }), S.testAllProps = g;var N = S.prefixed = function (e, n, t) {
    return 0 === e.indexOf("@") ? E(e) : (-1 != e.indexOf("-") && (e = s(e)), n ? g(e, n, t) : g(e, "pfx"));
  };Modernizr.addTest("objectfit", !!N("objectFit"), { aliases: ["object-fit"] }), o(), i(h), delete S.addTest, delete S.addAsyncTest;for (var T = 0; T < Modernizr._q.length; T++) {
    Modernizr._q[T]();
  }e.Modernizr = Modernizr;
}(window, document);

/* eslint-enable */

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icons = __webpack_require__(268);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  name: "AppIcon",
  props: {
    name: String,
    size: String,
    color: String,
    title: String,
    desc: String
  },
  methods: {
    getPath: function getPath(props) {
      return _icons2["default"][props.name];
    },
    getStyleClasses: function getStyleClasses(props) {
      return [props.size, props.color].map(function (val) {
        return val && "is-" + val;
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

/*
    TODO: 
        Add responsive options
        Add support for custom font load testing

*/
exports['default'] = {
    props: {
        targetLineCount: {
            'default': 1,
            type: Number
        },
        unit: {
            'default': 'rem',
            type: String
        },
        min: {
            'default': 1,
            type: Number
        },
        max: {
            'default': 2,
            type: Number
        }
    },
    data: function data() {
        return {
            observer: null
        };
    },

    methods: {
        calculate: function calculate() {
            var element = this.$el;

            element.style.display = 'inline-block';
            element.style.lineHeight = '1px';

            // Keep trying until it fits
            var fontSize = this.max;
            var stepSize = this.unit === 'px' ? 1 : 0.05;

            // element.style.fontSize = fontSize + this.unit;

            while (element.offsetHeight > this.targetLineCount && fontSize > this.min) {
                fontSize -= stepSize;
                // element.style.fontSize = fontSize + this.unit;
            }

            element.style.display = null;
            element.style.lineHeight = null;
        }
    },
    mounted: function mounted() {
        this.calculate();

        if ('MutationObserver' in window && this.observer === null) {
            // Create the observer (and what to do on changes...)
            this.observer = new MutationObserver(this.calculate);

            // Setup the observer
            this.observer.observe(this.$el, {
                subtree: true,
                characterData: true
            });
        }
    },

    beforeDestroy: function beforeDestroy() {
        // Clean up
        this.observer.disconnect();
    }
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            searchText: '',
            locations: [],
            isVisible: false
        };
    },

    props: {
        showDropdown: {
            type: Boolean,
            'default': true
        },
        showModal: {
            type: Boolean,
            'default': true
        },
        translations: {
            type: Object,
            required: true,
            'default': {
                "search": "Search",
                "or": "or",
                "searchResults": "Search results for",
                "clearResults": "Clear Results",
                "offices": "Offices",
                "address": "Address",
                "city": "City",
                "state": "State",
                "zipCode": "Zip Code"
            }
        },
        searchEndpoint: {
            type: String,
            required: true
        },
        states: {
            type: Array,
            'default': function _default() {
                return [];
            }
        }
    },
    methods: {
        clearResults: function clearResults() {
            this.locations = [];
            this.searchText = '';
        },
        handleSubmit: function handleSubmit(response) {
            this.searchText = response.searchText;
            this.locations = response.locations;

            this.$refs.locationSelectorModal.show();
        },
        hideModal: function hideModal() {
            this.$refs.locationSelectorModal.hide();
        },
        onShown: function onShown() {
            this.isVisible = true;
        },
        onHidden: function onHidden() {
            this.isVisible = false;
        }
    },
    mounted: function mounted() {
        console.log('showDropdown ---> ' + this.showDropdown);
        console.log('searchEndpoint ---> ' + this.searchEndpoint);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            zipcode: '',
            state: '',
            isLoading: false,
            zipcodeId: null,
            stateId: null
        };
    },
    mounted: function mounted() {
        this.zipcodeId = "zipcode_" + this._uid;
        this.stateId = "state_" + this._uid;
    },

    props: {
        isVisible: {
            type: Boolean,
            'default': false
        },
        onSubmit: {
            type: Function
        },
        translations: {
            type: Object,
            required: true
        },
        endpoint: {
            type: String,
            required: true
        },
        states: {
            type: Array
        }
    },
    computed: {
        validInput: function validInput() {
            return this.state !== '' || this.zipcode !== '';
        }
    },
    watch: {
        isVisible: function isVisible(val) {
            if (val) {
                this.focusRef(this.$refs.input1);
            }
        }
    },
    methods: {
        handleSubmit: function handleSubmit() {
            var _this = this;

            this.isLoading = true;

            _axios2['default'].post(this.$props.endpoint, {
                search: this.state || this.zipcode
            }).then(function (response) {
                _this.isLoading = false;

                // Pass the data back to the parent component
                _this.onSubmit({
                    searchText: _this.state || _this.zipcode,
                    locations: response.data
                });

                _this.state = '';
                _this.zipcode = '';
            })['catch'](function (error) {
                _this.isLoading = false;
            });
        },
        focusRef: function focusRef(ref) {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$nextTick(function () {
                    (typeof ref.$el !== 'undefined' ? ref.$el : ref).focus();
                });
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        locations: {
            type: Array,
            requires: true,
            'default': []
        },
        translations: {
            type: Object,
            required: true
        }
    },
    computed: {
        validLocations: function validLocations() {
            return this.locations.filter(function (location) {
                return location.url !== '';
            });
        }
    }
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ahaUtils = __webpack_require__(32);

var _ahaLoadingSpinner = __webpack_require__(42);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = (0, _ahaUtils.browserDetails)();
exports["default"] = {
  components: {
    ahaLoadingSpinner: _ahaLoadingSpinner2["default"]
  },
  data: function data() {
    return {
      searchText: "",
      foundlocations: this.locations,
      isVisible: false,
      searchClicked: 0,
      previousParams: {},
      invalidZipCode: false,
      isLoading: false
    };
  },

  props: {
    showDropdown: {
      type: Boolean,
      "default": true
    },
    showModal: {
      type: Boolean,
      "default": true
    },
    translations: {
      type: Object,
      required: true,
      "default": {
        title: "Find a Stroke Support Group Nearby",
        search: "Search",
        searchResults: "Search results for",
        clearResults: "Clear Results",
        name: "Group Name",
        city: "City",
        state: "State",
        radius: "Radius",
        virtualOption: "Virtual Option",
        zipCode: "Zip Code",
        zipCodePlaceholder: "Enter zip code",
        increaseRadius: "If your initial search does not pull up any groups, try increasing your mile radius.",
        noResultsFound: "No results found.",
        requiredFields: "All fields are required."
      }
    },
    searchEndpoint: {
      type: String,
      required: true
    },
    radius: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    image: {
      type: String
    },
    locations: {
      type: Array,
      "default": []
    },
    previousSearchedParams: {
      type: Object,
      "default": {
        zipcode: "",
        radius: "",
        audience: []
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var data = localStorage.getItem("_aha.last-group-finder");

      if (data) {
        var psoptions = JSON.parse(data);

        if (psoptions.locations && psoptions.locations.length > 0) {
          _this.searchClicked = 1;
          _this.searchText = psoptions.searchText;
          _this.foundlocations = psoptions.locations;
          _this.previousParams = {
            radius: psoptions.radius,
            zipcode: psoptions.searchText,
            audience: psoptions.audience
          };
          _this.previousSearchedParams = _this.previousParams;
        }
      }
    });
    if (this.$props.locations.length > 0) {
      this.$refs.clearResultsLink.focus();
    } else {
      this.$refs.strokeForm1.focusRef(this.$refs.strokeForm1.$refs.input1);
    }
  },

  methods: {
    parse_query_string: function parse_query_string(query) {
      var vars = query.split("&");
      var query_string = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        if (typeof query_string[key] === "undefined") {
          query_string[key] = decodeURIComponent(value);
        } else if (typeof query_string[key] === "string") {
          var arr = [query_string[key], decodeURIComponent(value)];
          query_string[key] = arr;
        } else {
          query_string[key].push(decodeURIComponent(value));
        }
      }
      return query_string;
    },
    displayPreviousSearchedParams: function displayPreviousSearchedParams(name) {
      var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href);
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    },
    clearResults: function clearResults(event) {
      this.foundlocations = [];
      this.previousParams = {};
      this.searchText = "";
      this.$refs.strokeForm1.resetForm();
      this.searchClicked = 0;
      this.$refs.results.clearFilters();
    },
    handleSubmit: function handleSubmit(response) {
      var _this2 = this;

      //this.previousParams = {};
      if (response.locations && response.locations.length > 0) {
        var data = JSON.stringify({
          searchText: response.searchText,
          locations: response.locations,
          radius: response.radius
        });

        localStorage.setItem("_aha.last-group-finder", data);
      } else {
        localStorage.removeItem("_aha.last-group-finder");
      }
      this.searchText = response.searchText;
      this.foundlocations = response.locations;
      this.invalidZipCode = response.invalidZipCode;
      this.searchClicked += 1;
      this.isLoading = response.isLoading;
      this.$nextTick(function () {
        if (document.querySelector("fieldset[name='filter']")) {
          var filters = document.querySelector("fieldset[name='filter']");
          var headerTop = document.querySelector('.l-header__top').getBoundingClientRect().height;
          var headerUtility = document.querySelector('.l-header__utility').getBoundingClientRect().height;
          var filtersParent = filters.closest('.container');
          if (browser.mobile) {
            var _mobileBuffer = 50;
            window.scrollTo({ top: filtersParent.offsetTop - Math.round(headerTop + headerUtility + _mobileBuffer) });
          } else {
            window.scrollTo({ top: filtersParent.offsetTop - Math.round(headerTop + headerUtility) });
          }
          filters.focus();
          _this2.$refs.results.clearFilters();
        }
      });
    },
    hideModal: function hideModal() {
      this.$refs.strokeGroupSelectorModal.hide();
    },
    onShown: function onShown() {
      this.isVisible = true;
    },
    onHidden: function onHidden() {
      this.isVisible = false;
    }
  }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  mixins: [_ahaId2['default']],
  props: {
    isLoading: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      uuid: null
    };
  },
  mounted: function mounted() {
    this.uuid = this.safeId('_AHA_loading_spinner_');
  }
}; //
//
//
//
//

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  data: function data() {
    return {
      zipcode: "",
      rad: "",
      isLoading: false,
      zipcodeId: null,
      radiusId: null
    };
  },
  mounted: function mounted() {
    this.zipcodeId = "zipcode_" + this._uid;
    this.radiusId = "radius_" + this._uid;

    var data = localStorage.getItem('_aha.last-group-finder');

    if (data) {
      var psoptions = JSON.parse(data);

      this.zipcode = psoptions.searchText;
      this.rad = psoptions.radius;
    }
    // this.$refs.input1.focus();
  },

  props: {
    isVisible: {
      type: Boolean,
      "default": false
    },
    onSubmit: {
      type: Function
    },
    translations: {
      type: Object,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    },
    radius: {
      type: Array
    }
  },
  computed: {
    validInput: function validInput() {
      return this.rad !== "" && this.zipcode !== "";
    }
  },
  watch: {
    isVisible: function isVisible(val) {
      if (val) {
        this.focusRef(this.$refs.input1);
      }
    }
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      localStorage.removeItem('_aha.last-group-finder');
      this.isLoading = true;
      this.$parent.$data.isLoading = true;

      _axios2["default"].post(this.$props.endpoint, {
        zipcode: this.zipcode,
        radius: this.rad
      }).then(function (response) {
        _this.isLoading = false;
        // Pass the data back to the parent component
        _this.onSubmit({
          searchText: _this.zipcode,
          locations: response.data,
          radius: _this.rad,
          isLoading: false
        });

        _this.rad = "";
        _this.zipcode = "";
      })["catch"](function (error) {
        _this.isLoading = false;
        _this.onSubmit({
          invalidZipCode: true,
          isLoading: false
        });
      });
    },
    focusRef: function focusRef(ref) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$nextTick(function () {
          (typeof ref.$el !== "undefined" ? ref.$el : ref).focus();
        });
      });
    },
    resetForm: function resetForm() {
      this.$refs.strokeForm.reset();
      this.$refs.input1.focus();
      localStorage.removeItem('_aha.last-group-finder');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  data: function data() {
    return {
      status: "",
      selected: [],
      currentSort: "",
      currentSortDir: "ascending",
      options: [{ text: "Survivors", value: "Survivors" }, { text: "Caregivers", value: "Caregivers" }, { text: "Medical Professionals", value: "Medical Professionals" }],
      mylocations: [],
      captionMessage: "h"
    };
  },

  props: {
    locations: {
      type: Array,
      requires: true,
      "default": []
    },
    translations: {
      type: Object,
      required: true
    },
    previousSearchedParams: {
      type: Object,
      required: true
    }
  },
  computed: {
    validLocations: function validLocations() {
      return this.locations.filter(function (location) {
        return location.url !== "";
      });
    },
    sortedName: function sortedName() {
      var _this = this;

      if (this.selected.length >= 1) {
        this.updateTableCaption();
        this.mylocations = this.locations.filter(function (location) {
          for (var i = 0; i < _this.selected.length; i++) {
            if (location.audience.indexOf(_this.selected[i]) > -1) {
              return location;
            }
          }
        });
      } else {
        this.mylocations = this.locations;
      }
      return this.mylocations.sort(function (a, b) {
        var modifier = 1;
        if (_this.currentSortDir === "descending") modifier = -1;
        if (a[_this.currentSort] < b[_this.currentSort]) return -1 * modifier;
        if (a[_this.currentSort] > b[_this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
    audienceUrlQuery: function audienceUrlQuery() {
      var query = "";
      if (this.selected.length > 0) {
        query = "";
        this.selected.forEach(function (item, i) {
          query += "&audience=" + item;
        });
      }
      return query;
    }
  },
  methods: {
    sort: function sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "ascending" ? "descending" : "ascending";
      }
      this.currentSort = s;
      this.updateTableCaption();
    },
    updateTableCaption: function updateTableCaption() {
      this.captionMessage = " (Sorted by " + this.$data.selected + ": " + this.$data.currentSortDir + ")";
    },
    handleLink: function handleLink(url) {
      window.location.href = url + '?' + this.audienceUrlQuery;
    },
    locationClicked: function locationClicked(url) {

      var baseUrl = window.location.href;
      var search = {
        id: url,
        baseURI: baseUrl
      };
      localStorage.setItem("_aha.last-search", JSON.stringify(search));

      var data = localStorage.getItem('_aha.last-group-finder');
      if (data) {
        var sgoptions = JSON.parse(data);

        sgoptions.audience = this.selected;
        localStorage.setItem('_aha.last-group-finder', JSON.stringify(sgoptions));
      }
    },

    clearFilters: function clearFilters() {
      this.selected = [];
    }
  },
  created: function created() {
    if (this.previousSearchedParams.audience) {
      this.selected = this.previousSearchedParams.audience;
    }
  }
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsCookie = __webpack_require__(91);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        notificationId: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            visible: false,
            cookieString: 'aha-alert-cookie-' + this.notificationId
        };
    },

    computed: {
        isVisible: function isVisible() {
            return this.visible;
        }
    },
    mounted: function mounted() {
        var _this = this;

        var alertCookie = _jsCookie2['default'].get(this.cookieString);

        if (typeof alertCookie == 'undefined') {

            var alertEl = window.document.querySelector('.c-alert');
            if (alertEl) {
                alertEl.classList.add('c-alert__active');
            }

            this.visible = true;

            this.$nextTick(function () {
                _this.$parent.$refs[_this.notificationId].addEventListener('click', function () {
                    _jsCookie2['default'].set(_this.cookieString, true);
                    _this.visible = false;
                });
            });
        } else {}
    }
}; //
//
//
//
//
//

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            hasAriaExpanded: 'false'
        };
    },

    // These props are optional.  By default, this component is designed for use in the main site navigation (header), which is what the default values here create.  If you need this component elsewhere, profile for instnace, you NEED to supply data for each of these props; they can be anything, as long as they are unique (except for the modalRole prop, which should be a valid role attribute value).
    // Example (profile version): 
    // <aha-mobile-nav nav-id="profile-navigation" nav-ref="profileNav" modal-title="Profile Navigation">
    props: {
        navId: {
            type: String,
            required: false,
            'default': 'mobile-navigation'
        },
        navRef: {
            type: String,
            required: false,
            'default': 'mobileNav'
        },
        modalTitle: {
            type: String,
            required: false,
            'default': 'Mobile Navigation'
        },
        modalRole: {
            type: String,
            required: false,
            'default': null
        },
        modalContentRole: {
            type: String,
            required: false,
            'default': null
        },
        modalTag: {
            type: String,
            required: false,
            'default': 'div'
        },
        showOnDesktop: {
            type: Boolean,
            required: false,
            'default': false
        }
    },
    methods: {
        hideNav: function hideNav(evt) {
            this.hasAriaExpanded = this.$refs[this.navRef].is_show ? 'false' : 'true';

            if (this.$refs[this.navRef].is_show) {
                evt.stopPropagation();
                evt.stopImmediatePropagation();

                document.body.classList.remove('modal-open--mobile-nav');

                this.$refs[this.navRef].hide();
            }
        },
        onShown: function onShown(evt) {
            var element = document.querySelector('.js-mobile-nav-positioning');
            var position = element.getBoundingClientRect();

            document.body.classList.add('modal-open--mobile-nav');

            evt.target.style.top = position.top + position.height + 'px';
            evt.target.style.bottom = 0;
        },
        onHidden: function onHidden(evt) {
            this.hasAriaExpanded = 'false';
            document.body.classList.remove('modal-open--mobile-nav');
        }
    }
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            hasAriaExpanded: 'false'
        };
    },

    // These props are optional.  By default, this component is designed for use in the main site navigation (header), which is what the default values here create.  If you need this component elsewhere, profile for instnace, you NEED to supply data for each of these props; they can be anything, as long as they are unique (except for the modalRole prop, which should be a valid role attribute value).
    // Example (profile version): 
    // <aha-mobile-nav nav-id="profile-navigation" nav-ref="profileNav" modal-title="Profile Navigation">
    props: {
        navId: {
            type: String,
            required: false,
            'default': 'mobile-navigation'
        },
        navRef: {
            type: String,
            required: false,
            'default': 'mobileNav'
        },
        modalTitle: {
            type: String,
            required: false,
            'default': 'Mobile Navigation'
        },
        modalRole: {
            type: String,
            required: false,
            'default': null
        },
        modalContentRole: {
            type: String,
            required: false,
            'default': null
        },
        modalTag: {
            type: String,
            required: false,
            'default': 'div'
        },
        showOnDesktop: {
            type: Boolean,
            required: false,
            'default': false
        }
    },
    methods: {
        hideNav: function hideNav(evt) {
            this.hasAriaExpanded = this.$refs[this.navRef].is_show ? 'false' : 'true';

            if (this.$refs[this.navRef].is_show) {
                evt.stopPropagation();
                evt.stopImmediatePropagation();

                document.body.classList.remove('modal-open--mobile-nav');

                this.$refs[this.navRef].hide();
            }
        },
        onShown: function onShown(evt) {
            var element = document.querySelector('.js-mobile-nav-positioning');
            var position = element.getBoundingClientRect();

            document.body.classList.add('modal-open--mobile-nav');

            evt.target.style.top = position.top + position.height + 'px';
            evt.target.style.bottom = 0;
        },
        onHidden: function onHidden(evt) {
            this.hasAriaExpanded = 'false';
            document.body.classList.remove('modal-open--mobile-nav');
        }
    }
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    // These props are optional.  By default, this component is designed for use in the main site navigation (header), which is what the default values here create.  If you need this component elsewhere, profile for instnace, you NEED to supply data for each of these props; they can be anything, as long as they are unique (except for the modalRole prop, which should be a valid role attribute value).
    // Example (profile version): 
    // <aha-mobile-nav nav-id="profile-navigation" nav-ref="profileNav" modal-title="Profile Navigation">
    props: {
        navId: {
            type: String,
            required: false,
            'default': 'mobile-navigation-search'
        },
        navRef: {
            type: String,
            required: false,
            'default': 'mobileNavSearch'
        },
        modalTitle: {
            type: String,
            required: false,
            'default': 'Mobile Navigation Search'
        },
        modalRole: {
            type: String,
            required: false,
            'default': null
        },
        modalContentRole: {
            type: String,
            required: false,
            'default': null
        },
        modalTag: {
            type: String,
            required: false,
            'default': 'div'
        },
        showOnDesktop: {
            type: Boolean,
            required: false,
            'default': false
        }
    },
    methods: {
        hideNav: function hideNav(evt) {
            if (this.$refs[this.navRef].is_show) {
                evt.stopPropagation();
                evt.stopImmediatePropagation();

                this.$refs[this.navRef].hide();
            }
        },
        onShown: function onShown(evt) {
            evt.target.style.bottom = 0;
        },
        onHidden: function onHidden(evt) {}
    }
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GoogleMap = __webpack_require__(309);

var _GoogleMap2 = _interopRequireDefault(_GoogleMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {};
    },

    components: {
        GoogleMap: _GoogleMap2['default']
    },
    props: {
        address: {
            type: String
        },
        zoom: {
            type: Number
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
  name: "GoogleMap",
  data: function data() {
    return {
      // default to montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 0, lng: 0 },
      markers: [],
      places: [],
      currentPlace: null
    };
  },

  props: {
    zoom: {
      type: Number
    },
    address: {
      type: String
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$refs.gmap.$mapPromise.then(function (map) {
      _this.searchLocation();
    });
  },


  methods: {

    geolocate: function geolocate() {
      var _this2 = this;

      navigator.geolocation.getCurrentPosition(function (position) {
        _this2.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    searchLocation: function searchLocation() {
      var _this3 = this;

      this.currentPlace = {};
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': this.address }, function (results, status) {
        if (status === 'OK') {
          _this3.currentPlace.lat = Number(results[0].geometry.location.lat());
          _this3.currentPlace.lng = Number(results[0].geometry.location.lng());
          var marker = {
            lat: _this3.currentPlace.lat,
            lng: _this3.currentPlace.lng
          };

          _this3.markers.push({ position: marker });
          _this3.places.push(_this3.currentPlace);
          _this3.center = marker;
        }
      });
    }

  }
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  data: function data() {
    return {
      isVisible: false,
      btnColor: true,
      btnColor2: false
    };
  },

  props: {
    showModal: {
      type: Boolean,
      "default": true
    },
    interval: {
      type: Number,
      "default": 0
    },
    // Added alt properties to ensure that value are dynamic.
    translations: {
      type: Object,
      required: true,
      "default": {
        btn: "Donate",
        url: "",
        title: "",
        description: "",
        image: null,
        video: null,
        alt: ""
      }
    },
    endpoint: {
      type: String,
      required: true
    },
    dataTracking: {
      type: String
    }
  },
  mounted: function mounted() {
    if (this.interval !== 0) {
      this.timeTrigger();
    } else if (this.$refs.ahaDonationPromoModal == null) {
      return false;
    } else {
      this.$refs.ahaDonationPromoModal.show();
    }

    if (this.translations.btnTheme == 'red') {
      this.btnColor = false;
    } else {
      this.btnColor = true;
    }

    if (this.translations.btnTheme2 == 'white') {
      this.btnColor2 = true;
    } else {
      this.btnColor2 = false;
    }

    console.log("Data Tracking");
    console.log(this.dataTracking);
  },

  methods: {
    handleClose: function handleClose() {
      this.$root.$emit("bv::hide::modal", "ahaDonationPromoModal");
      //this.$refs.ahaDonationPromoModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.ahaDonationPromoModal.hide();
    },
    onShown: function onShown() {
      this.isVisible = true;
    },
    onHidden: function onHidden() {
      this.isVisible = false;
    },
    timeTrigger: function timeTrigger() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ahaDonationPromoModal.show();
      }, this.interval * 1000);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ahaCookie = __webpack_require__(54);

exports["default"] = {
  data: function data() {
    return {
      zipcode: "",
      isVisible: false
    };
  },

  props: {
    translations: {
      type: Object,
      required: true,
      "default": {
        cookie: "",
        btn: "Search",
        heading: "",
        subheading: ""
      }
    },
    zipCodeSelector: {
      type: String,
      "default": ""
    }
  },
  mounted: function mounted() {
    _ahaCookie.Cookie.getAllCookies(); //Show all cookies
    if (_ahaCookie.Cookie.cookieExist(this.translations.cookie) === false) {
      this.showModal();
    }
  },

  methods: {
    handleClose: function handleClose() {
      this.$root.$emit("bv::hide::modal", "ahaZipCodeModal");
    },
    hideModal: function hideModal() {
      this.$refs.ahaZipCodeModal.hide();
    },
    onShown: function onShown() {
      this.isVisible = true;
    },
    onHidden: function onHidden() {
      this.isVisible = false;
    },
    onSubmit: function onSubmit() {
      _ahaCookie.Cookie.setCookie(this.translations.cookie, this.zipcode);
      this.handleClose();
      console.log(this.zipcode);
      document.getElementById(this.zipCodeSelector).value = _ahaCookie.Cookie.getCookieValue(this.translations.cookie);
      document.getElementById(this.zipCodeSelector).scrollIntoView();
      document.getElementById(this.zipCodeSelector).focus();
    },
    showModal: function showModal() {
      this.$refs.ahaZipCodeModal.show();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  data: function data() {
    return {
      datasessionTime: null,
      idleDuration: 2,
      _st: null
    };
  },

  props: {
    redirect: {
      type: String
    },
    endpoint: {
      type: String
    },
    sessionTime: {
      type: Number,
      "default": 2
    },
    translations: {
      type: Object,
      required: true,
      "default": {
        btnyeslabel: "Yes",
        btnnolabel: "No",
        heading: "",
        subheading: ""
      }
    }
  },
  created: function created() {
    this.datasessionTime = this.sessionTime;
  },
  mounted: function mounted() {
    var _this = this;

    this.startTimer(this.datasessionTime);
    // Modal States - shown or hidden
    this.$root.$on('bv::modal::shown', function (bvEvent) {
      if (bvEvent.vueTarget.$options.propsData.id === 'ahaTimeoutModal') {
        _this.onIdle("active");
      }
    });
  },

  methods: {
    handleClose: function handleClose() {
      this.$root.$emit("bv::hide::modal", "ahaTimeoutModal");
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      _axios2["default"].get(this.$props.endpoint).then(function (response) {
        if (response.status === 200) {
          _this2.onIdle("reset");
          _this2.datasessionTime = _this2.sessionTime;
          _this2.startTimer(_this2.datasessionTime);
          _this2.handleClose();
        }
      });
    },
    onCancel: function onCancel() {
      this.datasessionTime = 0;
      if (this.$props.redirect) {
        window.location.href = this.$props.redirect;
      } else {
        this.logOut();
      }
      this.handleClose();
    },
    onIdle: function onIdle(state) {
      var _this3 = this;

      state = state || "active"; // 'active' or 'reset'

      var _duration = Number(this.idleDuration) * 60 * 1000;
      // var _st = null;

      if (state === "reset") {
        clearTimeout(this._st);
        this._st = null;
      } else {
        this._st = setTimeout(function () {
          _this3.onCancel();
        }, _duration);
      }
    },
    logOut: function logOut() {
      if (typeof window.GenerateLogoutRequest !== 'undefined') {
        window.GenerateLogoutRequest();
      } else {
        return;
      }
    },
    showModal: function showModal() {
      this.$root.$emit("bv::show::modal", "ahaTimeoutModal");
    },

    startTimer: function startTimer(duration) {
      if (duration !== 0) {
        var vm = this;
        var _duration = duration * 60;
        var timer = _duration,
            minutes = void 0,
            seconds = void 0;

        var countdown = setInterval(function () {
          minutes = Number(timer / 60, 10);
          seconds = Number(timer % 60, 10);

          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;

          if (timer == 0) {
            timer = 0;
            //clearTimer(countdown);
            clearInterval(countdown);
            vm.showModal();
          } else {
            --timer;
          }
        }, 1000);
      } else {
        return;
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//

exports['default'] = {
    mixins: [_ahaId2['default']],
    provide: function provide() {
        return {
            EventBus: this.EventBus
        };
    },
    mounted: function mounted() {
        var _this = this;

        var vm = this;

        this.EventBus.$on('stepTrigger', function (index) {
            // no index
            if (typeof index === 'undefined') {
                _this.goToNextStep();
                // this.currentInput = null;
            } else {
                _this.goToStep(index);
                // this.currentInput = null;
            }
        });

        // A different input can be registered per step
        this.EventBus.$on('registerInput', function (stepKey, element) {
            _this.inputs[stepKey] = element;
            _this.currentInput = _this.inputs[stepKey];
        });
    },
    data: function data() {
        return {
            EventBus: new _vue2['default'](),
            step: 1,
            inputs: {},
            currentInput: null
        };
    },

    methods: {
        goToNextStep: function goToNextStep() {
            var currentInput = this.inputs[this.step];

            this.step++;

            var journeyForm = document.getElementById('URLReferral');
            if (journeyForm) {
                console.log('journey form was found', journeyForm);
                var journeyFormURL = journeyForm.getAttribute('value');
                var journeryArray = journeyFormURL.split('/');
                var urlCheck = journeryArray[journeryArray.length - 1];
                console.log('urlCheck', urlCheck);
                if (urlCheck === 'journey-to-better-health') {
                    var el = document.querySelector('#main-content form[novalidate="novalidate"]');
                    var stickyHeight = window.document.querySelector('.l-header__top.sticky').getBoundingClientRect().height;
                    var headerUtilityHeight = window.document.querySelector('.l-header__utility').getBoundingClientRect().height;
                    var topPos = el.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo(0, topPos - (stickyHeight + headerUtilityHeight));
                }
            }

            this.EventBus.$emit('stepChanged', this.step, currentInput);
        },
        goToStep: function goToStep(index) {
            var currentInput = this.inputs[this.step];

            this.step = index;

            this.EventBus.$emit('stepChanged', this.step, currentInput);
        }
    }
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

var _closest = __webpack_require__(119);

var _closest2 = _interopRequireDefault(_closest);

var _pageGoals = __webpack_require__(76);

var _pageGoals2 = _interopRequireDefault(_pageGoals);

var _ahaLoadingSpinner = __webpack_require__(42);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = {
    mixins: [_pageGoals2['default']],
    inject: ['EventBus'],
    components: {
        "aha-loading-spinner": _ahaLoadingSpinner2['default']
    },
    props: {
        errorStepKey: {
            type: Number,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        emailUrl: {
            type: String,
            required: false
        },
        quizId: {
            type: String,
            required: false
        },
        quizName: {
            type: String,
            required: false
        }
    },
    data: function data() {
        return {
            loading: false,
            formData: {
                symptoms: []
            },
            response: {},
            activeStep: 1,
            id: 'component_uid_' + this._uid,
            checkedItems: [],
            categoryType: []
        };
    },

    computed: {
        categoryList: function categoryList() {
            var _this = this;

            if (this.formData.symptoms) {
                var finalCategoryList = {};
                if (this.categoryType.length) {
                    this.categoryType.filter(function (categorytype) {
                        var category = [];
                        _this.formData.symptoms.filter(function (element) {
                            if (element.category === categorytype.category) {
                                category.push(element);
                            } else if (categorytype.remainingCategory.includes(element.category)) {
                                category.push(element);
                            }
                        });
                        if (category.length) {
                            finalCategoryList = _extends({}, finalCategoryList, _defineProperty({}, '' + categorytype.category, category));
                        }
                    });
                }
                return finalCategoryList;
            }
        }
    },

    methods: {
        submitForm: function submitForm(evt) {
            var _this2 = this;

            evt.preventDefault();
            this.loading = true;
            var showNumberOfResultCards = +evt.target.getAttribute('data-displaycategorycount');
            var eventName = evt.target.getAttribute('data-eventname');
            var eventparameters = evt.target.getAttribute('data-eventparameters');
            var eventSendTo = evt.target.getAttribute('data-send-to');
            if (eventName && eventparameters) {
                var rawObject = eventparameters.split(',').map(function (i) {
                    return i.split(':').map(function (j) {
                        return j.trim();
                    });
                });
                var eventObject = Object.fromEntries(rawObject);
                var eventNewObj = {};
                for (var key in eventObject) {
                    var newKey = key.replace(/\s/g, '_').toLowerCase();
                    eventNewObj[newKey] = eventObject[key];
                }
                eventNewObj.send_to = eventSendTo;
                window.gtag('event', eventName, eventNewObj);
            }
            (0, _axios2['default'])({
                method: 'POST',
                url: this.url,
                responseType: 'json',
                data: this.formData
            }).then(function (response) {
                console.log('response: ', response);
                _this2.categoryType.sort(function (a, b) {
                    return b.priority - a.priority;
                });
                if (showNumberOfResultCards && _this2.categoryType.length >= showNumberOfResultCards) {
                    _this2.categoryType.map(function (item, index) {
                        var temp = item;
                        if (!(showNumberOfResultCards >= +index + 1)) {
                            _this2.categoryType[0].remainingCategory.push(item.category);
                        }
                        return temp;
                    });
                    _this2.categoryType.length = showNumberOfResultCards;
                }
                setTimeout(function () {
                    _this2.AddedFullWidthClassSingleResultCard(showNumberOfResultCards);
                }, 100);
                if (_this2.$attrs && _this2.$attrs['data-quiz-type'] && _this2.$attrs['data-quiz-type'] === 'symptom-checker' && response.status == 200) {
                    // bypass and go directly to last slide
                    _this2.EventBus.$emit('stepTrigger');
                } else {
                    if (response.data === null) {
                        _this2.EventBus.$emit('stepTrigger', _this2.errorStepKey);
                    } else {
                        _this2.response = response.data;
                        _this2.EventBus.$emit('stepTrigger');
                    }
                }

                _this2.loading = false;
            })['catch'](function (error) {
                console.log('Error: ', error);
                var step = _this2.activeStep;
                _this2.EventBus.$emit('stepTrigger', _this2.errorStepKey);
                _this2.activeStep = step;

                _this2.loading = false;
            });
        },
        AddedFullWidthClassSingleResultCard: function AddedFullWidthClassSingleResultCard(showNumberOfResultCards) {
            var summaryCard = document.querySelectorAll('.summary-card');
            var categoryObjectLenght = Object.keys(this.categoryList).length;
            summaryCard.forEach(function (element) {
                if (element.style.display === '' && (showNumberOfResultCards === 1 || categoryObjectLenght === 1)) {
                    element.classList.add("single-card-full-width");
                } else {
                    element.classList.remove("single-card-full-width");
                }
            });
        },
        quizSubmitForm: function quizSubmitForm(evt) {
            var _this3 = this;

            evt.preventDefault();
            this.loading = true;
            (0, _axios2['default'])({
                method: 'POST',
                url: this.url,
                responseType: 'json',
                data: this.formData
            }).then(function (response) {
                if (response.data === null) {
                    _this3.EventBus.$emit('stepTrigger', _this3.errorStepKey);
                    // this.EventBus.$emit('stepTrigger');
                } else {
                    _this3.response = response.data;
                    _this3.formData = {};
                    _this3.formData.QuizData = _this3.response.QuizData;
                    _this3.response.QuizData = JSON.parse(response.data.QuizData);
                    _this3.formData.TotalScore = _this3.response.Summary.TotalScore;
                    _this3.formData.TotalScoreHash = _this3.response.Summary.TotalScoreHash;
                    if (_this3.response.ResponseTitle === null && _this3.response.ResponseText === null) {
                        _this3.EventBus.$emit('stepTrigger', _this3.activeStep + 2);
                    } else {
                        _this3.EventBus.$emit('stepTrigger');
                    }
                }
                _this3.loading = false;
            })['catch'](function (error) {
                console.log(error);
                var step = _this3.activeStep;
                _this3.EventBus.$emit('stepTrigger', _this3.errorStepKey);
                // this.EventBus.$emit('stepTrigger');
                _this3.activeStep = step;
                _this3.loading = false;
            });
        },
        resetForm: function resetForm(evt) {
            // this.formData = {};
            this.categoryType = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(this.formData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var k = _step.value;

                    if (Array.isArray(this.formData[k])) {
                        this.formData[k] = [];
                    } else {
                        this.formData[k] = '';
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.EventBus.$emit('stepTrigger', 1);
            _inputEventbus2['default'].$emit('inputCleared');
        },
        checkParent: function checkParent(el) {
            var root = '#' + this.id;
            var parent = (0, _closest2['default'])(el, root);
            if (this.$el === parent) {
                return true;
            } else {
                return false;
            }
        },
        clearCheckboxes: function clearCheckboxes() {
            var checkboxes = document.querySelectorAll('input[type=checkbox]:checked');
            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = false;
            }
        },
        clearAnswers: function clearAnswers() {
            this.clearCheckboxes();
            this.formData.AnswerId = null;
        },
        getCheckedItems: function getCheckedItems(id) {
            var checked = [];
            var checkboxes = document.querySelectorAll('input[type=checkbox]:checked');

            for (var i = 0; i < checkboxes.length; i++) {
                checked.push(checkboxes[i].value);
            }

            if (checked.length > 0) {
                this.formData[id] = checked;
            } else {
                this.formData[id] = false;
            }
        },
        sendEmail: function sendEmail(evt) {
            var _this4 = this;

            // prevent the form submission
            // don't need to submit the form
            // need to keep this modal open for the screen reader and not close with a timer
            evt.target.onsubmit = function (evt) {
                evt.preventDefault();
                // console.log('onsubmit from email modal');
            };

            // Goal Triggering
            var submitBtn = evt.target.querySelector('[type="submit"]');
            if (submitBtn && submitBtn.dataset.tracking) {
                var goalData = submitBtn.dataset.tracking;
                this.triggerPageGoals(goalData);
            }
            // End Goal Triggering

            var emailData = {};

            emailData['QuizId'] = this.response.QuizId;
            emailData['EmailTo'] = this.$el.querySelector('#email').value;
            emailData['EmailBody'] = this.$el.querySelector('#print-section').innerHTML;
            (0, _axios2['default'])({
                method: 'POST',
                url: this.emailUrl,
                data: emailData,
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                _this4.loading = false;
            })['catch'](function (error) {
                console.log(error);
            });

            // Close email modal
            setTimeout(function () {
                var slider = _this4.$el.querySelector('.discussion-email-modal .slide-inline');
                slider.classList.add('slide-left');
                // reset
                emailData = {};
                _this4.$el.querySelector('#email').value = '';
                // Close the modal with timeout
                /*setTimeout(() => {
                    this.$root.$emit('bv::hide::modal', 'email-results-modal');
                }, 900);*/
            }, 500);
        }
    }, mounted: function mounted() {
        if (this.quizId) {
            this.formData.quizId = this.quizId;
        }

        if (this.quizName) {
            this.formData.quizName = this.quizName;
        }

        if (this.$attrs && this.$attrs['data-quiz-type'] && this.$attrs['data-quiz-type'] === 'symptom-checker') {
            // if needed
        }
        document.body.onclick = function (e) {
            if (window.event) {
                e = event.srcElement;
            } else {
                e = e.target;
            }
            if (e.className && e.className.indexOf('buttondisable') != -1) {
                if (this.submitted = true) {
                    e.setAttribute('disabled', 'disabled');
                } else if (this.submitted = false) {
                    e.removeAttribute('disabled');
                }
            }
        };
    },
    created: function created() {
        var _this5 = this;

        _inputEventbus2['default'].$on('hiddenInputInit', function (value, id, el) {
            _this5.$nextTick(function () {
                var isParent = _this5.checkParent(el);
                if (isParent) {
                    _this5.formData[id] = value;
                }
            });
        });
        _inputEventbus2['default'].$on('inputInit', function (value, id, el) {
            _this5.$nextTick(function () {
                var isParent = _this5.checkParent(el);
                if (isParent) {
                    _this5.formData[id] = value;
                }
            });
        });
        _inputEventbus2['default'].$on('inputUpdated', function (value, id, el, category) {
            if (_this5.formData[id] !== value) {
                var isParent = _this5.checkParent(el);
                // console.log('Is Parent? ', isParent); true
                if (isParent) {
                    if (el.type === 'checkbox') {
                        _this5.getCheckedItems(id);
                    } else if (category != undefined) {
                        // For Quiz with category, icon, question, answer
                        var obj = {};
                        obj.id = id;
                        obj.value = el.dataset.resultcardsuffixtext ? value + ' ' + el.dataset.resultcardsuffixtext : value;
                        obj.icon = el.dataset.icon;
                        obj.question = el.dataset.question;
                        obj.category = category;
                        obj.colorcode = el.dataset.colorcode;

                        var categoryObj = {};
                        categoryObj.category = category;
                        categoryObj.priority = +el.dataset.priority;
                        categoryObj.remainingCategory = [];

                        var arr = _this5.formData.symptoms;
                        var categoryTypeArr = _this5.categoryType;
                        if (_this5.formData.symptoms.length === 0) {
                            _this5.formData.symptoms.push(obj);
                            _this5.categoryType.push(categoryObj);
                        } else {
                            var elementExist = arr.find(function (element) {
                                return element['id'] === id;
                            });
                            if (elementExist !== undefined) {
                                var i = arr.indexOf(elementExist);
                                //arr[i] = obj;
                                _this5.$set(arr, i, obj);
                                _this5.$set(categoryTypeArr, i, categoryObj);
                            } else {
                                arr.push(obj);
                                categoryTypeArr.push(categoryObj);
                            }
                        }
                    } else {
                        _this5.formData[id] = value;
                        // console.log('Form Data')
                        // console.log(this.formData);
                    }
                    _this5.categoryType = _this5.categoryType.reduce(function (unique, o) {
                        if (!unique.some(function (obj) {
                            return obj.category === o.category;
                        })) {
                            unique.push(o);
                        }
                        return unique;
                    }, []);
                    _this5.$forceUpdate();
                }
            }
        });
        this.EventBus.$on('stepChanged', function (step) {
            _this5.activeStep = step;
            _this5.clearAnswers();
        });
    }
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Polyfill for window.Element.closest()
// get nearest parent element matching selector
var closest = function closest(el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

    while (el) {
        if (matchesSelector.call(el, selector)) {
            break;
        }
        el = el.parentElement;
    }
    return el;
};

exports["default"] = closest;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectFit = __webpack_require__(121);

var _objectFit2 = _interopRequireDefault(_objectFit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    inject: ['EventBus'],
    data: function data() {
        return {
            step: 1
        };
    },
    mounted: function mounted() {
        var vm = this;

        window.scrollTo({ top: 0, behavior: 'smooth' });

        this.EventBus.$on('stepChanged', function (step, inputs) {
            var _this = this;

            if (vm.$el.nodeName !== '#comment' && step !== vm.stepKey) {
                vm.$el.classList.add('fade-leave-active', 'fade-leave-to');
            }

            setTimeout(function () {
                vm.step = step;
                _this.$nextTick(function () {
                    if (vm.$el.nodeName !== '#comment' && step === vm.stepKey) {
                        vm.$el.classList.add('fade-enter', 'fade-enter-active');
                        vm.$el.classList.remove('fade-enter');
                        vm.EventBus.$emit('stepShown', inputs);
                        setTimeout(function () {
                            (0, _objectFit2['default'])();
                        }, 150);
                    } else {
                        vm.$el.classList.remove('fade-leave-to');
                    }
                });
            }, 10);
        });
    },

    props: {
        stepKey: {
            type: Number,
            required: true
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = objectFitPolyfill;
function objectFitPolyfill() {
    // eslint-disable-next-line
    if (!Modernizr.objectfit) {
        var images = document.querySelectorAll('.h-placeholder-image, .h-video-play');

        for (var x = 0; x < images.length; x++) {
            var image = images[x].querySelector('img');

            if (image != null && !images[x].classList.contains('h-compat-object-fit')) {
                var lazyImgUrl = image.getAttribute('data-lazy-img-loading');
                var imgUrl = image.getAttribute('src');

                images[x].classList.add('h-compat-object-fit');

                if (lazyImgUrl) {
                    images[x].style.backgroundImage = 'url(' + lazyImgUrl + ')';
                } else {
                    images[x].style.backgroundImage = 'url(' + imgUrl + ')';
                }
            }
        }
    }
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            searchQuery: '',
            inputId: this.safeId() + '__search',
            modalId: this.safeId() + '__modal'
        };
    },

    props: {
        formAction: {
            type: String,
            required: true
        },
        searchLabel: {
            type: String,
            'default': 'Search'
        },
        placeholderText: {
            type: String,
            'default': 'ex: Heart Attack Symptoms'
        },
        inputName: {
            type: String,
            'default': 'query'
        },
        searchIcon: {
            type: String,
            'default': '/assets/glyphs/search.svg'
        },
        searchButton: {
            type: String,
            'default': 'Search'
        },
        queryDelimiter: {
            type: String,
            'default': '?'
        }
    },
    methods: {
        hideModal: function hideModal() {
            this.$refs.locationSelectorModal.hide();
        },
        onShown: function onShown() {
            var _this = this;

            this.$nextTick(function () {
                _this.$nextTick(function () {
                    _this.$refs.search.focus();
                });
            });
        },
        search: function search() {
            var url = this.formAction;
            if (this.searchQuery !== '') {
                url += this.queryDelimiter + this.inputName + '=' + this.searchQuery;
            }
            window.location.href = url;
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//


exports['default'] = {
    data: function data() {
        return {
            searchPageUri: null
        };
    },

    props: {
        linkText: {
            type: String,
            'default': 'Back to search'
        },
        storageKey: {
            type: String,
            'default': '_aha.last-search'
        },
        linkClass: {
            type: String,
            'default': ''
        },
        linkOnly: {
            type: Boolean,
            'default': false
        }
    },
    computed: {
        isVisible: function isVisible() {
            return !!this.searchPageUri;
        }
    },
    mounted: function mounted() {
        var store = localStorage.getItem(this.storageKey);
        if (!store) return;
        var lastSearch = JSON.parse(store);
        if (lastSearch && window.location.href.indexOf(lastSearch.id) >= 0) {
            this.searchPageUri = lastSearch.baseURI;
        }

        this.componentStyles = 'container container-fluid back-to-search-container';
        if (this.linkOnly) this.componentStyles = '';

        this.linkStyles = 'c-cta c-cta--icon h-theme--red c-cta--arrow-reverse c-cta--back-to-search';
        if (this.linkClass !== '' && this.linkClass !== undefined) this.linkStyles = this.linkStyles + " " + this.linkClass;
    }
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _registerEvent = __webpack_require__(77);

var _registerEvent2 = _interopRequireDefault(_registerEvent);

var _pageGoals = __webpack_require__(76);

var _pageGoals2 = _interopRequireDefault(_pageGoals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _pageGoals2['default']],
    inject: ['EventBus'],
    props: {
        translations: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        eventText: {
            type: String,
            'default': ""
        },
        eventItemId: {
            type: String
        },
        goals: {
            type: String
        }
    },
    data: function data() {
        return {
            isInvalid: false,
            fieldValue: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.EventBus.$emit('registerInput', _this.config.currentKey, _this.$refs.singleFieldInput);
        });
    },

    methods: {
        submitForm: function submitForm(evt) {
            var value = parseInt(this.fieldValue, 10);

            evt.preventDefault();

            if (isNaN(value) || typeof value !== 'number' || value < this.config.minValue || value > this.config.maxValue) {
                this.isInvalid = true;
            } else {
                var lowerBound = this.config.targetValue.length ? this.config.targetValue[0] : this.config.targetValue;
                var upperBound = this.config.targetValue.length ? this.config.targetValue[1] : this.config.targetValue;

                this.isInvalid = false;

                // Trigger Page Goals (mixins - pageGoalsMixin)
                this.triggerPageGoals(this.goals);

                // Send the analytics request
                _registerEvent2['default'].post(this.$props.eventItemId, this.$props.eventText + ' $$Response$$ ' + value);

                // If we have an input saved for this step, use it's values to determine the step
                if (value > upperBound) {
                    this.EventBus.$emit('stepTrigger', this.config.greaterKey);
                } else if (value < lowerBound) {
                    this.EventBus.$emit('stepTrigger', this.config.lessKey);
                } else {
                    this.EventBus.$emit('stepTrigger', this.config.targetKey);
                }
            }
        }
    },
    computed: {
        inputId: function inputId() {
            return this.safeId('_AHA_field-prompt_');
        }

    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _registerEvent = __webpack_require__(77);

var _registerEvent2 = _interopRequireDefault(_registerEvent);

var _pageGoals = __webpack_require__(76);

var _pageGoals2 = _interopRequireDefault(_pageGoals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _pageGoals2['default']],
    inject: ['EventBus'],
    props: {
        translations: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            'default': ""
        },
        label: {
            type: String,
            'default': ""
        },
        config: {
            type: Object,
            required: true
        },
        eventText: {
            type: String,
            'default': ""
        },
        eventItemId: {
            type: String
        },
        eventDatasourceId: {
            type: String
        },
        bypassCard: {
            type: Boolean,
            'default': false
        },
        goals: {
            type: String,
            required: false
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.$nextTick(function () {
                _this.EventBus.$emit('registerInput', _this.config.initialKey, _this.$el.querySelectorAll('[name="' + (_this.inputId + '_radio_') + '"]'));
            });
            //Remove p tag if empty
            var fLabel = _this.$refs.label;
            if (fLabel.innerHTML === '') {
                fLabel.parentNode.removeChild(fLabel);
            }
            //Remove role from fieldset
            // this.$el.querySelector('fieldset').removeAttribute('role');
            /*for(var child=this.$el.querySelector('fieldset').firstChild; child!==null; child=child.nextSibling) {
                if(child.hasAttribute('role')){
                    child.removeAttribute('role');
                    child.removeAttribute('aria-labelledby');
                }
            }*/
        });
        // Non IE
        /*this.$el.addEventListener('input', (evt) => {
            this.isFormValid = this.$el.checkValidity();
            console.log('Event input');
        });*/

        // IE
        var radios = this.$el.querySelectorAll('input[type="radio"]');
        var that = this;
        Array.prototype.slice.call(radios).forEach(function (item) {
            item.addEventListener('click', function (evt) {
                that.isFormValid = that.$el.checkValidity();
            });
        });
    },
    data: function data() {
        return {
            isInvalid: false,
            options: [],
            selected: null,
            isFormValid: false
        };
    },

    methods: {
        submitForm: function submitForm(evt) {
            var _this2 = this;

            var selected = this.config.options.find(function (option) {
                return option.text === _this2.selected;
            });
            var stepKey = void 0;

            evt.preventDefault();

            if (typeof selected === 'undefined') {
                this.isInvalid = true;
            } else {
                stepKey = parseInt(selected.stepKey, 10);

                if (this.$props.bypassCard) {
                    if (selected.linkTarget) {
                        window.open(selected.link, selected.linkTarget);
                    } else {
                        window.open(selected.link, "_self");
                    }
                } else {
                    this.EventBus.$emit('stepTrigger', stepKey);
                }

                // Trigger Page Goals (mixins - pageGoalsMixin)
                if (this.goals) {
                    this.triggerPageGoals(this.goals);
                }

                // Send the analytics request
                _registerEvent2['default'].post(this.$props.eventItemId, this.$props.eventText + ' $$Response$$ ' + selected.text, this.$props.eventDatasourceId);

                this.isInvalid = false;

                /* eslint-disable-next-line */
                // Reset form if retake 
                this.$el.reset();
                this.isFormValid = false;
            }
        }
    },
    computed: {
        inputId: function inputId() {
            return this.safeId('_AHA_field-prompt_');
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    props: {
        videoName: {
            required: true,
            type: String
        },
        loginId: {
            require: true,
            type: String
        },
        channelId: {
            required: true,
            type: String
        },
        apiBase: {
            required: true,
            type: String
        },
        scriptSrc: {
            required: true,
            type: String
        }
    },
    data: function data() {
        return {
            videoId: null
        };
    },

    methods: {
        loadScript: function loadScript() {
            if (document) {
                var script = document.createElement('script');
                script.setAttribute('src', this.scriptSrc);
                document.head.appendChild(script);
            }
        }
    },
    mounted: function mounted() {
        this.videoId = this.videoName + this.safeId('__TP_video_');
        window.__TVPage__ = window.__TVPage__ || {};
        window.__TVPage__.config = __TVPage__.config || {};
        window.__TVPage__.config[this.videoName] = {
            loginid: this.loginId,
            channel: {
                "id": this.channelId
            },
            targetEl: this.videoId,
            api_base_url: this.apiBase
        };
        this.$nextTick(this.loadScript);
    }
}; //
//
//
//

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    inject: ['EventBus'],
    props: {
        errorStepKey: {
            type: Number,
            'default': 4
        }
    },
    data: function data() {
        return {
            formData: {
                commitment: [],
                firstName: '',
                lastName: '',
                email: '',
                zipCode: '',
                newsletters: false,
                URLReferral: ''
            },
            validation: {
                commitment: false,
                firstName: true,
                lastName: true,
                email: true,
                zipCode: true
            },
            loading: false,
            response: false
        };
    },

    methods: {
        submitForm: function submitForm(evt) {
            var _this = this;

            evt.preventDefault();
            var url = '/aha-service/grfw/MakeACommitment';
            this.loading = true;
            (0, _axios2['default'])({
                method: 'POST',
                url: url,
                responseType: 'json',
                data: this.formData
            }).then(function (response) {
                if (response.data === null) {
                    _this.EventBus.$emit('stepTrigger', _this.errorStepKey);
                    _this.loading = false;
                } else {
                    if (response.data.AlreadyRegistered) {
                        _this.response = true;
                    }
                    _this.EventBus.$emit('stepTrigger');
                    _this.loading = false;
                }
            })['catch'](function (error) {
                console.log(error);
                _this.EventBus.$emit('stepTrigger', _this.errorStepKey);
                _this.loading = false;
            });
        },
        checkInput: function checkInput(value, evt) {
            if (evt.target.hasAttribute('validation-prop')) {
                var validationProp = evt.target.getAttribute('validation-prop');
                this.validation[validationProp] = value !== '' ? true : false;
            }
            return value;
        }
    },
    watch: {
        formData: {
            handler: function handler(value) {
                for (var property in value) {
                    if (property === 'commitment') {
                        if (value[property].length > 0) {
                            this.validation[property] = true;
                        } else {
                            this.validation[property] = false;
                        }
                    }
                }
            },
            deep: true
        }
    },
    computed: {
        isComplete: function isComplete() {

            return this.validEmail;
        },
        validEmail: function validEmail() {
            if (this.formData.firstName === '' || this.formData.lastName === '' || this.formData.email === '' || this.formData.zipCode === '' || this.formData.newsletters === false) {
                console.log('Enter information in all fields');
            } else {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(this.formData.email);
            }
        }
    },
    created: function created() {
        var _this2 = this;

        _inputEventbus2['default'].$on('hiddenInputInit', function (value, id) {
            _this2.formData[id] = value;
        });
    }
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mounted: function mounted() {
        this.getForm();
    },

    props: {
        endpoint: {
            type: String,
            'default': '/aha-service/RecipeBox/GetRecipeBoxes'
        },
        recipeId: {
            type: String,
            required: true
        },
        errorMessage: {
            type: String,
            'default': 'Error loading Recipe Box Folder'
        }
    },
    data: function data() {
        return {
            recipeBoxForm: null
        };
    },

    methods: {
        getForm: function getForm() {
            var _this = this;

            (0, _axios2['default'])({
                method: 'post',
                url: this.$props.endpoint,
                responseType: 'text',
                data: {
                    recipeId: this.$props.recipeId
                }
            }).then(function (response) {
                _this.recipeBoxForm = response.data;
            })['catch'](function (error) {
                _this.recipeBoxForm = '\n                        <div class="alert alert-danger" role="alert">\n                            ' + _this.$props.errorMessage + '\n                        </div>\n                    ';

                // eslint-disable-next-link
                console.log(error);
            });
        }
    }
}; //
//
//
//

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        removeText: {
            type: String,
            'default': 'Remove from favorites'
        },
        addText: {
            type: String,
            'default': 'Add to favorites'
        },
        activeClass: {
            type: String,
            'default': 'icon-solid-heart h-color--red'
        },
        inactiveClass: {
            type: String,
            'default': 'icon-heart h-color--black'
        },
        endpoint: {
            type: String,
            'default': '/aha-service/RecipeBox/DeleteRecipe'
        },
        recipeId: {
            type: String,
            required: true
        },
        folderName: {
            type: String,
            required: true
        },
        savedDate: {
            type: String,
            required: true
        },
        errorMessage: {
            type: String,
            'default': 'Error loading Recipe Box Folder'
        },
        name: {
            type: String,
            required: true
        },
        modalId: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            isFavorite: true,
            isProcessing: false,
            recipeBoxForm: null
        };
    },

    computed: {
        getName: function getName() {
            return this.$props.name;
        },
        srText: function srText() {
            return this.isFavorite ? this.$props.removeText : this.$props.addText;
        },
        iconClasses: function iconClasses() {
            return [this.isFavorite ? this.$props.activeClass : this.$props.inactiveClass];
        }
    },
    methods: {
        click: function click(evt) {
            var _this = this;

            evt.preventDefault();

            if (!this.isProcessing) {
                // If it's currently a favorite, call the delete endpoint
                if (this.isFavorite) {
                    (0, _axios2['default'])({
                        method: 'post',
                        url: this.$props.endpoint,
                        responseType: 'text',
                        data: {
                            recipeId: this.$props.recipeId,
                            folderName: this.$props.folderName,
                            savedDate: this.$props.savedDate
                        }
                    }).then(function (response) {
                        if (response.data) {
                            _this.isFavorite = !_this.isFavorite;
                        }
                    })['catch'](function (error) {
                        // eslint-disable-next-line
                        console.log(error);
                    });
                } else {
                    // Show the add to folder modal
                    this.$root.$emit('bv::show::modal', this.$props.modalId, evt.target);
                }
            }
        }
    }
}; //
//
//
//
//
//
//

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  filters: {
    underscore: function underscore(value) {
      if (!value) return "";
      value = value.toString();
      return "edit_" + value.split(" ").join("_");
    }
  },
  props: {
    translations: {
      type: Object,
      required: true
    },
    endpointDeleteRecipe: {
      type: String,
      "default": "/aha-service/RecipeBox/DeleteRecipeBox"
    },
    endpointRecipeListing: {
      type: String,
      "default": "/aha-service/RecipeBox/RecipeBoxListing"
    },
    endpointCreateFolder: {
      type: String,
      "default": "/aha-service/RecipeBox/CreateRecipeBoxFolder"
    },
    endpointUpdateFolders: {
      type: String,
      "default": "/aha-service/RecipeBox/SaveRecipe"
    },
    errorMessage: {
      type: String,
      "default": "Error loading Recipe Box Folder"
    },
    folderitems: {
      type: Array
    },
    items: {
      type: Array
    },
    message: {
      type: String,
      "default": " "
    }
  },
  data: function data() {
    return {
      recipeBoxUpdate: null,
      recipeBoxUpdateMessage: null,
      fieldValue: '',
      createFolderError: null,
      folderEditSection: null,
      isOpen: false,
      loadingImageShow: false,
      updateFolder: [],
      updateFolderError: null,
      recipeboxeditsection: null,
      isValid: true,
      wasSubmitted: false
    };
  },

  methods: {
    DeleteFolder: function DeleteFolder(folderName) {
      var _this = this;

      this.loadingImageShow = true;
      (0, _axios2["default"])({
        method: "post",
        url: this.$props.endpointDeleteRecipe,
        responseType: "json",
        data: {
          folderName: folderName
        }
      }).then(function (response) {
        console.log(response.data);
        _this.$props.items = response.data.JsonItemsDefaultFolders;
        _this.$refs.recipeBoxUpdateMessage.removeAttribute("hidden");
        _this.$refs.recipeBoxUpdateMessage.innerHTML = response.data.Message;
        _this.getRecipeListing();
        _this.loadingImageShow = false;
      })["catch"](function (error) {
        _this.loadingImageShow = false;
        _this.recipeBoxUpdate = "\n                        <div class=\"alert alert-danger\" role=\"alert\">\n                            " + _this.$props.errorMessage + "\n                        </div>\n                    ";

        // eslint-disable-next-link
        console.log(error);
      });
    },
    getRecipeListing: function getRecipeListing() {
      var _this2 = this;

      (0, _axios2["default"])({
        method: "post",
        url: this.$props.endpointRecipeListing,
        responseType: "json"
      }).then(function (response) {
        console.log(response.data);
        _this2.$props.folderitems = response.data.JsonItemsAllFolders;
        _this2.$props.items = response.data.JsonItemsDefaultFolders;
      })["catch"](function (error) {
        _this2.recipeBoxUpdate = "\n                        <div class=\"alert alert-danger\" role=\"alert\">\n                            " + _this2.$props.errorMessage + "\n                        </div>\n                    ";

        // eslint-disable-next-link
        console.log(error);
      });
    },
    createFolderFn: function createFolderFn() {
      var _this3 = this;

      if (this.fieldValue && this.fieldValue !== '') {
        this.isValid = true;
        this.loadingImageShow = true;
        (0, _axios2["default"])({
          method: "post",
          url: this.$props.endpointCreateFolder,
          responseType: "text",
          data: {
            folderName: this.fieldValue
          }
        }).then(function (response) {
          console.log(response.data);
          _this3.$refs.createFolderError.removeAttribute("hidden");
          _this3.$refs.createFolderError.innerHTML = response.data;
          _this3.getRecipeListing();
          _this3.loadingImageShow = false;
        })["catch"](function (error) {
          _this3.loadingImageShow = false;
          _this3.recipeBoxUpdate = "\n              <div class=\"alert alert-danger\" role=\"alert\">\n                  " + _this3.$props.errorMessage + "\n              </div>\n          ";
          // eslint-disable-next-link
          console.log(error);
        });
      } else {
        this.isValid = false;
        this.$refs.createFolderInput.focus();
      }
      this.wasSubmitted = true;
      this.fieldValue = '';
    },
    SumbitUpdateRecipeBox: function SumbitUpdateRecipeBox(evt) {
      var _this4 = this;

      this.updateFolder = evt.target.elements.updateFolder.value;
      var inputLists = evt.target.elements.updateFolder;
      var arra = {};
      if (evt.target.length > 2) {
        inputLists.forEach(function (element) {
          if (element.value != element._value) {
            arra[element._value] = element.value;
          }
        });
      } else {
        if (inputLists.value != inputLists._value) {
          arra[inputLists._value] = inputLists.value;
        }
      }

      this.loadingImageShow = true;
      (0, _axios2["default"])({
        method: "post",
        url: this.$props.endpointUpdateFolders,
        responseType: "text",
        data: {
          formData: arra
        }
      }).then(function (response) {
        console.log(response.data);
        _this4.$refs.updateFolderError.removeAttribute("hidden");
        _this4.$refs.updateFolderError.innerHTML = response.data;
        _this4.getRecipeListing();
        _this4.loadingImageShow = false;
      })["catch"](function (error) {
        _this4.loadingImageShow = false;
        _this4.recipeBoxUpdate = "\n                        <div class=\"alert alert-danger\" role=\"alert\">\n                            " + _this4.$props.errorMessage + "\n                        </div>\n                    ";

        // eslint-disable-next-link
        console.log(error);
      });
    },
    showEditSection: function showEditSection() {
      if (this.isOpen == true) {
        this.isOpen = false;
      } else {
        this.isOpen = true;
        this.focusRef(this.$refs.recipeboxeditsection);
      }
    },
    focusRef: function focusRef(ref) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$refs.recipeboxeditsection.focus();
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            url: window.location.href,
            updateCopiedMessage: ''
        };
    },

    props: {
        ariaLabelProp: {
            type: String,
            'default': 'Copy site URL to your clipboard.'
        }
    },
    methods: {
        UrlCopied: function UrlCopied() {
            var _this = this;

            this.updateCopiedMessage = 'URL copied!';

            setTimeout(function () {
                _this.updateCopiedMessage = '';
            }, 500);
        }
    }
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _postscribe = __webpack_require__(719);

var _postscribe2 = _interopRequireDefault(_postscribe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        src: {
            type: String
        },
        id: {
            type: String,
            required: false,
            'default': 'jotform'
        }
    },
    computed: {
        idwrapper: function idwrapper() {
            return this.id + '-wrapper';
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        window.postscribe = _postscribe2['default'];

        window.postscribe(this.$el, '<script type="text/javascript" id="' + this.id + '" src="' + this.src + '" ><\/script>', {
            done: function done() {
                // console.log('Postsrcibe done for Jotform');
            },
            error: function error(e) {
                console.log('Postscribe Errors: ', e);
                _this.reloadScript();
            }
        });
    },

    methods: {
        reloadScript: function reloadScript() {
            window.postscribe2 = _postscribe2['default'];
            window.postscribe2(this.$el, '<script type="text/javascript" id="' + this.id + '" src="' + this.src + '" ><\/script>', {
                done: function done() {
                    // console.log('Postsrcibe done for Jotform');
                },
                error: function error(e) {
                    console.log('Postscribe Errors: ', e);
                }
            });
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uniqid = __webpack_require__(62);

var _uniqid2 = _interopRequireDefault(_uniqid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        name: ''
    },
    data: function data() {
        return {
            modalId: (0, _uniqid2['default'])() + '__footer_support_bar_'
        };
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uniqid = __webpack_require__(62);

var _uniqid2 = _interopRequireDefault(_uniqid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        title: { type: String },
        variant: {
            type: String,
            'default': 'btn--select'
        }

    },
    data: function data() {
        return {
            modalId: (0, _uniqid2['default'])() + '__phd_accordion_'

        };
    },

    computed: {
        icon: function icon() {
            if (this.variant === '' || this.variant === 'default') {
                return 'btn--select';
            }if (this.variant === 'phd-community') {
                return 'btn--select phd-community';
            } else {
                return this.variant;
            }
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        dafdirect_settings: {
            type: String,
            'default': '135613797_1111_88885361-4ceb-423f-bde6-892d3785f35b'
        }
    },
    data: function data() {
        return {
            dafdirect_tin: '',
            dafdirect_token: 'hello',
            amount: '',
            data_dafdirect_settings: ''

        };
    },

    methods: {
        generateToken: function generateToken() {
            this.dafdirect_token = this.dafdirect_settings.substring(15);
        },
        generateTin: function generateTin() {
            this.dafdirect_tin = this.dafdirect_settings.substring(0, 9);
        },

        onSubmit: function onSubmit() {
            var _dsgtxt = "";
            var _amnt = "";
            var _dafurl = "";
            var _npoid = this.dafdirect_tin;
            var _tokenstr = "";
            var _querystring = "";

            // DAF url
            if (document.getElementById("dafprovider") != "undefined" && "FC" == document.getElementById("dafprovider").value) {
                _dafurl = "https://charitablegift.fidelity.com/cgfweb/CGFLogon.cgfdo";
            } else if ("SC" == document.getElementById("dafprovider").value) {
                _dafurl = "https://client.schwab.com/Login/SignOn/CustomerCenterLogin.aspx?SANC=recommendgrant&PARMS=|";
            } else if ("BNYM" == document.getElementById("dafprovider").value) {
                _dafurl = "https://bnym.iphiview.com/bnym/API/Grants.mvc.axd/DafDirect";
            } else {
                alert("Please select a donor advised fund.");
                return;
            }

            if (document.getElementById("dafdirect_dsgtxt")) {
                _dsgtxt = encodeURIComponent(document.getElementById("dafdirect_dsgtxt").value);
                document.getElementById("dafdirect_dsgtxt").value = "";
            }
            if (document.getElementById("dafdirect_amnt")) {
                _amnt = document.getElementById("dafdirect_amnt").value.replace(/[^0-9\.]+/g, '');
                document.getElementById("dafdirect_amnt").value = "";
            }
            if ("SC" == document.getElementById("dafprovider").value) {
                _tokenstr = "|ddtoken=" + this.dafdirect_token;
            } else {
                _tokenstr = "&ddtoken=" + this.dafdirect_token;
            }

            var action = "";
            if ("SC" == document.getElementById("dafprovider").value) {
                _querystring = "Npo_Id=" + _npoid + "|Grnt_Amnt=" + _amnt + "|Device_Type=Widget|App_Id=MDNR|source=widget" + "|Grnt_Dsg_Txt=" + _dsgtxt;
                action = _dafurl + _querystring + _tokenstr;
            } else {
                _querystring = "Npo_Id=" + _npoid + "&Grnt_Amnt=" + _amnt + "&Grnt_Dsg_Txt=" + _dsgtxt + "&Device_Type=Widget&App_Id=MDNR&source=widget";
                action = _dafurl + "?" + _querystring + _tokenstr;
            }
            document.getElementById("dafprovider").value = "";
            var popupWindow = window.open(action, '_blank');
            popupWindow.focus();
        }
    },
    created: function created() {
        if (this.dafdirect_settings === '' || this.dafdirect_settings === null) {
            this.data_dafdirect_settings = this.$options.props.dafdirect_settings['default'];
        } else {
            this.data_dafdirect_settings = this.dafdirect_settings;
        }
        this.generateToken();
    }
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(23);

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
    data: function data() {
        return {
            isVisible: false,
            filters: []
        };
    },

    props: {
        show: { type: Boolean, "default": true },
        name: {
            type: String,
            required: true
        },
        ariaLive: {
            type: String
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.isVisible = this.show;
        if ((0, _lodash.isString)(this.name)) {
            _inputEventbus2["default"].$on("toggle-for:" + this.name, function (value, el) {
                _this.isVisible = value;
            });
        }
        if (this.ariaLive) {
            this.$refs['container'].setAttribute('aria-live', this.ariaLive);
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  data: function data() {
    return {
      url: window.location.href,
      isSelected: false
    };
  },

  props: {
    id: {
      type: String,
      required: true
    },
    img: {
      type: String,
      "default": ""
    },
    imgAlt: {
      type: String,
      "default": ""
    },
    title: {
      type: String,
      "default": ""
    },
    description: {
      type: String,
      "default": ""
    },
    flags: {
      type: String,
      "default": ""
    },
    categoryTitle: {
      type: String,
      "default": ""
    },
    mediaTitle: {
      type: String,
      "default": ""
    },
    mediaText: {
      type: String,
      "default": ""
    },
    mediaLink: {
      type: String,
      "default": ""
    },
    mediaLinkClass: {
      type: String,
      "default": ""
    },
    mediaLinkTarget: {
      type: String,
      "default": ""
    },
    mediaLinkDescription: {
      type: String,
      "default": ""
    },
    downloadLink: {
      type: String,
      "default": ""
    },
    downloadLinkClass: {
      type: String,
      "default": ""
    },
    downloadLinkTarget: {
      type: String,
      "default": ""
    },
    downloadButtonText: {
      type: String,
      "default": "Download Your Tookit"
    },
    tabindex: {
      type: Number
    },
    active: {
      type: Boolean,
      "default": false
    },
    buttonText: {
      type: String,
      "default": "select"
    },
    removeButtonText: {
      type: String,
      "default": "deselect"
    },
    selected: {
      type: Boolean,
      "default": false
    },
    boxShadow: {
      type: Boolean,
      "default": false
    },
    rotate: {
      type: Number
    },
    skew: {
      type: Number
    },
    sortOrder: {
      type: String
    }
  },
  mounted: function mounted() {
    // if(this.active) {
    //     this.$refs.button.focus()
    // }
  },

  filters: {
    upper: function upper(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  computed: {
    styles: function styles() {
      return {
        "c-selection-card": true,
        selected: this.selected,
        hover: this.active,
        "box-shadow": this.boxShadow
      };
    },
    transformStyles: function transformStyles() {
      var transforms = [];
      if (this.rotate) {
        transforms.push("rotate(" + this.rotate + "deg)");
      }
      if (this.skew) {
        transforms.push("skew(" + this.skew + "deg)");
      }
      return transforms.length > 0 ? { transform: "" + transforms.join(" ") } : null;
    }
  }
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

var _ahaUtils = __webpack_require__(32);

var _lodash = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  name: 'SwitchInput',
  props: {
    isChecked: {
      type: Boolean,
      'default': false
    },
    id: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    toggleFor: {
      type: String
    },
    disabled: {
      type: Boolean,
      'default': false
    },
    showLabels: {
      type: Boolean,
      'default': true
    },
    ariaLabel: {
      type: [String]
    },
    ariaLabelledby: {
      type: [String]
    },
    ariaDescribedby: {
      type: [String]
    },
    onText: {
      type: String,
      'default': 'on'
    },
    offText: {
      type: String,
      'default': 'off'
    }
  },
  data: function data() {
    return {
      checked: !!this.isChecked,
      lineHeight: 12,
      height: 22,
      width: 50,
      margin: 3,
      fontSize: 16,
      containerStyles: {},
      focused: false
    };
  },
  mounted: function mounted() {
    var s = this.$refs["wrapper"];
    var styles = window.getComputedStyle(s, null);
    var lineHeight = styles.getPropertyValue('line-height');
    this.containerStyles = styles;
    this.fontSize = parseInt(styles.getPropertyValue('line-height')) * .8;
    this.height = parseInt(styles.getPropertyValue('line-height')) + this.margin * 2;
    this.emitToggleFor();
  },

  methods: {
    toggle: function toggle(event) {
      var cbk = this.$refs["cbk"];
      cbk.value = this.checked;

      var sideBar = document.getElementsByClassName('app__sidebar')[0];
      var mainContent = document.getElementById('main-content');

      if (sideBar !== undefined && mainContent !== undefined) {
        if (this.checked) {
          console.log(sideBar, mainContent);
          sideBar.style.display = "none";
          mainContent.classList.remove('app__content', 'col-md-9', 'col-xl-10', 'col-12');
          mainContent.classList.add('app__content', 'col-md-12', 'col-xl-12', 'col-12');
        } else {
          console.log(sideBar.style.display);
          sideBar.style.display = "block";
          mainContent.classList.remove('app__content', 'col-md-12', 'col-xl-12', 'col-12');
          mainContent.classList.add('app__content', 'col-md-9', 'col-xl-10', 'col-12');
        }
      }

      this.$emit('input', this.checked);
      this.$emit('change', {
        value: this.checked,
        name: this.name,
        srcEvent: event
      });
      this.emitToggleFor(event);
    },
    emitToggleFor: function emitToggleFor(event) {
      var cbk = this.$refs["cbk"];

      if (_.isString(this.toggleFor)) {
        var eventName = 'toggle-for:' + this.toggleFor;
        _inputEventbus2['default'].$emit('toggle-for:' + this.toggleFor, this.checked, cbk, event);
      }
    }
  },
  computed: {
    className: function className() {
      var checked = this.checked,
          disabled = this.disabled,
          focused = this.focused;


      return ['c-switch-input', {
        checked: checked,
        disabled: disabled,
        focused: focused
      }];
    },
    ariaChecked: function ariaChecked() {
      return this.checked;
    },
    getAriaLabel: function getAriaLabel() {
      return this.ariaLabelledby ? false : this.ariaLabel;
    },
    coreStyle: function coreStyle() {
      return {
        width: (0, _ahaUtils.px)(this.width),
        height: (0, _ahaUtils.px)(this.height),
        borderRadius: (0, _ahaUtils.px)(Math.round(this.height / 2))
      };
    },
    buttonRadius: function buttonRadius() {
      return this.height - this.margin * 2;
    },
    distance: function distance() {
      if (isNaN(this.height)) {
        this.height = 22;
        // console.log('inside if', this.height)
      }
      return (0, _ahaUtils.px)(this.width - this.height + this.margin);
    },
    buttonStyle: function buttonStyle() {
      var transition = 'transform 300ms';
      var margin = (0, _ahaUtils.px)(this.margin);

      var transform = this.checked ? (0, _ahaUtils.translate)(this.distance, margin) : (0, _ahaUtils.translate)(margin, margin);

      // console.log('height', this.height, typeof(this.number))

      return {
        width: (0, _ahaUtils.px)(this.buttonRadius),
        height: (0, _ahaUtils.px)(this.buttonRadius),
        transition: transition,
        transform: transform
      };
    },
    labelStyle: function labelStyle() {
      return {
        lineHeight: (0, _ahaUtils.px)(this.height),
        fontSize: this.fontSize ? (0, _ahaUtils.px)(this.fontSize) : null
      };
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(23);

var _cardSelector = __webpack_require__(55);

var _vuex = __webpack_require__(48);

var _utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  provide: function provide() {
    return {
      EventBus: this.EventBus
    };
  },
  data: function data() {
    return _extends({
      EventBus: new _vue2["default"](),
      active: -1,
      isSubmitted: false,
      focusedItem: null,
      filters: []
    }, (0, _vuex.mapState)({
      selectedFilters: function selectedFilters(state) {
        return state.filters;
      }
    }));
  },

  props: {
    name: { type: String },
    data: { type: String },
    title: { type: String },
    description: { type: String }
  },
  beforeCreate: function beforeCreate() {
    this.$store = (0, _cardSelector.initStore)();
    this.$store.commit("initialiseStore");
  },
  init: function init() {
    this.isSubmitted = false;
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$scopedSlots["default"] && this.$scopedSlots["default"]()) {
      var items = []; // Array
      _.forEach(this.$scopedSlots["default"](), function (element) {
        if (element.tag && element.tag.endsWith("aha-selection-card")) {
          var elData = element.componentOptions.propsData;
          items.push(elData); // Push item to array - items
        }
      });
      _.forEach(this.$scopedSlots.filters(), function (element) {
        if (element.tag && element.tag.endsWith("aha-card-selector-filter")) {
          var elData = element.componentOptions.propsData;
          _this2.filters.push(elData); // Push to array - filters
        }
      });

      // Converting sortOrder into array
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.sortOrder = item.sortOrder.split(",");
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"]) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$store.commit("setItems", items); // Add items to Vuex Store
    }

    this.EventBus.$on("filterChanged", function (name, isSelected) {
      _this2.$store.commit("updateFilter", { name: name, isSelected: isSelected });
      _this2.resize();
    });
    this.resize();
  },

  computed: _extends({}, (0, _vuex.mapGetters)({
    items: "availableItems",
    selectedItems: "selectedItems"
  }), {
    sortedItems: function sortedItems() {
      var _this = this;

      function compare(a, b) {
        var num1 = void 0,
            num2 = void 0;
        if (_this.selectedFilters().includes("youth") && a.flags.length > 1 && a.flags.includes("adults") && a.flags.includes("youth")) {
          num1 = Number(a.sortOrder[1]);
        } else {
          num1 = Number(a.sortOrder[0]);
        }
        if (_this.selectedFilters().includes("youth") && b.flags.length > 1 && b.flags.includes("adults") && b.flags.includes("youth")) {
          num2 = Number(b.sortOrder[1]);
        } else {
          num2 = Number(b.sortOrder[0]);
        }

        if (num1 < num2) return -1;
        if (num1 > num2) return 1;
        return 0;
      }
      return this.items.sort(compare);
    }
  }),
  methods: {
    resize: function resize() {
      var container = this.$refs["cardSelectorNode"];
      var items = container.getElementsByClassName("c-selection-card");
      var itemContainers = container.getElementsByClassName("c-card-selector-item");
      var height = 0;
      var padding = void 0;
      var getPadding = function getPadding(el) {
        if (padding) return padding;

        var styles = window.getComputedStyle(el, null);
        var px = styles["paddingTop"];
        var pt = parseInt(styles["paddingTop"]);
        var pb = parseInt(styles["paddingBottom"]);
        padding = pt + pb;
        return padding;
      };
      (0, _lodash.forEach)(items, function (card) {
        if (height < card.offsetHeight) {
          height = card.offsetHeight;

          console.log('inside selector');
          console.log('height', height);
          console.log('card.offsetHeight', card.offsetHeight);
        }

        if (height > 350) {
          height = 350;
        }
      });

      (0, _lodash.forEach)(itemContainers, function (cardContainer) {
        var styles = window.getComputedStyle(cardContainer, null);
        cardContainer.style["min-height"] = height + getPadding(cardContainer) + "px";
      });
    },
    isSelected: function isSelected(id) {
      return this.$store.state.selectedIds.includes(id);
    },
    onKeyPress: function onKeyPress(evt) {
      var _this3 = this;

      var key = evt.which || evt.keyCode;
      var previousItem = null,
          nextItem = null,
          currentItem = null;
      if (!this.focusedItem) {
        return;
      }
      this.items.forEach(function (item, i) {
        if (item.id === _this3.focusedItem) {
          currentItem = item;
          previousItem = i > 0 ? _this3.items[i - 1].id : null;
          nextItem = _this3.items.length - 1 > i ? _this3.items[i + 1].id : null;
        }
      });

      // console.log("navitems", currentItem, previousItem, nextItem);
      switch (key) {
        case _utils.KeyCodes.UP:
          evt.preventDefault();
          previousItem && this.focusItem(previousItem);
          break;
        case _utils.KeyCodes.DOWN:
          evt.preventDefault();
          nextItem && this.focusItem(nextItem);
          break;
        case _utils.KeyCodes.SPACE:
          evt.preventDefault();
          this.toggleItem(evt, currentItem);
          break;
      }
    },
    toggleItem: function toggleItem(evt, id) {
      var isSelected = !this.$store.state.selectedIds.includes(id);
      this.$store.commit("itemSelectionChanged", { id: id, isSelected: isSelected });
      evt.preventDefault();
    },
    isFiltered: function isFiltered(name) {
      return this.$store.state.filters.includes(name);
    },
    focusItem: function focusItem(itemId) {
      if (itemId) {
        this.focusedItem = itemId;
      } else {
        if (this.$store.state.selectedIds.length > 0) {
          this.focusedItem = this.$store.state.selectedIds[0];
        } else {
          this.focusedItem = this.$store.state.items[0].id;
        }
      }
    },
    submit: function submit(event) {
      this.$root.$emit("bv::show::modal", "loadingModal");
      this.isSubmitted = true;
      setTimeout(function () {
        var newUri = event.target.attributes.href.nodeValue;
        window.location.href = newUri;
      }, 250);
    }
  }
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    inject: ["EventBus"],
    data: function data() {
        return {
            url: window.location.href,
            enabled: !!this.checked
        };
    },

    props: {
        title: { type: String },
        description: { type: String },
        name: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            'default': false
        },
        onText: {
            type: String,
            'default': 'Yes'
        },
        offText: {
            type: String,
            'default': 'No'
        }
    },
    methods: {
        changed: function changed(_ref) {
            var value = _ref.value,
                name = _ref.name;

            this.EventBus.$emit("filterChanged", name, value, this);
        }
    }
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(23);

var _cardSelector = __webpack_require__(55);

var _vuex = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports["default"] = {
    data: function data() {
        return {
            filters: [],
            maxHeight: 0
        };
    },

    props: {
        data: [],
        mode: {
            type: String,
            "default": 'stack',
            validator: function validator(value) {
                return typeof value === 'string' && (value === 'stack' || value === 'stacked' || value === 'list');
            }
        }
    },
    beforeCreate: function beforeCreate() {
        this.$store = (0, _cardSelector.initStore)();
        this.$store.commit('initialiseStore');
    },
    mounted: function mounted() {
        this.resize();
    },

    methods: {
        resize: function resize() {
            var container = this.$refs['wrapper'];
            var items = container.getElementsByClassName('c-selection-card');
            var itemContainers = container.getElementsByClassName('c-card-viewer__item');
            var height = 0;
            var width = 0;
            var padding = void 0;
            (0, _lodash.each)(items, function (card) {

                //height = (height < card.offsetHeight) ? card.offsetHeight : height;
                width = width < card.offsetWidth ? card.offsetWidth : width;

                if (height < card.offsetHeight) {
                    height = card.offsetHeight;

                    console.log('inside viewer');
                    console.log('height', height);
                    console.log('card.offsetHeight', card.offsetHeight);
                }

                if (height > 350) {
                    height = 350;
                }
            });

            if (this.isList) {
                var totalHeight = (0, _lodash.reduce)(itemContainers, function (th, item) {
                    return th + item.offsetHeight;
                }, 0);
                container.style.height = totalHeight + "px";
            } else {
                container.style.height = height + "px";
                container.style.width = width + "px";
            }

            (0, _lodash.each)(items, function (card) {
                card.style.height = height + "px";
            });
        }
    },
    computed: _extends({}, (0, _vuex.mapGetters)({
        selectedItems: 'selectedItems'
    }), {
        cardOptions: function cardOptions(index) {
            return {
                boxShadow: true
            };
        },
        contentStyle: function contentStyle() {
            return _defineProperty({
                'c-card-viewer__content': true
            }, "stack-of-" + (0, _lodash.size)(this.items), this.mode === 'stack');
        },
        className: function className() {
            return {
                'c-card-viewer': true,
                'c-card-viewer__stack': this.mode === 'stack',
                'c-card-viewer__list': this.mode === 'list'
            };
        },
        items: function items() {
            var mode = this.mode.toLowerCase();
            if (mode !== 'list') {
                var items = [];
                var len = (0, _lodash.size)(this.selectedItems) < 3 ? (0, _lodash.size)(this.selectedItems) : 3;
                return (0, _lodash.slice)((0, _lodash.shuffle)(this.selectedItems), 0, len);
            }
            return this.selectedItems;
        },
        count: function count() {
            return this.items.length;
        },
        isList: function isList() {
            return this.mode === 'list';
        }
    })
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(23);

var _ = _interopRequireWildcard(_lodash);

var _cardSelector = __webpack_require__(55);

var _vuex = __webpack_require__(48);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
    props: {
        data: []
    },
    beforeCreate: function beforeCreate() {
        this.$store = (0, _cardSelector.initStore)();
        this.$store.commit('initialiseStore');
    },
    mounted: function mounted() {
        var text = this.$el.innerHTML;
        if (_.isString(text)) {
            text = text.replace(/{count}/gi, this.count);
            this.$el.innerHTML = text;
            // this.$slots.default.text = text;
        }
    },

    computed: _extends({}, (0, _vuex.mapGetters)({
        selectedItems: 'selectedItems'
    }), {
        count: function count() {
            return this.selectedItems.length;
        }
    })
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueTextMask = __webpack_require__(721);

var _vueTextMask2 = _interopRequireDefault(_vueTextMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//


exports['default'] = {
    name: 'aha-masked-input',
    inheritAttrs: true,
    components: {
        MaskedInput: _vueTextMask2['default']
    },
    data: function data() {
        return {
            val: ''
        };
    },

    props: {
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        styleClass: String
    },
    calulated: {
        mask: function mask() {
            var mask = '';
            switch (this.type) {
                case 'phone':
                    mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                    break;
                case 'date':
                    mask = [/[0-1]/, /[0-9]/, '/', /[1-3]/, /[0-9]/, '/', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/];
                    break;
            }
            return mask;
        }
    }
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        baseEndpointDomain: {
            type: String,
            'default': ''
        },
        dropdownController: {
            type: String,
            required: true
        },
        dropdownDynamic: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            coursetopic: null,
            coursetype: null,
            children: [],
            selectedTopic: '',
            errorMsg: 'No list found!',
            isError: false,
            showDynamicDropdown: false

        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$children.forEach(function (vNode) {
            vNode.$children.forEach(function (vNode) {
                // Course Type/Format - Dynamic
                if (vNode.$vnode.componentOptions.propsData.inputName === _this.dropdownDynamic) {
                    _this.coursetype = vNode;
                    _this.$nextTick(function () {
                        _this.resetCourseTypeList();
                    });
                }
                // Course Topic - Controller to fetch from API to generate Course Type dropdown list
                if (vNode.$vnode.componentOptions.propsData.inputName === _this.dropdownController) {
                    _this.coursetopic = vNode;
                    _this.$nextTick(function () {
                        // console.log('COURSETOPIC DROPDOWN: ', this.coursetopic);
                        _this.coursetopic.$on('selected', _this.listenToInput);
                    });
                }
            });
        });
    },

    methods: {
        listenToInput: function listenToInput(value, text, el) {
            if (value !== '') {
                if (this.selectedTopic !== text) {
                    var endpoint = el.getAttribute('data-endpoint');
                    this.fetchData(endpoint);
                    this.selectedTopic = text;
                }
            } else {
                this.resetCourseTypeList();
            }
        },
        fetchData: function fetchData(endpoint) {
            var _this2 = this;

            // test locally
            // let _endpoint = this.baseEndpointDomain + endpoint;
            // production
            var _endpoint = this.baseEndpointDomain + '?' + 'topicId=' + endpoint;
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var requestOptions = {
                method: "POST",
                headers: myHeaders
            };

            fetch(_endpoint, requestOptions).then(function (response) {
                if (response.ok) {
                    _this2.isError = false;
                    _this2.showDynamicDropdown = true;
                    response.json().then(function (data) {
                        _this2.children = data;
                    });
                } else {
                    throw Error(response.status + ' ' + response.statusText);
                }
            })['catch'](function (error) {
                _this2.resetCourseTypeList();
                _this2.isError = true;
            });
        },
        resetCourseTypeList: function resetCourseTypeList() {
            this.coursetype.resetList(0);
            this.children = [];
        }
    },
    render: function render() {
        return this.$scopedSlots['dynamicdropdowns']({
            children: this.children,
            error: this.errorMsg,
            isError: this.isError,
            showDynamicDropdown: this.showDynamicDropdown
        });
    }
}; //

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsCookie = __webpack_require__(91);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    data: function data() {
        return {
            cookieString: 'hide-science-volunteer-modal'
        };
    },

    props: {
        modalData: {
            type: Object,
            required: true
        }
    },
    mounted: function mounted() {
        var hideModalSessionCookie = _jsCookie2['default'].get(this.cookieString);

        if (this.modalData.isVolunteer && hideModalSessionCookie === undefined) {
            this.$refs.phdScienceVolunteerModal.show();
            _jsCookie2['default'].set(this.cookieString, true, { SameSite: 'Strict' });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _ahaLoadingSpinner = __webpack_require__(42);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports['default'] = {
    name: 'NewsletterAjax',
    components: {
        "aha-loading-spinner": _ahaLoadingSpinner2['default']
    },
    props: {
        url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            formData: {},
            response: {},
            toggleShow: false,
            loading: false,
            showError: false,
            errorMsg: ''
        };
    },

    methods: {
        submitForm: function submitForm(evt) {
            var _this = this;

            evt.preventDefault();
            this.loading = true;
            this.showLoadingModal();

            (0, _axios2['default'])({
                method: 'POST',
                url: this.url,
                responseType: 'json',
                data: this.formData
            }).then(function (response) {
                // console.log('RESPONSE', response.data);
                // on success slide in the thank you slide
                if (response.data === null) {
                    //
                } else {
                    //this.response = response.data;
                    //console.log('RESPONSE', response.data);
                    _this.response = response.data;
                    _this.toggleShow = response.data.success;
                    if (_this.showError === true) {
                        _this.resetError();
                    }
                    _this.hideLoadingModal(1000);
                    _this.loading = false;
                }
                //this.loading = false;
            })['catch'](function (error) {
                console.log('ERROR ERROR ERROR ERROR ');
                console.log(error);
                _this.hideLoadingModal(1000);
                // without timeout the error will show instantly, 
                // give some time for the modal to display
                setTimeout(function () {
                    _this.showError = true;
                    _this.errorMsg = error;
                    _this.loading = false;
                }, 1000);
            });
        },
        resetForm: function resetForm(evt) {
            this.formData = {};
            // this.EventBus.$emit('stepTrigger', 1);
            // inputEventBus.$emit('inputCleared');
            console.log('reset form is called');
        },
        showLoadingModal: function showLoadingModal() {
            this.$root.$emit("bv::show::modal", "loadingModal");
        },
        hideLoadingModal: function hideLoadingModal(val) {
            var _this2 = this;

            setTimeout(function () {
                _this2.$root.$emit("bv::hide::modal", "loadingModal");
            }, val);
        },
        resetError: function resetError() {
            this.showError = false;
            this.errorMsg = '';
        }
    },
    mounted: function mounted() {
        console.log('THIS: ', this);
        console.log('SCOPEDSLOTS', this.$scopedSlots);
        console.log('REFS', this.$refs);
    }
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaUtils = __webpack_require__(32);

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaLoadingSpinner = __webpack_require__(42);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var browser = (0, _ahaUtils.browserDetails)(); //
//
//
//
//
//
//
//
//
//

exports['default'] = {
    components: {
        "aha-loading-spinner": _ahaLoadingSpinner2['default']
    },
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            isValid: false,
            submitButton: null,
            form: null,
            emailInput: null,
            emailFormat: RegExp(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$/),
            isEmailFormatted: null,
            pagePosition: null,
            uuid: null,
            isLoading: false,
            spinnerEl: null
        };
    },

    methods: {
        a11yInjection: function a11yInjection() {
            var errorBoxes = this.$el.querySelectorAll('form .field-validation-error');
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = errorBoxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var errorBox = _step.value;

                    errorBox.style.display = 'none';
                    errorBox.setAttribute('role', 'alert');
                    errorBox.setAttribute('aria-atomic', 'true');
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        isEmailFormatValid: function isEmailFormatValid() {
            return this.isEmailFormatted = this.emailFormat.test(this.emailInput.value);
        },
        isFormValid: function isFormValid() {
            if (this.form.checkValidity() === false) {
                return false;
            } else if (this.form.checkValidity() === true && this.isEmailFormatValid() === true) {
                return true;
            }
        },
        onSubmitClicked: function onSubmitClicked() {
            var _this = this;

            // this.pagePosition = window.scrollY;
            // window.__scrollY__ = this.pagePosition;
            setTimeout(function () {
                _this.submitButton.disabled = true;
            }, 250);
            this.isLoading = true;
            // console.log("Spinner El");
            // console.log(this.spinnerEl);
            // this.spinnerEl.classList.remove('d-none');
            // this.spinnerEl.classList.add('d-inline-block');
            this.submitButton.value = "Submitting";
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var _this2 = this;

        this.uuid = this.safeId('_AHA_sc_form_wrapper_');
        this.a11yInjection();
        this.submitButton = this.$el.querySelector('[type="submit"]');
        this.submitButton.disabled = true;
        // let spinnerEl = document.createElement('div');
        // spinnerEl.classList.add('loader', 'd-none');
        // spinnerEl.innerText = "Loading...";
        // spinnerEl.innerHTML = `<div class="loader d-none ">Loading...</div>`;
        // this.spinnerEl = spinnerEl;
        // this.submitButton.after(spinnerEl);
        this.form = this.$el.querySelector('form[data-sc-fxb]');
        // this.$forceUpdate();

        this.emailInput = this.$el.querySelector('[type="email"]');
        var requiredInputs = this.$el.querySelectorAll('form [data-val-required]');
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            var _loop = function _loop() {
                var requiredInput = _step2.value;

                requiredInput.required = true;
                requiredInput.setAttribute('aria-required', 'true');
                requiredInput.nextElementSibling.id = requiredInput.getAttribute('aria-describedby');
                requiredInput.addEventListener('blur', function (e) {
                    if (requiredInput.validity.valid === false) {
                        if (requiredInput.nextElementSibling.classList.contains('field-validation-error')) {
                            requiredInput.nextElementSibling.style.display = 'block';
                            requiredInput.nextElementSibling.setAttribute('role', 'alert');
                            requiredInput.nextElementSibling.setAttribute('aria-live', 'assertive');
                        }
                    }
                    if (e.target.value === '' || e.target.value === null) {
                        requiredInput.setAttribute('aria-invalid', 'false');
                    }
                });
            };

            for (var _iterator2 = requiredInputs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                    _iterator2['return']();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        this.form.addEventListener('input', function () {
            _this2.isValid = _this2.isFormValid();
            _this2.submitButton.disabled = !_this2.isValid;
        });
        this.submitButton.addEventListener('click', function (e) {
            //e.preventDefault(); // for testing

            _this2.onSubmitClicked();
        });

        document.addEventListener("sc-forms-submit-success", function (e) {

            /*setTimeout(function() {
                if(browser.mobile) {
                    // var _frm = document.getElementById(e.detail);
                    var _frm = document.querySelector('.c-aha-form');
                    var _parentFrm = _frm.closest('.container');
                    _parentFrm.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                    
                }
            }, 0);*/

        });
    }
};

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNy44NjQiIGhlaWdodD0iMjYuNSIgdmlld0JveD0iMCAwIDI3Ljg2NCAyNi41Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojYzEwZTIxO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTMwLjQzNSwxMi44MDVsLTkuNjI3LTEuNEwxNi41LDIuNjgzLDEyLjIsMTEuNDA2bC05LjYyNywxLjRMOS41MzcsMTkuNiw3Ljg5MiwyOS4xODNsOC42MS00LjUyNyw4LjYxLDQuNTI3TDIzLjQ2OSwxOS42bDYuOTY2LTYuNzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi41NzEgLTIuNjgzKSIvPjwvc3ZnPg=="

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _ahaCookie = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
  mixins: [_ahaId2["default"]],
  props: {
    avgRating: Number,
    total: Number,
    avgRatingId: Number,
    avgRatingPageId: String,
    voteErrorMessage: String,
    rateMessage: String,
    endpoint: String,
    oneStarRating: String,
    twoStarRating: String,
    threeStarRating: String,
    fourStarRating: String,
    fiveStarRating: String,
    recipe_ID: String,
    name: String
  },
  data: function data() {
    return {
      picked: 0,
      heartsRefs: {
        full: "/assets/icons/aha-heart.svg", //1 - 0.24 & 0.75-1
        half: "/assets/icons/aha-heart-half.svg", //0.25 - 0.74
        empty: "/assets/icons/aha-heart-empty.svg" //0 stars
      },
      hearts: [],
      focused: false,
      hasSubmitted: false,
      votedAlready: false,
      errorFound: false,
      ratingTotal: this.total,
      cookiePicked: "CookiePicked",
      cookieName: "starRatingWidget"
    };
  },
  mounted: function mounted() {
    this.getHearts();
    if (_ahaCookie.Cookie.cookieExist(this.cookieName + this.avgRatingPageId)) {
      //logic to display uses rating
      this.ratingTotal = _ahaCookie.Cookie.getCookieValue(this.cookieName + this.avgRatingPageId);
      this.hasSubmitted = true;
      this.focused = true;
      //this.disableRB();
    }

    if (_ahaCookie.Cookie.cookieExist(this.cookiePicked + this.avgRatingPageId)) {
      //logic to display uses rating
      this.picked = _ahaCookie.Cookie.getCookieValue(this.cookiePicked + this.avgRatingPageId);
    }
  },

  methods: {
    getHearts: function getHearts() {
      // Empties - default
      for (var i = 0; i < 5; i++) {
        this.hearts.push(this.heartsRefs.empty);
      }

      // Whole hearts
      var fullHearts = Math.floor(this.avgRating);
      for (var f = 0; f < fullHearts; f++) {
        this.hearts[f] = this.heartsRefs.full;
      }

      // Halves - decimal
      var halfHeart = Number(this.avgRating % 1);

      // Logic for half or not because images can be full, half or empty
      switch (true) {
        case halfHeart > 0.25 && halfHeart < 0.74:
          this.hearts[fullHearts] = this.heartsRefs.half;
          break;
        case halfHeart >= 0.75:
          this.hearts[fullHearts] = this.heartsRefs.full;
          break;
        default:
          return;
      }
    },
    handleFocusout: function handleFocusout(event) {
      if (event.relatedTarget && event.relatedTarget.name !== 'rate' && !this.hasSubmitted && !this.ratingTotal) {
        event.target.checked = event.target.checked && false;
      } else if (!this.hasSubmitted && this.ratingTotal) {
        event.target.checked = event.target.checked && false;
        var overlay = document.getElementsByClassName("flip-cardoverlay");
        overlay[0].classList.remove("focused");
      }
    },
    ratingPicked: function ratingPicked(event) {
      var that = this;
      var data = event.target.value;

      if (that.hasSubmitted) {
        if (event.clientX !== 0) {
          that.votedAlready = true;
          that.focused = true;
          setTimeout(function () {
            this.fadeAway();
          }.bind(this), 3000);
        }
        event.preventDefault();
      } else if (event.clientX === 0) {
        return false;
      } else {
        _axios2["default"].post(this.endpoint, {
          rating: data
        }).then(function (response) {
          if (response.status == 200 || response.status == 201) {
            that.hasSubmitted = true;
            that.votedAlready = false;

            //increase rating
            that.ratingTotal++;

            _ahaCookie.Cookie.setCookie(that.cookieName + that.avgRatingPageId, that.ratingTotal);
            _ahaCookie.Cookie.setCookie(that.cookiePicked + that.avgRatingPageId, that.picked);
          }
        })["catch"](function (error) {
          that.errorFound = true;
        });
      }
    },
    fadeAway: function fadeAway() {
      this.votedAlready = false;
    },
    overlayFocused: function overlayFocused() {
      var overlay = document.getElementsByClassName("flip-cardoverlay");
      var radios = document.querySelectorAll('input[name="rate"]:focus');
      if (radios.length == 1) {
        overlay[0].classList.add("focused");
      }
    },
    disableRB: function disableRB() {
      var radios = document.querySelectorAll('input[name="rate"]:not(:checked)');

      for (var i = 0; i < radios.length; i++) {
        radios[i].disabled = true;
      }
    },
    getAriaLabelDetails: function getAriaLabelDetails(item) {
      var labelName = '';
      var radios = document.querySelectorAll('input[name="rate"]:focus');
      if (radios.length && !this.hasSubmitted) {
        var currentAriaLabel = document.querySelectorAll("[data-rating=\"" + item + "\"]");
        labelName = currentAriaLabel[0].getAttribute("aria-label");
      } else {
        if (this.ratingTotal >= 1 && (+this.picked === +item || +this.picked === 0 && +item === 5)) {
          labelName = this.name + " rated " + this.avgRating.toFixed(1) + " out of 5 star for " + this.ratingTotal + " ratings, " + (this.hasSubmitted ? "You rated " + this.picked + " star" : 'Rate this item (5 is the highest)') + ", grouping, " + item + " star";
        } else if (+this.picked === 0 && +item === 5) {
          labelName = this.name + " rate this item (5 is the highest), grouping, " + item + " star";
        }
      }
      return labelName;
    }
  },
  watch: {},
  computed: {
    ratingId: function ratingId() {
      return this.safeId("_AHA_rating_");
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemsStorage = __webpack_require__(78);

var STORAGE_KEY = '_aha-coveo-grocery-list'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// const STORAGE_KEY = "grocery-list";
// const itemsStorage = {
//     fetch: function() {
//         var items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
//         items.forEach((item,index) => {
//            item.id = index;
//         });
//         itemsStorage.uid = items.length;
//         return items;
//     },
//     save: function(items) {
//         localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
//     }
// };

// const filters = {
//     all: function(items) {
//         return items;
//     },
//     active: function(items) {
//         return items.filter(item => {
//             return !item.completed;
//         })
//     },
//     completed: function(items) {
//         return items.filter(item => {
//             return item.completed;
//         })
//     }
// };
exports['default'] = {
    props: {
        title: {
            type: String,
            required: false,
            'default': "My Grocery List"
        },
        count: {
            type: Number
        }
    },
    data: function data() {
        return {
            items: [],
            newItem: "",
            editedItem: null,
            visibility: "all",
            checked: ""
        };
    },

    // watch todos change for localStorage persistence
    watch: {
        items: {
            handler: function handler(items) {
                _itemsStorage.itemsStorageFunc.save(STORAGE_KEY, items);
                this.$eventHub.$emit('grocerylist::updated', this.remaining);

                var modal = document.querySelector('#GroceryListModal .modal-content'); // select the modal by it's id
                modal.addEventListener('keydown', function (e) {

                    // Focus trapp below: add all the elements inside modal which you want to make focusable
                    var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

                    var firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                    var focusableContent = modal.querySelectorAll(focusableElements);
                    var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                    var list = Array.from(focusableContent);
                    var index = list.findIndex(function (content) {
                        return content === document.activeElement;
                    });

                    //console.log(list[index], index, list[index + 1]); // 1
                    //console.log('i',index)

                    if (list[index]) {
                        list[index].addEventListener('click', function () {
                            list[index + 1].focus();
                        });
                    }

                    if (e.key !== 'Tab') {
                        return;
                    }

                    if (document.activeElement === firstFocusableElement && items.length === 0) {
                        firstFocusableElement.focus(); // add focus for the first focusable element
                        e.preventDefault();
                    }

                    if (e.shiftKey) {
                        // if shift key pressed for shift + tab combination
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus(); // add focus for the last focusable element
                            e.preventDefault();
                        }
                    } else {
                        // if tab key is pressed
                        if (document.activeElement === lastFocusableElement) {
                            // if focused has reached to last focusable element then focus first focusable element after pressing tab
                            firstFocusableElement.focus(); // add focus for the first focusable element
                            e.preventDefault();
                        }
                    }

                    var closeBtn = document.querySelector('#GroceryListModal___BV_modal_header_ .close');
                    closeBtn.addEventListener('click', function () {
                        setTimeout(function () {
                            document.querySelector('.coveo-results-header button.coveo-results-add-to-list').focus();
                        }, 0);
                    });
                });

                // Lines below hide email section of grocery list modal where there are no items remaining

                var privacyPolicy = document.getElementsByClassName('message');
                var emailSelector = document.getElementById('grocery-list-email');

                if (this.remaining === 0) {
                    privacyPolicy[0].setAttribute("style", "visibility: hidden; height:0;");
                    emailSelector.setAttribute("style", "visibility: hidden; height:0;");
                } else {
                    privacyPolicy[0].setAttribute("style", "visibility: visible; height:auto;");
                    emailSelector.setAttribute("style", "visibility: visible; height:auto;");
                }
            },
            deep: true
        }

    },
    computed: {
        filteredItems: function filteredItems() {
            return _itemsStorage.itemsStorageFilters[this.visibility](this.items);
        },
        remaining: function remaining() {
            return _itemsStorage.itemsStorageFilters.active(this.items).length;
        },
        allDone: {
            get: function get() {
                return this.remaining === 0;
            },
            set: function set(value) {
                this.items.forEach(function (item) {
                    item.completed = value;
                });
            }
        }
    },
    created: function created() {},
    mounted: function mounted() {
        this.items = _itemsStorage.itemsStorageFunc.fetch(STORAGE_KEY);
        if (this.remaining === 0) {
            this.checked = "Uncheck All";
        } else {
            this.checked = "Check All";
        };

        var allFilterBtn = document.querySelector('.filters li:nth-child(2) .btn');
        allFilterBtn.classList.add('activeFilter');

        console.log(this.remaining);
    },

    filters: {
        pluralize: function pluralize(n) {
            return n === 1 ? "item" : "items";
        }
    },
    methods: {
        showFilterBtnStyle: function showFilterBtnStyle() {
            // show indication of what filter tab the user is actively on.
            var allFilterBtn = document.querySelector('.filters li:nth-child(2) .btn');
            var activeFilterBtn = document.querySelector('.filters li:nth-child(3) .btn');
            var completedFilterBtn = document.querySelector('.filters li:nth-child(4) .btn');

            if (this.visibility) {
                if (this.visibility === 'all') {
                    allFilterBtn.classList.add('activeFilter');
                    activeFilterBtn.classList.remove('activeFilter');
                    completedFilterBtn.classList.remove('activeFilter');
                }
                if (this.visibility === 'active') {
                    allFilterBtn.classList.remove('activeFilter');
                    activeFilterBtn.classList.add('activeFilter');
                    completedFilterBtn.classList.remove('activeFilter');
                }
                if (this.visibility === 'completed') {
                    allFilterBtn.classList.remove('activeFilter');
                    activeFilterBtn.classList.remove('activeFilter');
                    completedFilterBtn.classList.add('activeFilter');
                }
            }
        },
        addItem: function addItem(value) {
            // var value = this.newItem && this.newItem.trim();
            /*if (!value) {
                return
            };*/
            this.items.push({
                ProductName: value,
                completed: false,
                id: _itemsStorage.itemsStorageFunc.uid++
            });
            this.newItem = "";
        },
        removeItem: function removeItem(item) {
            this.items.splice(this.items.indexOf(item), 1);
        },
        editItem: function editItem(item) {
            this.beforeEditCache = item.title;
            this.editedItem = item;
        },
        doneEdit: function doneEdit(item) {
            if (!this.editedItem) {
                return;
            }
            this.editedItem = null;
            item.title = item.title.trim();
            if (!item.title) {
                this.removeItem(item);
            }
        },
        cancelEdit: function cancelEdit(item) {
            this.editedItem = null;
            item.title = this.beforeEditCache;
        },
        removeCompleted: function removeCompleted(item, value) {
            var checkedItems = document.querySelectorAll("ul.grocery-list li.completed");
            var checkedBoxItems = document.querySelectorAll("ul.grocery-list li input[type='checkbox']");

            //unchecks checkboxes, removes class, sets check All, sets item back
            checkedBoxItems.forEach(function (checkedBoxItem) {
                checkedBoxItem.checked = false;
            });
            checkedItems.forEach(function (checkedItem) {
                checkedItem.classList.remove("completed");
            });
            this.checked = "Check All";
            this.items.forEach(function (item) {
                item.completed = value;
            });

            // focus on the "completed" button once completed items are cleared with the "clear completed" btn
            // let clearCompleteBtn = document.querySelector('.clear-completed')
            // clearCompleteBtn.addEventListener('click', () => {
            //     let completedFilterBtn = document.querySelector('.filters li:nth-child(4) .btn')
            //     completedFilterBtn.focus();
            // })

            //removes all checked items
            //this.items = itemsStorageFilters.active(this.items)
        },
        checkAll: function checkAll(item) {
            if (this.remaining === 0) {
                this.checked = "Check All";
            } else {
                this.checked = "Uncheck All";
            }
        },
        checkAllItems: function checkAllItems() {
            var checkboxes = document.querySelectorAll("ul.grocery-list li input[type='checkbox']").length;
            var checkboxesChecked = document.querySelectorAll("ul.grocery-list li input[type='checkbox']:checked").length;

            if (checkboxesChecked === checkboxes) {
                this.checked = "Uncheck All";
            } else {
                this.checked = "Check All";
            }
        }
    }
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemsStorage = __webpack_require__(78);

var STORAGE_KEY = '_aha-coveo-grocery-list'; //
//
//
//
//
//
//

// const STORAGE_KEY = "grocery-list";
// const itemsStorage = {
//     fetch: function() {
//         var items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
//         items.forEach((item,index) => {
//            item.id = index;
//         });
//         itemsStorage.uid = items.length;
//         return items;
//     }
// };

// var filters = {
//     active: function(items) {
//         return items.filter(item => {
//             return !item.completed;
//         })
//     },
// };

exports['default'] = {
    data: function data() {
        return {
            count: _itemsStorage.itemsStorageFilters.active(_itemsStorage.itemsStorageFunc.fetch(STORAGE_KEY)).length
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$eventHub.$on('grocerylist::updated', function (data) {
            _this.count = data;
        });
    }
};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contestantGridHeader = __webpack_require__(413);

var _contestantGridHeader2 = _interopRequireDefault(_contestantGridHeader);

var _contestantGrid = __webpack_require__(415);

var _contestantGrid2 = _interopRequireDefault(_contestantGrid);

var _contestantGridPagination = __webpack_require__(417);

var _contestantGridPagination2 = _interopRequireDefault(_contestantGridPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    name: 'AhaContestantGrid',
    data: function data() {
        return {
            search: '',
            isError: false,
            voteNowLabel: '',
            currentPageNo: 1,
            contendersList: [],
            numberOfPagesArray: [],
            contestantGridHeading: '',
            updatedSearchedContenderList: []
        };
    },

    components: {
        ContestantGrid: _contestantGrid2['default'],
        ContestantGridHeader: _contestantGridHeader2['default'],
        ContestantGridPagination: _contestantGridPagination2['default']
    },
    props: {
        endpoint: String,
        votesText: String,
        voteText: String,
        hideSearchbox: String,
        contextPageId: String,
        pageSize: String,
        contestNotactiveText: String,
        searchboxText: String,
        hideGreybar: String
    },
    methods: {
        setSearchResult: function setSearchResult(value) {
            this.search = value;
        },
        getPaginationDetails: function getPaginationDetails(data) {
            this.currentPageNo = data.currentActivePage;
            this.numberOfPagesArray = data.numberOfPagesArray;
        },
        updatedSearchedResults: function updatedSearchedResults(data) {
            this.updatedSearchedContenderList = data;
        },
        setCurrentActivePage: function setCurrentActivePage(data) {
            this.currentPageNo = data;
            this.$refs.focus.focus();
            this.$refs.viewContestantGrid.scrollIntoView({ behavior: 'smooth' });
        }
    },
    mounted: function mounted() {
        var _this = this;

        fetch(this.endpoint + '?contextPageId=' + this.contextPageId).then(function (res) {
            return res.json();
        }).then(function (data) {
            _this.isError = false;
            _this.contestantGridHeading = data.ContestantGridHeading;
            _this.voteNowLabel = data.VoteNowLabel;
            _this.contendersList = data.Nominees.map(function (item) {
                var nomineeDetails = item;
                nomineeDetails.fullName = nomineeDetails.FirstName + ' ' + nomineeDetails.LastName;
                return nomineeDetails;
            });
        })['catch'](function () {
            _this.isError = true;
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            search: '',
            updatedSearchedResult: '',
            hasShowUpdatedSearchedResult: false
        };
    },

    props: {
        contestantGridHeading: String,
        contestNotactiveText: String,
        contendersList: Array,
        updatedSearchedContenderList: Array,
        hideSearchbox: Boolean,
        searchboxText: String,
        hideGreybar: Boolean
    },
    computed: {
        hasContendersPresent: function hasContendersPresent() {
            return this.contendersList && this.contendersList.length;
        }
    },
    watch: {
        search: function search(val) {
            this.$emit('setSearchResult', val);
        },
        updatedSearchedContenderList: function updatedSearchedContenderList(val) {
            var _this = this;

            this.updatedSearchedResult = val.length + ' results found';
            setTimeout(function () {
                _this.updatedSearchedResult = '';
                _this.hasShowUpdatedSearchedResult = false;
            }, 500);
        }
    },
    methods: {
        selectResult: function selectResult(result) {
            this.search = result;
            this.hasShowUpdatedSearchedResult = true;
            this.$emit('setSearchResult', this.search);
        }
    }
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    name: 'ContestantGrid',
    props: {
        contendersList: Array,
        search: String,
        currentPageNo: Number,
        voteNowLabel: String,
        votesText: String,
        voteText: String,
        showNumberOfContendersPerPage: Number
    },
    computed: {
        sortedContendersList: function sortedContendersList() {
            var _this = this;

            var filtedByContendersName = this.contendersList.filter(function (item) {
                return item.fullName.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
            });
            this.setNumberOfPages(filtedByContendersName);
            var filtedByPerPageContenders = filtedByContendersName.filter(function (row, index) {
                var from = _this.currentPageNo * _this.showNumberOfContendersPerPage - _this.showNumberOfContendersPerPage;
                var to = _this.currentPageNo * _this.showNumberOfContendersPerPage;
                if (index >= from && index < to) return true;
            });
            this.$emit('updatedSearchedResults', filtedByContendersName);
            return filtedByPerPageContenders;
        }
    },
    methods: {
        setNumberOfPages: function setNumberOfPages(filtedByContendersName) {
            var numberOfPagesArray = [];
            var currentActivePage = this.currentPageNo;
            var numberOfPages = Math.ceil(filtedByContendersName.length / this.showNumberOfContendersPerPage);
            for (var index = 1; index <= numberOfPages; index++) {
                numberOfPagesArray.push(index);
            }
            if (numberOfPagesArray.length < currentActivePage) {
                currentActivePage = 1;
            }
            this.$emit('getPaginationDetails', { currentActivePage: currentActivePage, numberOfPagesArray: numberOfPagesArray });
        }
    }
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            currentPage: 0,
            totalPages: 0,
            maxVisibleButtons: 5,
            message: '',
            hasShowMessage: false
        };
    },

    props: {
        numberOfPagesArray: Array,
        currentPageNo: Number,
        pageSize: Number,
        contendersList: Array
    },
    watch: {
        currentPage: function currentPage(data) {
            this.$emit('setCurrentActivePage', data);
        },
        numberOfPagesArray: function numberOfPagesArray(val) {
            this.totalPages = val.length;
        },
        currentPageNo: function currentPageNo(val) {
            this.currentPage = val;
        }
    },
    computed: {
        startPage: function startPage() {

            if (this.currentPage === 1 || this.currentPage === 2) {
                return 1;
            }

            if (this.currentPage === this.totalPages || this.currentPage + 1 === this.totalPages) {
                return this.totalPages - this.maxVisibleButtons + 1;
            }

            return this.currentPage - 2;
        },
        endPage: function endPage() {
            return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        },
        pages: function pages() {
            var range = [];

            for (var i = this.startPage; i <= this.endPage; i += 1) {
                if (i >= 1) {
                    range.push(i);
                }
            }

            return range;
        }
    },
    methods: {
        setCurrentPage: function setCurrentPage(pageNumber) {
            var _this = this;

            this.currentPage = pageNumber;
            this.message = 'Updating results';

            setTimeout(function () {
                _this.message = 'Results ' + (_this.currentPage * _this.pageSize - (_this.pageSize - 1)) + ' - ' + (_this.totalPages === _this.currentPage ? _this.contendersList.length : _this.currentPage * _this.pageSize) + ' of ' + _this.contendersList.length + ' for nominees';
            }, 500);
        },
        setPreviousPage: function setPreviousPage() {
            var previousPage = this.currentPage - 1;
            this.setCurrentPage(previousPage);
        },
        setNextPage: function setNextPage() {
            var nextPage = this.currentPage + 1;
            this.setCurrentPage(nextPage);
        }
    },
    mounted: function mounted() {
        this.totalPages = this.numberOfPagesArray.length;
        this.currentPage = this.currentPageNo;
    }
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use-strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DropdownEventBus = function () {
    function DropdownEventBus() {
        _classCallCheck(this, DropdownEventBus);

        this.bus = window;
    }

    _createClass(DropdownEventBus, [{
        key: 'on',
        value: function on(evt, callback) {
            this.bus.addEventListener(evt, callback);
        }
    }, {
        key: 'off',
        value: function off(evt, callback) {
            this.bus.removeEventListener(evt, callback);
        }
    }, {
        key: 'emit',
        value: function emit(evt) {
            var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            /* eslint-disable-next-line */
            this.bus.dispatchEvent(new CustomEvent(evt, { detail: detail }));
        }
    }]);

    return DropdownEventBus;
}();

exports['default'] = DropdownEventBus;

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ckm_risk_calculator_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ckm_risk_calculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ckm_risk_calculator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ckm_risk_calculator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ckm_risk_calculator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbccf81e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ckm_risk_calculator_vue__ = __webpack_require__(471);
function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bbccf81e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ckm_risk_calculator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbccf81e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ckm_risk_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    data: function data() {
        return {
            sex_range: 0,
            age_range: {
                value: '',
                errorMessage: "Age in years must be between 30-79 years",
                requiredMessage: "Please enter your Age"
            },
            totalCholesterol_range: {
                value: "",
                errorMessage: "Total cholesterol must be between 130-320 mg/dL",
                requiredMessage: "Please enter the cholesterol value"
            },
            hdlCholesteron_range: {
                value: "",
                errorMessage: "HDL cholesterol must be between 20 to 100 mg/dL",
                requiredMessage: "Please enter the HDL cholesterol value"
            },
            sbp_range: {
                value: "",
                errorMessage: "Systolic blood pressure must be between 90-200 mm Hg",
                requiredMessage: "Please enter the SBP value"
            },
            diabetes_range: 0,
            currentSmoker_range: 0,
            bmi_range: {
                value: "",
                errorMessage: "Body Mass Index (BMI) must be between 18.5 - 39.9 kg/m",
                requiredMessage: "Please enter the Body mass index (BMI) value"
            },
            egfr_range: {
                value: "",
                errorMessage: "Estimated glomerular filtration rate (eGFR) may be between 15 - 140 ml.",
                requiredMessage: "Pelase enter the Estimated glomerular filtration rate (eGFR) value"
            },
            htmlmeds_range: 0,
            htn_range: 0,
            cholesteronTreated_range: 0,
            uacr_range: "",
            uacr_range_front_end: '',
            HbA1C_range: '',
            SID_range: '',
            totalCVDWomenValue: "",
            totalCVDMenValue: "",
            totalAscdWomenValue: "",
            totalAscdMenValue: "",
            totalHearFailureMenVlaue: "",
            totalHeartFailureWomenValues: "",
            totalHeartFailureThirtyValueWomenValue: "",
            ageValidation: false,
            totalCholesterolRangeValidation: false,
            hdlCholesteronValidate: false,
            spbValidate: false,
            validationBMI: false,
            validationegfr: false,
            isAgeRequried: false,
            istotalCholesterolRequired: false,
            ishdlCholesteronRequired: false,
            isSbpRequired: false,
            isbmiRequired: false,
            isegfrRequired: false,
            ageIcon: false,
            totalCholesteronIcon: false,
            hdlCholesteronIcon: false,
            sbpIcon: false,
            bmiIcon: false,
            egfrIcon: false,
            activeItem: 'premier',
            tierId: null,
            totalThirtyYearsHeartFailureWomen: "",
            totalThirtyAscvdWomenValue: "",
            totalThirtyYearsCVDWomenValue: "",
            totalThirtyHearFailureMenValue: "",
            totalThirtyAscvdMenValue: "",
            thrityYearsCVDMen: "",
            totalResult: 0,
            diabetesErrorMessage: "Any history of diabetes.",
            currentSmokerErrorMessage: "Any cigarette use within the last 30 days",
            htnMedsErrorMessage: "Current use of any medication for hypertension",
            CholesteroltreatedErrorMessage: "Current use of statin medication to lower cholesterol",
            diabetesIcon: false,
            currentSmokerIcon: false,
            htnMedsIcon: false,
            cholesteronTreatedIcon: false,
            totalValidation: false,
            mobile: window.innerWidth <= 700,
            uacrValidation: false,
            HbA1CValidation: false,
            SIDValidation: false,
            emptyUacrValidation: false,
            emptyHbA1CValidation: false,
            emptySIDValidation: false,
            iconUacrValidation: false,
            iconHbA1CValidation: false,
            iconSIDValidation: false,
            SDIAPIValue: -1,
            sdiZipCode: {
                URL: "/aha-service/PHDApi/GetSdiValueByZipcode",
                'default': "",
                upgrade: ""
            },
            isShowSID: 0,
            isShowHbA1C: 0,
            isShowUACR: 0,
            SDIMissing: 1,
            ModelName: "",
            isLoading: false
        };
    },

    methods: {
        handleUpperInput: function handleUpperInput(inputKey) {
            if (inputKey === 'bmi') {
                this.bmi_range.value = this.bmi_range.value.replace(/[^0-9.]/g, "");
            }
            if (inputKey === 'efgr') {
                this.egfr_range.value = this.egfr_range.value.replace(/[^0-9.]/g, "");
            }
            if (inputKey === 'sbp') {
                this.sbp_range.value = this.sbp_range.value.replace(/[^0-9.]/g, "");
            }
            if (inputKey === 'hdl') {
                this.hdlCholesteron_range.value = this.hdlCholesteron_range.value.replace(/[^0-9.]/g, "");
            }
            if (inputKey === 'total') {
                this.totalCholesterol_range.value = this.totalCholesterol_range.value.replace(/[^0-9.]/g, "");
            }
            if (inputKey === 'year') {
                this.age_range.value = this.age_range.value.replace(/[^0-9.]/g, "");
            }
        },
        handleInput: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(inputKey) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (inputKey === 'SID_range') {
                                    this.SID_range = this.SID_range.replace(/[^0-9.]/g, "");
                                }
                                if (inputKey === 'uacr') {
                                    this.uacr_range_front_end = this.uacr_range_front_end.replace(/[^0-9.]/g, "");
                                }

                                if (inputKey === 'hb') {
                                    this.HbA1C_range = this.HbA1C_range.replace(/[^0-9.]/g, "");
                                }

                                if (inputKey === 'SID_range' && this.SID_range.toString().length < 5) {
                                    this.SIDValidation = true;
                                }

                                if (!(inputKey === 'SID_range' && this.SID_range.toString().length === 5)) {
                                    _context.next = 19;
                                    break;
                                }

                                this.SIDValidation = false;
                                this.isLoading = true;
                                //this.SDIAPIValue= 4
                                //this.SIDValidation = false
                                _context.prev = 7;
                                _context.next = 10;
                                return _axios2['default'].post(this.sdiZipCode.URL + '?zipCode=' + this.SID_range);

                            case 10:
                                res = _context.sent;

                                if (res.data == null) {
                                    this.SDIAPIValue = -1;
                                    this.SDIMissing = 1;
                                } else if (res.data.SDI_Group == 'missing') {
                                    this.SDIMissing = 1;
                                    this.SDIAPIValue = -1;
                                } else {
                                    this.SDIAPIValue = res.data.SDI_decile;
                                    this.SDIMissing = 0;
                                }
                                this.isLoading = false;
                                _context.next = 19;
                                break;

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](7);

                                // Handle errors if necessary
                                console.error('Error during API call:', _context.t0);
                                this.isLoading = false;

                            case 19:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[7, 15]]);
            }));

            function handleInput(_x) {
                return _ref.apply(this, arguments);
            }

            return handleInput;
        }(),
        resetTheValueOnceUserYesOrNo: function resetTheValueOnceUserYesOrNo(val) {
            if (val == 'sid' && this.isShowSID === 1) {
                this.SID_range = '';
                this.SIDValidation = false;
                //this.emptySIDValidation = false;
            }
            if (val == 'hba1c' && this.isShowHbA1C === 1) {
                this.HbA1C_range = '';
                this.HbA1CValidation = false;
                this.emptyHbA1CValidation = false;
            }
            if (val == 'uacr' && this.isShowUACR === 1) {
                this.uacr_range_front_end = "";
                this.uacr_range = "";
                this.uacrValidation = false;
                this.emptyUacrValidation = false;
            }
        },
        latestIconsValidation: function latestIconsValidation(val) {
            if (val == 'uacr') {
                this.iconUacrValidation = !this.iconUacrValidation;
            } else if (val === 'HbA1C') {
                this.iconHbA1CValidation = !this.iconHbA1CValidation;
            } else if (val === 'sid') {
                this.iconSIDValidation = !this.iconSIDValidation;
            }
        },
        latestValidation: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val, input) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:

                                if (this.uacr_range && this.uacr_range_front_end < 0 || this.uacr_range_front_end > 25000) {
                                    this.uacrValidation = true;
                                } else {
                                    this.uacrValidation = false;
                                }
                                if (val === 'HbA1C' && this.HbA1C_range < 3 || this.HbA1C_range > 15) {
                                    this.HbA1CValidation = true;
                                } else {
                                    this.HbA1CValidation = false;
                                }
                                if (val === 'sid') {
                                    this.SID_range = input.target.value;
                                }
                                if (val === 'uacr') {

                                    this.uacr_range_front_end = input.target.value === '0' ? 0 : input.target.value;
                                    this.uacr_range = this.uacr_range_front_end == '0' ? 0.1 : this.uacr_range_front_end;
                                }

                                if (val === 'uacr' && this.uacr_range === "") {
                                    this.emptyUacrValidation = true;
                                    this.uacrValidation = false;
                                }
                                if (val == 'HbA1C' && this.HbA1C_range === "") {
                                    this.emptyHbA1CValidation = true;
                                    this.HbA1CValidation = false;
                                }
                                if (val == 'sid' && this.SID_range === "") {
                                    // this.emptySIDValidation = true;
                                    this.SIDValidation = true;
                                }
                                if (val === 'uacr' && this.uacr_range !== "") {
                                    this.emptyUacrValidation = false;
                                }
                                if (val == 'HbA1C' && this.HbA1C_range !== "") {
                                    this.emptyHbA1CValidation = false;
                                }
                                if (val == 'sid' && this.SID_range !== "") {
                                    this.SIDValidation = false;
                                }

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function latestValidation(_x2, _x3) {
                return _ref2.apply(this, arguments);
            }

            return latestValidation;
        }(),
        alertMessage: function alertMessage(val) {
            if (val === 'diabetes') {
                this.diabetesIcon = !this.diabetesIcon;
            } else if (val === "currentSmoker") {
                this.currentSmokerIcon = !this.currentSmokerIcon;
            } else if (val === "htnMeds") {
                this.htnMedsIcon = !this.htnMedsIcon;
            } else {
                this.cholesteronTreatedIcon = !this.cholesteronTreatedIcon;
            }
        },
        isActive: function isActive(menuItem) {
            return this.activeItem === menuItem;
        },
        setActive: function setActive(menuItem) {
            this.activeItem = menuItem;
        },
        hcmCalculatorFormula: function hcmCalculatorFormula() {

            var sexValue = this.sex_range;
            var ageValue = this.age_range.value;
            var totalCholesterolValue = this.totalCholesterol_range.value;
            var hdlCholesteronValue = this.hdlCholesteron_range.value;
            var sbpValue = this.sbp_range.value;
            var diabetesValue = this.diabetes_range;
            var currentSmokerValue = this.currentSmoker_range;
            var bmiValue = this.bmi_range.value;
            var egfrValue = this.egfr_range.value;
            var htmlmedsValue = this.htmlmeds_range;
            var htnValue = this.htn_range;
            var cholesteronTreatedValue = this.cholesteronTreated_range;
            var uacrValue = this.uacr_range;
            //30 years variables
            var age = this.age_range.value;
            var tc = this.totalCholesterol_range.value;
            var hdl = this.hdlCholesteron_range.value;
            var sbp = this.sbp_range.value;
            var diabetes = this.diabetes_range;
            var currentSmoker = this.currentSmoker_range;
            var egfr = this.egfr_range.value;
            var hdn = this.htmlmeds_range;
            var statin = this.cholesteronTreated_range;
            var bmi = this.bmi_range.value;
            var diabestValidation = diabetesValue === 1 ? 1 : 0;
            var currentSmokerValidation = currentSmokerValue === 1 ? 1 : 0;
            var htmlmedsValueValidation = htmlmedsValue === 1 ? 1 : 0;
            var cholesteronTreatedValidation = cholesteronTreatedValue === 1 ? 1 : 0;
            if (sexValue === 1) {
                var totalValuestchdl = totalCholesterolValue - hdlCholesteronValue;
                var carotSymbol = Math.pow((age - 55) / 10, 2);
                // start Heart failure women
                var disabetsFirstHearFailureWomenValue = diabetesValue === 1 ? 1.038346 : 0;
                var currentSmokerFirstHearFailureWomenValue = currentSmokerValue === 1 ? 0.583916 : 0;
                var htnValueFirstValue = htmlmedsValue === 1 ? 0.3534442 : 0;
                var htnValueSecondValue = htmlmedsValue === 1 ? 0.0981511 * (Math.max(sbpValue, 110) - 130) / 20 : 0;
                var disabetsSecondHearFailureWomenValue = diabetesValue === 1 ? 0.3581041 * (ageValue - 55) / 10 : 0;
                var currentSmokerSecondHearFailureWomenValue = currentSmokerValue === 1 ? 0.1159453 * (ageValue - 55) / 10 : 0;
                var totalHeartFailureWomen = -4.310409 + 0.8998235 * (ageValue - 55) / 10 - 0.4559771 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3576505 * (Math.max(sbpValue, 110) - 130) / 20 + disabetsFirstHearFailureWomenValue + currentSmokerFirstHearFailureWomenValue - 0.0072294 * (Math.min(bmiValue, 30) - 25) / 5 + 0.2997706 * (Math.max(bmiValue, 30) - 30) / 5 + 0.7451638 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0557087 * (Math.max(egfrValue, 60) - 90) / -15 + htnValueFirstValue - htnValueSecondValue - 0.0946663 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - disabetsSecondHearFailureWomenValue - currentSmokerSecondHearFailureWomenValue - 0.003878 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5 - 0.1884289 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15;
                // start UACR Heart failure women
                var totalHeartFailureWomenUACR = -4.841506 + 0.9145975 * (ageValue - 55) / 10 - 0.4441346 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3260323 * (Math.max(sbpValue, 110) - 130) / 20 + 0.9611365 * diabestValidation + 0.5755787 * currentSmokerValidation + 0.0008831 * (Math.min(bmiValue, 30) - 25) / 5 + 0.2988964 * (Math.max(bmiValue, 30) - 30) / 5 + 0.5915291 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0556823 * (Math.max(egfrValue, 60) - 90) / -15 + 0.3314097 * htmlmedsValueValidation - 0.1078596 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 - 0.0875231 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.356859 * diabestValidation * (ageValue - 55) / 10 - 0.1220248 * currentSmokerValidation * (ageValue - 55) / 10 - 0.0053637 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5 - 0.1610389 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + 0.2197281 * Math.log(this.uacr_range);
                // start HBA1C Heart failure women
                var HBACCtotalHeartFailure10years = diabestValidation === 1 ? 0.1856442 * (this.HbA1C_range - 5.3) : 0.1833083 * (this.HbA1C_range - 5.3);
                var totalHeartFailureWomenHBA1C = -4.288225 + 0.8997391 * ((ageValue - 55) / 10) - 0.4422749 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3378691 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.681284 + currentSmokerValidation * 0.5886005 - 0.0148657 * (Math.min(bmiValue, 30) - 25) / 5 + 0.2958374 * (Math.max(bmiValue, 30) - 30) / 5 + 0.73447 * (Math.min(egfrValue, 60) - 60) / -15 + 0.05926 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.3543475 - htmlmedsValueValidation * 0.1002139 * (Math.max(sbpValue, 110) - 130) / 20 - 0.0878765 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.303684 * (ageValue - 55) / 10 - currentSmokerValidation * 0.1178943 * (ageValue - 55) / 10 - 0.008345 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5 - 0.1912183 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + HBACCtotalHeartFailure10years;
                // start SDI Heart failure women
                var updateSIDHearFailureValue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDHearFailureValue = 0.1343318;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDHearFailureValue = 0.2496522;
                }
                var SDITenYearsSDIMissing = this.SDIMissing == 1 ? 0.1915023 : 0;
                var totalHeartFailureWomenSDI = -4.409382 + 0.8819156 * ((ageValue - 55) / 10) - 0.4495491 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3457405 * (Math.max(sbpValue, 110) - 130) / 20 + 1.02632 * diabestValidation + 0.5371646 * currentSmokerValidation - 0.0168447 * (Math.min(bmiValue, 30) - 25) / 5 + 0.2805126 * (Math.max(bmiValue, 30) - 30) / 5 + 0.7315223 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0651679 * (Math.max(egfrValue, 60) - 90) / -15 + 0.3491487 * htmlmedsValueValidation - 0.0890335 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 - 0.0971028 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.3528078 * diabestValidation * (ageValue - 55) / 10 - 0.106216 * currentSmokerValidation * (ageValue - 55) / 10 + 0.0064998 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5 - 0.1899413 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + updateSIDHearFailureValue + SDITenYearsSDIMissing;
                // start total Heart failure women
                var updateSIDTotalHearFailureValue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalHearFailureValue = 0.1213034;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalHearFailureValue = 0.2314147;
                }
                var TenYearsWoemnSDIDecileMissing = this.SDIMissing == 1 ? 0.1819138 : 0;
                var TenYearsWomenUACRMissing = this.uacr_range == "" ? 0.0395368 : 0.1948135 * Math.log(this.uacr_range);
                var TenYearsWomenHBA1CMissing = this.HbA1C_range == "" ? 0.0010583 : 0;
                var heartFailure10yearsTotal = 0;
                if (this.HbA1C_range !== "") {
                    heartFailure10yearsTotal = diabestValidation === 1 ? 0.176668 * (this.HbA1C_range - 5.3) : 0.1614911 * (this.HbA1C_range - 5.3);
                }
                var totalHeartFailureWomenTotal = -4.896524 + 0.884209 * ((ageValue - 55) / 10) - 0.421474 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3002919 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.6170359 + currentSmokerValidation * 0.5380269 - 0.0191335 * (Math.min(bmiValue, 30) - 25) / 5 + 0.2764302 * (Math.max(bmiValue, 30) - 30) / 5 + 0.5975847 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0654197 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.3313614 - htmlmedsValueValidation * 0.1002304 * (Math.max(sbpValue, 110) - 130) / 20 - 0.0845363 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.2989062 * (ageValue - 55) / 10 - currentSmokerValidation * 0.1111354 * (ageValue - 55) / 10 + 0.0008104 * (ageValue - 55) / 10 * (Math.max(bmiValue, 30) - 30) / 5 - 0.1666635 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + updateSIDTotalHearFailureValue
                // + 0.1948135 * Math.log(this.uacr_range)
                + heartFailure10yearsTotal + TenYearsWoemnSDIDecileMissing + TenYearsWomenUACRMissing - TenYearsWomenHBA1CMissing;
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomen) / (1 + Math.exp(totalHeartFailureWomen)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1 || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomenUACR) / (1 + Math.exp(totalHeartFailureWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomenHBA1C) / (1 + Math.exp(totalHeartFailureWomenHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomenSDI) / (1 + Math.exp(totalHeartFailureWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalHeartFailureWomenValues = (Math.exp(totalHeartFailureWomenTotal) / (1 + Math.exp(totalHeartFailureWomenTotal)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
                //end heart failure 
                //start ASCVD Women section             
                var totalAscvdWomenValueBase = -3.819975 + 0.719883 * ((ageValue - 55) / 10) + 0.1176967 * (totalValuestchdl * 0.02586 - 3.5) - 0.151185 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0835358 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3592852 * (Math.max(sbpValue, 110) - 130) / 20 + 0.8348585 * diabestValidation + 0.4831078 * currentSmokerValidation + 0.4864619 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0397779 * (Math.max(egfrValue, 60) - 90) / -15 + 0.2265309 * htmlmedsValueValidation - 0.0592374 * cholesteronTreatedValidation - 0.0395762 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 + 0.0844423 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5) - 0.0567839 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0325692 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.1035985 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.2417542 * diabestValidation * (ageValue - 55) / 10 - currentSmokerValidation * 0.0791142 * (ageValue - 55) / 10 - 0.1671492 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15;
                //start UACR ASCVD Women section
                var totalAscvdWomenUACR = -4.174614 + 0.7201999 * ((ageValue - 55) / 10) + 0.1135771 * (totalValuestchdl * 0.02586 - 3.5) - 0.1493506 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0726677 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3436259 * (Math.max(sbpValue, 110) - 130) / 20 + 0.7773094 * diabestValidation + 0.4746662 * currentSmokerValidation + 0.3824646 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0394178 * (Math.max(egfrValue, 60) - 90) / -15 + 0.2125182 * htmlmedsValueValidation - 0.0603046 * cholesteronTreatedValidation - 0.0466053 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 + 0.0733118 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5) - 0.0534262 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0325689 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0999887 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.2411762 * diabestValidation * (ageValue - 55) / 10 - 0.0826941 * currentSmokerValidation * (ageValue - 55) / 10 - 0.1444737 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + 0.1501217 * Math.log(this.uacr_range);
                //start HBA1C ASCVD Women section
                var hba1ASCVD10yearsValue = diabestValidation === 1 ? 0.1339055 * (this.HbA1C_range - 5.3) : 0.1596461 * (this.HbA1C_range - 5.3);
                var totalAscvdWomenHBA1C = -3.838746 + 0.7111831 * ((ageValue - 55) / 10) + 0.106797 * (totalValuestchdl * 0.02586 - 3.5) - 0.1425745 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0736824 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3480844 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.5112951 + currentSmokerValidation * 0.4880292 + 0.4754997 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0438132 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.2259093 - cholesteronTreatedValidation * 0.0648872 - htmlmedsValueValidation * 0.0437645 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.0697082 * (totalValuestchdl * 0.02586 - 3.5) - 0.0506382 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0327475 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0996442 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.1924338 * (ageValue - 55) / 10 - currentSmokerValidation * 0.0803539 * (ageValue - 55) / 10 - 0.1682586 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + hba1ASCVD10yearsValue;
                //start SDI ASCVD Women section
                //svdascvd10yearsValue
                var updateSIDTotalASCVDValue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalASCVDValue = 0.1473705;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalASCVDValue = 0.2451878;
                }
                var svdascvd10yearsValueSDIMissing = this.SDIMissing == 1 && 0.1691593;
                var totalAscvdWomenSDI = -3.955898 + 0.7028123 * ((ageValue - 55) / 10) + 0.1056078 * (totalValuestchdl * 0.02586 - 3.5) - 0.1502263 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0488757 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3402681 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.838022 + currentSmokerValidation * 0.4064592 + 0.4838394 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0480415 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.2270648 - cholesteronTreatedValidation * 0.0585626 - htmlmedsValueValidation * 0.0349485 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.1017299 * (totalValuestchdl * 0.02586 - 3.5) - 0.062389 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0285106 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.1033711 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.2477845 * (ageValue - 55) / 10 - currentSmokerValidation * 0.0544326 * (ageValue - 55) / 10 - 0.1735372 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + updateSIDTotalASCVDValue + svdascvd10yearsValueSDIMissing;
                //start total ASCVD Women section
                var updateSIDTotalASCVDValues = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalASCVDValues = 0.1413965;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalASCVDValues = 0.228136;
                }
                console.log("updateSIDTotalASCVDValues", updateSIDTotalASCVDValues);
                var totalDiabietsUACRASCVD = 0;
                if (this.HbA1C_range !== '') {
                    totalDiabietsUACRASCVD = diabestValidation === 1 ? 0.123192 * (this.HbA1C_range - 5.3) : 0.1410572 * (this.HbA1C_range - 5.3);
                }
                var TenYearsWoemnASCDSDIDecileMissing = this.SDIMissing == 1 ? 0.1588908 : 0;
                var TenYearsWomenASCDUACRMissing = this.uacr_range == "" ? 0.0061613 : 0.1371824 * Math.log(this.uacr_range);
                var TenYearsWomenASCDHBA1CMissing = this.HbA1C_range == "" ? 0.005866 : 0;
                var totalAscvdWomenTotal = -4.291503 + 0.7023067 * ((ageValue - 55) / 10) + 0.0898765 * (totalValuestchdl * 0.02586 - 3.5) - 0.1407316 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0256648 * (Math.min(sbpValue, 110) - 110) / 20 + 0.314511 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.4799217 + currentSmokerValidation * 0.4062049 + 0.3847744 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0495174 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.2133861 - cholesteronTreatedValidation * 0.0678552 - htmlmedsValueValidation * 0.0451416 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.0788187 * (totalValuestchdl * 0.02586 - 3.5) - 0.0535985 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0291762 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0961839 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.2001466 * (ageValue - 55) / 10 - currentSmokerValidation * 0.0586472 * (ageValue - 55) / 10 - 0.1537791 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + updateSIDTotalASCVDValues + totalDiabietsUACRASCVD + TenYearsWoemnASCDSDIDecileMissing + TenYearsWomenASCDUACRMissing + TenYearsWomenASCDHBA1CMissing;

                console.log("totalAscvdWomenTotal", totalAscvdWomenTotal);
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenValueBase) / (1 + Math.exp(totalAscvdWomenValueBase)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenUACR) / (1 + Math.exp(totalAscvdWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenHBA1C) / (1 + Math.exp(totalAscvdWomenHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenSDI) / (1 + Math.exp(totalAscvdWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalAscdWomenValue = (Math.exp(totalAscvdWomenTotal) / (1 + Math.exp(totalAscvdWomenTotal)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
                //end ASCVD Women end section
                //start CVD Women section
                //Base women
                var totalCVDWomenBase = -3.307728 + 0.7939329 * (ageValue - 55) / 10 + 0.0305239 * (totalValuestchdl * 0.02586 - 3.5) - 0.1606857 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.2394003 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3600781 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.8667604 + currentSmokerValidation * 0.5360739 + 0.6045917 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0433769 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.3151672 - cholesteronTreatedValidation * 0.1477655 + htmlmedsValueValidation * -0.0663612 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.1197879 * (totalValuestchdl * 0.02586 - 3.5) - 0.0819715 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0306769 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0946348 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * -0.27057 * (ageValue - 55) / 10 + currentSmokerValidation * -0.078715 * (ageValue - 55) / 10 - 0.1637806 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15;
                //Base CVD UACR women
                var totalCVDWomenUACR = -3.738341 + 0.7969249 * ((ageValue - 55) / 10) + 0.0256635 * (totalValuestchdl * 0.02586 - 3.5) - 0.1588107 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.2255701 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3396649 * (Math.max(sbpValue, 110) - 130) / 20 + 0.8047515 * diabestValidation + 0.5285338 * currentSmokerValidation + 0.4803511 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0434472 * (Math.max(egfrValue, 60) - 90) / -15 + 0.2985207 * htmlmedsValueValidation - 0.1497787 * cholesteronTreatedValidation - 0.0742889 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 + 0.106756 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5) - 0.0778126 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0306768 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0907168 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.2705122 * diabestValidation * (ageValue - 55) / 10 - 0.0830564 * currentSmokerValidation * (ageValue - 55) / 10 - 0.1389249 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + 0.1793037 * Math.log(this.uacr_range);
                //HbA1c 10 years women          
                var hbscValueCVD = diabestValidation == 1 ? 0.1338348 * (this.HbA1C_range - 5.3) : 0.1622409 * (this.HbA1C_range - 5.3);
                var totalCVDWomenHBA1C = -3.306162 + 0.7858178 * ((ageValue - 55) / 10) + 0.0194438 * (totalValuestchdl * 0.02586 - 3.5) - 0.1521964 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.2296681 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3465777 * (Math.max(sbpValue, 110) - 130) / 20 + 0.5366241 * diabestValidation + 0.5411682 * currentSmokerValidation + 0.5931898 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0472458 * (Math.max(egfrValue, 60) - 90) / -15 + 0.3158567 * htmlmedsValueValidation - 0.1535174 * cholesteronTreatedValidation - 0.0687752 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 + 0.1054746 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5) - 0.0761119 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0307469 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0905966 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.2241857 * diabestValidation * (ageValue - 55) / 10 - 0.080186 * currentSmokerValidation * (ageValue - 55) / 10 - 0.1667286 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + hbscValueCVD;
                // SID CVD 10 years women
                var updateSIDTotalCVD = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalCVD = 0.1442776;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalCVD = 0.2421409;
                }
                var svdCVD10yearsValidationSDIMissing = this.SDIMissing == 1 && 0.1885076;
                var totalCVDWomenSDI = -3.461564 + 0.7754083 * ((ageValue - 55) / 10) + 0.0221756 * (totalValuestchdl * 0.02586 - 3.5) - 0.1650828 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.2180808 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3381188 * (Math.max(sbpValue, 110) - 130) / 20 + 0.8624372 * diabestValidation + 0.4663953 * currentSmokerValidation + 0.5919004 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0516821 * (Math.max(egfrValue, 60) - 90) / -15 + 0.3182166 * htmlmedsValueValidation - 0.1460816 * cholesteronTreatedValidation - 0.0574455 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 + 0.1302287 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5) - 0.083509 * (ageValue - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0282181 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0952647 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.2718966 * diabestValidation * (ageValue - 55) / 10 - 0.0641738 * currentSmokerValidation * (ageValue - 55) / 10 - 0.1717026 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + updateSIDTotalCVD + svdCVD10yearsValidationSDIMissing;

                //Total CVD 10 years women
                var updateSIDTotalCVDWomen = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDTotalCVDWomen = 0.1361989;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDTotalCVDWomen = 0.2261596;
                }
                var totalWomen10years = 0;
                if (this.HbA1C_range !== "") {
                    totalWomen10years = diabestValidation == 1 ? 0.1298513 * (this.HbA1C_range - 5.3) : 0.1412555 * (this.HbA1C_range - 5.3);
                }
                var TenYearsWoemnCVDSDIDecileMissing = this.SDIMissing == 1 || this.SID_range === "" ? 0.1804508 : 0;
                var TenYearsWomenCVDUACRMissing = this.uacr_range == "" ? 0.0198413 : 0.1645922 * Math.log(this.uacr_range);
                var TenYearsWomenCVDHBA1CMissing = this.HbA1C_range == "" ? 0.0031658 : 0;
                var totalCVDWomenAll = -3.860385 + 0.7716794 * ((ageValue - 55) / 10) + 0.0062109 * (totalValuestchdl * 0.02586 - 3.5) - 0.1547756 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.1933123 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3071217 * (Math.max(sbpValue, 110) - 130) / 20 + 0.496753 * diabestValidation + 0.466605 * currentSmokerValidation + 0.4780697 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0529077 * (Math.max(egfrValue, 60) - 90) / -15 + 0.3034892 * htmlmedsValueValidation - 0.1556524 * cholesteronTreatedValidation - 0.0667026 * htmlmedsValueValidation * ((Math.max(sbpValue, 110) - 130) / 20) + 0.1061825 * cholesteronTreatedValidation * (totalValuestchdl * 0.02586 - 3.5) - 0.0742271 * ((ageValue - 55) / 10) * (totalValuestchdl * 0.02586 - 3.5) + 0.0288245 * ((ageValue - 55) / 10) * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0875188 * ((ageValue - 55) / 10) * (Math.max(sbpValue, 110) - 130) / 20 - 0.2267102 * diabestValidation * ((ageValue - 55) / 10) - 0.0676125 * currentSmokerValidation * ((ageValue - 55) / 10) - 0.1493231 * ((ageValue - 55) / 10) * (Math.min(egfrValue, 60) - 60) / -15 + updateSIDTotalCVDWomen + totalWomen10years + TenYearsWoemnCVDSDIDecileMissing + TenYearsWomenCVDUACRMissing - TenYearsWomenCVDHBA1CMissing;

                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {

                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenBase) / (1 + Math.exp(totalCVDWomenBase)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenUACR) / (1 + Math.exp(totalCVDWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenHBA1C) / (1 + Math.exp(totalCVDWomenHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenSDI) / (1 + Math.exp(totalCVDWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalCVDWomenValue = (Math.exp(totalCVDWomenAll) / (1 + Math.exp(totalCVDWomenAll)) * 100).toFixed(1);

                    this.ModelName = "full model";
                }
                //End CVD Women section
                //30 years womensection
                var firstThirtyHFWomenDiabetes = diabetes === 1 ? 0.8330787 : 0;
                var firstThrityHFWomenCurrentSmoker = currentSmoker === 1 ? 0.3438651 : 0;
                var firstThrityHFWomenHDN = hdn === 1 ? 0.333921 : 0;
                var secondThrityHFWomenHDN = hdn === 1 ? 0.0893177 * (Math.max(sbp, 110) - 130) / 20 : 0;
                var secondThirtyHFNWomenDiabetes = diabetes === 1 ? 0.404855 * (age - 55) / 10 : 0;
                var secondThirtyHFNWomenCurrentSmoker = currentSmoker === 1 ? 0.1982991 * (age - 55) / 10 : 0;
                var totalThirtyYearsHeartFailureWomen = -2.205379 + 0.6254374 * (age - 55) / 10 - 0.0983038 * carotSymbol - 0.3919241 * (Math.min(sbp, 110) - 110) / 20 + 0.3142295 * (Math.max(sbp, 110) - 130) / 20 + firstThirtyHFWomenDiabetes + firstThrityHFWomenCurrentSmoker + 0.0594874 * (Math.min(bmi, 30) - 25) / 5 + 0.2525536 * (Math.max(bmi, 30) - 30) / 5 + 0.2981642 * (Math.min(egfr, 60) - 60) / -15 + 0.0667159 * (Math.max(egfr, 60) - 90) / -15 + firstThrityHFWomenHDN - secondThrityHFWomenHDN - 0.0974299 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - secondThirtyHFNWomenDiabetes - secondThirtyHFNWomenCurrentSmoker - 0.0035619 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.1564215 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15;
                ///30 years UACR heart Failure womensection
                var totalThrityWomnHeartFailureUACRValue = -2.538952 + 0.6319513 * ((age - 55) / 10) - 0.1009284 * carotSymbol - 0.3787175 * (Math.min(sbp, 110) - 110) / 20 + 0.2863393 * (Math.max(sbp, 110) - 130) / 20 + 0.7631221 * diabestValidation + 0.3355843 * currentSmokerValidation + 0.0677084 * (Math.min(bmi, 30) - 25) / 5 + 0.2517238 * (Math.max(bmi, 30) - 30) / 5 + 0.1940067 * (Math.min(egfr, 60) - 60) / -15 + 0.0664006 * (Math.max(egfr, 60) - 90) / -15 + 0.3171436 * htmlmedsValueValidation - 0.0970661 * htmlmedsValueValidation * (Math.max(sbp, 110) - 130) / 20 - 0.0896239 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.400743 * diabestValidation * (age - 55) / 10 - 0.2042041 * currentSmokerValidation * (age - 55) / 10 - 0.0054699 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.13602 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + 0.1486028 * Math.log(this.uacr_range);
                var heartFaulureDiabetesValue = diabestValidation === 1 ? 0.1448336 * (this.HbA1C_range - 5.3) : 0.1277838 * (this.HbA1C_range - 5.3);
                var heartFailureThityValuewomenHCBA1C = -2.193553 + 0.6210856 * ((age - 55) / 10) - 0.1000972 * carotSymbol - 0.3773697 * (Math.min(sbp, 110) - 110) / 20 + 0.295316 * (Math.max(sbp, 110) - 130) / 20 + 0.5681692 * diabestValidation + 0.3449139 * currentSmokerValidation + 0.0540094 * (Math.min(bmi, 30) - 25) / 5 + 0.249767 * (Math.max(bmi, 30) - 30) / 5 + 0.2875781 * (Math.min(egfr, 60) - 60) / -15 + 0.0692013 * (Math.max(egfr, 60) - 90) / -15 + 0.3334936 * htmlmedsValueValidation - 0.0922339 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation - 0.0907885 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.3554646 * (age - 55) / 10 * diabestValidation - 0.2008846 * (age - 55) / 10 * currentSmokerValidation - 0.0079611 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.156803 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + heartFaulureDiabetesValue;
                var updateThirtySIDTotalHeartFailureWomen = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalHeartFailureWomen = 0.0960646;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalHeartFailureWomen = 0.1987543;
                }
                var SDIValueISMissingThirtyYear = this.SDIMissing == 1 ? 0.1562214 : 0;
                var totalThirtyYearsHeartFailureWomenSDI = -2.317899 + 0.5919097 * ((age - 55) / 10) - 0.1023133 * carotSymbol - 0.3864727 * (Math.min(sbp, 110) - 110) / 20 + 0.301876 * (Math.max(sbp, 110) - 130) / 20 + 0.8162909 * diabestValidation + 0.3449647 * currentSmokerValidation + 0.0574975 * (Math.min(bmi, 30) - 25) / 5 + 0.2367826 * (Math.max(bmi, 30) - 30) / 5 + 0.2790347 * (Math.min(egfr, 60) - 60) / -15 + 0.0742645 * (Math.max(egfr, 60) - 90) / -15 + 0.3352935 * htmlmedsValueValidation - 0.0772532 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation - 0.0995144 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.4000423 * (age - 55) / 10 * diabestValidation - 0.1770335 * (age - 55) / 10 * currentSmokerValidation + 0.0083046 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.149585 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + updateThirtySIDTotalHeartFailureWomen + SDIValueISMissingThirtyYear;
                //total heart Failure value
                var updateThirtySIDTotalHeartFailureWomens = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalHeartFailureWomens = 0.0847634;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalHeartFailureWomens = 0.18397;
                }
                var thrityYearsWomensHeartFailureValueMissingSDI = this.SDIMissing == 1 || this.SID_range == "" ? 0.1485802 : 0;
                var thrityYearsWomensHeartFailureValueMissingUACR = this.uacr_range == "" ? 0.0167008 : 0.1273306 * Math.log(this.uacr_range);
                var thrityYearsWomensHeartFailureValueMissingHBAC1 = this.HbA1C_range == "" ? 0.0138979 : 0;
                var finalValueThity = 0;
                if (this.HbA1C_range !== '') {
                    finalValueThity = diabestValidation == 1 ? 0.1378342 * (this.HbA1C_range - 5.3) : 0.1138832 * (this.HbA1C_range - 5.3);
                }
                var totalThirtyYearsHeartFailureWomenFull = -2.642208 + 0.5927507 * ((age - 55) / 10) - 0.1028754 * carotSymbol - 0.3593781 * (Math.min(sbp, 110) - 110) / 20 + 0.2628556 * (Math.max(sbp, 110) - 130) / 20 + 0.5113472 * diabestValidation + 0.347344 * currentSmokerValidation + 0.0564656 * (Math.min(bmi, 30) - 25) / 5 + 0.2363857 * (Math.max(bmi, 30) - 30) / 5 + 0.1971295 * (Math.min(egfr, 60) - 60) / -15 + 0.0735227 * (Math.max(egfr, 60) - 90) / -15 + 0.3219386 * htmlmedsValueValidation - 0.0880321 * htmlmedsValueValidation * (Math.max(sbp, 110) - 130) / 20 - 0.0863132 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.3425359 * diabestValidation * (age - 55) / 10 - 0.181405 * currentSmokerValidation * (age - 55) / 10 + 0.0031285 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.1356989 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + updateThirtySIDTotalHeartFailureWomens
                //+ 0.1273306  * Math.log(this.uacr_range) 
                + finalValueThity + thrityYearsWomensHeartFailureValueMissingSDI + thrityYearsWomensHeartFailureValueMissingUACR + thrityYearsWomensHeartFailureValueMissingHBAC1;
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(totalThirtyYearsHeartFailureWomen) / (1 + Math.exp(totalThirtyYearsHeartFailureWomen)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(totalThrityWomnHeartFailureUACRValue) / (1 + Math.exp(totalThrityWomnHeartFailureUACRValue)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(heartFailureThityValuewomenHCBA1C) / (1 + Math.exp(heartFailureThityValuewomenHCBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(totalThirtyYearsHeartFailureWomenSDI) / (1 + Math.exp(totalThirtyYearsHeartFailureWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalThirtyYearsHeartFailureWomen = (Math.exp(totalThirtyYearsHeartFailureWomenFull) / (1 + Math.exp(totalThirtyYearsHeartFailureWomenFull)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
                //30 years end Women heart Failure
                //30 years ASCVD women start here
                var firstThirtyASCVDWomenDiabetes = diabetes === 1 ? 0.6296707 : 0;
                var firstThrityASCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.268292 : 0;
                var firstThrityASCVDWomenHDN = hdn === 1 ? 0.1875292 : 0;
                var firstThrityASCVDWomenStatin = statin === 1 ? 0.0152476 : 0;
                var secondThrityASCVDWomenHDN = hdn === 1 ? 0.0276123 * (Math.max(sbp, 110) - 130) / 20 : 0;
                var secondThrityASCVDDWomenStatin = statin === 1 ? 0.0736147 * (totalValuestchdl * 0.02586 - 3.5) : 0;
                var secondThirtyASCVDNWomenDiabetes = diabetes === 1 ? 0.2727793 * (age - 55) / 10 : 0;
                var secondthrityASCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1530907 * (age - 55) / 10 : 0;
                var totalThirtyAscvdWomenValue = -1.974074 + 0.4669202 * (age - 55) / 10 - 0.0893118 * carotSymbol + 0.1256901 * (totalValuestchdl * 0.02586 - 3.5) - 0.1542255 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0018093 * (Math.min(sbp, 110) - 110) / 20 + 0.322949 * (Math.max(sbp, 110) - 130) / 20 + firstThirtyASCVDWomenDiabetes + firstThrityASCVDWomenCurrentSmoker + 0.100106 * (Math.min(egfr, 60) - 60) / -15 + 0.0499663 * (Math.max(egfr, 60) - 90) / -15 + firstThrityASCVDWomenHDN + firstThrityASCVDWomenStatin - secondThrityASCVDWomenHDN + secondThrityASCVDDWomenStatin - 0.0521962 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0316918 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1046101 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - secondThirtyASCVDNWomenDiabetes - secondthrityASCVDWomenCurrentSmoker - 0.1299149 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15;
                //30 years UACR ASCVD women start here
                var totalThirtyAscvdWomenUACR = -2.178888 + 0.4629669 * ((age - 55) / 10) - 0.0902777 * carotSymbol + 0.1215214 * (totalValuestchdl * 0.02586 - 3.5) - 0.1522069 * (hdl * 0.02586 - 1.3) / 0.3 + 0.0092679 * (Math.min(sbp, 110) - 110) / 20 + 0.3113609 * (Math.max(sbp, 110) - 130) / 20 + 0.581256 * diabestValidation + 0.263167 * currentSmokerValidation + 0.0391726 * (Math.min(egfr, 60) - 60) / -15 + 0.0492959 * (Math.max(egfr, 60) - 90) / -15 + 0.1786178 * htmlmedsValueValidation + 0.0131058 * cholesteronTreatedValidation - 0.0325135 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.0617093 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0489189 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0321079 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1003185 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2684574 * (age - 55) / 10 * diabestValidation - 0.1547301 * (age - 55) / 10 * currentSmokerValidation - 0.1130703 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + 0.0903471 * Math.log(this.uacr_range);
                var totalThirtyASCDHDBc1Value = diabestValidation === 1 ? 0.0875827 * (this.HbA1C_range - 5.3) : 0.1126417 * (this.HbA1C_range - 5.3);
                var totalThirtyAscvdWomenHbA1c = -2.011533 + 0.4555574 * ((age - 55) / 10) - 0.0903501 * carotSymbol + 0.1148321 * (totalValuestchdl * 0.02586 - 3.5) - 0.1458754 * (hdl * 0.02586 - 1.3) / 0.3 + 0.0089323 * (Math.min(sbp, 110) - 110) / 20 + 0.3139029 * (Math.max(sbp, 110) - 130) / 20 + 0.386281 * diabestValidation + 0.2714309 * currentSmokerValidation + 0.0930987 * (Math.min(egfr, 60) - 60) / -15 + 0.0532216 * (Math.max(egfr, 60) - 90) / -15 + 0.1862181 * htmlmedsValueValidation + 0.0106964 * cholesteronTreatedValidation - 0.0329713 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.0583609 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0463273 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0324717 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1004777 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2266944 * (age - 55) / 10 * diabestValidation - 0.1541859 * (age - 55) / 10 * currentSmokerValidation - 0.1286005 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + totalThirtyASCDHDBc1Value;
                var updateThirtySIDASCVDWomens = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDASCVDWomens = 0.1149139;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDASCVDWomens = 0.1976537;
                }
                var ASCVDThirtyYearValueSDIMissing = this.SDIMissing == 1 ? 0.1391241 : 0;
                var totalThirtyAscvdWomenSdi = -2.116951 + 0.4396545 * ((age - 55) / 10) - 0.0918489 * carotSymbol + 0.1132729 * (totalValuestchdl * 0.02586 - 3.5) - 0.1544977 * (hdl * 0.02586 - 1.3) / 0.3 + 0.036315 * (Math.min(sbp, 110) - 110) / 20 + 0.3049229 * (Math.max(sbp, 110) - 130) / 20 + 0.6344794 * diabestValidation + 0.234514 * currentSmokerValidation + 0.0898312 * (Math.min(egfr, 60) - 60) / -15 + 0.0564502 * (Math.max(egfr, 60) - 90) / -15 + 0.1933487 * htmlmedsValueValidation + 0.0220467 * cholesteronTreatedValidation - 0.0229229 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.0903326 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0579383 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0274011 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1039749 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2785102 * (age - 55) / 10 * diabestValidation - 0.1167267 * (age - 55) / 10 * currentSmokerValidation - 0.1269382 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + updateThirtySIDASCVDWomens + ASCVDThirtyYearValueSDIMissing;
                var updateThirtySIDTotalASCVDWomens = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalASCVDWomens = 0.1107632;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalASCVDWomens = 0.1840367;
                }
                var thrityYearsWomensACVDValueMissingSDI = this.SDIMissing == 1 || this.SID_range === "" ? 0.1308962 : 0;
                var thrityYearsWomensACVDValueMissingUACR = this.uacr_range == "" ? -0.0147785 : 0.0810739 * Math.log(this.uacr_range);
                var thrityYearsWomensACVDValueMissingHBAC1 = this.HbA1C_range == "" ? 0.017301 : 0;
                var totalThirtyYearsWomenDiabetesTotal = 0;
                if (this.HbA1C_range !== '') {
                    totalThirtyYearsWomenDiabetesTotal = diabestValidation === 1 ? 0.0794709 * (this.HbA1C_range - 5.3) : 0.1002615 * (this.HbA1C_range - 5.3);
                }
                var totalThirtyAscvdWomenFull = -2.314066 + 0.4386739 * ((age - 55) / 10) - 0.0921956 * carotSymbol + 0.0977728 * (totalValuestchdl * 0.02586 - 3.5) - 0.1453525 * (hdl * 0.02586 - 1.3) / 0.3 + 0.0590925 * (Math.min(sbp, 110) - 110) / 20 + 0.2862862 * (Math.max(sbp, 110) - 130) / 20 + 0.3669136 * diabestValidation + 0.2354695 * currentSmokerValidation + 0.0354338 * (Math.min(egfr, 60) - 60) / -15 + 0.0573093 * (Math.max(egfr, 60) - 90) / -15 + 0.1840085 * htmlmedsValueValidation + 0.0117504 * cholesteronTreatedValidation - 0.0331945 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.0664311 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0492826 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0288888 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0964709 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2279648 * (age - 55) / 10 * diabestValidation - 0.120405 * (age - 55) / 10 * currentSmokerValidation - 0.1157635 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + updateThirtySIDTotalASCVDWomens + totalThirtyYearsWomenDiabetesTotal + thrityYearsWomensACVDValueMissingSDI + thrityYearsWomensACVDValueMissingUACR + thrityYearsWomensACVDValueMissingHBAC1;
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenValue) / (1 + Math.exp(totalThirtyAscvdWomenValue)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenUACR) / (1 + Math.exp(totalThirtyAscvdWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenHbA1c) / (1 + Math.exp(totalThirtyAscvdWomenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenSdi) / (1 + Math.exp(totalThirtyAscvdWomenSdi)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalThirtyAscvdWomenValue = (Math.exp(totalThirtyAscvdWomenFull) / (1 + Math.exp(totalThirtyAscvdWomenFull)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
                //ASCVD end here
                //30 years CVD women start from here
                var firstThirtyCVDWomenDiabetes = diabetes === 1 ? 0.6793894 : 0;
                var firstThrityCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.3196112 : 0;
                var firstThrityCVDWomenHDN = hdn === 1 ? 0.2894 : 0;
                var firstThrityCVDWomenStatin = statin === 1 ? 0.075688 : 0;
                var secondThrityCVDWomenHDN = hdn === 1 ? 0.056367 * (Math.max(sbp, 110) - 130) / 20 : 0;
                var secondThrityCVDWomenStatin = statin === 1 ? 0.1071019 * (totalValuestchdl * 0.02586 - 3.5) : 0;
                var secondThirtyCVDNWomenDiabetes = diabetes === 1 ? 0.3206166 * (age - 55) / 10 : 0;
                var secondthrityCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1607862 * (age - 55) / 10 : 0;
                var thrityYearsCVDWomen = -1.318827 + 0.5503079 * (age - 55) / 10 - 0.0928369 * carotSymbol + 0.0409794 * (totalValuestchdl * 0.02586 - 3.5) - 0.1663306 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1628654 * (Math.min(sbp, 110) - 110) / 20 + 0.3299505 * (Math.max(sbp, 110) - 130) / 20 + firstThirtyCVDWomenDiabetes + firstThrityCVDWomenCurrentSmoker + 0.1857101 * (Math.min(egfr, 60) - 60) / -15 + 0.0553528 * (Math.max(egfr, 60) - 90) / -15 + firstThrityCVDWomenHDN - firstThrityCVDWomenStatin - secondThrityCVDWomenHDN + secondThrityCVDWomenStatin - 0.0751438 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0301786 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0998776 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - secondThirtyCVDNWomenDiabetes - secondthrityCVDWomenCurrentSmoker - 0.1450788 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15;
                //30 years UACR CVD women start from here
                var thrityYearsCVDWomenUACR = -1.583738 + 0.5491768 * ((age - 55) / 10) - 0.0937311 * carotSymbol + 0.0359847 * (totalValuestchdl * 0.02586 - 3.5) - 0.1642965 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1483404 * (Math.min(sbp, 110) - 110) / 20 + 0.313353 * (Math.max(sbp, 110) - 130) / 20 + 0.6253766 * diabestValidation + 0.3147172 * currentSmokerValidation + 0.1094663 * (Math.min(egfr, 60) - 60) / -15 + 0.0550705 * (Math.max(egfr, 60) - 90) / -15 + 0.2782433 * htmlmedsValueValidation - 0.0786239 * cholesteronTreatedValidation - 0.0628947 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.093204 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0710685 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0306363 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0951455 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.3168231 * (age - 55) / 10 * diabestValidation - 0.1636391 * (age - 55) / 10 * currentSmokerValidation - 0.1265483 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + 0.1142251 * Math.log(this.uacr_range);
                var thieryYearCVDHBA1CdiabestValidation = diabestValidation === 1 ? 0.0940543 * (this.HbA1C_range - 5.3) : 0.1116486 * (this.HbA1C_range - 5.3);
                var thrityYearsCVDWomenHbA1c = -1.341059 + 0.5343493 * ((age - 55) / 10) - 0.0952314 * carotSymbol + 0.0298124 * (totalValuestchdl * 0.02586 - 3.5) - 0.1578451 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1504488 * (Math.min(sbp, 110) - 110) / 20 + 0.3173368 * (Math.max(sbp, 110) - 130) / 20 + 0.4314738 * diabestValidation + 0.3209399 * currentSmokerValidation + 0.1771435 * (Math.min(egfr, 60) - 60) / -15 + 0.0582828 * (Math.max(egfr, 60) - 90) / -15 + 0.2888947 * htmlmedsValueValidation - 0.0795886 * cholesteronTreatedValidation - 0.0600438 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.0920598 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0696108 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.0308807 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0954051 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2763408 * (age - 55) / 10 * diabestValidation - 0.1623944 * (age - 55) / 10 * currentSmokerValidation - 0.1430514 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + thieryYearCVDHBA1CdiabestValidation;
                var updateThirtySIDTotalCVDWomens = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalCVDWomens = 0.1129725;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalCVDWomens = 0.1975843;
                }
                var ThirytYEarsSDIValueMissing = this.SDIMissing == 1 ? 0.1627381 : 0;
                var thrityYearsCVDWomenSDI = -1.493211 + 0.5124233 * ((age - 55) / 10) - 0.0978159 * carotSymbol + 0.0322131 * (totalValuestchdl * 0.02586 - 3.5) - 0.1717884 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1364536 * (Math.min(sbp, 110) - 110) / 20 + 0.3074443 * (Math.max(sbp, 110) - 130) / 20 + 0.6709275 * diabestValidation + 0.2897728 * currentSmokerValidation + 0.1670658 * (Math.min(egfr, 60) - 60) / -15 + 0.0618439 * (Math.max(egfr, 60) - 90) / -15 + 0.2969806 * htmlmedsValueValidation - 0.0665514 * cholesteronTreatedValidation - 0.0458917 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.1168505 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0770419 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.027634 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0992045 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.3208137 * (age - 55) / 10 * diabestValidation - 0.134847 * (age - 55) / 10 * currentSmokerValidation - 0.1399842 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + updateThirtySIDTotalCVDWomens + ThirytYEarsSDIValueMissing;
                var updateThirtySIDTotalCVDWomen = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateThirtySIDTotalCVDWomen = 0.1067741;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateThirtySIDTotalCVDWomen = 0.1853138;
                }
                var totalCalCVDWomenthirtyYear = 0;
                if (this.HbA1C_range !== '') {
                    totalCalCVDWomenthirtyYear = diabestValidation === 1 ? 0.0925285 * (this.HbA1C_range - 5.3) : 0.0975598 * (this.HbA1C_range - 5.3);
                }
                var thrityYearsWomensCVDValueMissingSDI = this.SDIMissing == 1 || this.SID_range === "" ? 0.1567115 : 0;
                var thrityYearsWomensCVDValueMissingUACR = this.uacr_range == "" ? 0.0006181 : 0.1028065 * Math.log(this.uacr_range);
                var thrityYearsWomensCVDValueMissingHBAC1 = this.HbA1C_range == "" ? 0.0101713 : 0;
                var thrityYearsCVDWomenFull = -1.748475 + 0.5073749 * ((age - 55) / 10) - 0.0981751 * carotSymbol + 0.0162303 * (totalValuestchdl * 0.02586 - 3.5) - 0.1617147 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1111241 * (Math.min(sbp, 110) - 110) / 20 + 0.282946 * (Math.max(sbp, 110) - 130) / 20 + 0.4004069 * diabestValidation + 0.2918701 * currentSmokerValidation + 0.1017102 * (Math.min(egfr, 60) - 60) / -15 + 0.0622643 * (Math.max(egfr, 60) - 90) / -15 + 0.2872416 * htmlmedsValueValidation - 0.0768135 * cholesteronTreatedValidation - 0.0557282 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.0917585 * (totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0679131 * (age - 55) / 10 * (totalValuestchdl * 0.02586 - 3.5) + 0.029076 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0907755 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2702118 * (age - 55) / 10 * diabestValidation - 0.1373216 * (age - 55) / 10 * currentSmokerValidation - 0.1255864 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + updateThirtySIDTotalCVDWomen + totalCalCVDWomenthirtyYear + thrityYearsWomensCVDValueMissingSDI + thrityYearsWomensCVDValueMissingUACR + thrityYearsWomensCVDValueMissingHBAC1;

                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomen) / (1 + Math.exp(thrityYearsCVDWomen)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomenUACR) / (1 + Math.exp(thrityYearsCVDWomenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomenHbA1c) / (1 + Math.exp(thrityYearsCVDWomenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomenSDI) / (1 + Math.exp(thrityYearsCVDWomenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalThirtyYearsCVDWomenValue = (Math.exp(thrityYearsCVDWomenFull) / (1 + Math.exp(thrityYearsCVDWomenFull)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
            } else {
                var _totalValuestchdl = totalCholesterolValue - hdlCholesteronValue;
                var _carotSymbol = Math.pow((age - 55) / 10, 2);
                //start heart Failure men
                var totalHearFailureMenValue = -3.946391 + 0.8972642 * ((ageValue - 55) / 10) - 0.6811466 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3634461 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.923776 + currentSmokerValidation * 0.5023736 - 0.0485841 * ((Math.min(bmiValue, 30) - 25) / 5) + 0.3726929 * ((Math.max(bmiValue, 30) - 30) / 5) + 0.6926917 * ((Math.min(egfrValue, 60) - 60) / -15) + 0.0251827 * ((Math.max(egfrValue, 60) - 90) / -15) + htmlmedsValueValidation * 0.2980922 - htmlmedsValueValidation * 0.0497731 * (Math.max(sbpValue, 110) - 130) / 20 - 0.1289201 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20) - diabestValidation * 0.3040924 * (ageValue - 55) / 10 - currentSmokerValidation * 0.1401688 * (ageValue - 55) / 10 + 0.0068126 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5) - 0.1797778 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15);
                //start UACR heart Failure men
                var totalHearFailureMenValueUACR = -4.556907 + 0.9111795 * ((ageValue - 55) / 10) - 0.6693649 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3290082 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.8377655 + currentSmokerValidation * 0.4978917 - 0.042749 * ((Math.min(bmiValue, 30) - 25) / 5) + 0.3624165 * ((Math.max(bmiValue, 30) - 30) / 5) + 0.5075796 * ((Math.min(egfrValue, 60) - 60) / -15) + 0.0137716 * ((Math.max(egfrValue, 60) - 90) / -15) + htmlmedsValueValidation * 0.2739963 - htmlmedsValueValidation * 0.0645712 * (Math.max(sbpValue, 110) - 130) / 20 - 0.1230039 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20) - diabestValidation * 0.3013297 * (ageValue - 55) / 10 - currentSmokerValidation * 0.1410318 * (ageValue - 55) / 10 + 0.0021531 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5) - 0.1548018 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15) + 0.2306299 * Math.log(this.uacr_range);
                //start HBA1C heart Failure men
                var tenYeraHearFailureHBA1C = diabestValidation === 1 ? 0.1652857 * (this.HbA1C_range - 5.3) : 0.1505859 * (this.HbA1C_range - 5.3);
                var totalHearFailureMenValueHBA1C = -3.961954 + 0.911787 * ((ageValue - 55) / 10) - 0.6568071 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3524645 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.5849752 + currentSmokerValidation * 0.5014014 - 0.0512352 * ((Math.min(bmiValue, 30) - 25) / 5) + 0.365294 * ((Math.max(bmiValue, 30) - 30) / 5) + 0.6892219 * ((Math.min(egfrValue, 60) - 60) / -15) + 0.0292377 * ((Math.max(egfrValue, 60) - 90) / -15) + htmlmedsValueValidation * 0.3038296 - htmlmedsValueValidation * 0.0515032 * (Math.max(sbpValue, 110) - 130) / 20 - 0.1262343 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20) - diabestValidation * 0.2449514 * (ageValue - 55) / 10 - currentSmokerValidation * 0.1392217 * (ageValue - 55) / 10 + 0.0009592 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5) - 0.1917105 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15) + tenYeraHearFailureHBA1C;
                //start SDI heart Failure men
                var updateSIDHearFailureTenValue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDHearFailureTenValue = 0.1235632;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDHearFailureTenValue = 0.3592212;
                }
                var HeartFailureSDIValueMissing = this.SDIMissing == 1 ? 0.17924 : 0;
                var totalHearFailureMenValueSDI = -4.058977 + 0.894179 * ((ageValue - 55) / 10) - 0.7067398 * (Math.min(sbpValue, 110) - 110) / 20 + 0.350241 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.9252453 + currentSmokerValidation * 0.4364765 - 0.0866297 * ((Math.min(bmiValue, 30) - 25) / 5) + 0.3706765 * ((Math.max(bmiValue, 30) - 30) / 5) + 0.6696768 * ((Math.min(egfrValue, 60) - 60) / -15) + 0.0237374 * ((Math.max(egfrValue, 60) - 90) / -15) + htmlmedsValueValidation * 0.2688352 - htmlmedsValueValidation * 0.0434892 * (Math.max(sbpValue, 110) - 130) / 20 - 0.1297155 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20) - diabestValidation * 0.299086 * (ageValue - 55) / 10 - currentSmokerValidation * 0.1079522 * (ageValue - 55) / 10 + 0.0130483 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5) - 0.1797791 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15) + updateSIDHearFailureTenValue + HeartFailureSDIValueMissing;
                //start Total heart Failure men
                var updateSIDHearFailureTenTotalValue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDHearFailureTenTotalValue = 0.1106372;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDHearFailureTenTotalValue = 0.3371204;
                }
                var updateDiabeitesHeartFailureTenTotalValue = 0;
                if (this.HbA1C_range !== '') {
                    updateDiabeitesHeartFailureTenTotalValue = diabestValidation == 1 ? 0.148297 * (this.HbA1C_range - 5.3) : 0.1234088 * (this.HbA1C_range - 5.3);
                }
                var TwentyYearsWoemnHeartFailureSDIDecileMissing = this.SDIMissing == 1 || this.SID_range == "" ? 0.1694628 : 0;
                var TwentyYearsWomenHeartFailureUACRMissing = this.uacr_range == "" ? 0.1702805 : 0.2164607 * Math.log(this.uacr_range);
                var TwentyYearsWomenHeartFailureHBA1CMissing = this.HbA1C_range == "" ? 0.0234637 : 0;
                var totalHearFailureMenValueTotal = -4.663513 + 0.9095703 * ((ageValue - 55) / 10) - 0.6765184 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3111651 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.5535052 + currentSmokerValidation * 0.4326811 - 0.0854286 * ((Math.min(bmiValue, 30) - 25) / 5) + 0.3551736 * ((Math.max(bmiValue, 30) - 30) / 5) + 0.5102245 * ((Math.min(egfrValue, 60) - 60) / -15) + 0.015472 * ((Math.max(egfrValue, 60) - 90) / -15) + htmlmedsValueValidation * 0.2570964 - htmlmedsValueValidation * 0.0591177 * (Math.max(sbpValue, 110) - 130) / 20 - 0.1219056 * ((ageValue - 55) / 10) * ((Math.max(sbpValue, 110) - 130) / 20) - diabestValidation * 0.2437577 * (ageValue - 55) / 10 - currentSmokerValidation * 0.105363 * (ageValue - 55) / 10 + 0.0037907 * ((ageValue - 55) / 10) * ((Math.max(bmiValue, 30) - 30) / 5) - 0.1660207 * ((ageValue - 55) / 10) * ((Math.min(egfrValue, 60) - 60) / -15) + updateSIDHearFailureTenTotalValue
                //+ 0.2164607  * Math.log(this.uacr_range)
                + updateDiabeitesHeartFailureTenTotalValue + TwentyYearsWoemnHeartFailureSDIDecileMissing + TwentyYearsWomenHeartFailureUACRMissing - TwentyYearsWomenHeartFailureHBA1CMissing;
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValue) / (1 + Math.exp(totalHearFailureMenValue)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValueUACR) / (1 + Math.exp(totalHearFailureMenValueUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValueHBA1C) / (1 + Math.exp(totalHearFailureMenValueHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValueSDI) / (1 + Math.exp(totalHearFailureMenValueSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalHearFailureMenVlaue = (Math.exp(totalHearFailureMenValueTotal) / (1 + Math.exp(totalHearFailureMenValueTotal)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
                //End heart Failure men
                //start ASCVD Men section
                var totalAscvdMenValueBase = -3.500655 + 0.7099847 * (ageValue - 55) / 10 + 0.1658663 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1144285 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.2837212 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3239977 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.7189597 + currentSmokerValidation * 0.3956973 + 0.3690075 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0203619 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.2036522 - cholesteronTreatedValidation * 0.0865581 - htmlmedsValueValidation * 0.0322916 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.114563 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0300005 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0232747 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0927024 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.2018525 * (ageValue - 55) / 10 - currentSmokerValidation * 0.0970527 * (ageValue - 55) / 10 - 0.1217081 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15;
                //start UACR ASCVD Men section
                var totalAscvdMenValueUACR = -3.85146 + 0.7141718 * (ageValue - 55) / 10 + 0.1602194 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1139086 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.2719456 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3058719 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.6600631 + currentSmokerValidation * 0.3884022 + 0.2466316 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0151852 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.186167 - cholesteronTreatedValidation * 0.0894395 - htmlmedsValueValidation * 0.0411884 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.1058212 * (_totalValuestchdl * 0.02586 - 3.5) - 0.028089 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0240427 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0912325 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.2004894 * (ageValue - 55) / 10 - currentSmokerValidation * 0.096936 * (ageValue - 55) / 10 - 0.1022867 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + 0.1510073 * Math.log(this.uacr_range);
                //start HBA1C ASCVD Men section
                var hba1cTenYearsASCVD = diabetesValue === 1 ? 0.1157161 * (this.HbA1C_range - 5.3) : 0.1288303 * (this.HbA1C_range - 5.3);
                var totalAscvdMenValueHBA1C = -3.51835 + 0.7064146 * (ageValue - 55) / 10 + 0.1532267 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1082166 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.2675288 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3173809 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.432604 + currentSmokerValidation * 0.3958842 + 0.3665014 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0250243 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.2061158 - cholesteronTreatedValidation * 0.0899988 - htmlmedsValueValidation * 0.0334959 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.1034168 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0255406 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0247538 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0917441 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.1499195 * (ageValue - 55) / 10 - currentSmokerValidation * 0.098089 * (ageValue - 55) / 10 - 0.1305231 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + hba1cTenYearsASCVD;
                //start SDI ASCVD Men section
                var updateSIDASCVDTenTotalValue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDASCVDTenTotalValue = 0.0728242;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDASCVDTenTotalValue = 0.2824453;
                }
                var ASCVDTenYearsSDIMissing = this.SDIMissing == 1 ? 0.1437348 : 0;
                var totalAscvdMenValueSDI = -3.624712 + 0.7150087 * (ageValue - 55) / 10 + 0.1627339 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1194988 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.363659 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3179476 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.7156422 + currentSmokerValidation * 0.3404477 + 0.3545754 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0157875 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.1786233 - cholesteronTreatedValidation * 0.1018269 - htmlmedsValueValidation * 0.028313 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.1209467 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0285806 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0247348 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0919494 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.1981491 * (ageValue - 55) / 10 - currentSmokerValidation * 0.0776891 * (ageValue - 55) / 10 - 0.1284899 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + updateSIDASCVDTenTotalValue + ASCVDTenYearsSDIMissing;
                //start Total ASCVD Men section
                var updateSIDASCVDTenTotalValues = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDASCVDTenTotalValues = 0.0651121;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDASCVDTenTotalValues = 0.2676683;
                }
                var totalASCVDDiabetes = 0;
                if (this.HbA1C_range !== "") {
                    totalASCVDDiabetes = diabestValidation == 1 ? 0.101282 * (this.HbA1C_range - 5.3) : 0.1092726 * (this.HbA1C_range - 5.3);
                }
                var TwentyYearsWoemnASCVDSDIDecileMissing = this.SDIMissing == 1 || this.SID_range == "" ? 0.1388492 : 0;
                var TwentyYearsWomenASCVDUACRMissing = this.uacr_range == "" ? 0.0652944 : 0.1375837 * Math.log(this.uacr_range);
                var TwentyYearsWomenASCVDHBA1CMissing = this.HbA1C_range == "" ? 0.0112852 : 0;
                var totalAscvdMenValueTotal = -3.969788 + 0.7128741 * (ageValue - 55) / 10 + 0.1465201 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1125794 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.3387216 * (Math.min(sbpValue, 110) - 110) / 20 + 0.2980252 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.399583 + currentSmokerValidation * 0.3379111 + 0.2582604 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0147769 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.1686621 - cholesteronTreatedValidation * 0.1073619 - htmlmedsValueValidation * 0.0381038 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.1034169 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0228755 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0267453 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.0897449 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.1497464 * (ageValue - 55) / 10 - currentSmokerValidation * 0.077206 * (ageValue - 55) / 10 - 0.1198368 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + updateSIDASCVDTenTotalValues + totalASCVDDiabetes + TwentyYearsWoemnASCVDSDIDecileMissing + TwentyYearsWomenASCVDUACRMissing - TwentyYearsWomenASCVDHBA1CMissing;
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueBase) / (1 + Math.exp(totalAscvdMenValueBase)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueUACR) / (1 + Math.exp(totalAscvdMenValueUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueHBA1C) / (1 + Math.exp(totalAscvdMenValueHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueSDI) / (1 + Math.exp(totalAscvdMenValueSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalAscdMenValue = (Math.exp(totalAscvdMenValueTotal) / (1 + Math.exp(totalAscvdMenValueTotal)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
                //end ASCVD Men section
                //start CVD Men section
                var totalCVDMenBase = -3.031168 + 0.7688528 * (ageValue - 55) / 10 + 0.0736174 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0954431 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.4347345 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3362658 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.7692857 + currentSmokerValidation * 0.4386871 + 0.5378979 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0164827 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.288879 - cholesteronTreatedValidation * 0.1337349 - htmlmedsValueValidation * 0.0475924 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.150273 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0517874 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0191169 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.1049477 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.2251948 * (ageValue - 55) / 10 - currentSmokerValidation * 0.0895067 * (ageValue - 55) / 10 - 0.1543702 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15;
                //start UACR CVD Men section
                var totalCVDMenUACR = -3.510705 + 0.7768655 * ((ageValue - 55) / 10) + 0.0659949 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0951111 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.420667 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3120151 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.698521 + currentSmokerValidation * 0.4314669 + 0.3841364 * (Math.min(egfrValue, 60) - 60) / -15 + 0.009384 * (Math.max(egfrValue, 60) - 90) / -15 + 0.2676494 * htmlmedsValueValidation - 0.1390966 * cholesteronTreatedValidation - 0.0579315 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 + 0.1383719 * cholesteronTreatedValidation * (_totalValuestchdl * 0.02586 - 3.5) - 0.0488332 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0200406 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.102454 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.2236355 * diabestValidation * (ageValue - 55) / 10 - 0.089485 * currentSmokerValidation * (ageValue - 55) / 10 - 0.1321848 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + 0.1887974 * Math.log(this.uacr_range);
                //10 year total CVD HBA1C
                var diabetesValueCVD10yearsHBA1C = diabestValidation === 1 ? 0.13159 * (this.HbA1C_range - 5.3) : 0.1295185 * (this.HbA1C_range - 5.3);
                var totalCVDMenHBA1C = -3.040901 + 0.7699177 * ((ageValue - 55) / 10) + 0.0605093 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0888525 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.417713 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3288657 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.4759471 + currentSmokerValidation * 0.4385663 + 0.5334616 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0206431 * (Math.max(egfrValue, 60) - 90) / -15 + 0.2917524 * htmlmedsValueValidation - 0.1383313 * cholesteronTreatedValidation - 0.0482622 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 + 0.1393796 * cholesteronTreatedValidation * (_totalValuestchdl * 0.02586 - 3.5) - 0.0463501 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0205926 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.1037717 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.1737697 * diabestValidation * (ageValue - 55) / 10 - 0.0915839 * currentSmokerValidation * (ageValue - 55) / 10 - 0.1637039 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + diabetesValueCVD10yearsHBA1C;
                //10 year total CVD SDI
                var updateSIDCVDTenTotalValue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDCVDTenTotalValue = 0.0889119;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDCVDTenTotalValue = 0.291897;
                }
                var menCVDSDITenYearsMissing = this.SDIMissing == 1 ? 0.1508151 : 0;
                var totalCVDMenSDI = -3.159572 + 0.7756377 * ((ageValue - 55) / 10) + 0.0715325 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0976775 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.5186614 * (Math.min(sbpValue, 110) - 110) / 20 + 0.3235653 * (Math.max(sbpValue, 110) - 130) / 20 + diabestValidation * 0.7722496 + currentSmokerValidation * 0.3761129 + 0.5180893 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0118451 * (Math.max(egfrValue, 60) - 90) / -15 + htmlmedsValueValidation * 0.2634094 - cholesteronTreatedValidation * 0.1455263 - htmlmedsValueValidation * 0.0367013 * (Math.max(sbpValue, 110) - 130) / 20 + cholesteronTreatedValidation * 0.1617785 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0507669 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0178356 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.1059337 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - diabestValidation * 0.2236755 * (ageValue - 55) / 10 - currentSmokerValidation * 0.0723216 * (ageValue - 55) / 10 - 0.1548205 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + updateSIDCVDTenTotalValue + menCVDSDITenYearsMissing;
                //10 year total CVD total
                var tenYearSDIFullvalue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    tenYearSDIFullvalue = 0.0802431;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    tenYearSDIFullvalue = 0.275073;
                }
                var tenYearCVDFulldiabestValidation = 0;
                if (this.HbA1C_range !== '') {
                    tenYearCVDFulldiabestValidation = diabestValidation == 1 ? 0.1165698 * (this.HbA1C_range - 5.3) : 0.1048297 * (this.HbA1C_range - 5.3);
                }
                var TwentyYearsWoemnCVDSDIDecileMissing = this.SDIMissing == 1 || this.SID_range === "" ? 0.144759 : 0;
                var TwentyYearsWomenCVDUACRMissing = this.uacr_range == "" ? 0.1095674 : 0.1772853 * Math.log(this.uacr_range);
                var TwentyYearsWomenCVDHBA1CMissing = this.HbA1C_range == "" ? 0.0230072 : 0;
                var totalCVDMenTotal = -3.631387 + 0.7847578 * ((ageValue - 55) / 10) + 0.0534485 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0911282 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.4921973 * (Math.min(sbpValue, 110) - 110) / 20 + 0.2972415 * (Math.max(sbpValue, 110) - 130) / 20 + 0.4527054 * diabestValidation + 0.3726641 * currentSmokerValidation + 0.3886854 * (Math.min(egfrValue, 60) - 60) / -15 + 0.0081661 * (Math.max(egfrValue, 60) - 90) / -15 + 0.2508052 * htmlmedsValueValidation - 0.1538484 * cholesteronTreatedValidation - 0.0474695 * htmlmedsValueValidation * (Math.max(sbpValue, 110) - 130) / 20 + 0.1415382 * cholesteronTreatedValidation * (_totalValuestchdl * 0.02586 - 3.5) - 0.0436455 * (ageValue - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0199549 * (ageValue - 55) / 10 * (hdlCholesteronValue * 0.02586 - 1.3) / 0.3 - 0.1022686 * (ageValue - 55) / 10 * (Math.max(sbpValue, 110) - 130) / 20 - 0.1762507 * diabestValidation * (ageValue - 55) / 10 - 0.0715873 * currentSmokerValidation * (ageValue - 55) / 10 - 0.1428668 * (ageValue - 55) / 10 * (Math.min(egfrValue, 60) - 60) / -15 + tenYearSDIFullvalue + tenYearCVDFulldiabestValidation + TwentyYearsWoemnCVDSDIDecileMissing + TwentyYearsWomenCVDUACRMissing - TwentyYearsWomenCVDHBA1CMissing;
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenBase) / (1 + Math.exp(totalCVDMenBase)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenUACR) / (1 + Math.exp(totalCVDMenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenHBA1C) / (1 + Math.exp(totalCVDMenHBA1C)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenSDI) / (1 + Math.exp(totalCVDMenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalCVDMenValue = (Math.exp(totalCVDMenTotal) / (1 + Math.exp(totalCVDMenTotal)) * 100).toFixed(1);

                    this.ModelName = "full model";
                }
                //end CVD Men section
                //30 years start from here
                var _firstThirtyHFWomenDiabetes = diabetesValue === 1 ? 0.6840338 : 0;
                var _firstThrityHFWomenCurrentSmoker = currentSmoker === 1 ? 0.2656273 : 0;
                var _firstThrityHFWomenHDN = hdn === 1 ? 0.2583631 : 0;
                var _secondThrityHFWomenHDN = hdn === 1 ? 0.0391938 * (Math.max(sbp, 110) - 130) / 20 : 0;
                var _secondThirtyHFNWomenDiabetes = diabetesValue === 1 ? 0.3273572 * (age - 55) / 10 : 0;
                var _secondThirtyHFNWomenCurrentSmoker = currentSmoker === 1 ? 0.2043019 * (age - 55) / 10 : 0;
                var totalThirtyHearFailureMenValue = -1.95751 + 0.5681541 * (age - 55) / 10 - 0.1048388 * _carotSymbol - 0.4761564 * (Math.min(sbp, 110) - 110) / 20 + 0.30324 * (Math.max(sbp, 110) - 130) / 20 + _firstThirtyHFWomenDiabetes + _firstThrityHFWomenCurrentSmoker + 0.0833107 * (Math.min(bmi, 30) - 25) / 5 + 0.26999 * (Math.max(bmi, 30) - 30) / 5 + 0.2541805 * (Math.min(egfr, 60) - 60) / -15 + 0.0638923 * (Math.max(egfr, 60) - 90) / -15 + _firstThrityHFWomenHDN - _secondThrityHFWomenHDN - 0.1269124 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - _secondThirtyHFNWomenDiabetes - _secondThirtyHFNWomenCurrentSmoker - 0.0182831 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.1342618 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15;
                //Thirty years UACR heart failure men
                var totalThirtyHearFailureMenUACR = -2.314872 + 0.5750236 * (age - 55) / 10 - 0.1062268 * _carotSymbol - 0.4633994 * (Math.min(sbp, 110) - 110) / 20 + 0.2742874 * (Math.max(sbp, 110) - 130) / 20 + 0.612208 * diabestValidation + 0.2614987 * currentSmokerValidation + 0.0895459 * (Math.min(bmi, 30) - 25) / 5 + 0.2632424 * (Math.max(bmi, 30) - 30) / 5 + 0.1430472 * (Math.min(egfr, 60) - 60) / -15 + 0.0535184 * (Math.max(egfr, 60) - 90) / -15 + 0.2417468 * htmlmedsValueValidation - 0.0498574 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation - 0.1193827 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.316651 * (age - 55) / 10 * diabestValidation - 0.2046122 * (age - 55) / 10 * currentSmokerValidation - 0.0216878 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.1165637 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + 0.1366452 * Math.log(this.uacr_range);
                //30 years HBA1C heart Failure
                var herartFailurethirtyYearDiabeites = diabestValidation == 1 ? 0.1101184 * (this.HbA1C_range - 5.3) : 0.0949198 * (this.HbA1C_range - 5.3);
                var totalThirtyHearFailureMenHbA1c = -1.974999 + 0.5703729 * (age - 55) / 10 - 0.1084544 * _carotSymbol - 0.4471767 * (Math.min(sbp, 110) - 110) / 20 + 0.2910152 * (Math.max(sbp, 110) - 130) / 20 + 0.4507242 * diabestValidation + 0.259585 * currentSmokerValidation + 0.0850676 * (Math.min(bmi, 30) - 25) / 5 + 0.2637222 * (Math.max(bmi, 30) - 30) / 5 + 0.2454706 * (Math.min(egfr, 60) - 60) / -15 + 0.0675649 * (Math.max(egfr, 60) - 90) / -15 + 0.2611991 * htmlmedsValueValidation - 0.0408908 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation - 0.1241051 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2849461 * (age - 55) / 10 * diabestValidation - 0.2032308 * (age - 55) / 10 * currentSmokerValidation - 0.0239714 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.138301 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + herartFailurethirtyYearDiabeites;
                //30 years thirty heart failure SDI
                var thrityYearsHeartFailureSDIMen = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thrityYearsHeartFailureSDIMen = 0.0680528;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thrityYearsHeartFailureSDIMen = 0.2619865;
                }
                var ThrityYearHeartFailureSDIMissing = this.SDIMissing == 1 ? 0.1151424 : 0;
                var totalThirtyHearFailureMenSDI = -2.060187 + 0.5387527 * (age - 55) / 10 - 0.1090333 * _carotSymbol - 0.4829094 * (Math.min(sbp, 110) - 110) / 20 + 0.2843569 * (Math.max(sbp, 110) - 130) / 20 + 0.6827667 * diabestValidation + 0.2406677 * currentSmokerValidation + 0.0618028 * (Math.min(bmi, 30) - 25) / 5 + 0.2705615 * (Math.max(bmi, 30) - 30) / 5 + 0.2255837 * (Math.min(egfr, 60) - 60) / -15 + 0.0653632 * (Math.max(egfr, 60) - 90) / -15 + 0.2263243 * htmlmedsValueValidation - 0.0316851 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation - 0.1258716 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.3243709 * (age - 55) / 10 * diabestValidation - 0.1596172 * (age - 55) / 10 * currentSmokerValidation - 0.0103092 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.1204785 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + thrityYearsHeartFailureSDIMen + ThrityYearHeartFailureSDIMissing;
                //Heart filure full
                var thrityYearsHeartFailureFullSDIMen = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thrityYearsHeartFailureFullSDIMen = 0.057746;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thrityYearsHeartFailureFullSDIMen = 0.2446441;
                }
                var diabetesThirtyYerasHeartFailureFull = 0;
                if (this.HbA1C_range !== '') {
                    diabetesThirtyYerasHeartFailureFull = diabestValidation == 1 ? 0.0985062 * (this.HbA1C_range - 5.3) : 0.0804844 * (this.HbA1C_range - 5.3);
                }
                var thrityYearsmensHeartFailureValuesMissingSDI = this.SDIMissing == 1 || this.SID_range == "" ? 0.1076782 : 0;
                var thrityYearsmensHeartFailureValuesMissingUACR = this.uacr_range == "" ? 0.1274796 : 0.1233486 * Math.log(this.uacr_range);
                var thrityYearsmensHeartFailureValuesMissingHBAC1 = this.HbA1C_range == "" ? 0.0022806 : 0;
                var totalThirtyHearFailureMenFull = -2.425439 + 0.5478829 * (age - 55) / 10 - 0.1111928 * _carotSymbol - 0.4547346 * (Math.min(sbp, 110) - 110) / 20 + 0.2527602 * (Math.max(sbp, 110) - 130) / 20 + 0.4385384 * diabestValidation + 0.2397952 * currentSmokerValidation + 0.0640931 * (Math.min(bmi, 30) - 25) / 5 + 0.2643081 * (Math.max(bmi, 30) - 30) / 5 + 0.1354588 * (Math.min(egfr, 60) - 60) / -15 + 0.0570689 * (Math.max(egfr, 60) - 90) / -15 + 0.220666 * htmlmedsValueValidation - 0.0436769 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation - 0.1168376 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2730055 * (age - 55) / 10 * diabestValidation - 0.1573691 * (age - 55) / 10 * currentSmokerValidation - 0.0174998 * (age - 55) / 10 * (Math.max(bmi, 30) - 30) / 5 - 0.1128676 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + thrityYearsHeartFailureFullSDIMen
                //+ 0.1233486 * Math.log(this.uacr_range) 
                + diabetesThirtyYerasHeartFailureFull + thrityYearsmensHeartFailureValuesMissingSDI + thrityYearsmensHeartFailureValuesMissingUACR + thrityYearsmensHeartFailureValuesMissingHBAC1;
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenValue) / (1 + Math.exp(totalThirtyHearFailureMenValue)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenUACR) / (1 + Math.exp(totalThirtyHearFailureMenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenHbA1c) / (1 + Math.exp(totalThirtyHearFailureMenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenSDI) / (1 + Math.exp(totalThirtyHearFailureMenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalThirtyHearFailureMenValue = (Math.exp(totalThirtyHearFailureMenFull) / (1 + Math.exp(totalThirtyHearFailureMenFull)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
                //30 years end men heart failure
                //30 years ASCVD men start here
                var _firstThirtyASCVDWomenDiabetes = diabetes === 1 ? 0.4790257 : 0;
                var _firstThrityASCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1782635 : 0;
                var _firstThrityASCVDWomenHDN = hdn === 1 ? 0.1421182 : 0;
                var _firstThrityASCVDWomenStatin = statin === 1 ? 0.0135996 : 0;
                var _secondThrityASCVDWomenHDN = hdn === 1 ? 0.0218265 * (Math.max(sbp, 110) - 130) / 20 : 0;
                var _secondThrityASCVDDWomenStatin = statin === 1 ? 0.1013148 * (_totalValuestchdl * 0.02586 - 3.5) : 0;
                var _secondThirtyASCVDNWomenDiabetes = diabetes === 1 ? 0.2159947 * (age - 55) / 10 : 0;
                var _secondthrityASCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1548811 * (age - 55) / 10 : 0;
                var totalThirtyAscvdMenValue = -1.736444 + 0.3994099 * (age - 55) / 10 - 0.0937484 * _carotSymbol + 0.1744643 * (_totalValuestchdl * 0.02586 - 3.5) - 0.120203 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0665117 * (Math.min(sbp, 110) - 110) / 20 + 0.2753037 * (Math.max(sbp, 110) - 130) / 20 + _firstThirtyASCVDWomenDiabetes + _firstThrityASCVDWomenCurrentSmoker - 0.0218789 * (Math.min(egfr, 60) - 60) / -15 + 0.0602553 * (Math.max(egfr, 60) - 90) / -15 + _firstThrityASCVDWomenHDN + _firstThrityASCVDWomenStatin - _secondThrityASCVDWomenHDN + _secondThrityASCVDDWomenStatin - 0.0312619 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.020673 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0920935 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - _secondThirtyASCVDNWomenDiabetes - _secondthrityASCVDWomenCurrentSmoker - 0.0712547 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15;
                //total thrity year UACR
                var totalThirtyYearAscvdMenUACR = -1.873449 + 0.3995607 * (age - 55) / 10 - 0.094557 * _carotSymbol + 0.1686692 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1202145 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0555561 * (Math.min(sbp, 110) - 110) / 20 + 0.2633566 * (Math.max(sbp, 110) - 130) / 20 + 0.4362036 * diabestValidation + 0.1716233 * currentSmokerValidation - 0.0775282 * (Math.min(egfr, 60) - 60) / -15 + 0.0561236 * (Math.max(egfr, 60) - 90) / -15 + 0.1319331 * htmlmedsValueValidation + 0.0102428 * cholesteronTreatedValidation - 0.0269294 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.0920557 * (_totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0297021 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0217935 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0893347 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2081467 * (age - 55) / 10 * diabestValidation - 0.1542716 * (age - 55) / 10 * currentSmokerValidation - 0.0597254 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + 0.0684872 * Math.log(this.uacr_range);
                //ACVD thriy year hba1c
                var thirtyHBACDDiabetes = diabestValidation == 1 ? 0.0591089 * (this.HbA1C_range - 5.3) : 0.0821158 * (this.HbA1C_range - 5.3);
                var totalThirtyYearAscvdMenHbA1c = -1.777708 + 0.3883267 * (age - 55) / 10 - 0.0958114 * _carotSymbol + 0.1613374 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1144418 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0474338 * (Math.min(sbp, 110) - 110) / 20 + 0.2691281 * (Math.max(sbp, 110) - 130) / 20 + 0.2859773 * diabestValidation + 0.1759553 * currentSmokerValidation - 0.0242898 * (Math.min(egfr, 60) - 60) / -15 + 0.0644523 * (Math.max(egfr, 60) - 90) / -15 + 0.142874 * htmlmedsValueValidation + 0.0115062 * cholesteronTreatedValidation - 0.02333 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.0899664 * (_totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0275478 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.022573 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.090802 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.1771894 * (age - 55) / 10 * diabestValidation - 0.1548847 * (age - 55) / 10 * currentSmokerValidation - 0.0732754 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + thirtyHBACDDiabetes;
                //Thirty year men SDI
                var thirtyYearMenASCVDSDI = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thirtyYearMenASCVDSDI = 0.0199201;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thirtyYearMenASCVDSDI = 0.194949;
                }
                var thirtyYearASCVDMenSDIMissing = this.SDIMissing == 1 ? 0.0863835 : 0;
                var totalThirtyYearAscvdMenSDI = -1.836632 + 0.3749788 * (age - 55) / 10 - 0.0990063 * _carotSymbol + 0.1708505 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1272841 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1275555 * (Math.min(sbp, 110) - 110) / 20 + 0.2659339 * (Math.max(sbp, 110) - 130) / 20 + 0.4676531 * diabestValidation + 0.1610104 * currentSmokerValidation - 0.0465144 * (Math.min(egfr, 60) - 60) / -15 + 0.0596996 * (Math.max(egfr, 60) - 90) / -15 + 0.1147096 * htmlmedsValueValidation + 0.0052906 * cholesteronTreatedValidation - 0.0186687 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.1063151 * (_totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0307797 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0218126 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0898242 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.210054 * (age - 55) / 10 * diabestValidation - 0.1246327 * (age - 55) / 10 * currentSmokerValidation - 0.0629358 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + thirtyYearMenASCVDSDI + thirtyYearASCVDMenSDIMissing;
                //thity year ASCVD men full
                var updateSIDHearFailureTenTotalValueFull = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    updateSIDHearFailureTenTotalValueFull = 0.015675;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    updateSIDHearFailureTenTotalValueFull = 0.1864231;
                }
                var diabestValidationFullASCVD = 0;
                if (this.HbA1C_range !== "") {
                    diabestValidationFullASCVD = diabestValidation == 1 ? 0.0501422 * (this.HbA1C_range - 5.3) : 0.0722905 * (this.HbA1C_range - 5.3);
                }
                var thrityYearsMensASCVDValueMissingSDI = this.SDIMissing == 1 || this.SID_range == "" ? 0.0845697 : 0;
                var thrityYearsMensASCVDValueMissingUACR = this.uacr_range == "" ? 0.0252244 : 0.0560171 * Math.log(this.uacr_range);
                var thrityYearsMensASCVDValueMissingHBAC1 = this.HbA1C_range == "" ? 0.0114945 : 0;
                var totalThirtyYearAscvdMenFull = -1.985368 + 0.3743566 * (age - 55) / 10 - 0.0995499 * _carotSymbol + 0.1544808 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1215297 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1083968 * (Math.min(sbp, 110) - 110) / 20 + 0.2555179 * (Math.max(sbp, 110) - 130) / 20 + 0.2696998 * diabestValidation + 0.1628432 * currentSmokerValidation - 0.077507 * (Math.min(egfr, 60) - 60) / -15 + 0.0583407 * (Math.max(egfr, 60) - 90) / -15 + 0.1120322 * htmlmedsValueValidation - 0.0025063 * cholesteronTreatedValidation - 0.0256116 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.0886745 * (_totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0254507 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0244639 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.0869146 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.165745 * (age - 55) / 10 * diabestValidation - 0.1244714 * (age - 55) / 10 * currentSmokerValidation - 0.0624552 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + updateSIDHearFailureTenTotalValueFull
                //+ 0.0560171 *  Math.log(this.uacr_range) 
                + diabestValidationFullASCVD + thrityYearsMensASCVDValueMissingSDI + thrityYearsMensASCVDValueMissingUACR + thrityYearsMensASCVDValueMissingHBAC1;
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyAscvdMenValue) / (1 + Math.exp(totalThirtyAscvdMenValue)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyYearAscvdMenUACR) / (1 + Math.exp(totalThirtyYearAscvdMenUACR)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyYearAscvdMenHbA1c) / (1 + Math.exp(totalThirtyYearAscvdMenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyYearAscvdMenSDI) / (1 + Math.exp(totalThirtyYearAscvdMenSDI)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.totalThirtyAscvdMenValue = (Math.exp(totalThirtyYearAscvdMenFull) / (1 + Math.exp(totalThirtyYearAscvdMenFull)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
                //30 years ASCVD stop here
                //30 years CVD Mens start here
                var _firstThirtyCVDWomenDiabetes = diabetes === 1 ? 0.5331276 : 0;
                var _firstThrityCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.2141914 : 0;
                var _firstThrityCVDWomenHDN = hdn === 1 ? 0.232714 : 0;
                var _firstThrityCVDWomenStatin = statin === 1 ? 0.0272112 : 0;
                var _secondThrityCVDWomenHDN = hdn === 1 ? 0.0384488 * (Math.max(sbp, 110) - 130) / 20 : 0;
                var _secondThrityCVDWomenStatin = statin === 1 ? 0.134192 * (_totalValuestchdl * 0.02586 - 3.5) : 0;
                var _secondThirtyCVDNWomenDiabetes = diabetes === 1 ? 0.2585943 * (age - 55) / 10 : 0;
                var _secondthrityCVDWomenCurrentSmoker = currentSmoker === 1 ? 0.1566406 * (age - 55) / 10 : 0;
                var thrityYearsCVDMen = -1.148204 + 0.4627309 * (age - 55) / 10 - 0.0984281 * _carotSymbol + 0.0836088 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1029824 * (hdl * 0.02586 - 1.3) / 0.3 - 0.2140352 * (Math.min(sbp, 110) - 110) / 20 + 0.2904325 * (Math.max(sbp, 110) - 130) / 20 + _firstThirtyCVDWomenDiabetes + _firstThrityCVDWomenCurrentSmoker + 0.1155556 * (Math.min(egfr, 60) - 60) / -15 + 0.0603775 * (Math.max(egfr, 60) - 90) / -15 + _firstThrityCVDWomenHDN - _firstThrityCVDWomenStatin - _secondThrityCVDWomenHDN + _secondThrityCVDWomenStatin - 0.0511759 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0165865 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1101437 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - _secondThirtyCVDNWomenDiabetes - _secondthrityCVDWomenCurrentSmoker - 0.1166776 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15;
                //thirty years CVD men UACR
                var thrityYearsCVDMenUacr = -1.398727 + 0.464491 * (age - 55) / 10 - 0.0998895 * _carotSymbol + 0.0757606 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1031778 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1990714 * (Math.min(sbp, 110) - 110) / 20 + 0.2715816 * (Math.max(sbp, 110) - 130) / 20 + 0.4754637 * diabestValidation + 0.2069672 * currentSmokerValidation + 0.0331103 * (Math.min(egfr, 60) - 60) / -15 + 0.0540474 * (Math.max(egfr, 60) - 90) / -15 + 0.2189911 * htmlmedsValueValidation - 0.0331044 * cholesteronTreatedValidation - 0.04534 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.1214535 * (_totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0483995 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0178997 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1059324 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2492861 * (age - 55) / 10 * diabestValidation - 0.1561543 * (age - 55) / 10 * currentSmokerValidation - 0.1012429 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + 0.1007571 * Math.log(this.uacr_range);
                //30 years CVD HBA1C Men
                var diabestValidationThrityYearsCVDMen = diabestValidation == 1 ? 0.0768169 * (this.HbA1C_range - 5.3) : 0.0777295 * (this.HbA1C_range - 5.3);
                var thrityYearsCVDMenHbA1c = -1.180767 + 0.4519873 * (age - 55) / 10 - 0.101624 * _carotSymbol + 0.0700456 * (_totalValuestchdl * 0.02586 - 3.5) - 0.0968005 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1923527 * (Math.min(sbp, 110) - 110) / 20 + 0.2827043 * (Math.max(sbp, 110) - 130) / 20 + 0.3417152 * diabestValidation + 0.2105272 * currentSmokerValidation + 0.1113291 * (Math.min(egfr, 60) - 60) / -15 + 0.0640135 * (Math.max(egfr, 60) - 90) / -15 + 0.2334248 * htmlmedsValueValidation - 0.0299421 * cholesteronTreatedValidation - 0.0393204 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.1228854 * (_totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0463737 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0184599 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1085744 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2208049 * (age - 55) / 10 * diabestValidation - 0.1577978 * (age - 55) / 10 * currentSmokerValidation - 0.1179375 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + diabestValidationThrityYearsCVDMen;
                //Thirty year CVD SDP Men
                var thrityYearCVDMENSDIValue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thrityYearCVDMENSDIValue = 0.0314626;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thrityYearCVDMENSDIValue = 0.2003953;
                }
                var thrityYearCVDMenSDIMissing = this.SDIMissing == 1 ? 0.0927451 : 0;
                var thrityYearsCVDMenSDP = -1.251031 + 0.437377 * (age - 55) / 10 - 0.104443 * _carotSymbol + 0.0812573 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1069199 * (hdl * 0.02586 - 1.3) / 0.3 - 0.2786727 * (Math.min(sbp, 110) - 110) / 20 + 0.2729256 * (Math.max(sbp, 110) - 130) / 20 + 0.5279006 * diabestValidation + 0.1878949 * currentSmokerValidation + 0.0866569 * (Math.min(egfr, 60) - 60) / -15 + 0.0594948 * (Math.max(egfr, 60) - 90) / -15 + 0.2028246 * htmlmedsValueValidation - 0.0308404 * cholesteronTreatedValidation - 0.0283679 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.1439353 * (_totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0510854 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0150236 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1095448 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2561109 * (age - 55) / 10 * diabestValidation - 0.1282945 * (age - 55) / 10 * currentSmokerValidation - 0.1011023 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + thrityYearCVDMENSDIValue + thrityYearCVDMenSDIMissing;
                //thrity year CVD Full
                var thirtyYearCVDSDIFullValue = 0;
                if (this.SDIAPIValue >= 4 && this.SDIAPIValue <= 6) {
                    thirtyYearCVDSDIFullValue = 0.0256704;
                } else if (this.SDIAPIValue >= 7 && this.SDIAPIValue <= 10) {
                    thirtyYearCVDSDIFullValue = 0.1887637;
                }
                var diabetiesThirtyFullCVDFullValue = 0;
                if (this.HbA1C_range !== '') {
                    diabetiesThirtyFullCVDFullValue = diabestValidation === 1 ? 0.0676202 * (this.HbA1C_range - 5.3) : 0.063409 * (this.HbA1C_range - 5.3);
                }
                var thrityYearsmensHeartFailureValueMissingSDI = this.SDIMissing == 1 || this.SID_range == "" ? 0.089241 : 0;
                var thrityYearsmensHeartFailureValueMissingUACR = this.uacr_range == "" ? 0.0710124 : 0.0894596 * Math.log(this.uacr_range);
                var thrityYearsmensHeartFailureValueMissingHBAC1 = this.HbA1C_range == "" ? 0.0038783 : 0;
                var thirtyYearCVDMenFull = -1.504558 + 0.4427595 * (age - 55) / 10 - 0.1064108 * _carotSymbol + 0.0629381 * (_totalValuestchdl * 0.02586 - 3.5) - 0.1015427 * (hdl * 0.02586 - 1.3) / 0.3 - 0.2542326 * (Math.min(sbp, 110) - 110) / 20 + 0.2549679 * (Math.max(sbp, 110) - 130) / 20 + 0.333835 * diabestValidation + 0.1873833 * currentSmokerValidation + 0.0246102 * (Math.min(egfr, 60) - 60) / -15 + 0.0552014 * (Math.max(egfr, 60) - 90) / -15 + 0.1979729 * htmlmedsValueValidation - 0.0407714 * cholesteronTreatedValidation - 0.0365522 * (Math.max(sbp, 110) - 130) / 20 * htmlmedsValueValidation + 0.1232822 * (_totalValuestchdl * 0.02586 - 3.5) * cholesteronTreatedValidation - 0.0441334 * (age - 55) / 10 * (_totalValuestchdl * 0.02586 - 3.5) + 0.0177865 * (age - 55) / 10 * (hdl * 0.02586 - 1.3) / 0.3 - 0.1046657 * (age - 55) / 10 * (Math.max(sbp, 110) - 130) / 20 - 0.2116113 * (age - 55) / 10 * diabestValidation - 0.1277905 * (age - 55) / 10 * currentSmokerValidation - 0.0955922 * (age - 55) / 10 * (Math.min(egfr, 60) - 60) / -15 + thirtyYearCVDSDIFullValue
                // + 0.0894596 * Math.log(this.uacr_range) 
                + diabetiesThirtyFullCVDFullValue + thrityYearsmensHeartFailureValueMissingSDI + thrityYearsmensHeartFailureValueMissingUACR + thrityYearsmensHeartFailureValueMissingHBAC1;
                if (this.uacr_range === '' && this.HbA1C_range === '' && this.SID_range === '' || this.SDIAPIValue === -1 && this.SID_range !== '' && this.uacr_range === '' && this.HbA1C_range === '') {
                    this.thrityYearsCVDMen = (Math.exp(thrityYearsCVDMen) / (1 + Math.exp(thrityYearsCVDMen)) * 100).toFixed(1);
                    this.ModelName = "base model";
                } else if (this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range === '' || this.uacr_range !== '' && this.HbA1C_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.thrityYearsCVDMen = (Math.exp(thrityYearsCVDMenUacr) / (1 + Math.exp(thrityYearsCVDMenUacr)) * 100).toFixed(1);
                    this.ModelName = "model that included UACR";
                } else if ((this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range) === '' || this.HbA1C_range !== '' && this.uacr_range === '' && this.SID_range !== '' && this.SDIMissing == 1) {
                    this.thrityYearsCVDMen = (Math.exp(thrityYearsCVDMenHbA1c) / (1 + Math.exp(thrityYearsCVDMenHbA1c)) * 100).toFixed(1);
                    this.ModelName = "model that included HbA1c";
                } else if (this.SID_range !== '' && this.HbA1C_range === '' && this.uacr_range === '' && this.SDIMissing == 0) {
                    this.thrityYearsCVDMen = (Math.exp(thrityYearsCVDMenSDP) / (1 + Math.exp(thrityYearsCVDMenSDP)) * 100).toFixed(1);
                    this.ModelName = "model that included SDI based on zip code";
                } else {
                    this.thrityYearsCVDMen = (Math.exp(thirtyYearCVDMenFull) / (1 + Math.exp(thirtyYearCVDMenFull)) * 100).toFixed(1);
                    this.ModelName = "full model";
                }
            }
        },
        validateIcon: function validateIcon() {
            this.ageIcon = !this.ageIcon;
        },
        validateAge: function validateAge(val) {
            if (val == 'info') {
                this.ageIcon = !this.ageIcon;
            } else {
                if (this.age_range.value === "") {
                    this.isAgeRequried = true;
                    this.ageValidation = false;
                } else {
                    this.isAgeRequried = false;
                }
                if (this.age_range.value && this.age_range.value < 30 || this.age_range.value > 79) {
                    this.ageValidation = true;
                } else {
                    this.ageValidation = false;
                }
            }
        },
        validateTotalCholesterol: function validateTotalCholesterol(val) {
            if (val == 'info') {
                this.totalCholesteronIcon = !this.totalCholesteronIcon;
            } else {
                if (this.totalCholesterol_range.value == "") {
                    this.istotalCholesterolRequired = true;
                    this.totalCholesterolRangeValidation = false;
                } else {
                    this.istotalCholesterolRequired = false;
                }
                if (this.totalCholesterol_range.value && this.totalCholesterol_range.value < 130 || this.totalCholesterol_range.value > 320) {

                    this.totalCholesterolRangeValidation = true;
                } else {
                    this.totalCholesterolRangeValidation = false;
                }
            }
        },
        hdlCholesteronValidation: function hdlCholesteronValidation(val) {
            if (val === 'info') {
                this.hdlCholesteronIcon = !this.hdlCholesteronIcon;
            } else {
                if (this.hdlCholesteron_range.value == "") {
                    this.ishdlCholesteronRequired = true;
                    this.hdlCholesteronValidate = false;
                } else {
                    this.ishdlCholesteronRequired = false;
                }
                if (this.hdlCholesteron_range.value && this.hdlCholesteron_range.value < 20 || this.hdlCholesteron_range.value > 100) {
                    this.hdlCholesteronValidate = true;
                } else {
                    this.hdlCholesteronValidate = false;
                }
            }
        },
        sbpValidation: function sbpValidation(val) {
            if (val == 'info') {
                this.sbpIcon = !this.sbpIcon;
            } else {
                if (this.sbp_range.value == "") {
                    this.isSbpRequired = true;
                    this.spbValidate = false;
                } else {
                    this.isSbpRequired = false;
                }
                if (this.sbp_range.value && this.sbp_range.value < 90 || this.sbp_range.value > 200) {
                    this.spbValidate = true;
                } else {
                    this.spbValidate = false;
                }
            }
        },
        BMIValidation: function BMIValidation(val) {
            if (val == 'info') {
                this.bmiIcon = !this.bmiIcon;
            } else {
                if (this.bmi_range.value == "") {
                    this.isbmiRequired = true;
                    this.validationBMI = false;
                } else {
                    this.isbmiRequired = false;
                }
                if (this.bmi_range.value && this.bmi_range.value < 18.5 || this.bmi_range.value > 39.9) {
                    this.validationBMI = true;
                } else {
                    this.validationBMI = false;
                }
            }
        },
        egfrValidation: function egfrValidation(val) {
            if (val == 'info') {
                this.egfrIcon = !this.egfrIcon;
            } else {
                if (this.egfr_range.value == "") {
                    this.isegfrRequired = true;
                    this.validationegfr = false;
                } else {
                    this.isegfrRequired = false;
                }
                if (this.egfr_range.value && this.egfr_range.value < 15 || this.egfr_range.value > 140) {
                    this.validationegfr = true;
                } else {
                    this.validationegfr = false;
                }
            }
        },
        formValidate: function formValidate(e) {
            //age
            if (this.age_range.value == "") {
                this.isAgeRequried = true;
            } else if (this.age_range.value && this.age_range.value < 30 || this.age_range.value > 79) {
                this.ageValidation = true;
            } else {
                this.isAgeRequried = false;
                this.ageValidation = false;
            }
            //total cholesteron
            if (this.totalCholesterol_range.value == "") {
                this.istotalCholesterolRequired = true;
            } else if (this.totalCholesterol_range.value < 130 || this.totalCholesterol_range.value > 320) {
                this.totalCholesterolRangeValidation = true;
            } else {
                this.istotalCholesterolRequired = false;
                this.totalCholesterolRangeValidation = false;
            }
            //hdl cholesteron
            if (this.hdlCholesteron_range.value == "") {
                this.ishdlCholesteronRequired = true;
            } else if (this.hdlCholesteron_range.value < 20 || this.hdlCholesteron_range.value > 100) {
                this.hdlCholesteronValidate = true;
            } else {
                this.ishdlCholesteronRequired = false;
                this.hdlCholesteronValidate = false;
            }
            //sbp value
            if (this.sbp_range.value == "") {
                this.isSbpRequired = true;
            } else if (this.sbp_range.value < 90 || this.sbp_range.value > 200) {
                this.spbValidate = true;
            } else {
                this.isSbpRequired = false;
                this.spbValidate = false;
            }
            //bmi range
            if (this.bmi_range.value == "") {
                this.isbmiRequired = true;
            } else if (this.bmi_range.value < 18.5 || this.bmi_range.value > 39.9) {
                this.validationBMI = true;
            } else {
                this.isbmiRequired = false;
                this.validationBMI = false;
            }
            //egfr
            if (this.egfr_range.value == "") {
                this.isegfrRequired = true;
            } else if (this.egfr_range.value < 15 || this.egfr_range.value > 140) {
                this.validationegfr = true;
            } else {
                this.isegfrRequired = false;
                this.validationegfr = false;
            }

            if (this.isShowUACR === 1 && this.uacr_range_front_end === "") {
                this.emptyUacrValidation = true;
            }
            if (this.isShowHbA1C === 1 && this.HbA1C_range == "") {
                this.emptyHbA1CValidation = true;
            }
            if (this.isShowSID === 1 && this.SID_range == "") {
                this.SIDValidation = true;
            }

            //total cal
            if (!this.isegfrRequired && !this.validationegfr && !this.validationBMI && !this.isbmiRequired && !this.isSbpRequired && !this.spbValidate && !this.ishdlCholesteronRequired && !this.hdlCholesteronValidate && !this.istotalCholesterolRequired && !this.totalCholesterolRangeValidation && !this.isAgeRequried && !this.ageValidation) {
                this.totalValidation = true;
                //this.SIDValidation =false
                if (this.uacr_range_front_end !== "" && this.uacrValidation === true) {
                    this.totalValidation = false;
                } else if (this.HbA1C_range !== "" && this.HbA1CValidation === true) {
                    this.totalValidation = false;
                } else if (this.isShowSID === 1 && this.SID_range !== "" && this.SID_range.toString().length < 5) {
                    this.totalValidation = false;
                    //this.emptySIDValidation = true
                    this.SIDValidation = true;
                }
            } else {
                this.totalValidation = false;
            }
        },
        resetForm: function resetForm() {
            this.htmlmeds_range = "0";
            this.validationegfr = false;
            this.isegfrRequired = false;
            this.egfrIcon = false;
            this.validationBMI = false;
            this.isbmiRequired = false;
            this.validationBMI = false;
            this.spbValidate = false;
            this.isSbpRequired = false;
            this.sbpIcon = false;
            this.hdlCholesteronValidate = false;
            this.ishdlCholesteronRequired = false;
            this.hdlCholesteronIcon = false;
            this.totalCholesterolRangeValidation = false;
            this.istotalCholesterolRequired = false;
            this.totalCholesteronIcon = false;
            this.ageIcon = false;
            this.ageValidation = false;
            this.isAgeRequried = false;
            this.totalThirtyYearsHeartFailureWomen = "";
            this.totalThirtyAscvdWomenValue = "";
            this.totalThirtyYearsCVDWomenValue = "";
            this.totalThirtyHearFailureMenValue = "";
            this.totalThirtyAscvdMenValue = "";
            this.thrityYearsCVDMen = "";
            this.totalCVDMenValue = "";
            this.totalCVDWomenValue = "";
            this.totalAscdMenValue = "";
            this.totalAscdWomenValue = "";
            this.totalHearFailureMenVlaue = '';
            this.totalHeartFailureWomenValue = '';
            this.totalResult = 0;
            this.sex_range = 0;
            this.diabetes_range = 0;
            this.currentSmoker_range = 0;
            this.htn_range = 0;
            this.cholesteronTreated_range = 0;
            this.uacr_range = 0;
            this.isAgeValidate = false;
            this.isMlvwtValidate = false;
            this.isLasizeValidate = false;
            this.isMaxlovtValidate = false;
            this.isMlvwtRequired = false;
            this.isLasizeRequired = false;
            this.isMaxlvotRequired = false;
            this.ageToolTip = true;
            this.mlvwtToolTip = true;
            this.lasizeToolTip = true;
            this.maxlvotToolTip = true;
            this.fhscdToolTip = true;
            this.nsvtToolTip = true;
            this.unexSyToolTip = true;
            this.ef50ToolTip = true;
            this.apAnToolTip = true;
            this.elgeToolTip = true;
            this.age_range.value = "";
            this.totalCholesterol_range.value = "";
            this.hdlCholesteron_range.value = "";
            this.sbp_range.value = "";
            this.bmi_range.value = "";
            this.egfr_range.value = "";
            this.diabetesIcon = false;
            this.currentSmokerIcon = false;
            this.htnMedsIcon = false;
            this.cholesteronTreatedIcon = false;
            this.bmiIcon = false;
            this.isShowSID = 0;
            this.isShowHbA1C = 0;
            this.isShowUACR = 0;
            this.HbA1C_range = '';
            this.SID_range = '';
            this.uacr_range = '';
            this.iconUacrValidation = false;
            this.iconHbA1CValidation = false;
            this.iconSIDValidation = false;
            this.uacr_range_front_end = "";
            this.SIDValidation = false;
            this.emptySIDValidation = false;
            this.iconSIDValidation = false;
            this.ModelName = "";
            this.totalValidation = false;
        }
    },
    watch: {
        sex_range: function sex_range(newVal, oldVal) {
            if (oldVal === 0) {
                this.totalCVDWomenValue = "";
                this.totalCVDMenValue = "";
                this.totalAscdWomenValue = "";
                this.totalAscdMenValue = "";
                this.totalHearFailureMenVlaue = "";
                this.totalHeartFailureWomenValue = "";
                //thirty year
                this.totalThirtyYearsHeartFailureWomen = "";
                this.totalThirtyAscvdWomenValue = "";
                this.totalThirtyYearsCVDWomenValue = "";
                this.totalThirtyHearFailureMenValue = "";
                this.totalThirtyAscvdMenValue = "";
                this.thrityYearsCVDMen = "";
                this.totalHeartFailureWomenValues = "";
                // this.SDIMissing = ""
                this.ModelName = "";
                this.sex_range = 1;
            } else if (oldVal === 1) {
                this.totalCVDWomenValue = "";
                this.totalCVDMenValue = "";
                this.totalAscdWomenValue = "";
                this.totalAscdMenValue = "";
                this.totalHearFailureMenVlaue = "";
                this.totalHeartFailureWomenValue = "";
                this.totalHeartFailureWomenValues = "";
                //thirty year
                this.totalThirtyYearsHeartFailureWomen = "";
                this.totalThirtyAscvdWomenValue = "";
                this.totalThirtyYearsCVDWomenValue = "";
                this.totalThirtyHearFailureMenValue = "";
                this.totalThirtyAscvdMenValue = "";
                this.thrityYearsCVDMen = "";
                this.sex_range = 0;
                this.ModelName = "";
            }
        },

        'age_range.value': {
            handler: function handler(newVal, oldVal) {
                if (oldVal >= 60) {
                    this.totalThirtyYearsHeartFailureWomen = "";
                    this.totalThirtyAscvdWomenValue = "";
                    this.totalThirtyYearsCVDWomenValue = "";
                    this.totalThirtyHearFailureMenValue = "";
                    this.totalThirtyAscvdMenValue = "";
                    this.thrityYearsCVDMen = "";
                }
            }
        }
        // isShowSID(nexVal, oldVal) {
        //     if (oldVal === 0) {
        //         this.totalCVDMenValue = ""
        //         this.thrityYearsCVDMen = ""
        //         this.totalAscdMenValue = ""
        //         this.totalThirtyAscvdMenValue = ""
        //         this.totalHearFailureMenVlaue = ""
        //         this.totalThirtyHearFailureMenValue = ""
        //         this.totalCVDWomenValue = ""
        //         this.totalThirtyYearsCVDWomenValue = ""
        //         this.totalAscdWomenValue = ""
        //         this.totalThirtyAscvdWomenValue = ""
        //         this.totalHeartFailureWomenValues = ""
        //         this.totalThirtyYearsHeartFailureWomen = ""
        //         //this.SIDValidation =true
        //     } else {
        //         //this.SIDValidation =false
        //     }
        // }
    }
};

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcf_calculator_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcf_calculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcf_calculator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcf_calculator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcf_calculator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db33603_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcf_calculator_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcf_calculator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db33603_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcf_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        laDiameterLabel: {
            type: String,
            "default": ""
        },
        ageClinicalEvaluationLabel: {
            type: String,
            "default": ""
        },
        ageHcmDiagnosisLabel: {
            type: String,
            "default": ""
        },
        heartFailureSymptomsLabel: {
            type: String,
            "default": ""
        },
        laDiameterErromessage: {
            type: String,
            "default": ""
        },
        ageClinicalEvaluationErrormessage: {
            type: String,
            "default": ""
        },
        ageHcmDiagnosisErrormessage: {
            type: String,
            "default": ""
        },
        heartFailureSymptomsErrormesage: {
            type: String,
            "default": ""
        },
        riskScoreLabel: {
            type: String,
            "default": ""
        },
        hcmAfScoreText: {
            type: String,
            "default": ""
        },
        twoYearRiskText: {
            type: String,
            "default": ""
        },
        fiveYearRiskText: {
            type: String,
            "default": ""
        },
        bottomText: {
            type: String,
            "default": ""
        }
    },
    data: function data() {
        return {
            laDiameterDrodownValue: "",
            ageClinicalEvaluationDropdownValue: "",
            ageHCMDropdDownValue: "",
            heartFailureSymptoms: "0",
            totalValue: "",
            laDiameterErrMsg: false,
            ageClinicalErrMsg: false,
            ageHCMDErrMsg: false,
            totalResultMsg: false,
            twoPersent: "",
            fivePersent: "",
            risk: "",
            recommendationTxt: false,
            btnTxt: false,
            answerList: [{
                label: "low risk",
                totalScore: 8,
                riskAF2: 0.4,
                riskAF5: 1.0
            }, {
                label: "low risk",
                totalScore: 9,
                riskAF2: 0.5,
                riskAF5: 1.2
            }, {
                label: "low risk",
                totalScore: 10,
                riskAF2: 0.6,
                riskAF5: 1.4
            }, {
                label: "low risk",
                totalScore: 11,
                riskAF2: 0.7,
                riskAF5: 1.7
            }, {
                label: "low risk",
                totalScore: 12,
                riskAF2: 0.9,
                riskAF5: 2.1
            }, {
                label: "low risk",
                totalScore: 13,
                riskAF2: 1.0,
                riskAF5: 2.5
            }, {
                label: "low risk",
                totalScore: 14,
                riskAF2: 1.3,
                riskAF5: 3.0
            }, {
                label: "low risk",
                totalScore: 15,
                riskAF2: 1.5,
                riskAF5: 3.6
            }, {
                label: "low risk",
                totalScore: 16,
                riskAF2: 1.8,
                riskAF5: 4.3
            }, {
                label: "low risk",
                totalScore: 17,
                riskAF2: 2.2,
                riskAF5: 5.2
            }, {
                label: "intermediate risk",
                totalScore: 18,
                riskAF2: 2.6,
                riskAF5: 6.2
            }, {
                label: "intermediate risk",
                totalScore: 19,
                riskAF2: 3.1,
                riskAF5: 7.4
            }, {
                label: "intermediate risk",
                totalScore: 20,
                riskAF2: 3.8,
                riskAF5: 8.9
            }, {
                label: "intermediate risk",
                totalScore: 21,
                riskAF2: 4.5,
                riskAF5: 10.6
            }, {
                label: "high risk",
                totalScore: 22,
                riskAF2: 5.4,
                riskAF5: 12.6
            }, {
                label: "high risk",
                totalScore: 23,
                riskAF2: 6.5,
                riskAF5: 15.0
            }, {
                label: "high risk",
                totalScore: 24,
                riskAF2: 7.8,
                riskAF5: 17.8
            }, {
                label: "high risk",
                totalScore: 25,
                riskAF2: 9.3,
                riskAF5: 21.1
            }, {
                label: "high risk",
                totalScore: 26,
                riskAF2: 11.1,
                riskAF5: 24.8
            }, {
                label: "high risk",
                totalScore: 27,
                riskAF2: 13.3,
                riskAF5: 29.1
            }, {
                label: "high risk",
                totalScore: 28,
                riskAF2: 15.7,
                riskAF5: 33.9
            }, {
                label: "high risk",
                totalScore: 29,
                riskAF2: 18.7,
                riskAF5: 39.3
            }, {
                label: "high risk",
                totalScore: 30,
                riskAF2: 22.0,
                riskAF5: 45.2
            }, {
                label: "high risk",
                totalScore: 31,
                riskAF2: 25.9,
                riskAF5: 51.5
            }]
        };
    },

    methods: {
        hcfCalculatorFormula: function hcfCalculatorFormula() {
            var _this = this;

            if (this.laDiameterDrodownValue !== "" && this.ageClinicalEvaluationDropdownValue !== "" && this.ageHCMDropdDownValue !== "") {
                this.totalValue = parseInt(this.laDiameterDrodownValue) + parseInt(this.ageClinicalEvaluationDropdownValue) + parseInt(this.ageHCMDropdDownValue) + parseInt(this.heartFailureSymptoms);
                this.totalValue = this.totalValue > 31 ? "31+" : this.totalValue < 8 ? 'below 8' : this.totalValue;
                var filteredList = this.answerList.filter(function (item) {
                    return item.totalScore === _this.totalValue;
                });
                this.twoPersent = this.totalValue === "31+" || this.totalValue === 'below 8' ? null : filteredList[0].riskAF2.toFixed(1);
                this.fivePersent = this.totalValue === "31+" || this.totalValue === 'below 8' ? null : filteredList[0].riskAF5.toFixed(1);

                if (this.totalValue > 21 || this.totalValue === "31+") {
                    this.recommendationTxt = true;
                } else {
                    this.recommendationTxt = false;
                }
                this.btnTxt = true;
            } else {
                this.totalValue = "";
            }
        },
        formValidate: function formValidate() {
            if (this.laDiameterDrodownValue === "") {
                this.laDiameterErrMsg = true;
            }
            if (this.ageClinicalEvaluationDropdownValue === "") {
                this.ageClinicalErrMsg = true;
            }

            if (this.ageHCMDropdDownValue === "") {
                this.ageHCMDErrMsg = true;
            }

            if (this.laDiameterErrMsg && this.ageClinicalErrMsg && this.ageHCMDErrMsg) {
                this.totalResultMsg = true;
            }
        },
        handleChange: function handleChange(val) {
            if (val === "laDiameterDrodownValue") {
                if (this.laDiameterDrodownValue === "") {
                    this.laDiameterErrMsg = true;
                } else {
                    this.laDiameterErrMsg = false;
                }
            }

            if (val === "ageClinicalEvaluationLabel") {
                if (this.ageClinicalEvaluationDropdownValue === "") {
                    this.ageClinicalErrMsg = true;
                } else {
                    this.ageClinicalErrMsg = false;
                }
            }

            if (val === 'ageHcmDiagnosisLabel') {
                if (this.ageHCMDropdDownValue === "") {
                    this.ageHCMDErrMsg = true;
                } else {
                    this.ageHCMDErrMsg = false;
                }
            }
        },
        reset: function reset() {
            this.laDiameterDrodownValue = "", this.ageClinicalEvaluationDropdownValue = "", this.ageHCMDropdDownValue = "", this.heartFailureSymptoms = "0", this.totalValue = "", this.laDiameterErrMsg = false, this.ageClinicalErrMsg = false, this.ageHCMDErrMsg = false, this.totalResultMsg = false, this.twoPersent = "", this.fivePersent = "", this.risk = "", this.recommendationTxt = false, this.btnTxt = false;
        }
    }
};

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_dropdown_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_dropdown_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_dropdown_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_dropdown_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00e813fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_search_dropdown_vue__ = __webpack_require__(477);
function injectStyle (ssrContext) {
  __webpack_require__(475)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_dropdown_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00e813fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_search_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
    props: {
        label: {
            type: String,
            "default": ""
        },
        dropdowndata: {
            type: String,
            "default": function _default() {
                return [];
            }
        },
        savePreferencesEndpoint: {
            type: String,
            "default": ""
        },
        getPreferencesEndpoint: {
            type: String,
            "default": ""
        },
        saveSuccessMessage: {
            type: String,
            "default": ""
        },
        saveErrorMessage: {
            type: String,
            "default": ""
        },
        refresh: {
            type: String,
            "default": ""
        }
    },

    data: function data() {
        return {
            modalVisible: true,
            dropdowns: JSON.parse(this.dropdowndata),
            sucessMsg: false,
            errorMsg: false,
            validationError: false,
            dropdownData: {
                SsoId: null,
                UserId: null,
                BroadAreaScience: [{
                    id: "label-959e2351-2ff7-47c5-9040-71f1c9c56417"
                }],
                Degrees: [{
                    id: "aeab1b33-6efb-4eeb-8c19-477f79a64bb5"
                }, {
                    id: "9b7616c3-048f-45c9-9e92-498e006845f4"
                }],
                Role: [{
                    id: "6094d535-2233-40d4-850c-7c9f84075602"
                }],
                Expertise: [{
                    id: "4c40bc8c-7b4b-403b-aa72-51357dfc41f5"
                }],
                Interest: [{
                    id: "4c40bc8c-7b4b-403b-aa72-51357dfc41f5"
                }]
            }
        };
    },
    created: function created() {
        this.dropdowns = this.dropdowns.map(function (dropdown) {
            return _extends({}, dropdown, {
                isOpen: false // Ensure every dropdown has isOpen property set to false
            });
        });
    },
    mounted: function mounted() {
        this.initializeDropdownSelections();
        console.log("dropdowns", this.dropdowns);
    },


    methods: {
        initializeDropdownSelections: function initializeDropdownSelections() {
            var _this = this;

            _axios2["default"].get("" + this.getPreferencesEndpoint).then(function (res) {
                _this.dropdowns.forEach(function (dropdown) {
                    console.log("dropdownLab", dropdown.Label, dropdown);
                    // Map the API label to your internal label
                    var normalizedLabel = dropdown.Label === "Area of Science" ? "BroadAreaScience" : dropdown.Label;

                    var preSelectedItems = res.data[normalizedLabel];
                    if (preSelectedItems && preSelectedItems.length) {
                        dropdown.SelectedItems = preSelectedItems.map(function (preSelected) {
                            var itemId = preSelected.id;

                            // Helper function to find item recursively
                            var findItemById = function findItemById(items) {
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;

                                try {
                                    for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                        var item = _step.value;

                                        if (item.Value === itemId) {
                                            return item; // Found the item
                                        }
                                        // Check children recursively if present
                                        if (item.Children && item.Children.length > 0) {
                                            var childMatch = findItemById(item.Children);
                                            if (childMatch) return childMatch;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"]) {
                                            _iterator["return"]();
                                        }
                                    } finally {
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }

                                return null; // Item not found in current level
                            };

                            var matchedItem = findItemById(dropdown.Values);

                            if (matchedItem) {
                                return matchedItem.Name;
                            } else {
                                console.warn("Item with id " + itemId + " not found for dropdown " + dropdown.Label);
                                return { id: itemId }; // Optional: Return ID alone if item not found
                            }
                        });
                    } else {
                        console.warn("No pre-selected items found for dropdown Label " + dropdown.Label);
                    }
                });
            })["catch"](function (err) {
                _this.errorMsg = true;
                console.error(err);
            });
        },
        scrollToTop: function scrollToTop() {
            window.scrollTo({ top: 150, behavior: "smooth" });
        },
        toggleDropdown: function toggleDropdown(dropdown, index) {
            // Toggle the dropdown's open/close state
            dropdown.IsDropdownOpen = !dropdown.IsDropdownOpen;

            // Construct the container ID dynamically based on the index
            var currentContainerId = "container" + (index + 1);
            var currentContainer = document.getElementById(currentContainerId);

            // Check if the dropdown is open or closed and set the container border accordingly
            if (dropdown.IsDropdownOpen) {
                // When the dropdown is open, remove the border
                if (currentContainer) {
                    //  currentContainer.style.border = "2px solid red";
                    currentContainer.style.transition = "height 0.3s ease-in-out";
                    currentContainer.style.marginTop = "270px";
                }
            } else {
                // When the dropdown is closed, apply the red border
                if (currentContainer) {
                    currentContainer.style.border = "none";
                    currentContainer.style.transition = "height 0.3s ease-in-out";
                    currentContainer.style.marginTop = "auto";
                }
            }
        },
        toggleExpand: function toggleExpand(option) {
            option.expanded = !option.expanded;
        },
        toggleSub: function toggleSub(option, label) {
            var _this2 = this;

            console.log("Sub-option to toggle:", option);

            // Recursive function to find and toggle the specific option and its children in the original dropdowns
            var findAndToggleSub = function findAndToggleSub(items) {
                items.forEach(function (item) {
                    if (item.Name === option.Name && item.Value === option.Value) {
                        // Toggle the current option's expanded state
                        if (!item.hasOwnProperty("expanded")) {
                            _this2.$set(item, "expanded", false);
                        }
                        _this2.$set(item, "expanded", !item.expanded);
                        console.log("Toggled expanded for: " + item.Name + ", new value: " + item.expanded);

                        // If the option has children, toggle their expanded states as well
                        if (item.Children && item.Children.length > 0) {
                            item.Children.forEach(function (child) {
                                if (!child.hasOwnProperty("expanded")) {
                                    _this2.$set(child, "expanded", false);
                                }
                                _this2.$set(child, "expanded", !child.expanded);
                                console.log("Toggled expanded for child: " + child.Name + ", new value: " + child.expanded);
                            });
                        }
                    }

                    // Recur for nested children
                    if (item.Children && item.Children.length > 0) {
                        findAndToggleSub(item.Children);
                    }
                });
            };

            // Find the dropdown with the matching label and toggle the sub-option
            this.dropdowns.forEach(function (dropdown) {
                if (dropdown.Label === label.Label) {
                    findAndToggleSub(dropdown.Values);
                }
            });
        },
        toggleParent: function toggleParent(option, label) {
            var _this3 = this;

            console.log("Option to toggle:", option);

            // Recursive function to find and toggle the corresponding option in the original dropdowns
            var findAndToggle = function findAndToggle(items) {
                items.forEach(function (item) {
                    if (item.Name === option.Name && item.Value === option.Value) {
                        // Use $set to toggle the "expanded" property reactively
                        if (!item.hasOwnProperty("expanded")) {
                            _this3.$set(item, "expanded", false);
                        }
                        _this3.$set(item, "expanded", !item.expanded);
                        console.log("Toggled expanded for: " + item.Name + ", new value: " + item.expanded);
                    }

                    // Recur for children if present
                    if (item.Children && item.Children.length > 0) {
                        findAndToggle(item.Children);
                    }
                });
            };

            // Find the dropdown with the matching label and toggle the option
            this.dropdowns.forEach(function (dropdown) {
                if (dropdown.Label === label.Label) {
                    findAndToggle(dropdown.Values);
                }
            });
        },
        filteredOptions: function filteredOptions(dropdown) {
            var query = dropdown.SearchQuery.toLowerCase().trim(); // Normalize the search query
            if (!query) {
                return dropdown.Values; // Return all options if the search query is empty
            }
            return this.filterOptionsRecursively(dropdown.Values, query);
        },


        // Recursive method to filter options and their children
        filterOptionsRecursively: function filterOptionsRecursively(options, query) {
            var _this4 = this;

            return options.map(function (option) {
                var matches = option.Name.toLowerCase().includes(query); // Check if this option matches

                // Recursively filter the children, if any
                var filteredChildren = option.Children ? _this4.filterOptionsRecursively(option.Children, query) : [];

                // Include this option if it matches or has matching children
                if (matches || filteredChildren.length > 0) {
                    return _extends({}, option, { // Copy the option
                        Children: filteredChildren // Keep the filtered children
                    });
                }

                return null; // Exclude options that don't match
            }).filter(Boolean); // Remove null values
        },
        handleParentCheckboxChange: function handleParentCheckboxChange(option) {
            var _this5 = this;

            // If the option has children, we handle selection of all children
            if (option.Children && option.Children.length > 0) {
                if (this.isOptionSelected(option)) {
                    // If parent is selected, ensure all children are also selected
                    option.Children.forEach(function (child) {
                        if (!_this5.dropdown.SelectedItems.includes(child.Name)) {
                            _this5.dropdown.SelectedItems.push(child.Name);
                        }
                    });
                } else {
                    // If parent is deselected, remove all children from selection
                    option.Children.forEach(function (child) {
                        var index = _this5.dropdown.SelectedItems.indexOf(child.Name);
                        if (index !== -1) _this5.dropdown.SelectedItems.splice(index, 1);
                    });
                }
            } else {
                // If no children, toggle the parent option itself in SelectedItems
                var index = this.dropdown.SelectedItems.indexOf(option.Name);
                if (index === -1) {
                    this.dropdown.SelectedItems.push(option.Name);
                } else {
                    this.dropdown.SelectedItems.splice(index, 1);
                }
            }
        },
        isOptionSelected: function isOptionSelected(option) {
            var _this6 = this;

            // Check if an option (and all its children) are selected
            if (option.Children && option.Children.length > 0) {
                return option.Children.every(function (child) {
                    return _this6.dropdown.SelectedItems.includes(child.Name);
                });
            } else {
                return this.dropdown.SelectedItems.includes(option.Name);
            }
        },
        handleSubCheckboxChange: function handleSubCheckboxChange(subOption, parentOption) {
            subOption.expanded = true;

            var dropdown = this.dropdowns.find(function (d) {
                return d.Values.includes(parentOption);
            });
            if (!parentOption.Children || parentOption.Children.length === 0) {
                var index = dropdown.SelectedItems.indexOf(subOption.Name);
                if (index > -1) dropdown.SelectedItems.splice(index, 1);else console.log("subOption", subOption);
                dropdown.SelectedItems.push(subOption.Name);
            }
        },


        // Expand and select the semi-sub-options independently
        handleSemiSubCheckboxChange: function handleSemiSubCheckboxChange(semiSubOption, subOption) {
            console.log("subOption", subOption.Value);
            var dropdown = this.dropdowns.find(function (d) {
                return d.Values.includes(subOption);
            });
            console.log("dropdown", dropdown);
            var index = dropdown.SelectedItems.indexOf(semiSubOption.Name);
            if (index > -1) dropdown.SelectedItems.splice(index, 1);else dropdown.SelectedItems.push(semiSubOption.Name);
        },
        removeItem: function removeItem(dropdown, item) {
            var index = dropdown.SelectedItems.indexOf(item);
            if (index > -1) {
                dropdown.SelectedItems.splice(index, 1);
            }

            // Deselect the corresponding checkboxes in the dropdown options
            dropdown.Values.forEach(function (option) {
                if (option.Name === item) {
                    option.selected = false; // Deselect parent option
                }

                // Check sub-options
                option.Children.forEach(function (subOption) {
                    if (subOption.Name === item) {
                        subOption.selected = false; // Deselect sub-option
                    }

                    // Check semi sub-options
                    subOption.Children.forEach(function (semiSubOption) {
                        if (semiSubOption.Name === item) {
                            semiSubOption.selected = false; // Deselect semi sub-option
                        }
                    });
                });
            });
        },
        submit: function submit(event) {
            var _this7 = this;

            if (event) {
                event.preventDefault();
            }
            var allInputsEmpty = this.dropdowns.every(function (dropdown) {
                return !dropdown.SelectedItems || dropdown.SelectedItems.length === 0;
            });

            if (allInputsEmpty) {
                this.validationError = true;
                this.sucessMsg = false;
                this.scrollToTop();
                return; // Stop execution
            } else {
                this.validationError = false;
            }
            var resultObject = {};
            this.dropdowns.forEach(function (dropdown) {
                var label = dropdown.Label;
                var selectedItems = dropdown.SelectedItems;
                console.log("Selected items for", label, selectedItems);

                // Rename 'Area of Science' to 'BroadAreaScience'
                if (label === "Area of Science") {
                    label = "BroadAreaScience";
                }
                var selectedValues = [];

                selectedItems.forEach(function (selected) {
                    // Validate the selected item in the dropdown values
                    var validatedOption = null;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = dropdown.Values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var option = _step2.value;

                            validatedOption = _this7.validateSelectedOption(option, selected);
                            if (validatedOption) break;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
                                _iterator2["return"]();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    if (validatedOption) {
                        // Recursively get selected children
                        var children = _this7.findSelectedOptions(validatedOption);
                        console.log("Children for", validatedOption.Name, children);

                        var currentOption = {
                            name: validatedOption.Name,
                            id: validatedOption.Value,
                            children: children.length ? children : []
                        };

                        selectedValues.push(currentOption);
                    } else {
                        console.log("No matching option found for", selected);
                    }
                });

                if (selectedValues.length) {
                    resultObject[label.charAt(0).toUpperCase() + label.slice(1)] = selectedValues;
                } else {
                    console.log("No selected values for " + label);
                }
            });

            var output = this.flattenAllCategories(resultObject);
            Object.keys(output).forEach(function (key) {
                output[key] = _this7.removeDuplicates(output[key]);
            });

            (0, _axios2["default"])({
                method: "post",
                url: this.savePreferencesEndpoint,
                headers: { "Content-Type": "application/json" },
                data: JSON.stringify(output, null, 2)
            });
            this.scrollToTop();
            this.sucessMsg = true;
            if (this.refresh === "true") {
                window.location.reload();
                this.setTimeout(function () {
                    _this7.sucessMsg = false;
                }, 6000);
            }
        },
        removeDuplicates: function removeDuplicates(arr) {
            console.log("arr", arr);
            var uniqueItems = new Set();
            return arr.filter(function (item) {
                if (!uniqueItems.has(item.id)) {
                    uniqueItems.add(item.id);
                    return true;
                }
                return false;
            });
        },
        flattenAllCategories: function flattenAllCategories(data) {
            var result = {};

            // Iterate over each main category key in data (e.g., "Role", "Expertise", "Interest")
            Object.keys(data).forEach(function (category) {
                result[category] = [];

                // Recursive function to flatten items
                function extractItems(items) {
                    items.forEach(function (item) {
                        // Add the current item (name and id) to the result array for this category
                        var name = item.name,
                            id = item.id;

                        result[category].push({ name: name, id: id });

                        // If there are children, recursively process them
                        if (Array.isArray(item.children) && item.children.length > 0) {
                            extractItems(item.children);
                        }
                    });
                }

                // Start the recursion with the main category array
                if (Array.isArray(data[category])) {
                    extractItems(data[category]);
                }
            });

            return result;
        },
        validateSelectedOption: function validateSelectedOption(option, selected) {
            // Check if the option is the selected item
            if (option.Name === selected) {
                console.log("Valid option found:", option);
                return option; // Return the option if it matches the selected item
            }

            // If the option has children, search within them recursively
            if (option.Children && option.Children.length > 0) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = option.Children[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var child = _step3.value;

                        var result = this.validateSelectedOption(child, selected);
                        if (result) {
                            return result; // Return the validated child/sub-child if found
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3["return"]) {
                            _iterator3["return"]();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }

            // Return null if no match found at this level
            return null;
        },
        findSelectedOptions: function findSelectedOptions(option) {
            var _this8 = this;

            if (!option.Children || option.Children.length === 0) {
                console.log("Bharath");
                return []; // If no children, return an empty array
            }
            var selectedChildren = option.Children.filter(function (child) {
                return _this8.isSelected(child);
            }).map(function (child) {
                var subChildren = _this8.findSelectedOptions(child); // Recursively get selected sub-options
                var result = {
                    name: child.Name,
                    id: child.Value
                };
                if (subChildren.length > 0) {
                    result.children = subChildren;
                }
                return result;
            });

            return selectedChildren;
        },
        isSelected: function isSelected(option) {
            return this.dropdowns.some(function (dropdown) {
                return dropdown.SelectedItems.includes(option.Name);
            });
        }
    }
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _props;

var _hcmScdCalculator = __webpack_require__(56);

var _hcmScdCalculator2 = _interopRequireDefault(_hcmScdCalculator);

var _riskKidsPrimacy = __webpack_require__(57);

var _riskKidsPrimacy2 = _interopRequireDefault(_riskKidsPrimacy);

var _riskHcmPrimacy = __webpack_require__(487);

var _riskHcmPrimacy2 = _interopRequireDefault(_riskHcmPrimacy);

var _hcmPrimacy = __webpack_require__(491);

var _hcmPrimacy2 = _interopRequireDefault(_hcmPrimacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue';
/* eslint-disable */


exports["default"] = {
    components: {
        HcmScdCalculator: _hcmScdCalculator2["default"],
        RiskKidsPrimacy: _riskKidsPrimacy2["default"],
        RiskHCMPrimacy: _riskHcmPrimacy2["default"],
        HcmPrimacy: _hcmPrimacy2["default"]
    },
    props: (_props = {
        //popup messages
        resultGuidelineTextSixteen: {
            type: String,
            required: true
        },
        resultGuidelineTextAdult: {
            type: String,
            required: true
        },
        hcmRecommendationDescription: {
            type: String,
            required: true
        },
        patientSelectionLabel: {
            type: String,
            required: true
        },
        posteriorLvErrorMessage: {
            type: String,
            required: true
        },
        posteriorLvLabel: {
            type: String,
            required: true
        },
        resultGuidelineText: {
            type: String,
            required: true
        },
        calculatorVersionText: {
            type: String,
            required: true
        },

        ageLabel: {
            type: String,
            required: true
        },

        riskHeaderText: {
            type: String,
            required: true
        },
        riskFooterText: {
            type: String,
            required: true
        }
    }, _defineProperty(_props, "ageLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "ageHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "ageSectionText", {
        type: String,
        required: true
    }), _defineProperty(_props, "ageHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "ageIfEightyErrorMessage", {
        type: String,
        required: true
    }), _defineProperty(_props, "heightErrorMessage", {
        type: String,
        required: true
    }), _defineProperty(_props, "weightErrorMessage", {
        type: String,
        required: true
    }), _defineProperty(_props, "laSizeErrorMessage", {
        type: String,
        required: true
    }), _defineProperty(_props, "maxLvotGradientErrorMessage", {
        type: String,
        required: true
    }), _defineProperty(_props, "mlvwtErrorMessage", {
        type: String,
        required: true
    }), _defineProperty(_props, "isdErrorMessage", {
        type: String,
        required: true
    }), _defineProperty(_props, "sexLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "heightLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "weightLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "laSizeLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "maxLvotGradientLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "mlvwtLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "isdLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "gpLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "usLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "nsvtLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "gsLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "efLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "fhscdLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "aaLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "lgeLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "laSizeHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "maxLvotGradientHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "mlvwtHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "isdHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "gpHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "usHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "nsvtHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "gsHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "efHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "fhscdHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "aaHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "lgeHelpText", {
        type: String,
        required: true
    }), _defineProperty(_props, "ageErrorMessage", {
        type: String,
        required: true
    }), _defineProperty(_props, "hcmRiskKidsScoreLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "hcmRiskKidsScoreDescription", {
        type: String,
        required: true
    }), _defineProperty(_props, "primacyRiskScoreLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "primacyRiskScoreDescription", {
        type: String,
        required: true
    }), _defineProperty(_props, "lvmwtZScoreLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "lvmwtZScoreDescription", {
        type: String,
        required: true
    }), _defineProperty(_props, "laDiameterZScoreLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "laDiameterZScoreDescription", {
        type: String,
        required: true
    }), _defineProperty(_props, "hcmScdScoreLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "hcmScdScoreDescription", {
        type: String,
        required: true
    }), _defineProperty(_props, "prognosticIndexLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "prognosticIndexDescription", {
        type: String,
        required: true
    }), _defineProperty(_props, "hcmScdRecommendationLabel", {
        type: String,
        required: true
    }), _defineProperty(_props, "hcmScdRecommendationDescription", {
        type: String,
        required: true
    }), _defineProperty(_props, "errorModalHeaderText", {
        type: String,
        required: true
    }), _defineProperty(_props, "errorModalFooterText", {
        type: String,
        required: true
    }), _props),

    data: function data() {
        return {
            userAgeValue: "",
            ageValidation: false,
            ageValidationError: "If the patient is less than 1 year old, please enter 0.",
            firstStep: false,
            secondStep: false,
            thirdStep: false,
            fourthStep: false,
            hideFirstScreen: true
        };
    },


    methods: {
        handleValidation: function handleValidation() {
            var age = Number(this.userAgeValue);

            if (this.userAgeValue.includes('.')) {

                this.ageValidationError = "Age can only be a whole number. If less than 1 year old, please enter 0.";
                this.ageValidation = true;
            } else if (age < 1 && age !== "") {
                this.ageValidationError = "Due to value entered, HCM Risk Kids cannot be computed.";
                this.ageValidation = true;
            } else if (age < 0 || age > 80) {
                this.ageValidationError = this.ageIfEightyErrorMessage;
                this.ageValidation = true;
            } else {
                this.ageValidationError = "If the patient is less than 1 year old, please enter 0.";
                this.ageValidation = false;
            }
        },
        handleUpperInput: function handleUpperInput() {
            this.userAgeValue = this.userAgeValue.replace(/[^0-9.]/g, "");
        },
        handleSecondScree: function handleSecondScree() {
            this.secondStep = false;
            this.hideFirstScreen = true;
        },
        handleThirdScreen: function handleThirdScreen() {
            this.thirdStep = false;
            this.hideFirstScreen = true;
        },
        handleFourthScreen: function handleFourthScreen() {
            this.fourthStep = false;
            this.hideFirstScreen = true;
        },
        handleFirstScreen: function handleFirstScreen() {
            this.firstStep = false;
            this.hideFirstScreen = true;
        },
        redirectNxtScreen: function redirectNxtScreen() {

            if (this.userAgeValue === "") {
                this.ageValidationError = this.ageErrorMessage;
                this.ageValidation = true;
            } else if (this.userAgeValue.includes('.')) {
                this.ageValidationError = "Age can only be a whole number. If less than 1 year old, please enter 0.";
                this.ageValidation = true;
            } else {
                var age = Number(this.userAgeValue);
                if (age >= 0 && age <= 15) {
                    this.hideFirstScreen = false;
                    this.firstStep = true;
                    this.ageValidation = false;
                } else if (age === 16) {
                    this.secondStep = true;
                    this.hideFirstScreen = false;
                    this.ageValidation = false;
                }
                // else if (age === 17) {                  
                //     this.thirdStep = true;
                //     this.hideFirstScreen = false;
                //     this.ageValidation = false;

                // } 
                else if (age >= 17 && age <= 80) {
                        this.fourthStep = true;
                        this.hideFirstScreen = false;
                        this.ageValidation = false;
                    } else if (age < 0 || age > 80) {
                        this.ageValidation = true;
                        this.ageValidationError = this.ageIfEightyErrorMessage;
                    } else {
                        this.ageValidationError = this.ageIfEightyErrorMessage;
                        this.ageValidation = true;
                    }
            }
        }
    },
    mounted: function mounted() {
        this.$root.$on("bv::modal::hidden", function ($event) {});
    }
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  props: {
    hcmRecommendationDescription: {
      type: String,
      required: true
    },
    patientSelectionLabel: {
      type: String,
      required: true
    },
    riskHeaderText: {
      type: String,
      required: true
    },
    resultGuidelineTextAdult: {
      type: String,
      required: true
    },
    calculatorVersionText: {
      type: String,
      required: true
    },
    userAgeValue: {
      type: String,
      required: true
    },
    handleFourthScreen: Function,
    heightErrorMessage: {
      type: String,
      required: true
    },
    weightErrorMessage: {
      type: String,
      required: true
    },
    laSizeErrorMessage: {
      type: String,
      required: true
    },
    maxLvotGradientErrorMessage: {
      type: String,
      required: true
    },
    mlvwtErrorMessage: {
      type: String,
      required: true
    },
    isdErrorMessage: {
      type: String,
      required: true
    },
    sexLabel: {
      type: String,
      required: true
    },
    heightLabel: {
      type: String,
      required: true
    },
    weightLabel: {
      type: String,
      required: true
    },
    laSizeLabel: {
      type: String,
      required: true
    },
    maxLvotGradientLabel: {
      type: String,
      required: true
    },
    mlvwtLabel: {
      type: String,
      required: true
    },
    isdLabel: {
      type: String,
      required: true
    },
    gpLabel: {
      type: String,
      required: true
    },
    usLabel: {
      type: String,
      required: true
    },
    nsvtLabel: {
      type: String,
      required: true
    },
    gsLabel: {
      type: String,
      required: true
    },
    efLabel: {
      type: String,
      required: true
    },
    fhscdLabel: {
      type: String,
      required: true
    },
    aaLabel: {
      type: String,
      required: true
    },
    lgeLabel: {
      type: String,
      required: true
    },
    laSizeHelpText: {
      type: String,
      required: true
    },
    maxLvotGradientHelpText: {
      type: String,
      required: true
    },
    mlvwtHelpText: {
      type: String,
      required: true
    },
    isdHelpText: {
      type: String,
      required: true
    },
    gpHelpText: {
      type: String,
      required: true
    },
    usHelpText: {
      type: String,
      required: true
    },
    nsvtHelpText: {
      type: String,
      required: true
    },
    gsHelpText: {
      type: String,
      required: true
    },
    efHelpText: {
      type: String,
      required: true
    },
    fhscdHelpText: {
      type: String,
      required: true
    },
    aaHelpText: {
      type: String,
      required: true
    },
    lgeHelpText: {
      type: String,
      required: true
    },
    //modal Text 
    hcmRiskkidsScoreLabel: {
      type: String,
      required: true
    },

    hcmRiskKidsScoreDescription: {
      type: String,
      required: true
    },
    primacyRiskScoreLabel: {
      type: String,
      required: true
    },

    primacyRiskScoreDescription: {
      type: String,
      required: true
    },
    lvmwtZScoreLabel: {
      type: String,
      required: true
    },

    lvmwtZScoreDescription: {
      type: String,
      required: true
    },
    laDiameterZScoreLabel: {
      type: String,
      required: true
    },

    laDiameterZScoreDescription: {
      type: String,
      required: true
    },
    hcmScdScoreLabel: {
      type: String,
      required: true
    },

    hcmScdScoreDescription: {
      type: String,
      required: true
    },
    prognosticIndexLabel: {
      type: String,
      required: true
    },

    prognosticIndexDescription: {
      type: String,
      required: true
    },
    hcmScdRecommendationLabel: {
      type: String,
      required: true
    },
    hcmScdRecommendationDescription: {
      type: String,
      required: true
    },
    errorModalFooterText: {
      type: String,
      required: true
    },
    errorModalHeaderText: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isShowModal: false,
      isAgeValidate: false,
      isMlvwtValidate: false,
      isLasizeValidate: false,
      isMaxlovtValidate: false,
      isAgeRequired: false,
      isMlvwtRequired: false,
      isLasizeRequired: false,
      isMaxlvotRequired: false,
      ageToolTip: true,
      mlvwtToolTip: true,
      lasizeToolTip: true,
      maxlvotToolTip: true,
      fhscdToolTip: true,
      nsvtToolTip: true,
      unexSyToolTip: true,
      ef50ToolTip: true,
      apAnToolTip: true,
      elgeToolTip: true,

      mlvwt_range: {
        value: "",
        wallThickness: {
          min: 10,
          max: 35
        },
        requiredMessage: this.mlvwtErrorMessage,
        errorMessage: "MLVWT must be between 10 and 35 mm."
      },
      lasize_range: {
        value: "",
        laDiameter: {
          min: 28,
          max: 67
        },
        requiredMessage: this.laSizeErrorMessages,
        errorMessage: "LA Size must be between 28 and 67 mm"
      },
      maxlvot_range: {
        value: "",
        lvotGradient: {
          min: 2,
          max: 154
        },
        requiredMessage: this.mlvwtErrorMessage,
        errorMessage: "Max LVOT Gradient must be between 2 and 154 mmHg."
      },
      fhscd_pick: 0,
      nsvt_pick: 0,
      unexSy_pick: 0,
      ef50_pick: 0,
      apAn_pick: 0,
      elge_pick: 0,
      recommendation: "",
      risk: {
        value: ""
      },
      hcmScdCalculatorResultValidatoin: false,
      validationModal: false,
      mainScreen: false

    };
  },

  methods: {
    validationBack: function validationBack() {
      this.validationModal = false;
      this.mainScreen = false;
      this.isShowModal = false;
    },
    handleUpperInput: function handleUpperInput(inputKey) {

      if (inputKey === 'ivsd_mm') {
        this.mlvwt_range.value = this.mlvwt_range.value.replace(/[^0-9.]/g, "");
      }

      if (inputKey === 'lvpwd_mm') {
        this.lasize_range.value = this.lasize_range.value.replace(/[^0-9.]/g, "");
      }

      if (inputKey === 'la_systole_mm') {
        this.maxlvot_range.value = this.maxlvot_range.value.replace(/[^0-9.]/g, "");
      }

      if (inputKey === 'peak_grad_mmhg') {
        this.peak_grad_mmhg = this.peak_grad_mmhg.replace(/[^0-9.]/g, "");
      }
    },
    handleBackScreen: function handleBackScreen() {
      this.handleFourthScreen();
    },
    handleReload: function handleReload() {

      window.location.reload();
    },
    hcmCalculatorFormula: function hcmCalculatorFormula() {
      this.isShowModal = true;
      this.validationModal = false;
      this.mainScreen = true;
      var age = this.userAgeValue;
      var mlvwt = this.mlvwt_range;
      var lasize = this.lasize_range;
      var maxlvot = this.maxlvot_range;
      var fhscd = this.fhscd_pick;
      var nsvt = this.nsvt_pick;
      var unexSyncope = this.unexSy_pick;
      var ef50 = this.ef50_pick;
      var aa = this.apAn_pick;
      var elge = this.elge_pick;

      var a = 0.01799934 * age;
      var b = 0.15939858 * mlvwt.value - 0.00294271 * mlvwt.value * mlvwt.value;
      var c = 0.0259082 * lasize.value;
      var d = 0.00446131 * maxlvot.value;
      var e = fhscd === 0 ? 0 : 0.4583082;
      var f = nsvt === 0 ? 0 : 0.82639195;
      var g = unexSyncope === 0 ? 0 : 0.71650361;
      var h = mlvwt.value <= 29 ? 0 : 1;
      var i = ef50 === 0 ? 0 : 1;
      var j = null;
      var k = b + c + d + e + f + g - a;
      var l = Math.pow(2.71828183, k);
      var m = Math.pow(0.998, l);
      var risk = 100 * (1 - m);

      var elgeYes = elge == 1;
      var aaYes = aa == 1;
      var efYes = i == 1;
      var nsvtYes = f == 0.82639195;
      var fhscdYes = e == 0.4583082;
      var usYes = g == 0.71650361;
      var mlvwtYes = h == 1;

      switch (true) {
        //Class 2A: When one parameter AND NSVT AND Extensive LGE = YES
        case elgeYes && nsvtYes && aaYes && efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%, Apical Aneurysm, and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge, aa, ef & nsvt are yes");
          break;
        case efYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge & nsvt");
          break;
        case aaYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge & nsvt");
          break;
        case fhscdYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("fhscd, elge, nsvt are yes");
          break;
        case usYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("US, elge, nsvt are yes");
          break;
        case mlvwtYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("mlvwt, elge, nsvt are yes");
          break;
        case elgeYes && efYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm, EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge,ef,aa are yes");
          break;
        case nsvtYes && efYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Apical Aneursym)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge,ef,aa are yes");
          break;

        //Class 2B(a): When all parameters = NO except for NVST AND Extensive LGE
        case elgeYes && nsvtYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "This patient has 2 risk factors that while individually carry Class 2B indications, having both of these likely represents more risk than having either risk factor in isolation";
          console.log("elge & nsvt");
          break;

        //Class 2A: When any parameter AND EXTENSIVE LGE = YES
        case elgeYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("switch elge & aa");
          break;
        case elgeYes && efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge & ef are yes");
          break;
        case elgeYes && fhscdYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("FHSCD and ELGE are yes");
          break;
        case elgeYes && usYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Unexplained Syncope and ELGE are yes");
          break;
        case elgeYes && mlvwtYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("MLVWT and ELGE are yes");
          break;

        //Class 2A: When any parameter AND NVST = YES
        case nsvtYes && efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF and NSVT are yes");
          break;
        case nsvtYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF and NSVT are yes");
          break;
        case nsvtYes && fhscdYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("FHSCD and NSVT are yes");
          break;
        case nsvtYes && usYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Unexplained Syncope and NSVT are yes");
          break;
        case nsvtYes && mlvwtYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("MLVWT and NSVT are yes");
          break;

        //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
        case efYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF and AA are yes");
          break;

        //Class 2B: When all parameters = NO except for NVST OR Extensive LGE
        case nsvtYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
          console.log("nsvtYes");
          break;
        case elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
          console.log("elge catch all");
          break;

        //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
        case efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF is Yes");
          break;
        case aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Apical aneurysm is yes");
          break;
        case fhscdYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("fhscd is yes");
          break;
        case usYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Unexplained Syncope is Yes");
          break;
        case mlvwtYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("mlvwt is yes");
          break;
        default:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the absence of risk factors, this patient does not have an indication for an  <span class='abbr' title='Implantable Cardioverter Defibrillator'><abbr title='Implantable Cardioverter Defibrillator'>ICD</abbr></span>  (Class 3 – No Benefit)";
          console.log("all no");
          break;
      }
    },
    validateMlvwt: function validateMlvwt() {
      if (this.mlvwt_range.value === "") {
        this.isMlvwtRequired = true;
        this.isMlvwtValidate = false;
      } else if (this.mlvwt_range.value >= this.mlvwt_range.wallThickness.min && this.mlvwt_range.value <= this.mlvwt_range.wallThickness.max) {
        this.isMlvwtValidate = false;
        this.isMlvwtRequired = false;
      } else {
        this.isMlvwtValidate = true;
        this.isMlvwtRequired = false;
      }
    },
    validateLasize: function validateLasize() {
      if (this.lasize_range.value === '') {

        this.isLasizeValidate = false;
        this.isLasizeRequired = true;
      } else if (this.lasize_range.value >= this.lasize_range.laDiameter.min && this.lasize_range.value <= this.lasize_range.laDiameter.max) {
        this.isLasizeValidate = false;
        this.isLasizeRequired = false;
      } else {
        this.isLasizeValidate = true;
        this.isLasizeRequired = false;
      }
    },
    validateMaxlovt: function validateMaxlovt() {
      if (this.maxlvot_range.value === "") {
        this.isMaxlvotRequired = true;
        this.isMaxlovtValidate = false;
      } else if (this.maxlvot_range.value >= this.maxlvot_range.lvotGradient.min && this.maxlvot_range.value <= this.maxlvot_range.lvotGradient.max) {
        this.isMaxlvotRequired = false;
        this.isMaxlovtValidate = false;
      } else {
        this.isMaxlvotRequired = false;
        this.isMaxlovtValidate = true;
      }
    },
    formValidate: function formValidate(e) {

      // if (this.mlvwt_range.value == "") {
      //   this.isMlvwtRequired = true;
      //   console.log("number not entered");
      //   e.preventDefault();
      // } else {
      //   this.isMlvwtRequired = false;
      //   console.log("number entered");
      // }

      // if (this.lasize_range.value == "") {
      //   this.isLasizeRequired = true;
      //   console.log("number not entered");
      //   e.preventDefault();
      // } else {
      //   this.isLasizeRequired = false;
      //   console.log("number  entered");
      // }

      // if (this.maxlvot_range.value == "") {
      //   this.isMaxlvotRequired = true;
      //   console.log("number not entered");
      //   e.preventDefault();
      // } else {
      //   this.isMaxlvotRequired = false;
      //   console.log("number entered");
      // }

      if (this.lasize_range.value === '') {
        console.log('Bharat');
        this.hcmScdCalculatorResultValidatoin = false;
      } else if (this.lasize_range.value > 67 || this.lasize_range.value < 28) {
        console.log('1st satement false');
        this.hcmScdCalculatorResultValidatoin = false;
      } else if (this.maxlvot_range.value === '') {
        this.hcmScdCalculatorResultValidatoin = false;
      } else if (this.maxlvot_range.value > 154 || this.maxlvot_range.value < 2) {
        this.hcmScdCalculatorResultValidatoin = false;
      } else if (this.mlvwt_range.value === '') {
        this.hcmScdCalculatorResultValidatoin = false;
      } else if (this.mlvwt_range.value > 35 || this.mlvwt_range.value < 10) {
        this.hcmScdCalculatorResultValidatoin = false;
      } else {
        this.hcmScdCalculatorResultValidatoin = true;
      }

      if (this.hcmScdCalculatorResultValidatoin) {
        this.validationModal = false;
        this.isShowModal = true;
        this.mainScreen = true;
        this.hcmCalculatorFormula();
      } else {
        this.validationModal = true;
      }
    },
    resetForm: function resetForm() {

      this.mlvwt_range.value = "";
      this.lasize_range.value = "";
      this.maxlvot_range.value = "";
      this.fhscd_pick = 0;
      this.nsvt_pick = 0;
      this.unexSy_pick = 0;
      this.ef50_pick = 0;
      this.apAn_pick = 0;
      this.elge_pick = 0;
      this.risk.value = "";
      this.recommendation = "";
      this.isAgeValidate = false;
      this.isMlvwtValidate = false;
      this.isLasizeValidate = false;
      this.isMaxlovtValidate = false;
      this.isAgeRequired = false;
      this.isMlvwtRequired = false;
      this.isLasizeRequired = false;
      this.isMaxlvotRequired = false;
      this.ageToolTip = true;
      this.mlvwtToolTip = true;
      this.lasizeToolTip = true;
      this.maxlvotToolTip = true;
      this.fhscdToolTip = true;
      this.nsvtToolTip = true;
      this.unexSyToolTip = true;
      this.ef50ToolTip = true;
      this.apAnToolTip = true;
      this.elgeToolTip = true;
    }
  }
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _hcmScdCalculator = __webpack_require__(56);

var _hcmScdCalculator2 = _interopRequireDefault(_hcmScdCalculator);

var _riskKidsPrimacy = __webpack_require__(57);

var _riskKidsPrimacy2 = _interopRequireDefault(_riskKidsPrimacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue';
/* eslint-disable */
var _require = __webpack_require__(79),
    age_oth_spline = _require.age_oth_spline,
    age_scd_spline = _require.age_scd_spline,
    grad_scd_spline = _require.grad_scd_spline,
    la_scd_spline = _require.la_scd_spline,
    lvpwd_scd_spline = _require.lvpwd_scd_spline,
    ivsd_scd_spline = _require.ivsd_scd_spline;

var _require2 = __webpack_require__(80),
    cif_scd = _require2.cif_scd;

var z_functions_1 = __webpack_require__(81);
var genotype_spline_functions_1 = __webpack_require__(82);
var no_genotype_spline_functions_1 = __webpack_require__(83);
var genotype_baseline_hazard_1 = __webpack_require__(84);
var no_genotype_baseline_hazard_1 = __webpack_require__(85);

exports['default'] = {
    components: {
        HcmScdCalculator: _hcmScdCalculator2['default'],
        RiskKidsPrimacy: _riskKidsPrimacy2['default']
    },
    props: {
        hcmRecommendationDescription: {
            type: String,
            required: true
        },
        patientSelectionLabel: {
            type: String,
            required: true
        },
        posteriorLvLabel: {
            type: String,
            required: true
        },
        posteriorLvErrorMessage: {
            type: String,
            required: true
        },
        riskHeaderText: {
            type: String,
            required: true
        },
        resultGuidelineText: {
            type: String,
            required: true
        },
        calculatorVersionText: {
            type: String,
            required: true
        },
        userAgeValue: {
            type: String,
            required: true
        },
        handleFirstScreen: Function,
        heightErrorMessage: {
            type: String,
            required: true
        },
        weightErrorMessage: {
            type: String,
            required: true
        },
        laSizeErrorMessage: {
            type: String,
            required: true
        },
        maxLvotGradientErrorMessage: {
            type: String,
            required: true
        },
        mlvwtErrorMessage: {
            type: String,
            required: true
        },
        isdErrorMessage: {
            type: String,
            required: true
        },
        sexLabel: {
            type: String,
            required: true
        },
        heightLabel: {
            type: String,
            required: true
        },
        weightLabel: {
            type: String,
            required: true
        },
        laSizeLabel: {
            type: String,
            required: true
        },
        maxLvotGradientLabel: {
            type: String,
            required: true
        },
        mlvwtLabel: {
            type: String,
            required: true
        },
        isdLabel: {
            type: String,
            required: true
        },
        gpLabel: {
            type: String,
            required: true
        },
        usLabel: {
            type: String,
            required: true
        },
        nsvtLabel: {
            type: String,
            required: true
        },
        gsLabel: {
            type: String,
            required: true
        },
        efLabel: {
            type: String,
            required: true
        },
        fhscdLabel: {
            type: String,
            required: true
        },
        aaLabel: {
            type: String,
            required: true
        },
        lgeLabel: {
            type: String,
            required: true
        },
        laSizeHelpText: {
            type: String,
            required: true
        },
        maxLvotGradientHelpText: {
            type: String,
            required: true
        },
        mlvwtHelpText: {
            type: String,
            required: true
        },
        isdHelpText: {
            type: String,
            required: true
        },
        gpHelpText: {
            type: String,
            required: true
        },
        usHelpText: {
            type: String,
            required: true
        },
        nsvtHelpText: {
            type: String,
            required: true
        },
        gsHelpText: {
            type: String,
            required: true
        },
        efHelpText: {
            type: String,
            required: true
        },
        fhscdHelpText: {
            type: String,
            required: true
        },
        aaHelpText: {
            type: String,
            required: true
        },
        lgeHelpText: {
            type: String,
            required: true
        },
        hcmRiskKidsScoreLabel: {
            type: String,
            required: true
        },

        hcmRiskKidsScoreDescription: {
            type: String,
            required: true
        },
        primacyRiskScoreLabel: {
            type: String,
            required: true
        },

        primacyRiskScoreDescription: {
            type: String,
            required: true
        },
        lvmwtZScoreLabel: {
            type: String,
            required: true
        },

        lvmwtZScoreDescription: {
            type: String,
            required: true
        },
        laDiameterZScoreLabel: {
            type: String,
            required: true
        },

        laDiameterZScoreDescription: {
            type: String,
            required: true
        },
        hcmScdScoreLabel: {
            type: String,
            required: true
        },

        hcmScdScoreDescription: {
            type: String,
            required: true
        },
        prognosticIndexLabel: {
            type: String,
            required: true
        },

        prognosticIndexDescription: {
            type: String,
            required: true
        },
        errorModalHeaderText: {
            type: String,
            required: true
        },
        errorModalFooterText: {
            type: String,
            required: true
        }

    },

    data: function data() {
        return {
            sex_range: 0,
            isShowModal: false,
            hgt_cm: "",
            wgt_kg: "",
            ivsd_mm: "",
            lvpwd_mm: "",
            la_systole_mm: "",
            peak_grad_mmhg: "",
            hx_nsvt: 0,
            hx_syncope: 0,
            testedStatus: "",
            primacyTotalResult: "",
            RiskKidsTotalResult: "",
            ageValidationError: "",
            heightValidationError: "",
            weightValidationError: "",
            ivsd_mm_validationError: "",
            lvpwd_mm_validationError: "",
            la_systole_mm_validationError: "",
            peak_grad_mmhg_validationError: "",
            isLoading: "",
            ageValidation: false,
            heightValidation: false,
            weightValidation: false,
            ivsd_mm_Validation: false,
            lvpwd_mm_validation: false,
            la_systole_mm_validation: false,
            peak_grad_mmhg_validation: false,
            genoTypePossitive: false,
            genotype_mutation: 0,
            genotype_mutation_yes: 0,
            non_vt: 0,
            un_sy: 0,
            lv_Zz_score: "",
            heightRangeIcon: false,
            weightRangeIcon: false,
            ivsd_mmRangeIcon: false,
            lvpwd_mmRangeIcon: false,
            la_systole_mmRangeIcon: false,
            peak_grad_mmhgRangeIcon: false,
            lv_Zz_scoregRangeIcon: false,
            ladiascoreRangeIcon: false,
            HistoryVentricularRangeIcon: false,
            HistoryUnexplainedRangeIcon: false,
            GenotypestatusRangeIcon: false,
            GenotypepositiveRangeIcon: false,
            nonVtRangeIcon: false,
            UnexplainedSyncopeIcon: false,
            PrognosticTotal: "",
            riskKidsCalculatorResultValidation: false,
            primacyCalculatorResulatValidation: false,
            validationModal: false,
            mainScreen: false,
            posterLVWall: "",
            posterLVWall_validationError: ""
        };
    },

    computed: {
        canShowTotalResult: function canShowTotalResult() {
            return this.ageValidation === false && this.heightValidation === false && this.weightValidation === false && this.ivsd_mm_Validation === false && this.lvpwd_mm_validation === false && this.la_systole_mm_validation === false && this.peak_grad_mmhg_validation === false && this.hgt_cm !== "" && this.wgt_kg !== "" && this.ivsd_mm !== "" && this.lvpwd_mm !== "" && this.la_systole_mm !== "" && this.peak_grad_mmhg !== "";
        }
    },
    methods: {
        handleUpperInput: function handleUpperInput(inputKey) {
            if (inputKey === 'height') {
                this.hgt_cm = this.hgt_cm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'weight') {
                this.wgt_kg = this.wgt_kg.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'ivsd_mm') {
                this.ivsd_mm = this.ivsd_mm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'lvpwd_mm') {
                this.lvpwd_mm = this.lvpwd_mm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'la_systole_mm') {
                this.la_systole_mm = this.la_systole_mm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'peak_grad_mmhg') {
                this.peak_grad_mmhg = this.peak_grad_mmhg.replace(/[^0-9.]/g, "");
            }
        },
        handleBackScreen: function handleBackScreen() {
            this.handleFirstScreen();
        },
        handleReload: function handleReload() {
            window.location.reload();
        },
        handleChange: function handleChange(notTested) {
            if (notTested === "notTested") {
                this.genoTypePossitive = false;
                this.genotype_mutation = 0;
            } else {
                this.genoTypePossitive = true;
                this.totalResult = "";
            }
        },
        bsa_fml: function bsa_fml(w, h) {
            return Math.exp(0.3964 * Math.log(h)) * Math.exp(0.5378 * Math.log(w)) * 0.024265;
        },
        ivsd_z_fml: function ivsd_z_fml(ivsd, bsa) {
            return (ivsd - (0.45686 * Math.pow(bsa, 0.59577) + 0.18722)) / (0.02033 + 0.04698 * bsa);
        },
        lvpwd_z_fml: function lvpwd_z_fml(lvpwd, bsa) {
            return (lvpwd - (0.3767 * Math.pow(bsa, 0.72326) + 0.243)) / (0.0371 + 0.02776 * bsa);
        },
        la_systole_z_fml: function la_systole_z_fml(la, bsa) {
            return (Math.log10(la) - Math.log10(Math.pow(10, 0.81375 * Math.pow(bsa, 0.20444) - 0.43308))) / (0.07447 - 0.01478 * bsa);
        },
        formValidate: function formValidate(e) {
            if (this.wgt_kg === '') {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.wgt_kg > 150 || this.wgt_kg < 2) {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.la_systole_mm === '') {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.la_systole_mm > 80 || this.la_systole_mm < 3) {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.peak_grad_mmhg === '') {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.peak_grad_mmhg > 200 || this.peak_grad_mmhg < 0) {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.lvpwd_mm === '') {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.lvpwd_mm > 70 || this.lvpwd_mm < 4) {
                this.riskKidsCalculatorResultValidation = false;
            } else {
                this.riskKidsCalculatorResultValidation = true;
            }

            ///primacy cal start from here
            if (this.wgt_kg === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.wgt_kg > 150 || this.wgt_kg < 1) {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.hgt_cm === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.hgt_cm > 190 || this.hgt_cm < 25) {

                this.primacyCalculatorResulatValidation = false;
            } else if (this.la_systole_mm === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.la_systole_mm > 55 || this.la_systole_mm < 5) {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.peak_grad_mmhg === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.peak_grad_mmhg > 210 || this.peak_grad_mmhg < 0) {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.ivsd_mm === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.ivsd_mm > 43 || this.ivsd_mm < 0.5) {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.posterLVWall === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.posterLVWall > 60 || this.posterLVWall < 0.5) {
                this.primacyCalculatorResulatValidation = false;
            } else {
                this.primacyCalculatorResulatValidation = true;
            }

            if (this.primacyCalculatorResulatValidation && this.riskKidsCalculatorResultValidation) {
                this.validationModal = false;
                this.isShowModal = true;
                this.mainScreen = true;
                this.calculate_sdc_risk();
            } else {
                this.validationModal = true;
            }
        },
        validationFiled: function validationFiled(val) {
            if (val === 'Height') {
                if (this.hgt_cm > 190 || this.hgt_cm < 25) {
                    this.heightValidationError = this.heightErrorMessage;

                    //   this.primacyCalculatorResulatValidation = false
                } else {

                    this.heightValidation = false;
                    this.heightValidationError = "";
                    //this.primacyCalculatorResulatValidation = true
                }
            }

            if (val === 'weight') {
                if (this.wgt_kg === "") {
                    this.weightValidationError = this.weightErrorMessage;
                } else if (this.wgt_kg < 2 && this.wgt_kg >= 1) {
                    //  this.riskKidsCalculatorResultValidation = false;
                    this.weightValidationError = "Due to value entered, HCM Risk Kids cannot be computed.";
                } else if (this.wgt_kg > 150 || this.wgt_kg < 1) {
                    this.weightValidationError = this.weightErrorMessage;

                    //  this.primacyCalculatorResulatValidation = false
                    //  this.riskKidsCalculatorResultValidation = true;
                } else {
                    this.weightValidationError = "";
                    // this.riskKidsCalculatorResultValidation = true;
                    // this.primacyCalculatorResulatValidation = true
                }
            }

            if (val === "ivsd_mm") {
                if (this.ivsd_mm > 43 || this.ivsd_mm < 0.5) {
                    this.ivsd_mm_validationError = this.isdErrorMessage;

                    //  this.primacyCalculatorResulatValidation = false
                    // this.riskKidsCalculatorResultValidation = true
                } else {
                    this.ivsd_mm_validationError = "";
                    // this.primacyCalculatorResulatValidation = true
                    //  this.riskKidsCalculatorResultValidation = true
                }
            }

            if (val === 'lvpwd_mm') {
                if (this.lvpwd_mm === '') {
                    this.lvpwd_mm_validationError = this.mlvwtErrorMessage;
                }
                //    else  if(this.lvpwd_mm < 4 && this.lvpwd_mm > 0.5) {

                //         this.lvpwd_mm_validationError =
                //         "Due to value entered, HCM Risk Kids cannot be computed.";
                //        // this.riskKidsCalculatorResultValidation = false
                //        // this.primacyCalculatorResulatValidation = true

                //     }
                // else if(this.lvpwd_mm > 60 && this.lvpwd_mm < 70) {
                //     this.lvpwd_mm_validationError =
                //     "Due to value entered, PRIMaCY cannot be computed.";

                // }
                else if (this.lvpwd_mm > 70 || this.lvpwd_mm < 4) {

                        this.lvpwd_mm_validationError = this.mlvwtErrorMessage;
                    } else {
                        this.lvpwd_mm_validationError = "";
                    }

                // if(this.lvpwd_mm > 0.5 || this.lvpwd_mm < 70) {
                //     this.lvpwd_mm_validationError =
                //     this.mlvwtErrorMessage;
                // } else {
                //     this.lvpwd_mm_validationError = ""
                // }

                // if(this.lvpwd_mm > 4 || this.lvpwd_mm < 70) {
                //     this.riskKidsCalculatorResultValidation = true;
                // } else {
                //     this.riskKidsCalculatorResultValidation = false;
                // }

                // if(this.lvpwd_mm > 0.5 || this.lvpwd_mm < 60) {
                //     this.primacyCalculatorResulatValidation = true;
                // } else {
                //     this.primacyCalculatorResulatValidation = false;
                // }
            }

            if (val === "la_systole_mm") {
                if (this.la_systole_mm === '') {
                    this.la_systole_mm_validationError = this.laSizeErrorMessage;
                } else if (this.la_systole_mm < 3 || this.la_systole_mm > 80) {

                    this.la_systole_mm_validationError = this.laSizeErrorMessage;
                } else if (this.la_systole_mm < 5 || this.la_systole_mm > 55) {

                    this.la_systole_mm_validationError = "Due to value entered, PRIMaCY cannot be computed.";
                    // this.primacyCalculatorResulatValidation = false
                    //  this.riskKidsCalculatorResultValidation = true
                } else {
                    this.la_systole_mm_validationError = "";
                    // this.primacyCalculatorResulatValidation = true
                    // this.riskKidsCalculatorResultValidation = true
                }
            }

            if (val === 'peak_grad_mmhg') {
                if (this.peak_grad_mmhg === '') {
                    this.peak_grad_mmhg_validationError = "Max LVOT Gradient must be between 0 and 210 mmHg.";
                    // this.maxLvotGradientErrorMessage;
                } else if (this.peak_grad_mmhg < 0 || this.peak_grad_mmhg > 210) {
                    // console.log ('working')
                    this.peak_grad_mmhg_validationError = "Max LVOT Gradient must be between 0 and 210 mmHg.";
                    //this.maxLvotGradientErrorMessage;

                    //this.primacyCalculatorResulatValidation = false
                } else if (this.peak_grad_mmhg > 200 && this.peak_grad_mmhg < 210) {

                    this.peak_grad_mmhg_validationError = "Due to value entered, HCM Risk Kids cannot be computed.";
                    //  this.riskKidsCalculatorResultValidation = false
                } else {
                    this.peak_grad_mmhg_validationError = "";
                    // this.riskKidsCalculatorResultValidation = true
                    // this.primacyCalculatorResulatValidation = true
                }
            }

            if (val === 'posterLVWall') {
                if (this.posterLVWall === '') {
                    this.posterLVWall_validationError = this.posteriorLvErrorMessage;
                } else if (this.posterLVWall > 60 || this.posterLVWall < 0.5) {

                    this.posterLVWall_validationError = this.posteriorLvErrorMessage;
                } else {
                    this.posterLVWall_validationError = "";
                }
            }
        },
        validationBack: function validationBack() {
            this.validationModal = false;
            this.mainScreen = false;
            this.isShowModal = false;
        },
        calculate_sdc_risk: function calculate_sdc_risk() {

            this.isShowModal = true;
            this.validationModal = false;
            this.mainScreen = true;
            var age_yr = this.userAgeValue;
            var hgt_cm = this.hgt_cm;
            var wgt_kg = this.wgt_kg;
            var ivsd_mm = this.ivsd_mm;
            var lvpwd_mm = this.lvpwd_mm;
            var la_systole_mm = this.la_systole_mm;
            var peak_grad_mmhg = this.peak_grad_mmhg;
            var genotype_mutation = this.genotype_mutation == 0 ? null : this.genotype_mutation_yes === 0 ? false : true;
            // console.log ('this.genotype_mutation', this.genotype_mutation, genotype_mutation)
            var bodySurfaceArea = 0.1023 * Math.pow(this.wgt_kg, 0.68);
            var roundedNumber = parseFloat(bodySurfaceArea.toFixed(8));
            // console.log ('bodySurfaceArea', roundedNumber)
            var convertCMMM = this.lvpwd_mm / 10;
            // console.log('convertCMMM', convertCMMM)
            var LVMWTZ = (convertCMMM / Math.pow(bodySurfaceArea, 0.4) - 0.58) / 0.09;
            // console.log('LVMWTZ', LVMWTZ)
            this.lv_Zz_score = parseFloat(LVMWTZ.toFixed(9));
            // console.log('this.lv_Zz_score', this.lv_Zz_score)
            // console.log ('this.sex_range', this.sex_range)
            var laDiameterZScore = this.sex_range == "0" ? (la_systole_mm / (10.665 * Math.pow(this.wgt_kg, 0.255)) - 1) / 0.118 : (la_systole_mm / (10.74 * Math.pow(this.wgt_kg, 0.246)) - 1) / 0.124;
            var sexRangeValue = parseFloat(laDiameterZScore.toFixed(9));
            // console.log('laDiameterZScore', laDiameterZScore)
            this.la_dia_score = sexRangeValue;
            var firstStep = 0.2171364 * (parseFloat(LVMWTZ.toFixed(9)) - 11.09) - 0.0047562 * (Math.pow(parseFloat(LVMWTZ.toFixed(9)), 2) - 174.12);
            // console.log('firstStep', firstStep)
            var secondStep = +0.130365 * (sexRangeValue - 1.92);
            // console.log ('secondStep', secondStep)
            var thirdStep = -0.0065555 * (this.peak_grad_mmhg - 21.8);
            // console.log ('thirdStep', thirdStep)
            var fourthStep = +0.1861694 * this.non_vt;
            //console.log ('fourthStep', fourthStep , 'hx_nsvt', hx_nsvt)
            var fifthStep = +0.429624 * this.un_sy;
            // console.log ('fifthStep', fifthStep)
            // console.log ('this.peak_grad_mmhg', this.peak_grad_mmhg)
            var PrognosticTotal = 0.2171364 * (parseFloat(LVMWTZ.toFixed(9)) - 11.09) - 0.0047562 * (Math.pow(parseFloat(LVMWTZ.toFixed(9)), 2) - 174.12) + 0.130365 * (sexRangeValue - 1.92) - 0.0065555 * (this.peak_grad_mmhg - 21.8) + 0.1861694 * this.non_vt + 0.429624 * this.un_sy;
            // parseFloat(secondStep.toFixed(9)) + 
            // parseFloat(thirdStep.toFixed(9)) + 
            // fourthStep + 
            // fifthStep;
            var totalPrognosticTotal = parseFloat(PrognosticTotal.toFixed(9));
            //    console.log('totalPrognosticTotal', totalPrognosticTotal)
            this.PrognosticTotal = totalPrognosticTotal;
            var base = 0.949437808;
            var powerResult = Math.pow(base, Math.exp(PrognosticTotal));
            this.RiskKidsTotalResult = ((1 - powerResult) * 100).toFixed(2) + '%';
            // console.log ('RiskKidsTotalResult', this.RiskKidsTotalResult)
            var ivsd_scd_spline = void 0;
            var lvpwd_scd_spline = void 0;
            var la_scd_spline = void 0;
            var grad_scd_spline = void 0;
            var age_scd_spline = void 0;
            var nsvt_scd_spline = void 0;
            var syncope_scd_spline = void 0;
            var gene_scd_spline = void 0;
            var age_oth_spline = void 0;
            var cif_obj = void 0;
            var prog_idx_scd_calib_factor = void 0;
            var prog_idx_oth_calib_factor = void 0;
            if (genotype_mutation == null) {
                ivsd_scd_spline = no_genotype_spline_functions_1.no_genotype_ivsd_scd_spline;
                lvpwd_scd_spline = no_genotype_spline_functions_1.no_genotype_lvpwd_scd_spline;
                la_scd_spline = no_genotype_spline_functions_1.no_genotype_la_scd_spline;
                grad_scd_spline = no_genotype_spline_functions_1.no_genotype_grad_scd_spline;
                age_scd_spline = no_genotype_spline_functions_1.no_genotype_age_scd_spline;
                nsvt_scd_spline = no_genotype_spline_functions_1.no_genotype_nsvt_scd_spline;
                syncope_scd_spline = no_genotype_spline_functions_1.no_genotype_syncope_scd_spline;
                gene_scd_spline = no_genotype_spline_functions_1.no_genotype_genotype_scd_spline;
                age_oth_spline = no_genotype_spline_functions_1.no_genotype_age_oth_spline;
                cif_obj = no_genotype_baseline_hazard_1.no_genotype_cif_scd;
                prog_idx_scd_calib_factor = 1.30563989776015;
                prog_idx_oth_calib_factor = 5.84865347533236;
            } else {
                ivsd_scd_spline = genotype_spline_functions_1.genotype_ivsd_scd_spline;
                lvpwd_scd_spline = genotype_spline_functions_1.genotype_lvpwd_scd_spline;
                la_scd_spline = genotype_spline_functions_1.genotype_la_scd_spline;
                grad_scd_spline = genotype_spline_functions_1.genotype_grad_scd_spline;
                age_scd_spline = genotype_spline_functions_1.genotype_age_scd_spline;
                nsvt_scd_spline = genotype_spline_functions_1.genotype_nsvt_scd_spline;
                syncope_scd_spline = genotype_spline_functions_1.genotype_syncope_scd_spline;
                gene_scd_spline = genotype_spline_functions_1.genotype_genotype_scd_spline;
                age_oth_spline = genotype_spline_functions_1.genotype_age_oth_spline;
                cif_obj = genotype_baseline_hazard_1.genotype_cif_scd;
                prog_idx_scd_calib_factor = 1.352992544571569;
                prog_idx_oth_calib_factor = 5.84865347533236;
            }
            var age_idx = age_yr;
            var bsa = (0, z_functions_1.bsa_fml)(wgt_kg, hgt_cm);
            var ivsd_z_calc = (0, z_functions_1.ivsd_z_fml)(ivsd_mm / 10, bsa);
            console.log('posterLVWall', posterLVWall);
            var lvpwd_z_calc = (0, z_functions_1.lvpwd_z_fml)(this.posterLVWall / 10, bsa);
            var la_z_calc = (0, z_functions_1.la_systole_z_fml)(la_systole_mm / 10, bsa);
            var peak_grad_first_echo = peak_grad_mmhg;

            if (this.non_vt == 1) {
                var non_sustained_vt = 1;
            } else {
                var non_sustained_vt = 0;
            }
            if (this.un_sy == 1) {
                var history_syncope = 1;
            } else {
                var history_syncope = 0;
            }
            var prog_idx_scd_uncal = ivsd_scd_spline(ivsd_z_calc) + lvpwd_scd_spline(lvpwd_z_calc) + la_scd_spline(la_z_calc) + grad_scd_spline(peak_grad_first_echo) + age_scd_spline(age_idx) + nsvt_scd_spline(non_sustained_vt) + syncope_scd_spline(history_syncope) + gene_scd_spline(genotype_mutation);
            var prog_idx_oth_uncal = age_oth_spline(age_idx);
            var prog_idx_scd = prog_idx_scd_calib_factor * prog_idx_scd_uncal;
            var prog_idx_oth = prog_idx_oth_calib_factor * prog_idx_oth_uncal;
            var prevBaseCumHazSCD = 0;
            var prevBaseCumHazOth = 0;
            var prevPrevBaseCumHazSCD = 0;
            var prevPrevBaseCumHazOth = 0;
            var cumulativeProdSurvPrev = 1;
            var cumulativeSumCIFSCD = 0;
            var cif_result = [];
            cif_obj.forEach(function (entry) {
                entry.hazard_scd = entry.cumhaz0_scd * Math.exp(prog_idx_scd) - prevBaseCumHazSCD * Math.exp(prog_idx_scd);
                if (entry.day_prev_evt == 0) {
                    entry.hazard_ttl = 0;
                } else {
                    entry.hazard_ttl = prevBaseCumHazSCD * Math.exp(prog_idx_scd) + prevBaseCumHazOth * Math.exp(prog_idx_oth) - (prevPrevBaseCumHazSCD * Math.exp(prog_idx_scd) + prevPrevBaseCumHazOth * Math.exp(prog_idx_oth));
                }
                prevPrevBaseCumHazSCD = prevBaseCumHazSCD;
                prevPrevBaseCumHazOth = prevBaseCumHazOth;
                prevBaseCumHazSCD = entry.cumhaz0_scd;
                prevBaseCumHazOth = entry.cumhaz0_oth;
                entry.one_minus_hazard_ttl = 1 - entry.hazard_ttl;
                cumulativeProdSurvPrev *= entry.one_minus_hazard_ttl;
                entry.surv_prev = cumulativeProdSurvPrev;
                cumulativeSumCIFSCD += entry.hazard_scd * entry.surv_prev;
                entry.cif_scd = cumulativeSumCIFSCD;
                cif_result.push(entry);
            });
            this.primacyTotalResult = (cif_result[cif_result.length - 1]['cif_scd'] * 100).toFixed(2) + "%";
            console.log('primacyTotalResult', this.primacyTotalResult);
            return cif_result[cif_result.length - 1]['cif_scd'];
        },
        handleIconValidatoin: function handleIconValidatoin(val) {
            if (val === 'height') {
                this.heightRangeIcon = !this.heightRangeIcon;
            }

            if (val === 'weight') {
                this.weightRangeIcon = !this.weightRangeIcon;
            }

            if (val === 'ivsd_mm') {
                this.ivsd_mmRangeIcon = !this.ivsd_mmRangeIcon;
            }

            if (val === "lvpwd_mm") {
                this.lvpwd_mmRangeIcon = !this.lvpwd_mmRangeIcon;
            }

            if (val === 'la_systole_mm') {
                this.la_systole_mmRangeIcon = !this.la_systole_mmRangeIcon;
            }

            if (val === "peak_grad_mmhg") {
                this.peak_grad_mmhgRangeIcon = !this.peak_grad_mmhgRangeIcon;
            }

            if (val === "lv_Zz_score") {
                this.lv_Zz_scoregRangeIcon = !this.lv_Zz_scoregRangeIcon;
            }

            if (val === "la_dia_score") {
                this.ladiascoreRangeIcon = !this.ladiascoreRangeIcon;
            }

            if (val === "HistoryVentricular") {
                this.HistoryVentricularRangeIcon = !this.HistoryVentricularRangeIcon;
            }

            if (val === "HistoryUnexplained") {
                this.HistoryUnexplainedRangeIcon = !this.HistoryUnexplainedRangeIcon;
            }

            if (val === "Genotypestatus") {
                this.GenotypestatusRangeIcon = !this.GenotypestatusRangeIcon;
            }

            if (val === "Genotypepositive") {
                this.GenotypepositiveRangeIcon = !this.GenotypepositiveRangeIcon;
            }

            if (val === "nonVt") {
                this.nonVtRangeIcon = !this.nonVtRangeIcon;
            }

            if (val === "UnexplainedSyncope") {
                this.UnexplainedSyncopeIcon = !this.UnexplainedSyncopeIcon;
            }
        },
        resetForm: function resetForm() {
            this.posterLVWall = "";
            this.sex_range = 0;
            this.hgt_cm = "";
            this.wgt_kg = "";
            this.ivsd_mm = "";
            this.lvpwd_mm = "";
            this.la_systole_mm = "";
            this.peak_grad_mmhg = "";
            this.hx_nsvt = 0;
            this.hx_syncope = 0;
            this.testedStatus = "";
            this.totalResult = "";
            this.ageValidationError = "";
            this.heightValidationError = "";
            this.weightValidationError = "";
            this.ivsd_mm_validationError = "";
            this.lvpwd_mm_validationError = "";
            this.la_systole_mm_validationError = "";
            this.peak_grad_mmhg_validationError = "";
            this.isLoading = "";
            this.isShowModal = false;
            this.ageValidation = false;
            this.heightValidation = false;
            this.weightValidation = false;
            this.ivsd_mm_Validation = false;
            this.lvpwd_mm_validation = false;
            this.la_systole_mm_validation = false;
            this.peak_grad_mmhg_validation = false;
            this.genoTypePossitive = false;
            this.genotype_mutation = 0;
            this.genotype_mutation_yes = 0;
            this.non_vt = 0;
            this.un_sy = 0;
            this.lv_Zz_score = "";
            this.heightRangeIcon = false;
            this.weightRangeIcon = false;
            this.ivsd_mmRangeIcon = false;
            this.lvpwd_mmRangeIcon = false;
            this.la_systole_mmRangeIcon = false;
            this.peak_grad_mmhgRangeIcon = false;
            this.lv_Zz_scoregRangeIcon = false;
            this.ladiascoreRangeIcon = false;
            this.HistoryVentricularRangeIcon = false;
            this.HistoryUnexplainedRangeIcon = false;
            this.GenotypestatusRangeIcon = false;
            this.GenotypepositiveRangeIcon = false;
            this.nonVtRangeIcon = false;
            this.UnexplainedSyncopeIcon = false;
            this.validationModal = false;
            this.mainScreen = false;
        }
    },
    mounted: function mounted() {
        //this.EventBus.$emit('stepTrigger', '3');
        //console.log('children', this.$root.$children);// dont work, app as a child

        //console.log('child ',this.$children.find(child => { return child.$options.name === "aha-modal"; }))
        //console.log('Quiz',this.$refs['Quiz']);
        //console.log('Quiz Modal',this.$root);
        //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 3); // Works
        this.$root.$on("bv::modal::hidden", function ($event) {
            //console.log('evt', $event);
            //this.$root.EventBus.$emit('stepTrigger', '1');
            //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 1);
        });
    },

    watch: {
        hx_nsvt: function hx_nsvt(newVal, oldVal) {
            if (oldVal === 0) {
                this.hx_nsvt = 1;
                console.log("this.hx_nsvt", this.hx_nsvt);
            } else if (oldVal === 1) {
                this.hx_nsvt = 0;
            }
        },
        hx_syncope: function hx_syncope(newVal, oldVal) {
            if (oldVal === 0) {
                this.hx_syncope = 1;
                console.log("this.hx_syncope", this.hx_syncope);
            } else {
                this.hx_syncope - 0;
            }
        }
    }
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _methods;

var _hcmScdCalculator = __webpack_require__(56);

var _hcmScdCalculator2 = _interopRequireDefault(_hcmScdCalculator);

var _riskKidsPrimacy = __webpack_require__(57);

var _riskKidsPrimacy2 = _interopRequireDefault(_riskKidsPrimacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue';
/* eslint-disable */


var _require = __webpack_require__(79),
    age_oth_spline = _require.age_oth_spline,
    age_scd_spline = _require.age_scd_spline,
    grad_scd_spline = _require.grad_scd_spline,
    la_scd_spline = _require.la_scd_spline,
    lvpwd_scd_spline = _require.lvpwd_scd_spline,
    ivsd_scd_spline = _require.ivsd_scd_spline;

var _require2 = __webpack_require__(80),
    cif_scd = _require2.cif_scd;

var z_functions_1 = __webpack_require__(81);
var genotype_spline_functions_1 = __webpack_require__(82);
var no_genotype_spline_functions_1 = __webpack_require__(83);
var genotype_baseline_hazard_1 = __webpack_require__(84);
var no_genotype_baseline_hazard_1 = __webpack_require__(85);

exports['default'] = {
    components: {
        HcmScdCalculator: _hcmScdCalculator2['default'],
        RiskKidsPrimacy: _riskKidsPrimacy2['default']
    },
    props: {
        hcmRecommendationDescription: {
            type: String,
            required: true
        },
        patientSelectionLabel: {
            type: String,
            required: true
        },
        riskHeaderText: {
            type: String,
            required: true
        },
        resultGuidelineTextSixteen: {
            type: String,
            required: true
        },
        calculatorVersionText: {
            type: String,
            required: true
        },
        hcmScdRecommendationLabel: {
            type: String,
            required: true
        },
        hcmScdRecommendationDescription: {
            type: String,
            required: true
        },
        userAgeValue: {
            type: String,
            required: true
        },
        //Error message

        ageIf80ErrorMessage: {
            type: String,
            required: true
        },
        heightErrorMessage: {
            type: String,
            required: true
        },
        weightErrorMessage: {
            type: String,
            required: true
        },
        laSizeErrorMessage: {
            type: String,
            required: true
        },
        maxLvotGradientErrorMessage: {
            type: String,
            required: true
        },
        mlvwtErrorMessage: {
            type: String,
            required: true
        },
        isdErrorMessage: {
            type: String,
            required: true
        },
        //labels
        sexLabel: {
            type: String,
            required: true
        },
        heightLabel: {
            type: String,
            required: true
        },
        weightLabel: {
            type: String,
            required: true
        },
        laSizeLabel: {
            type: String,
            required: true
        },
        maxLvotGradientLabel: {
            type: String,
            required: true
        },
        mlvwtLabel: {
            type: String,
            required: true
        },
        isdLabel: {
            type: String,
            required: true
        },
        gpLabel: {
            type: String,
            required: true
        },
        usLabel: {
            type: String,
            required: true
        },
        nsvtLabel: {
            type: String,
            required: true
        },
        gsLabel: {
            type: String,
            required: true
        },
        efLabel: {
            type: String,
            required: true
        },
        fhscdLabel: {
            type: String,
            required: true
        },
        aaLabel: {
            type: String,
            required: true
        },
        lgeLabel: {
            type: String,
            required: true
        },
        //help text
        laSizeHelpText: {
            type: String,
            required: true
        },
        maxLvotGradientHelpText: {
            type: String,
            required: true
        },
        mlvwtHelpText: {
            type: String,
            required: true
        },
        isdHelpText: {
            type: String,
            required: true
        },
        gpHelpText: {
            type: String,
            required: true
        },
        usHelpText: {
            type: String,
            required: true
        },
        nsvtHelpText: {
            type: String,
            required: true
        },
        gsHelpText: {
            type: String,
            required: true
        },
        efHelpText: {
            type: String,
            required: true
        },
        fhscdHelpText: {
            type: String,
            required: true
        },
        aaHelpText: {
            type: String,
            required: true
        },
        lgeHelpText: {
            type: String,
            required: true
        },
        handleSecondScree: Function,
        hcmRiskKidsScoreLabel: {
            type: String,
            required: true
        },

        hcmRiskKidsScoreDescription: {
            type: String,
            required: true
        },
        primacyRiskScoreLabel: {
            type: String,
            required: true
        },

        primacyRiskScoreDescription: {
            type: String,
            required: true
        },
        lvmwtZScoreLabel: {
            type: String,
            required: true
        },

        lvmwtZScoreDescription: {
            type: String,
            required: true
        },
        laDiameterZScoreLabel: {
            type: String,
            required: true
        },

        laDiameterZScoreDescription: {
            type: String,
            required: true
        },
        hcmScdScoreLabel: {
            type: String,
            required: true
        },

        hcmScdScoreDescription: {
            type: String,
            required: true
        },
        prognosticIndexLabel: {
            type: String,
            required: true
        },

        prognosticIndexDescription: {
            type: String,
            required: true
        },
        errorModalHeaderText: {
            type: String,
            required: true
        },
        errorModalFooterText: {
            type: String,
            required: true
        }
    },

    data: function data() {
        var _ref;

        return _ref = {
            sex_range: 0,
            isShowModal: false,
            hgt_cm: "",
            wgt_kg: "",
            ivsd_mm: "",
            lvpwd_mm: "",
            la_systole_mm: "",
            peak_grad_mmhg: "",
            hx_nsvt: 0,
            hx_syncope: 0,
            testedStatus: "",
            primacyTotalResult: "",
            RiskKidsTotalResult: "",
            ageValidationError: "",
            heightValidationError: "",
            weightValidationError: "",
            ivsd_mm_validationError: "",
            lvpwd_mm_validationError: "",
            la_systole_mm_validationError: "",
            peak_grad_mmhg_validationError: "",
            isLoading: "",
            ageValidation: false,
            heightValidation: false,
            weightValidation: false,
            ivsd_mm_Validation: false,
            lvpwd_mm_validation: false,
            la_systole_mm_validation: false,
            peak_grad_mmhg_validation: false,
            genoTypePossitive: false,
            genotype_mutation: 0,
            genotype_mutation_yes: 0,
            non_vt: 0,
            un_sy: 0,
            lv_Zz_score: "",
            heightRangeIcon: false,
            weightRangeIcon: false,
            ivsd_mmRangeIcon: false,
            lvpwd_mmRangeIcon: false,
            la_systole_mmRangeIcon: false,
            peak_grad_mmhgRangeIcon: false,
            lv_Zz_scoregRangeIcon: false,
            ladiascoreRangeIcon: false,
            HistoryVentricularRangeIcon: false,
            HistoryUnexplainedRangeIcon: false,
            GenotypestatusRangeIcon: false,
            GenotypepositiveRangeIcon: false,
            nonVtRangeIcon: false,
            UnexplainedSyncopeIcon: false,
            fhscd_pick: 0,
            nsvt_pick: 0,
            ef50_pick: 0,
            apAn_pick: 0,
            risk: {
                value: ""
            }
        }, _defineProperty(_ref, 'RiskKidsTotalResult', ""), _defineProperty(_ref, 'PrognosticTotal', ""), _defineProperty(_ref, 'la_dia_score', ""), _defineProperty(_ref, 'recommendation', ""), _defineProperty(_ref, 'fhscdIcon', false), _defineProperty(_ref, 'nsvtLabelRangeIcon', false), _defineProperty(_ref, 'efLabelRangeIcon', false), _defineProperty(_ref, 'aaLabelRangeIcon', false), _defineProperty(_ref, 'elge_pick', 0), _defineProperty(_ref, 'lgeLabelRangeIcon', false), _defineProperty(_ref, 'riskKidsCalculatorResultValidation', false), _defineProperty(_ref, 'primacyCalculatorResulatValidation', false), _defineProperty(_ref, 'hcmScdCalculatorResultValidatoin', false), _defineProperty(_ref, 'validationModal', false), _defineProperty(_ref, 'mainScreen', false), _ref;
    },

    computed: {
        canShowTotalResult: function canShowTotalResult() {
            return this.ageValidation === false && this.heightValidation === false && this.weightValidation === false && this.ivsd_mm_Validation === false && this.lvpwd_mm_validation === false && this.la_systole_mm_validation === false && this.peak_grad_mmhg_validation === false && this.hgt_cm !== "" && this.wgt_kg !== "" && this.ivsd_mm !== "" && this.lvpwd_mm !== "" && this.la_systole_mm !== "" && this.peak_grad_mmhg !== "";
        }
    },
    methods: (_methods = {
        handleUpperInput: function handleUpperInput(inputKey) {
            if (inputKey === 'height') {
                this.hgt_cm = this.hgt_cm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'weight') {
                this.wgt_kg = this.wgt_kg.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'ivsd_mm') {
                this.ivsd_mm = this.ivsd_mm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'lvpwd_mm') {
                this.lvpwd_mm = this.lvpwd_mm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'la_systole_mm') {
                this.la_systole_mm = this.la_systole_mm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'peak_grad_mmhg') {
                this.peak_grad_mmhg = this.peak_grad_mmhg.replace(/[^0-9.]/g, "");
            }
        },
        handleBackScreen: function handleBackScreen() {
            this.handleSecondScree();
        },
        handleReload: function handleReload() {
            window.location.reload();
        },
        handleChange: function handleChange(notTested) {

            if (notTested === "notTested") {
                this.genoTypePossitive = false;
                this.genotype_mutation = 0;
            } else {
                this.genoTypePossitive = true;
                this.totalResult = "";
            }
        },
        validationBack: function validationBack() {
            this.validationModal = false;
            this.mainScreen = false;
            this.isShowModal = false;
        },
        bsa_fml: function bsa_fml(w, h) {
            return Math.exp(0.3964 * Math.log(h)) * Math.exp(0.5378 * Math.log(w)) * 0.024265;
        },
        ivsd_z_fml: function ivsd_z_fml(ivsd, bsa) {
            return (ivsd - (0.45686 * Math.pow(bsa, 0.59577) + 0.18722)) / (0.02033 + 0.04698 * bsa);
        },
        lvpwd_z_fml: function lvpwd_z_fml(lvpwd, bsa) {
            return (lvpwd - (0.3767 * Math.pow(bsa, 0.72326) + 0.243)) / (0.0371 + 0.02776 * bsa);
        },
        la_systole_z_fml: function la_systole_z_fml(la, bsa) {
            return (Math.log10(la) - Math.log10(Math.pow(10, 0.81375 * Math.pow(bsa, 0.20444) - 0.43308))) / (0.07447 - 0.01478 * bsa);
        },
        formValidate: function formValidate(e) {
            if (this.wgt_kg === '') {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.wgt_kg > 150 || this.wgt_kg < 2) {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.la_systole_mm === '') {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.la_systole_mm > 80 || this.la_systole_mm < 3) {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.peak_grad_mmhg === '') {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.peak_grad_mmhg > 200 || this.peak_grad_mmhg < 0) {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.lvpwd_mm === '') {
                this.riskKidsCalculatorResultValidation = false;
            } else if (this.lvpwd_mm > 70 || this.lvpwd_mm < 4) {
                this.riskKidsCalculatorResultValidation = false;
            } else {
                this.riskKidsCalculatorResultValidation = true;
            }

            ///primacy cal start from here
            // if (this.wgt_kg === '') {
            //     this.primacyCalculatorResulatValidation = false
            // } else if (this.wgt_kg > 150 || this.wgt_kg < 1) {
            //     this.primacyCalculatorResulatValidation = false
            // }

            // else if (this.hgt_cm === '') {
            //     this.primacyCalculatorResulatValidation = false
            // } else if (this.hgt_cm > 190 || this.hgt_cm < 25) {

            //     this.primacyCalculatorResulatValidation = false
            // }

            // else if (this.la_systole_mm === '') {
            //     this.primacyCalculatorResulatValidation = false
            // } else if (this.la_systole_mm > 55 || this.la_systole_mm < 5) {
            //     this.primacyCalculatorResulatValidation = false
            // }

            // else if (this.peak_grad_mmhg === '') {
            //     this.primacyCalculatorResulatValidation = false
            // } else if (this.peak_grad_mmhg > 200 || this.peak_grad_mmhg < 0) {
            //     this.primacyCalculatorResulatValidation = false
            // }

            // else if (this.lvpwd_mm === '') {
            //     this.primacyCalculatorResulatValidation = false
            // } else if (this.lvpwd_mm > 60 || this.lvpwd_mm < 0.5) {
            //     this.primacyCalculatorResulatValidation = false
            // }

            // else if (this.ivsd_mm === '') {
            //     this.primacyCalculatorResulatValidation = false
            // } else if (this.ivsd_mm > 43 || this.ivsd_mm < 0.5) {
            //     this.primacyCalculatorResulatValidation = false
            // } else {
            //     this.primacyCalculatorResulatValidation = true
            // }

            //HCM SCD CAL
            if (this.la_systole_mm === '') {
                this.hcmScdCalculatorResultValidatoin = false;
            } else if (this.la_systole_mm > 67 || this.la_systole_mm < 28) {
                this.hcmScdCalculatorResultValidatoin = false;
                console.log('1208');
            } else if (this.peak_grad_mmhg === '') {
                this.hcmScdCalculatorResultValidatoin = false;
            } else if (this.peak_grad_mmhg > 154 || this.peak_grad_mmhg < 2) {
                this.hcmScdCalculatorResultValidatoin = false;
                console.log('1215');
            } else if (this.lvpwd_mm > 35 || this.lvpwd_mm < 10) {
                this.hcmScdCalculatorResultValidatoin = false;
            } else if (this.lvpwd_mm === '') {
                this.hcmScdCalculatorResultValidatoin = false;
            } else {
                this.hcmScdCalculatorResultValidatoin = true;
            }

            if (this.riskKidsCalculatorResultValidation && this.hcmScdCalculatorResultValidatoin) {

                this.validationModal = false;
                this.isShowModal = true;
                this.mainScreen = true;
                this.calculate_sdc_risk();
            } else {

                this.validationModal = true;
            }
        },
        validationFiled: function validationFiled(val) {
            if (val === 'Height') {
                if (this.hgt_cm === "") {
                    this.heightValidationError = this.heightErrorMessage;
                } else if (this.hgt_cm > 190 || this.hgt_cm < 25) {
                    this.heightValidationError = this.heightErrorMessage;
                    this.heightValidation = true;
                } else {
                    this.heightValidation = false;
                    this.heightValidationError = "";
                }
            }

            if (val === 'weight') {
                if (this.wgt_kg == "") {
                    this.weightValidationError = "Weight must be between 2 and 150 kg.";
                }
                // else if (this.wgt_kg < 2 && this.wgt_kg >= 1) {
                //     this.weightValidationError =
                //         "Due to value entered, HCM Risk Kids cannot be computed.";

                // } 
                else if (this.wgt_kg > 150 || this.wgt_kg < 2) {
                        this.weightValidationError = "Weight must be between 2 and 150 kg.";
                    } else {
                        this.weightValidationError = "";
                    }
            }

            if (val === "ivsd_mm") {
                if (this.ivsd_mm > 43 || this.ivsd_mm < 0.5) {
                    this.ivsd_mm_validationError = this.isdErrorMessage;
                    console.log('workdsf');
                } else {
                    this.ivsd_mm_validationError = "";
                }
            }

            if (val === 'lvpwd_mm') {
                if (this.lvpwd_mm === "") {
                    this.lvpwd_mm_validationError = this.mlvwtErrorMessage;
                    //     "Interventricular septal diameter (mm) is missing.";
                    this.weightValidation = false;
                } else if (this.lvpwd_mm > 70 || this.lvpwd_mm < 4) {
                    this.lvpwd_mm_validationError = this.mlvwtErrorMessage;
                    console.log('working');
                }
                // else if (this.lvpwd_mm < 4 && this.lvpwd_mm > 0.5) {
                //     this.lvpwd_mm_validationError =
                //         "Due to value entered, HCM Risk Kids cannot be computed.";

                // } 
                else if (this.lvpwd_mm > 35 || this.lvpwd_mm < 10) {

                        this.lvpwd_mm_validationError = "Due to value entered, HCM SCD cannot be computed";
                    }
                    // else if (this.lvpwd_mm > 60) {
                    //     this.lvpwd_mm_validationError =
                    //         "Due to value entered, PRIMaCY cannot be computed.";

                    // } 
                    else {
                            this.lvpwd_mm_validationError = "";
                        }
            }

            if (val === "la_systole_mm") {
                if (this.la_systole_mm == "") {
                    this.la_systole_mm_validationError = this.laSizeErrorMessage;
                } else if (this.la_systole_mm > 80 || this.la_systole_mm < 3) {

                    this.la_systole_mm_validationError = this.laSizeErrorMessage;
                }
                // else if (this.la_systole_mm < 5 || (this.la_systole_mm > 55 && this.la_systole_mm < 67)) {
                //     this.la_systole_mm_validationError = ""
                //        // "Due to value entered, PRIMaCY cannot be computed.";
                //    // this.primacyCalculatorResulatValidation = true
                // } 
                else if (this.la_systole_mm < 28 || this.la_systole_mm > 67) {
                        this.la_systole_mm_validationError = "Due to value entered, HCM SCD cannot be computed";
                        // this.primacyCalculatorResulatValidation = false
                        // this.hcmScdCalculatorResultValidatoin = true
                    }
                    //  else if (this.la_systole_mm > 55) {
                    //     this.la_systole_mm_validationError = ""
                    //        "Due to value entered, PRIMaCY cannot be computed.";
                    //      this.primacyCalculatorResulatValidation = true
                    // }  
                    else {
                            this.la_systole_mm_validationError = "";
                            // this.primacyCalculatorResulatValidation = false
                            // this.hcmScdCalculatorResultValidatoin = false
                        }
            }

            if (val === 'peak_grad_mmhg') {
                if (this.peak_grad_mmhg === "") {
                    this.peak_grad_mmhg_validationError = this.maxLvotGradientErrorMessage;
                } else if (this.peak_grad_mmhg < 0 || this.peak_grad_mmhg > 200) {

                    this.peak_grad_mmhg_validationError = this.maxLvotGradientErrorMessage;
                    // this.maxLvotGradientErrorMessage;
                    //this.primacyCalculatorResulatValidation = false
                }
                // else if (this.peak_grad_mmhg > 200) {
                //     this.peak_grad_mmhg_validationError = "Due to value entered, HCM Risk Kids cannot be computed."
                //      this.riskKidsCalculatorResultValidation = true
                //      this.primacyCalculatorResulatValidation = false
                // }
                else if (this.peak_grad_mmhg > 154 || this.peak_grad_mmhg < 2) {
                        this.peak_grad_mmhg_validationError = "Due to value entered, HCM SCD cannot be computed.";
                        // this.riskKidsCalculatorResultValidation = false
                        //  this.primacyCalculatorResulatValidation = true
                    }
                    // else if (this.peak_grad_mmhg < 0 && peak_grad_mmhg > 210) {

                    //     this.peak_grad_mmhg_validationError =
                    //         "Peak LV outflow tract gradient must be between 0 and 210 mmHg.";

                    // }
                    else {
                            this.peak_grad_mmhg_validationError = "";
                            //this.riskKidsCalculatorResultValidation = false
                            //this.primacyCalculatorResulatValidation = false
                        }
            }
        },
        calculate_sdc_risk: function calculate_sdc_risk() {
            this.isShowModal = true;
            this.validationModal = false;
            this.mainScreen = true;
            var age_yr = this.userAgeValue;
            var hgt_cm = this.hgt_cm;
            var wgt_kg = this.wgt_kg;
            var ivsd_mm = this.ivsd_mm;
            var lvpwd_mm = this.lvpwd_mm;
            var la_systole_mm = this.la_systole_mm;
            var peak_grad_mmhg = this.peak_grad_mmhg;
            var hx_nsvt = this.hx_nsvt;
            var hx_syncope = this.hx_syncope;
            var testedStatus = this.testedStatus;
            var genotype_mutation = this.genotype_mutation == 0 ? null : this.genotype_mutation_yes === 0 ? false : true;
            // console.log('this.genotype_mutation', this.genotype_mutation, genotype_mutation)
            var bodySurfaceArea = 0.1023 * Math.pow(this.wgt_kg, 0.68);
            var roundedNumber = parseFloat(bodySurfaceArea.toFixed(8));
            // console.log('bodySurfaceArea', roundedNumber)

            var convertCMMM = this.lvpwd_mm / 10;
            // console.log('convertCMMM', convertCMMM)
            var LVMWTZ = (convertCMMM / Math.pow(bodySurfaceArea, 0.4) - 0.58) / 0.09;
            // console.log('LVMWTZ', LVMWTZ)
            this.lv_Zz_score = parseFloat(LVMWTZ.toFixed(9));
            // console.log('this.lv_Zz_score', this.lv_Zz_score)
            // console.log('this.sex_range', this.sex_range)
            var laDiameterZScore = this.sex_range == "0" ? (la_systole_mm / (10.665 * Math.pow(this.wgt_kg, 0.255)) - 1) / 0.118 : (la_systole_mm / (10.74 * Math.pow(this.wgt_kg, 0.246)) - 1) / 0.124;
            var sexRangeValue = parseFloat(laDiameterZScore.toFixed(9));
            // console.log('laDiameterZScore', laDiameterZScore)
            this.la_dia_score = sexRangeValue;

            var firstStep = 0.2171364 * (parseFloat(LVMWTZ.toFixed(9)) - 11.09) - 0.0047562 * (Math.pow(parseFloat(LVMWTZ.toFixed(9)), 2) - 174.12);
            // console.log('firstStep', firstStep)
            var secondStep = +0.130365 * (sexRangeValue - 1.92);
            // console.log('secondStep', secondStep)
            var thirdStep = -0.0065555 * (this.peak_grad_mmhg - 21.8);
            // console.log('thirdStep', thirdStep)
            var fourthStep = +0.1861694 * this.nsvt_pick;
            // console.log('fourthStep', fourthStep)
            var fifthStep = +0.429624 * this.un_sy;
            // console.log('fifthStep', fifthStep)
            // console.log('this.peak_grad_mmhg', this.peak_grad_mmhg)
            var PrognosticTotal = 0.2171364 * (parseFloat(LVMWTZ.toFixed(9)) - 11.09) - 0.0047562 * (Math.pow(parseFloat(LVMWTZ.toFixed(9)), 2) - 174.12) + 0.130365 * (sexRangeValue - 1.92) - 0.0065555 * (this.peak_grad_mmhg - 21.8) + 0.1861694 * this.nsvt_pick + 0.429624 * this.un_sy;
            // parseFloat(secondStep.toFixed(9)) + 
            // parseFloat(thirdStep.toFixed(9)) + 
            // fourthStep + 
            // fifthStep;
            var totalPrognosticTotal = parseFloat(PrognosticTotal.toFixed(9));
            // console.log('totalPrognosticTotal', totalPrognosticTotal)
            this.PrognosticTotal = totalPrognosticTotal;
            var base = 0.949437808;
            var powerResult = Math.pow(base, Math.exp(PrognosticTotal));
            this.RiskKidsTotalResult = ((1 - powerResult) * 100).toFixed(2) + '%';
            console.log('RiskKidsTotalResult', this.RiskKidsTotalResult);
            var ivsd_scd_spline = void 0;
            var lvpwd_scd_spline = void 0;
            var la_scd_spline = void 0;
            var grad_scd_spline = void 0;
            var age_scd_spline = void 0;
            var nsvt_scd_spline = void 0;
            var syncope_scd_spline = void 0;
            var gene_scd_spline = void 0;
            var age_oth_spline = void 0;
            var cif_obj = void 0;
            var prog_idx_scd_calib_factor = void 0;
            var prog_idx_oth_calib_factor = void 0;
            if (genotype_mutation == null) {
                ivsd_scd_spline = no_genotype_spline_functions_1.no_genotype_ivsd_scd_spline;
                lvpwd_scd_spline = no_genotype_spline_functions_1.no_genotype_lvpwd_scd_spline;
                la_scd_spline = no_genotype_spline_functions_1.no_genotype_la_scd_spline;
                grad_scd_spline = no_genotype_spline_functions_1.no_genotype_grad_scd_spline;
                age_scd_spline = no_genotype_spline_functions_1.no_genotype_age_scd_spline;
                nsvt_scd_spline = no_genotype_spline_functions_1.no_genotype_nsvt_scd_spline;
                syncope_scd_spline = no_genotype_spline_functions_1.no_genotype_syncope_scd_spline;
                gene_scd_spline = no_genotype_spline_functions_1.no_genotype_genotype_scd_spline;
                age_oth_spline = no_genotype_spline_functions_1.no_genotype_age_oth_spline;
                cif_obj = no_genotype_baseline_hazard_1.no_genotype_cif_scd;
                prog_idx_scd_calib_factor = 1.30563989776015;
                prog_idx_oth_calib_factor = 5.84865347533236;
            } else {
                ivsd_scd_spline = genotype_spline_functions_1.genotype_ivsd_scd_spline;
                lvpwd_scd_spline = genotype_spline_functions_1.genotype_lvpwd_scd_spline;
                la_scd_spline = genotype_spline_functions_1.genotype_la_scd_spline;
                grad_scd_spline = genotype_spline_functions_1.genotype_grad_scd_spline;
                age_scd_spline = genotype_spline_functions_1.genotype_age_scd_spline;
                nsvt_scd_spline = genotype_spline_functions_1.genotype_nsvt_scd_spline;
                syncope_scd_spline = genotype_spline_functions_1.genotype_syncope_scd_spline;
                gene_scd_spline = genotype_spline_functions_1.genotype_genotype_scd_spline;
                age_oth_spline = genotype_spline_functions_1.genotype_age_oth_spline;
                cif_obj = genotype_baseline_hazard_1.genotype_cif_scd;
                prog_idx_scd_calib_factor = 1.352992544571569;
                prog_idx_oth_calib_factor = 5.84865347533236;
            }
            var age_idx = age_yr;
            var bsa = (0, z_functions_1.bsa_fml)(wgt_kg, hgt_cm);
            var ivsd_z_calc = (0, z_functions_1.ivsd_z_fml)(ivsd_mm / 10, bsa);
            var lvpwd_z_calc = (0, z_functions_1.lvpwd_z_fml)(lvpwd_mm / 10, bsa);
            var la_z_calc = (0, z_functions_1.la_systole_z_fml)(la_systole_mm / 10, bsa);
            var peak_grad_first_echo = peak_grad_mmhg;

            if (this.nsvt_pick == 1) {
                var non_sustained_vt = 1;
            } else {
                var non_sustained_vt = 0;
            }
            if (this.un_sy == 1) {
                var history_syncope = 1;
            } else {
                var history_syncope = 0;
            }
            var prog_idx_scd_uncal = ivsd_scd_spline(ivsd_z_calc) + lvpwd_scd_spline(lvpwd_z_calc) + la_scd_spline(la_z_calc) + grad_scd_spline(peak_grad_first_echo) + age_scd_spline(age_idx) + nsvt_scd_spline(non_sustained_vt) + syncope_scd_spline(history_syncope) + gene_scd_spline(genotype_mutation);
            var prog_idx_oth_uncal = age_oth_spline(age_idx);
            var prog_idx_scd = prog_idx_scd_calib_factor * prog_idx_scd_uncal;
            var prog_idx_oth = prog_idx_oth_calib_factor * prog_idx_oth_uncal;
            var prevBaseCumHazSCD = 0;
            var prevBaseCumHazOth = 0;
            var prevPrevBaseCumHazSCD = 0;
            var prevPrevBaseCumHazOth = 0;
            var cumulativeProdSurvPrev = 1;
            var cumulativeSumCIFSCD = 0;
            var cif_result = [];
            cif_obj.forEach(function (entry) {
                entry.hazard_scd = entry.cumhaz0_scd * Math.exp(prog_idx_scd) - prevBaseCumHazSCD * Math.exp(prog_idx_scd);
                if (entry.day_prev_evt == 0) {
                    entry.hazard_ttl = 0;
                } else {
                    entry.hazard_ttl = prevBaseCumHazSCD * Math.exp(prog_idx_scd) + prevBaseCumHazOth * Math.exp(prog_idx_oth) - (prevPrevBaseCumHazSCD * Math.exp(prog_idx_scd) + prevPrevBaseCumHazOth * Math.exp(prog_idx_oth));
                }
                prevPrevBaseCumHazSCD = prevBaseCumHazSCD;
                prevPrevBaseCumHazOth = prevBaseCumHazOth;
                prevBaseCumHazSCD = entry.cumhaz0_scd;
                prevBaseCumHazOth = entry.cumhaz0_oth;
                entry.one_minus_hazard_ttl = 1 - entry.hazard_ttl;
                cumulativeProdSurvPrev *= entry.one_minus_hazard_ttl;
                entry.surv_prev = cumulativeProdSurvPrev;
                cumulativeSumCIFSCD += entry.hazard_scd * entry.surv_prev;
                entry.cif_scd = cumulativeSumCIFSCD;
                cif_result.push(entry);
            });
            this.primacyTotalResult = (cif_result[cif_result.length - 1]['cif_scd'] * 100).toFixed(2) + "%";
            this.hcmCalculatorFormula();
            return cif_result[cif_result.length - 1]['cif_scd'];
        },
        handleIconValidatoin: function handleIconValidatoin(val) {
            if (val === 'height') {
                this.heightRangeIcon = !this.heightRangeIcon;
            }

            if (val === 'weight') {
                this.weightRangeIcon = !this.weightRangeIcon;
            }

            if (val === 'ivsd_mm') {
                this.ivsd_mmRangeIcon = !this.ivsd_mmRangeIcon;
            }

            if (val === "lvpwd_mm") {
                this.lvpwd_mmRangeIcon = !this.lvpwd_mmRangeIcon;
            }

            if (val === 'la_systole_mm') {
                this.la_systole_mmRangeIcon = !this.la_systole_mmRangeIcon;
            }

            if (val === "peak_grad_mmhg") {
                this.peak_grad_mmhgRangeIcon = !this.peak_grad_mmhgRangeIcon;
            }

            if (val === "lv_Zz_score") {
                this.lv_Zz_scoregRangeIcon = !this.lv_Zz_scoregRangeIcon;
            }

            if (val === "la_dia_score") {
                this.ladiascoreRangeIcon = !this.ladiascoreRangeIcon;
            }

            if (val === "HistoryVentricular") {
                this.HistoryVentricularRangeIcon = !this.HistoryVentricularRangeIcon;
            }

            if (val === "HistoryUnexplained") {
                this.HistoryUnexplainedRangeIcon = !this.HistoryUnexplainedRangeIcon;
            }

            if (val === "Genotypestatus") {
                this.GenotypestatusRangeIcon = !this.GenotypestatusRangeIcon;
            }

            if (val === "Genotypepositive") {
                this.GenotypepositiveRangeIcon = !this.GenotypepositiveRangeIcon;
            }

            if (val === "nonVt") {
                this.nonVtRangeIcon = !this.nonVtRangeIcon;
            }

            if (val === "UnexplainedSyncope") {
                this.UnexplainedSyncopeIcon = !this.UnexplainedSyncopeIcon;
            }

            if (val === "fhscdLabel") {
                this.fhscdIcon = !this.fhscdIcon;
            }

            if (val === "nsvtLabel") {
                this.nsvtLabelRangeIcon = !this.nsvtLabelRangeIcon;
            }

            if (val === "efLabel") {
                this.efLabelRangeIcon = !this.efLabelRangeIcon;
            }

            if (val === "aaLabel") {
                this.aaLabelRangeIcon = !this.aaLabelRangeIcon;
            }

            if (val === "lgeLabel") {
                this.lgeLabelRangeIcon = !this.lgeLabelRangeIcon;
            }
        }
    }, _defineProperty(_methods, 'handleReload', function handleReload() {

        window.location.reload();
    }), _defineProperty(_methods, 'hcmCalculatorFormula', function hcmCalculatorFormula() {
        //this.isShowModal = true;
        var mlvwt = this.lvpwd_mm;
        var lasize = this.la_systole_mm;
        var maxlvot = this.peak_grad_mmhg;
        var fhscd = this.fhscd_pick;
        var nsvt = this.nsvt_pick;
        var unexSyncope = this.un_sy;
        var ef50 = this.ef50_pick;
        var aa = this.apAn_pick;
        var elge = this.elge_pick;

        var a = 0.01799934 * this.userAgeValue;
        var b = 0.15939858 * mlvwt - 0.00294271 * mlvwt * mlvwt;
        var c = 0.0259082 * lasize;
        var d = 0.00446131 * maxlvot;
        var e = fhscd === 0 ? 0 : 0.4583082;
        var f = nsvt === 0 ? 0 : 0.82639195;
        var g = unexSyncope === 0 ? 0 : 0.71650361;
        var h = mlvwt <= 29 ? 0 : 1;
        var i = ef50 === 0 ? 0 : 1;
        var j = null;
        var k = b + c + d + e + f + g - a;
        var l = Math.pow(2.71828183, k);
        var m = Math.pow(0.998, l);
        var risk = 100 * (1 - m);

        var elgeYes = elge == 1;
        var aaYes = aa == 1;
        var efYes = i == 1;
        var nsvtYes = f == 0.82639195;
        var fhscdYes = e == 0.4583082;
        var usYes = g == 0.71650361;
        var mlvwtYes = h == 1;

        switch (true) {
            //Class 2A: When one parameter AND NSVT AND Extensive LGE = YES
            case elgeYes && nsvtYes && aaYes && efYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%, Apical Aneurysm, and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge, aa, ef & nsvt are yes");
                break;
            case efYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge & nsvt");
                break;
            case aaYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge & nsvt");
                break;
            case fhscdYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("fhscd, elge, nsvt are yes");
                break;
            case usYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("US, elge, nsvt are yes");
                break;
            case mlvwtYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("mlvwt, elge, nsvt are yes");
                break;
            case elgeYes && efYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm, EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge,ef,aa are yes");
                break;
            case nsvtYes && efYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Apical Aneursym)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge,ef,aa are yes");
                break;

            //Class 2B(a): When all parameters = NO except for NVST AND Extensive LGE
            case elgeYes && nsvtYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "This patient has 2 risk factors that while individually carry Class 2B indications, having both of these likely represents more risk than having either risk factor in isolation";
                console.log("elge & nsvt");
                break;

            //Class 2A: When any parameter AND EXTENSIVE LGE = YES
            case elgeYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("switch elge & aa");
                break;
            case elgeYes && efYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge & ef are yes");
                break;
            case elgeYes && fhscdYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("FHSCD and ELGE are yes");
                break;
            case elgeYes && usYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("Unexplained Syncope and ELGE are yes");
                break;
            case elgeYes && mlvwtYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("MLVWT and ELGE are yes");
                break;

            //Class 2A: When any parameter AND NVST = YES
            case nsvtYes && efYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("EF and NSVT are yes");
                break;
            case nsvtYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("EF and NSVT are yes");
                break;
            case nsvtYes && fhscdYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("FHSCD and NSVT are yes");
                break;
            case nsvtYes && usYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("Unexplained Syncope and NSVT are yes");
                break;
            case nsvtYes && mlvwtYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("MLVWT and NSVT are yes");
                break;

            //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
            case efYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("EF and AA are yes");
                break;

            //Class 2B: When all parameters = NO except for NVST OR Extensive LGE
            case nsvtYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
                console.log("nsvtYes");
                break;
            case elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
                console.log("elge catch all");
                break;

            //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
            case efYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("EF is Yes");
                break;
            case aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("Apical aneurysm is yes");
                break;
            case fhscdYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("fhscd is yes");
                break;
            case usYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("Unexplained Syncope is Yes");
                break;
            case mlvwtYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("mlvwt is yes");
                break;
            default:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the absence of risk factors, this patient does not have an indication for an  <span class='abbr' title='Implantable Cardioverter Defibrillator'><abbr title='Implantable Cardioverter Defibrillator'>ICD</abbr></span>  (Class 3 – No Benefit)";
                console.log("all no");
                break;
        }
        console.log('recommendation', this.recommendation);
        console.log('risk', this.risk);
    }), _defineProperty(_methods, 'resetForm', function resetForm() {
        console.log('this.sex_range', this.sex_range);
        this.hgt_cm = "";
        this.wgt_kg = "";
        this.ivsd_mm = "";
        this.lvpwd_mm = "";
        this.la_systole_mm = "";
        this.peak_grad_mmhg = "";
        this.sex_range = 0;
        this.hx_nsvt = 0;
        this.hx_syncope = 0;
        this.fhscd_pick = 0;
        this.nsvt_pick = 0;
        this.unexSy_pick = 0;
        this.ef50_pick = 0;
        this.apAn_pick = 0;
        this.elge_pick = 0;
        this.non_vt = 0;
        this.elge_pick = 0;
        this.un_sy = 0;
        this.genotype_mutation = 0;
        this.genotype_mutation_yes = 0;
        this.testedStatus = "";
        this.totalResult = "";
        this.ageValidationError = "";
        this.heightValidationError = "";
        this.weightValidationError = "";
        this.ivsd_mm_validationError = "";
        this.lvpwd_mm_validationError = "";
        this.la_systole_mm_validationError = "";
        this.peak_grad_mmhg_validationError = "";
        this.isLoading = "";
        this.ageValidation = false;
        this.heightValidation = false;
        this.weightValidation = false;
        this.ivsd_mm_Validation = false;
        this.lvpwd_mm_validation = false;
        this.la_systole_mm_validation = false;
        this.peak_grad_mmhg_validation = false;
        this.heightRangeIcon = false;
        this.weightRangeIcon = false;
        this.ivsd_mmRangeIcon = false;
        this.lvpwd_mmRangeIcon = false;
        this.la_systole_mmRangeIcon = false;
        this.peak_grad_mmhgRangeIcon = false;
        this.lv_Zz_scoregRangeIcon = false;
        this.ladiascoreRangeIcon = false;
        this.HistoryVentricularRangeIcon = false;
        this.HistoryUnexplainedRangeIcon = false;
        this.GenotypestatusRangeIcon = false;
        this.GenotypepositiveRangeIcon = false;
        this.nonVtRangeIcon = false;
        this.UnexplainedSyncopeIcon = false;
        this.lgeLabelRangeIcon = false;
        this.nsvtLabelRangeIcon = false;
        this.efLabelRangeIcon = false;
        this.aaLabelRangeIcon = false, this.lgeLabelRangeIcon = false;
        this.fhscdIcon = false;
        this.mlvwt_range.value = "";
        this.lasize_range.value = "";
        this.maxlvot_range.value = "";

        this.risk.value = "";
        this.recommendation = "";
        this.isAgeValidate = false;
        this.isMlvwtValidate = false;
        this.isLasizeValidate = false;
        this.isMaxlovtValidate = false;
        this.isAgeRequired = false;
        this.isMlvwtRequired = false;
        this.isLasizeRequired = false;
        this.isMaxlvotRequired = false;
        this.ageToolTip = true;
        this.mlvwtToolTip = true;
        this.lasizeToolTip = true;
        this.maxlvotToolTip = true;
        this.fhscdToolTip = true;
        this.nsvtToolTip = true;
        this.unexSyToolTip = true;
        this.ef50ToolTip = true;
        this.apAnToolTip = true;
        this.elgeToolTip = true;
        this.fhscdIcon = false;
        this.nsvtLabelRangeIcon = false;
        this.efLabelRangeIcon = false;
        this.aaLabelRangeIcon = false;
    }), _methods),
    mounted: function mounted() {
        //this.EventBus.$emit('stepTrigger', '3');
        //console.log('children', this.$root.$children);// dont work, app as a child

        //console.log('child ',this.$children.find(child => { return child.$options.name === "aha-modal"; }))
        //console.log('Quiz',this.$refs['Quiz']);
        //console.log('Quiz Modal',this.$root);
        //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 3); // Works
        this.$root.$on("bv::modal::hidden", function ($event) {
            //console.log('evt', $event);
            //this.$root.EventBus.$emit('stepTrigger', '1');
            //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 1);
        });
    },

    watch: {
        hx_nsvt: function hx_nsvt(newVal, oldVal) {
            if (oldVal === 0) {
                this.hx_nsvt = 1;
                console.log("this.hx_nsvt", this.hx_nsvt);
            } else if (oldVal === 1) {
                this.hx_nsvt = 0;
            }
        },
        hx_syncope: function hx_syncope(newVal, oldVal) {
            if (oldVal === 0) {
                this.hx_syncope = 1;
                console.log("this.hx_syncope", this.hx_syncope);
            } else {
                this.hx_syncope - 0;
            }
        }
    }
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _methods;

var _hcmScdCalculator = __webpack_require__(56);

var _hcmScdCalculator2 = _interopRequireDefault(_hcmScdCalculator);

var _riskKidsPrimacy = __webpack_require__(57);

var _riskKidsPrimacy2 = _interopRequireDefault(_riskKidsPrimacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue';
/* eslint-disable */


var _require = __webpack_require__(79),
    age_oth_spline = _require.age_oth_spline,
    age_scd_spline = _require.age_scd_spline,
    grad_scd_spline = _require.grad_scd_spline,
    la_scd_spline = _require.la_scd_spline,
    lvpwd_scd_spline = _require.lvpwd_scd_spline,
    ivsd_scd_spline = _require.ivsd_scd_spline;

var _require2 = __webpack_require__(80),
    cif_scd = _require2.cif_scd;

var z_functions_1 = __webpack_require__(81);
var genotype_spline_functions_1 = __webpack_require__(82);
var no_genotype_spline_functions_1 = __webpack_require__(83);
var genotype_baseline_hazard_1 = __webpack_require__(84);
var no_genotype_baseline_hazard_1 = __webpack_require__(85);

exports['default'] = {
    components: {
        HcmScdCalculator: _hcmScdCalculator2['default'],
        RiskKidsPrimacy: _riskKidsPrimacy2['default']
    },
    props: {
        riskHeaderText: {
            type: String,
            required: true
        },
        resultGuidelineText: {
            type: String,
            required: true
        },
        calculatorVersionText: {
            type: String,
            required: true
        },
        userAgeValue: {
            type: String,
            required: true
        },
        handleFourthScreen: Function,
        heightErrorMessage: {
            type: String,
            required: true
        },
        weightErrorMessage: {
            type: String,
            required: true
        },
        laSizeErrorMessage: {
            type: String,
            required: true
        },
        maxLvotGradientErrorMessage: {
            type: String,
            required: true
        },
        mlvwtErrorMessage: {
            type: String,
            required: true
        },
        isdErrorMessage: {
            type: String,
            required: true
        },
        sexLabel: {
            type: String,
            required: true
        },
        heightLabel: {
            type: String,
            required: true
        },
        weightLabel: {
            type: String,
            required: true
        },
        laSizeLabel: {
            type: String,
            required: true
        },
        maxLvotGradientLabel: {
            type: String,
            required: true
        },
        mlvwtLabel: {
            type: String,
            required: true
        },
        isdLabel: {
            type: String,
            required: true
        },
        gpLabel: {
            type: String,
            required: true
        },
        usLabel: {
            type: String,
            required: true
        },
        nsvtLabel: {
            type: String,
            required: true
        },
        gsLabel: {
            type: String,
            required: true
        },
        efLabel: {
            type: String,
            required: true
        },
        fhscdLabel: {
            type: String,
            required: true
        },
        aaLabel: {
            type: String,
            required: true
        },
        lgeLabel: {
            type: String,
            required: true
        },
        laSizeHelpText: {
            type: String,
            required: true
        },
        maxLvotGradientHelpText: {
            type: String,
            required: true
        },
        mlvwtHelpText: {
            type: String,
            required: true
        },
        isdHelpText: {
            type: String,
            required: true
        },
        gpHelpText: {
            type: String,
            required: true
        },
        usHelpText: {
            type: String,
            required: true
        },
        nsvtHelpText: {
            type: String,
            required: true
        },
        gsHelpText: {
            type: String,
            required: true
        },
        efHelpText: {
            type: String,
            required: true
        },
        fhscdHelpText: {
            type: String,
            required: true
        },
        aaHelpText: {
            type: String,
            required: true
        },
        lgeHelpText: {
            type: String,
            required: true
        },
        handleThirdScreen: Function,
        hcmRiskkidsScoreLabel: {
            type: String,
            required: true
        },

        hcmRiskKidsScoreDescription: {
            type: String,
            required: true
        },
        primacyRiskScoreLabel: {
            type: String,
            required: true
        },

        primacyRiskScoreDescription: {
            type: String,
            required: true
        },
        lvmwtZScoreLabel: {
            type: String,
            required: true
        },

        lvmwtZScoreDescription: {
            type: String,
            required: true
        },
        laDiameterZScoreLabel: {
            type: String,
            required: true
        },

        laDiameterZScoreDescription: {
            type: String,
            required: true
        },
        hcmScdScoreLabel: {
            type: String,
            required: true
        },

        hcmScdScoreDescription: {
            type: String,
            required: true
        },
        prognosticIndexLabel: {
            type: String,
            required: true
        },

        prognosticIndexDescription: {
            type: String,
            required: true
        },
        errorModalHeaderText: {
            type: String,
            required: true
        },
        errorModalFooterText: {
            type: String,
            required: true
        },
        hcmScdRecommendationLabel: {
            type: String,
            required: true
        }

    },

    data: function data() {
        return {
            sex_range: 0,
            isShowModal: false,
            hgt_cm: "",
            wgt_kg: "",
            ivsd_mm: "",
            lvpwd_mm: "",
            la_systole_mm: "",
            peak_grad_mmhg: "",
            hx_nsvt: 0,
            hx_syncope: 0,
            testedStatus: "",
            primacyTotalResult: "",
            RiskKidsTotalResult: "",
            ageValidationError: "",
            heightValidationError: "",
            weightValidationError: "",
            ivsd_mm_validationError: "",
            lvpwd_mm_validationError: "",
            la_systole_mm_validationError: "",
            peak_grad_mmhg_validationError: "",
            isLoading: "",
            ageValidation: false,
            heightValidation: false,
            weightValidation: false,
            ivsd_mm_Validation: false,
            lvpwd_mm_validation: false,
            la_systole_mm_validation: false,
            peak_grad_mmhg_validation: false,
            genoTypePossitive: false,
            genotype_mutation: 0,
            genotype_mutation_yes: 0,
            non_vt: 0,
            un_sy: 0,
            lv_Zz_score: "",
            heightRangeIcon: false,
            weightRangeIcon: false,
            ivsd_mmRangeIcon: false,
            lvpwd_mmRangeIcon: false,
            la_systole_mmRangeIcon: false,
            peak_grad_mmhgRangeIcon: false,
            lv_Zz_scoregRangeIcon: false,
            ladiascoreRangeIcon: false,
            HistoryVentricularRangeIcon: false,
            HistoryUnexplainedRangeIcon: false,
            GenotypestatusRangeIcon: false,
            GenotypepositiveRangeIcon: false,
            nonVtRangeIcon: false,
            UnexplainedSyncopeIcon: false,
            fhscd_pick: 0,
            nsvt_pick: 0,
            ef50_pick: 0,
            apAn_pick: 0,
            risk: {
                value: ""
            },
            recommendation: "",
            fhscdIcon: false,
            nsvtLabelRangeIcon: false,
            efLabelRangeIcon: false,
            aaLabelRangeIcon: false,
            lgeLabelRangeIcon: false,
            elge_pick: 0,
            hcmScdCalculatorResultValidatoin: false,
            primacyCalculatorResulatValidation: false,
            mainScreen: false,
            validationModal: false

        };
    },

    computed: {
        canShowTotalResult: function canShowTotalResult() {
            return this.ageValidation === false && this.heightValidation === false && this.weightValidation === false && this.ivsd_mm_Validation === false && this.lvpwd_mm_validation === false && this.la_systole_mm_validation === false && this.peak_grad_mmhg_validation === false && this.hgt_cm !== "" && this.wgt_kg !== "" && this.ivsd_mm !== "" && this.lvpwd_mm !== "" && this.la_systole_mm !== "" && this.peak_grad_mmhg !== "";
        }
    },
    methods: (_methods = {
        handleUpperInput: function handleUpperInput(inputKey) {
            if (inputKey === 'height') {
                this.hgt_cm = this.hgt_cm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'weight') {
                this.wgt_kg = this.wgt_kg.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'ivsd_mm') {
                this.ivsd_mm = this.ivsd_mm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'lvpwd_mm') {
                this.lvpwd_mm = this.lvpwd_mm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'la_systole_mm') {
                this.la_systole_mm = this.la_systole_mm.replace(/[^0-9.]/g, "");
            }

            if (inputKey === 'peak_grad_mmhg') {
                this.peak_grad_mmhg = this.peak_grad_mmhg.replace(/[^0-9.]/g, "");
            }
        },
        validationBack: function validationBack() {
            this.validationModal = false;
            this.mainScreen = false;
            this.isShowModal = false;
        },
        handleBackScreen: function handleBackScreen() {
            this.handleThirdScreen();
        },
        handleReload: function handleReload() {
            window.location.reload();
        },
        handleChange: function handleChange(notTested) {

            if (notTested === "notTested") {
                this.genoTypePossitive = false;
                this.genotype_mutation = 0;
            } else {
                this.genoTypePossitive = true;
                this.totalResult = "";
            }
        },
        bsa_fml: function bsa_fml(w, h) {
            return Math.exp(0.3964 * Math.log(h)) * Math.exp(0.5378 * Math.log(w)) * 0.024265;
        },
        ivsd_z_fml: function ivsd_z_fml(ivsd, bsa) {
            return (ivsd - (0.45686 * Math.pow(bsa, 0.59577) + 0.18722)) / (0.02033 + 0.04698 * bsa);
        },
        lvpwd_z_fml: function lvpwd_z_fml(lvpwd, bsa) {
            return (lvpwd - (0.3767 * Math.pow(bsa, 0.72326) + 0.243)) / (0.0371 + 0.02776 * bsa);
        },
        la_systole_z_fml: function la_systole_z_fml(la, bsa) {
            return (Math.log10(la) - Math.log10(Math.pow(10, 0.81375 * Math.pow(bsa, 0.20444) - 0.43308))) / (0.07447 - 0.01478 * bsa);
        },
        validationFiled: function validationFiled(val) {
            if (val === 'Height') {
                if (this.hgt_cm === "") {
                    this.heightValidationError = this.heightErrorMessage;
                } else if (this.hgt_cm > 190 || this.hgt_cm < 25) {
                    this.heightValidationError = "Height must be between 25 and 190 cm.";
                } else {
                    this.heightValidation = false;
                    this.heightValidationError = "";
                }
            }

            if (val === 'weight') {
                if (this.wgt_kg == "") {
                    this.weightValidationError = this.weightErrorMessage;
                } else if (this.wgt_kg > 150 || this.wgt_kg < 1) {
                    this.weightValidationError = "Weight must be between 1 and 150 kg.";
                } else {
                    this.weightValidationError = "";
                }
            }

            if (val === "ivsd_mm") {
                if (this.ivsd_mm === "") {
                    this.ivsd_mm_validationError = this.isdErrorMessage;
                    //     "Interventricular septal diameter (mm) is missing.";
                    this.weightValidation = false;
                } else if (this.ivsd_mm > 43 || this.ivsd_mm < 0.5) {
                    this.ivsd_mm_validationError = this.isdErrorMessage;
                } else {
                    this.ivsd_mm_validationError = "";
                }
            }

            if (val === 'lvpwd_mm') {
                if (this.lvpwd_mm == "") {
                    this.lvpwd_mm_validationError = 'MLVWT must be between 0.5 and 60 mm.';
                } else if (this.lvpwd_mm > 60 || this.lvpwd_mm < 0.5) {
                    this.lvpwd_mm_validationError = 'MLVWT must be between 0.5 and 60 mm.';
                } else if (this.lvpwd_mm > 60) {
                    this.lvpwd_mm_validationError = "Due to value entered, PRIMaCY cannot be computed.";
                    //   this.primacyCalculatorResulatValidation = true 
                } else if (this.lvpwd_mm > 35 || this.lvpwd_mm < 10) {
                    this.lvpwd_mm_validationError = "Due to value entered, HCM SCD cannot be computed.";
                    // this.hcmScdCalculatorResultValidatoin = true 
                    //this.primacyCalculatorResulatValidation = false 
                } else {
                    this.lvpwd_mm_validationError = "";
                    //this.primacyCalculatorResulatValidation = false 
                    //this.primacyCalculatorResulatValidation = false 
                }
            }

            if (val === "la_systole_mm") {
                if (this.la_systole_mm == "") {
                    this.la_systole_mm_validationError = "LA Size must be between 5 and 67 mm";
                } else if (this.la_systole_mm < 5 || this.la_systole_mm > 67) {
                    this.la_systole_mm_validationError = "LA Size must be between 5 and 67 mm";

                    //  this.primacyCalculatorResulatValidation = true
                } else if (this.la_systole_mm < 28 || this.la_systole_mm > 67) {
                    this.la_systole_mm_validationError = "Due to value entered, HCM SCD cannot be computed";
                    // this.primacyCalculatorResulatValidation = false
                    //this.hcmScdCalculatorResultValidatoin = true
                } else if (this.la_systole_mm > 55) {
                    this.la_systole_mm_validationError = "Due to value entered, PRIMaCY cannot be computed.";
                    //  this.primacyCalculatorResulatValidation = true
                } else if (this.la_systole_mm > 55 || this.la_systole_mm < 5) {

                    this.la_systole_mm_validationError = "LA Size must be between 5 and 67 mm";
                } else {
                    this.la_systole_mm_validationError = "";
                    //   this.primacyCalculatorResulatValidation = false
                    // this.hcmScdCalculatorResultValidatoin = false
                }
            }

            if (val === 'peak_grad_mmhg') {
                if (this.peak_grad_mmhg === "") {
                    this.peak_grad_mmhg_validationError = this.maxLvotGradientErrorMessage;
                } else if (this.peak_grad_mmhg >= 0 && this.peak_grad_mmhg < 2 || this.peak_grad_mmhg > 154 && this.peak_grad_mmhg <= 210) {
                    this.peak_grad_mmhg_validationError = "Due to value entered, HCM SCD cannot be computed.";
                    //    this.primacyCalculatorResulatValidation = true
                } else if (this.peak_grad_mmhg < 0 || this.peak_grad_mmhg > 210) {
                    console.log('working');
                    this.peak_grad_mmhg_validationError = this.maxLvotGradientErrorMessage;
                } else {
                    this.peak_grad_mmhg_validationError = "";
                    // this.primacyCalculatorResulatValidation = false
                }
            }
        },
        formValidate: function formValidate(e) {
            //  this.validationModal = true
            if (this.wgt_kg === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.wgt_kg > 150 || this.wgt_kg < 1) {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.hgt_cm === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.hgt_cm > 190 || this.hgt_cm < 25) {

                this.primacyCalculatorResulatValidation = false;
            } else if (this.la_systole_mm === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.la_systole_mm > 55 || this.la_systole_mm < 5) {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.peak_grad_mmhg === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.peak_grad_mmhg > 210 || this.peak_grad_mmhg < 0) {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.lvpwd_mm === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.lvpwd_mm > 60 || this.lvpwd_mm < 0.5) {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.ivsd_mm === '') {
                this.primacyCalculatorResulatValidation = false;
            } else if (this.ivsd_mm > 43 || this.ivsd_mm < 0.5) {
                this.primacyCalculatorResulatValidation = false;
            } else {
                this.primacyCalculatorResulatValidation = true;
            }

            //HCM SCD CAL

            if (this.la_systole_mm === '') {
                this.hcmScdCalculatorResultValidatoin = false;
            } else if (this.la_systole_mm > 67 || this.la_systole_mm < 28) {
                this.hcmScdCalculatorResultValidatoin = false;
            } else if (this.peak_grad_mmhg === '') {
                this.hcmScdCalculatorResultValidatoin = false;
            } else if (this.peak_grad_mmhg > 154 || this.peak_grad_mmhg < 2) {
                this.hcmScdCalculatorResultValidatoin = false;
            } else if (this.lvpwd_mm === '') {
                this.hcmScdCalculatorResultValidatoin = false;
            } else if (this.lvpwd_mm > 35 || this.lvpwd_mm < 10) {
                this.hcmScdCalculatorResultValidatoin = false;
            } else {
                this.hcmScdCalculatorResultValidatoin = true;
            }

            if (this.primacyCalculatorResulatValidation && this.hcmScdCalculatorResultValidatoin) {

                this.validationModal = false;
                this.isShowModal = true;
                this.mainScreen = true;
                this.calculate_sdc_risk();
            } else {

                this.validationModal = true;
            }
        },
        calculate_sdc_risk: function calculate_sdc_risk() {
            this.isShowModal = true;
            this.validationModal = false;
            this.mainScreen = true;
            var age_yr = this.userAgeValue;
            var hgt_cm = this.hgt_cm;
            var wgt_kg = this.wgt_kg;
            var ivsd_mm = this.ivsd_mm;
            var lvpwd_mm = this.lvpwd_mm;
            var la_systole_mm = this.la_systole_mm;
            var peak_grad_mmhg = this.peak_grad_mmhg;
            var hx_nsvt = this.hx_nsvt;
            var hx_syncope = this.hx_syncope;
            var testedStatus = this.testedStatus;
            var genotype_mutation = this.genotype_mutation == 0 ? null : this.genotype_mutation_yes === 0 ? false : true;
            console.log('this.genotype_mutation', this.genotype_mutation, genotype_mutation);
            var bodySurfaceArea = 0.1023 * Math.pow(this.wgt_kg, 0.68);
            var roundedNumber = parseFloat(bodySurfaceArea.toFixed(8));
            console.log('bodySurfaceArea', roundedNumber);

            var convertCMMM = this.lvpwd_mm / 10;
            console.log('convertCMMM', convertCMMM);
            var LVMWTZ = (convertCMMM / Math.pow(bodySurfaceArea, 0.4) - 0.58) / 0.09;
            console.log('LVMWTZ', LVMWTZ);
            this.lv_Zz_score = parseFloat(LVMWTZ.toFixed(9));
            console.log('this.lv_Zz_score', this.lv_Zz_score);
            console.log('this.sex_range', this.sex_range);
            var laDiameterZScore = this.sex_range == "0" ? (la_systole_mm / (10.665 * Math.pow(this.wgt_kg, 0.225)) - 1) / 0.118 : (la_systole_mm / (10.74 * Math.pow(this.wgt_kg, 0.246)) - 1) / 0.124;
            var sexRangeValue = parseFloat(laDiameterZScore.toFixed(9));
            console.log('laDiameterZScore', laDiameterZScore);
            this.la_dia_score = sexRangeValue;

            var firstStep = 0.2171364 * (parseFloat(LVMWTZ.toFixed(9)) - 11.09) - 0.0047562 * (Math.pow(parseFloat(LVMWTZ.toFixed(9)), 2) - 174.12);
            console.log('firstStep', firstStep);
            var secondStep = +0.130365 * (sexRangeValue - 1.92);
            console.log('secondStep', secondStep);
            var thirdStep = -0.0065555 * (this.peak_grad_mmhg - 21.8);
            console.log('thirdStep', thirdStep);
            var fourthStep = +0.1861694 * this.non_vt;
            //console.log ('fourthStep', fourthStep , 'hx_nsvt', hx_nsvt)
            var fifthStep = +0.429624 * this.un_sy;
            console.log('fifthStep', fifthStep);
            console.log('this.peak_grad_mmhg', this.peak_grad_mmhg);
            var PrognosticTotal = 0.2171364 * (parseFloat(LVMWTZ.toFixed(9)) - 11.09) - 0.0047562 * (Math.pow(parseFloat(LVMWTZ.toFixed(9)), 2) - 174.12) + 0.130365 * (sexRangeValue - 1.92) - 0.0065555 * (this.peak_grad_mmhg - 21.8) + 0.1861694 * this.nsvt_pick + 0.429624 * this.un_sy;
            // parseFloat(secondStep.toFixed(9)) + 
            // parseFloat(thirdStep.toFixed(9)) + 
            // fourthStep + 
            // fifthStep;
            var totalPrognosticTotal = parseFloat(PrognosticTotal.toFixed(9));
            console.log('totalPrognosticTotal', totalPrognosticTotal);
            this.PrognosticTotal = totalPrognosticTotal;
            var base = 0.949437808;
            var powerResult = Math.pow(base, Math.exp(PrognosticTotal));
            this.RiskKidsTotalResult = ((1 - powerResult) * 100).toFixed(9);
            console.log('RiskKidsTotalResult', this.RiskKidsTotalResult);
            var ivsd_scd_spline = void 0;
            var lvpwd_scd_spline = void 0;
            var la_scd_spline = void 0;
            var grad_scd_spline = void 0;
            var age_scd_spline = void 0;
            var nsvt_scd_spline = void 0;
            var syncope_scd_spline = void 0;
            var gene_scd_spline = void 0;
            var age_oth_spline = void 0;
            var cif_obj = void 0;
            var prog_idx_scd_calib_factor = void 0;
            var prog_idx_oth_calib_factor = void 0;
            if (genotype_mutation == null) {
                ivsd_scd_spline = no_genotype_spline_functions_1.no_genotype_ivsd_scd_spline;
                lvpwd_scd_spline = no_genotype_spline_functions_1.no_genotype_lvpwd_scd_spline;
                la_scd_spline = no_genotype_spline_functions_1.no_genotype_la_scd_spline;
                grad_scd_spline = no_genotype_spline_functions_1.no_genotype_grad_scd_spline;
                age_scd_spline = no_genotype_spline_functions_1.no_genotype_age_scd_spline;
                nsvt_scd_spline = no_genotype_spline_functions_1.no_genotype_nsvt_scd_spline;
                syncope_scd_spline = no_genotype_spline_functions_1.no_genotype_syncope_scd_spline;
                gene_scd_spline = no_genotype_spline_functions_1.no_genotype_genotype_scd_spline;
                age_oth_spline = no_genotype_spline_functions_1.no_genotype_age_oth_spline;
                cif_obj = no_genotype_baseline_hazard_1.no_genotype_cif_scd;
                prog_idx_scd_calib_factor = 1.30563989776015;
                prog_idx_oth_calib_factor = 5.84865347533236;
            } else {
                ivsd_scd_spline = genotype_spline_functions_1.genotype_ivsd_scd_spline;
                lvpwd_scd_spline = genotype_spline_functions_1.genotype_lvpwd_scd_spline;
                la_scd_spline = genotype_spline_functions_1.genotype_la_scd_spline;
                grad_scd_spline = genotype_spline_functions_1.genotype_grad_scd_spline;
                age_scd_spline = genotype_spline_functions_1.genotype_age_scd_spline;
                nsvt_scd_spline = genotype_spline_functions_1.genotype_nsvt_scd_spline;
                syncope_scd_spline = genotype_spline_functions_1.genotype_syncope_scd_spline;
                gene_scd_spline = genotype_spline_functions_1.genotype_genotype_scd_spline;
                age_oth_spline = genotype_spline_functions_1.genotype_age_oth_spline;
                cif_obj = genotype_baseline_hazard_1.genotype_cif_scd;
                prog_idx_scd_calib_factor = 1.352992544571569;
                prog_idx_oth_calib_factor = 5.84865347533236;
            }
            var age_idx = age_yr;
            var bsa = (0, z_functions_1.bsa_fml)(wgt_kg, hgt_cm);
            var ivsd_z_calc = (0, z_functions_1.ivsd_z_fml)(ivsd_mm / 10, bsa);
            var lvpwd_z_calc = (0, z_functions_1.lvpwd_z_fml)(lvpwd_mm / 10, bsa);
            var la_z_calc = (0, z_functions_1.la_systole_z_fml)(la_systole_mm / 10, bsa);
            var peak_grad_first_echo = peak_grad_mmhg;

            if (this.nsvt_pick == 1) {
                console.log("true", this.nsvt_pick);
                var non_sustained_vt = 1;
            } else {
                var non_sustained_vt = 0;
                console.log("false", this.nsvt_pick);
            }
            if (this.un_sy == 1) {
                console.log("true", this.un_sy);
                var history_syncope = 1;
            } else {
                var history_syncope = 0;
                console.log("true", this.un_sy);
            }
            var prog_idx_scd_uncal = ivsd_scd_spline(ivsd_z_calc) + lvpwd_scd_spline(lvpwd_z_calc) + la_scd_spline(la_z_calc) + grad_scd_spline(peak_grad_first_echo) + age_scd_spline(age_idx) + nsvt_scd_spline(non_sustained_vt) + syncope_scd_spline(history_syncope) + gene_scd_spline(genotype_mutation);
            var prog_idx_oth_uncal = age_oth_spline(age_idx);
            var prog_idx_scd = prog_idx_scd_calib_factor * prog_idx_scd_uncal;
            var prog_idx_oth = prog_idx_oth_calib_factor * prog_idx_oth_uncal;
            var prevBaseCumHazSCD = 0;
            var prevBaseCumHazOth = 0;
            var prevPrevBaseCumHazSCD = 0;
            var prevPrevBaseCumHazOth = 0;
            var cumulativeProdSurvPrev = 1;
            var cumulativeSumCIFSCD = 0;
            var cif_result = [];
            cif_obj.forEach(function (entry) {
                entry.hazard_scd = entry.cumhaz0_scd * Math.exp(prog_idx_scd) - prevBaseCumHazSCD * Math.exp(prog_idx_scd);
                if (entry.day_prev_evt == 0) {
                    entry.hazard_ttl = 0;
                } else {
                    entry.hazard_ttl = prevBaseCumHazSCD * Math.exp(prog_idx_scd) + prevBaseCumHazOth * Math.exp(prog_idx_oth) - (prevPrevBaseCumHazSCD * Math.exp(prog_idx_scd) + prevPrevBaseCumHazOth * Math.exp(prog_idx_oth));
                }
                prevPrevBaseCumHazSCD = prevBaseCumHazSCD;
                prevPrevBaseCumHazOth = prevBaseCumHazOth;
                prevBaseCumHazSCD = entry.cumhaz0_scd;
                prevBaseCumHazOth = entry.cumhaz0_oth;
                entry.one_minus_hazard_ttl = 1 - entry.hazard_ttl;
                cumulativeProdSurvPrev *= entry.one_minus_hazard_ttl;
                entry.surv_prev = cumulativeProdSurvPrev;
                cumulativeSumCIFSCD += entry.hazard_scd * entry.surv_prev;
                entry.cif_scd = cumulativeSumCIFSCD;
                cif_result.push(entry);
            });
            this.primacyTotalResult = (cif_result[cif_result.length - 1]['cif_scd'] * 100).toFixed(2) + "%";
            this.hcmCalculatorFormula();
            return cif_result[cif_result.length - 1]['cif_scd'];
        },
        handleIconValidatoin: function handleIconValidatoin(val) {
            if (val === 'height') {
                this.heightRangeIcon = !this.heightRangeIcon;
            }

            if (val === 'weight') {
                this.weightRangeIcon = !this.weightRangeIcon;
            }

            if (val === 'ivsd_mm') {
                this.ivsd_mmRangeIcon = !this.ivsd_mmRangeIcon;
            }

            if (val === "lvpwd_mm") {
                this.lvpwd_mmRangeIcon = !this.lvpwd_mmRangeIcon;
            }

            if (val === 'la_systole_mm') {
                this.la_systole_mmRangeIcon = !this.la_systole_mmRangeIcon;
            }

            if (val === "peak_grad_mmhg") {
                this.peak_grad_mmhgRangeIcon = !this.peak_grad_mmhgRangeIcon;
            }

            if (val === "lv_Zz_score") {
                this.lv_Zz_scoregRangeIcon = !this.lv_Zz_scoregRangeIcon;
            }

            if (val === "la_dia_score") {
                this.ladiascoreRangeIcon = !this.ladiascoreRangeIcon;
            }

            if (val === "HistoryVentricular") {
                this.HistoryVentricularRangeIcon = !this.HistoryVentricularRangeIcon;
            }

            if (val === "HistoryUnexplained") {
                this.HistoryUnexplainedRangeIcon = !this.HistoryUnexplainedRangeIcon;
            }

            if (val === "Genotypestatus") {
                this.GenotypestatusRangeIcon = !this.GenotypestatusRangeIcon;
            }

            if (val === "Genotypepositive") {
                this.GenotypepositiveRangeIcon = !this.GenotypepositiveRangeIcon;
            }

            if (val === "nonVt") {
                this.nonVtRangeIcon = !this.nonVtRangeIcon;
            }

            if (val === "UnexplainedSyncope") {
                this.UnexplainedSyncopeIcon = !this.UnexplainedSyncopeIcon;
            }

            if (val === "fhscdLabel") {
                this.fhscdIcon = !this.fhscdIcon;
            }

            if (val === "nsvtLabel") {
                this.nsvtLabelRangeIcon = !this.nsvtLabelRangeIcon;
            }

            if (val === "efLabel") {
                this.efLabelRangeIcon = !this.efLabelRangeIcon;
            }

            if (val === "aaLabel") {
                this.aaLabelRangeIcon = !this.aaLabelRangeIcon;
            }

            if (val === "lgeLabel") {
                this.lgeLabelRangeIcon = !this.lgeLabelRangeIcon;
            }
        }
    }, _defineProperty(_methods, 'handleReload', function handleReload() {

        window.location.reload();
    }), _defineProperty(_methods, 'handleChange', function handleChange(notTested) {
        if (notTested === "notTested") {
            this.genoTypePossitive = false;
            this.genotype_mutation = 0;
        } else {
            this.genoTypePossitive = true;
            this.totalResult = "";
        }
    }), _defineProperty(_methods, 'hcmCalculatorFormula', function hcmCalculatorFormula() {

        var mlvwt = this.lvpwd_mm;
        var lasize = this.la_systole_mm;
        var maxlvot = this.peak_grad_mmhg;
        var fhscd = this.fhscd_pick;
        var nsvt = this.nsvt_pick;
        var unexSyncope = this.un_sy;
        var ef50 = this.ef50_pick;
        var aa = this.apAn_pick;
        var elge = this.elge_pick;

        var a = 0.01799934 * this.userAgeValue;
        var b = 0.15939858 * mlvwt - 0.00294271 * mlvwt * mlvwt;
        var c = 0.0259082 * lasize;
        var d = 0.00446131 * maxlvot;
        var e = fhscd === 0 ? 0 : 0.4583082;
        var f = nsvt === 0 ? 0 : 0.82639195;
        var g = unexSyncope === 0 ? 0 : 0.71650361;
        var h = mlvwt <= 29 ? 0 : 1;
        var i = ef50 === 0 ? 0 : 1;
        var j = null;
        var k = b + c + d + e + f + g - a;
        var l = Math.pow(2.71828183, k);
        var m = Math.pow(0.998, l);
        var risk = 100 * (1 - m);

        var elgeYes = elge == 1;
        var aaYes = aa == 1;
        var efYes = i == 1;
        var nsvtYes = f == 0.82639195;
        var fhscdYes = e == 0.4583082;
        var usYes = g == 0.71650361;
        var mlvwtYes = h == 1;

        switch (true) {
            //Class 2A: When one parameter AND NSVT AND Extensive LGE = YES
            case elgeYes && nsvtYes && aaYes && efYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%, Apical Aneurysm, and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge, aa, ef & nsvt are yes");
                break;
            case efYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge & nsvt");
                break;
            case aaYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge & nsvt");
                break;
            case fhscdYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("fhscd, elge, nsvt are yes");
                break;
            case usYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("US, elge, nsvt are yes");
                break;
            case mlvwtYes && nsvtYes && elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("mlvwt, elge, nsvt are yes");
                break;
            case elgeYes && efYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm, EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge,ef,aa are yes");
                break;
            case nsvtYes && efYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Apical Aneursym)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge,ef,aa are yes");
                break;

            //Class 2B(a): When all parameters = NO except for NVST AND Extensive LGE
            case elgeYes && nsvtYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "This patient has 2 risk factors that while individually carry Class 2B indications, having both of these likely represents more risk than having either risk factor in isolation";
                console.log("elge & nsvt");
                break;

            //Class 2A: When any parameter AND EXTENSIVE LGE = YES
            case elgeYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("switch elge & aa");
                break;
            case elgeYes && efYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("elge & ef are yes");
                break;
            case elgeYes && fhscdYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("FHSCD and ELGE are yes");
                break;
            case elgeYes && usYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("Unexplained Syncope and ELGE are yes");
                break;
            case elgeYes && mlvwtYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("MLVWT and ELGE are yes");
                break;

            //Class 2A: When any parameter AND NVST = YES
            case nsvtYes && efYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("EF and NSVT are yes");
                break;
            case nsvtYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("EF and NSVT are yes");
                break;
            case nsvtYes && fhscdYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("FHSCD and NSVT are yes");
                break;
            case nsvtYes && usYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("Unexplained Syncope and NSVT are yes");
                break;
            case nsvtYes && mlvwtYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("MLVWT and NSVT are yes");
                break;

            //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
            case efYes && aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("EF and AA are yes");
                break;

            //Class 2B: When all parameters = NO except for NVST OR Extensive LGE
            case nsvtYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
                console.log("nsvtYes");
                break;
            case elgeYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
                console.log("elge catch all");
                break;

            //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
            case efYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("EF is Yes");
                break;
            case aaYes:
                this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("Apical aneurysm is yes");
                break;
            case fhscdYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("fhscd is yes");
                break;
            case usYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("Unexplained Syncope is Yes");
                break;
            case mlvwtYes:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
                console.log("mlvwt is yes");
                break;
            default:
                this.risk.value = risk.toFixed(2), this.recommendation = "Based on the absence of risk factors, this patient does not have an indication for an  <span class='abbr' title='Implantable Cardioverter Defibrillator'><abbr title='Implantable Cardioverter Defibrillator'>ICD</abbr></span>  (Class 3 – No Benefit)";
                console.log("all no");
                break;
        }
    }), _defineProperty(_methods, 'resetForm', function resetForm() {
        this.hgt_cm = "";
        this.wgt_kg = "";
        this.ivsd_mm = "";
        this.lvpwd_mm = "";
        this.la_systole_mm = "";
        this.peak_grad_mmhg = "";
        this.sex_range = 0;
        this.hx_nsvt = 0;
        this.hx_syncope = 0;
        this.fhscd_pick = 0;
        this.nsvt_pick = 0;
        this.unexSy_pick = 0;
        this.ef50_pick = 0;
        this.apAn_pick = 0;
        this.elge_pick = 0;
        this.non_vt = 0;
        this.elge_pick = 0;
        this.un_sy = 0;
        this.genotype_mutation = 0;
        this.genotype_mutation_yes = 0;
        this.testedStatus = "";
        this.totalResult = "";
        this.ageValidationError = "";
        this.heightValidationError = "";
        this.weightValidationError = "";
        this.ivsd_mm_validationError = "";
        this.lvpwd_mm_validationError = "";
        this.la_systole_mm_validationError = "";
        this.peak_grad_mmhg_validationError = "";
        this.isLoading = "";
        this.ageValidation = false;
        this.heightValidation = false;
        this.weightValidation = false;
        this.ivsd_mm_Validation = false;
        this.lvpwd_mm_validation = false;
        this.la_systole_mm_validation = false;
        this.peak_grad_mmhg_validation = false;
        this.heightRangeIcon = false;
        this.weightRangeIcon = false;
        this.ivsd_mmRangeIcon = false;
        this.lvpwd_mmRangeIcon = false;
        this.la_systole_mmRangeIcon = false;
        this.peak_grad_mmhgRangeIcon = false;
        this.lv_Zz_scoregRangeIcon = false;
        this.ladiascoreRangeIcon = false;
        this.HistoryVentricularRangeIcon = false;
        this.HistoryUnexplainedRangeIcon = false;
        this.GenotypestatusRangeIcon = false;
        this.GenotypepositiveRangeIcon = false;
        this.nonVtRangeIcon = false;
        this.UnexplainedSyncopeIcon = false;
        this.lgeLabelRangeIcon = false;
        this.efLabelRangeIcon = false;
        this.aaLabelRangeIcon = false, this.lgeLabelRangeIcon = false;
        this.fhscdIcon = false;

        this.mlvwt_range.value = "";
        this.lasize_range.value = "";
        this.maxlvot_range.value = "";

        this.risk.value = "";
        this.recommendation = "";
        this.isAgeValidate = false;
        this.isMlvwtValidate = false;
        this.isLasizeValidate = false;
        this.isMaxlovtValidate = false;
        this.isAgeRequired = false;
        this.isMlvwtRequired = false;
        this.isLasizeRequired = false;
        this.isMaxlvotRequired = false;
        this.ageToolTip = true;
        this.mlvwtToolTip = true;
        this.lasizeToolTip = true;
        this.maxlvotToolTip = true;
        this.fhscdToolTip = true;
        this.nsvtToolTip = true;
        this.unexSyToolTip = true;
        this.ef50ToolTip = true;
        this.apAnToolTip = true;
        this.elgeToolTip = true;
        this.fhscdIcon = false;
        this.nsvtLabelRangeIcon = false;
        this.efLabelRangeIcon = false;
        this.aaLabelRangeIcon = false;
    }), _methods),
    mounted: function mounted() {
        //this.EventBus.$emit('stepTrigger', '3');
        //console.log('children', this.$root.$children);// dont work, app as a child

        //console.log('child ',this.$children.find(child => { return child.$options.name === "aha-modal"; }))
        //console.log('Quiz',this.$refs['Quiz']);
        //console.log('Quiz Modal',this.$root);
        //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 3); // Works
        this.$root.$on("bv::modal::hidden", function ($event) {
            //console.log('evt', $event);
            //this.$root.EventBus.$emit('stepTrigger', '1');
            //this.$refs['Quiz'].EventBus.$emit('stepTrigger', 1);
        });
    },

    watch: {
        hx_syncope: function hx_syncope(newVal, oldVal) {
            if (oldVal === 0) {
                this.hx_syncope = 1;
                console.log("this.hx_syncope", this.hx_syncope);
            } else {
                this.hx_syncope - 0;
            }
        }
    }
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
    props: {
        saveEndpoint: {
            type: String,
            required: true
        },
        getEndpoint: {
            type: String,
            required: true
        },
        saveButtonText: {
            type: String,
            "default": "Save"
        },
        savedButtonText: {
            type: String,
            "default": "Saved"
        }
    },
    data: function data() {
        return {
            toggleSaveBtn: false,
            alreadSaved: false
        };
    },
    mounted: function mounted() {
        window.addEventListener("globalFunctionTriggered", this.updateComponent);
    },
    beforeUnmount: function beforeUnmount() {
        window.removeEventListener("globalFunctionTriggered", this.updateComponent);
    },

    methods: {
        updateComponent: function updateComponent(event) {
            if (event.detail.data !== undefined) {
                this.alreadSaved = event.detail.data;
                this.toggleSaveBtn = event.detail.data;
                console.log("Updated component state:", event.detail.data);
            }
        },
        handleSaveVideo: function handleSaveVideo(actionType) {
            var _this = this;

            var videoElement = document.getElementById("videoItemId");
            var categoryElement = document.getElementById("videoCategoryId");
            if (!videoElement || !categoryElement) {
                console.error("Video ID or Category ID not found.");
                return;
            }
            var videoid = videoElement.Value;
            var videocategoryid = categoryElement.Value;
            _axios2["default"].post(this.saveEndpoint, {
                videos: [{
                    videoId: videoid,
                    categoryId: videocategoryid
                }],
                isdelete: actionType === "savedVideo"
            }).then(function (res) {
                if (res.data) {
                    _this.toggleSaveBtn = true;
                }
            })["catch"](function (err) {
                console.error("Error:", err);
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        componentTitle: { type: String, "default": "" },
        editLabel: { type: String, "default": "" },
        removeLabel: { type: String, "default": "" },
        filterLabel: { type: String, "default": "" },
        filterAllContent: { type: String, "default": "All" },
        selectLabel: { type: String, "default": "" },
        savedVideos: { type: Array, "default": function _default() {
                return [];
            } },
        saveEndpoint: { type: String, "default": "" },
        filterDropdownValues: { type: [Array, String], "default": function _default() {
                return [];
            } }
    },
    data: function data() {
        return {
            editSection: true,
            selectedVideos: { videos: [], isdelete: true },
            selectedCategory: "All",
            selectedVideoUrl: "",
            selectedVideoTitle: "",
            selectedVideoTeaser: "",
            videofullcontentlink: "",
            isModalOpen: false
        };
    },

    computed: {
        filteredVideos: function filteredVideos() {
            var _this = this;

            var videos = this.savedVideos;
            if (typeof videos === "string") {
                try {
                    videos = JSON.parse(videos);
                } catch (error) {
                    console.error("Invalid JSON format for savedVideos:", error);
                    return [];
                }
            }
            if (!Array.isArray(videos)) {
                console.error("savedVideos is not an array:", videos);
                return [];
            }
            if (this.selectedCategory !== "All") {
                videos = videos.filter(function (video) {
                    return video.VideoCategory.trim() === _this.selectedCategory.trim();
                });
            }
            var videoMap = new Map();
            videos.forEach(function (video) {
                videoMap.set(video.VideoId, video);
            });
            return Array.from(videoMap.values());
        },
        parsedDropdownValues: function parsedDropdownValues() {
            try {
                if (typeof this.filterDropdownValues === "string") {
                    return JSON.parse(this.filterDropdownValues).map(function (item) {
                        return item.replace(/&#160;/g, " ");
                    });
                } else if (Array.isArray(this.filterDropdownValues)) {
                    return this.filterDropdownValues.map(function (item) {
                        return item.replace(/&#160;/g, " ");
                    });
                }
                return [];
            } catch (error) {
                console.error("Error parsing filterDropdownValues:", error);
                return [];
            }
        }
    },
    methods: {
        toggleEditSection: function toggleEditSection() {
            this.editSection = !this.editSection;
        },
        handleRemoveVideos: function handleRemoveVideos() {
            _axios2["default"].post(this.saveEndpoint, this.selectedVideos).then(function (res) {
                console.log("Response:", res);
                window.location.reload();
            })["catch"](function (err) {
                console.error("Error:", err);
            });
        },
        handleSelectedVideos: function handleSelectedVideos(videoId, categoryid) {
            var index = this.selectedVideos.videos.findIndex(function (v) {
                return v.videoId === videoId;
            });
            if (index === -1) {
                this.selectedVideos.videos = [].concat(_toConsumableArray(this.selectedVideos.videos), [{ videoId: videoId, categoryid: categoryid }]);
            } else {
                this.selectedVideos.videos = this.selectedVideos.videos.filter(function (v) {
                    return v.videoId !== videoId;
                });
            }
        },
        openModal: function openModal(video) {
            if (video) {
                this.selectedVideoUrl = video.VideoUrl;
                this.selectedVideoTitle = video.Title;
                this.selectedVideoTeaser = video.Teaser;
                this.videofullcontentlink = video.VideoFullContentLink;
                this.showModal(); // Function to open the modal
            }
        },
        showModal: function showModal() {
            this.$root.$emit("bv::show::modal", "save-video-modal");
        },
        handelCancel: function handelCancel() {
            this.editSection = !this.editSection;
        }
    },
    watch: {
        isModalOpen: function isModalOpen(newVal) {
            if (!newVal) {
                this.selectedVideoUrl = ""; // Stop video when modal closes
            }
        }
    }
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
    props: {
        buttonText: {
            type: String,
            "default": "Save Video"
        },
        saveEndpoint: {
            type: String,
            required: true
        },
        videoId: {
            type: String,
            required: true
        },
        categoryId: {
            type: String,
            required: true
        },
        savedButtonText: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            toggleSaveBtn: false
        };
    },

    methods: {
        handleSaveVideo: function handleSaveVideo() {
            var _this = this;

            _axios2["default"].post(this.saveEndpoint, {
                videos: [{
                    videoId: this.videoId,
                    categoryid: this.categoryId
                }],
                isdelete: false
            }).then(function () {
                _this.toggleSaveBtn = true;
            })["catch"](function (err) {
                console.error("Error:", err);
            });
        }
    }
}; //
//
//
//
//
//
//

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
    props: {
        resetContentText: {
            type: String,
            "default": ""
        },
        resetContentButtonText: {
            type: String,
            "default": ""
        },
        resetContentSuccessMessage: {
            type: String,
            "default": ""
        },
        resetContentErrorMessage: {
            type: String,
            "default": ""
        },
        resetContentEndpoint: {
            type: String,
            "default": ""
        }
    },
    data: function data() {
        return {
            successMsg: false,
            errorMesg: false
        };
    },

    methods: {
        handleAPICall: function handleAPICall() {
            var _this = this;

            _axios2["default"].post("" + this.resetContentEndpoint).then(function (res) {
                console.log(res);
                _this.errorMesg = false;
                _this.successMsg = true;
            })["catch"](function (err) {
                console.log(err);
                _this.errorMesg = true;
                _this.successMsg = false;
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_funding_opportunities_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_funding_opportunities_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_funding_opportunities_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_funding_opportunities_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_funding_opportunities_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5986f381_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_search_funding_opportunities_vue__ = __webpack_require__(510);
function injectStyle (ssrContext) {
  __webpack_require__(508)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_search_funding_opportunities_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5986f381_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_search_funding_opportunities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = {
    props: {
        results: {
            type: Array,
            required: true
        },
        dropDownValues: {
            type: Array,
            required: true
        },
        translations: {
            type: Object,
            required: true
        },
        pageSize: {
            type: Number,
            required: true
        },
        searchEndpoint: {
            type: String,
            required: true
        },
        noResultsMessage: {
            type: String,
            required: true
        }

    },
    data: function data() {
        return {
            currentPageNo: 1,
            pageSize: this.pageSize, // Default number of results per page
            selectedCategory: "",
            searchText: "",
            formDate: "",
            toDate: "",
            validationDate: false,
            totalLength: 0
        };
    },

    computed: {
        parsedResult: function parsedResult() {
            console.log('translations', this.translations);
            // Check if this.results is defined and not null
            if (this.results == null) {
                this.totalLength = 0; // Set totalLength to 0 for null results
                return null; // Return null for empty results
            }

            // Check if this.results is a string
            if (typeof this.results === "string") {
                // Handle encoded quotes
                if (this.results.includes("&quot;")) {
                    var decodedString = this.results.replace(/&quot;/g, '"');
                    var parsedData = JSON.parse(decodedString);
                    this.totalLength = Array.isArray(parsedData) ? parsedData.length : Object.keys(parsedData).length;
                    return parsedData;
                } else {
                    // Attempt to parse directly if no encoded quotes are found
                    try {
                        var _parsedData = JSON.parse(this.results);
                        this.totalLength = Array.isArray(_parsedData) ? _parsedData.length : Object.keys(_parsedData).length;
                        return _parsedData;
                    } catch (error) {
                        console.error("Error parsing JSON:", error);
                        this.totalLength = 0; // Reset totalLength on parse error
                        return null; // Return null if parsing fails
                    }
                }
            } else if (Array.isArray(this.results)) {
                // If this.results is already an array, calculate totalLength
                this.totalLength = this.results.length;
                return this.results;
            } else if (_typeof(this.results) === "object" && this.results !== null) {
                // If this.results is an object, calculate totalLength based on keys
                this.totalLength = Object.keys(this.results).length;
                return this.results;
            } else {
                // Handle unexpected types
                this.totalLength = 0; // Reset totalLength for unexpected types
                return null; // Return null for unexpected types
            }
        },
        parsedDropdownValues: function parsedDropdownValues() {
            var decodedString = this.dropDownValues.replace(/&quot;/g, '"');
            return JSON.parse(decodedString);
        },
        labelUpdated: function labelUpdated() {
            var decodedString = this.translations.replace(/&quot;/g, '"');
            return JSON.parse(decodedString);
        },
        paginatedResults: function paginatedResults() {
            var start = (this.currentPageNo - 1) * this.pageSize;
            var end = start + this.pageSize;
            return this.parsedResult.slice(start, end);
        },
        totalPages: function totalPages() {
            return Math.ceil(this.parsedResult.length / this.pageSize);
        }
    },
    methods: {
        handleSearchResult: function handleSearchResult() {
            var _this = this;

            // console.log ( this.pageSize, this.searchText, this.selectedCategory, this.c, this.toDate)
            //this.validationDate = this.toDate <= this.formDate;

            if (this.formDate !== "" && this.toDate !== "") {
                if (this.toDate <= this.formDate) {
                    this.validationDate = true;
                } else {
                    this.validationDate = false;
                }
            }

            _axios2["default"].post(this.searchEndpoint + "?pageSize=" + this.pageSize + "&searchText=" + this.searchText + "&category=" + this.selectedCategory + "&fromDate=" + this.formDate + "&toDate=" + this.toDate).then(function (res) {
                _this.results = res.data;
                var parsed = _this.parsedResult("json");
                console.log(parsed);
            })["catch"](function (err) {
                return console.log(err);
            });
        },
        handleClearFilter: function handleClearFilter() {
            this.searchText = "";
            this.selectedCategory = "";
            this.toDate = "";
            this.formDate = "";
            this.validationDate = false;
            this.handleSearchResult();
        },
        setPage: function setPage(page) {
            this.currentPageNo = page;
        },
        prevPage: function prevPage() {
            if (this.currentPageNo > 1) {
                this.currentPageNo--;
            }
        },
        nextPage: function nextPage() {
            if (this.currentPageNo < this.totalPages) {
                this.currentPageNo++;
            }
        },
        setPageSize: function setPageSize(size) {
            this.pageSize = size;
            this.currentPageNo = 1; // Reset to the first page when page size changes
        }
    }
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        trialContent: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            tableData: {}
        };
    },
    beforeMount: function beforeMount() {
        this.tableData = this.trialContent;
    }
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    name: 'selector',
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            activeItem: 'journals',
            tierId: null,
            mobile: window.innerWidth <= 700

        };
    },
    created: function created() {
        if (this.mobile) {
            this.activeItem = ' ';
        }
    },

    methods: {
        isActive: function isActive(menuItem) {
            return this.activeItem === menuItem;
        },
        setActive: function setActive(menuItem) {
            this.activeItem = menuItem;
            if (this.activeItem === 'guidelines') {
                console.log('guidelines');
            }
        },
        onHidden: function onHidden() {
            console.log("closed");
            this.activeItem = '';
        }
    },
    mounted: function mounted() {
        this.tierId = this.safeId('__PHD_selector_');
        console.log(this.tierId);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        tables: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            theData: []
        };
    },
    beforeMount: function beforeMount() {
        this.theData = this.tables;
    }
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        tableData: {
            // example data can be found:
            // demo\pages\components\phd-membership-rate-comparison.vue
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            theData: {}
        };
    },
    beforeMount: function beforeMount() {
        this.theData = this.tableData;
    },

    computed: {
        numberOfDataColumns: function numberOfDataColumns() {
            var count = this.theData.rateText.length;

            return count;
        },
        columnCountClass: function columnCountClass() {
            var className = '';

            switch (this.numberOfDataColumns) {
                case 1:
                    className = "data-column-count--one";
                    break;
                case 2:
                    className = "data-column-count--two";
                    break;
            }

            return className;
        }
    }
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        scData: {
            // example data can be found:
            // demo\components\phd\phd-left-nav-demo.vue
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            menuData: {}
        };
    },
    beforeMount: function beforeMount() {
        this.menuData = this.scData;
    },

    methods: {
        findActiveItem: function findActiveItem() {
            var activeText = "Menu";

            for (var i = 0; i < this.menuData.length; i++) {
                var thisItem = this.menuData[i];
                if (thisItem.active) {
                    activeText = thisItem.text;
                    break;
                }
            }

            return activeText;
        }
    }
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        navData: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            theData: []
        };
    },
    beforeMount: function beforeMount() {
        this.theData = this.navData;

        this.detectActiveItem();
    },

    directives: {
        'click-outside': {
            bind: function bind(el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    // here I check that click was outside the el and his childrens
                    if (!(el == event.target || el.contains(event.target))) {
                        // and if it did, call method provided in attribute value
                        vnode.context[binding.expression](event);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unbind: function unbind(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            } // click-outside
        } },
    methods: {
        detectActiveItem: function detectActiveItem() {
            // The purpose of this method is to check for the existance of ANY active item.  If any item in any sub-nav is active, we do nothing.  If nothing is active, we need to make the very first item active so that things will work properly on mobile.
            var somethingIsTrue = false;

            // Looping through all navigation items
            for (var i = 0; i < this.theData.navItems.length; i++) {
                // creating a variable for the current group of subNav items
                var childGroup = this.theData.navItems[i].subNav;

                if (childGroup !== "" && childGroup !== undefined && childGroup !== null) {
                    for (var ii = 0; ii < childGroup.length; ii++) {
                        if (childGroup[ii].active === true) {
                            // we found an active item
                            somethingIsTrue = true;
                            // we can stop looping now
                            break;
                        } // end if
                    } // end for

                    if (somethingIsTrue === true) {
                        break;
                    } // end if
                } // end if
            } // end for

            if (somethingIsTrue !== true) {
                // There aren't any active items, so let's make the first one active
                this.theData.navItems[0].subNav[0].active = true;
            }
        },
        showAll: function showAll() {
            this.theData.showAll = true;
        },
        hideAll: function hideAll() {
            this.theData.showAll = false;
            for (var i = 0; i < this.theData.navItems.length; i++) {
                this.theData.navItems[i].open = false;
            }
        },
        closeAllTertiary: function closeAllTertiary() {
            for (var i = 0; i < this.theData.navItems.length; i++) {
                this.theData.navItems[i].open = false;
            }
        },
        handleSecondaryNavClick: function handleSecondaryNavClick(itemIndex) {
            var _this = this;

            if (this.theData.showAll === false && window.innerWidth < 992) {
                this.showAll();
            } else {
                if (this.theData.navItems[itemIndex].open === true) {
                    this.theData.navItems[itemIndex].open = false;
                } else {
                    var strRef = 'secondary-dropdown-' + itemIndex + '_tertiary-item-0';
                    this.closeAllTertiary();
                    this.theData.navItems[itemIndex].open = true;

                    this.$nextTick(function () {
                        _this.$refs[strRef][0].focus();
                    });
                }
            }
        },
        findActiveChild: function findActiveChild(index) {
            // loop through parents children to figure out if this parent is active
            // this.navData.navItems[i].subNav
            var isActive = false;
            var subNav = this.navData.navItems[index].subNav;

            if (subNav !== "" && subNav !== undefined && subNav !== null) {
                for (var i = 0; i < subNav.length; i++) {
                    var subNavItem = subNav[i];

                    if (subNavItem.active === true) {
                        isActive = subNavItem.active;
                        break;
                    }
                } // end for loop

                return isActive;
            } // end if
        },
        // end findActiveChild(index)
        handleSecondaryUp: function handleSecondaryUp(index) {
            var thisItem = this.theData.navItems[index];
            if (thisItem.open) {
                // pressing up arrow on secondary nav level when tertiary is open shoud close it.
                this.theData.navItems[index].open = false;
                var strRef = 'secondary-dropdown-' + index;
                this.$refs[strRef][0].focus();
            }
        },
        handleSecondaryDown: function handleSecondaryDown(index) {
            var _this2 = this;

            var thisItem = this.theData.navItems[index];
            var strRef = 'secondary-dropdown-' + index + '_tertiary-item-0';
            if (thisItem.open) {
                // pressing down arrow on secondary nav level when tertiary is open should transfer focus to first link inside tertiary
                this.$refs[strRef][0].focus();
            } else {
                // Else it will open the tertiary nav and ensure the first subnav item is focused
                this.closeAllTertiary();
                this.theData.navItems[index].open = true;

                this.$nextTick(function () {
                    _this2.$refs[strRef][0].focus();
                });
            }
        },

        // todo here: handle left & right arrow keys for secondary, then handle all directions for tertiary.  excellent resource: https://www.youtube.com/watch?v=SGVSvi1OxE8
        handleEscape: function handleEscape(index) {
            var thisItem = this.theData.navItems[index];
            if (thisItem.open) {
                this.theData.navItems[index].open = false;
                var strRef = 'secondary-dropdown-' + index;
                this.$refs[strRef][0].focus();
            }
        },
        handleTab: function handleTab(subIndex, length) {
            if (subIndex + 1 === length) {
                this.closeAllTertiary();
            }
        },
        handleSecondaryPrevious: function handleSecondaryPrevious(index, length) {
            var thisItem = this.theData.navItems[index];
            var strRef = 'secondary-dropdown-' + (index - 1);

            if (index === 0) {
                return;
            }

            if (thisItem.open) {
                this.theData.navItems[index].open = false;
            }

            this.$refs[strRef][0].focus();
        },
        handleSecondaryNext: function handleSecondaryNext(index, length) {
            var thisItem = this.theData.navItems[index];
            var strRef = 'secondary-dropdown-' + (index + 1);

            if (index + 1 === length) {
                return;
            }

            if (thisItem.open) {
                this.theData.navItems[index].open = false;
            }

            this.$refs[strRef][0].focus();
        },
        handleTertiaryPrevious: function handleTertiaryPrevious(index, length, subIndex) {
            var strRef = 'secondary-dropdown-' + index + '_tertiary-item-' + (subIndex - 1);

            if (subIndex === 0) {
                this.handleSecondaryUp(index);
                return;
            }

            this.$refs[strRef][0].focus();
        },
        handleTertiaryNext: function handleTertiaryNext(index, length, subIndex) {
            var strRef = 'secondary-dropdown-' + index + '_tertiary-item-' + (subIndex + 1);

            if (subIndex + 1 === length) {
                return;
            }

            this.$refs[strRef][0].focus();
        }
    }
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        heading: {
            type: String,
            required: true
        },
        headingLevel: {
            type: String,
            "default": "1"
        },
        description: {
            type: String,
            required: false
        },
        link: {
            type: Object,
            required: false
        }
    },
    data: function data() {
        return {};
    }
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _props, _watch;

var _memberTierSelectorTab = __webpack_require__(533);

var _memberTierSelectorTab2 = _interopRequireDefault(_memberTierSelectorTab);

var _memberTierSelectorPanel = __webpack_require__(535);

var _memberTierSelectorPanel2 = _interopRequireDefault(_memberTierSelectorPanel);

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaLoadingSpinner = __webpack_require__(42);

var _ahaLoadingSpinner2 = _interopRequireDefault(_ahaLoadingSpinner);

var _keyCodes = __webpack_require__(75);

var _keyCodes2 = _interopRequireDefault(_keyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    name: "member-tier-selector",
    mixins: [_ahaId2["default"]],
    components: {
        "selector-tab": _memberTierSelectorTab2["default"],
        "selector-panel": _memberTierSelectorPanel2["default"],
        "aha-loading-spinner": _ahaLoadingSpinner2["default"]
    },
    props: (_props = {
        uri: {
            type: String,
            "default": ""
        },
        flowType: {
            type: String,
            "default": "new"
        },
        promomsg: {
            type: String,
            "default": "Have a promo code?"
        }
    }, _defineProperty(_props, "promomsg", {
        type: String,
        "default": "Have a promo code?"
    }), _defineProperty(_props, "promoModalHeader", {
        type: String,
        "default": "Processing Request"
    }), _defineProperty(_props, "promoModalMessage", {
        type: String,
        "default": "Associating promo code to order."
    }), _defineProperty(_props, "promoCodeSession", {
        type: String,
        "default": ""
    }), _defineProperty(_props, "warningmessage", {
        type: String,
        "default": ""
    }), _defineProperty(_props, "loadingMessage", {
        type: String,
        "default": "Getting Member Levels"
    }), _defineProperty(_props, "icons", {
        type: Object,
        "default": function _default() {
            return {};
        }
    }), _defineProperty(_props, "secondarylinks", {
        type: Object,
        "default": function _default() {
            return {};
        }
    }), _defineProperty(_props, "componentTitle", {
        type: String,
        "default": "Professional Membership"
    }), _defineProperty(_props, "orderinprogress", {
        type: Boolean,
        "default": false
    }), _defineProperty(_props, "disableSignup", {
        type: Boolean,
        "default": false
    }), _defineProperty(_props, "componentSubheader", {
        type: String,
        "default": false
    }), _defineProperty(_props, "stGraduationYear", {
        type: String,
        "default": ""
    }), _defineProperty(_props, "ecCompletionTerm", {
        type: String,
        "default": ""
    }), _props),
    data: function data() {
        var _ref;

        return _ref = {
            componentId: null,
            activeItem: "1",
            tierId: null,
            tiercode: "",
            mobile: window.innerWidth <= 700,
            promoCode: null,
            isPromoCodeValid: false,
            tiers: [],
            tiersPromo: [],
            isLoading: true,
            isLoadingPromo: false,
            errorMsg: "",
            promoMsgFromApi: "",
            promoVisible: false,
            earlyCareerTerm: "0",
            termRemaining: null,
            signupUri: {
                base: "/phpapiproxy/signup",
                "default": "",
                upgrade: ""
            },
            referrer: "",
            timer: "",
            timerInterval: 10000,
            computedFlowType: this.flowType,
            tabs: [],
            currentTab: 0,
            tabsInitialized: false,
            signUpButtonText: "Join or Renew",
            selectedOption: null,
            dropdownOptions: [],
            studentModal: false,
            membershipContent: "",
            userSelectTierModal: "",
            headerOfModal: ""
        }, _defineProperty(_ref, "membershipContent", ""), _defineProperty(_ref, "selectedTier", null), _defineProperty(_ref, "earlyCareerTermValidation", false), _ref;
    },
    created: function created() {
        // Polyfill for nodelist foreach IE
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        if (this.mobile) {
            this.activeItem = " ";
        }
    },

    computed: {
        title: function title() {
            return this.componentTitle.trim() !== "" ? this.componentTitle : "Professional Membership";
        },
        loadingmsg: function loadingmsg() {
            return this.loadingMessage.trim() !== "" ? this.loadingMessage : "Getting Member Levels";
        },
        filteredTiers: function filteredTiers() {
            if (this.tiers.length > 0) {
                return this.tiers.slice(0, -1);
            }
        }
    },
    methods: {
        earlyCarrerTermSelector: function earlyCarrerTermSelector() {
            if (this.earlyCareerTerm !== "0") {
                this.earlyCareerTermValidation = false;
            } else {
                this.earlyCareerTermValidation = true;
            }
        },
        studentTraineeDropDown: function studentTraineeDropDown() {
            if (this.selectedOption !== null) {
                this.studentModal = false;

                this.setSignupUriDefault(this.activeItem, this.promoCode, this.earlyCareerTerm, this.referrer, this.computedFlowType, this.selectedOption);
            } else {
                this.studentModal = true;
            }
        },
        fetchDropdownOptions: function fetchDropdownOptions() {
            var _this = this;

            setTimeout(function () {
                var newData = [{
                    value: null,
                    label: "Select Graduation or Fellowship Completion Year"
                }, { value: "2025", label: "2025" }, { value: "2026", label: "2026" }, { value: "2027", label: "2027" }, { value: "2028", label: "2028" }, { value: "2029", label: "2029" }, { value: "2030", label: "2030" }, { value: "2031", label: "2031" }, { value: "2032", label: "2032" }, { value: "2033", label: "2033" }, { value: "2034", label: "2034" }, { value: "2035", label: "2035" }];

                // Update the dropdownOptions array
                _this.dropdownOptions = newData;

                // Optionally, set a default selected value
                _this.selectedOption = newData[0].value;
            }, 500); // Simulating a delay of 1 second (adjust as needed)
        },
        handleDropdownChange: function handleDropdownChange() {
            if (this.selectedOption !== null) {
                this.studentModal = false;
            } else {
                this.studentModal = true;
            }
        },
        handleSelectTier: function handleSelectTier(tierId) {
            this.selectedTier = tierId;
            this.activeItem = tierId;
        },
        handleAdditionModalBenefits: function handleAdditionModalBenefits(code, featuresBenefits, name) {
            if (code === "EC") {
                this.$root.$emit("bv::show::modal", "ecTwo-membership-featureBenfits-modal");
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            } else if (code === "PS") {
                this.$root.$emit("bv::show::modal", "ps-membership-featureBenfits-modal");
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            } else if (code === "PP") {
                this.$root.$emit("bv::show::modal", "pp-membership-featureBenfits-modal");
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            } else if (code === "GM") {
                this.$root.$emit("bv::show::modal", "gm-membership-featureBenfits-modal");
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            } else if (code === "ST") {
                this.$root.$emit("bv::show::modal", "st-membership-featureBenfits-modal");
                this.membershipContent = featuresBenefits;
                this.userSelectTierModal = name;
                this.headerOfModal = name;
            }
        },
        fetchData: function fetchData() {
            var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/PhpApiProxy/GetMemberTierAsync";

            var _this2 = this;

            var flowType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "new";
            var promoCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = void 0;

            if (promoCode !== null) {
                raw = JSON.stringify({
                    flowType: flowType,
                    promoCode: promoCode
                });
                // console.log("RAW BODY: ", raw);
            } else {
                raw = JSON.stringify({
                    flowType: flowType
                });
            }

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch(uri, requestOptions).then(function (response) {
                if (response.ok) {
                    response.json().then(function (data) {
                        _this2.tiers = data.result.tiers;
                        _this2.setActive(String(_this2.tiers[0].id), String(_this2.tiers[0].code));
                        _this2.promoMsgFromApi = data.result.promoCodeMessage;
                        _this2.isPromoCodeValid = data.result.isPromoValid;
                        _this2.promoCode = data.result.promoCode;
                        _this2.isLoading = false;
                        _this2.cancelTimer(); //clear interval on success
                        if (_this2.isLoadingPromo === true) {
                            _this2.isLoadingPromo = false;
                            _this2.completePromoCodeDataFetch();
                        }

                        // Tabs keyboard accessibility
                        // Initialize tabs - create an array of tabs when data is loaded
                        _this2.$nextTick(function () {
                            if (_this2.tabsInitialized === false) {
                                _this2.initalizeTabsKeyboarding();
                                _this2.tabsInitialized = true;
                            }
                        });
                    });
                } else {
                    throw Error(response.status + " " + response.statusText);
                }
            })
            // uncomment for prod
            ["catch"](function (error) {
                _this2.errorMsg = error;
                console.log(error);
            });
            //testing only
            // ANCHOR: LOCAL DATA
            //.catch((error) => this.fetchLocalMembershipData());
        },
        fetchLocalMembershipData: function fetchLocalMembershipData() {
            var _this3 = this;

            fetch("./data/upgrade.json").then(function (response) {
                if (response.ok) {
                    response.json().then(function (data) {
                        _this3.tiers = data.result.tiers;
                        _this3.setActive(String(_this3.tiers[0].id), String(_this3.tiers[0].code));
                        _this3.promoMsgFromApi = data.result.promoCodeMessage;
                        _this3.isPromoCodeValid = data.result.isPromoValid;
                        _this3.promoCode = data.result.promoCode;
                        _this3.isLoading = false;
                        _this3.cancelTimer(); //clear interval on success
                        if (_this3.isLoadingPromo === true) {
                            _this3.isLoadingPromo = false;
                            _this3.completePromoCodeDataFetch();
                        }

                        // Tabs keyboard accessibility
                        // Initialize tabs - create an array of tabs when data is loaded
                        _this3.$nextTick(function () {
                            if (_this3.tabsInitialized === false) {
                                _this3.initalizeTabsKeyboarding();
                                _this3.tabsInitialized = true;
                            }
                        });
                    });
                } else {
                    throw Error(response.statusText);
                }
            })["catch"](function (error) {
                console.log("Error:", error);
            });
        },
        isActive: function isActive(tierid) {
            return this.activeItem === tierid;
        },
        setActive: function setActive(tierid, tiercode) {
            var _this4 = this;

            this.activeItem = tierid;
            this.tiercode = tiercode;

            this.tabs.forEach(function (t, index) {
                if (t.dataset.tierId == _this4.activeItem) {
                    _this4.currentTab = index;
                }
            });
        },
        onHidden: function onHidden() {
            this.activeItem = "";
        },
        onPromoCodeSubmit: function onPromoCodeSubmit() {
            // ANCHOR: Promo Submit
            this.$root.$emit("bv::show::modal", "loadingModal");

            this.$root.$emit("bv::toggle::collapse", "collapse-promo-code");
            var promoBtn = document.querySelector(".c-promo-code .c-promo-code__btn");
            var enteredPromoCode = document.getElementById("inputPromoCode").value;

            this.fetchData(this.uri, this.computedFlowType, enteredPromoCode);
            this.isLoadingPromo = true;
        },
        completePromoCodeDataFetch: function completePromoCodeDataFetch() {
            var _this5 = this;

            setTimeout(function () {
                _this5.$root.$emit("bv::hide::modal", "loadingModal");
                _this5.$refs.formpromo.reset();
                if (_this5.promoCode !== null) {
                    _this5.showHidePromoAppliedDisplay("show");
                }
            }, 1500);
        },
        onDataReset: function onDataReset() {
            this.$root.$emit("bv::show::modal", "loadingModal");
            this.promoCode = null;
            this.isLoadingPromo = true;
            this.fetchData(this.uri, this.computedFlowType, this.promoCode);
        },
        setEarlyCareerTerm: function setEarlyCareerTerm(num) {
            this.earlyCareerTerm = num;
            this.setSignupUriDefault(4, encodeURIComponent(this.promoCode), num, this.referrer, this.computedFlowType || "new");
        },
        onSignUp: function onSignUp(evt) {
            // ANCHOR: Signup
            evt.preventDefault();
            if (this.orderinprogress) return;
            var _code = evt.target.dataset["tierCode"];
            var _tierid = evt.target.dataset["tierId"];
            var _termRemaining = evt.target.dataset["termRemaining"];

            // EC
            if (_termRemaining && _code !== "ST") {
                this.termRemaining = evt.target.dataset["termRemaining"];
            } else {
                this.termRemaining = null;
            }

            // console.log(evt.target.dataset);
            this.setSignupUriDefault(_tierid, encodeURIComponent(this.promoCode), this.earlyCareerTerm, this.referrer, this.computedFlowType || "new", this.selectedOption);

            if (this.tiers.length === 1) {
                window.location.href = this.signupUri["default"];
            } else {

                if (_code === "EC") {
                    this.handleEarlyTraining();
                } else if (_code === "GM") {
                    this.$root.$emit("bv::show::modal", "gp-upgrade-modal");
                    this.signupUri.upgrade = this.signupUri.base + "?tierId=2&promoCode=" + this.promoCode + "&earlyCareerTerm=" + this.earlyCareerTerm + "&ru=" + this.referrer + "&flowType=" + this.computedFlowType;
                } else if (_code === "ST") {
                    this.handleStudentTrainee();
                } else {
                    //go to new location
                    window.location.href = this.signupUri["default"];
                }
            }

            // if (_code === "EC") {
            //   this.earlyCareerTerm = 1;
            // } else {
            //   this.earlyCareerTerm = 0;
            // }
        },
        handleEarlyTraining: function handleEarlyTraining() {
            if (this.ecCompletionTerm === "") {
                this.$root.$emit("bv::show::modal", "ec-membership-modal");
            } else {
                // this.signupUri.default = `${this.signupUri.base}?tierId=${this.activeItem}&promoCode=${this.promoCode}&earlyCareerTerm=${this.ecCompletionTerm}&ru=${this.referrer}&flowType=${this.computedFlowType}&STGraduationYear=${this.selectedOption}`;
                window.location.href = this.signupUri.base + "?tierId=" + this.activeItem + "&promoCode=" + this.promoCode + "&earlyCareerTerm=" + this.ecCompletionTerm + "&ru=" + this.referrer + "&flowType=" + this.computedFlowType + "&STGraduationYear=" + this.selectedOption;
            }
        },
        handleStudentTrainee: function handleStudentTrainee() {
            if (this.stGraduationYear === "") {
                this.$root.$emit("bv::show::modal", "st-membership-modal");
            } else {
                //this.signupUri.default = `${this.signupUri.base}?tierId=${this.activeItem}&promoCode=${this.promoCode}&earlyCareerTerm=${this.earlyCareerTerm}&ru=${this.referrer}&flowType=${this.computedFlowType}&STGraduationYear=${this.stGraduationYear}`;
                window.location.href = this.signupUri.base + "?tierId=" + this.activeItem + "&promoCode=" + this.promoCode + "&earlyCareerTerm=" + this.earlyCareerTerm + "&ru=" + this.referrer + "&flowType=" + this.computedFlowType + "&STGraduationYear=" + this.stGraduationYear;
            }
        },
        setSignupUriDefault: function setSignupUriDefault(_activeItem, _promocode, _ec, _referrer, flowType, selectOption) {
            this.signupUri["default"] = this.signupUri.base + "?tierId=" + _activeItem + "&promoCode=" + _promocode + "&earlyCareerTerm=" + _ec + "&ru=" + _referrer + "&flowType=" + flowType + "&STGraduationYear=" + selectOption;
        },
        getTierIcon: function getTierIcon(_tiercode) {
            var code = _tiercode;
            var icons = this.icons.membershipicons;
            var icon_path = "";
            if (icons) {
                icons.forEach(function (icon) {
                    if (icon.code === code) {
                        icon_path = icon.path;
                    }
                });
            }

            return icon_path;
        },
        getReferrer: function getReferrer() {
            function getUrlParameter(name) {
                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
                var results = regex.exec(location.search);
                // return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
                return results === null ? "" : results[1];
            }

            this.referrer = getUrlParameter("ru");
            //this.computedFlowType = getUrlParameter('flowType') || this.computedFlowType; //this is changing the flowType prop
            if (getUrlParameter("c")) {
                this.computedFlowType = getUrlParameter("flowType");
            }
            if (this.promoCodeSession === "") {
                this.promoCode = getUrlParameter("promoCode") || null;
            } else {
                this.promoCode = this.promoCodeSession;
            }
        },
        closePromoCodeAppliedDisplay: function closePromoCodeAppliedDisplay($evt) {
            this.showHidePromoAppliedDisplay("hide");
            if (this.isPromoCodeValid === true) {
                this.onDataReset();
            }
        },
        showHidePromoAppliedDisplay: function showHidePromoAppliedDisplay(state) {
            // state = 'show', 'hide'
            var _state = state;
            var _el = document.querySelector(".c-promo-code__display-wrapper");
            var _className = "d-none";

            if (_state === "hide") {
                _el.classList.add(_className);
            } else {
                if (_el.classList.contains(_className)) {
                    _el.classList.remove(_className);
                }
            }
        },
        cancelTimer: function cancelTimer() {
            clearInterval(this.timer);
        },
        onPromoCodeKeydown: function onPromoCodeKeydown(event) {
            // esc to close
            // if (event.keyCode === KeyCodes.ESC || event.key === "Escape") {
            //   this.promoVisible = false;
            // }
            // Down arrow to expand
            if (event.keyCode === _keyCodes2["default"].DOWN || event.key === "ArrowDown") {
                event.preventDefault();
                this.promoVisible = true;
            }
        },
        onKeynav: function onKeynav(evt) {
            // ANCHOR: Keyboard Nav
            // Tab item keyboarding
            var key = evt.keyCode;
            var shift = evt.shiftKey;

            function stop() {
                evt.preventDefault();
                evt.stopPropagation();
            }

            if (key === _keyCodes2["default"].UP || key === _keyCodes2["default"].LEFT) {
                stop();
                this.previousTab();
            } else if (key === _keyCodes2["default"].DOWN || key === _keyCodes2["default"].RIGHT) {
                stop();
                this.nextTab();
            }
        },
        setTab: function setTab(index) {
            var _this6 = this;

            // ANCHOR: SET TAB
            index = index || 0;
            // Prevent setting same tab
            if (index === this.currentTab) {
                return;
            }

            var tab = this.tabs[index];

            // Don't go beyond indexes!
            if (!tab) {
                return;
            }

            // Activate requested current tab, and deactivate any old tabs
            this.tabs.forEach(function (t) {
                if (t === tab) {
                    // Set new tab as active
                    _this6.setActive(tab.dataset.tierId, tab.dataset.tier);
                    setTimeout(function () {
                        tab.focus();
                    }, 0);
                } else {
                    // Ensure non current tabs are not active
                }
            });
            // Update currentTab
            this.currentTab = index;
        },
        previousTab: function previousTab() {
            this.setTab(this.currentTab - 1);
        },
        nextTab: function nextTab() {
            this.setTab(this.currentTab + 1);
        },
        initalizeTabsKeyboarding: function initalizeTabsKeyboarding() {
            // ANCHOR: INITIALIZE TABS FOR KEYBOARDING
            // Initialize when content is loaded
            var tabs = this.$el.querySelectorAll('a[role="tab"]');
            this.tabs = tabs;
        }
    },
    watch: (_watch = {
        earlyCareerTerm: {
            handler: function handler(newValue, oldValue) {
                this.earlyCareerTerm = newValue;
                // this.setSignupUriDefault(
                //   this.activeItem,
                //   this.promoCode,
                //   this.earlyCareerTerm,
                //   this.referrer,
                //   this.computedFlowType
                // );
            }
        }
    }, _defineProperty(_watch, "earlyCareerTerm", function earlyCareerTerm(newVal, oldVal) {
        this.earlyCareerTerm = newValue;
    }), _defineProperty(_watch, "selectedTier", function selectedTier(newVal, oldVal) {
        this.selectedTier = newVal;
    }), _defineProperty(_watch, "deep", false), _watch),
    mounted: function mounted() {
        var _this7 = this;

        // console.log("prop flow-type: ", this.computedFlowType);
        this.fetchDropdownOptions();
        this.componentId = this.safeId("__PHD_selector_");
        this.getReferrer(); // Get values from the query string
        this.fetchData(this.uri, this.computedFlowType || "new", this.promoCode);
        // Call fertchData again after 20 seconds, to solve api being idle
        this.timer = setInterval(function () {
            _this7.fetchData(_this7.uri, _this7.computedFlowType || "new", _this7.promoCode);
        }, this.timerInterval);

        if (this.flowType === "upgrade") {
            this.signUpButtonText = "Upgrade Now";
        }

        // Close promo box on keypress - escape key
        document.addEventListener("keydown", function (evt) {
            if (evt.keyCode === _keyCodes2["default"].ESCAPE || evt.key === "Escape" && _this7.promoVisible === true) {
                console.log("esc");
                _this7.promoVisible = false;
            }
        });
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.timer);
    }
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  name: "selector-tab",
  props: {
    tierid: "",
    tiercode: ""
  },
  methods: {
    setParentActive: function setParentActive() {
      this.$parent.setActive(String(this.tierid), String(this.tiercode));
    }
  }
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keyCodes = __webpack_require__(75);

var _keyCodes2 = _interopRequireDefault(_keyCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    name: 'selector-panel',
    props: {
        tierid: '',
        displayname: '',
        price: '',
        discountPrice: '',
        tiercode: ''
    },
    data: function data() {
        return {
            visible: false
        };
    },

    computed: {
        collapseid: function collapseid() {
            return 'collapse-panel-' + this.tierid;
        }
    },
    methods: {
        setParentActive: function setParentActive() {
            this.$parent.setActive(String(this.tierid));
        },
        openOnKeyDown: function openOnKeyDown() {
            // Down arrow to expand
            if (event.keyCode === _keyCodes2['default'].DOWN || event.key === "ArrowDown") {
                event.preventDefault();
                this.visible = true;
            }

            if (event.keyCode === _keyCodes2['default'].ESCAPE || event.key === "Escape") {
                event.preventDefault();
                this.visible = false;
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        var tabbables = this.$el.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
        var lastTabbable = tabbables[tabbables.length - 1];
        if (window.getComputedStyle(lastTabbable).display === 'none') {
            lastTabbable = tabbables[tabbables.length - 2];
        }
        lastTabbable.addEventListener('keydown', function (evt) {
            _this.$parent.nextTab();
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    mixins: [_ahaId2['default']],
    data: function data() {
        return {
            isChecked: false,
            checkboxId: null
        };
    },
    props: {
        checkClass: {
            type: String
        }
    },
    computed: {
        containerClasses: function containerClasses() {
            return [this.isChecked ? 'is-checked' : '', this['class']];
        },
        containerAttributes: function containerAttributes() {
            return {
                'role': 'checkbox',
                'aria-checked': this.isChecked.toString(),
                'tabindex': 0,
                'aria-labelledby': this.checkboxId
            };
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.checkboxId = this.safeId('_PHD_checkbox_');
        // on hidden
        this.$root.$on('bv::modal::hidden', function (bvEvent, modalId) {
            if (bvEvent.vueTarget.$options.propsData.id === _this.$parent.$options.propsData.id) {
                _this.isChecked = false;
                var elm = _this.$parent.$el.querySelector('.checked-continue');
                _this.resetClass(elm, 'disabled');
                // toggleClass(this.$parent.$el.querySelector('.ec-continue'))
            }
        });
    },

    methods: {
        toggleChecked: function toggleChecked(evt) {
            if (evt.type === 'click' || evt.keyCode === _utils.KeyCodes.SPACE) {
                evt.preventDefault();
                this.isChecked = !this.isChecked;
                var elm = this.$parent.$el.querySelector('.checked-continue');
                console.log('element ', elm);
                this.toggleClass(elm, 'disabled');
            }
        },
        toggleClass: function toggleClass(elm, classname) {
            console.log('toggle', elm, classname);
            elm.classList.toggle(classname);
        },
        resetClass: function resetClass(elm, classname) {
            if (!elm.classList.contains(classname)) {
                elm.classList.add(classname);
            }
        }
    }
};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    props: {
        uri: {
            type: String,
            'default': ""
        },
        community: {
            type: Number,
            'default': 2
        },
        numbertoshow: {
            type: Number,
            'default': 5
        }
    },
    data: function data() {
        return {
            apiData: []
            // demoResponse is for testing data only
            // demoResponse: {
            //     "statusCode": 200,
            //     "status": "OK",
            //     "errors": null,
            //     "result": [
            //         {
            //             "eventId": null,
            //             "eventCode": "6598455",
            //             "eventName": "Giantbomb Gaming News",
            //             "eventLink": 'http://giantbomb.com',
            //             "eventDescription": "This is a fake description for Giantbomb.com's gaming news event thingy for testing purposes.",
            //             "startDate": null,
            //             "startTime": "",
            //             "endDate": null,
            //             "endTime": "",
            //             "creditHours": "0.25",
            //             "facility": null,
            //             "facilityCity": "",
            //             "facilityState": "",
            //             "releaseDate": null,
            //             "expirationDate": null,
            //             "lmsActivityKeyword": []
            //         },
            //         {
            //             "eventId": null,
            //             "eventCode": "6598706",
            //             "eventName": "Google-a-thon",
            //             "eventLink": "https://google.com",
            //             "eventDescription": "This is a story all about how my life got flipped turned upside down, let me take a minute you just sit right there and I'll tell you how I became the prince of a town called Bel-Air.",
            //             "startDate": null,
            //             "startTime": "",
            //             "endDate": null,
            //             "endTime": "",
            //             "creditHours": "0.25",
            //             "facility": null,
            //             "facilityCity": "",
            //             "facilityState": "",
            //             "releaseDate": null,
            //             "expirationDate": null,
            //             "lmsActivityKeyword": []
            //         },
            //         {
            //             "eventId": null,
            //             "eventCode": "6598565",
            //             "eventName": "Test Event 3",
            //             "eventLink": "https://arstechnica.com",
            //             "eventDescription": "This webinar series covers evaluation of patients with cryptogenic stroke, cardiac monitoring and the role of atrial cardiopathy; and the management Strategies for patients with cryptogenic stroke. Descriptions and accreditations are shown under Activity Information. Accreditation is claimed separately on each activity. Click the Register button to purchase the bundle.",
            //             "startDate": null,
            //             "startTime": "",
            //             "endDate": null,
            //             "endTime": "",
            //             "creditHours": "0.25",
            //             "facility": null,
            //             "facilityCity": "",
            //             "facilityState": "",
            //             "releaseDate": null,
            //             "expirationDate": null,
            //             "lmsActivityKeyword": []
            //         },
            //         {
            //             "eventId": null,
            //             "eventCode": "6598565",
            //             "eventName": "Test Event 4",
            //             "eventLink": "https://polygon.com",
            //             "eventDescription": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi quis iste, nemo corporis iusto ipsam fugiat voluptate unde, neque temporibus perferendis blanditiis atque ea distinctio dolorum, dolor sed ducimus nihil!",
            //             "startDate": null,
            //             "startTime": "",
            //             "endDate": null,
            //             "endTime": "",
            //             "creditHours": "0.25",
            //             "facility": null,
            //             "facilityCity": "",
            //             "facilityState": "",
            //             "releaseDate": null,
            //             "expirationDate": null,
            //             "lmsActivityKeyword": []
            //         }
            //     ]
            // }
        };
    },
    beforeMount: function beforeMount() {
        this.getApiData();
    },

    methods: {
        getApiData: function getApiData() {
            var _this = this;

            _axios2['default'].get(this.uri, {
                params: {
                    communityId: this.community
                }
            }).then(function (response) {
                _this.apiData = response.data.result;
                // console.log('***Data successfully retrieved***');
                // console.log('apiData: ', this.apiData);
            })['catch'](function (error) {
                console.log('getApiData Error: ', error);
            });

            // Example Response - uncomment this line if you need to see this thing actually work
            // this.apiData = this.demoResponse.result;
        } // getApiData

    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  data: function data() {
    return {
      isAgeValidate: false,
      isMlvwtValidate: false,
      isLasizeValidate: false,
      isMaxlovtValidate: false,
      isAgeRequired: false,
      isMlvwtRequired: false,
      isLasizeRequired: false,
      isMaxlvotRequired: false,
      ageToolTip: true,
      mlvwtToolTip: true,
      lasizeToolTip: true,
      maxlvotToolTip: true,
      fhscdToolTip: true,
      nsvtToolTip: true,
      unexSyToolTip: true,
      ef50ToolTip: true,
      apAnToolTip: true,
      elgeToolTip: true,
      age_range: {
        value: "",
        ageRange: {
          min: 16,
          max: 80
        },
        requiredMessage: "Please enter your age",
        errorMessage: "Age input should be between 16 to 80 years."
      },
      mlvwt_range: {
        value: "",
        wallThickness: {
          min: 10,
          max: 35
        },
        requiredMessage: "Please enter the wall thickness",
        errorMessage: "Maximal wall thickness input should be between 10mm and 35mm."
      },
      lasize_range: {
        value: "",
        laDiameter: {
          min: 28,
          max: 67
        },
        requiredMessage: "Please enter the LA Diameter",
        errorMessage: "LA Diameter input should be between 28mm and 67mm."
      },
      maxlvot_range: {
        value: "",
        lvotGradient: {
          min: 2,
          max: 154
        },
        requiredMessage: "Please enter the LVOT Gradient",
        errorMessage: "LVOT Gradient input should be between 2mmHg and 154mmHg."
      },
      fhscd_pick: 0,
      nsvt_pick: 0,
      unexSy_pick: 0,
      ef50_pick: 0,
      apAn_pick: 0,
      elge_pick: 0,
      recommendation: "",
      risk: {
        value: ""
      }
    };
  },

  methods: {
    hcmCalculatorFormula: function hcmCalculatorFormula() {
      var age = this.age_range;
      var mlvwt = this.mlvwt_range;
      var lasize = this.lasize_range;
      var maxlvot = this.maxlvot_range;
      var fhscd = this.fhscd_pick;
      var nsvt = this.nsvt_pick;
      var unexSyncope = this.unexSy_pick;
      var ef50 = this.ef50_pick;
      var aa = this.apAn_pick;
      var elge = this.elge_pick;

      var a = 0.01799934 * age.value;
      var b = 0.15939858 * mlvwt.value - 0.00294271 * mlvwt.value * mlvwt.value;
      var c = 0.0259082 * lasize.value;
      var d = 0.00446131 * maxlvot.value;
      var e = fhscd === 0 ? 0 : 0.4583082;
      var f = nsvt === 0 ? 0 : 0.82639195;
      var g = unexSyncope === 0 ? 0 : 0.71650361;
      var h = mlvwt.value <= 29 ? 0 : 1;
      var i = ef50 === 0 ? 0 : 1;
      var j = null;
      var k = b + c + d + e + f + g - a;
      var l = Math.pow(2.71828183, k);
      var m = Math.pow(0.998, l);
      var risk = 100 * (1 - m);

      var elgeYes = elge == 1;
      var aaYes = aa == 1;
      var efYes = i == 1;
      var nsvtYes = f == 0.82639195;
      var fhscdYes = e == 0.4583082;
      var usYes = g == 0.71650361;
      var mlvwtYes = h == 1;

      switch (true) {
        //Class 2A: When one parameter AND NSVT AND Extensive LGE = YES
        case elgeYes && nsvtYes && aaYes && efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%, Apical Aneurysm, and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge, aa, ef & nsvt are yes");
          break;
        case efYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge & nsvt");
          break;
        case aaYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge & nsvt");
          break;
        case fhscdYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("fhscd, elge, nsvt are yes");
          break;
        case usYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("US, elge, nsvt are yes");
          break;
        case mlvwtYes && nsvtYes && elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("mlvwt, elge, nsvt are yes");
          break;
        case elgeYes && efYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm, EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge,ef,aa are yes");
          break;
        case nsvtYes && efYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Apical Aneursym)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge,ef,aa are yes");
          break;

        //Class 2B(a): When all parameters = NO except for NVST AND Extensive LGE
        case elgeYes && nsvtYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "This patient has 2 risk factors that while individually carry Class 2B indications, having both of these likely represents more risk than having either risk factor in isolation";
          console.log("elge & nsvt");
          break;

        //Class 2A: When any parameter AND EXTENSIVE LGE = YES
        case elgeYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("switch elge & aa");
          break;
        case elgeYes && efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("elge & ef are yes");
          break;
        case elgeYes && fhscdYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("FHSCD and ELGE are yes");
          break;
        case elgeYes && usYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Unexplained Syncope and ELGE are yes");
          break;
        case elgeYes && mlvwtYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("MLVWT and ELGE are yes");
          break;

        //Class 2A: When any parameter AND NVST = YES
        case nsvtYes && efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF and NSVT are yes");
          break;
        case nsvtYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF and NSVT are yes");
          break;
        case nsvtYes && fhscdYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("FHSCD and NSVT are yes");
          break;
        case nsvtYes && usYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Unexplained Syncope and NSVT are yes");
          break;
        case nsvtYes && mlvwtYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("MLVWT and NSVT are yes");
          break;

        //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
        case efYes && aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF and AA are yes");
          break;

        //Class 2B: When all parameters = NO except for NVST OR Extensive LGE
        case nsvtYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
          console.log("nsvtYes");
          break;
        case elgeYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)", this.recommendation = "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)";
          console.log("elge catch all");
          break;

        //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
        case efYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("EF is Yes");
          break;
        case aaYes:
          this.risk.value = risk.toFixed(2) + " " + "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)", this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Apical aneurysm is yes");
          break;
        case fhscdYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("fhscd is yes");
          break;
        case usYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("Unexplained Syncope is Yes");
          break;
        case mlvwtYes:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)";
          console.log("mlvwt is yes");
          break;
        default:
          this.risk.value = risk.toFixed(2), this.recommendation = "Based on the absence of risk factors, this patient does not have an indication for an  <span class='abbr' title='Implantable Cardioverter Defibrillator'><abbr title='Implantable Cardioverter Defibrillator'>ICD</abbr></span>  (Class 3 – No Benefit)";
          console.log("all no");
          break;
      }
    },
    validateAge: function validateAge() {
      if (this.age_range.value >= this.age_range.ageRange.min && this.age_range.value <= this.age_range.ageRange.max) {
        console.log("within range");
        this.isAgeValidate = false;
      } else {
        console.log("outside range");
        this.isAgeValidate = true;
      }
    },
    validateMlvwt: function validateMlvwt() {
      if (this.mlvwt_range.value >= this.mlvwt_range.wallThickness.min && this.mlvwt_range.value <= this.mlvwt_range.wallThickness.max) {
        console.log("within range");
        this.isMlvwtValidate = false;
      } else {
        console.log("outside range");
        this.isMlvwtValidate = true;
      }
    },
    validateLasize: function validateLasize() {
      if (this.lasize_range.value >= this.lasize_range.laDiameter.min && this.lasize_range.value <= this.lasize_range.laDiameter.max) {
        console.log("within range");
        this.isLasizeValidate = false;
      } else {
        console.log("outside range");
        this.isLasizeValidate = true;
      }
    },
    validateMaxlovt: function validateMaxlovt() {
      if (this.maxlvot_range.value >= this.maxlvot_range.lvotGradient.min && this.maxlvot_range.value <= this.maxlvot_range.lvotGradient.max) {
        console.log("within range");
        this.isMaxlovtValidate = false;
      } else {
        console.log("outside range");
        this.isMaxlovtValidate = true;
      }
    },
    formValidate: function formValidate(e) {
      if (this.age_range.value == "") {
        this.isAgeRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isAgeRequired = false;
        console.log("number entered");
      }

      if (this.mlvwt_range.value == "") {
        this.isMlvwtRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isMlvwtRequired = false;
        console.log("number entered");
      }

      if (this.lasize_range.value == "") {
        this.isLasizeRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isLasizeRequired = false;
        console.log("number  entered");
      }

      if (this.maxlvot_range.value == "") {
        this.isMaxlvotRequired = true;
        console.log("number not entered");
        e.preventDefault();
      } else {
        this.isMaxlvotRequired = false;
        console.log("number entered");
      }
    },
    resetForm: function resetForm() {
      this.age_range.value = "";
      this.mlvwt_range.value = "";
      this.lasize_range.value = "";
      this.maxlvot_range.value = "";
      this.fhscd_pick = 0;
      this.nsvt_pick = 0;
      this.unexSy_pick = 0;
      this.ef50_pick = 0;
      this.apAn_pick = 0;
      this.elge_pick = 0;
      this.risk.value = "";
      this.recommendation = "";
      this.isAgeValidate = false;
      this.isMlvwtValidate = false;
      this.isLasizeValidate = false;
      this.isMaxlovtValidate = false;
      this.isAgeRequired = false;
      this.isMlvwtRequired = false;
      this.isLasizeRequired = false;
      this.isMaxlvotRequired = false;
      this.ageToolTip = true;
      this.mlvwtToolTip = true;
      this.lasizeToolTip = true;
      this.maxlvotToolTip = true;
      this.fhscdToolTip = true;
      this.nsvtToolTip = true;
      this.unexSyToolTip = true;
      this.ef50ToolTip = true;
      this.apAnToolTip = true;
      this.elgeToolTip = true;
    }
  }
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        references: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            activeId: null,
            sourceAnchor: null
        };
    },
    computed: {
        allIds: function allIds() {
            return this.references.map(function (contentObject) {
                return contentObject.id;
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        var parentCollapseButtons = [];
        var parentCollapse = this.$refs.eccReferences.closest('.nested-accordion__collapse');

        while (parentCollapse) {
            var previousElementSibling = parentCollapse.previousElementSibling;
            if (parentCollapse && previousElementSibling && previousElementSibling.classList && previousElementSibling.classList.contains('nested-accordion__toggle-button')) {
                parentCollapseButtons.push(previousElementSibling);
                parentCollapse = previousElementSibling.closest('.nested-accordion__collapse');
            } else {
                parentCollapse = null;
            }
        }

        document.body.addEventListener('click', function (e) {
            var forceScroll = false;
            var hashId = e.target.hash ? e.target.hash.substr(1) : false;
            if (hashId) {
                _this.sourceAnchor = e.target;
            }

            var activeIdIndex = _this.allIds.indexOf(hashId) > -1 ? _this.allIds.indexOf(hashId) : -1;
            if (activeIdIndex > -1) {
                _this.activeId = _this.allIds[activeIdIndex];

                if (parentCollapseButtons.length > 0) {
                    parentCollapseButtons.forEach(function (collapseButton) {
                        var collapseId = collapseButton.getAttribute('aria-controls');
                        if (collapseButton.getAttribute('aria-expanded') === 'false' && collapseId) {
                            e.preventDefault();
                            _this.$root.$emit('bv::toggle::collapse', collapseId);
                            forceScroll = true;
                        }
                    });

                    if (forceScroll) {
                        setTimeout(function () {
                            _this.$refs[hashId][0].scrollIntoView();
                        }, 500);
                    }
                }
            }
        });
    },

    methods: {
        returnToText: function returnToText() {
            var _this2 = this;

            if (this.sourceAnchor) {
                this.$nextTick(function () {
                    _this2.sourceAnchor.scrollIntoView();
                    _this2.sourceAnchor = null;
                });
            }
            this.activeId = null;
        }
    }
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
    props: {
        mapData: {
            type: Array,
            required: false
        },
        mapSettings: {
            type: Object,
            required: false,
            'default': function _default() {
                return {
                    mapHeight: '500px',
                    activeStateColor: '#ce2a23',
                    inactiveStateColor: '#6f859a',
                    hiddenStateAbbrev: ['MD', 'RI', 'CT', 'MA', 'NH', 'DC', 'DE', 'NJ', 'VT'],
                    showAccessibleStateSelector: true,
                    screenReaderMapTitle: 'CPR In Schools Legislation Map',
                    selectorButtonLabel: 'Select',
                    blankSelectorOptionLabel: 'Select A State'
                };
            }
        }
    },
    data: function data() {
        return {
            chart: null,
            statesList: []
        };
    },
    computed: {
        amchartsPresent: function amchartsPresent() {
            return window.am4core ? true : false;
        },
        mapDataPresent: function mapDataPresent() {
            return Array.isArray(this.mapData) ? this.mapData.length > 0 ? true : false : false;
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.amchartsPresent) {
            am4core.ready(function () {
                _this.initMap();
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
    },

    methods: {
        initMap: function initMap() {
            var _this2 = this;

            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end

            // Create map instance
            var chart = am4core.create(this.$refs.chartdiv, am4maps.MapChart);
            chart.readerTitle = this.mapSettings.screenReaderMapTitle;
            chart.role = null;
            chart.svgContainer.hideOverflow = true;

            // Set map definition
            chart.geodata = am4geodata_usaLow;

            // Set projection
            chart.projection = new am4maps.projections.AlbersUsa();
            // chart.projection.role = '';

            // Set focus styles
            chart.focusFilter.strokeWidth = 0;

            // Create map polygon series
            var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
            polygonSeries.readerTitle = '';
            polygonSeries.role = '';
            polygonSeries.dataFields.line1 = 'line1';
            polygonSeries.dataFields.line2 = 'line2';
            polygonSeries.dataFields.line3 = 'line3';
            polygonSeries.dataFields.url = 'url';
            polygonSeries.sortPolygonsBy = 'name';

            polygonSeries.heatRules.push({
                property: "fill",
                target: polygonSeries.mapPolygons.template,
                min: am4core.color(this.mapSettings.inactiveStateColor),
                max: am4core.color(this.mapSettings.activeStateColor)
            });

            // Make map load polygon data (state shapes and names) from GeoJSON
            polygonSeries.useGeodata = true;
            polygonSeries.calculateVisualCenter = true;

            // Set heatmap values for each state
            polygonSeries.data = this.mapData;

            // Create series tooltip
            polygonSeries.tooltip.getFillFromObject = false;
            polygonSeries.tooltip.background.fill = am4core.color("#fff");
            polygonSeries.tooltip.background.fillOpacity = 1;
            polygonSeries.tooltip.background.cornerRadius = 4;
            polygonSeries.tooltip.background.strokeWidth = 0;
            polygonSeries.tooltip.label.fill = am4core.color("#000");
            polygonSeries.tooltip.fillOpacity = 1;
            polygonSeries.tooltip.label.interactionsEnabled = true;

            if (window.innerWidth >= 1024) {
                polygonSeries.tooltip.fontSize = '0.8rem';
            } else {
                polygonSeries.tooltip.fontSize = '0.7rem';
                polygonSeries.tooltip.keepTargetHover = true;
                chart.homeZoomLevel = 1.1;
                polygonSeries.tooltip.label.maxWidth = 250;
                polygonSeries.tooltip.label.wrap = true;
            }

            // Configure series tooltip
            var polygonTemplate = polygonSeries.mapPolygons.template;
            polygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;
            polygonTemplate.tooltipPosition = 'fixed';
            polygonTemplate.hoverOnFocus = true;

            if (window.innerWidth >= 1024) {
                polygonTemplate.tooltipText = "[bold]{name}\n[/]{line1}\n{line2}\n{line3}";
            } else {
                // Caution, setting custom tooltip HTML breaks IE support, use for mobile only
                polygonTemplate.tooltipHTML = '\n                    <p class="c-svg-map__tooltip-header">{name} <a href=\'{url}\' target=\'_blank\'>(Link)</a></p>\n                    <span class="c-svg-map__tooltip-content-line">{line1}</span>\n                    <span class="c-svg-map__tooltip-content-line">{line2}</span>\n                    <span class="c-svg-map__tooltip-content-line">{line3}</span>\n                ';
                polygonTemplate.userClassName = 'c-svg-map__disable-clicks';
            }

            polygonTemplate.nonScalingStroke = true;
            polygonTemplate.strokeWidth = 1.5;

            // Create series labels
            var labelSeries = chart.series.push(new am4maps.MapImageSeries());
            labelSeries.readerTitle = '';
            labelSeries.role = '';
            var labelTemplate = labelSeries.mapImages.template.createChild(am4core.Label);
            labelTemplate.horizontalCenter = "middle";
            labelTemplate.verticalCenter = "middle";
            labelTemplate.fill = am4core.color("#fff");
            labelTemplate.fontWeight = "bold";
            labelTemplate.interactionsEnabled = false;

            if (window.innerWidth >= 1024) {
                labelTemplate.fontSize = ".9rem";
            } else {
                labelTemplate.fontSize = ".7rem";
            }

            polygonSeries.events.on("inited", function () {
                polygonSeries.mapPolygons.each(function (polygon) {
                    if (polygon.dataItem.dataContext.id === undefined) {
                        return;
                    }

                    _this2.statesList.unshift({
                        id: polygon.dataItem.dataContext.id,
                        name: polygon.dataItem.dataContext.name
                    });

                    var label = labelSeries.mapImages.create();
                    label.tabindex = -1;
                    var stateAbbrev = polygon.dataItem.dataContext.id.split("-").pop();
                    var value = polygon.dataItem.dataContext.value;
                    var hiddenStateIndex = _this2.mapSettings.hiddenStateAbbrev.indexOf(stateAbbrev);
                    polygon.readerTitle = polygon.dataItem.dataContext.name + ': ';

                    if (polygon.dataItem.dataContext.line1) {
                        polygon.readerTitle += polygon.dataItem.dataContext.line1;
                    }

                    if (polygon.dataItem.dataContext.line2) {
                        polygon.readerTitle += polygon.dataItem.dataContext.line2;
                    }

                    if (polygon.dataItem.dataContext.line3) {
                        polygon.readerTitle += polygon.dataItem.dataContext.line3;
                    }

                    if (hiddenStateIndex > -1) {
                        label.background = new am4core.RoundedRectangle();
                        label.background.cornerRadius(4, 4, 4, 4);
                        label.ignoreBounds = true;

                        if (value === '1') {
                            label.background.fill = am4core.color(_this2.mapSettings.activeStateColor);
                        } else if (value === '0') {
                            label.background.fill = am4core.color(_this2.mapSettings.inactiveStateColor);
                        }

                        label.fontWeight = 'bold';
                        label.textAlign = 'middle';
                        label.textValign = 'middle';
                        label.contentAlign = 'middle';
                        label.contentValign = 'middle';
                        label.children.getIndex(0).text = stateAbbrev;
                        label.cursorOverStyle = am4core.MouseCursorStyle.pointer;

                        if (window.innerWidth < 576) {
                            label.fontSize = '.7rem';
                            label.width = 25;
                            label.height = 13;
                            label.paddingTop = 7;
                            label.paddingLeft = 13;

                            if (hiddenStateIndex < 5) {
                                var lat = 35.00 + hiddenStateIndex * 2;
                                var lng = -70.71 + hiddenStateIndex * .7;
                                label.latitude = lat;
                                label.longitude = lng;
                            } else {
                                var _lat = 23.93 + hiddenStateIndex * 2;
                                var _lng = -78.71 + hiddenStateIndex * .6;
                                label.latitude = _lat;
                                label.longitude = _lng;
                            }
                        } else if (window.innerWidth < 768) {
                            label.fontSize = '.7rem';
                            label.width = 32;
                            label.height = 19;
                            label.paddingTop = 11;
                            label.paddingLeft = 16;

                            if (hiddenStateIndex < 5) {
                                var _lat2 = 35.80 + hiddenStateIndex * 1.6;
                                var _lng2 = -71.10 + hiddenStateIndex * .6;
                                label.latitude = _lat2;
                                label.longitude = _lng2;
                            } else {
                                var _lat3 = 26.93 + hiddenStateIndex * 1.6;
                                var _lng3 = -77.71 + hiddenStateIndex * .45;
                                label.latitude = _lat3;
                                label.longitude = _lng3;
                            }
                        } else if (window.innerWidth < 992) {
                            label.fontSize = '.7rem';
                            label.width = 32;
                            label.height = 19;
                            label.paddingTop = 11;
                            label.paddingLeft = 16;

                            if (hiddenStateIndex < 5) {
                                var _lat4 = 36.93 + hiddenStateIndex * 1.1;
                                var _lng4 = -70.51 + hiddenStateIndex * .4;
                                label.latitude = _lat4;
                                label.longitude = _lng4;
                            } else {
                                var _lat5 = 30.93 + hiddenStateIndex * 1.1;
                                var _lng5 = -75.71 + hiddenStateIndex * .35;
                                label.latitude = _lat5;
                                label.longitude = _lng5;
                            }
                        } else if (window.innerWidth >= 992) {
                            label.fontSize = '.9rem';
                            label.width = 32;
                            label.height = 19;
                            label.paddingTop = 11;
                            label.paddingLeft = 16;

                            if (hiddenStateIndex < 5) {
                                var _lat6 = 36.93 + hiddenStateIndex * 1.1;
                                var _lng6 = -70.51 + hiddenStateIndex * .4;
                                label.latitude = _lat6;
                                label.longitude = _lng6;
                            } else {
                                var _lat7 = 30.93 + hiddenStateIndex * 1.1;
                                var _lng7 = -75.71 + hiddenStateIndex * .35;
                                label.latitude = _lat7;
                                label.longitude = _lng7;
                            }
                        }

                        label.events.on("over", function (e) {
                            polygon.isHover = true;
                            // This is needed so that "unhovering" previous polygon does not hide tooltip
                            e.target.isHover = false;
                            e.target.isHover = true;
                        });

                        label.events.on("out", function (e) {
                            polygon.isHover = false;
                        });

                        if (window.innerWidth >= 1024) {
                            label.events.on("over", function (e) {
                                label.url = polygon.dataItem.dataContext.url;
                                label.urlTarget = 'blank';
                            });

                            label.events.on("out", function (e) {
                                label.url = null;
                                label.urlTarget = null;
                            });
                        } else {
                            label.userClassName = 'c-svg-map__disable-clicks';
                        }
                    } else {
                        label.latitude = polygon.visualLatitude;
                        label.longitude = polygon.visualLongitude;
                        label.children.getIndex(0).text = stateAbbrev;
                    }

                    if (window.innerWidth >= 1024) {
                        polygon.events.on('over', function () {
                            polygon.url = polygon.dataItem.dataContext.url;
                            polygon.urlTarget = 'blank';
                        });

                        polygon.events.on('out', function () {
                            polygon.url = null;
                            polygon.urlTarget = null;
                        });
                    }

                    var hoverState = polygon.states.create("hover");
                    hoverState.properties.fill = am4core.color(polygon.fill).lighten(-0.35);

                    polygon.events.on("focus", function (e) {
                        polygon.url = polygon.dataItem.dataContext.url;
                        polygon.urlTarget = 'blank';
                    }, _this2);

                    polygon.events.on("blur", function (e) {
                        polygon.url = null;
                        polygon.urlTarget = null;
                    }, _this2);
                });
            });

            this.$nextTick(function () {
                // Clean up extraneous WAI-ARIA attributes for accessibility & Hide AMCharts Logo
                var svgContainer = _this2.$refs.chartdiv.querySelector('.c-svg-map svg');
                var toolTips = _this2.$refs.chartdiv.querySelectorAll('[role="tooltip"]');
                var amChartsLogo = _this2.$refs.chartdiv.querySelector('g[aria-labelledby^="id-"');

                if (svgContainer) {
                    svgContainer.removeAttribute('role');
                }

                if (toolTips.length > 0) {
                    toolTips.forEach(function (el) {
                        if (!el.getAttribute('font-size')) {
                            el.parentNode.removeChild(el);
                        }
                    });
                }

                if (amChartsLogo) {
                    amChartsLogo.setAttribute('visibility', 'hidden');
                }
            });

            this.chart = chart;
        },
        selectState: function selectState() {
            var statePolylgon = this.chart.series.getIndex(0).getPolygonById(this.$refs.stateselector.value);

            if (statePolylgon) {
                statePolylgon.isFocused = true;
                var stateDOMElement = this.$refs.chartdiv.querySelector('#' + statePolylgon.uid);

                if (stateDOMElement) {
                    window.setTimeout(function () {
                        // SVG element focus hack for IE
                        if (window.document.documentMode) {
                            var foreignObjectEl = document.createElement('foreignObject');
                            var inputEl = document.createElement('input');
                            foreignObjectEl.appendChild(inputEl);
                            stateDOMElement.appendChild(foreignObjectEl);
                            inputEl.focus();
                            inputEl.disabled = true;
                            foreignObjectEl.parentNode.removeChild(foreignObjectEl);
                        } else {
                            stateDOMElement.focus();
                        }
                    }, 500);
                }
            }
        }
    }
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hcxfPublicationResultTemplate = __webpack_require__(557);

var _hcxfPublicationResultTemplate2 = _interopRequireDefault(_hcxfPublicationResultTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  data: function data() {
    return {
      hcxfPublicationResultTemplate: _hcxfPublicationResultTemplate2['default']
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atomicPagination = __webpack_require__(58);

var _atomicPagination2 = _interopRequireDefault(_atomicPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    data: function data() {
        return {
            tabValue: "",
            allLinks: []
        };
    },

    props: {
        accessToken: {
            type: String,
            required: true
        },
        organizationId: {
            type: String,
            required: true
        },
        searchHub: {
            type: String,
            required: true
        },
        ahaScienceDetail: {
            type: String,
            required: true
        },
        ahaScienceTabName: {
            type: String,
            required: true
        },
        hcxfScienceDetail: {
            type: String,
            required: true
        },
        hcxfScienceTabName: {
            type: String,
            required: true
        },
        evidenceLibraryDetail: {
            type: String,
            required: true
        },
        evidenceLibraryTabName: {
            type: String,
            required: true
        },
        indexName: {
            type: String,
            required: true
        },
        templateId: {
            type: String,
            required: true
        }
    },

    methods: {
        initInterface: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this = this;

                var searchInterface, engine;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return customElements.whenDefined("atomic-search-interface");

                            case 2:
                                searchInterface = document.querySelector("atomic-search-interface");
                                _context.next = 5;
                                return searchInterface.initialize({
                                    accessToken: this.accessToken,
                                    organizationId: this.organizationId,
                                    preprocessRequest: function preprocessRequest(request, clientOrigin, metadata) {

                                        var body = JSON.parse(request.body);
                                        if (clientOrigin === 'searchApiFetch') {
                                            body.aq = '(@source==(\"' + _this.indexName + '\") ( @z95xtemplate=' + _this.templateId + '))';
                                            body.searchHub = _this.searchHub;
                                        }

                                        request.body = JSON.stringify(body);
                                        return request;
                                    }
                                });

                            case 5:
                                engine = searchInterface.engine;

                                searchInterface.executeFirstSearch();

                                engine.subscribe(function () {
                                    setTimeout(function () {
                                        _this.checkForCardLink();
                                        _this.updateSpeedBump();
                                        var searchBox = document.querySelector('atomic-search-box').shadowRoot;
                                        if (searchBox.children[0] && searchBox.children[0].firstElementChild) {
                                            var div = searchBox.children[0].firstElementChild;
                                            if (div) {
                                                div.classList.add("w-full");
                                            }
                                        }
                                    }, 500);
                                });

                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function initInterface() {
                return _ref.apply(this, arguments);
            }

            return initInterface;
        }(),
        addTabClickEventListener: function addTabClickEventListener() {
            var _this2 = this;

            var shadowHost = document.querySelectorAll('.tab-container > custom-tab.hydrated').forEach(function (element) {
                element.addEventListener('click', function (event) {
                    var path = event.composedPath();
                    var tabAnchor = path.find(function (el) {
                        return el.tagName === 'A';
                    });
                    console.log(tabAnchor);
                    if (tabAnchor) {
                        _this2.handleTabClick(tabAnchor.innerText);
                    }
                });
            });
        },
        handleTabClick: function handleTabClick(tabName) {
            this.tabValue = tabName;
        },
        checkForCardLink: function checkForCardLink() {
            var _this3 = this;

            var nodes = document.querySelector('atomic-result-list').shadowRoot;
            var shadowNode = nodes.querySelectorAll("[part='result-list-grid-clickable-container outline']");
            if (shadowNode.length > 0) {
                shadowNode.forEach(function (node) {
                    var resultRoot = node.querySelector('atomic-result').shadowRoot;
                    if (resultRoot) {
                        var link = resultRoot.querySelector('.result-link a');
                        var isInternalLink = resultRoot.querySelector('.isExternal') == null ? false : true;
                        if (link && link.getAttribute('href')) {

                            if (isInternalLink && !link.classList.contains('twoClick')) {
                                link.classList.add('twoClick');
                                _this3.allLinks.push(link);
                            }
                        }
                    }
                });
            }
        },
        updateSpeedBump: function updateSpeedBump() {
            var speedBumps = this.allLinks;
            var speedBumpLink = document.querySelector('#speed-bump-link');
            window.activeSpeedBumpLink = null;
            Array.from(speedBumps).forEach(function (element, index) {
                if (!element.hasAttribute('speed-bump-set')) {
                    element.addEventListener('click', function (event) {
                        event.preventDefault();
                        window.activeSpeedBumpLink = event.currentTarget;
                        speedBumpLink.setAttribute('href', event.currentTarget.getAttribute('href'));
                        speedBumpLink.click();
                    });

                    element.setAttribute('speed-bump-set', '');
                }
            });
        },
        getHashParam: function getHashParam(key) {
            var hash = window.location.hash.substring(1);
            var params = new URLSearchParams(hash);
            return decodeURIComponent(params.get(key));
        },
        updateTabValue: function updateTabValue() {
            this.tabValue = this.getHashParam("tab");
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.initInterface().then(function () {
            _this4.updateTabValue();
            _this4.addTabClickEventListener();
        });
    },

    components: {
        coveoPagination: _atomicPagination2["default"]
    }
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//

exports["default"] = {
    name: "coveo-pagination"
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hcxfPractitionerResultTemplate = __webpack_require__(573);

var _hcxfPractitionerResultTemplate2 = _interopRequireDefault(_hcxfPractitionerResultTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  data: function data() {
    return {
      defaultResultTemplate: _hcxfPractitionerResultTemplate2['default']
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var initMap = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref2, Map, _ref3, AdvancedMarkerElement;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return google.maps.importLibrary("maps");

          case 2:
            _ref2 = _context.sent;
            Map = _ref2.Map;
            _context.next = 6;
            return google.maps.importLibrary("marker");

          case 6:
            _ref3 = _context.sent;
            AdvancedMarkerElement = _ref3.AdvancedMarkerElement;


            map = new Map(document.getElementById("hcxf-map"), {
              center: { lat: defaultLat, lng: defaultLng },
              zoom: 4,
              maxZoom: 12,
              mapId: "practitionerMap"
            });

            google.maps.event.trigger(map, "resize");

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function initMap() {
    return _ref.apply(this, arguments);
  };
}();

var addMarker = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(title, position) {
    var _ref5, AdvancedMarkerElement, marker;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return google.maps.importLibrary("marker");

          case 2:
            _ref5 = _context2.sent;
            AdvancedMarkerElement = _ref5.AdvancedMarkerElement;
            marker = new AdvancedMarkerElement({
              map: map,
              position: position,
              title: title
            });


            mapMarkers.push(marker);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function addMarker(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();

var deleteMarker = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(marker) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            marker.setMap(null);
            mapMarkers.splice(mapMarkers.findIndex(function (m) {
              return m.position === marker.position;
            }), 1);

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function deleteMarker(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

var showMarkers = function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            setMapOnAll(map);

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function showMarkers() {
    return _ref7.apply(this, arguments);
  };
}();

var onSearchResultsUpdated = function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(response) {
    var _this = this;

    var bounds, results, geocoder, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, singleResult;

    return regeneratorRuntime.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            deleteMarkers();

            bounds = new google.maps.LatLngBounds();
            results = response.body.results;

            if (!(results.length === 0)) {
              _context6.next = 7;
              break;
            }

            centerMapOnPoint(defaultLat, defaultLng);
            map.setZoom(4);
            return _context6.abrupt("return", response);

          case 7:
            geocoder = new google.maps.Geocoder();
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context6.prev = 11;
            _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
              var result, latitude, longitude, title, isExist, geocodeResult, _isExist;

              return regeneratorRuntime.wrap(function _loop$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      result = _step.value;
                      latitude = parseFloat(result.raw.latitude);
                      longitude = parseFloat(result.raw.longitude);
                      title = result.title;

                      if (!(latitude && longitude)) {
                        _context5.next = 12;
                        break;
                      }

                      isExist = checkMarkerIfAlreadyExist(latitude, longitude);

                      if (isExist) {
                        _context5.next = 9;
                        break;
                      }

                      _context5.next = 9;
                      return addMarker(title, { lat: latitude, lng: longitude });

                    case 9:
                      bounds.extend({ lat: latitude, lng: longitude });
                      _context5.next = 25;
                      break;

                    case 12:
                      _context5.next = 14;
                      return new Promise(function (resolve, reject) {
                        geocoder.geocode({ address: result.raw.z122xipz32xcode }, function (results, status) {
                          if (status === "OK" && results[0]) {
                            var location = results[0].geometry.location;
                            resolve({ lat: location.lat(), lng: location.lng() });
                          } else {
                            console.error("Geocode Failed:", status);
                            reject(status);
                          }
                        });
                      });

                    case 14:
                      geocodeResult = _context5.sent;

                      if (!geocodeResult) {
                        _context5.next = 25;
                        break;
                      }

                      latitude = geocodeResult.lat;
                      longitude = geocodeResult.lng;
                      _isExist = checkMarkerIfAlreadyExist(latitude, longitude);

                      if (_isExist) {
                        _context5.next = 22;
                        break;
                      }

                      _context5.next = 22;
                      return addMarker(title, { lat: latitude, lng: longitude });

                    case 22:
                      bounds.extend({ lat: latitude, lng: longitude });

                      result.raw.latitude = latitude;
                      result.raw.longitude = longitude;

                    case 25:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _loop, _this);
            });
            _iterator = results[Symbol.iterator]();

          case 14:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context6.next = 19;
              break;
            }

            return _context6.delegateYield(_loop(), "t0", 16);

          case 16:
            _iteratorNormalCompletion = true;
            _context6.next = 14;
            break;

          case 19:
            _context6.next = 25;
            break;

          case 21:
            _context6.prev = 21;
            _context6.t1 = _context6["catch"](11);
            _didIteratorError = true;
            _iteratorError = _context6.t1;

          case 25:
            _context6.prev = 25;
            _context6.prev = 26;

            if (!_iteratorNormalCompletion && _iterator["return"]) {
              _iterator["return"]();
            }

          case 28:
            _context6.prev = 28;

            if (!_didIteratorError) {
              _context6.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context6.finish(28);

          case 32:
            return _context6.finish(25);

          case 33:
            _context6.next = 35;
            return showMarkers();

          case 35:
            lastResultSet = results;

            if (results.length === 1) {
              singleResult = results[0];

              centerMapOnPoint(parseFloat(singleResult.raw.latitude), parseFloat(singleResult.raw.longitude));
              map.fitBounds(bounds);
              map.setZoom(8);
            } else {
              map.fitBounds(bounds);
            }
            return _context6.abrupt("return", response);

          case 38:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5, this, [[11, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function onSearchResultsUpdated(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

var centerMapOnPoint = function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(lat, lng) {
    return regeneratorRuntime.wrap(function _callee6$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            map.setCenter({ lat: lat, lng: lng });

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee6, this);
  }));

  return function centerMapOnPoint(_x5, _x6) {
    return _ref9.apply(this, arguments);
  };
}();

var registerLinkEvents = function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
    var shadowRoot, links;
    return regeneratorRuntime.wrap(function _callee7$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            shadowRoot = document.querySelector("atomic-result-list").shadowRoot;

            if (shadowRoot) {
              links = shadowRoot.querySelector("div.list-root");

              if (links) {
                links.childNodes.forEach(function (node, index) {
                  if (node.tagName === "ATOMIC-RESULT") {
                    var atomicResultShadowRoot = node.shadowRoot;
                    var resultRoot = atomicResultShadowRoot.querySelector("div.result-root atomic-result-fields-list");
                    if (resultRoot) {
                      resultRoot.childNodes.forEach(function (child, index) {
                        var childrenNodes = Array.from(child.childNodes);
                        childrenNodes.forEach(function (node, i) {
                          if (node.tagName === "ATOMIC-RESULT-SECTION-TITLE") {
                            var resultLink = node.querySelector("atomic-result-link");
                            var unique = node.querySelector("atomic-result-text[field='uniqueId']");
                            var link = resultLink.querySelector("a");

                            if (link && unique) {
                              link.dataset.uniqueId = unique.innerHTML.trim();
                              link.onclick = function (event) {
                                event.preventDefault();
                                var target = event.target.parentElement;

                                if (target) {
                                  var uniqueId = target.dataset.uniqueId;
                                  var dataItem = lastResultSet.find(function (element) {
                                    return element.uniqueId === uniqueId;
                                  });

                                  if (dataItem) {
                                    var latitude = dataItem.raw.latitude;
                                    var longitude = dataItem.raw.longitude;
                                    centerMapOnPoint(latitude, longitude);
                                    map.setZoom(6);
                                    var cards = getAllOrgCards();
                                    if (cards) {
                                      var activeCardClass = 'active-card';
                                      cards.forEach(function (card) {
                                        return card.classList.remove(activeCardClass);
                                      });
                                      var card = link.closest('.organization-card');
                                      card.classList.add(activeCardClass);
                                    }
                                  }
                                }
                              };
                            }
                          }
                        });
                      });
                    }
                  }
                });
              }
            }

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee7, this);
  }));

  return function registerLinkEvents() {
    return _ref10.apply(this, arguments);
  };
}();

var _atomicPagination = __webpack_require__(58);

var _atomicPagination2 = _interopRequireDefault(_atomicPagination);

var _hcxfPractitionerFacets = __webpack_require__(578);

var _hcxfPractitionerFacets2 = _interopRequireDefault(_hcxfPractitionerFacets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var map;
var mapMarkers = [];
var lastResultSet = [];
var defaultLat = 32.8826285;
var defaultLng = -96.7662485;

function setMapOnAll(map) {
  mapMarkers.forEach(function (marker) {
    marker.setMap(map);
  });
}

function deleteMarkers() {
  setMapOnAll(null);
  mapMarkers = [];
}

function checkMarkerIfAlreadyExist(lat, lng) {
  return mapMarkers.some(function (marker) {
    return marker.position.lat === lat && marker.position.lng === lng;
  });
}

function getAllOrgCards() {
  var resultList = document.querySelector("atomic-result-list").shadowRoot.querySelector("div.list-root");
  if (!resultList) {
    console.error("No atomic-result-list found.");
    return [];
  }
  var orgCards = [];
  resultList.childNodes.forEach(function (result) {
    if (result.tagName === 'ATOMIC-RESULT') {
      var shadowRoot = result.shadowRoot;
      if (shadowRoot) {
        var orgCard = shadowRoot.querySelector('.organization-card');
        if (orgCard) {
          orgCards.push(orgCard);
        }
      }
    }
  });
  return orgCards;
}

var waitForShadowElement = function waitForShadowElement(selector, part, callback) {
  var retryCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

  var element = document.querySelector(selector);
  if (element) {
    var shadowRoot = element.shadowRoot;
    if (shadowRoot) {
      var target = shadowRoot.querySelector("[part=\"" + part + "\"]");
      if (target) {
        callback(target);
        return;
      }
    }
  }
  if (retryCount > 0) {
    setTimeout(function () {
      return waitForShadowElement(selector, part, callback, retryCount - 1);
    }, 1000);
  } else {
    console.error('Could not find the Shadow DOM element.');
  }
};

exports["default"] = {
  props: {
    accessToken: {
      type: String,
      required: true
    },
    organizationId: {
      type: String,
      required: true
    },
    searchHub: {
      type: String,
      required: true
    },
    indexName: {
      type: String,
      required: true
    },
    templateId: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    this.initInterface();
  },


  components: {
    PractitionerFacets: _hcxfPractitionerFacets2["default"],
    coveoPagination: _atomicPagination2["default"]
  },
  methods: {
    initInterface: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this2 = this;

        var searchInterface, engine;
        return regeneratorRuntime.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.$nextTick();

              case 2:
                initMap();

                _context9.next = 5;
                return customElements.whenDefined('atomic-search-interface');

              case 5:
                searchInterface = document.querySelector('atomic-search-interface');


                waitForShadowElement('atomic-result-list', 'result-list', function (resultList) {
                  var style = document.createElement('style');
                  style.textContent = "\n                    ::-webkit-scrollbar {\n                        width: 8px;\n                    }\n                    ::-webkit-scrollbar-track {\n                        background: #e5e5e5;\n                        border-radius: 4px;\n                    }\n                    ::-webkit-scrollbar-thumb {\n                        background-color: #002f6c;\n                        border-radius: 4px;\n                    }\n                    ::-webkit-scrollbar-thumb:hover {\n                        background-color: #001d42;\n                    }\n                ";
                  resultList.appendChild(style);
                });
                // Initialization
                _context9.t0 = searchInterface;
                _context9.t1 = this.accessToken;
                _context9.t2 = this.organizationId;
                _context9.next = 12;
                return searchInterface.getOrganizationEndpoints(this.organizationId);

              case 12:
                _context9.t3 = _context9.sent;
                _context9.t4 = {
                  preprocessSearchResponseMiddleware: onSearchResultsUpdated
                };

                _context9.t5 = function preprocessRequest(request, clientOrigin, metadata) {
                  var body = JSON.parse(request.body);
                  if (clientOrigin === 'searchApiFetch') {
                    body.aq = '(@source==(\"' + _this2.indexName + '\") ( @z95xtemplate=' + _this2.templateId + '))';
                    body.searchHub = _this2.searchHub;
                  }

                  request.body = JSON.stringify(body);
                  return request;
                };

                _context9.t6 = {
                  accessToken: _context9.t1,
                  organizationId: _context9.t2,
                  organizationEndpoints: _context9.t3,
                  search: _context9.t4,
                  preprocessRequest: _context9.t5
                };
                _context9.next = 18;
                return _context9.t0.initialize.call(_context9.t0, _context9.t6);

              case 18:
                engine = searchInterface.engine;


                engine.subscribe(function () {
                  registerLinkEvents();
                  var searchBox = document.querySelector('atomic-search-box').shadowRoot;
                  if (searchBox.children[0] && searchBox.children[0].firstElementChild) {
                    var div = searchBox.children[0].firstElementChild;
                    if (div) {
                      div.classList.add("w-full");
                    }
                  }
                });

                // Trigger a first search
                _context9.next = 22;
                return searchInterface.executeFirstSearch();

              case 22:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee8, this);
      }));

      function initInterface() {
        return _ref11.apply(this, arguments);
      }

      return initInterface;
    }()
  }
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports['default'] = {
  data: function data() {
    return {
      showContent: false
    };
  },

  methods: {
    toggleContent: function toggleContent() {
      this.showContent = !this.showContent;
    }
  },
  props: {
    label: {
      type: String,
      'default': 'Keywords'
    },
    keywords: {
      type: Array,
      'default': function _default() {
        return Array(10).fill('keyword');
      },
      validator: function validator(value) {
        return value.every(function (item) {
          return typeof item === 'string';
        });
      }
    }
  }
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atomicPagination = __webpack_require__(58);

var _atomicPagination2 = _interopRequireDefault(_atomicPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    props: {
        accessToken: {
            type: String,
            required: true
        },
        organizationId: {
            type: String,
            required: true
        },
        searchHub: {
            type: String,
            required: true
        },
        indexName: {
            type: String,
            required: true
        },
        templateId: {
            type: String,
            required: true
        }

    },
    methods: {
        initInterface: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this = this;

                var searchInterface, engine;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return customElements.whenDefined("atomic-search-interface");

                            case 2:
                                searchInterface = document.querySelector("atomic-search-interface");
                                _context2.next = 5;
                                return searchInterface.initialize({
                                    accessToken: this.accessToken,
                                    organizationId: this.organizationId,
                                    preprocessRequest: function preprocessRequest(request, clientOrigin, metadata) {

                                        var body = JSON.parse(request.body);
                                        if (clientOrigin === 'searchApiFetch') {
                                            body.aq = '(@source==(\"' + _this.indexName + '\") ( @z95xtemplate=' + _this.templateId + '))';
                                            body.searchHub = _this.searchHub;
                                        }

                                        request.body = JSON.stringify(body);
                                        return request;
                                    }
                                });

                            case 5:
                                engine = searchInterface.engine;

                                searchInterface.executeFirstSearch();

                                engine.subscribe(function () {
                                    var searchBox = document.querySelector('atomic-search-box').shadowRoot;
                                    if (searchBox.children[0] && searchBox.children[0].firstElementChild) {
                                        var div = searchBox.children[0].firstElementChild;
                                        if (div) {
                                            div.classList.add("w-full");
                                        }
                                    }
                                    if (engine.state.query.q) {
                                        var clearButton = searchBox.querySelector('[part="clear-button"]');
                                        if (clearButton) {
                                            clearButton.addEventListener("click", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                                    while (1) {
                                                        switch (_context.prev = _context.next) {
                                                            case 0:
                                                                searchBox.querySelector('[part="submit-button"]').click();

                                                            case 1:
                                                            case "end":
                                                                return _context.stop();
                                                        }
                                                    }
                                                }, _callee, _this);
                                            })));
                                        }
                                    }
                                });

                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function initInterface() {
                return _ref.apply(this, arguments);
            }

            return initInterface;
        }()
    },
    mounted: function mounted() {
        this.initInterface();
    },

    components: {
        coveoPagination: _atomicPagination2["default"]
    }
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hcxfResearchResultTemplate = __webpack_require__(590);

var _hcxfResearchResultTemplate2 = _interopRequireDefault(_hcxfResearchResultTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  data: function data() {
    return {
      hcxfResearchResultTemplate: _hcxfResearchResultTemplate2['default']
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atomicPagination = __webpack_require__(58);

var _atomicPagination2 = _interopRequireDefault(_atomicPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
    data: function data() {
        return {
            allLinks: []
        };
    },

    props: {
        accessToken: {
            type: String,
            required: true
        },
        organizationId: {
            type: String,
            required: true
        },
        searchHub: {
            type: String,
            required: true
        },
        listingHeader: {
            type: String,
            required: true
        },
        indexName: {
            type: String,
            required: true
        },
        templateId: {
            type: String,
            required: true
        }
    },
    methods: {
        initInterface: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this = this;

                var searchInterface, engine;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return customElements.whenDefined("atomic-search-interface");

                            case 2:
                                searchInterface = document.querySelector("atomic-search-interface");
                                _context.next = 5;
                                return searchInterface.initialize({
                                    accessToken: this.accessToken,
                                    organizationId: this.organizationId,
                                    preprocessRequest: function preprocessRequest(request, clientOrigin, metadata) {
                                        var body = JSON.parse(request.body);
                                        if (clientOrigin === 'searchApiFetch') {
                                            body.aq = '(@source==(\"' + _this.indexName + '\") ( @z95xtemplate=' + _this.templateId + '))';
                                            body.searchHub = _this.searchHub;
                                        }
                                        request.body = JSON.stringify(body);
                                        return request;
                                    }
                                });

                            case 5:
                                engine = searchInterface.engine;

                                searchInterface.executeFirstSearch();

                                engine.subscribe(function () {
                                    setTimeout(function () {
                                        _this.checkForCardLink();
                                        _this.updateSpeedBump();
                                    }, 500);
                                });

                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function initInterface() {
                return _ref.apply(this, arguments);
            }

            return initInterface;
        }(),
        checkForCardLink: function checkForCardLink() {
            var _this2 = this;

            var nodes = document.querySelector('atomic-result-list').shadowRoot;
            var shadowNode = nodes.querySelectorAll("[part='outline']");
            if (shadowNode.length > 0) {
                shadowNode.forEach(function (node) {
                    var resultRoot = node.shadowRoot;
                    if (resultRoot) {
                        var link = resultRoot.querySelector('.result-link a');
                        var isExternalElement = resultRoot.querySelector('.isExternal');

                        var isInternalLink = isExternalElement === null ? false : isExternalElement.innerText == 0 ? false : isExternalElement.innerText == 1 ? true : false;

                        if (link && link.getAttribute('href')) {
                            if (isInternalLink && !link.classList.contains('twoClick')) {
                                link.classList.add('twoClick');
                                _this2.allLinks.push(link);
                            }
                        }
                    }
                });
            }
        },
        updateSpeedBump: function updateSpeedBump() {
            var speedBumps = this.allLinks;
            var speedBumpLink = document.querySelector('#speed-bump-link');
            window.activeSpeedBumpLink = null;
            Array.from(speedBumps).forEach(function (element, index) {
                if (!element.hasAttribute('speed-bump-set')) {
                    element.addEventListener('click', function (event) {
                        event.preventDefault();
                        window.activeSpeedBumpLink = event.currentTarget;
                        speedBumpLink.setAttribute('href', event.currentTarget.getAttribute('href'));
                        speedBumpLink.click();
                    });

                    element.setAttribute('speed-bump-set', '');
                }
            });
        }
    },
    mounted: function mounted() {
        this.initInterface();
    },

    components: {
        coveoPagination: _atomicPagination2["default"]
    }
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hcxfNewsResultTemplate = __webpack_require__(603);

var _hcxfNewsResultTemplate2 = _interopRequireDefault(_hcxfNewsResultTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  data: function data() {
    return {
      defaultResultTemplate: _hcxfNewsResultTemplate2['default']
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  name: "DashboardAlert",

  props: {
    message: {
      type: String,
      required: true,
      "default": ""
    }
  },

  data: function data() {
    return {
      isVisible: false
    };
  },
  mounted: function mounted() {
    this.checkMessageVisibility();
  },


  methods: {
    hideMessage: function hideMessage() {
      this.isVisible = false;
      localStorage.setItem("dashboardMessageClosed", "true");
      this.$emit("close");
    },
    checkMessageVisibility: function checkMessageVisibility() {
      var isMessageClosed = localStorage.getItem("dashboardMessageClosed") === "true";
      this.isVisible = !isMessageClosed;
    }
  }
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  name: "EventsList",

  props: {
    translations: {
      type: Object,
      required: true,
      "default": function _default() {
        return {
          EventsListHeading: "Heart Challenge Events",
          LoadingText: "Loading...",
          NoEventsText: "No events found.",
          MoreDetailsText: "More Details"
        };
      }
    },
    apiConfig: {
      type: Object,
      "default": function _default() {
        return {
          apiKey: "wDB09SQODRpVIOvX",
          baseUrl: "https://www2.heart.org/site/CRTeamraiserAPI"
        };
      }
    },
    customFilters: {
      type: Array,
      "default": function _default() {
        return ["Heart Walk", "Field Day", "Cyclenation"];
      }
    },
    dateLocale: {
      type: String,
      "default": "en-US"
    }
  },

  data: function data() {
    return {
      allEvents: [],
      loading: true,
      filters: this.transformFilters(this.customFilters)
    };
  },


  methods: {
    transformFilters: function transformFilters(filterLabels) {
      return filterLabels.map(function (label) {
        return {
          id: label.toLowerCase().replace(/\s+/g, "-"),
          label: label,
          checked: true // Set to true by default
        };
      });
    },
    fetchEvents: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var searchParams, apiParams, queryString, response, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                searchParams = this.getUrlParams();
                apiParams = {
                  v: "1.0",
                  api_key: this.apiConfig.apiKey,
                  response_format: "json",
                  list_page_size: 500,
                  list_sort_column: "event_date",
                  list_ascending: "true"
                };


                if (searchParams.state) {
                  apiParams = _extends({}, apiParams, {
                    method: "getTeamraisersByInfo",
                    state: searchParams.state
                  });
                } else if (searchParams.zipcode && searchParams.distance) {
                  apiParams = _extends({}, apiParams, {
                    method: "getTeamraisersByDistance",
                    starting_postal: searchParams.zipcode,
                    search_distance: searchParams.distance
                  });
                } else {
                  apiParams = _extends({}, apiParams, {
                    method: "getTeamraisersByInfo"
                  });
                }

                _context.prev = 3;
                queryString = new URLSearchParams(apiParams).toString();
                _context.next = 7;
                return fetch(this.apiConfig.baseUrl + "?" + queryString);

              case 7:
                response = _context.sent;
                _context.next = 10;
                return response.json();

              case 10:
                data = _context.sent;


                if (data.getTeamraisersResponse && data.getTeamraisersResponse.teamraiser) {
                  this.allEvents = Array.isArray(data.getTeamraisersResponse.teamraiser) ? data.getTeamraisersResponse.teamraiser : [data.getTeamraisersResponse.teamraiser];
                } else {
                  this.allEvents = [];
                }
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);

                console.error("API call failed:", _context.t0);
                this.allEvents = [];

              case 18:
                _context.prev = 18;

                this.loading = false;
                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 14, 18, 21]]);
      }));

      function fetchEvents() {
        return _ref.apply(this, arguments);
      }

      return fetchEvents;
    }(),
    getUrlParams: function getUrlParams() {
      var params = new URLSearchParams(window.location.search);
      var searchParams = {};

      if (params.has("state")) {
        searchParams.state = params.get("state");
      } else if (params.has("zipcode") && params.has("distance")) {
        searchParams.zipcode = params.get("zipcode");
        searchParams.distance = params.get("distance");
      }

      return searchParams;
    },
    formatDate: function formatDate(dateString) {
      return new Date(dateString).toLocaleDateString(this.dateLocale, {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    },
    handleFilterChange: function handleFilterChange() {
      // Filter changes are handled through the displayedEvents computed property
    }
  },

  computed: {
    displayedEvents: function displayedEvents() {
      var uncheckedFilters = this.filters.filter(function (f) {
        return !f.checked;
      }).map(function (f) {
        return f.id.replace("-", " ").toLowerCase();
      });

      if (uncheckedFilters.length === 0) {
        return this.allEvents;
      }

      return this.allEvents.filter(function (event) {
        var eventName = event.name.toLowerCase();
        // Return true if the event name doesn't match any unchecked filters
        return !uncheckedFilters.some(function (filter) {
          return eventName.includes(filter);
        });
      });
    }
  },

  created: function created() {
    this.fetchEvents();
  }
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports["default"] = {
  name: "EventSearch",

  props: {
    translations: {
      type: Object,
      required: true
    },
    HeartChallengeMiles: {
      type: Array,
      required: true
    },
    HeartChallengeStates: {
      type: Array,
      required: true
    },
    apiKey: {
      type: String,
      required: true
    },
    baseUrl: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      formData: {
        zipCode: "",
        distance: "",
        state: ""
      },
      zipCodeError: "",
      events: [],
      loading: false,
      searchPerformed: false
    };
  },


  computed: {
    viewMoreUrl: function viewMoreUrl() {
      var baseUrl = "/events";
      if (this.formData.state) {
        return baseUrl + "?state=" + encodeURIComponent(this.formData.state);
      } else if (this.formData.zipCode && this.formData.distance) {
        return baseUrl + "?zipcode=" + encodeURIComponent(this.formData.zipCode) + "&distance=" + encodeURIComponent(this.formData.distance);
      }
      return baseUrl;
    },
    isFormValid: function isFormValid() {
      return this.formData.state !== "" || this.formData.zipCode !== "" && this.isValidZipCode(this.formData.zipCode) && this.formData.distance !== "";
    }
  },

  methods: {
    // Basic ZIP code validation
    isValidZipCode: function isValidZipCode(zipCode) {
      // First check if it's 5 digits
      if (!/^\d{5}$/.test(zipCode)) return false;

      // Convert to number to check range
      var numericZip = parseInt(zipCode, 10);
      return numericZip >= 1 && numericZip <= 99950;
    },


    // Validate Zip Code and clear state if valid
    validateZipCode: function validateZipCode() {
      this.zipCodeError = "";
      if (this.formData.zipCode && !this.isValidZipCode(this.formData.zipCode)) {
        this.zipCodeError = "Please enter a valid ZIP code";
      }
      this.clearState();
    },
    validateKeyPress: function validateKeyPress(e) {
      // Only allow numeric input (0-9)
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },


    // Add this new method to determine the image prefix based on event name
    getImagePrefix: function getImagePrefix(eventName) {
      var nameLower = eventName.toLowerCase();
      if (nameLower.includes("cyclenation")) {
        return "cyclenation_event_card";
      } else if (nameLower.includes("field day")) {
        return "field_day_event_card";
      }
      return "heartwalk_event_card";
    },


    // Add this method to get the image number (1, 2, or 3)
    getImageNumber: function getImageNumber(index) {
      // Use modulo to cycle through 1, 2, 3
      return index % 3 + 1;
    },


    // Add this method to generate the full image path
    getEventImagePath: function getEventImagePath(eventName, index) {
      var prefix = this.getImagePrefix(eventName);
      var imageNumber = this.getImageNumber(index);
      return "/-/media/Project/WBWB/Dashboard-Page/" + prefix + "_" + imageNumber + ".jpg";
    },
    clearState: function clearState() {
      this.formData.state = "";
    },
    clearZipAndDistance: function clearZipAndDistance() {
      this.formData.zipCode = "";
      this.formData.distance = "";
      this.zipCodeError = "";
    },
    handleSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, queryString, response, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isFormValid) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!(this.formData.zipCode && !this.isValidZipCode(this.formData.zipCode))) {
                  _context.next = 5;
                  break;
                }

                this.zipCodeError = "Please enter a valid ZIP code";
                return _context.abrupt("return");

              case 5:

                this.loading = true;
                params = {
                  v: "1.0",
                  api_key: this.apiKey,
                  response_format: "json",
                  list_page_offset: 0,
                  list_page_size: 5,
                  list_sort_column: "event_date",
                  list_ascending: "true"
                };


                if (this.formData.zipCode && this.formData.distance) {
                  params = _extends({}, params, {
                    method: "getTeamraisersByDistance",
                    starting_postal: this.formData.zipCode,
                    search_distance: this.formData.distance
                  });
                } else if (this.formData.state) {
                  params = _extends({}, params, {
                    method: "getTeamraisersByInfo",
                    state: this.formData.state
                  });
                }

                _context.prev = 8;
                queryString = new URLSearchParams(params).toString();
                _context.next = 12;
                return fetch(this.baseUrl + "?" + queryString);

              case 12:
                response = _context.sent;
                _context.next = 15;
                return response.json();

              case 15:
                data = _context.sent;


                console.log("Full API Response:", data);

                if (data.getTeamraisersResponse && data.getTeamraisersResponse.teamraiser) {
                  this.events = Array.isArray(data.getTeamraisersResponse.teamraiser) ? data.getTeamraisersResponse.teamraiser : [data.getTeamraisersResponse.teamraiser];
                  this.searchPerformed = true;
                } else {
                  this.events = [];
                }
                _context.next = 26;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](8);

                console.error("API call failed:", _context.t0);
                this.events = [];
                console.log("this.events api fail", this.events, "length", this.events.length);
                this.searchPerformed = true;

              case 26:
                _context.prev = 26;

                this.loading = false;
                return _context.finish(26);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 20, 26, 29]]);
      }));

      function handleSubmit() {
        return _ref.apply(this, arguments);
      }

      return handleSubmit;
    }(),
    formatMonth: function formatMonth(dateString) {
      return new Date(dateString).toLocaleString("en-US", { month: "short" }).toUpperCase();
    },
    formatDay: function formatDay(dateString) {
      return new Date(dateString).getDate();
    },
    formatFullDate: function formatFullDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    }
  }
};

/***/ }),
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(635);

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapVue = __webpack_require__(662);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _veeValidate = __webpack_require__(696);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueClipboard = __webpack_require__(697);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

var _vuex = __webpack_require__(48);

var _vuex2 = _interopRequireDefault(_vuex);

var _vue2GoogleMaps = __webpack_require__(698);

var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);

var _appIcon = __webpack_require__(265);

var _appIcon2 = _interopRequireDefault(_appIcon);

var _fitText = __webpack_require__(270);

var _fitText2 = _interopRequireDefault(_fitText);

var _ahaNavDropdown = __webpack_require__(272);

var _ahaNavDropdown2 = _interopRequireDefault(_ahaNavDropdown);

var _ahaSelectDropdown = __webpack_require__(276);

var _ahaSelectDropdown2 = _interopRequireDefault(_ahaSelectDropdown);

var _ahaSelectDropdownItem = __webpack_require__(277);

var _ahaSelectDropdownItem2 = _interopRequireDefault(_ahaSelectDropdownItem);

var _locationSelector = __webpack_require__(278);

var _locationSelector2 = _interopRequireDefault(_locationSelector);

var _locationSelectorForm = __webpack_require__(281);

var _locationSelectorForm2 = _interopRequireDefault(_locationSelectorForm);

var _locationSelectorTable = __webpack_require__(283);

var _locationSelectorTable2 = _interopRequireDefault(_locationSelectorTable);

var _strokeGroupSelector = __webpack_require__(285);

var _strokeGroupSelector2 = _interopRequireDefault(_strokeGroupSelector);

var _strokeGroupSelectorForm = __webpack_require__(288);

var _strokeGroupSelectorForm2 = _interopRequireDefault(_strokeGroupSelectorForm);

var _strokeGroupSelectorTable = __webpack_require__(290);

var _strokeGroupSelectorTable2 = _interopRequireDefault(_strokeGroupSelectorTable);

var _ahaYoutube = __webpack_require__(292);

var _ahaYoutube2 = _interopRequireDefault(_ahaYoutube);

var _ahaNotification = __webpack_require__(293);

var _ahaNotification2 = _interopRequireDefault(_ahaNotification);

var _ahaMobileNav = __webpack_require__(295);

var _ahaMobileNav2 = _interopRequireDefault(_ahaMobileNav);

var _ahaMobileNavPanel = __webpack_require__(297);

var _ahaMobileNavPanel2 = _interopRequireDefault(_ahaMobileNavPanel);

var _ahaMobileNavSearchPanel = __webpack_require__(299);

var _ahaMobileNavSearchPanel2 = _interopRequireDefault(_ahaMobileNavSearchPanel);

var _ahaRecipeCheckbox = __webpack_require__(301);

var _ahaRecipeCheckbox2 = _interopRequireDefault(_ahaRecipeCheckbox);

var _ahaRecipeSocial = __webpack_require__(302);

var _ahaRecipeSocial2 = _interopRequireDefault(_ahaRecipeSocial);

var _ahaModal = __webpack_require__(303);

var _ahaModal2 = _interopRequireDefault(_ahaModal);

var _ahaListbox = __webpack_require__(305);

var _ahaListbox2 = _interopRequireDefault(_ahaListbox);

var _ahaGoogleMap = __webpack_require__(306);

var _ahaGoogleMap2 = _interopRequireDefault(_ahaGoogleMap);

var _ahaHalfImageHalfCopyCollapse = __webpack_require__(312);

var _ahaHalfImageHalfCopyCollapse2 = _interopRequireDefault(_ahaHalfImageHalfCopyCollapse);

var _ahaDonationModal = __webpack_require__(314);

var _ahaDonationModal2 = _interopRequireDefault(_ahaDonationModal);

var _ahaHospitalZipcodeModal = __webpack_require__(316);

var _ahaHospitalZipcodeModal2 = _interopRequireDefault(_ahaHospitalZipcodeModal);

var _ahaSessionTimeoutModal = __webpack_require__(318);

var _ahaSessionTimeoutModal2 = _interopRequireDefault(_ahaSessionTimeoutModal);

var _ahaTransitionGroup = __webpack_require__(320);

var _ahaTransitionGroup2 = _interopRequireDefault(_ahaTransitionGroup);

var _ahaTransitionGroupForm = __webpack_require__(322);

var _ahaTransitionGroupForm2 = _interopRequireDefault(_ahaTransitionGroupForm);

var _ahaTransitionStep = __webpack_require__(325);

var _ahaTransitionStep2 = _interopRequireDefault(_ahaTransitionStep);

var _ahaTransitionTrigger = __webpack_require__(327);

var _ahaTransitionTrigger2 = _interopRequireDefault(_ahaTransitionTrigger);

var _ahaTransitionInputValue = __webpack_require__(328);

var _ahaTransitionInputValue2 = _interopRequireDefault(_ahaTransitionInputValue);

var _ahaInlineSiteSearch = __webpack_require__(329);

var _ahaInlineSiteSearch2 = _interopRequireDefault(_ahaInlineSiteSearch);

var _impactedData = __webpack_require__(331);

var _impactedData2 = _interopRequireDefault(_impactedData);

var _ahaSearchResultsForm = __webpack_require__(333);

var _ahaSearchResultsForm2 = _interopRequireDefault(_ahaSearchResultsForm);

var _ahaBackToSearch = __webpack_require__(335);

var _ahaBackToSearch2 = _interopRequireDefault(_ahaBackToSearch);

var _ahaShare = __webpack_require__(341);

var _ahaShare2 = _interopRequireDefault(_ahaShare);

var _ahaShareGigya = __webpack_require__(342);

var _ahaShareGigya2 = _interopRequireDefault(_ahaShareGigya);

var _ahaSingleFieldPromptForm = __webpack_require__(343);

var _ahaSingleFieldPromptForm2 = _interopRequireDefault(_ahaSingleFieldPromptForm);

var _ahaSingleFieldPromptRadioForm = __webpack_require__(345);

var _ahaSingleFieldPromptRadioForm2 = _interopRequireDefault(_ahaSingleFieldPromptRadioForm);

var _ahaTvPageModal = __webpack_require__(347);

var _ahaTvPageModal2 = _interopRequireDefault(_ahaTvPageModal);

var _ahaMakeCommitmentForm = __webpack_require__(349);

var _ahaMakeCommitmentForm2 = _interopRequireDefault(_ahaMakeCommitmentForm);

var _ahaAddToRecipeBox = __webpack_require__(351);

var _ahaAddToRecipeBox2 = _interopRequireDefault(_ahaAddToRecipeBox);

var _ahaRecipeBoxFavorite = __webpack_require__(353);

var _ahaRecipeBoxFavorite2 = _interopRequireDefault(_ahaRecipeBoxFavorite);

var _ahaModifyRecipeBox = __webpack_require__(355);

var _ahaModifyRecipeBox2 = _interopRequireDefault(_ahaModifyRecipeBox);

var _ahaCopyUrlToClipboard = __webpack_require__(358);

var _ahaCopyUrlToClipboard2 = _interopRequireDefault(_ahaCopyUrlToClipboard);

var _ahaExternalScript = __webpack_require__(360);

var _ahaExternalScript2 = _interopRequireDefault(_ahaExternalScript);

var _footerSupportBarSection = __webpack_require__(362);

var _footerSupportBarSection2 = _interopRequireDefault(_footerSupportBarSection);

var _simpleAccordion = __webpack_require__(364);

var _simpleAccordion2 = _interopRequireDefault(_simpleAccordion);

var _ahaDafWidget = __webpack_require__(366);

var _ahaDafWidget2 = _interopRequireDefault(_ahaDafWidget);

var _ahaCollapsableView = __webpack_require__(370);

var _ahaCollapsableView2 = _interopRequireDefault(_ahaCollapsableView);

var _ahaSelectionCard = __webpack_require__(372);

var _ahaSelectionCard2 = _interopRequireDefault(_ahaSelectionCard);

var _ahaSwitchInput = __webpack_require__(374);

var _ahaSwitchInput2 = _interopRequireDefault(_ahaSwitchInput);

var _ahaCardSelector = __webpack_require__(378);

var _ahaCardSelector2 = _interopRequireDefault(_ahaCardSelector);

var _ahaCardSelectorFilter = __webpack_require__(380);

var _ahaCardSelectorFilter2 = _interopRequireDefault(_ahaCardSelectorFilter);

var _ahaCardViewer = __webpack_require__(382);

var _ahaCardViewer2 = _interopRequireDefault(_ahaCardViewer);

var _ahaCardViewerText = __webpack_require__(384);

var _ahaCardViewerText2 = _interopRequireDefault(_ahaCardViewerText);

var _ahaMaskedInput = __webpack_require__(386);

var _ahaMaskedInput2 = _interopRequireDefault(_ahaMaskedInput);

var _ahaCprSearchCourseWrapper = __webpack_require__(390);

var _ahaCprSearchCourseWrapper2 = _interopRequireDefault(_ahaCprSearchCourseWrapper);

var _phdScienceVolunteerModal = __webpack_require__(391);

var _phdScienceVolunteerModal2 = _interopRequireDefault(_phdScienceVolunteerModal);

var _ahaNewsletterAjaxThankYou = __webpack_require__(393);

var _ahaNewsletterAjaxThankYou2 = _interopRequireDefault(_ahaNewsletterAjaxThankYou);

var _ahaSitecoreFormWrapper = __webpack_require__(397);

var _ahaSitecoreFormWrapper2 = _interopRequireDefault(_ahaSitecoreFormWrapper);

var _ratingsWidgetStar = __webpack_require__(401);

var _ratingsWidgetStar2 = _interopRequireDefault(_ratingsWidgetStar);

var _ahaCarousel = __webpack_require__(406);

var _ahaCarousel2 = _interopRequireDefault(_ahaCarousel);

var _ahaGroceryList = __webpack_require__(408);

var _ahaGroceryList2 = _interopRequireDefault(_ahaGroceryList);

var _ahaGroceryCount = __webpack_require__(410);

var _ahaGroceryCount2 = _interopRequireDefault(_ahaGroceryCount);

var _ahaContestantGrid = __webpack_require__(412);

var _ahaContestantGrid2 = _interopRequireDefault(_ahaContestantGrid);

var _pluralize = __webpack_require__(420);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _verticalAlign = __webpack_require__(421);

var _verticalAlign2 = _interopRequireDefault(_verticalAlign);

var _lazyImg = __webpack_require__(422);

var _lazyImg2 = _interopRequireDefault(_lazyImg);

var _toggleChecked = __webpack_require__(423);

var _toggleChecked2 = _interopRequireDefault(_toggleChecked);

var _toggleCreditImage = __webpack_require__(424);

var _toggleCreditImage2 = _interopRequireDefault(_toggleCreditImage);

var _perfectScrollbar = __webpack_require__(425);

var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);

var _shareButton = __webpack_require__(426);

var _shareButton2 = _interopRequireDefault(_shareButton);

var _speedBump = __webpack_require__(427);

var _speedBump2 = _interopRequireDefault(_speedBump);

var _ssoIntercept = __webpack_require__(428);

var _ssoIntercept2 = _interopRequireDefault(_ssoIntercept);

var _printElement = __webpack_require__(430);

var _printElement2 = _interopRequireDefault(_printElement);

var _registerEvent = __webpack_require__(431);

var _registerEvent2 = _interopRequireDefault(_registerEvent);

var _formSubmit = __webpack_require__(432);

var _formSubmit2 = _interopRequireDefault(_formSubmit);

var _formValidate = __webpack_require__(433);

var _formValidate2 = _interopRequireDefault(_formValidate);

var _formSubmitCheckbox = __webpack_require__(434);

var _formSubmitCheckbox2 = _interopRequireDefault(_formSubmitCheckbox);

var _buttonCollapseContent = __webpack_require__(435);

var _buttonCollapseContent2 = _interopRequireDefault(_buttonCollapseContent);

var _imageVideoCarousel = __webpack_require__(436);

var _imageVideoCarousel2 = _interopRequireDefault(_imageVideoCarousel);

var _luminateDonateForm = __webpack_require__(437);

var _luminateDonateForm2 = _interopRequireDefault(_luminateDonateForm);

var _maxChildrenHeight = __webpack_require__(438);

var _maxChildrenHeight2 = _interopRequireDefault(_maxChildrenHeight);

var _nestedAccordion = __webpack_require__(439);

var _nestedAccordion2 = _interopRequireDefault(_nestedAccordion);

var _tabs = __webpack_require__(440);

var _tabs2 = _interopRequireDefault(_tabs);

var _tabsCustomTabbing = __webpack_require__(441);

var _tabsCustomTabbing2 = _interopRequireDefault(_tabsCustomTabbing);

var _hiddenInput = __webpack_require__(442);

var _hiddenInput2 = _interopRequireDefault(_hiddenInput);

var _input = __webpack_require__(443);

var _input2 = _interopRequireDefault(_input);

var _youtubeModal = __webpack_require__(444);

var _youtubeModal2 = _interopRequireDefault(_youtubeModal);

var _closeCoveoModal = __webpack_require__(445);

var _closeCoveoModal2 = _interopRequireDefault(_closeCoveoModal);

var _formSubmitGroceryEmail = __webpack_require__(446);

var _formSubmitGroceryEmail2 = _interopRequireDefault(_formSubmitGroceryEmail);

var _votingAction = __webpack_require__(447);

var _votingAction2 = _interopRequireDefault(_votingAction);

var _votingMarketingOptedIn = __webpack_require__(448);

var _votingMarketingOptedIn2 = _interopRequireDefault(_votingMarketingOptedIn);

var _speedBumpLinks = __webpack_require__(449);

var _speedBumpLinks2 = _interopRequireDefault(_speedBumpLinks);

var _skipTo = __webpack_require__(450);

var _skipTo2 = _interopRequireDefault(_skipTo);

var _selectAll = __webpack_require__(451);

var _selectAll2 = _interopRequireDefault(_selectAll);

var _speedBumpModalTabbing = __webpack_require__(452);

var _speedBumpModalTabbing2 = _interopRequireDefault(_speedBumpModalTabbing);

var _customEvent = __webpack_require__(453);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _objectFit = __webpack_require__(121);

var _objectFit2 = _interopRequireDefault(_objectFit);

var _localstorage = __webpack_require__(454);

var _localstorage2 = _interopRequireDefault(_localstorage);

var _fromStore = __webpack_require__(455);

var _fromStore2 = _interopRequireDefault(_fromStore);

var _inputMask = __webpack_require__(457);

var _inputMask2 = _interopRequireDefault(_inputMask);

var _stickyHeader = __webpack_require__(458);

var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

var _analyticsCampaignTracker = __webpack_require__(459);

var _analyticsCampaignTracker2 = _interopRequireDefault(_analyticsCampaignTracker);

var _courseSearchForm = __webpack_require__(460);

var _courseSearchForm2 = _interopRequireDefault(_courseSearchForm);

var _phdProVolSearch = __webpack_require__(461);

var _phdProVolSearch2 = _interopRequireDefault(_phdProVolSearch);

var _authoring = __webpack_require__(462);

var _authoring2 = _interopRequireDefault(_authoring);

var _vjsDropdownCoveo = __webpack_require__(464);

var _vjsDropdownCoveo2 = _interopRequireDefault(_vjsDropdownCoveo);

var _coveoEvents = __webpack_require__(465);

var _coveoEvents2 = _interopRequireDefault(_coveoEvents);

var _fundraiseUp = __webpack_require__(466);

var _fundraiseUp2 = _interopRequireDefault(_fundraiseUp);

var _detectIos = __webpack_require__(467);

var _detectIos2 = _interopRequireDefault(_detectIos);

var _revealElementBehindSticky = __webpack_require__(468);

var _revealElementBehindSticky2 = _interopRequireDefault(_revealElementBehindSticky);

var _ahaCookie = __webpack_require__(54);

var _itemsStorage = __webpack_require__(78);

var _ckmRiskCalculator = __webpack_require__(157);

var _ckmRiskCalculator2 = _interopRequireDefault(_ckmRiskCalculator);

var _hcfCalculator = __webpack_require__(159);

var _hcfCalculator2 = _interopRequireDefault(_hcfCalculator);

var _ahaSearchDropdown = __webpack_require__(161);

var _ahaSearchDropdown2 = _interopRequireDefault(_ahaSearchDropdown);

var _primacyCalculator = __webpack_require__(478);

var _primacyCalculator2 = _interopRequireDefault(_primacyCalculator);

var _ahaSaveVideo = __webpack_require__(496);

var _ahaSaveVideo2 = _interopRequireDefault(_ahaSaveVideo);

var _ahaSavedVideos = __webpack_require__(500);

var _ahaSavedVideos2 = _interopRequireDefault(_ahaSavedVideos);

var _ahaSaveTeaserVideo = __webpack_require__(504);

var _ahaSaveTeaserVideo2 = _interopRequireDefault(_ahaSaveTeaserVideo);

var _ahaResetPersonalization = __webpack_require__(506);

var _ahaResetPersonalization2 = _interopRequireDefault(_ahaResetPersonalization);

var _ahaSearchFundingOpportunities = __webpack_require__(172);

var _ahaSearchFundingOpportunities2 = _interopRequireDefault(_ahaSearchFundingOpportunities);

__webpack_require__(511);

__webpack_require__(546);

__webpack_require__(551);

__webpack_require__(605);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Expose VanillaJS Dropdown plugin to Global scope


// HCxF Components

// Phd Components


// Global Filter
window.VJSDropdown = new _authoring2['default']();

// Wbwb Components

// Plugins

// import setMainNavActive from '@/utils/main-nav-active';

// import setSsoInterceptLinks from '@/utils/sso-intercept-links'; // removed by C.Castle


// Global directives

// added contestant grid


// Reusuable Generic components


_vue2['default'].use(_bootstrapVue2['default']);
_vue2['default'].use(_veeValidate2['default']);
_vue2['default'].use(_vueClipboard2['default']);
_vue2['default'].use(_vuex2['default']);
_vue2['default'].use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAfoI8CjSCPhRd7IYXmgAbArVRkEdGvMyU',
        libraries: 'places'
    }
});

_vue2['default'].filter('pluralize', _pluralize2['default']);

_vue2['default'].directive('vertical-align', _verticalAlign2['default']);
_vue2['default'].directive('lazy-img', _lazyImg2['default']);
_vue2['default'].directive('toggle-checked', _toggleChecked2['default']);
_vue2['default'].directive('toggle-credit-image', _toggleCreditImage2['default']);
_vue2['default'].directive('share-button', _shareButton2['default']);
_vue2['default'].directive('perfect-scrollbar', _perfectScrollbar2['default']);
_vue2['default'].directive('speed-bump', _speedBump2['default']);
_vue2['default'].directive('sso-intercept', _ssoIntercept2['default']);
_vue2['default'].directive('print-element', _printElement2['default']);
_vue2['default'].directive('register-event', _registerEvent2['default']);
_vue2['default'].directive('form-submit', _formSubmit2['default']);
_vue2['default'].directive('form-validate', _formValidate2['default']);
_vue2['default'].directive('form-submit-checkbox', _formSubmitCheckbox2['default']);
_vue2['default'].directive('button-collapse-content', _buttonCollapseContent2['default']);
_vue2['default'].directive('image-video-carousel', _imageVideoCarousel2['default']);
_vue2['default'].directive('luminate-donate-form', _luminateDonateForm2['default']);
_vue2['default'].directive('max-children-height', _maxChildrenHeight2['default']);
_vue2['default'].directive('nestedAccordion', _nestedAccordion2['default']);
_vue2['default'].directive('tabs', _tabs2['default']);
_vue2['default'].directive('tabs-custom-tabbing', _tabsCustomTabbing2['default']);
_vue2['default'].directive('hidden-input', _hiddenInput2['default']);
_vue2['default'].directive('input', _input2['default']);
_vue2['default'].directive('youtube-modal', _youtubeModal2['default']);
_vue2['default'].directive('close-coveo-modal', _closeCoveoModal2['default']);
_vue2['default'].directive('from-store', _fromStore2['default']);
_vue2['default'].directive('aha-mask', _inputMask2['default']);
_vue2['default'].directive('sticky-header', _stickyHeader2['default']);
_vue2['default'].directive('course-search-form', _courseSearchForm2['default']);
_vue2['default'].directive('phd-pro-vol-search', _phdProVolSearch2['default']);
_vue2['default'].directive('form-submit-grocery-email', _formSubmitGroceryEmail2['default']);
_vue2['default'].directive('ckm-risk-calculator', _ckmRiskCalculator2['default']);
_vue2['default'].directive('hcf-calculator', _hcfCalculator2['default']);
_vue2['default'].directive('voting-action', _votingAction2['default']);
_vue2['default'].directive('voting-marketing-optedin', _votingMarketingOptedIn2['default']);
_vue2['default'].directive('aha-search-dropdown', _ahaSearchDropdown2['default']);
_vue2['default'].directive('aha-search-funding-opportunities', _ahaSearchFundingOpportunities2['default']);

// Non-visual required components
_vue2['default'].component('app-icon', _appIcon2['default']);
_vue2['default'].component('fit-text', _fitText2['default']);
_vue2['default'].component('aha-nav-dropdown', _ahaNavDropdown2['default']);
_vue2['default'].component('aha-select-dropdown', _ahaSelectDropdown2['default']);
_vue2['default'].component('aha-select-dropdown-item', _ahaSelectDropdownItem2['default']);
_vue2['default'].component('aha-location-selector', _locationSelector2['default']);
_vue2['default'].component('aha-location-selector-form', _locationSelectorForm2['default']);
_vue2['default'].component('aha-location-selector-table', _locationSelectorTable2['default']);
_vue2['default'].component('aha-stroke-group-selector', _strokeGroupSelector2['default']);
_vue2['default'].component('aha-stroke-group-selector-form', _strokeGroupSelectorForm2['default']);
_vue2['default'].component('aha-stroke-group-selector-table', _strokeGroupSelectorTable2['default']);
_vue2['default'].component('aha-youtube', _ahaYoutube2['default']);
_vue2['default'].component('aha-notification', _ahaNotification2['default']);
_vue2['default'].component('aha-mobile-nav', _ahaMobileNav2['default']);
_vue2['default'].component('aha-mobile-nav-panel', _ahaMobileNavPanel2['default']);
_vue2['default'].component('aha-mobile-nav-search-panel', _ahaMobileNavSearchPanel2['default']);
_vue2['default'].component('aha-recipe-checkbox', _ahaRecipeCheckbox2['default']);
_vue2['default'].component('aha-recipe-social', _ahaRecipeSocial2['default']);
_vue2['default'].component('aha-modal', _ahaModal2['default']);
_vue2['default'].component('aha-listbox', _ahaListbox2['default']);
_vue2['default'].component('aha-donation-modal', _ahaDonationModal2['default']);
_vue2['default'].component('aha-hospital-zipcode-modal', _ahaHospitalZipcodeModal2['default']);
_vue2['default'].component('aha-session-timeout-modal', _ahaSessionTimeoutModal2['default']);
_vue2['default'].component('aha-inline-site-search', _ahaInlineSiteSearch2['default']);
_vue2['default'].component('impacted-data', _impactedData2['default']);
_vue2['default'].component('aha-back-to-search-link', _ahaBackToSearch2['default']);
_vue2['default'].component('aha-share', _ahaShare2['default']);
_vue2['default'].component('aha-share-gigya', _ahaShareGigya2['default']);
_vue2['default'].component('aha-transition-group', _ahaTransitionGroup2['default']);
_vue2['default'].component('aha-transition-group-form', _ahaTransitionGroupForm2['default']);
_vue2['default'].component('aha-transition-step', _ahaTransitionStep2['default']);
_vue2['default'].component('aha-transition-trigger', _ahaTransitionTrigger2['default']);
_vue2['default'].component('aha-transition-input-value', _ahaTransitionInputValue2['default']);
_vue2['default'].component('aha-search-results-form', _ahaSearchResultsForm2['default']);
_vue2['default'].component('aha-single-field-prompt-form', _ahaSingleFieldPromptForm2['default']);
_vue2['default'].component('aha-single-field-prompt-radio-form', _ahaSingleFieldPromptRadioForm2['default']);
_vue2['default'].component('aha-tv-page-modal', _ahaTvPageModal2['default']);
_vue2['default'].component('aha-make-commitment-form', _ahaMakeCommitmentForm2['default']);
_vue2['default'].component('aha-add-to-recipe-box', _ahaAddToRecipeBox2['default']);
_vue2['default'].component('aha-recipe-box-favorite', _ahaRecipeBoxFavorite2['default']);
_vue2['default'].component('aha-modify-recipe-box', _ahaModifyRecipeBox2['default']);
_vue2['default'].component('aha-google-map', _ahaGoogleMap2['default']);
_vue2['default'].component('aha-half-image-half-copy-collapse', _ahaHalfImageHalfCopyCollapse2['default']);
_vue2['default'].component('aha-copy-url-to-clipboard', _ahaCopyUrlToClipboard2['default']);
_vue2['default'].component('aha-external-script', _ahaExternalScript2['default']);
_vue2['default'].component('support-bar-section', _footerSupportBarSection2['default']);
_vue2['default'].component('simple-accordion', _simpleAccordion2['default']);
_vue2['default'].component('aha-daf-widget', _ahaDafWidget2['default']);
_vue2['default'].component('aha-selection-card', _ahaSelectionCard2['default']);
_vue2['default'].component('aha-card-selector', _ahaCardSelector2['default']);
_vue2['default'].component('aha-card-selector-filter', _ahaCardSelectorFilter2['default']);
_vue2['default'].component('aha-card-viewer', _ahaCardViewer2['default']);
_vue2['default'].component('aha-card-viewer-text', _ahaCardViewerText2['default']);
_vue2['default'].component('aha-switch-input', _ahaSwitchInput2['default']);
_vue2['default'].component('aha-collapsable-view', _ahaCollapsableView2['default']);
_vue2['default'].component('aha-masked-input', _ahaMaskedInput2['default']);
_vue2['default'].component('aha-cpr-search-course-wrapper', _ahaCprSearchCourseWrapper2['default']);
_vue2['default'].component('phd-science-volunteer-modal', _phdScienceVolunteerModal2['default']);
_vue2['default'].component('aha-newsletter-ajax-thank-you', _ahaNewsletterAjaxThankYou2['default']);
_vue2['default'].component('aha-sitecore-form-wrapper', _ahaSitecoreFormWrapper2['default']);
_vue2['default'].component('ratings-widget-star', _ratingsWidgetStar2['default']);
_vue2['default'].component('aha-carousel', _ahaCarousel2['default']);
_vue2['default'].component('aha-grocery-list', _ahaGroceryList2['default']);
_vue2['default'].component('aha-grocery-count', _ahaGroceryCount2['default']);
_vue2['default'].component('ckm-risk-calculator', _ckmRiskCalculator2['default']);
_vue2['default'].component('hcf-calculator', _hcfCalculator2['default']);
// added new aha contestant grid
_vue2['default'].component('aha-contestant-grid', _ahaContestantGrid2['default']);
_vue2['default'].component('primacy-calculator', _primacyCalculator2['default']);
_vue2['default'].component('aha-reset-personalization', _ahaResetPersonalization2['default']);
_vue2['default'].component('aha-save-video', _ahaSaveVideo2['default']);
_vue2['default'].component('aha-saved-videos', _ahaSavedVideos2['default']);
_vue2['default'].component('aha-save-teaser-video', _ahaSaveTeaserVideo2['default']);
_vue2['default'].directive('aha-search-funding-opportunities', _ahaSearchFundingOpportunities2['default']);

_vue2['default'].config.ignoredElements = ['atomic-search-interface', 'atomic-search-layout', 'atomic-layout-section', 'atomic-search-box', 'atomic-facet-manager', 'atomic-category-facet', 'atomic-facet', 'atomic-numeric-facet', 'atomic-numeric-range', 'atomic-timeframe-facet', 'atomic-timeframe', 'atomic-rating-facet', 'atomic-rating-range-facet', 'atomic-color-facet', 'atomic-format-currency', 'atomic-segmented-facet-scrollable', 'atomic-segmented-facet', 'atomic-popover', 'atomic-breadbox', 'atomic-query-summary', 'atomic-refine-toggle', 'atomic-sort-dropdown', 'atomic-sort-expression', 'atomic-did-you-mean', 'atomic-notifications', 'atomic-smart-snippet', 'atomic-smart-snippet-suggestions', 'atomic-query-error', 'atomic-no-results', 'atomic-load-more-results', 'atomic-result-list', 'atomic-result-template', 'atomic-result-section-visual', 'atomic-result-section-title', 'atomic-result-link', 'atomic-result-section-excerpt', 'atomic-result-text'];

_vue2['default'].prototype.$eventHub = new _vue2['default']();

/* eslint-disable */
window.ahavm = new _vue2['default']({
    el: '#app'
});

// Set up the speed-bump hack to bridge between vanilla JS and Vue
(0, _speedBumpLinks2['default'])('.twoClick, .twoclick', '#speed-bump-link');
// setSsoInterceptLinks('#sso-intercept-link'); // removed by C.Castle
(0, _skipTo2['default'])('.c-skip-to');
(0, _selectAll2['default'])();
// setMainNavActive();
(0, _speedBumpModalTabbing2['default'])();
(0, _vjsDropdownCoveo2['default'])();
(0, _coveoEvents2['default'])();
(0, _customEvent2['default'])();
(0, _objectFit2['default'])();
(0, _localstorage2['default'])();
(0, _analyticsCampaignTracker2['default'])();
(0, _fundraiseUp2['default'])();
(0, _detectIos2['default'])();
(0, _revealElementBehindSticky2['default'])();
window.AHACookieAPI = _ahaCookie.Cookie;
window.AHAItemsStorageAPI = { itemsStorage: _itemsStorage.itemsStorageFunc, filters: _itemsStorage.itemsStorageFilters };

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f0ba5e_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_app_icon_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_icon_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f0ba5e_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_app_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(267);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2978e917", content, true, {});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".icon{width:1.2em;height:1.2em;fill:currentColor}.icon.is-large{width:2em;height:2em}.icon.is-medium{width:1.6em;height:1.6em}.icon.is-normal{width:1.2em;height:1.2em}.icon.is-small{width:1em;height:1em}.icon.is-tiny{width:.8em;height:.8em}.icon.is-blue,.icon.is-primary{fill:#2196f3}.icon.is-green,.icon.is-success{fill:#4caf50}.icon.is-danger,.icon.is-red{fill:#f44336}.icon.is-orange,.icon.is-warning{fill:#ff9800}", ""]);

// exports


/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = {"heart":"M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z","housing":"M4.21875,0 C1.8984375,0 0,1.8984375 0,4.21875 C0,4.9359375 0.5484375,5.484375 1.265625,5.484375 C1.9828125,5.484375 2.53125,4.9359375 2.53125,4.21875 C2.53125,3.290625 3.290625,2.53125 4.21875,2.53125 C5.146875,2.53125 5.90625,3.290625 5.90625,4.21875 C5.90625,5.146875 5.146875,5.90625 4.21875,5.90625 C1.8984375,5.90625 0,7.8046875 0,10.125 L0,18.984375 C0,19.321875 0.1265625,19.659375 0.3796875,19.8703125 C0.6328125,20.08125 0.928125,20.25 1.265625,20.25 L7.171875,20.25 C7.509375,20.25 7.846875,20.1234375 8.0578125,19.8703125 C8.26875,19.6171875 8.4375,19.321875 8.4375,18.984375 L8.4375,4.21875 C8.4375,1.8984375 6.5390625,0 4.21875,0 Z M7.59375,18.984375 C7.59375,19.1109375 7.5515625,19.1953125 7.4671875,19.2796875 C7.3828125,19.3640625 7.2984375,19.40625 7.171875,19.40625 L1.265625,19.40625 C1.1390625,19.40625 1.0546875,19.3640625 0.9703125,19.2796875 C0.8859375,19.1953125 0.84375,19.1109375 0.84375,18.984375 L0.84375,10.125 C0.84375,8.26875 2.3625,6.75 4.21875,6.75 C5.6109375,6.75 6.75,5.6109375 6.75,4.21875 C6.75,2.8265625 5.6109375,1.6875 4.21875,1.6875 C2.8265625,1.6875 1.6875,2.8265625 1.6875,4.21875 C1.6875,4.471875 1.51875,4.640625 1.265625,4.640625 C1.0125,4.640625 0.84375,4.471875 0.84375,4.21875 C0.84375,2.3625 2.3625,0.84375 4.21875,0.84375 C6.075,0.84375 7.59375,2.3625 7.59375,4.21875 L7.59375,18.984375 Z M3.335512,13.5288024 L5.81587685,11.0484375 L6.6234375,11.8559981 L3.73929232,14.7401433 C3.62392652,14.8555091 3.50856071,14.913192 3.335512,14.913192 C3.16246329,14.913192 3.04709748,14.8555091 2.93173167,14.7401433 L1.7780736,13.5864853 L2.58563425,12.7789246 L3.335512,13.5288024 Z M17.71875,4.21875 C17.71875,1.8984375 15.8203125,0 13.5,0 C11.1796875,0 9.28125,1.8984375 9.28125,4.21875 C9.28125,6.5390625 11.1796875,8.4375 13.5,8.4375 C13.7953125,8.4375 14.090625,8.3953125 14.34375,8.353125 L14.34375,18.39375 L13.5,19.2375 L11.390625,17.128125 L11.390625,17.04375 L12.5296875,15.9046875 C12.6140625,15.8203125 12.65625,15.7359375 12.65625,15.609375 C12.65625,15.4828125 12.6140625,15.3984375 12.5296875,15.3140625 L11.390625,14.175 L11.390625,14.090625 L12.5296875,12.9515625 C12.6140625,12.8671875 12.65625,12.7828125 12.65625,12.65625 C12.65625,12.5296875 12.6140625,12.4453125 12.5296875,12.3609375 L11.390625,11.221875 L11.390625,11.1375 L12.1078125,10.4203125 C12.1921875,10.3359375 12.234375,10.2515625 12.234375,10.125 L12.234375,8.859375 L11.390625,8.859375 L11.390625,9.95625 L10.6734375,10.6734375 C10.5890625,10.7578125 10.546875,10.8421875 10.546875,10.96875 L10.546875,11.390625 C10.546875,11.5171875 10.5890625,11.6015625 10.6734375,11.6859375 L11.64375,12.65625 L10.6734375,13.6265625 C10.5890625,13.7109375 10.546875,13.7953125 10.546875,13.921875 L10.546875,14.34375 C10.546875,14.4703125 10.5890625,14.5546875 10.6734375,14.6390625 L11.64375,15.609375 L10.6734375,16.5796875 C10.5890625,16.6640625 10.546875,16.7484375 10.546875,16.875 L10.546875,17.296875 C10.546875,17.4234375 10.5890625,17.5078125 10.6734375,17.5921875 L13.2046875,20.1234375 C13.2890625,20.2078125 13.415625,20.25 13.5,20.25 C13.584375,20.25 13.7109375,20.2078125 13.7953125,20.1234375 L15.0609375,18.8578125 C15.1453125,18.7734375 15.1875,18.6890625 15.1875,18.5625 L15.1875,8.1 C16.6640625,7.425 17.71875,5.9484375 17.71875,4.21875 Z M13.5,7.59375 C11.64375,7.59375 10.125,6.075 10.125,4.21875 C10.125,2.3625 11.64375,0.84375 13.5,0.84375 C15.35625,0.84375 16.875,2.3625 16.875,4.21875 C16.875,6.075 15.35625,7.59375 13.5,7.59375 Z","program":"M77.53455,4271 L77.53455,4275.5 L72,4275.5 L72,4307 L112.5,4307 L112.5,4282.241 L105.75405,4275.5 L92.25,4275.5 L77.53455,4271 Z M79.78455,4300.48805 L79.78455,4274.042 L91.12455,4277.75 L91.12455,4304.75 L79.78455,4300.48805 Z M93.375,4277.75 L103.5,4277.75 L103.5,4284.49595 L110.24955,4284.49595 L110.24955,4304.75 L93.375,4304.75 L93.375,4277.75 Z M74.25,4277.75 L77.53455,4277.75 L77.53455,4302.15395 L84.897,4304.75 L74.25,4304.75 L74.25,4277.75 Z M105.74955,4278.677 L109.32255,4282.2455 L105.74955,4282.2455 L105.74955,4278.677 Z"}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',_vm._g(_vm._b({staticClass:"icon",class:_vm.$options.methods.getStyleClasses(_vm.props),attrs:{"viewBox":"0 0 24 24","role":"img"}},'svg',_vm.data.attrs,false),_vm.listeners),[_c('title',[_vm._v(_vm._s(_vm.props.title || _vm.props.name))]),_vm._v(" "),(_vm.props.desc)?_c('desc',[_vm._v(_vm._s(_vm.props.desc))]):_vm._e(),_vm._v(" "),_c('path',{attrs:{"d":_vm.$options.methods.getPath(_vm.props)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1e6fd1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fit_text_vue__ = __webpack_require__(271);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fit_text_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1e6fd1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fit_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaDropdown = __webpack_require__(74);

var _ahaDropdown2 = _interopRequireDefault(_ahaDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _ahaDropdown2['default']],
    render: function render(h) {
        var toggle = h('button', {
            ref: 'toggle',
            attrs: {
                id: this.safeId('_BV_toggle_'),
                'aria-haspopup': this.hasPopup,
                'aria-expanded': this.visible ? 'true' : 'false'
            },
            'class': this.extraClasses,
            on: {
                click: this.toggle,
                keydown: this.toggle
            }
        }, [this.$slots['default']]);

        var arrow = h('span', {
            ref: 'arrow',
            attrs: {
                'x-arrow': ''
            },
            'class': this.arrowClass
        });

        var menu = h('div', {
            ref: 'menu',
            'class': this.menuClasses,
            attrs: this.menuAttributes,
            on: {
                keydown: this.onKeydown // tab, up, down, esc
            }
        }, [this.$slots.dropdown, arrow]);

        return h('div', {
            ref: 'dropdown',
            attrs: {
                id: this.safeId()
            },
            'class': this.dropdownClasses
        }, [toggle, menu]);
    },

    props: {
        target: {
            // String ID of element, or element/component reference
            type: [String, Object]
        },
        size: {
            type: String,
            'default': null
        },
        extraClasses: {
            type: String,
            'default': ''
        },
        arrowClass: {
            type: String,
            'default': 'c-nav-dropdown__arrow'
        },
        role: {
            type: String,
            'default': null
        },
        hasPopup: {
            type: String,
            'default': 'true'
        },
        arrow: {
            type: Boolean,
            'default': true
        },
        boundary: {
            // String: `scrollParent`, `window` or `viewport`
            // Object: HTML Element reference
            type: [String, Object],
            'default': 'scrollParent'
        }
    },
    computed: {
        dropdownClasses: function dropdownClasses() {
            var position = '';
            // Position `static` is needed to allow menu to "breakout" of the scrollParent boundaries
            // when boundary is anything other than `scrollParent`
            // See https://github.com/twbs/bootstrap/issues/24251#issuecomment-341413786
            if (this.boundary !== 'scrollParent' || !this.boundary) {
                position = 'position-static';
            }

            return ['c-nav-dropdown__container', this.visible ? 'show' : '', position];
        },
        menuClasses: function menuClasses() {
            return ['c-nav-dropdown', 'dropdown-menu', this.right ? 'dropdown-menu-right' : ''];
        },
        menuAttributes: function menuAttributes() {
            var attributes = {
                'aria-labelledby': this.safeId('_BV_toggle_')
            };

            if (this.role) {
                attributes.role = this.role;
            }

            return attributes;
        },
        toggleClasses: function toggleClasses() {
            return [{
                'dropdown-toggle': !this.noCaret || this.split,
                'dropdown-toggle-split': this.split
            }, this.toggleClass];
        }
    }
};

/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaDropdown = __webpack_require__(74);

var _ahaDropdown2 = _interopRequireDefault(_ahaDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _ahaDropdown2['default']],
    render: function render(h) {
        var toggle = h('button', {
            ref: 'toggle',
            attrs: {
                id: this.safeId('_BV_toggle_'),
                'aria-haspopup': 'true',
                'aria-expanded': this.visible ? 'true' : 'false',
                type: 'button'
            },
            'class': this.toggleClasses,
            on: {
                click: this.toggle,
                keydown: this.toggle
            }
        }, [this.buttonText]);

        var arrow = h('span', {
            ref: 'arrow',
            attrs: {
                'x-arrow': ''
            },
            'class': 'c-nav-dropdown__arrow'
        });

        var menu = h('div', {
            ref: 'menu',
            'class': this.menuClasses,
            attrs: {
                role: this.role,
                'aria-labelledby': this.safeId('_BV_toggle_')
            },
            on: {
                keydown: this.onKeydown // tab, up, down, esc
            }
        }, [this.$slots.dropdown, this.arrow ? arrow : null]);

        var hiddenInput = h('input', {
            attrs: {
                type: 'hidden',
                value: this.hiddenValue,
                name: this.inputName
            }
        });

        return h('div', {
            ref: 'dropdown',
            attrs: {
                id: this.safeId()
            },
            'class': this.dropdownClasses
        }, [toggle, hiddenInput, menu]);
    },
    data: function data() {
        return {
            hiddenValue: null,
            displayText: null,
            dropdownItems: {}
        };
    },

    props: {
        value: {
            required: false
        },
        defaultValue: {
            type: String,
            required: true
        },
        toggleClass: {
            type: String,
            'default': ''
        },
        role: {
            type: String,
            'default': 'menu'
        },
        arrow: {
            type: Boolean,
            'default': false
        },
        inputName: {
            type: String,
            'default': 'searchCategory'
        },
        boundary: {
            // String: `scrollParent`, `window` or `viewport`
            // Object: HTML Element reference
            type: [String, Object],
            'default': 'scrollParent'
        }
    },
    mounted: function mounted() {
        this.$on('selected', this.clickListener);
        this.$on('register', this.registerDropdownItem);

        // Set the default dropdown value if specified
        if (this.defaultValue) {
            this.hiddenValue = this.defaultValue;
        }
    },

    methods: {
        clickListener: function clickListener(value, text) {
            if (typeof value !== 'undefined') {
                this.hiddenValue = value;
                this.displayText = text;

                this.$emit('input', this.hiddenValue);
            }
        },
        registerDropdownItem: function registerDropdownItem(value, text) {
            this.dropdownItems[value] = text;
        }
    },
    watch: {
        // Value comes from v-model
        value: function value(val) {
            // If the value is trying to be set programmatically, check the registered dropdown items
            if (typeof this.dropdownItems[val] !== 'undefined') {
                this.hiddenValue = val;
                this.displayText = this.dropdownItems[val];
            }
        }
    },
    computed: {
        buttonText: function buttonText() {
            return this.displayText || this.defaultValue;
        },
        dropdownClasses: function dropdownClasses() {
            var position = '';
            // Position `static` is needed to allow menu to "breakout" of the scrollParent boundaries
            // when boundary is anything other than `scrollParent`
            // See https://github.com/twbs/bootstrap/issues/24251#issuecomment-341413786
            if (this.boundary !== 'scrollParent' || !this.boundary) {
                position = 'position-static';
            }

            return ['c-select-dropdown__container', this.visible ? 'show' : '', position];
        },
        menuClasses: function menuClasses() {
            return ['c-select-dropdown', 'dropdown-menu', this.right ? 'dropdown-menu-right' : ''];
        },
        toggleClasses: function toggleClasses() {
            return [this.toggleClass];
        }
    }
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(18);

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    render: function render(h) {
        var vm = this;

        return h(this.tag, {
            on: {
                keydown: function keydown(e) {
                    if (e.keyCode === _utils.KeyCodes.ENTER || e.keyCode === _utils.KeyCodes.SPACE) {
                        vm.emitEvents(e, vm.inputValue, vm.text);
                    }

                    // If we're trying to tab inside of the dropdown, close it
                    if (e.keyCode === 9 || e.keyCode === 16 && e.keyCode === 9) {
                        vm.$root.$emit('clicked::link', e);
                    }
                },
                click: function click(e) {
                    vm.emitEvents(e, vm.inputValue, vm.text);
                }
            },
            attrs: this.attributes,
            'class': this.itemClass
        }, [this.$slots['default']]);
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.$parent.$emit('register', _this.inputValue, _this.text, _this.$el);
        });

        if (this.selected) {
            this.$nextTick(function () {
                _this.$parent.$emit('selected', _this.inputValue, _this.text, _this.$el, true);
            });
        }
    },

    props: {
        value: {
            type: String
        },
        text: {
            type: String,
            required: true
        },
        itemClass: {
            type: String
        },
        selected: {
            type: Boolean,
            'default': false
        },
        tag: {
            type: String,
            'default': 'button'
        },
        role: {
            type: String,
            'default': 'menuitem'
        }
    },
    computed: {
        attributes: function attributes() {
            var attributes = {
                // type: 'button',
                role: this.role,
                id: this.safeId('_dropdown-item_')
            };

            if (this.tag !== 'a') {
                attributes['aria-selected'] = 'false';
            }

            return attributes;
        },
        inputValue: function inputValue() {
            return this.value;
        }
    },
    methods: {
        emitEvents: function emitEvents(e, value, text) {
            this.$parent.$emit('selected', value, text, this.$el);
        }
    }
};

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1be99543_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_vue__ = __webpack_require__(280);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1be99543_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 279 */,
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showDropdown)?_c('div',[_c('aha-nav-dropdown',{attrs:{"role":"dialog","has-popup":"dialog","position":"right","extra-classes":"c-top-nav__link c-cta dropdown-toggle","disable-menu-events":true},on:{"shown":_vm.onShown,"hidden":_vm.onHidden}},[_vm._t("default"),_vm._v(" "),_c('template',{slot:"dropdown"},[_vm._t("content"),_vm._v(" "),_c('aha-location-selector-form',{attrs:{"endpoint":_vm.searchEndpoint,"states":_vm.states,"translations":_vm.translations,"is-visible":_vm.isVisible,"on-submit":_vm.handleSubmit}})],2)],2)],1):_c('div',[_vm._t("content"),_vm._v(" "),_c('aha-location-selector-form',{attrs:{"endpoint":_vm.searchEndpoint,"states":_vm.states,"translations":_vm.translations,"is-visible":_vm.isVisible,"on-submit":_vm.handleSubmit}})],2),_vm._v(" "),(_vm.showModal)?_c('div',[_c('aha-modal',{ref:"locationSelectorModal",staticClass:"c-location-modal",attrs:{"id":"locationSelectorModal","hide-footer":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('h2',{staticClass:"c-location-modal__heading h4"},[_vm._v(_vm._s(_vm.translations.searchResults)+" "),_c('i',[_vm._v("\""+_vm._s(_vm.searchText)+"\"")])])]),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'locationSelectorModal', $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('aha-location-selector-table',{attrs:{"translations":_vm.translations,"locations":_vm.locations}})],2)],1):_c('div',{staticClass:"c-location-selector__mobile-table"},[(_vm.locations.length)?_c('div',[_c('div',{staticClass:"c-location-selector__mobile-header"},[_c('h2',{staticClass:"c-location-modal__heading h4"},[_vm._v(_vm._s(_vm.translations.searchResults)+" "),_c('i',[_vm._v("\""+_vm._s(_vm.searchText)+"\"")])]),_vm._v(" "),_c('span',{staticClass:"c-cta h-theme--red",on:{"click":_vm.clearResults}},[_vm._v(_vm._s(_vm.translations.clearResults))])]),_vm._v(" "),_c('aha-location-selector-table',{attrs:{"translations":_vm.translations,"locations":_vm.locations}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d40fdfc0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_form_vue__ = __webpack_require__(282);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d40fdfc0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"location-selector-form",staticClass:"location-search",class:{ 'is-loading': _vm.isLoading },attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"location-search__fields"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.zipcodeId}},[_vm._v(_vm._s(_vm.translations.zipCode))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"}],ref:"input1",staticClass:"form-control",attrs:{"id":_vm.zipcodeId,"name":"zipcode","type":"text","pattern":"^\\d{5}(?:[-\\s]\\d{4})?$","placeholder":_vm.translations.zipCode},domProps:{"value":(_vm.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"location-search__or"},[_vm._v(_vm._s(_vm.translations.or))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.stateId}},[_vm._v(_vm._s(_vm.translations.state))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.state),expression:"state"}],staticClass:"custom-select btn--select",attrs:{"id":_vm.stateId,"name":"state"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.state=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.translations.state))]),_vm._v(" "),_vm._l((_vm.states),function(state){return _c('option',{key:state.code,domProps:{"value":state.code}},[_vm._v(_vm._s(state.title))])})],2)])]),_vm._v(" "),_c('button',{ref:"submit",staticClass:"location-search__search btn btn-tertiary btn-round",attrs:{"disabled":!_vm.validInput,"type":"submit"}},[_vm._v(_vm._s(_vm.translations.search))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f14e12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_table_vue__ = __webpack_require__(284);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_location_selector_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f14e12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_location_selector_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.validLocations.length)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.translations.noResults))]):_vm._e(),_vm._v(" "),(_vm.validLocations.length)?_c('table',{staticClass:"c-location-modal__table table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.translations.offices))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.translations.address))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.validLocations),function(location){return _c('tr',{key:location.id},[_c('td',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":location.url}},[_vm._v(_vm._s(location.name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(location.address1)+" "+_vm._s(location.address2))])])}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c3e199a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_vue__ = __webpack_require__(287);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c3e199a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container",class:{ show: _vm.isLoading },attrs:{"role":"alert","aria-live":"assertive","id":_vm.uuid}},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-md"},[_c('div',{staticClass:"c-promo c-promo--full-width c-promo--bg-triangle c-promo--border c-promo--shadow h-theme--red"},[_c('aha-loading-spinner',{attrs:{"is-loading":_vm.isLoading}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--match-height"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.translations.title))]),_vm._v(" "),_c('div',[_c('p',[_c('span',{staticClass:"small form-text text-danger"},[_vm._v(_vm._s(_vm.translations.requiredFields))])]),_vm._v(" "),_c('aha-stroke-group-selector-form',{ref:"strokeForm1",attrs:{"endpoint":_vm.searchEndpoint,"radius":_vm.radius,"translations":_vm.translations,"is-visible":_vm.isVisible,"on-submit":_vm.handleSubmit}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.translations.increaseRadius))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"c-promo__media h-placeholder-image h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:(_vm.image),expression:"image"}],attrs:{"src":_vm.image,"alt":""}})])])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-location-selector__mobile-table",attrs:{"aria-live":"polite","aria-atomic":"true"}},[(_vm.invalidZipCode)?_c('div',[_c('div',[_c('p',[_vm._v(_vm._s(_vm.translations.zipCodeNotFound))])])]):(_vm.foundlocations.length)?_c('div',[_c('div',{staticClass:"c-location-selector__mobile-header"},[_c('h2',{staticClass:"c-location-modal__heading h4"},[_vm._v("\n            "+_vm._s(_vm.translations.searchResults)+"\n            "),_c('i',[_vm._v("\""+_vm._s(_vm.searchText)+"\"")])]),_vm._v(" "),_c('button',{ref:"clearResultsLink",staticClass:"c-cta btn btn-link h-theme--red",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.clearResults.apply(null, arguments)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.clearResults.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.clearResults.apply(null, arguments)}]}},[_vm._v(_vm._s(_vm.translations.clearResults))])]),_vm._v(" "),_c('aha-stroke-group-selector-table',{ref:"results",attrs:{"previousSearchedParams":_vm.previousParams,"translations":_vm.translations,"locations":_vm.foundlocations}})],1):_c('div',[(_vm.searchClicked > 0 && _vm.foundlocations.length === 0)?_c('div',[_c('h3',[_vm._v(_vm._s(_vm.translations.noResultsFound))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.translations.increaseRadius))])]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403b030f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_form_vue__ = __webpack_require__(289);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403b030f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"strokeForm",staticClass:"stroke-group-search my-4",class:{ 'is-loading': _vm.isLoading },attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"location-search__fields"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.zipcodeId}},[_vm._v(_vm._s(_vm.translations.zipCode))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"}],ref:"input1",staticClass:"form-control",attrs:{"id":_vm.zipcodeId,"name":"zipcode","type":"text","pattern":"^\\d{5}(?:[-\\s]\\d{4})?$","placeholder":_vm.translations.zipCodePlaceholder},domProps:{"value":(_vm.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"ml-5 d-xs-none"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.radiusId}},[_vm._v(_vm._s(_vm.translations.radius))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rad),expression:"rad"}],staticClass:"custom-select btn--select",attrs:{"id":_vm.radiusId,"name":"radius"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.rad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select radius")]),_vm._v(" "),_vm._l((_vm.radius),function(rad){return _c('option',{key:rad.code,domProps:{"value":rad.code}},[_vm._v(_vm._s(rad.title))])})],2)])]),_vm._v(" "),_c('button',{ref:"submit",staticClass:"location-search__search btn btn-tertiary btn-round",attrs:{"disabled":!_vm.validInput,"type":"submit"}},[_vm._v(_vm._s(_vm.translations.search))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018c16d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_table_vue__ = __webpack_require__(291);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stroke_group_selector_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018c16d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stroke_group_selector_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md"},[_c('b-form-group',{attrs:{"name":"filter","label":"Filter by Audience:"}},[_c('b-form-checkbox-group',{attrs:{"plain":"","options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1),_vm._v(" "),_c('table',{staticClass:"c-location-modal__table table mb-6",attrs:{"id":"results-table"}},[_c('caption',{staticClass:"sr-only",attrs:{"id":"stroke-groups-caption","aria-live":"polite"}},[_vm._v("\n      Stroke Group Results\n      "),_c('span',{ref:"captionUpdate",attrs:{"id":"captionUpdated"}},[_vm._v(_vm._s(_vm.captionMessage))])]),_vm._v(" "),_c('thead',[_c('tr',[_c('th',{attrs:{"tabindex":"0","aria-sort":_vm.currentSortDir},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sort('name')},"click":function($event){return _vm.sort('name')}}},[_c('span',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.translations.name))])]),_vm._v(" "),_c('th',{attrs:{"tabindex":"0","aria-sort":_vm.currentSortDir},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sort('virtualoption')},"click":function($event){return _vm.sort('virtualoption')}}},[_c('span',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.translations.virtualOption))])]),_vm._v(" "),_c('th',{attrs:{"tabindex":"0","aria-sort":_vm.currentSortDir},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sort('city')},"click":function($event){return _vm.sort('city')}}},[_c('span',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.translations.city))])]),_vm._v(" "),_c('th',{attrs:{"tabindex":"0","aria-sort":_vm.currentSortDir},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sort('state')},"click":function($event){return _vm.sort('state')}}},[_c('span',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.translations.state))])]),_vm._v(" "),_c('th',{attrs:{"tabindex":"0","aria-sort":_vm.currentSortDir},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sort('zip')},"click":function($event){return _vm.sort('zip')}}},[_c('span',{attrs:{"role":"button"}},[_vm._v(_vm._s(_vm.translations.zipCode))])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.sortedName),function(location){return _c('tr',{key:location.id},[_c('td',[_c('a',{staticClass:"c-cta h-theme--red",attrs:{"href":location.url},on:{"click":function($event){return _vm.locationClicked(location.url)}}},[_vm._v(_vm._s(location.name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(location.virtualoption))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(location.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(location.state))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(location.zip))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _youtubePlayer = __webpack_require__(713);

var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    render: function render(h) {
        var _this = this;

        var youtubeContainerId = this.safeId('_AHA_youtube_');

        var youtube = h('div', {
            'class': 'youtube-player',
            attrs: {
                id: youtubeContainerId
            }
        });

        var embed = h('div', {
            'class': 'embed-responsive embed-responsive-16by9'
        }, [youtube]);

        var closeButton = h('b-btn-close', {
            on: {
                click: function click(event) {
                    _this.$root.$emit('bv::hide::modal', _this.trigger, event.target);
                }
            }
        });

        var modal = h('aha-modal', {
            'class': 'c-modal--youtube',
            attrs: {
                id: this.trigger,
                centered: true,
                lazy: true,
                hideFooter: true,
                hideHeader: true,
                noFade: true,
                title: this.title
            },
            on: {
                shown: function shown(event) {
                    var arg = event.arg;
                    var player = (0, _youtubePlayer2['default'])(youtubeContainerId, {
                        playerVars: {
                            rel: 0
                        }
                    });

                    // eslint-disable-next-line
                    if (arg === 'queue') {
                        player.cueVideoById(_this.videoId);
                    } else {
                        player.loadVideoById(_this.videoId);
                        player.playVideo();
                    }
                }
            }
        }, [closeButton, embed]);

        return modal;
    },

    props: {
        trigger: {
            type: String,
            required: true
        },
        title: {
            type: String,
            'default': 'Video'
        },
        videoId: {
            type: String,
            required: true
        }
    }
};

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1d0856_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_notification_vue__ = __webpack_require__(294);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_notification_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1d0856_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}]},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_374e8721_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_mobile_nav_vue__ = __webpack_require__(296);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_374e8721_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_mobile_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.navId),expression:"navId"}],staticClass:"c-top-nav__menu-trigger",attrs:{"aria-label":"Menu","aria-expanded":_vm.hasAriaExpanded},on:{"click":_vm.hideNav}},[_vm._m(0)]),_vm._v(" "),_c('aha-modal',{ref:_vm.navRef,staticClass:"c-mobile-nav",attrs:{"id":_vm.navId,"title":_vm.modalTitle,"modalRole":_vm.navId,"modalContentRole":_vm.modalContentRole,"modalTag":_vm.modalTag,"showOnDesktop":_vm.showOnDesktop,"hide-backdrop":"","hide-header":"","hide-footer":""},on:{"shown":_vm.onShown,"hidden":_vm.onHidden}},[_vm._t("default")],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-top-nav__hamburger"},[_c('span',{staticClass:"sr-only"},[_vm._v("Menu")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_panel_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_panel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_panel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_panel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d71c388_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_mobile_nav_panel_vue__ = __webpack_require__(298);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_panel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d71c388_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_mobile_nav_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.navId),expression:"navId"}],staticClass:"c-top-nav__menu-trigger",attrs:{"aria-label":"Menu","aria-expanded":_vm.hasAriaExpanded},on:{"click":_vm.hideNav}},[_vm._m(0)]),_vm._v(" "),_c('aha-modal',{ref:_vm.navRef,staticClass:"c-mobile-nav",attrs:{"id":_vm.navId,"title":_vm.modalTitle,"modalRole":_vm.navId,"modalContentRole":_vm.modalContentRole,"modalTag":_vm.modalTag,"showOnDesktop":_vm.showOnDesktop,"hide-backdrop":"","hide-header":"","hide-footer":""},on:{"shown":_vm.onShown,"hidden":_vm.onHidden}},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.navId),expression:"navId"}],staticClass:"c-top-nav__menu-trigger",on:{"click":_vm.hideNav}},[_c('span',{staticClass:"c-top-nav__hamburger"}),_vm._v(" "),_c('span',[_vm._v("\n                    Close Menu\n                ")])]),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-top-nav__hamburger"},[_c('span',[_vm._v("Menu")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_search_panel_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_search_panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_search_panel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_search_panel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_search_panel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc3dd4b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_mobile_nav_search_panel_vue__ = __webpack_require__(300);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_mobile_nav_search_panel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fc3dd4b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_mobile_nav_search_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.navId),expression:"navId"}],staticClass:"c-top-nav__menu-trigger",on:{"click":_vm.hideNav}},[_c('img',{attrs:{"src":"assets/glyphs/search.svg","alt":"search"}}),_vm._v(" "),_c('span',{staticClass:"d-block"},[_vm._v("Search")])]),_vm._v(" "),_c('aha-modal',{ref:_vm.navRef,staticClass:"c-mobile-nav",attrs:{"id":_vm.navId,"title":_vm.modalTitle,"modalRole":_vm.navId,"modalContentRole":_vm.modalContentRole,"modalTag":_vm.modalTag,"showOnDesktop":_vm.showOnDesktop,"hide-backdrop":"","hide-header":"","hide-footer":""},on:{"shown":_vm.onShown,"hidden":_vm.onHidden}},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.navId),expression:"navId"}],staticClass:"c-top-nav__menu-trigger search-modal-close-hamburger w-100 pl-4 justify-content-end",on:{"click":_vm.hideNav}},[_c('span',[_vm._v("\n                    Close Menu\n                ")]),_vm._v(" "),_c('span',{staticClass:"c-top-nav__hamburger"})]),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    mounted: function mounted() {
        this.checkboxId = this.safeId('_AHA_checkbox_');
    },
    render: function render(h) {
        var _this = this;

        var iconCheck = h('i', {
            'class': 'icon-check'
        });

        var check = h('span', {
            'class': this.checkClass,
            attrs: this.containerAttributes
        }, [iconCheck]);

        var empty = h('div', {
            attrs: {
                id: this.checkboxId
            }
        }, [this.$slots['default']]);

        var container = h('div', {
            'class': this.containerClasses,
            on: {
                click: function click(evt) {
                    toggleChecked(evt);
                },
                keypress: function keypress(evt) {
                    toggleChecked(evt);
                }
            }
        }, [check, empty]);

        var toggleChecked = function toggleChecked(evt) {
            if (evt.type === 'click' || evt.keyCode === _utils.KeyCodes.SPACE) {
                evt.preventDefault();
                _this.isChecked = !_this.isChecked;
            }
        };

        return container;
    },

    data: function data() {
        return {
            isChecked: false,
            checkboxId: null
        };
    },
    props: {
        checkClass: {
            type: String
        }
    },
    computed: {
        containerClasses: function containerClasses() {
            return [this.isChecked ? 'is-checked' : '', this['class']];
        },
        containerAttributes: function containerAttributes() {
            return {
                'role': 'checkbox',
                'aria-checked': this.isChecked.toString(),
                'tabindex': 0,
                'aria-labelledby': this.checkboxId
            };
        }
    }
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* global gigya */

exports['default'] = {
    render: function render(h) {
        var ratings = h('div', {
            'class': 'c-recipe__ratings',
            attrs: {
                id: 'ratingsDiv'
            }
        });

        var comments = h('div', {
            'class': 'c-recipe__comments',
            attrs: {
                id: 'commentsDiv'
            }
        });

        var container = h('div', {
            'class': 'c-recipe__social'
        }, [ratings, comments]);

        return container;
    },

    props: {
        ratingsCategoryId: {
            type: String,
            required: true
        },
        ratingsStreamId: {
            type: String,
            required: true
        },
        commentsCategoryId: {
            type: String,
            required: true
        },
        commentsStreamId: {
            type: String,
            required: true
        },
        commentsStreamTags: {
            type: String,
            required: true
        },
        hideShareButtons: {
            type: Boolean,
            'default': false
        },
        showReadReviewsLink: {
            type: Boolean,
            'default': false
        },
        showCommentButton: {
            type: Boolean,
            'default': true
        },
        writeReviewLabel: {
            type: String,
            'default': 'Write Review'
        },
        hideRatingToolLabel: {
            type: String,
            'default': 'Hide Rating'
        }
    },
    mounted: function mounted() {
        var _this = this;

        var ratingsParams = {
            categoryID: this.ratingsCategoryId,
            streamID: this.ratingsStreamId,
            containerID: 'ratingsDiv',
            showReadReviewsLink: this.showReadReviewsLink,
            showCommentButton: this.showCommentButton,
            onAddReviewClicked: function onAddReviewClicked() {
                var commentsElement = document.querySelector('#commentsDiv');
                var reviewButton = document.querySelector('.gig-rating-writeYourReview');

                commentsElement.classList.toggle('is-visible');

                reviewButton.text = commentsElement.classList.contains('is-visible') ? _this.hideRatingToolLabel : _this.writeReviewLabel;
            },
            onReadReviewsClicked: function onReadReviewsClicked() {
                var commentsElement = document.querySelector('#commentsDiv');
                var reviewButton = document.querySelector('.gig-rating-writeYourReview');

                commentsElement.classList.toggle('is-visible');

                reviewButton.text = commentsElement.classList.contains('is-visible') ? _this.hideRatingToolLabel : _this.writeReviewLabel;
            },
            onLoad: function onLoad() {
                var reviewButton = document.querySelector('.gig-rating-writeYourReview');

                reviewButton.innerHTML = _this.writeReviewLabel;
            }
        };

        var ratingsElement = document.querySelector('#ratingsDiv');

        ratingsElement.classList.toggle('is-visible', this.showCommentButton || this.showReadReviewsLink);

        gigya.comments.showRatingUI(ratingsParams);

        var commentsParams = {
            categoryID: this.commentsCategoryId,
            streamID: this.commentsStreamId,
            containerID: 'commentsDiv',
            hideShareButtons: this.hideShareButtons,
            version: 2,
            disabledShareProviders: '*',
            streamTags: this.commentsStreamTags
        };

        gigya.comments.showCommentsUI(commentsParams);
    }
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _button = __webpack_require__(714);

var _button2 = _interopRequireDefault(_button);

var _buttonClose = __webpack_require__(716);

var _buttonClose2 = _interopRequireDefault(_buttonClose);

var _mixins = __webpack_require__(717);

var _utils = __webpack_require__(18);

var _bvEvent = __webpack_require__(718);

var _bvEvent2 = _interopRequireDefault(_bvEvent);

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _extendAhaModal = __webpack_require__(304);

var _extendAhaModal2 = _interopRequireDefault(_extendAhaModal);

var _dom = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// Selectors for padding/margin adjustments
var Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'

    // ObserveDom config
};

var OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
};

exports['default'] = {
    mixins: [_ahaId2['default'], _mixins.listenOnRootMixin, _extendAhaModal2['default']],
    components: {
        bBtn: _button2['default'],
        bBtnClose: _buttonClose2['default']
    },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;
        // Modal Header
        var header = h(false);

        if (!t.hideHeader) {
            var modalHeader = $slots['modal-header'];
            if (!modalHeader) {
                var closeButton = h(false);
                if (!t.hideHeaderClose) {
                    closeButton = h('b-btn-close', {
                        props: {
                            disabled: t.is_transitioning,
                            ariaLabel: t.headerCloseLabel,
                            textVariant: t.headerTextVariant
                        },
                        on: {
                            click: function click(evt) {
                                t.hide('header-close');
                            }
                        }
                    }, [$slots['modal-header-close']]);
                }
                // modalHeader = [h(t.titleTag, {
                //     class: ['modal-title']
                // }, [$slots['modal-title'] || t.title]), closeButton];
                modalHeader = [closeButton];
            }
            header = h('div', {
                ref: 'header',
                'class': t.headerClasses,
                attrs: {
                    id: t.safeId('__BV_modal_header_')
                }
            }, [modalHeader]);
        }
        // Modal Body
        var body = h('div', {
            ref: 'body',
            'class': t.bodyClasses,
            attrs: {
                id: t.safeId('__BV_modal_body_')
            }
        }, [$slots['default']]);
        // Modal Footer
        var footer = h(false);
        if (!t.hideFooter) {
            var modalFooter = $slots['modal-footer'];
            if (!modalFooter) {
                var okButton = h(false);
                if (!t.okOnly) {
                    okButton = h('b-btn', {
                        props: {
                            variant: t.cancelVariant,
                            size: t.buttonSize,
                            disabled: t.cancelDisabled || t.busy || t.is_transitioning
                        },
                        on: {
                            click: function click(evt) {
                                t.hide('cancel');
                            }
                        }
                    }, [$slots['modal-cancel'] || t.cancelTitle]);
                }
                var cancelButton = h('b-btn', {
                    props: {
                        variant: t.okVariant,
                        size: t.buttonSize,
                        disabled: t.okDisabled || t.busy || t.is_transitioning
                    },
                    on: {
                        click: function click(evt) {
                            t.hide('ok');
                        }
                    }
                }, [$slots['modal-ok'] || t.okTitle]);
                modalFooter = [cancelButton, okButton];
            }
            footer = h('footer', {
                ref: 'footer',
                'class': t.footerClasses,
                attrs: {
                    id: t.safeId('__BV_modal_footer_')
                }
            }, [modalFooter]);
        }
        // Assemble Modal Content
        var modalContent = h('div', {
            ref: 'content',
            'class': ['modal-content'],
            attrs: this.modalContentAttributes,
            on: {
                focusout: t.onFocusout,
                click: function click(evt) {
                    evt.stopPropagation();
                }
            }
        }, [header, body, footer]);

        // Modal Dialog wrapper
        var modalDialog = h('div', {
            'class': t.dialogClasses
        }, [modalContent]);

        var modalTag = this.modalTag;

        // Modal
        var modal = h(modalTag, {
            ref: 'modal',
            'class': t.modalClasses,
            directives: [{
                name: 'show',
                rawName: 'v-show',
                value: t.is_visible,
                expression: 'is_visible'
            }],
            attrs: t.dialogAttributes,
            on: {
                click: t.onClickOut,
                keydown: t.onEsc
            }
        }, [modalDialog]);
        // Wrap modal in transition
        modal = h('transition', {
            props: {
                enterClass: '',
                enterToClass: '',
                enterActiveClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: ''
            },
            on: {
                'before-enter': t.onBeforeEnter,
                'enter': t.onEnter,
                'after-enter': t.onAfterEnter,
                'before-leave': t.onBeforeLeave,
                'leave': t.onLeave,
                'after-leave': t.onAfterLeave
            }
        }, [modal]);
        // Modal Backdrop
        var backdrop = h(false);
        if (!t.hideBackdrop && (t.is_visible || t.is_transitioning)) {
            backdrop = h('div', {
                'class': t.backdropClasses,
                attrs: {
                    id: t.safeId('__BV_modal_backdrop_')
                }
            });
        }
        // Assemble modal and backdrop
        var outer = h(false);
        if (!t.is_hidden) {
            outer = h('div', {
                attrs: {
                    id: t.safeId('__BV_modal_outer_')
                }
            }, [modal, backdrop]);
        }
        // Wrap in DIV to maintain thi.$el reference for hide/show method aceess
        return h('div', {}, [outer]);
    },
    data: function data() {
        return {
            is_hidden: this.lazy || false,
            is_visible: false,
            is_transitioning: false,
            is_show: false,
            is_shown_for_desktop: false,
            is_block: false,
            scrollbarWidth: 0,
            isBodyOverflowing: false,
            return_focus: this.returnFocus || null,
            arg: null
        };
    },

    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        ariaLabelledby: {
            type: String,
            'default': ''
        },
        title: {
            type: String,
            'default': ''
        },
        titleTag: {
            type: String,
            'default': 'h5'
        },
        modalTag: {
            type: String,
            'default': 'div'
        },
        size: {
            type: String,
            'default': 'md'
        },
        centered: {
            type: Boolean,
            'default': false
        },
        buttonSize: {
            type: String,
            'default': ''
        },
        noFade: {
            type: Boolean,
            'default': false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            'default': false
        },
        noCloseOnEsc: {
            type: Boolean,
            'default': false
        },
        noEnforceFocus: {
            type: Boolean,
            'default': false
        },
        headerBgVariant: {
            type: String,
            'default': null
        },
        headerBorderVariant: {
            type: String,
            'default': null
        },
        headerTextVariant: {
            type: String,
            'default': null
        },
        headerClass: {
            type: [String, Array],
            'default': null
        },
        bodyBgVariant: {
            type: String,
            'default': null
        },
        bodyTextVariant: {
            type: String,
            'default': null
        },
        bodyClass: {
            type: [String, Array],
            'default': null
        },
        footerBgVariant: {
            type: String,
            'default': null
        },
        footerBorderVariant: {
            type: String,
            'default': null
        },
        footerTextVariant: {
            type: String,
            'default': null
        },
        footerClass: {
            type: [String, Array],
            'default': null
        },
        hideHeader: {
            type: Boolean,
            'default': false
        },
        hideFooter: {
            type: Boolean,
            'default': false
        },
        hideHeaderClose: {
            type: Boolean,
            'default': false
        },
        hideBackdrop: {
            type: Boolean,
            'default': false
        },
        okOnly: {
            type: Boolean,
            'default': false
        },
        okDisabled: {
            type: Boolean,
            'default': false
        },
        cancelDisabled: {
            type: Boolean,
            'default': false
        },
        visible: {
            type: Boolean,
            'default': false
        },
        returnFocus: {
            'default': null
        },
        headerCloseLabel: {
            type: String,
            'default': 'Close'
        },
        cancelTitle: {
            type: String,
            'default': 'Cancel'
        },
        okTitle: {
            type: String,
            'default': 'OK'
        },
        cancelVariant: {
            type: String,
            'default': 'secondary'
        },
        okVariant: {
            type: String,
            'default': 'primary'
        },
        lazy: {
            type: Boolean,
            'default': false
        },
        busy: {
            type: Boolean,
            'default': false
        },
        modalRole: {
            type: String,
            'default': null
        },
        modalContentRole: {
            type: String,
            'default': null
        },
        showOnDesktop: {
            type: Boolean,
            'default': false
        },
        hasHideAriaLabelledby: {
            type: Boolean,
            'default': false
        }
    },
    computed: {
        dialogAttributes: function dialogAttributes() {
            var attributes = {
                id: this.safeId(),
                // 'aria-describedby': this.safeId('__BV_modal_body_'),
                'aria-hidden': this.is_shown_for_desktop ? false : this.is_visible ? null : 'true',
                'aria-modal': 'true'
            };

            if (this.modalRole) {
                attributes.role = this.modalRole;
            }

            if (this.hideHeader && !this.hasHideAriaLabelledby) {
                // Allow aria-labelledby to be set manually
                if (this.ariaLabelledby !== '') {
                    attributes['aria-labelledby'] = this.ariaLabelledby;
                } else {
                    attributes['aria-label'] = this.$slots['modal-title'] || this.title;
                }
            }

            return attributes;
        },
        modalClasses: function modalClasses() {
            return ['modal', {
                fade: !this.noFade,
                show: this.is_show,
                'd-block': this.is_block
            }];
        },
        modalContentAttributes: function modalContentAttributes() {
            var attributes = {
                tabindex: '-1'
            };

            if (this.modalContentRole) {
                attributes.role = this.modalContentRole;
            }

            return attributes;
        },
        dialogClasses: function dialogClasses() {
            var _ref = {};

            return ['modal-dialog', (_ref, _defineProperty(_ref, 'modal-' + this.size, Boolean(this.size)), _defineProperty(_ref, 'modal-dialog-centered', this.centered), _ref)];
        },
        backdropClasses: function backdropClasses() {
            return ['modal-backdrop', {
                fade: !this.noFade,
                show: this.is_show || this.noFade
            }];
        },
        headerClasses: function headerClasses() {
            var _ref2 = {};

            return ['modal-header', (_ref2, _defineProperty(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), _defineProperty(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), _defineProperty(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2), this.headerClass];
        },
        bodyClasses: function bodyClasses() {
            var _ref3 = {};

            return ['modal-body', (_ref3, _defineProperty(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), _defineProperty(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3), this.bodyClass];
        },
        footerClasses: function footerClasses() {
            var _ref4 = {};

            return ['modal-footer', (_ref4, _defineProperty(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), _defineProperty(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), _defineProperty(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4), this.footerClass];
        }
    },
    watch: {
        visible: function visible(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            this[newVal ? 'show' : 'hide']();
        }
    },
    methods: {
        // Public Methods
        show: function show() {
            if (this.is_visible) {
                return;
            }
            var showEvt = new _bvEvent2['default']('show', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                relatedTarget: null
            });
            this.emitEvent(showEvt);
            if (showEvt.defaultPrevented || this.is_visible) {
                // Don't show if canceled
                return;
            }
            if ((0, _dom.hasClass)(document.body, 'modal-open')) {
                // If another modal is already open, wait for it to close
                this.$root.$once('bv::modal::hidden', this.doShow);
            } else {
                // Show the modal
                this.doShow();
            }
        },
        hide: function hide(trigger) {
            if (!this.is_visible) {
                return;
            }
            var hideEvt = new _bvEvent2['default']('hide', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                // this could be the trigger element/component reference
                relatedTarget: null,
                isOK: trigger || null,
                trigger: trigger || null,
                cancel: function cancel() {
                    // Backwards compatibility
                    (0, _utils.warn)('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
                    this.preventDefault();
                }
            });
            if (trigger === 'ok') {
                this.$emit('ok', hideEvt);
            } else if (trigger === 'cancel') {
                this.$emit('cancel', hideEvt);
            }
            this.emitEvent(hideEvt);
            // Hide if not canceled
            if (hideEvt.defaultPrevented || !this.is_visible) {
                return;
            }
            // stop observing for content changes
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this.is_visible = false;
            this.$emit('change', false);
        },

        // Private method to finish showing modal
        doShow: function doShow() {
            var _this = this;

            // Plce modal in DOM if lazy
            this.is_hidden = false;
            this.$nextTick(function () {
                // We do this in nextTick to ensure the modal is in DOM first before we show it
                _this.is_visible = true;
                _this.$emit('change', true);
                // Observe changes in modal content and adjust if necessary
                _this._observer = (0, _utils.observeDom)(_this.$refs.content, _this.adjustDialog.bind(_this), OBSERVER_CONFIG);
            });
        },

        // Transition Handlers
        onBeforeEnter: function onBeforeEnter() {
            this.is_transitioning = true;
            this.checkScrollbar();
            this.setScrollbar();
            this.adjustDialog();
            (0, _dom.addClass)(document.body, 'modal-open');
            this.addRemoveInertAttribute(true);
            this.setResizeEvent(true);
        },
        onEnter: function onEnter() {
            this.is_block = true;
            this.$refs.modal.scrollTop = 0;
        },
        onAfterEnter: function onAfterEnter() {
            var _this2 = this;

            this.is_show = true;
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this2.focusFirst();
                var shownEvt = new _bvEvent2['default']('shown', {
                    cancelable: false,
                    vueTarget: _this2,
                    target: _this2.$refs.modal,
                    relatedTarget: null,
                    arg: this.arg
                });
                _this2.emitEvent(shownEvt);
            });
        },
        onBeforeLeave: function onBeforeLeave() {
            this.is_transitioning = true;
            this.setResizeEvent(false);
        },
        onLeave: function onLeave() {
            // Remove the 'show' class
            this.is_show = false;
        },
        onAfterLeave: function onAfterLeave() {
            var _this3 = this;

            this.is_block = false;
            this.resetAdjustments();
            this.resetScrollbar();
            this.is_transitioning = false;
            (0, _dom.removeClass)(document.body, 'modal-open');
            this.addRemoveInertAttribute(false);
            this.$nextTick(function () {
                _this3.is_hidden = _this3.lazy || false;
                _this3.returnFocusTo();
                var hiddenEvt = new _bvEvent2['default']('hidden', {
                    cancelable: false,
                    vueTarget: _this3,
                    target: _this3.lazy ? null : _this3.$refs.modal,
                    relatedTarget: null
                });
                _this3.emitEvent(hiddenEvt);
            });
        },

        // Event emitter
        emitEvent: function emitEvent(bvEvt) {
            var type = bvEvt.type;
            this.$emit(type, bvEvt);
            this.$root.$emit('bv::modal::' + type, bvEvt);
        },

        // UI Event Handlers
        onClickOut: function onClickOut(evt) {
            // If backdrop clicked, hide modal
            if (this.is_visible && !this.noCloseOnBackdrop) {
                this.hide('backdrop');
            }
        },
        onEsc: function onEsc(evt) {
            // If ESC pressed, hide modal
            if (evt.keyCode === _utils.KeyCodes.ESC && this.is_visible && !this.noCloseOnEsc) {
                this.hide('esc');
            }
            if (evt.shiftKey && this.is_visible) {
                document.addEventListener('keydown', function (e) {
                    var modal = document.querySelector('.modal.fade.show'); // select the modal by it's id
                    var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                    var firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                    var focusableContent = modal.querySelectorAll(focusableElements);
                    var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
                    if (e.shiftKey) {
                        // if shift key pressed for shift + tab combination
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus(); // add focus for the last focusable element
                            e.preventDefault();
                        }
                    } else {
                        // if tab key is pressed
                        if (document.activeElement === lastFocusableElement) {
                            // if focused has reached to last focusable element then focus first focusable element after pressing tab
                            firstFocusableElement.focus(); // add focus for the first focusable element
                            e.preventDefault();
                        }
                    }
                });
            }
        },
        onFocusout: function onFocusout(evt) {
            // If focus leaves modal, bring it back
            // 'focusout' Event Listener bound on content
            var content = this.$refs.content;
            var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            var firstFocusableElement = content.querySelectorAll(focusableElements)[0];
            if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                firstFocusableElement.focus();
            }
        },

        // Resize Listener
        setResizeEvent: function setResizeEvent(on) {
            var _this4 = this;

            ['resize', 'orientationchange'].forEach(function (evtName) {
                if (on) {
                    (0, _dom.eventOn)(window, evtName, _this4.adjustDialog);
                } else {
                    (0, _dom.eventOff)(window, evtName, _this4.adjustDialog);
                }
            });
        },

        // Root Listener handlers
        showHandler: function showHandler(id, triggerEl, arg) {
            this.arg = null;
            if (arg) {
                this.arg = arg;
            }
            if (id === this.id) {
                this.return_focus = triggerEl || null;
                this.show();
            }
        },
        hideHandler: function hideHandler(id) {
            if (id === this.id) {
                this.hide();
            }
        },
        modalListener: function modalListener(bvEvt) {
            // If another modal opens, close this one
            if (bvEvt.vueTarget !== this) {
                this.hide();
            }
        },

        // Focus control handlers
        focusFirst: function focusFirst() {
            // Don't try and focus if we are SSR
            if (typeof document === 'undefined') {
                return;
            }
            var content = this.$refs.content;
            var modal = this.$refs.modal;
            var activeElement = document.activeElement;
            if (activeElement && content && content.contains(activeElement)) {
                // If activeElement is child of content, no need to change focus
            } else if (content) {
                if (modal) {
                    modal.scrollTop = 0;
                }
                // Focus the modal content wrapper
                content.focus();
            }
        },
        returnFocusTo: function returnFocusTo() {
            // Prefer returnFocus prop over event specified return_focus value
            var el = this.returnFocus || this.return_focus || null;
            if (typeof el === 'string') {
                // CSS Selector
                el = (0, _dom.select)(el);
            }
            if (el) {
                el = el.$el || el;
                if ((0, _dom.isVisible)(el)) {
                    el.focus();
                }
            }
        },

        // Utility methods
        getScrollbarWidth: function getScrollbarWidth() {
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        },
        adjustDialog: function adjustDialog() {
            if (!this.is_visible) {
                return;
            }
            var modal = this.$refs.modal;
            var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
            if (!this.isBodyOverflowing && isModalOverflowing) {
                modal.style.paddingLeft = this.scrollbarWidth + 'px';
            }
            if (this.isBodyOverflowing && !isModalOverflowing) {
                modal.style.paddingRight = this.scrollbarWidth + 'px';
            }
        },
        resetAdjustments: function resetAdjustments() {
            var modal = this.$refs.modal;
            if (modal) {
                modal.style.paddingLeft = '';
                modal.style.paddingRight = '';
            }
        },
        checkScrollbar: function checkScrollbar() {
            var rect = (0, _dom.getBCR)(document.body);
            this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        },
        setScrollbar: function setScrollbar() {
            if (this.isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var computedStyle = window.getComputedStyle;
                var body = document.body;
                var scrollbarWidth = this.scrollbarWidth;
                // Adjust fixed content padding
                (0, _dom.selectAll)(Selector.FIXED_CONTENT).forEach(function (el) {
                    var actualPadding = el.style.paddingRight;
                    var calculatedPadding = computedStyle(el).paddingRight || 0;
                    (0, _dom.setAttr)(el, 'data-padding-right', actualPadding);
                    el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
                });
                // Adjust sticky content margin
                (0, _dom.selectAll)(Selector.STICKY_CONTENT).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    (0, _dom.setAttr)(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
                });
                // Adjust navbar-toggler margin
                (0, _dom.selectAll)(Selector.NAVBAR_TOGGLER).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    (0, _dom.setAttr)(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
                });
                // Adjust body padding
                var actualPadding = body.style.paddingRight;
                var calculatedPadding = computedStyle(body).paddingRight;
                (0, _dom.setAttr)(body, 'data-padding-right', actualPadding);
                body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
            }
        },
        resetScrollbar: function resetScrollbar() {
            // Restore fixed content padding
            (0, _dom.selectAll)(Selector.FIXED_CONTENT).forEach(function (el) {
                if ((0, _dom.hasAttr)(el, 'data-padding-right')) {
                    el.style.paddingRight = (0, _dom.getAttr)(el, 'data-padding-right') || '';
                    (0, _dom.removeAttr)(el, 'data-padding-right');
                }
            });
            // Restore sticky content and navbar-toggler margin
            (0, _dom.selectAll)(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
                if ((0, _dom.hasAttr)(el, 'data-margin-right')) {
                    el.style.marginRight = (0, _dom.getAttr)(el, 'data-margin-right') || '';
                    (0, _dom.removeAttr)(el, 'data-margin-right');
                }
            });
            // Restore body padding
            var body = document.body;
            if ((0, _dom.hasAttr)(body, 'data-padding-right')) {
                body.style.paddingRight = (0, _dom.getAttr)(body, 'data-padding-right') || '';
                (0, _dom.removeAttr)(body, 'data-padding-right');
            }
        },
        addRemoveInertAttribute: function addRemoveInertAttribute(hasSetInertAttribute) {
            var elements = [].concat(_toConsumableArray(document.getElementsByClassName('c-skip-to')), _toConsumableArray(document.getElementsByClassName('l-header__top')), _toConsumableArray(document.getElementsByClassName('l-header__main')), _toConsumableArray(document.getElementsByClassName('l-main')), _toConsumableArray(document.getElementsByClassName('l-footer')), _toConsumableArray(document.querySelectorAll('.l-header__utility')));
            elements.forEach(function (element) {
                if (hasSetInertAttribute) {
                    element.setAttribute('inert', '');
                } else {
                    element.removeAttribute('inert');
                }
            });
        }
    },
    created: function created() {
        // create non-reactive property
        this._observer = null;
    },
    mounted: function mounted() {
        var _this5 = this;

        // Update dialogAttributes() computed property to remove aria-hidden=true if shownOnDesktop prop is set to true and screen is desktop size
        if (this.showOnDesktop) {
            var timeout = false;
            var delay = 1000;

            if (window.innerWidth > 991) {
                this.is_shown_for_desktop = true;
            }

            // Handle window resize events to remove aria-hidden=true on desktop size with a delay
            window.addEventListener('resize', function () {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    if (window.innerWidth > 991) {
                        _this5.is_shown_for_desktop = true;
                    } else {
                        _this5.is_shown_for_desktop = false;
                    }
                }, delay);
            });
        }
        // Measure scrollbar
        this.getScrollbarWidth();
        // Listen for events from others to either open or close ourselves
        this.listenOnRoot('bv::show::modal', this.showHandler);
        this.listenOnRoot('bv::hide::modal', this.hideHandler);
        // Listen for bv:modal::show events, and close ourselves if the opening modal not us
        this.listenOnRoot('bv::modal::show', this.modalListener);
        // Initially show modal?
        if (this.visible === true) {
            this.show();
        }
    },
    beforeDestroy: function beforeDestroy() {
        // Ensure everything is back to normal
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
        this.setResizeEvent(false);
        // Re-adjust body/navbar/fixed padding/margins (if needed)
        (0, _dom.removeClass)(document.body, 'modal-open');
        this.resetAdjustments();
        this.resetScrollbar();
    }
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    props: {
        interval: {
            type: Number,
            'default': 0
        }
    },
    data: function data() {
        return {
            test: '',
            Quiz: null
        };
    },
    mounted: function mounted() {
        this.openAtTimeout();

        this.Quiz = this.$children.find(function (child) {
            return child.$options.name === "aha-transition-group";
        });
        if (this.Quiz !== undefined) {
            console.log('Quiz component', this.Quiz);
            this.$root.$on('bv::modal::hidden', this.resetQuiz);
        }
    },

    methods: {
        openAtTimeout: function openAtTimeout() {
            var _this = this;

            if (this.interval === 0 || this.interval === '') {
                return;
            }
            setTimeout(function () {
                _this.show();
            }, this.interval * 1000);
        },
        resetQuiz: function resetQuiz(evt) {
            // Reset quiz back to first step
            this.Quiz.EventBus.$emit('stepTrigger', 1);
        }
    }
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

var _ahaDropdown = __webpack_require__(74);

var _ahaDropdown2 = _interopRequireDefault(_ahaDropdown);

var _dom = __webpack_require__(25);

var _keyCodes = __webpack_require__(274);

var _keyCodes2 = _interopRequireDefault(_keyCodes);

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default'], _ahaDropdown2['default']],
    render: function render(h) {
        var toggle = h('button', {
            ref: 'toggle',
            attrs: {
                type: 'button',
                id: this.safeId('_AHA_toggle_'),
                'aria-haspopup': this.role,
                'aria-expanded': this.visible ? 'true' : 'false'
            },
            'class': this.toggleClasses,
            on: {
                click: this.toggle,
                keydown: this.toggle
            }
        }, [this.buttonText]);

        var arrow = h('span', {
            ref: 'arrow',
            attrs: {
                'x-arrow': ''
            },
            'class': 'c-nav-dropdown__arrow'
        });

        var menu = h(this.dropdownTag, {
            ref: 'menu',
            'class': this.menuClasses,
            attrs: {
                tabindex: -1,
                role: this.role,
                'aria-activedescendant': this.activeItemId,
                'aria-labelledby': this.safeId('_AHA_toggle_')
            },
            on: {
                keydown: this.onListboxKeydown
            }
        }, [this.$slots.dropdown, this.arrow ? arrow : null]);

        var hiddenInput = h('input', {
            ref: 'input',
            attrs: {
                type: 'hidden',
                value: this.hiddenValue,
                name: this.inputName
            },
            directives: [this.directiveOptions]
        });

        return h('div', {
            ref: 'dropdown',
            attrs: {
                id: this.safeId()
            },
            'class': this.dropdownClasses
        }, [toggle, hiddenInput, menu]);
    },
    data: function data() {
        return {
            hiddenValue: null,
            displayText: null,
            activeItemId: null,
            dropdownItems: [],
            directiveOptions: {}
        };
    },

    props: {
        value: {
            required: false
        },
        defaultValue: {
            type: String,
            required: true
        },
        labelledby: {
            type: String,
            'default': ''
        },
        toggleClass: {
            type: String,
            'default': ''
        },
        menuClass: {
            type: String,
            'default': ''
        },
        role: {
            type: String,
            'default': 'menu'
        },
        arrow: {
            type: Boolean,
            'default': false
        },
        inputName: {
            type: String,
            'default': 'searchCategory'
        },
        dropdownTag: {
            type: String,
            'default': 'div'
        },
        dropdownItemActiveClass: {
            type: String,
            'default': 'selected'
        },
        inputDirective: {
            type: Boolean,
            'default': false
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$on('selected', this.selectedListener);
        this.$on('register', this.registerDropdownItem);

        if (this.inputDirective) {
            this.directiveOptions = {
                name: 'input',
                value: this.inputName
            };
        }

        this.$nextTick(function () {
            if (_this.defaultValue) {
                _this.hiddenValue = _this.defaultValue;

                // If we have a default value, set the item to be selected on first menu opening
                var item = _this.dropdownItems.find(function (item) {
                    return item.value === _this.defaultValue || item.text === _this.defaultValue;
                });

                if (typeof item !== 'undefined') {
                    item.selected = true;
                    // This next line actually sets the item as selected
                    _this.selectedListener(item.value, item.text, item.element);
                }
            }
        });
    },

    methods: {
        onListboxKeydown: function onListboxKeydown(evt) {
            this.onKeydown(evt);

            // Select the currently selected dropdown item
            if (!this.disableMenuEvents && (evt.keyCode === _keyCodes2['default'].ENTER || evt.keyCode === _keyCodes2['default'].SPACE)) {
                var item = this.currentSelectedDropdown();
                this.selectedListener(item.value, item.text, item.element);
            }
        },
        selectedListener: function selectedListener(value, text, element, isInitial) {
            if (typeof value !== 'undefined') {
                this.hiddenValue = value;
                this.displayText = text;

                this.setSelectedDropdownItem(value);

                this.$emit('input', this.hiddenValue);
                _inputEventbus2['default'].$emit('inputUpdated', this.hiddenValue, this.inputName, this.$el);
                this.focusItemByElement(element);

                // Disable focus on initial page load
                if (!isInitial) {
                    this.focusToggler();
                }
            }
        },
        getItems: function getItems() {
            return this.filterVisible((0, _dom.selectAll)('[role]', this.$refs.menu));
        },
        registerDropdownItem: function registerDropdownItem(value, text, element) {
            this.dropdownItems.push({
                value: value,
                text: text,
                element: element,
                selected: false
            });
        },
        showMenuFocus: function showMenuFocus() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$nextTick(function () {
                    var item = _this2.dropdownItems.find(function (item) {
                        return item.selected;
                    });

                    if (typeof item !== 'undefined') {
                        _this2.setSelectedDropdownItem(item.value);
                        _this2.focusItemByElement(item.element);
                    }

                    _this2.$refs.menu.focus();
                });
            });
        },
        setSelectedDropdownItem: function setSelectedDropdownItem(value) {
            this.dropdownItems.forEach(function (item) {
                item.selected = false;

                if (item.value === value) {
                    item.selected = true;
                }
            });
        },
        focusItem: function focusItem(index, items) {
            var element = items.find(function (element, i) {
                return i === index;
            });

            this.setSelectedDropdownClasses(element, items);
        },
        focusItemByElement: function focusItemByElement(element) {
            var items = this.getItems();

            var index = items.indexOf(items.find(function (item) {
                return item === element;
            }));

            this.focusItem(index, items);
        },
        focusNext: function focusNext(evt, up) {
            var _this3 = this;

            if (!this.visible) {
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();

            this.$nextTick(function () {
                var items = _this3.getItems();

                if (items.length < 1) {
                    return;
                }

                var index = items.indexOf(items.find(function (el) {
                    return el.classList.contains(_this3.dropdownItemActiveClass);
                }));

                if (up && index > 0) {
                    index--;
                } else if (!up && index < items.length - 1) {
                    index++;
                }

                if (index < 0) {
                    index = 0;
                }

                _this3.focusItem(index, items);
            });
        },
        setSelectedDropdownClasses: function setSelectedDropdownClasses(selectedElement, elements) {
            var _this4 = this;

            elements.forEach(function (el) {
                el.classList.remove(_this4.dropdownItemActiveClass);
                if (selectedElement.tagName !== 'A') {
                    el.setAttribute('aria-selected', false);
                }
            });

            if (selectedElement && (0, _dom.getAttr)(selectedElement, 'tabindex') !== '-1') {
                selectedElement.classList.add(this.dropdownItemActiveClass);
                if (selectedElement.tagName !== 'A') {
                    selectedElement.setAttribute('aria-selected', true);
                }
                this.activeItemId = selectedElement.getAttribute('id');
            }
        },
        currentSelectedDropdown: function currentSelectedDropdown() {
            var _this5 = this;

            return this.dropdownItems.find(function (item) {
                return item.element.classList.contains(_this5.dropdownItemActiveClass);
            });
        },
        resetList: function resetList() {
            var item = this.dropdownItems[0];
            this.selectedListener(item.value, item.text, item.element);
        }
    },
    watch: {
        value: function value(val) {
            var dropdown = this.dropdownItems.find(function (item) {
                return item.value === val;
            });

            // If the value is trying to be set programmatically, check the registered dropdown items
            if (typeof dropdown !== 'undefined') {
                this.hiddenValue = val;
                this.displayText = dropdown.text;

                this.setSelectedDropdownItem(dropdown.value);
            }
        }
    },
    computed: {
        buttonText: function buttonText() {
            return this.displayText || this.getDefaultValue;
        },
        getDefaultValue: function getDefaultValue() {
            var _this6 = this;

            var item = this.dropdownItems.find(function (item) {
                return item.value === _this6.defaultValue;
            });

            if (typeof item !== 'undefined') {
                return item.text;
            } else {
                return this.defaultValue;
            }
        },
        dropdownClasses: function dropdownClasses() {
            return ['c-select-dropdown__container', 'position-static', this.visible ? 'show' : ''];
        },
        menuClasses: function menuClasses() {
            return ['c-select-dropdown', 'dropdown-menu', this.right ? 'dropdown-menu-right' : '', this.menuClass];
        },
        toggleClasses: function toggleClasses() {
            return [this.toggleClass];
        }
    }
};

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf3c60ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_google_map_vue__ = __webpack_require__(311);
function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_google_map_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf3c60ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_google_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(308);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5cfa7392", content, true, {});

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_379b8021_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__ = __webpack_require__(310);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_379b8021_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-map',{ref:"gmap",staticStyle:{"width":"100%","height":"276px"},attrs:{"center":_vm.center,"zoom":_vm.zoom}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.center=m.position}}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('google-map',{attrs:{"address":_vm.address,"zoom":_vm.zoom}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d17c824_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_half_image_half_copy_collapse_vue__ = __webpack_require__(313);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d17c824_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_half_image_half_copy_collapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo text-collapse"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo__media h-placeholder-image image-fixed h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://via.placeholder.com/425'),expression:"'https://via.placeholder.com/425'"}],attrs:{"src":"https://via.placeholder.com/425"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-text-contrast"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"button-collapse-content",rawName:"v-button-collapse-content"}],staticClass:"btn btn-primary",attrs:{"type":"button","data-toggle":"collapse","data-target":"#collapseExample","aria-expanded":"false","aria-controls":"collapseExample"}},[_vm._v("\n                            Expand to see more\n                        ")])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"l-promo text-collapse"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-text-contrast"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"button-collapse-content",rawName:"v-button-collapse-content"}],staticClass:"btn btn-primary",attrs:{"data-text-id":"collapseExample1","type":"button","data-toggle":"collapse","data-target":"#collapseExample1","aria-expanded":"false","aria-controls":"collapseExample1"}},[_vm._v("\n                            Expand to see more\n                        ")])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo__media h-placeholder-image image-fixed h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://via.placeholder.com/425'),expression:"'https://via.placeholder.com/425'"}],attrs:{"src":"https://via.placeholder.com/425"}})])])])]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"l-promo text-collapse"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo__media h-placeholder-image image-fixed h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://via.placeholder.com/425'),expression:"'https://via.placeholder.com/425'"}],attrs:{"src":"https://via.placeholder.com/425"}})])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-text-contrast"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"button-collapse-content",rawName:"v-button-collapse-content"}],staticClass:"btn btn-primary",attrs:{"data-text-id":"collapseExample3","type":"button","data-toggle":"collapse","data-target":"#collapseExample3","aria-expanded":"false","aria-controls":"collapseExample3"}},[_vm._v("\n                            Expand to see more\n                        ")])]),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('div',{staticClass:"l-promo text-collapse"},[_c('div',{staticClass:"l-promo__col"},[_c('div',{staticClass:"c-promo c-promo--half c-promo--bg h-text-contrast"},[_c('div',{staticClass:"c-promo__content"},[_c('h2',{staticClass:"h3"},[_vm._v("Veggie Migas")]),_vm._v(" "),_c('p',[_vm._v("A Tex-Mex dish, migas are corn tortilla strips gently fried and incorporated into scrambled eggs. This spin on the classic uses very little oil while also adding an array of veggies into the mix.")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"button-collapse-content",rawName:"v-button-collapse-content"}],staticClass:"btn btn-primary",attrs:{"data-text-id":"collapseExample4","type":"button","data-toggle":"collapse","data-target":"#collapseExample4","aria-expanded":"false","aria-controls":"collapseExample4"}},[_vm._v("\n                            Expand to see more\n                        ")])]),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col c-promo--last-sm"},[_c('div',{staticClass:"c-promo__media h-placeholder-image image-fixed h-placeholder-image--bg h-placeholder-image--bg-sm"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:('https://via.placeholder.com/425'),expression:"'https://via.placeholder.com/425'"}],attrs:{"src":"https://via.placeholder.com/425"}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",attrs:{"id":"collapseExample"}},[_c('div',{staticClass:"card card-body c-promo--bg"},[_vm._v("\n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. \n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--green-lime",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",attrs:{"id":"collapseExample1"}},[_c('div',{staticClass:"card card-body c-promo--bg"},[_vm._v("\n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. \n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--green-lime",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",attrs:{"id":"collapseExample3"}},[_c('div',{staticClass:"card card-body c-promo--bg"},[_vm._v("\n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. \n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--green-lime",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",attrs:{"id":"collapseExample4"}},[_c('div',{staticClass:"card card-body c-promo--bg"},[_vm._v("\n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     \n                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.                                     Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. \n                            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo__actions"},[_c('a',{staticClass:"c-cta c-cta--icon h-theme--green-lime",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"assets/glyphs/recipe.svg"}}),_vm._v("View Recipe\n                        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc10d6b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_donation_modal_vue__ = __webpack_require__(315);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_donation_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc10d6b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_donation_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showModal)?_c('div',[_c('aha-modal',{ref:"ahaDonationPromoModal",attrs:{"id":"ahaDonationPromoModal","size":"lg","hide-footer":"","hide-header":"","centered":"","lazy":"","has-hide-aria-labelledby":true,"modalRole":'dialog'}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('div',{staticClass:"l-generic__col col-md-12 p-0"},[_c('div',{staticClass:"c-promotion__card h-theme--black h-text-contrast mb-0"},[_c('div',{staticClass:"c-article-card__background h-placeholder-image",class:{
                  'h-placeholder-image--16-9': _vm.translations.image,
                }},[(_vm.translations.image)?_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:(_vm.translations.image),expression:"translations.image"}],attrs:{"src":_vm.translations.image,"alt":_vm.translations.alt}}):_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.translations.video,"allowfullscreen":""}}),_vm._v(" "),_c('b-btn-close',{staticClass:"c-modal--promotion__close btn btn-dark",on:{"click":_vm.handleClose}},[_vm._v("×")])],1)])])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"center"}},[_c('div',{staticClass:"col-lg-12 c-promotion__title__wrapper w-100 px-0"},[_c('div',{staticClass:"c-promotion__title w-100 text-center mb-3",attrs:{"id":"dialog-title"},domProps:{"innerHTML":_vm._s(_vm.translations.title)}})]),_vm._v(" "),_c('div',{staticClass:"d-flex c-promotion__modal",class:{ 'flex-wrap': _vm.translations.btn2 }},[_c('div',{},[_c('div',{staticClass:"h4 text-lg-left text-center",attrs:{"id":"dialog-description"},domProps:{"innerHTML":_vm._s(_vm.translations.description)}})]),_vm._v(" "),_c('div',{staticClass:"mx-auto mt-3 c-promotion__modal-buttons"},[_c('a',{staticClass:"mb-lg-0 mb-3 mr-lg-5 mr-0 btn btn-lg btn-round btn-danger",class:{ 'btn-outline-primary' : _vm.btnColor },attrs:{"href":_vm.translations.url,"data-tracking":_vm.dataTracking}},[_vm._v(_vm._s(_vm.translations.btn))]),_vm._v(" "),(_vm.translations.btn2)?_c('a',{staticClass:"btn btn-lg ml-lg-5 ml-0 btn-round btn-danger",class:{ 'btn-outline-primary': _vm.btnColor2 },attrs:{"href":_vm.translations.url2,"data-tracking":_vm.dataTracking}},[_vm._v(_vm._s(_vm.translations.btn2))]):_vm._e()])])])],1)],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_544613c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_hospital_zipcode_modal_vue__ = __webpack_require__(317);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_hospital_zipcode_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_544613c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_hospital_zipcode_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-location-modal"},[_c('aha-modal',{ref:"ahaZipCodeModal",attrs:{"id":"ahaZipCodeModal","aria-labelledby":"dialog-title","aria-describedby":"dialog-description","size":"lg","hide-footer":"","centered":"","lazy":""}},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"c-listing-header c-listing-header--medium pt-0"},[_c('div',{staticClass:"c-listing-header__cta-container d-block"},[_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v(_vm._s(_vm.translations.heading))])])]),_vm._v(" "),_c('p',{staticClass:"c-listing-header__subheading"},[_vm._v(_vm._s(_vm.translations.subheading))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('form',{attrs:{"action":"#","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"text-left",attrs:{"for":"event_manual_zipcode"}},[_vm._v("\n                Zip code (required)\n                "),_c('p',{staticClass:"invalid-feedback"},[_vm._v("Please provide a valid zipcode.")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"}],staticClass:"form-control",attrs:{"id":"event_manual_zipcode","type":"text","pattern":"^\\d{5}(?:[-\\s]\\d{4})?$","name":"manualZipcodeEntry","placeholder":"Please enter your zip code","aria-required":"true","required":"","aria-invalid":"false"},domProps:{"value":(_vm.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}})]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary btn-round",attrs:{"type":"submit"},domProps:{"value":_vm.translations.btn}})])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_317fb771_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_session_timeout_modal_vue__ = __webpack_require__(319);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_session_timeout_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_317fb771_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_session_timeout_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-location-modal"},[_c('aha-modal',{ref:"ahaTimeoutModal",attrs:{"id":"ahaTimeoutModal","aria-labelledby":"dialog-title","aria-describedby":"dialog-description","no-close-on-esc":true,"no-close-on-backdrop":true,"hide-header-close":"","hide-footer":"","centered":"","lazy":""}},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"c-listing-header c-listing-header--medium pt-0"},[_c('div',{staticClass:"c-listing-header__cta-container d-block"},[_c('h2',{staticClass:"c-listing-header__heading"},[_vm._v(_vm._s(_vm.translations.heading))])])]),_vm._v(" "),_c('p',{staticClass:"c-listing-header__subheading"},[_vm._v(_vm._s(_vm.translations.subheading))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('form',{attrs:{"action":"#","method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('input',{staticClass:"btn btn-primary btn-round",attrs:{"type":"submit"},domProps:{"value":_vm.translations.btnyeslabel}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-round",on:{"click":function($event){$event.preventDefault();return _vm.onCancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.translations.btnnolabel))])])])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d738682_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_group_vue__ = __webpack_require__(321);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d738682_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daee65ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_group_form_vue__ = __webpack_require__(324);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_group_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daee65ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_group_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports['default'] = {
    post: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(endpoint, obj) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', (0, _axios2['default'])({
                                method: 'post',
                                url: endpoint,
                                responseType: 'json',
                                data: obj
                            })['catch'](function (error) {
                                // eslint-disable-next-line
                                console.log('Trigger Page Goals error: ' + error);
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function post(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return post;
    }()
};

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transition-group-form",attrs:{"id":_vm.id}},[_vm._t("default",null,{"formData":_vm.formData,"loading":_vm.loading,"activeStep":_vm.activeStep,"response":_vm.response,"submitForm":_vm.submitForm,"quizSubmitForm":_vm.quizSubmitForm,"resetForm":_vm.resetForm,"sendEmail":_vm.sendEmail,"categoryList":_vm.categoryList})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f347b12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_step_vue__ = __webpack_require__(326);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_transition_step_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f347b12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_transition_step_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step == _vm.stepKey),expression:"step == stepKey"}],key:_vm.stepKey},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inject: ['EventBus'],
    props: {
        ariaLabel: {
            type: String,
            required: false
        }
    },
    render: function render(h) {
        var _this = this;

        var container = h('button', {
            attrs: {
                'aria-label': this.ariaLabel
            },
            on: {
                click: function click(evt) {
                    if (evt.target.hasAttribute('step-index')) {
                        _this.EventBus.$emit('stepTrigger', evt.target.getAttribute('step-index'));
                    } else {
                        var eventName = evt.target.getAttribute('data-eventname');
                        var eventparameters = evt.target.getAttribute('data-eventparameters');
                        var eventSendTo = evt.target.getAttribute('data-send-to');
                        if (eventName && eventparameters) {
                            var rawObject = eventparameters.split(',').map(function (i) {
                                return i.split(':').map(function (j) {
                                    return j.trim();
                                });
                            });
                            var eventObject = Object.fromEntries(rawObject);
                            var eventNewObj = {};
                            for (var key in eventObject) {
                                var newKey = key.replace(/\s/g, '_').toLowerCase();
                                eventNewObj[newKey] = eventObject[key];
                            }
                            eventNewObj.send_to = eventSendTo;
                            window.gtag('event', eventName, eventNewObj);
                        }
                        _this.EventBus.$emit('stepTrigger');
                        // evt.target.setAttribute('disabled', 'disabled');
                    }
                }
            }
        }, [this.$slots['default']]);

        return container;
    }
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inject: ['EventBus'],
    render: function render(h) {
        var container = h('span', {});

        return container;
    },

    props: {},
    mounted: function mounted() {
        var _this = this;

        this.EventBus.$on('stepShown', function (inputs) {
            _this.$nextTick(function () {
                if (inputs.length) {
                    for (var i = 0; i < inputs.length; i++) {
                        if (inputs[i].checked) {
                            _this.$el.innerHTML = inputs[i].value;
                            break;
                        }
                    }
                } else {
                    _this.$el.innerHTML = inputs.value;
                }
            });
        });
    }
};

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be6e32a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_inline_site_search_vue__ = __webpack_require__(330);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_inline_site_search_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be6e32a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_inline_site_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modalId),expression:"modalId"}],staticClass:"c-top-nav__link btn btn-link-plain"},[_c('img',{attrs:{"src":_vm.searchIcon,"alt":""}}),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.searchLabel))])]),_vm._v(" "),_c('aha-modal',{staticClass:"c-site-search-modal global-search-section",attrs:{"id":_vm.modalId,"hide-footer":"","hide-header":"","lazy":""},on:{"shown":_vm.onShown}},[_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', _vm.modalId, $event.target)}}},[_vm._v("×")]),_vm._v(" "),_c('form',{staticClass:"c-inline-search__form",attrs:{"action":_vm.formAction,"role":"search"}},[_c('div',{staticClass:"c-inline-search__search form-group form-group--horizontal"},[_c('label',{staticClass:"col-form-label-lg",attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.searchLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],ref:"search",staticClass:"c-inline-search__input form-control form-control-lg",attrs:{"type":"text","id":_vm.inputId,"name":_vm.inputName,"placeholder":_vm.placeholderText},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('input',{staticClass:"c-inline-search__submit btn btn-lg btn-danger btn-round",attrs:{"type":"submit"},domProps:{"value":_vm.searchButton},on:{"click":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd80c64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impacted_data_vue__ = __webpack_require__(332);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd80c64_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impacted_data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-impact-map-data"},[_c('div',{staticClass:"c-impact-map-data__container container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-impact-map-data col-md-10 offset-md-1"},[_c('h1',[_vm._v("Our Impact")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("For nearly 100 years")]),_vm._v(", we've been fighting heart disease and stroke, helping communities live longer, healthier lives."),_c('br'),_vm._v("\n          When you support the American Heart Association, it's evident in communities like yours."),_c('br'),_vm._v(" "),_c('i',[_vm._v("Explore the map below to see how your support has made an impact.")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("13.6%")])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Reduction in deaths from Stroke")]),_c('br'),_vm._v("\n              Since February 2018\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("$200"),_c('br'),_c('label',[_vm._v("MILLION")])])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Invested annually in inovative research funding")]),_c('br'),_vm._v("\n              More than any private not-for-profit organization except the federal government.\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("15.1%")])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Reduction in deaths from Heart Disease")]),_c('br'),_vm._v("\n              Since February 2018\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("30"),_c('br'),_c('label',[_vm._v("MILLION")])])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Nutritious school lunches provided")])])])]),_vm._v(" "),_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("14"),_c('br'),_c('label',[_vm._v("MILLION")])])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Nutritious school breakfasts provided")])])])]),_vm._v(" "),_c('div',{staticClass:"c-impact-map-data col-md-4 float-left"},[_c('div',{staticClass:"c-impact-map-data__sub-headings"},[_c('span',{staticClass:"c-impact-map-data__sub-heading"},[_c('strong',[_vm._v("22"),_c('br'),_c('label',[_vm._v("MILLION")])])])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"c-impact-map-data__text"},[_c('strong',[_vm._v("Peaople trained in CPR each year")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _queryParams = __webpack_require__(334);

var _queryParams2 = _interopRequireDefault(_queryParams);

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

var _closest = __webpack_require__(119);

var _closest2 = _interopRequireDefault(_closest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    render: function render(h) {
        var template = h('div', [this.$scopedSlots['default']({
            isInitialized: this.isInitialized,
            currentQuery: this.currentQuery,
            sortBy: this.sortBy,
            numResults: this.numResults,
            formData: this.formData,
            flaggedData: this.flaggedData,
            id: this.id,
            isValid: this.isValid,
            submitSearch: this.submitSearch,
            manualSubmitSearch: this.manualSubmitSearch,
            checkFormData: this.checkFormData,
            checkParent: this.checkParent
        })]);

        var form = h('form', {
            ref: 'searchForm',
            attrs: {
                id: this.id,
                action: this.action
            }
        }, [template]);

        return form;
    },
    data: function data() {
        return {
            isInitialized: false,
            currentQuery: {
                type: String
            },
            sortBy: {
                type: String
            },
            numResults: {
                type: String
            },
            formData: {},
            flaggedData: [],
            id: 'component_uid_' + this._uid
        };
    },

    props: {
        action: {
            type: String,
            'default': ''
        },
        queryString: {
            type: String,
            'default': null
        },
        queryDelimeter: {
            type: String,
            'default': '?'
        },
        sortByName: {
            type: String,
            'default': 'sort-by'
        },
        numResultsName: {
            type: String,
            'default': 'num-results'
        }
    },
    computed: {
        isValid: function isValid() {
            return this.checkFormData;
        }
    },
    watch: {
        sortBy: function sortBy(val) {
            this.submitSearch();
        },
        numResults: function numResults(val) {
            this.submitSearch();
        }
    },
    methods: {
        submitSearch: function submitSearch() {
            var _this = this;

            // Don't submit search until default values are set
            if (this.isInitialized) {
                this.$nextTick(function () {
                    _this.$refs.searchForm.submit();
                });
            }
        },
        manualSubmitSearch: function manualSubmitSearch() {
            var _this2 = this;

            if (this.isInitialized) {
                this.$nextTick(function () {
                    var validQuery = _this2.checkFormData();
                    var url = _this2.action;
                    if (validQuery) {
                        var i = 0;
                        url += _this2.queryDelimeter;
                        for (var prop in _this2.formData) {
                            if (_this2.formData[prop] !== '') {
                                var flagged = false;
                                var z = 0;
                                do {
                                    if (_this2.flaggedData[z] === prop) {
                                        flagged = true;
                                    }
                                    z++;
                                } while (z < _this2.flaggedData.length && !flagged);
                                if (i > 0) {
                                    url += '&';
                                }
                                if (flagged) {
                                    url += prop + '=' + _this2.formData[prop];
                                } else {
                                    url += prop + '=[' + _this2.formData[prop] + ']';
                                }
                                i++;
                            }
                        }
                    }
                    window.location.href = url;
                });
            }
        },
        checkFormData: function checkFormData() {
            for (var prop in this.formData) {
                if (this.formData[prop] !== '') {
                    return true;
                }
            }
            return false;
        },
        checkParent: function checkParent(el) {
            var root = '#' + this.id;
            var parent = (0, _closest2['default'])(el, root);
            if (this.$el === parent) {
                return true;
            } else {
                return false;
            }
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        var params = (0, _queryParams2['default'])();

        // Save the current query
        if (this.queryString && typeof params[this.queryString] !== 'undefined') {
            this.currentQuery = params[this.queryString];
        }

        this.$nextTick(function () {
            if (typeof params[_this3.sortByName] !== 'undefined') {
                _this3.sortBy = params[_this3.sortByName];
            }

            if (typeof params[_this3.numResultsName] !== 'undefined') {
                _this3.numResults = params[_this3.numResultsName];
            }

            _this3.$nextTick(function () {
                _this3.isInitialized = true;
            });
        });
    },
    created: function created() {
        var _this4 = this;

        _inputEventbus2['default'].$on('inputInit', function (value, id, el) {
            _this4.$nextTick(function () {
                var isParent = _this4.checkParent(el);
                if (isParent && !_this4.formData[id]) {
                    _this4.formData[id] = value;
                }
            });
        });

        _inputEventbus2['default'].$on('inputInitFlagged', function (value, id, el) {
            _this4.$nextTick(function () {
                var isParent = _this4.checkParent(el);
                if (isParent) {
                    _this4.formData[id] = value;
                    _this4.flaggedData.push(id);
                }
            });
        });

        _inputEventbus2['default'].$on('inputUpdated', function (value, id, el) {
            if (_this4.formData[id] !== value) {
                var isParent = _this4.checkParent(el);
                if (isParent) {
                    _this4.formData[id] = value;
                    _this4.$forceUpdate();
                }
            }
        });
    }
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports['default'] = queryParams;
function queryParams() {
    var query = window.location.search;

    return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
        var _param$split = param.split('='),
            _param$split2 = _slicedToArray(_param$split, 2),
            key = _param$split2[0],
            value = _param$split2[1];

        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        return params;
    }, {});
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc7711c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_back_to_search_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(336)
  __webpack_require__(338)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fc7711c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_back_to_search_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc7711c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_back_to_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(337);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("338446e7", content, true, {});

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".c-cta--arrow-reverse[data-v-2fc7711c]:before{content:\"<\";width:15px}.c-cta--arrow-reverse[data-v-2fc7711c]{padding:1.875rem 0}.c-cta--arrow-reverse[data-v-2fc7711c]:hover:before{text-decoration:none}", ""]);

// exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(339);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("589285f5", content, true, {});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".back-to-search-container+.c-hero-full{margin-top:18px}", ""]);

// exports


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{class:_vm.componentStyles},[(_vm.linkOnly)?_c('a',{class:_vm.linkStyles,attrs:{"href":_vm.searchPageUri}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.linkText))]})],2):_c('b-row',[_c('b-col',[_c('a',{class:_vm.linkStyles,attrs:{"href":_vm.searchPageUri}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.linkText))]})],2)])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* global addthis */

exports['default'] = {
    render: function render(h) {
        var addThis = h('div', {
            'class': 'c-share addthis_inline_share_toolbox'
        });

        var shareSpan = h('span', {
            'class': 'c-social__text'
        }, [this.shareText]);

        var container = h('div', {
            'class': 'c-social'
        }, [this.showText ? shareSpan : null, addThis]);

        return container;
    },

    props: {
        shareText: {
            type: String,
            'default': 'Share:'
        },
        showText: {
            type: Boolean,
            'default': false
        }
    },
    mounted: function mounted() {
        // Force AddThis to refresh
        if (typeof addthis.layers.refresh !== 'undefined') {
            addthis.layers.refresh();
        }
    }
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaId = __webpack_require__(7);

var _ahaId2 = _interopRequireDefault(_ahaId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    mixins: [_ahaId2['default']],
    render: function render(h) {
        var gigya = h('div', {
            'class': 'c-share c-share--gigya',
            attrs: {
                id: this.shareId
            }
        });

        var container = h('div', {
            'class': 'c-social'
        }, [gigya, this.hasDefaultSlot && this.$slots['default']]);

        return container;
    },

    props: {
        shareButtons: {
            type: Array
        },
        description: {
            type: String,
            'default': ''
        },
        title: {
            type: String,
            'default': ''
        },
        imageUrl: {
            type: String,
            'default': ''
        },
        tags: {
            type: String,
            'default': ''
        }
    },
    computed: {
        shareId: function shareId() {
            return this.safeId('_AHA-gigya-social');
        },
        hasDefaultSlot: function hasDefaultSlot() {
            return !!this.$slots['default'];
        }
    },
    mounted: function mounted() {
        var act = new gigya.socialize.UserAction();

        act.setDescription(this.description);
        act.setTitle(this.title);
        act.addMediaItem({
            type: 'image',
            src: this.imageUrl
        });

        var showShareBarUiParams = {
            containerID: this.shareId,
            tags: this.tags,
            wrap: 'true',
            iconsOnly: 'true',
            showTooltips: 'true',
            layout: 'horizontal',
            shortURLs: 'never',
            showCounts: 'none',
            shareButtons: this.shareButtons || [{
                provider: 'facebook',
                tooltip: 'Share on Facebook',
                iconImgUp: '/dist/common/assets/share/facebook.svg'
            }, {
                provider: 'twitter',
                tooltip: 'Share on Twitter',
                iconImgUp: '/dist/common/assets/share/twitter.svg'
            }, {
                provider: 'pinterest',
                tooltip: 'Pin It!',
                iconImgUp: '/dist/common/assets/share/pinterest.svg'
            }, {
                provider: 'print',
                tooltip: 'Print',
                iconImgUp: '/dist/common/assets/share/print.svg'
            }],
            userAction: act,
            onLoad: function onLoad(event) {
                var container = document.querySelector('#' + event.containerID);
                var shareButtons = container.querySelectorAll('.gig-share-button');

                for (var x = 0; x < shareButtons.length; x++) {
                    shareButtons[x].setAttribute('tabindex', 0);
                    shareButtons[x].setAttribute('role', 'button');

                    shareButtons[x].addEventListener('keypress', function (keyEvent) {
                        if (keyEvent.charCode === 13) {
                            this.onclick();
                        }
                    });
                }
            }
        };

        this.$nextTick(function () {
            gigya.socialize.showShareBarUI(showShareBarUiParams);
        });
    }
}; /* global gigya */

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb854628_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_single_field_prompt_form_vue__ = __webpack_require__(344);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb854628_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_single_field_prompt_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"c-single-field-prompt-form",attrs:{"novalidate":""},on:{"submit":_vm.submitForm}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label col-form-label-lg",attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.translations.label))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],ref:"singleFieldInput",staticClass:"form-control form-control-lg",class:{ 'is-invalid': _vm.isInvalid },attrs:{"id":_vm.inputId,"placeholder":_vm.translations.placeholder,"min":_vm.config.minValue,"max":_vm.config.maxValue,"required":""},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group",attrs:{"aria-hidden":!_vm.isInvalid,"aria-describedby":_vm.inputId,"role":"alert"}},[_c('div',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.translations.validation))])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-lg btn-danger",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.translations.submit))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53a78eb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_single_field_prompt_radio_form_vue__ = __webpack_require__(346);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_single_field_prompt_radio_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53a78eb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_single_field_prompt_radio_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"c-single-field-prompt-form",attrs:{"novalidate":""},on:{"submit":_vm.submitForm}},[_c('b-form-group',{attrs:{"label":_vm.title}},[_c('p',{ref:"label",domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),_c('div',{staticClass:"input-group",class:{ 'is-invalid': _vm.isInvalid },attrs:{"aria-hidden":!_vm.isInvalid,"role":"alert","aria-atomic":"true"}},[_c('div',{staticClass:"invalid-feedback",attrs:{"id":"invalid_feedback"}},[_c('p',[_vm._v(_vm._s(_vm.translations.validation))])])]),_vm._v(" "),_vm._l((this.config.options),function(option){return _c('div',{key:option.stepKey,staticClass:"custom-control custom-radio",class:{ 'is-invalid': _vm.isInvalid }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"custom-control-input",class:{ 'is-invalid': _vm.isInvalid },attrs:{"type":"radio","required":"","id":_vm.inputId + '_radio_' + option.stepKey,"name":_vm.inputId + '_radio_'},domProps:{"value":option.text,"checked":_vm._q(_vm.selected,option.text)},on:{"change":function($event){_vm.selected=option.text}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":_vm.inputId + '_radio_' + option.stepKey},domProps:{"innerHTML":_vm._s(option.text)}})])})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-lg btn-danger",attrs:{"type":"submit","disabled":!_vm.isFormValid}},[_vm._v(_vm._s(_vm.translations.submit))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e71aa7b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_tv_page_modal_vue__ = __webpack_require__(348);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_tv_page_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e71aa7b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_tv_page_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.videoId}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0445f523_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_make_commitment_form_vue__ = __webpack_require__(350);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_make_commitment_form_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0445f523_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_make_commitment_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"novalidate":""},on:{"submit":_vm.submitForm}},[_c('div',{staticClass:"c-promo c-promo--events c-promo--shadow c-promo--row",attrs:{"aria-live":"polite"}},[_vm._t("default",null,{"formData":_vm.formData,"response":_vm.response,"validation":_vm.validation,"loading":_vm.loading,"isComplete":_vm.isComplete,"checkInput":_vm.checkInput,"validEmail":_vm.validEmail})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b42a290_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_add_to_recipe_box_vue__ = __webpack_require__(352);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_add_to_recipe_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b42a290_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_add_to_recipe_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.recipeBoxForm)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50416a9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_recipe_box_favorite_vue__ = __webpack_require__(354);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_recipe_box_favorite_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50416a9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_recipe_box_favorite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-reset",attrs:{"type":"button"},on:{"click":_vm.click}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.srText))]),_vm._v(" "),_c('span',{class:_vm.iconClasses})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702afd68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_modify_recipe_box_vue__ = __webpack_require__(356);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_modify_recipe_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702afd68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_modify_recipe_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-recipe-box-widget"},[_c('div',{staticClass:"c-recipe-box-widget__header c-label c-label--red c-label--wide"},[_c('h3',{staticClass:"c-recipe-box-widget__heading h6"},[_vm._v(_vm._s(_vm.translations.firstSectionTitle))]),_vm._v(" "),_c('a',{staticClass:"c-recipe-box-widget__edit c-cta h-color--white",attrs:{"href":"#","role":"button","aria-label":"Edit Folder","title":"Edit Folder"},on:{"click":_vm.showEditSection}},[_vm._v(_vm._s(_vm.translations.editText))])]),_vm._v(" "),_c('nav',{staticClass:"c-recipe-box-widget__content"},[_c('ul',{staticClass:"c-recipe-box-categories"},[_c('li',[_c('a',{staticClass:"c-recipe-box-categories__link",attrs:{"href":_vm.translations.currentItemLink}},[_vm._v(_vm._s(_vm.translations.label))])]),_vm._v(" "),_vm._l((_vm.folderitems),function(option){return _c('li',{key:option.text},[(option.count!=null)?_c('a',{staticClass:"c-recipe-box-categories__link",attrs:{"href":_vm.translations.currentItemLink + '?recipeFolder=' + option.text}},[_vm._v(_vm._s(option.text)+" ("+_vm._s(option.count)+")")]):_vm._e(),_vm._v(" "),(option.count==null)?_c('a',{staticClass:"c-recipe-box-categories__link",attrs:{"href":_vm.translations.currentItemLink + '?recipeFolder=' + option.text}},[_vm._v(_vm._s(option.text))]):_vm._e()])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"recipeboxeditsection",staticClass:"c-recipe-box-widget",attrs:{"id":"recipeboxeditsection","role":"document","tabindex":"-1"}},[_c('div',{staticClass:"c-recipe-box-widget__header c-label c-label--red c-label--wide"},[_c('h3',{staticClass:"c-recipe-box-widget__heading h6"},[_vm._v(_vm._s(_vm.translations.firstSectionTitle))])]),_vm._v(" "),_c('div',{ref:"folderEditSection",staticClass:"c-recipe-box-widget__content clearfix"},[_c('form',{attrs:{"id":"updateRecipeboxFormData","action":"#"},on:{"submit":function($event){$event.preventDefault();return _vm.SumbitUpdateRecipeBox.apply(null, arguments)}}},[_c('ul',{ref:"recipeBoxUpdate",staticClass:"c-recipe-box-categories update-recipe-section",attrs:{"id":"recipeBoxUpdate"}},[_c('li',{ref:"recipeBoxUpdateMessage",staticClass:"sr-only",attrs:{"id":"recipeBoxUpdateMessage","hidden":true,"aria-live":"polite","role":"alert"}}),_vm._v(" "),_c('li',{staticClass:"form-group"},[_vm._v(_vm._s(_vm.translations.label))]),_vm._v(" "),_vm._l((_vm.items),function(option){return _c('li',{key:option.text,staticClass:"form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":_vm._f("underscore")(option.text)}},[_vm._v(_vm._s(option.text))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control has-invalid-icon",attrs:{"id":_vm._f("underscore")(option.text),"type":"text","name":"updateFolder","title":option.text},domProps:{"value":option.text}}),_vm._v(" "),_c('a',{staticClass:"input-validation-icon input-validation-icon--invalid",attrs:{"href":"#","aria-label":"Delete Folder","title":"Delete Folder","role":"button"},on:{"click":function($event){return _vm.DeleteFolder(option.text)}}},[_c('i',{staticClass:"icon-times"})])])])})],2),_vm._v(" "),_c('input',{staticClass:"c-recipe-box-widget__submit btn btn-danger btn-round",attrs:{"type":"submit"},domProps:{"value":_vm.translations.saveButtonText}})])])]),_vm._v(" "),_c('div',{staticClass:"c-recipe-box-widget"},[_c('div',{staticClass:"c-recipe-box-widget__header c-label c-label--red c-label--wide"},[_c('h3',{staticClass:"c-recipe-box-widget__heading h6"},[_vm._v(_vm._s(_vm.translations.createNewFolder))])]),_vm._v(" "),_c('div',{staticClass:"c-recipe-box-widget__content clearfix"},[_c('p',{ref:"createFolderError",staticClass:"sr-only",attrs:{"hidden":true,"role":"alert"}}),_vm._v(" "),_c('form',{class:[_vm.wasSubmitted ? 'was-validated' : 'needs-validation'],attrs:{"action":"#","novalidate":""}},[_c('ul',{staticClass:"c-recipe-box-categories"},[_c('li',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.fieldValue),expression:"fieldValue",modifiers:{"trim":true}}],ref:"createFolderInput",staticClass:"form-control",class:_vm.isValid ? ' ' : 'is-invalid',attrs:{"aria-atomic":_vm.isValid,"aria-invalid":!_vm.isValid,"required":"","id":"create-new-folder","type":"text","placeholder":_vm.translations.newFolderName,"name":""},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.isValid)?_c('div',{staticClass:"form-text text-danger is-invalid h4",attrs:{"role":"alert","aria-atomic":"true","id":"new-folder-help"}},[_c('small',[_vm._v("A folder name is required.")])]):_vm._e()])]),_vm._v(" "),_c('input',{staticClass:"c-recipe-box-widget__submit btn btn-danger btn-round",attrs:{"type":"submit","disabled":_vm.fieldValue === ''},domProps:{"value":_vm.translations.createButtonText},on:{"click":function($event){$event.preventDefault();return _vm.createFolderFn.apply(null, arguments)}}})])])]),_vm._v(" "),(_vm.loadingImageShow)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingImageShow),expression:"loadingImageShow"}],class:{ 'loading-image modal fade show d-block': _vm.loadingImageShow }},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-backdrop fade show",attrs:{"id":"recipe-add-to-box___BV_modal_backdrop__jlf62in2"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"create-new-folder"}},[_vm._v("\n              New Folder Name "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-centered"},[_c('img',{attrs:{"src":__webpack_require__(357),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be213d4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_copy_url_to_clipboard_vue__ = __webpack_require__(359);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_copy_url_to_clipboard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be213d4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_copy_url_to_clipboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.url),expression:"url",arg:"copy"}],ref:"button",staticClass:"btn btn-link m-0 p-0 bg-white border-0",attrs:{"type":"button","aria-label":_vm.ariaLabelProp},on:{"click":function($event){return _vm.UrlCopied()}}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"copy-url-message",class:{'visually-hidden-copy-url-message': _vm.updateCopiedMessage === ''},attrs:{"role":"alert"}},[_vm._v("\n        "+_vm._s(_vm.updateCopiedMessage)+"\n    ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c1bb10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_external_script_vue__ = __webpack_require__(361);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_external_script_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c1bb10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_external_script_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ext_script",staticClass:"ext-script-container",attrs:{"id":_vm.idwrapper}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d7a2c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_support_bar_section_vue__ = __webpack_require__(363);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_support_bar_section_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d7a2c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_support_bar_section_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col c-support-bar__section"},[_c('div',{staticClass:"c-support-bar__content"},[_c('h2',{staticClass:"h6 c-support-bar__content-title"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.modalId),expression:"modalId"}],staticClass:"btn btn-link-plain btn--select"},[_c('span',{staticClass:"h6"},[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":_vm.modalId,"visible":false}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e90980b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simple_accordion_vue__ = __webpack_require__(365);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simple_accordion_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e90980b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simple_accordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-simple-accordion",attrs:{"id":[_vm.modalId + '_simple-accordion_']}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.modalId),expression:"modalId"}],staticClass:"btn btn-link-plain",class:[_vm.icon]},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('b-collapse',{attrs:{"id":_vm.modalId,"visible":false}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fca9f42_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_daf_widget_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fca9f42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_daf_widget_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fca9f42_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_daf_widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(368);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("22bdd65d", content, true, {});

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "form label[data-v-0fca9f42]{font-weight:500}p[data-v-0fca9f42]{font-size:.85rem;font-weight:500}", ""]);

// exports


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-promo c-promo--full-width c-promo--border c-promo--shadow h-theme--red"},[_c('form',{directives:[{name:"form-submit",rawName:"v-form-submit"}],attrs:{"action":"","method":"post","name":"dafdirect","id":"dafdirect"}},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 form__content"},[_c('p',[_vm._v("\n                If you have a donor advised fund, DAF Direct enables you to recommend grants to this nonprofit directly from your DAF (as long as your DAF's sponsoring organization is participating).\n            ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.amount),expression:"amount",modifiers:{"number":true}}],staticClass:"text-iput dafdirectInput form-control",attrs:{"name":"dafdirect_amnt","id":"dafdirect_amnt","type":"number","required":""},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-primary btn-block",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_vm._v("Submit")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 form__image mb-3 d-flex justify-content-center align-items-center"},[_c('img',{attrs:{"src":"https://www.dafdirect.org/ddirect/images/logo-DAF-direct2.jpg","alt":"Logo DAF Direct"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dafprovider"}},[_vm._v("Donate now from: "),_c('span',{staticClass:"small text-danger"},[_vm._v("(required)")])]),_vm._v(" "),_c('select',{staticClass:"form-control custom-select btn--select py-0",attrs:{"id":"dafprovider","required":""}},[_c('option',{attrs:{"value":""}},[_vm._v("--Please select--")]),_vm._v(" "),_c('option',{attrs:{"value":"FC"}},[_vm._v("Fidelity Charitable")]),_vm._v(" "),_c('option',{attrs:{"value":"SC"}},[_vm._v("Schwab Charitable")]),_vm._v(" "),_c('option',{attrs:{"value":"BNYM"}},[_vm._v("BNY Mellon")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dafdirect_dsgtxt"}},[_vm._v("Designation:")]),_vm._v(" "),_c('input',{staticClass:"dafdirectInputFull dafdirectInpu form-control",attrs:{"type":"text","name":"dafdirect_dsgtxt","id":"dafdirect_dsgtxt","size":"8","value":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"dafdirect_amnt"}},[_vm._v("Amount: $ "),_c('span',{staticClass:"small text-danger"},[_vm._v("(required)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f0a792e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_collapsable_view_vue__ = __webpack_require__(371);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_collapsable_view_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f0a792e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_collapsable_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"c-collapsible-view"},[(_vm.isVisible)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af098a9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_selection_card_vue__ = __webpack_require__(373);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_selection_card_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af098a9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_selection_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.styles,style:(_vm.transformStyles)},[_c('div',{staticClass:"c-selection-card__content"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.img,"alt":_vm.imgAlt}})]),_vm._v(" "),_c('div',{staticClass:"title-container"},[_c('h2',{staticClass:"title h4",attrs:{"id":("selectionCard-" + _vm.id + "_title")}},[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('transition',{attrs:{"name":"selection-card-hover"}},[_c('div',{class:{'c-selection-card__overlay': true}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('button',{staticClass:"btn btn-round btn-danger"},[_vm._v(_vm._s(_vm._f("upper")(_vm.selected ? _vm.removeButtonText : _vm.buttonText)))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2ab436_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_switch_input_vue__ = __webpack_require__(377);
function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c2ab436"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_switch_input_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c2ab436_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_switch_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(376);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4fc2ae8a", content, true, {});

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-4c2ab436]{background-color:#d22338}.phd-bg--red-alt[data-v-4c2ab436]{background-color:#c0161d}.phd-bg--gray-light[data-v-4c2ab436]{background-color:#f1f1f1}.phd-bg--gray[data-v-4c2ab436]{background-color:#979797}.phd-bg--gray-mid[data-v-4c2ab436]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-4c2ab436]{background-color:#373737}.phd-bg--black[data-v-4c2ab436]{background-color:#000}.phd-bg--black-alt[data-v-4c2ab436]{background-color:#050606}.phd-bg--blue[data-v-4c2ab436]{background-color:#65baf5}.phd-bg--blue-alt[data-v-4c2ab436]{background-color:#034a80}.phd-bg--mustard[data-v-4c2ab436]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-4c2ab436]{background-color:#a7762d}.phd-bg--lime[data-v-4c2ab436]{background-color:#abd02e}.phd-bg--lime-alt[data-v-4c2ab436]{background-color:#6b831c}.phd-bg--seafoam[data-v-4c2ab436]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-4c2ab436]{background-color:#1d7164}.phd-font-color--red[data-v-4c2ab436]{color:#d22338}.phd-font-color--red-alt[data-v-4c2ab436]{color:#c0161d}.phd-font-color--gray-light[data-v-4c2ab436]{color:#f1f1f1}.phd-font-color--gray[data-v-4c2ab436]{color:#979797}.phd-font-color--gray-mid[data-v-4c2ab436]{color:#6d6e71}.phd-font-color--gray-dark[data-v-4c2ab436]{color:#373737}.phd-font-color--black[data-v-4c2ab436]{color:#000}.phd-font-color--black-alt[data-v-4c2ab436]{color:#050606}.phd-font-color--blue[data-v-4c2ab436]{color:#65baf5}.phd-font-color--blue-alt[data-v-4c2ab436]{color:#034a80}.phd-font-color--mustard[data-v-4c2ab436]{color:#f9b146}.phd-font-color--mustard-alt[data-v-4c2ab436]{color:#a7762d}.phd-font-color--lime[data-v-4c2ab436]{color:#abd02e}.phd-font-color--lime-alt[data-v-4c2ab436]{color:#6b831c}.phd-font-color--seafoam[data-v-4c2ab436]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-4c2ab436]{color:#1d7164}.phd-link-color--red[data-v-4c2ab436],.phd-link-color--red[data-v-4c2ab436]:hover{color:#d22338}.phd-link-color--red-alt[data-v-4c2ab436],.phd-link-color--red-alt[data-v-4c2ab436]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-4c2ab436],.phd-link-color--gray-light[data-v-4c2ab436]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-4c2ab436],.phd-link-color--gray[data-v-4c2ab436]:hover{color:#979797}.phd-link-color--gray-mid[data-v-4c2ab436],.phd-link-color--gray-mid[data-v-4c2ab436]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-4c2ab436],.phd-link-color--gray-dark[data-v-4c2ab436]:hover{color:#373737}.phd-link-color--black[data-v-4c2ab436],.phd-link-color--black[data-v-4c2ab436]:hover{color:#000}.phd-link-color--black-alt[data-v-4c2ab436],.phd-link-color--black-alt[data-v-4c2ab436]:hover{color:#050606}.phd-link-color--blue[data-v-4c2ab436],.phd-link-color--blue[data-v-4c2ab436]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-4c2ab436],.phd-link-color--blue-alt[data-v-4c2ab436]:hover{color:#034a80}.phd-link-color--mustard[data-v-4c2ab436],.phd-link-color--mustard[data-v-4c2ab436]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-4c2ab436],.phd-link-color--mustard-alt[data-v-4c2ab436]:hover{color:#a7762d}.phd-link-color--lime[data-v-4c2ab436],.phd-link-color--lime[data-v-4c2ab436]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-4c2ab436],.phd-link-color--lime-alt[data-v-4c2ab436]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-4c2ab436],.phd-link-color--seafoam[data-v-4c2ab436]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-4c2ab436],.phd-link-color--seafoam-alt[data-v-4c2ab436]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-4c2ab436]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-4c2ab436]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-4c2ab436]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-4c2ab436]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-4c2ab436]{background-color:#e71e26}.ecc-bg--loe-br[data-v-4c2ab436]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-4c2ab436]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-4c2ab436]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-4c2ab436]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-4c2ab436]{background-color:#bdd3ea}.ecc-bg--gray[data-v-4c2ab436]{background-color:#ebebeb}.ecc-bg--white[data-v-4c2ab436]{background-color:#fff}.ecc-bg--black[data-v-4c2ab436]{background-color:#000}.ecc-font-color--cor-1[data-v-4c2ab436]{color:#67bf80}.ecc-font-color--cor-2a[data-v-4c2ab436]{color:#ffd643}.ecc-font-color--cor-2b[data-v-4c2ab436]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-4c2ab436]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-4c2ab436]{color:#e71e26}.ecc-font-color--loe-br[data-v-4c2ab436]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-4c2ab436]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-4c2ab436]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-4c2ab436]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-4c2ab436]{color:#bdd3ea}.ecc-font-color--gray[data-v-4c2ab436]{color:#ebebeb}.ecc-font-color--white[data-v-4c2ab436]{color:#fff}.ecc-font-color--black[data-v-4c2ab436]{color:#000}.c-switch-input[data-v-4c2ab436]{display:inline-block;position:relative;vertical-align:middle;font-size:10px;cursor:pointer}.c-switch-input.focused[data-v-4c2ab436]{outline:5px auto -webkit-focus-ring-color;outline-color:-webkit-focus-ring-color;outline-style:auto;outline-width:5px}.c-switch-input input[data-v-4c2ab436]{opacity:0;position:absolute;width:1px;height:1px}.c-switch-input--label[data-v-4c2ab436]{position:absolute;top:0;font-weight:600;color:#fff;z-index:1}.c-switch-input--label.v-left[data-v-4c2ab436]{left:10px}.c-switch-input--label.v-right[data-v-4c2ab436]{right:10px}.c-switch-input--core[data-v-4c2ab436]{display:block;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;outline:0;margin:0;-webkit-transition:border-color .3s,background-color .3s;transition:border-color .3s,background-color .3s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#343a40}.checked .c-switch-input--core[data-v-4c2ab436]{background-color:#c10e21}.c-switch-input--button[data-v-4c2ab436]{display:block;position:absolute;overflow:hidden;top:0;left:0;border-radius:100%;background-color:#fff;z-index:2}.c-switch-input.disabled[data-v-4c2ab436]{pointer-events:none;opacity:.6}legend.c-switch-input-legend[data-v-4c2ab436]{display:inline;margin-right:10px}", ""]);

// exports


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{ref:"wrapper",class:_vm.className,attrs:{"tabindex":"-1","aria-live":"polite"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],ref:"cbk",attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"role":"switch","aria-checked":_vm.checked,"aria-label":_vm.getAriaLabel,"aria-labelledby":_vm.ariaLabelledby,"aria-describedby":_vm.ariaDescribedby},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":[function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}},_vm.toggle],"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false}}}),_vm._v(" "),_c('span',{staticClass:"c-switch-input--core",style:(_vm.coreStyle)},[_c('span',{staticClass:"c-switch-input--button",style:(_vm.buttonStyle)})]),_vm._v(" "),(_vm.showLabels)?[(_vm.checked)?_c('span',{staticClass:"c-switch-input--label v-left",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.onText)+"\n      ")]):_c('span',{staticClass:"c-switch-input--label v-right",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.offText))])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d97cc064_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_selector_vue__ = __webpack_require__(379);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d97cc064_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-card-selector"},[_c('div',{staticClass:"c-card-selector__header"},[_c('h1',{attrs:{"id":"c-card-selector__header-label"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}})]),_vm._v(" "),_c('div',{staticClass:"c-card-selector__filters"},[(!_vm.filters)?_c('div',[_vm._t("filters")],2):_vm._l((_vm.filters),function(item,i){return _c('aha-card-selector-filter',{key:("filter_" + i),attrs:{"title":item.title,"description":item.description,"name":item.name,"checked":_vm.isFiltered(item.name)}})})],2),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"c-card-selector__message"},[_vm._v(_vm._s(_vm.errors[0]))]):_vm._e(),_vm._v(" "),_c('ul',{ref:"cardSelectorNode",staticClass:"c-card-selector__content",attrs:{"role":"listbox","aria-labelledby":"c-card-selector__header-label","aria-multiselectable":"true","tabindex":"-1"}},[_vm._l((_vm.sortedItems),function(item,i){return _c('li',{key:("selector-item_" + i),ref:("selectorItem_" + i),refInFor:true,staticClass:"c-card-selector-item",attrs:{"aria-selected":_vm.isSelected(item.id) ? 'true' : 'false',"id":("selector-item_" + i),"role":"option","active":_vm.focusedItem === item.id,"tabindex":"0"},on:{"mouseover":function($event){_vm.focusedItem = item.id},"mouseleave":function($event){_vm.focusedItem = null},"click":function (evt) { return _vm.toggleItem(evt, item.id); },"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return (function (evt) { return _vm.toggleItem(evt, item.id); }).apply(null, arguments)},"blur":function($event){_vm.focusedItem = null},"focus":function($event){_vm.focusedItem = item.id}}},[_c('aha-selection-card',{attrs:{"id":item.id,"title":item.title,"img":item.img,"imgAlt":item.imgAlt,"description":item.description,"button":item.button,"removeButtonText":item.removeButtonText,"flags":item.flags,"categoryTitle":item.categoryTitle,"mediaTitle":item.mediaTitle,"mediaText":item.mediaText,"mediaLink":item.mediaLink,"mediaLinkTarget":item.mediaLinkTarget,"mediaLinkClass":item.mediaLinkClass,"mediaLinkDescription":item.mediaLinkDescription,"downloadLink":item.downloadLink,"downloadLinkTarget":item.downloadLinkTarget,"downloadLinkClass":item.downloadLinkClass,"downloadButtonText":item.downloadButtonText,"selected":_vm.isSelected(item.id),"active":_vm.focusedItem === item.id,"sortOrder":item.sortOrder}})],1)}),_vm._v(" "),(!_vm.items)?_c('div',[_vm._t("default")],2):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"c-card-selector__actions"},[_vm._t("actions",null,{"valid":_vm.$store.state.selectedIds.length > 0,"submit":_vm.submit,"isFiltered":_vm.isFiltered,"selectedItems":_vm.$store.state.selectedIds})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3420a12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_selector_filter_vue__ = __webpack_require__(381);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_selector_filter_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3420a12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_selector_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-selector-filter row"},[_c('div',{staticClass:"c-selector-filter__wrapper col-md-6 offset-md-3 col-12"},[_c('div',{staticClass:"c-selector-filter__content",attrs:{"id":"tempone"}},[_c('h2',{staticClass:"h4"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"c-selector-filter__input"},[_c('fieldset',[_c('legend',{staticClass:"sr-only",attrs:{"aria-labelledby":"tempone","id":"YouthOpportunities"}},[_vm._v("\n            Switch for youth opportunities.\n            ")]),_vm._v(" "),_c('aha-switch-input',{attrs:{"value":_vm.enabled,"on-text":_vm.onText,"off-text":_vm.offText,"name":_vm.name,"isChecked":_vm.checked,"aria-describedby":"YouthOpportunities"},on:{"change":_vm.changed}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d18abde0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_viewer_vue__ = __webpack_require__(383);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d18abde0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_viewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('div',{ref:"wrapper",class:_vm.contentStyle},[_vm._l((_vm.items),function(item,i){return _c('div',{key:("selectionCard-" + i),staticClass:"c-card-viewer__item"},[_c('aha-selection-card',_vm._b({},'aha-selection-card',Object.assign({}, _vm.cardOptions, item),false)),_vm._v(" "),(_vm.isList)?_c('div',{staticClass:"c-selection-card-details"},[_c('div',{staticClass:"h3"},[_vm._v(_vm._s(item.mediaTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.mediaText))]),_vm._v(" "),_c('div',{staticClass:"card-media-container"},[(item.mediaLink)?_c('div',{staticClass:"card-media",class:item.downloadLink  ? 'card-media--border' : ''},[_c('a',{staticClass:"btn--vol-media-play",class:item.mediaLinkClass,attrs:{"href":item.mediaLink,"target":item.mediaLinkTarget,"tabindex":"0"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Play "),_c('span',{domProps:{"innerHTML":_vm._s(item.mediaLinkDescription)}})])]),_vm._v(" "),_c('div',[(item.mediaLinkDescription)?_c('div',{staticClass:"info small",domProps:{"innerHTML":_vm._s(item.mediaLinkDescription)}}):_vm._e()])]):_vm._e(),_vm._v(" "),(item.downloadLink)?_c('div',{staticClass:"card-action"},[_c('a',{staticClass:"btn btn-round btn-outline-primary",class:item.downloadLinkClass,attrs:{"href":item.downloadLink,"target":item.downloadLinkTarget}},[_vm._v(_vm._s(item.downloadButtonText))])]):_vm._e()])]):_vm._e()],1)}),_vm._v(" "),(!_vm.items)?_c('div',[_vm._t("default",null,{"items":_vm.items,"count":_vm.count})],2):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53d1ec6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_viewer_text_vue__ = __webpack_require__(385);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_card_viewer_text_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53d1ec6c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_card_viewer_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content"},[_vm._t("default",null,{"count":_vm.count,"items":_vm.selectedItems})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccca9e52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_masked_input_vue__ = __webpack_require__(389);
function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_masked_input_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccca9e52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_masked_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(388);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("58325691", content, true, {});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('masked-input',{class:_vm.styleClass,attrs:{"type":"text","name":_vm.name,"mask":['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],"guide":true},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_cpr_search_course_wrapper_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26551639_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_science_volunteer_modal_vue__ = __webpack_require__(392);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_science_volunteer_modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26551639_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_science_volunteer_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-science-volunteer-modal"},[(_vm.modalData.isVolunteer)?_c('div',[_c('aha-modal',{ref:"phdScienceVolunteerModal",attrs:{"id":"phdScienceVolunteerModal","size":"md","hide-footer":"","hide-header":"","centered":"","lazy":""}},[(_vm.modalData.title)?_c('h2',{staticClass:"mb-4",domProps:{"innerHTML":_vm._s(_vm.modalData.title)}}):_vm._e(),_vm._v(" "),_c('b-btn-close',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'phdScienceVolunteerModal', $event.target)}}},[_vm._v("×")]),_vm._v(" "),(_vm.modalData.message)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.modalData.message)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-around mt-4"},[(_vm.modalData.yesRedirect)?_c('a',{staticClass:"btn btn-round btn-primary",attrs:{"href":_vm.modalData.yesRedirect},domProps:{"innerHTML":_vm._s(_vm.modalData.yesLabel)}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-dark",domProps:{"innerHTML":_vm._s(_vm.modalData.noLabel)},on:{"click":function($event){return _vm.$root.$emit('bv::hide::modal', 'phdScienceVolunteerModal', $event.target)}}})])],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b38c3e3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_newsletter_ajax_thank_you_vue__ = __webpack_require__(396);
function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b38c3e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_newsletter_ajax_thank_you_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b38c3e3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_newsletter_ajax_thank_you_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(395);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2fced827", content, true, {});

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".fade-enter-active[data-v-1b38c3e3],.fade-leave-active[data-v-1b38c3e3]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-1b38c3e3],.fade-leave-to[data-v-1b38c3e3]{opacity:.5}", ""]);

// exports


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-newsletter-ajax"},[_c('aha-modal',{ref:"loadingModal",staticClass:"c-loadingModal",attrs:{"size":"md","id":"loadingModal","hide-footer":"","hide-header-close":"","no-close-on-esc":"","no-close-on-backdrop":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"c-loadingModal__heading"},[_vm._v("Submitting")])]),_vm._v(" "),_c('aha-loading-spinner',{attrs:{"is-loading":true}})],2),_vm._v(" "),(_vm.showError)?_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n        "+_vm._s(_vm.errorMsg)+"\n    ")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.toggleShow)?_vm._t("newsletter",null,{"resetForm":_vm.resetForm,"formData":_vm.formData,"submitForm":_vm.submitForm,"response":_vm.response,"toggleShow":_vm.toggleShow}):_vm._t("thankyou",null,{"toggleShow":_vm.toggleShow})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48acc12e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_sitecore_form_wrapper_vue__ = __webpack_require__(400);
function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_sitecore_form_wrapper_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48acc12e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_sitecore_form_wrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(399);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("300c5f09", content, true, {});

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".loader{font-size:8px;position:relative;text-indent:-9999em;border-top:.75em solid pink;border-right:.75em solid pink;border-bottom:.75em solid pink;border-left:.75em solid #c10e21;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation:load8 1.1s infinite linear;animation:load8 1.1s infinite linear}.loader,.loader:after{border-radius:50%;width:5em;height:5em}", ""]);

// exports


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aha-sc-form-container",attrs:{"id":_vm.uuid}},[(_vm.isLoading)?_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratings_widget_star_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratings_widget_star_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratings_widget_star_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratings_widget_star_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratings_widget_star_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d26a79_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ratings_widget_star_vue__ = __webpack_require__(405);
function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79d26a79"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratings_widget_star_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d26a79_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ratings_widget_star_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(403);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("150b545e", content, true, {});

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(722);
exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".c-hero-card__action[data-v-79d26a79]{overflow:hidden}.rate[data-v-79d26a79]{float:left;height:26px;padding:0 0 0 10px;margin-bottom:0}.rate label[data-v-79d26a79]{margin-bottom:0;margin:0 1px}.rate:not(:checked)>input[data-v-79d26a79]{position:absolute;left:-9999px}.rate:checked>label[data-v-79d26a79],.rate:not(:checked)>label[data-v-79d26a79]{float:right;width:1em;overflow:hidden;white-space:nowrap;cursor:pointer;font-size:27px;color:#fff}.rate:not(:checked)>label[data-v-79d26a79]:before{content:url(" + escape(__webpack_require__(404)) + ");position:relative;bottom:2px}.rate>input:checked~label[data-v-79d26a79]{content:url(" + escape(__webpack_require__(148)) + ")}.rate:not(:checked)>label:hover~label[data-v-79d26a79],.rate:not(:checked)>label[data-v-79d26a79]:hover,.rate>input:checked+label:hover~label[data-v-79d26a79],.rate>input:checked+label[data-v-79d26a79]:hover,.rate>input:checked~label:hover~label[data-v-79d26a79],.rate>input:checked~label[data-v-79d26a79]:hover,.rate>label:hover~input:checked~label[data-v-79d26a79]{content:url(" + escape(__webpack_require__(148)) + ")}.flip-cardcontainer[data-v-79d26a79]{position:relative;width:150px;margin-right:5px}.flip-cardimage[data-v-79d26a79]{display:block;width:100%;height:auto}.flip-cardoverlay[data-v-79d26a79]{position:absolute;bottom:1px;left:0;height:100%;width:100%;opacity:0;-webkit-transition:.5s ease;transition:.5s ease;background-color:#fff}.flip-cardcontainer:hover .flip-cardoverlay[data-v-79d26a79],.flip-cardoverlay.focused[data-v-79d26a79]{opacity:1}.flip-cardtext[data-v-79d26a79]{color:#000;font-size:20px;position:relative;top:0;left:68px;width:155px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-align:center}.flip-cardcontainer_averageRating[data-v-79d26a79]{margin-bottom:0}.flip-cardcontainer_averageRating img[data-v-79d26a79]{margin:0 1px}.average[data-v-79d26a79]{position:relative;top:3px}.picked-rating[data-v-79d26a79]{width:150px;background-color:#fff;position:relative;top:28px;padding-bottom:1px;z-index:-1}label[for=star4][data-v-79d26a79],label[for=star5][data-v-79d26a79]{position:relative;right:-3px;top:1px}label[for=star3][data-v-79d26a79]{position:relative;right:-2px;top:1px}label[for=star2][data-v-79d26a79]{position:relative;right:-1px;top:1px}label[for=star1][data-v-79d26a79]{position:relative;right:0;top:1px}.fade-enter-active[data-v-79d26a79],.fade-leave-active[data-v-79d26a79]{-webkit-transition:opacity 1.3s ease;transition:opacity 1.3s ease}.picked-rating p[data-v-79d26a79]{padding:0 5px;line-height:0}.errorMessage[data-v-79d26a79],.votedAlready[data-v-79d26a79]{background-color:#fff;line-height:20px!important}.rate input:checked~label[data-v-79d26a79]{color:#999}.rate input:checked+label[data-v-79d26a79]{color:#036;border-bottom-color:#036}.rate input[type=radio]:focus-visible+label[data-v-79d26a79]{outline:1px auto -webkit-focus-ring-color}.rate input:hover+label[data-v-79d26a79]{border-bottom-style:dotted}.rate:hover input+label[data-v-79d26a79]{color:#036}.rate input:hover~label .rate input[id=star0]+label[data-v-79d26a79]{color:#999}.rate input:hover+label[data-v-79d26a79]{color:#036}.ratingWidget__content-container[data-v-79d26a79]{display:-webkit-box;display:-ms-flexbox;display:flex;padding-bottom:1.5rem}article .picked-rating[data-v-79d26a79]{top:26px;padding-bottom:0;z-index:1}article .picked-rating p[data-v-79d26a79]{position:relative;bottom:5px}article .ratingWidget__content-container[data-v-79d26a79]{padding-bottom:3rem}@media screen and (max-width:768px){.flip-cardtext[data-v-79d26a79]{top:15px}.picked-rating[data-v-79d26a79],article .picked-rating[data-v-79d26a79]{top:46px;padding-bottom:0;z-index:1}.average[data-v-79d26a79]{width:100%}.flip-cardcontainer[data-v-79d26a79]{width:370px;margin-right:0;bottom:10px}article .ratingWidget__content-container[data-v-79d26a79]{padding-bottom:2.5rem}.flip-cardcontainer_averageRating[data-v-79d26a79]{margin-top:10px}}@media screen and (min-width:768px) and (max-width:1024px){.flip-cardcontainer[data-v-79d26a79]{width:210px}.ratingWidget__content-container[data-v-79d26a79]{padding-bottom:2rem}article .ratingWidget__content-container[data-v-79d26a79]{padding-bottom:2.75rem}.picked-rating[data-v-79d26a79],article .picked-rating[data-v-79d26a79]{padding-bottom:0;z-index:1}}", ""]);

// exports


/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNy44NjQiIGhlaWdodD0iMjYuNSIgdmlld0JveD0iMCAwIDI3Ljg2NCAyNi41Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojYzEwZTIxO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTMwLjQzNSwxMi44MDVsLTkuNjI3LTEuNEwxNi41LDIuNjgzLDEyLjIsMTEuNDA2bC05LjYyNywxLjRMOS41MzcsMTkuNiw3Ljg5MiwyOS4xODNsOC42MS00LjUyNyw4LjYxLDQuNTI3TDIzLjQ2OSwxOS42bDYuOTY2LTYuNzlaTTE2LjUsMjIuNWwtNi4wODEsMy4yLDEuMTYxLTYuNzcxLTQuOTE5LTQuOCw2LjgtLjk4OCwzLjA0LTYuMTYsMy4wNCw2LjE2LDYuOC45ODgtNC45MTksNC44TDIyLjU4NCwyNS43LDE2LjUsMjIuNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjU3MSAtMi42ODMpIi8+PC9zdmc+"

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ratingWidget__container"},[_c('div',{staticClass:"ratingWidget__content-container",attrs:{"id":_vm.ratingId}},[_c('div',{staticClass:"flip-cardcontainer"},[_c('p',{staticClass:"flip-cardcontainer_averageRating"},_vm._l((_vm.hearts),function(heart,index){return _c('span',[_c('img',{attrs:{"src":heart,"alt":""}})])}),0),_vm._v(" "),_c('div',{staticClass:"flip-cardoverlay",class:{ focused: _vm.focused }},[_c('div',{staticClass:"flip-cardtext text-center"},[_c('div',{staticClass:"rate",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.ratingPicked($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.picked),expression:"picked",modifiers:{"number":true}}],attrs:{"type":"radio","id":"star5","name":"rate","value":"5","data-rating":"5","aria-label":("" + (_vm.getAriaLabelDetails(5))),"tabindex":_vm.getAriaLabelDetails(5) !== '' ? 0 : -1},domProps:{"checked":_vm._q(_vm.picked,_vm._n("5"))},on:{"focusin":function($event){return _vm.overlayFocused()},"focusout":function($event){return _vm.handleFocusout($event)},"click":function($event){return _vm.ratingPicked($event)},"change":function($event){_vm.picked=_vm._n("5")}}}),_vm._v(" "),_c('label',{attrs:{"for":"star5","title":_vm.fiveStarRating,"tabindex":"-1"}},[_vm._v("rate 5 stars")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.picked),expression:"picked",modifiers:{"number":true}}],attrs:{"type":"radio","id":"star4","name":"rate","value":"4","data-rating":"4","aria-label":("" + (_vm.getAriaLabelDetails(4))),"tabindex":_vm.getAriaLabelDetails(4) !== '' ? 0 : -1},domProps:{"checked":_vm._q(_vm.picked,_vm._n("4"))},on:{"focusin":function($event){return _vm.overlayFocused()},"focusout":function($event){return _vm.handleFocusout($event)},"click":function($event){return _vm.ratingPicked($event)},"change":function($event){_vm.picked=_vm._n("4")}}}),_vm._v(" "),_c('label',{attrs:{"for":"star4","title":_vm.fourStarRating,"tabindex":"-1"}},[_vm._v("rate 4 stars")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.picked),expression:"picked",modifiers:{"number":true}}],attrs:{"type":"radio","id":"star3","name":"rate","value":"3","data-rating":"3","aria-label":("" + (_vm.getAriaLabelDetails(3))),"tabindex":_vm.getAriaLabelDetails(3) !== '' ? 0 : -1},domProps:{"checked":_vm._q(_vm.picked,_vm._n("3"))},on:{"focusin":function($event){return _vm.overlayFocused()},"focusout":function($event){return _vm.handleFocusout($event)},"click":function($event){return _vm.ratingPicked($event)},"change":function($event){_vm.picked=_vm._n("3")}}}),_vm._v(" "),_c('label',{attrs:{"for":"star3","title":_vm.threeStarRating,"tabindex":"-1"}},[_vm._v("rate 3 stars")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.picked),expression:"picked",modifiers:{"number":true}}],attrs:{"type":"radio","id":"star2","name":"rate","value":"2","data-rating":"2","aria-label":("" + (_vm.getAriaLabelDetails(2))),"tabindex":_vm.getAriaLabelDetails(2) !== '' ? 0 : -1},domProps:{"checked":_vm._q(_vm.picked,_vm._n("2"))},on:{"focusin":function($event){return _vm.overlayFocused()},"focusout":function($event){return _vm.handleFocusout($event)},"click":function($event){return _vm.ratingPicked($event)},"change":function($event){_vm.picked=_vm._n("2")}}}),_vm._v(" "),_c('label',{attrs:{"for":"star2","title":_vm.twoStarRating,"tabindex":"-1"}},[_vm._v("rate 2 stars")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.picked),expression:"picked",modifiers:{"number":true}}],attrs:{"type":"radio","id":"star1","name":"rate","value":"1","data-rating":"1","aria-label":("" + (_vm.getAriaLabelDetails(1))),"tabindex":_vm.getAriaLabelDetails(1) !== '' ? 0 : -1},domProps:{"checked":_vm._q(_vm.picked,_vm._n("1"))},on:{"focusin":function($event){return _vm.overlayFocused()},"focusout":function($event){return _vm.handleFocusout($event)},"click":function($event){return _vm.ratingPicked($event)},"change":function($event){_vm.picked=_vm._n("1")}}}),_vm._v(" "),_c('label',{attrs:{"for":"star1","title":_vm.oneStarRating,"tabindex":"-1"}},[_vm._v("rate 1 star")])])]),_vm._v(" "),_c('div',{staticClass:"picked-rating"},[(_vm.hasSubmitted == true)?_c('p',{attrs:{"role":"alert"}},[_vm._v("\n            You rated "+_vm._s(_vm.picked)+" stars\n          ")]):_vm._e(),_vm._v(" "),(_vm.errorFound == true)?_c('p',{staticClass:"errorMessage",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.voteErrorMessage)+"\n          ")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.votedAlready)?_c('p',{staticClass:"votedAlready",attrs:{"role":"alert"}},[_vm._v("\n              You've already voted once\n            ")]):_vm._e()])],1)])]),_vm._v(" "),_c('div',{staticClass:"average"},[(_vm.ratingTotal >= 1)?_c('span',[_c('span',{staticClass:"averageRating"},[_vm._v(_vm._s(_vm.avgRating.toFixed(1))+" out of 5 stars")]),_vm._v("\n        | "+_vm._s(_vm.ratingTotal)+" ratings\n      ")]):_c('span',[_vm._v(_vm._s(_vm.rateMessage))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5737992_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_carousel_vue__ = __webpack_require__(407);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5737992_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"carousel",attrs:{"id":"myCarousel","aria-roledescription":"carousel","aria-label":"Highlighted television shows"}},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"controls"},[_c('button',{staticClass:"rotation pause",attrs:{"type":"button","aria-label":"Stop automatic slide show"}},[_c('svg',{attrs:{"width":"42","height":"34","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticClass:"background",attrs:{"x":"2","y":"2","rx":"5","ry":"5","width":"38","height":"24"}}),_vm._v(" "),_c('rect',{staticClass:"border",attrs:{"x":"4","y":"4","rx":"5","ry":"5","width":"34","height":"20"}}),_vm._v(" "),_c('polygon',{staticClass:"pause",attrs:{"points":"17 8 17 20"}}),_vm._v(" "),_c('polygon',{staticClass:"pause",attrs:{"points":"24 8 24 20"}}),_vm._v(" "),_c('polygon',{staticClass:"play",attrs:{"points":"15 8 15 20 27 14"}})])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"previous",attrs:{"type":"button","aria-controls":"myCarousel-items","aria-label":"Previous Slide"}},[_c('i',{staticClass:"icon-left-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"next",attrs:{"type":"button","aria-controls":"myCarousel-items","aria-label":"Next Slide"}},[_c('i',{staticClass:"icon-right-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-items",attrs:{"id":"myCarousel-items","aria-live":"off"}},[_c('div',{staticClass:"carousel-item active",attrs:{"role":"group","aria-roledescription":"slide","aria-label":"1 of 6"}},[_c('div',{staticClass:"col-md-5 mb-3 mb-md-0"},[_c('div',{staticClass:"carousel-image"},[_c('div',{staticClass:"c-video__media-container"},[_c('button',{staticClass:"c-video__media h-video-play h-placeholder-image h-placeholder-image--5-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placeimg.com/360/240/any","alt":"","data-lazy-img-loading":"//placeimg.com/360/240/any"}})])]),_vm._v(" "),_c('div',{staticClass:"c-modal--youtube"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('h2',{staticClass:"h3"},[_vm._v("Nancy Williams")]),_vm._v(" "),_c('p',[_vm._v("\"Fusce pulvinar facilisis nisi, id imperdiet ipsum volutpat dapibus. Donec at felis a arcu ultricies dignissim. Sed tincidunt libero ac eleifend consequat. Mauris massa lectus, euismod at rutrum sed, pellentesque eget lectus. Etiam faucibus dui ut nibh dapibus suscipit. Nullam lacus tellus, varius vitae sapien sagittis, sodales blandit risus. Praesent dignissim sit amet sem eu efficitur. Curabitur eu arcu aliquet, ultricies libero nec, elementum justo.\"")]),_vm._v(" "),_c('a',{staticClass:"c-cta c-cta--arrow h-theme--aqua-alt",attrs:{"href":"#"}},[_vm._v("Read Her Story")])])]),_vm._v(" "),_c('div',{staticClass:"carousel-item",attrs:{"role":"group","aria-roledescription":"slide","aria-label":"2 of 6"}},[_c('div',{staticClass:"col-md-5 mb-3 mb-md-0"},[_c('div',{staticClass:"carousel-image"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":"https://via.placeholder.com/150","alt":"Land's End in Cornwall"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('h2',{staticClass:"h3"},[_vm._v("Frank Williams")]),_vm._v(" "),_c('p',[_vm._v("\"Fusce pulvinar facilisis nisi, id imperdiet ipsum volutpat dapibus. Donec at felis a arcu ultricies dignissim. Sed tincidunt libero ac eleifend consequat. Mauris massa lectus, euismod at rutrum sed, pellentesque eget lectus. Etiam faucibus dui ut nibh dapibus suscipit. Nullam lacus tellus, varius vitae sapien sagittis, sodales blandit risus. Praesent dignissim sit amet sem eu efficitur. Curabitur eu arcu aliquet, ultricies libero nec, elementum justo.\"")]),_vm._v(" "),_c('a',{staticClass:"c-cta c-cta--arrow h-theme--aqua-alt",attrs:{"href":"#"}},[_vm._v("Read Her Story")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3be28701_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_grocery_list_vue__ = __webpack_require__(409);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3be28701_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_grocery_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-grocery-list"},[_c('div',{staticClass:"d-flex flex-column flex-md-row justify-content-between"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length),expression:"items.length"}],staticClass:"view__container order-1 d-print-none"},[_c('ul',{staticClass:"filters list-unstyled list-inline"},[_vm._m(0),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.visibility = 'all'; _vm.showFilterBtnStyle()}}},[_vm._v("All")])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.visibility = 'active'; _vm.showFilterBtnStyle()}}},[_vm._v("Active")])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.visibility = 'completed'; _vm.showFilterBtnStyle()}}},[_vm._v("Completed")])])])]),_vm._v(" "),_c('div',{staticClass:"h3 mt-3"},[_vm._v("Items:"),_c('aha-grocery-count')],1)]),_vm._v(" "),_vm._t("header"),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length === 0),expression:"items.length === 0"}]},[_vm._t("error",function(){return [_c('h2',{staticClass:"text-primary"},[_vm._v("No items found.")])]})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length),expression:"items.length"}],staticClass:"c-grocery-list__container"},[_c('div',{staticClass:"completed__container d-flex justify-content-between d-print-none"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allDone),expression:"allDone"}],staticClass:"toggle-all",attrs:{"type":"checkbox","id":"toggle-all"},domProps:{"checked":Array.isArray(_vm.allDone)?_vm._i(_vm.allDone,null)>-1:(_vm.allDone)},on:{"change":function($event){var $$a=_vm.allDone,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.allDone=$$a.concat([$$v]))}else{$$i>-1&&(_vm.allDone=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.allDone=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"toggle-all"},on:{"click":_vm.checkAll}},[_vm._v(_vm._s(_vm.checked))]),_vm._v(" "),_c('button',{staticClass:"btn clear-completed",on:{"click":function($event){$event.preventDefault();return _vm.removeCompleted.apply(null, arguments)}}},[_vm._v("Clear Completed")])]),_vm._v(" "),_c('ul',{staticClass:"grocery-list list-unstyled"},_vm._l((_vm.filteredItems),function(item){return _c('li',{key:item.id,class:{completed: item.completed}},[_c('div',{staticClass:"view"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.completed),expression:"item.completed"}],staticClass:"toggle",attrs:{"id":item.id,"type":"checkbox"},domProps:{"checked":Array.isArray(item.completed)?_vm._i(item.completed,null)>-1:(item.completed)},on:{"click":_vm.checkAllItems,"change":function($event){var $$a=item.completed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "completed", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "completed", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "completed", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":item.id}},[_vm._v(_vm._s(item.ProductName))]),_vm._v(" "),_c('button',{staticClass:"destroy d-print-none",on:{"click":function($event){return _vm.removeItem(item)}}})])])}),0)])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-inline-item"},[_c('span',[_vm._v("View:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85604068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_grocery_count_vue__ = __webpack_require__(411);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_grocery_count_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85604068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_grocery_count_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n    "+_vm._s(_vm.count)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_contestant_grid_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_contestant_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_contestant_grid_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_contestant_grid_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_contestant_grid_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32634c12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_contestant_grid_vue__ = __webpack_require__(419);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_contestant_grid_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32634c12_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_contestant_grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_header_vue__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb7e15f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contestant_grid_header_vue__ = __webpack_require__(414);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb7e15f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contestant_grid_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center c-contestant-header"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('h3',{staticClass:"c-contestant-header__title"},[_vm._v("\n            "+_vm._s(_vm.hasContendersPresent ? _vm.contestantGridHeading : _vm.contestNotactiveText)+"\n        ")])]),_vm._v(" "),(_vm.hasContendersPresent && !_vm.hideSearchbox)?_c('div',{staticClass:"col-12 offset-md-3 col-md-3"},[_c('div',{staticClass:"position-relative"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control c-contestant-header__autocomplete",attrs:{"type":"text","placeholder":_vm.searchboxText},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"close-icon d-block position-absolute",attrs:{"tabindex":_vm.search ? '0' : '-1',"role":"button","aria-label":"Reset the search results"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.selectResult('')},"click":function($event){return _vm.selectResult('')}}},[_c('i',{staticClass:"icon-times"})]),_vm._v(" "),(_vm.search || _vm.hasShowUpdatedSearchedResult)?_c('p',{staticClass:"sr-only",attrs:{"role":"alert"}},[_vm._v("\n                    "+_vm._s(_vm.updatedSearchedResult)+"\n                ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.hasContendersPresent && !_vm.hideGreybar)?_c('div',{staticClass:"col-12"},[_c('hr',{staticClass:"divider mb-0"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7312939b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contestant_grid_vue__ = __webpack_require__(416);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7312939b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contestant_grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row m-0"},_vm._l((_vm.sortedContendersList),function(item){return _c('div',{key:item.id,staticClass:"col-sm-12 col-md-6 col-lg-4 col-xl-3 px-2 my-4"},[_c('div',{staticClass:"c-contestant__card text-center border-0 position-relative"},[_c('div',{staticClass:"c-contestant__card-header card-header p-0"},[_c('img',{staticClass:"card-img",attrs:{"src":item.ImageUrl,"alt":"alt text"}})]),_vm._v(" "),_c('div',{staticClass:"card-body pb-0 px-0"},[_c('h4',{staticClass:"mb-0"},[_c('a',{staticClass:"c-contestant__card-title text-bold",attrs:{"href":item.PageUrl}},[_vm._v("\n                        "+_vm._s(item.fullName)+"\n                    ")])]),_vm._v(" "),_c('p',{staticClass:"card-text m-0 pt-2 c-contestant__card-description"},[_vm._v("\n                    "+_vm._s(item.NomineeTitle)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"c-contestant__card-footer card-footer py-0"},[(item.VoteTotal)?_c('p',{staticClass:"mt-1 mb-0 c-contestant__card-votes-count"},[_vm._v("\n                    "+_vm._s(item.VoteTotal)+" "+_vm._s(item.VoteTotal === 1 ? _vm.voteText : _vm.votesText)+"\n                ")]):_vm._e(),_vm._v(" "),(item.VoteAllowed)?_c('a',{staticClass:"btn btn-round btn-outline-primary mt-3",attrs:{"href":item.PageUrl,"aria-label":("" + (item.VoteNowFor))}},[_vm._v("\n                    "+_vm._s(_vm.voteNowLabel)+"\n                ")]):_vm._e()])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_pagination_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_pagination_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_pagination_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_pagination_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067c5670_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contestant_grid_pagination_vue__ = __webpack_require__(418);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contestant_grid_pagination_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067c5670_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contestant_grid_pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-contestant-pagination my-5"},[_c('nav',{attrs:{"role":"navigation","aria-label":"Pagination","aria-hidden":"false"}},[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count"},[(_vm.currentPage !== 1)?_c('li',{staticClass:"page-item mx-2"},[_c('button',{staticClass:"page-link",attrs:{"type":"button","role":"button","aria-label":"Previous Page","tabindex":"0"},on:{"click":function($event){return _vm.setPreviousPage()}}},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous Page")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.pages),function(pageNumber){return _c('li',{staticClass:"page-item mx-2"},[_c('button',{staticClass:"page-link font-weight-normal",class:{'active': _vm.currentPage === pageNumber },attrs:{"type":"button","role":"button","tabindex":"0","aria-current":("" + (_vm.currentPage === pageNumber && 'page')),"aria-selected":_vm.currentPage === pageNumber ? 'true' : 'false',"aria-label":("Page " + pageNumber)},on:{"click":function($event){return _vm.setCurrentPage(pageNumber)}}},[_vm._v("\n                        "+_vm._s(pageNumber)+"\n                    ")])])}),_vm._v(" "),(_vm.currentPage !== _vm.totalPages)?_c('li',{staticClass:"page-item mx-2"},[_c('button',{staticClass:"page-link",attrs:{"type":"button","role":"button","tabindex":"0","aria-label":"Next Page"},on:{"click":_vm.setNextPage}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next Page")])])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"sr-only",attrs:{"aria-live":"polite"}},[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewContestantGrid",staticClass:"my-5"},[_c('div',{staticClass:"container"},[_c('ContestantGridHeader',{attrs:{"contestantGridHeading":_vm.contestantGridHeading,"contendersList":_vm.contendersList,"contestNotactiveText":_vm.isError ? _vm.contestNotactiveText : '',"searchboxText":_vm.searchboxText,"hideSearchbox":JSON.parse(_vm.hideSearchbox.toLowerCase()),"hideGreybar":JSON.parse(_vm.hideGreybar.toLowerCase()),"updatedSearchedContenderList":_vm.updatedSearchedContenderList},on:{"setSearchResult":function($event){return _vm.setSearchResult($event)}}}),_vm._v(" "),_c('span',{ref:"focus",staticClass:"sr-only",attrs:{"tabindex":"-1","aria-hidden":"true"}}),_vm._v(" "),_c('ContestantGrid',{attrs:{"search":_vm.search,"voteNowLabel":_vm.voteNowLabel,"votesText":_vm.votesText,"voteText":_vm.voteText,"contendersList":_vm.contendersList,"currentPageNo":_vm.currentPageNo,"showNumberOfContendersPerPage":+_vm.pageSize},on:{"getPaginationDetails":function($event){return _vm.getPaginationDetails($event)},"updatedSearchedResults":function($event){return _vm.updatedSearchedResults($event)}}}),_vm._v(" "),(_vm.numberOfPagesArray.length >= 2)?_c('ContestantGridPagination',{attrs:{"numberOfPagesArray":_vm.numberOfPagesArray,"currentPageNo":_vm.currentPageNo,"contendersList":_vm.contendersList,"pageSize":+_vm.pageSize},on:{"setCurrentActivePage":function($event){return _vm.setCurrentActivePage($event)}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filter = undefined;

var _pluralize = __webpack_require__(723);

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var filter = exports.filter = function filter(value, number) {
    return (0, _pluralize2['default'])(value, number);
};
exports['default'] = filter;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaUtils = __webpack_require__(32);

var state = new WeakMap();
var resizeEvent = 'resize';

exports['default'] = {
    bind: function bind(el) {
        state.set(el, {
            resizeEventListener: null
        });
    },
    inserted: function inserted(el, directive, vnode) {
        var data = state.get(el);
        var resizeEventHandler = (0, _ahaUtils.debounce)(function () {
            // hardcoding for now unless we find another use-case
            if (window.innerWidth < 992) {
                el.style.top = 'auto';
                el.style.marginTop = 'auto';
            } else {
                el.style.top = '50%';
                el.style.marginTop = '-' + el.clientHeight / 2 + 'px';
            }
        }, 50);

        data.resizeEventListener = resizeEventHandler;
        window.addEventListener(resizeEvent, resizeEventHandler);
        resizeEventHandler();

        vnode.context.$on('v-vertical-align-reset', function () {
            resizeEventHandler();
        });
    },
    unbind: function unbind(el) {
        var data = state.get(el);

        window.removeEventListener(resizeEvent, data.resizeEventListener);
    }
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LazyImgInitial = 'is-loading';
var LazyImgLoaded = 'is-loaded';

exports['default'] = {
    inserted: function inserted(el, binding) {
        var img = new Image();

        el.setAttribute('data-lazy-img-loading', binding.value);
        el.classList.add(LazyImgInitial);

        img.src = binding.value;

        img.onload = function () {
            el.src = binding.value;

            el.classList.remove(LazyImgInitial);
            el.classList.add(LazyImgLoaded);
        };
    }
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    inserted: function inserted(el, binding) {
        var isChecked = false;

        el.setAttribute('role', 'checkbox');
        el.setAttribute('aria-checked', 'false');
        el.setAttribute('tabindex', 0);

        el.addEventListener('click', function () {
            toggleChecked();
        });

        el.addEventListener('keypress', function (evt) {
            if (evt.keyCode === 13) {
                toggleChecked();
            }
        });

        function toggleChecked() {
            isChecked = !isChecked;
            el.classList.toggle('is-checked');

            el.setAttribute('aria-checked', isChecked.toString());
            if (binding.modifiers.event) {
                _inputEventbus2['default'].$emit('toggle-checked', el.value, el.id, el);
            }
        }
    }
};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inserted: function inserted(el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            this.classList.toggle('active');

            var isPressed = this.getAttribute('aria-pressed') === 'true';
            this.setAttribute('aria-pressed', !isPressed);
        });
    }
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ahaUtils = __webpack_require__(32);

var _perfectScrollbar = __webpack_require__(724);

var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var state = new WeakMap();
var resizeEvent = 'resize';

exports['default'] = {
    bind: function bind(el) {
        state.set(el, {
            resizeEventListener: null,
            scrollbar: null
        });
    },
    inserted: function inserted(el, directive, vnode) {
        var data = state.get(el);

        var resizeEventHandler = (0, _ahaUtils.debounce)(function () {
            if (window.outerWidth >= 576 && data.scrollbar === null) {
                data.scrollbar = new _perfectScrollbar2['default'](el, {
                    suppressScrollY: true,
                    wheelPropagation: true,
                    wheelSpeed: 0.4
                });
            }

            if (window.outerWidth < 576 && data.scrollbar !== null) {
                data.scrollbar.destroy();
            }
        }, 100);

        data.resizeEventListener = resizeEventHandler;

        window.addEventListener(resizeEvent, resizeEventHandler);
        resizeEventHandler();
    },
    unbind: function unbind(el) {
        var data = state.get(el);

        window.removeEventListener(resizeEvent, data.resizeEventListener);

        if (data.scrollbar !== null) {
            data.scrollbar.destroy();
            data.scrollbar = null; // to make sure garbages are collected
        }
    }
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inserted: function inserted(el, binding) {
        var url = el.getAttribute('href');

        el.addEventListener('click', function (event) {
            event.preventDefault();
            window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=585,height=511');
        });
    }
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(18);

exports['default'] = {
    bind: function bind(el, binding, vnode) {
        var targetHref = void 0;
        var isModalShowing = false;

        if (el.tagName === 'A') {
            targetHref = el.getAttribute('href');
        } else {
            targetHref = el.getAttribute('target-href');
            el.setAttribute('tabindex', '0');
        }

        el.addEventListener('click', function (evt) {
            evt.preventDefault();

            isModalShowing = true;
            vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
        });

        el.addEventListener('keypress', function (evt) {
            evt.preventDefault();

            if (evt.keyCode === _utils.KeyCodes.ENTER) {
                isModalShowing = true;
                vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
            }
        });

        vnode.context.$root.$on('bv::modal::show', function (evt) {
            if (isModalShowing) {
                if (window.activeSpeedBumpLink) {
                    var speedBumpLink = document.querySelector('#speed-bump-link');

                    setModalContent(evt.vueTarget.$vnode.context.$refs, speedBumpLink.getAttribute('href'));
                } else {
                    setModalContent(evt.vueTarget.$vnode.context.$refs, targetHref);
                }
            }
        });

        vnode.context.$root.$on('bv::modal::hide', function (evt) {
            if (isModalShowing) {
                isModalShowing = false;
                setModalContent(evt.vueTarget.$vnode.context.$refs, '');
            }
        });

        vnode.context.$root.$on('bv::modal::hidden', function (evt) {
            if (window.activeSpeedBumpLink) {
                window.activeSpeedBumpLink.focus();
                window.activeSpeedBumpLink = null;
            }
        });

        if (el.tagName !== 'BUTTON') {
            // If element is not a button, we add `role="button"` for accessibility
            el.setAttribute('role', 'button');
        }

        function setModalContent(refs, value) {
            var text = refs['speed-bump-text'];
            var href = refs['speed-bump-link'];

            if (text) {
                if (value.length > 120) {
                    text.innerHTML = value.substring(0, 120) + '...';
                } else {
                    text.innerHTML = value;
                }
            }

            if (href) {
                href.setAttribute('href', value);

                href.addEventListener('click', function () {
                    setTimeout(function () {
                        vnode.context.$root.$emit('bv::hide::modal', 'speed-bump-modal');
                    }, 250);
                });
            }
        }
    }
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(18);

var _tlsAvailable = __webpack_require__(429);

exports['default'] = {
    bind: function bind(el, binding, vnode) {
        var targetHref = void 0;
        var isModalShowing = false;

        el.addEventListener('click', function (evt) {
            targetHref = el.getAttribute('href');

            if (!(0, _tlsAvailable.isTlsAvailable)() && targetHref.match(/sso\.heart\.org/)) {
                evt.preventDefault();

                isModalShowing = true;
                vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
            }
        });

        el.addEventListener('keypress', function (evt) {
            evt.preventDefault();

            if (evt.keyCode === _utils.KeyCodes.ENTER) {
                isModalShowing = true;
                vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
            }
        });

        vnode.context.$root.$on('bv::modal::hide', function (evt) {
            if (isModalShowing) {
                isModalShowing = false;
            }
        });

        vnode.context.$root.$on('bv::modal::hidden', function (evt) {
            if (window.activeSssoIntercept) {
                window.activeSssoIntercept.focus();
                window.activeSssoIntercept = null;
            }
        });

        if (el.tagName !== 'BUTTON') {
            // If element is not a button, we add `role="button"` for accessibility
            el.setAttribute('role', 'button');
        }
    }
};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isTlsAvailable = isTlsAvailable;

var _ahaUtils = __webpack_require__(32);

function isTlsAvailable() {
    var browser = (0, _ahaUtils.browserDetails)();
    var isSecure = true;

    switch (browser.name) {
        case 'Chrome':
            if (browser.mobile) {
                if (browser.version < 4.1) {
                    isSecure = false;
                }
            } else {
                if (browser.version < 31) {
                    isSecure = false;
                }
            }

            break;

        case 'Safari':
            if (browser.mobile) {
                if (browser.version < 5) {
                    isSecure = false;
                }
            } else {
                if (browser.version < 7) {
                    isSecure = false;
                }
            }

            break;

        case 'MSIE':
            if (browser.mobile) {
                if (browser.version < 10) {
                    isSecure = false;
                }
            } else {
                if (browser.version < 10) {
                    isSecure = false;
                }
            }

            break;

        case 'Opera':
            if (browser.version < 10) {
                isSecure = false;
            }

            break;

        case 'Firefox':
            if (browser.version < 24) {
                isSecure = false;
            }

            break;
    }

    return isSecure;
}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _printd = __webpack_require__(725);

exports['default'] = {
    inserted: function inserted(el, binding) {
        el.addEventListener('click', function (evt) {
            evt.preventDefault();

            var printElement = document.getElementById(binding.value);
            var d = new _printd.Printd();

            // Styling to enable background graphics on printed grocery list so that user can see checkboxes
            var cssText = '\n                #grocery-list-print-section {\n                    -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */\n                    color-adjust: exact !important;                 /*Firefox*/\n                }\n            ';

            var styles = ['https://www.heart.org/dist/common/app.css', 'https://www.heart.org/dist/common/vendor.css', cssText];
            d.print(printElement, styles);
        });
    }
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _registerEvent = __webpack_require__(77);

var _registerEvent2 = _interopRequireDefault(_registerEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    inserted: function inserted(el, binding) {
        var itemId = el.getAttribute('event-item-id');
        var text = el.getAttribute('event-text');
        var datasourceId = el.getAttribute('event-datasource-id');

        el.addEventListener('click', function (evt) {
            _registerEvent2['default'].post(itemId, text, datasourceId);
        });
    }
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/** Date: 4/7/2019*/
/*RQI form with 1 required checkboxes checked*/
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {

        var forms = el;
        var button = forms.querySelector('[type=submit]');
        var required = forms.querySelectorAll('input[required="required"]');
        var telephone = forms.querySelectorAll('input[type="tel"]:required, [id^=phone]:required');
        var phoneFormat = RegExp(/^(\d{3})-(\d{3})-(\d{4})$/);
        var zipFormat = RegExp(/^\d{5}$|^\d{5}-\d{4}$/);
        button.disabled = true;

        forms.onsubmit = function (event) {
            // Safari fix
            event.preventDefault();
            if (vnode.context.$root.$el.querySelector('.c-loadingModal')) {
                vnode.context.$root.$emit('bv::show::modal', 'loadingModal');
            }
            // Safari fix
            setTimeout(function () {
                HTMLFormElement.prototype.submit.call(event.target);
                // forms.submit();
            }, 500);
        };

        var validateForm = function validateForm(el) {
            if (el && el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el && el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }

            if (forms.checkValidity() === false) {
                button.disabled = true;
            } else {
                button.disabled = false;
            }
        };

        // Email validation message
        var validateEmail = function validateEmail(el) {
            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && el.nextElementSibling.classList.contains('invalid-feedback')) {
                    el.nextElementSibling.classList.toggle('d-block');
                }
            }
            // email validation for doctor quiz 
        };

        // Telephone validation message
        var validatePhone = function validatePhone(el) {
            if (el.value.length === 0) {
                el.setCustomValidity('');
            }

            var isFormatted = phoneFormat.test(el.value);

            if (isFormatted) {
                el.setCustomValidity('');
            } else if (el.value.length > 0) {
                el.setCustomValidity('Please provide a valid Phone.');
            }

            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        };

        var validateZip = function validateZip(el) {
            var isFormatted = zipFormat.test(el.value);

            if (isFormatted) {
                el.setCustomValidity('');
            } else {
                el.setCustomValidity('Zipcode Required.');
            }

            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var req = _step.value;

                req.addEventListener('change', function (evt) {
                    if (req.required === true) {
                        validateEmail(req);
                    }
                    validateForm();
                });
            };

            for (var _iterator = required[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator['return']) {
                    _iterator['return']();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            var _loop2 = function _loop2() {
                var form = _step2.value;

                form.addEventListener('input', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else {
                        form.setCustomValidity('');
                    }
                    if (form.required === true && form.id.startsWith('zipcode')) {
                        validateZip(form);
                    }
                    // For non-required zip code in course search component
                    if (form.id === 'zipcode' && form.value.length > 0) {
                        validateZip(form);
                    }
                    validateForm(form);
                });

                form.addEventListener('blur', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else {
                        form.setCustomValidity('');
                    }
                    if (form.required === true && form.id.startsWith('zipcode')) {
                        validateZip(form);
                    }
                    // For non-required zip code in course search component
                    if (form.id === 'zipcode' && form.value.length > 0) {
                        validateZip(form);
                    }
                    validateForm(form);
                });

                form.addEventListener('change', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else if (form.required === true && form.value.length > 0) {
                        form.setCustomValidity('');
                    }
                    validateForm(form);
                });
            };

            for (var _iterator2 = forms[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop2();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                    _iterator2['return']();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = telephone[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var tel = _step3.value;

                tel.addEventListener('blur', function (evt) {
                    validatePhone(evt.target);
                    validateForm();
                });
            }

            // Check form on load
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                    _iterator3['return']();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        validateForm();
    }
};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/* Vue directive to validate all required fields with error messages */
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {

        var forms = el;
        var button = forms.querySelector('[type=submit]');
        var required = forms.querySelectorAll('input[required="required"]');
        var telephone = forms.querySelectorAll('input[type="tel"], [id^=phone]');
        var phoneFormat = RegExp(/^(\d{3})-(\d{3})-(\d{4})$/);
        var zipFormat = RegExp(/^\d{5}$|^\d{5}-\d{4}$/);
        button.disabled = true;

        var validateForm = function validateForm(el) {
            if (el && el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el && el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }

            if (forms.checkValidity() === false) {
                button.disabled = true;
            } else {
                button.disabled = false;
            }
        };

        // Email validation message
        var validateEmail = function validateEmail(el) {
            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && el.nextElementSibling.classList.contains('invalid-feedback')) {
                    el.nextElementSibling.classList.toggle('d-block');
                }
            }
            // email validation for doctor quiz 
        };

        // Telephone validation message
        var validatePhone = function validatePhone(el) {
            if (el.value.length === 0) {
                el.setCustomValidity('');
            }

            var isFormatted = phoneFormat.test(el.value);

            if (isFormatted) {
                el.setCustomValidity('');
            } else if (el.value.length > 0) {
                el.setCustomValidity('Please provide a valid Phone.');
            }

            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        };

        var validateZip = function validateZip(el) {
            var isFormatted = zipFormat.test(el.value);

            if (isFormatted) {
                el.setCustomValidity('');
            } else {
                el.setCustomValidity('Zipcode Required.');
            }

            if (el.validity.valid === false) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.add('d-block');
                }
            }

            if (el.validity.valid === true) {
                if (el.nextElementSibling !== null && (el.nextElementSibling.classList.contains('invalid-feedback') || el.nextElementSibling.classList.contains('Invalid-Feedback'))) {
                    el.nextElementSibling.classList.remove('d-block');
                }
            }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var req = _step.value;

                req.addEventListener('change', function (evt) {
                    if (req.required === true) {
                        validateEmail(req);
                    }
                    validateForm();
                });
            };

            for (var _iterator = required[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator['return']) {
                    _iterator['return']();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            var _loop2 = function _loop2() {
                var form = _step2.value;

                form.addEventListener('input', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else {
                        form.setCustomValidity('');
                    }
                    if (form.required === true && form.id.startsWith('zipcode')) {
                        validateZip(form);
                    }
                    // For non-required zip code in course search component
                    if (form.id === 'zipcode' && form.value.length > 0) {
                        validateZip(form);
                    }
                    validateForm(form);
                });

                form.addEventListener('blur', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else {
                        form.setCustomValidity('');
                    }
                    if (form.required === true && form.id.startsWith('zipcode')) {
                        validateZip(form);
                    }
                    // For non-required zip code in course search component
                    if (form.id === 'zipcode' && form.value.length > 0) {
                        validateZip(form);
                    }
                    validateForm(form);
                });

                form.addEventListener('change', function (evt) {
                    if (form.required === true && form.value === '') {
                        form.setCustomValidity('Please provide a valid response.');
                    } else if (form.required === true && form.value.length > 0) {
                        form.setCustomValidity('');
                    }
                    validateForm(form);
                });
            };

            for (var _iterator2 = forms[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _loop2();
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                    _iterator2['return']();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = telephone[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var tel = _step3.value;

                tel.addEventListener('blur', function (evt) {
                    validatePhone(evt.target);
                    validateForm();
                });
            }

            // Check form on load
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                    _iterator3['return']();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        validateForm();
    }
};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/** Date: 4/7/2019*/
/*RQI form with 1 required checkboxes checked*/
exports['default'] = {
    inserted: function inserted(el) {
        var button = el.querySelector('[type=submit]');
        var requiredEls = el.querySelectorAll('input:required,select:required');
        var requiredCheckboxes = el.querySelectorAll('input[type="checkbox"]');

        button.disabled = true;

        if (requiredEls.length > 0) {
            (function () {

                var checkFormValidity = function checkFormValidity() {

                    var isFormValid = false;

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = requiredEls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var requiredEl = _step.value;

                            if (requiredEl.validity.valid === true && checkBoxesValidation() !== false) {
                                isFormValid = true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator['return']) {
                                _iterator['return']();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    button.disabled = !isFormValid;
                };

                // ---

                var checkBoxesValidation = function checkBoxesValidation() {
                    var checkedOne = Array.prototype.slice.call(requiredCheckboxes).some(function (x) {
                        return x.checked;
                    });
                    return checkedOne;
                };

                // ---

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = requiredEls[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var requiredEl = _step2.value;

                        requiredEl.addEventListener('input', function (evt) {
                            checkFormValidity();
                        });
                    }

                    // ---
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                            _iterator2['return']();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = requiredCheckboxes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var cb = _step3.value;

                        cb.addEventListener('change', function (evt) {
                            checkFormValidity();
                        });
                    }

                    // Check form on load
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                            _iterator3['return']();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                checkFormValidity();
            })();
        }
    }
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    bind: function bind(el) {
        el.addEventListener('click', function (e) {
            var buttonClicked = e.target;
            // get the value of the data attribute of the button clicked and store it in a variable for later use
            // const buttonClickedValue = buttonClicked.getAttribute('aria-expanded');
            // get the value of the data attribute of the button collapse text
            var buttonCollapseTextValue = buttonClicked.getAttribute('data-collapse-text');
            // get the value of the data attribute of the button expand text
            var buttonExpandTextValue = buttonClicked.getAttribute('data-expand-text');
            // get the content element that is related to the button clicked and has the class fixed-image and store it in a variable for later use
            var contentElementFixedImage = e.target.parentElement;
            // // get the parent element of contentElementFixedImage and store it in a variable for later use
            var contentElement = contentElementFixedImage.parentElement;
            // //get the parent element of contentElement and store it in a variable for later use
            var contentElementParent = contentElement.parentElement;
            // // get the sibling element of contentElementParent and store it in a variable for later use
            var contentElementSibling = contentElementParent.parentElement;
            // get the content element that has the class fixed-image and store it in a variable for later use
            var contentElementFixedImageSibling = contentElementSibling.querySelector('.image-fixed');
            // console.log(contentElementSibling)

            if (buttonClicked.innerHTML.trim() === buttonExpandTextValue) {
                var _contentElement = buttonClicked.previousElementSibling;
                _contentElement.classList.add('show');
                // console.log(contentElement, contentElement.classList)
                //add class 'expanded-text' to c-promo
                contentElementParent.classList.add('expanded-text');
                // //change the text of the button to 'Expand to see more'
                buttonClicked.innerHTML = buttonCollapseTextValue || 'Collapse to see less';

                if (window.innerWidth > 425 && buttonClicked.innerHTML.trim() === buttonCollapseTextValue) {
                    contentElementFixedImageSibling.style.position = 'sticky';
                    contentElementFixedImageSibling.style.top = '70px';
                    contentElementFixedImageSibling.classList.add('img-expanded-pos');
                    console.log('inside 1');
                }
            } else {
                var _contentElement2 = buttonClicked.previousElementSibling;
                _contentElement2.classList.remove('show');
                // console.log(contentElement, contentElement.classList)
                //remove class 'expanded-text' from .c-promo
                contentElementParent.classList.remove('expanded-text');
                buttonClicked.innerHTML = buttonExpandTextValue || 'Expand to see more';

                if (window.innerWidth > 425 && buttonClicked.innerHTML.trim() === buttonCollapseTextValue) {
                    contentElementFixedImageSibling.style.position = 'relative';
                    contentElementFixedImageSibling.style.top = '0px';
                    contentElementFixedImageSibling.classList.remove('img-expanded-pos');
                    console.log('inside 2');
                }

                contentElementSibling.scrollIntoView({ block: "start", behavior: "smooth" });
            }
        });
    }
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 *   File:   carousel-prev-next.js
 *
 *   Desc:   Carousel widget with Previous and Next Buttons that implements ARIA Authoring Practices
 *
 */

var CarouselPreviousNext = function CarouselPreviousNext(node, options) {
    // merge passed options with defaults
    options = _extends({ moreaccessible: false, paused: false, norotate: true }, options || {});

    // a prefers-reduced-motion user setting must always override autoplay
    var hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (hasReducedMotion.matches) {
        options.paused = true;
    }

    /* DOM properties */
    this.domNode = node;

    this.carouselItemNodes = node.querySelectorAll('.carousel-item');

    this.containerNode = node.querySelector('.carousel-items');
    this.liveRegionNode = node.querySelector('.carousel-items');
    this.pausePlayButtonNode = null;
    this.previousButtonNode = null;
    this.nextButtonNode = null;

    this.playLabel = 'Start automatic slide show';
    this.pauseLabel = 'Stop automatic slide show';

    /* State properties */
    this.hasUserActivatedPlay = false; // set when the user activates the play/pause button
    this.isAutoRotationDisabled = options.norotate; // This property for disabling auto rotation
    this.isPlayingEnabled = !options.paused; // This property is also set in updatePlaying method
    this.timeInterval = 5000; // length of slide rotation in ms
    this.currentIndex = 0; // index of current slide
    this.slideTimeout = null; // save reference to setTimeout

    // Pause Button

    var elem = document.querySelector('.controls button.rotation');
    if (elem) {
        this.pausePlayButtonNode = elem;
        this.pausePlayButtonNode.addEventListener('click', this.handlePausePlayButtonClick.bind(this));
    }

    // Previous Button

    elem = document.querySelector('.controls button.previous');
    if (elem) {
        this.previousButtonNode = elem;
        this.previousButtonNode.addEventListener('click', this.handlePreviousButtonClick.bind(this));
        this.previousButtonNode.addEventListener('focus', this.handleFocusIn.bind(this));
        this.previousButtonNode.addEventListener('blur', this.handleFocusOut.bind(this));
    }

    // Next Button

    elem = document.querySelector('.controls button.next');
    if (elem) {
        this.nextButtonNode = elem;
        this.nextButtonNode.addEventListener('click', this.handleNextButtonClick.bind(this));
        this.nextButtonNode.addEventListener('focus', this.handleFocusIn.bind(this));
        this.nextButtonNode.addEventListener('blur', this.handleFocusOut.bind(this));
    }

    // Carousel item events

    for (var i = 0; i < this.carouselItemNodes.length; i++) {
        var carouselItemNode = this.carouselItemNodes[i];

        // support stopping rotation when any element receives focus in the tabpanel
        carouselItemNode.addEventListener('focusin', this.handleFocusIn.bind(this));
        carouselItemNode.addEventListener('focusout', this.handleFocusOut.bind(this));

        var imageLinkNode = carouselItemNode.querySelector('.carousel-image a');

        if (imageLinkNode) {
            imageLinkNode.addEventListener('focus', this.handleImageLinkFocus.bind(this));
            imageLinkNode.addEventListener('blur', this.handleImageLinkBlur.bind(this));
        }
    }

    // Handle hover events
    this.domNode.addEventListener('mouseover', this.handleMouseOver.bind(this));
    this.domNode.addEventListener('mouseout', this.handleMouseOut.bind(this));

    // initialize behavior based on options

    this.enableOrDisableAutoRotation(options.norotate);
    this.updatePlaying(!options.paused && !options.norotate);
    this.setAccessibleStyling(options.moreaccessible);
    this.rotateSlides();
};

/* Public function to disable/enable rotation and if false, hide pause/play button */
CarouselPreviousNext.prototype.enableOrDisableAutoRotation = function (disable) {
    this.isAutoRotationDisabled = disable;
    this.pausePlayButtonNode.hidden = disable;
};

/* Public function to update controls/caption styling */
CarouselPreviousNext.prototype.setAccessibleStyling = function (accessible) {
    if (accessible) {
        this.domNode.classList.add('carousel-moreaccessible');
    } else {
        this.domNode.classList.remove('carousel-moreaccessible');
    }
};

CarouselPreviousNext.prototype.showCarouselItem = function (index) {
    this.currentIndex = index;

    for (var i = 0; i < this.carouselItemNodes.length; i++) {
        var carouselItemNode = this.carouselItemNodes[i];
        if (index === i) {
            carouselItemNode.classList.add('active');
        } else {
            carouselItemNode.classList.remove('active');
        }
    }
};

CarouselPreviousNext.prototype.previousCarouselItem = function () {
    var nextIndex = this.currentIndex - 1;
    if (nextIndex < 0) {
        nextIndex = this.carouselItemNodes.length - 1;
    }
    this.showCarouselItem(nextIndex);
};

CarouselPreviousNext.prototype.nextCarouselItem = function () {
    var nextIndex = this.currentIndex + 1;
    if (nextIndex >= this.carouselItemNodes.length) {
        nextIndex = 0;
    }
    this.showCarouselItem(nextIndex);
};

CarouselPreviousNext.prototype.rotateSlides = function () {
    if (!this.isAutoRotationDisabled) {
        if (!this.hasFocus && !this.hasHover && this.isPlayingEnabled || this.hasUserActivatedPlay) {
            this.nextCarouselItem();
        }
    }

    this.slideTimeout = setTimeout(this.rotateSlides.bind(this), this.timeInterval);
};

CarouselPreviousNext.prototype.updatePlaying = function (play) {
    this.isPlayingEnabled = play;

    if (play) {
        this.pausePlayButtonNode.setAttribute('aria-label', this.pauseLabel);
        this.pausePlayButtonNode.classList.remove('play');
        this.pausePlayButtonNode.classList.add('pause');
        this.liveRegionNode.setAttribute('aria-live', 'off');
    } else {
        this.pausePlayButtonNode.setAttribute('aria-label', this.playLabel);
        this.pausePlayButtonNode.classList.remove('pause');
        this.pausePlayButtonNode.classList.add('play');
        this.liveRegionNode.setAttribute('aria-live', 'polite');
    }
};

/* Event Handlers */

CarouselPreviousNext.prototype.handleImageLinkFocus = function () {
    this.liveRegionNode.classList.add('focus');
};

CarouselPreviousNext.prototype.handleImageLinkBlur = function () {
    this.liveRegionNode.classList.remove('focus');
};

CarouselPreviousNext.prototype.handleMouseOver = function (event) {
    if (!this.pausePlayButtonNode.contains(event.target)) {
        this.hasHover = true;
    }
};

CarouselPreviousNext.prototype.handleMouseOut = function () {
    this.hasHover = false;
};

/* EVENT HANDLERS */

CarouselPreviousNext.prototype.handlePausePlayButtonClick = function () {
    this.hasUserActivatedPlay = !this.isPlayingEnabled;
    this.updatePlaying(!this.isPlayingEnabled);
};

CarouselPreviousNext.prototype.handlePreviousButtonClick = function () {
    this.previousCarouselItem();
};

CarouselPreviousNext.prototype.handleNextButtonClick = function () {
    this.nextCarouselItem();
};

/* Event Handlers for carousel items */

CarouselPreviousNext.prototype.handleFocusIn = function () {
    this.liveRegionNode.setAttribute('aria-live', 'polite');
    this.hasFocus = true;
};

CarouselPreviousNext.prototype.handleFocusOut = function () {
    if (this.isPlayingEnabled) {
        this.liveRegionNode.setAttribute('aria-live', 'off');
    }
    this.hasFocus = false;
};

/* Initialize Carousel and options */

window.addEventListener('load', function () {
    var carouselEls = document.querySelectorAll('.carousel');
    var carousels = [];

    // set example behavior based on
    // default setting of the checkboxes and the parameters in the URL
    // update checkboxes based on any corresponding URL parameters
    var checkboxes = document.querySelectorAll('.carousel-options input[type=checkbox]');
    var urlParams = new URLSearchParams(this.location.search);
    var carouselOptions = {};

    // initialize example features based on
    // default setting of the checkboxes and the parameters in the URL
    // update checkboxes based on any corresponding URL parameters
    checkboxes.forEach(function (checkbox) {
        var checked = checkbox.checked;

        if (urlParams.has(checkbox.value)) {
            var urlParam = urlParams.get(checkbox.value);
            if (typeof urlParam === 'string') {
                checked = urlParam === 'true';
                checkbox.checked = checked;
            }
        }

        carouselOptions[checkbox.value] = checkbox.checked;
    });

    carouselEls.forEach(function (node) {
        carousels.push(new CarouselPreviousNext(node, carouselOptions));
    });

    // add change event to checkboxes
    checkboxes.forEach(function (checkbox) {
        var updateEvent;
        switch (checkbox.value) {
            case 'moreaccessible':
                updateEvent = 'setAccessibleStyling';
                break;
            case 'norotate':
                updateEvent = 'enableOrDisableAutoRotation';
                break;
        }

        // update the carousel behavior and URL when a checkbox state changes
        checkbox.addEventListener('change', function (event) {
            urlParams.set(event.target.value, event.target.checked + '');
            window.history.replaceState(null, '', window.location.pathname + '?' + urlParams);

            if (updateEvent) {
                carousels.forEach(function (carousel) {
                    carousel[updateEvent](event.target.checked);
                });
            }
        });
    });
}, false);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/** Date: 10/2/2020*/

// import { valueOf } from "core-js/fn/_";

/* luminate donation form  */
exports['default'] = {
    inserted: function inserted(el) {
        var button = el.querySelector("[type=submit]");
        var amountRadios = el.querySelectorAll('input[name="amount_select"]');
        var otherAmount = el.querySelector('input[name="amount_other"]');
        var amount = el.querySelector('input[name="amount"]');
        var donationDiv = el.querySelector("#donation");
        var errorMessage = document.querySelector(".error-message");
        var spinner = document.createElement('span');
        spinner.classList.add('spinner-border', 'spinner-border-sm');
        spinner.setAttribute('role', 'status');
        spinner.setAttribute('aria-hidden', 'true');
        button.classList.add('has-spinner');

        // ON SUBMIT - APPEND FREQUENCY AND AMOUNT TO FORM ACTION 
        el.onsubmit = function (e) {
            var frequencyValue = el.querySelector('input[name="frequency"]:checked').value;
            var amountValue = el.querySelector('input[name="amount"]').value;
            var action_src = el.action;
            action_src += "&amount=" + amountValue + "&frequency=" + frequencyValue;
            el.action = action_src;
            button.append(spinner);
            button.disabled = true; // only submit one time
        };

        function unselectAllAmountRadios() {
            Array.prototype.slice.call(amountRadios).forEach(function (radio) {
                radio.checked = false;
            });
        }

        function clearAmountOther() {
            otherAmount.value = "";
        }

        function setAmountHidden(val) {
            //for backend to get value amount either from radio or input text field
            if (val != "undefined") {
                amount.value = val;
            }
        }

        donationDiv.addEventListener("input", function (e) {
            // listens for input change
            switch (e.target.name) {
                case "amount_other":
                    unselectAllAmountRadios();
                    break;
                case "amount_select":
                    clearAmountOther();
                    break;
            }
            validateDonation();
        });

        function validateDonation() {
            var selected = document.querySelector('input[name="amount_select"]:checked');
            var selectedValue = selected ? selected.value : "";

            if (selectedValue.length >= 2 && otherAmount.value.length === 0) {
                button.disabled = false;
                errorMessage.style.display = "none";
                setAmountHidden(selectedValue);
            } else if (otherAmount.value > 9 && otherAmount.value < 50001) {
                button.disabled = false;
                errorMessage.style.display = "none";
                setAmountHidden(otherAmount.value);
            } else {
                button.disabled = true;
                errorMessage.style.display = "block";
                setAmountHidden("");
            }
        }

        // Run on page load
        validateDonation();
    }
};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    inserted: function inserted(el) {

        var winWidth = window.innerWidth;
        var mobileWidth = 500;

        var getMaxHeight = function getMaxHeight() {
            var maxHeight = 0;
            var tabPanels = document.querySelectorAll('[role="tabpanel"]');
            console.log("panels: ", tabPanels.length);
            for (var i = 0; i < tabPanels.length; i++) {
                var elHeight = tabPanels[i].offsetHeight;
                console.log(i + ': ' + elHeight);
                if (elHeight > maxHeight) {
                    maxHeight = elHeight;
                }
            }
            return maxHeight;
        };

        var setMaxHeight = function setMaxHeight(height) {
            var tabPanels = document.querySelectorAll('[role="tabpanel"]');
            for (var i = 0; i < tabPanels.length; i++) {
                tabPanels[i].style.height = height + "px";
            }
        };

        var reportWindowSize = function reportWindowSize() {
            if (winWidth > mobileWidth) {
                setMaxHeight(getMaxHeight());
            }
        };

        console.log("width: ", winWidth);

        setTimeout(function () {
            if (winWidth > mobileWidth) {
                setMaxHeight(getMaxHeight());
            }
            window.addEventListener('resize', reportWindowSize);
        }, 500);
    }
};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    bind: function bind(el, binding, vnode) {
        var nestedAccordionEl = el.querySelector('.js-nested-accordion');
        var expandAllBoolean = true;
        var accordionObserver = new window.MutationObserver(observerCallback);
        var toggleAllButton = el.querySelector('.nested-accordion__toggle-all');
        var hashId = window.location.href.split('#')[1] || '';
        var searchResultLinkedHeading = el.querySelector('button[aria-controls="' + hashId + '"]');
        var parentContainersArray = [];

        if (nestedAccordionEl) {
            accordionObserver.observe(nestedAccordionEl, {
                attributeFilter: ['aria-expanded'],
                attributes: true,
                subtree: true
            });
        }

        if (searchResultLinkedHeading) {
            var parentContainer = getClosest(searchResultLinkedHeading, '.nested-accordion__collapse');

            if (parentContainer) {
                while (parentContainer) {
                    if (parentContainer.previousElementSibling && parentContainer.previousElementSibling.classList && parentContainer.previousElementSibling.classList.contains('nested-accordion__toggle-button')) {
                        parentContainersArray.push(parentContainer.previousElementSibling);
                        parentContainer = getClosest(parentContainer.previousElementSibling, '.nested-accordion__collapse');
                    } else {
                        break;
                    }
                }

                if (parentContainersArray.length) {
                    var _loop = function _loop(i) {
                        setTimeout(function () {
                            parentContainersArray[i].click();
                        }, 10);
                    };

                    for (var i = 0; i < parentContainersArray.length; i++) {
                        _loop(i);
                    }
                }
            }

            searchResultLinkedHeading.click();
            searchResultLinkedHeading.scrollIntoView();
        }

        window.toggleNestedAccordions = function toggleNestedAccordions() {
            if (expandAllBoolean) {
                expandAll();

                if (toggleAllButton) {
                    toggleAllButton.innerHTML = 'Collapse All <span aria-hidden="true">&minus;</span>';
                }

                expandAllBoolean = false;
            } else {
                collapseAll();

                if (toggleAllButton) {
                    toggleAllButton.innerHTML = 'Expand All <span aria-hidden="true">&plus;</span>';
                }

                expandAllBoolean = true;
            }
        };

        function expandAll() {
            var buttonList = el.querySelectorAll('.js-nested-accordion button.nested-accordion__toggle-button');

            for (var i = 0; i < buttonList.length; i++) {
                if (buttonList[i].attributes.getNamedItem('aria-expanded').value === 'false') {
                    buttonList[i].click();
                }
            }
        }

        function collapseAll() {
            var buttonList = el.querySelectorAll('.js-nested-accordion button.nested-accordion__toggle-button');

            for (var i = 0; i < buttonList.length; i++) {
                if (buttonList[i].attributes.getNamedItem('aria-expanded').value === 'true') {
                    buttonList[i].click();
                }
            }
        }

        function getClosest(elem, selector) {
            for (; elem && elem !== document; elem = elem.parentNode) {
                if (elem.matches(selector)) return elem;
            }

            return null;
        }

        function observerCallback(mutationsList) {
            mutationsList.forEach(function (node) {
                var target = node.target;
                var parentElement = target.parentElement;
                var lastButtonElement = void 0;
                var targetIsLastButtonElement = false;
                var targetIsContainerElement = false;
                var parentCollapseElement = getClosest(target, '.nested-accordion__collapse');
                var lastChildButtonElement = void 0;
                var childCardBody = void 0;
                var nextParentButtonElement = void 0;
                var nextSiblingButton = void 0;
                var targetIsExpanded = target.attributes.getNamedItem('aria-expanded').value === 'true';

                if (target.classList.contains('js-transparent-border') && targetIsExpanded) {
                    target.classList.remove('js-transparent-border');
                    target.classList.add('js-transparent-border-off');

                    if (target.nextElementSibling && target.nextElementSibling.classList && target.nextElementSibling.classList.contains('nested-accordion__collapse--content')) {
                        target.nextElementSibling.setAttribute('data-content', '');
                    }
                } else if (target.classList.contains('js-transparent-border-off') && !targetIsExpanded) {
                    target.classList.remove('js-transparent-border-off');

                    if (target.nextElementSibling && target.nextElementSibling.classList && target.nextElementSibling.classList.contains('nested-accordion__collapse--content')) {
                        target.nextElementSibling.removeAttribute('data-content');
                    }
                }

                if (parentElement) {
                    for (var i = parentElement.childNodes.length; i--;) {
                        if (parentElement.childNodes[i].classList && parentElement.childNodes[i].classList.contains('nested-accordion__toggle-button')) {
                            lastButtonElement = parentElement.childNodes[i];
                            break;
                        }
                    }
                }

                if (lastButtonElement) {
                    targetIsLastButtonElement = target.isSameNode(lastButtonElement);
                }

                if (target.nextElementSibling.classList && (target.nextElementSibling.classList.contains('nested-accordion__collapse--container-container') || target.nextElementSibling.classList.contains('nested-accordion__collapse--container'))) {
                    targetIsContainerElement = true;
                }

                if (lastButtonElement && targetIsExpanded && target.nextElementSibling.classList && target.nextElementSibling.classList.contains('nested-accordion__collapse--content')) {
                    if (parentCollapseElement) {
                        nextParentButtonElement = parentCollapseElement.nextElementSibling;

                        if (!nextParentButtonElement && targetIsLastButtonElement) {
                            target.nextElementSibling.setAttribute('data-content', '');
                        }
                    }
                }

                if (target.attributes.getNamedItem('aria-expanded').value === 'true') {
                    targetIsExpanded = true;
                } else {
                    targetIsExpanded = false;
                }

                if (targetIsLastButtonElement && targetIsContainerElement) {
                    childCardBody = target.nextElementSibling.querySelector('.card-body');

                    if (parentCollapseElement) {
                        nextParentButtonElement = parentCollapseElement.nextElementSibling;
                    }

                    if (childCardBody) {
                        for (var _i = childCardBody.childNodes.length; _i--;) {
                            if (childCardBody.childNodes[_i].classList && childCardBody.childNodes[_i].classList.contains('nested-accordion__toggle-button')) {
                                lastChildButtonElement = childCardBody.childNodes[_i];
                                break;
                            }
                        }

                        if (lastChildButtonElement && lastChildButtonElement.attributes.getNamedItem('aria-expanded').value === 'false') {
                            lastChildButtonElement.classList.add('js-transparent-border');
                        }
                    }
                }

                if (targetIsLastButtonElement && nextParentButtonElement && nextParentButtonElement.classList && nextParentButtonElement.classList.contains('nested-accordion__toggle-button')) {
                    if (targetIsExpanded) {
                        nextParentButtonElement.classList.add('js-hide-after');
                    } else {
                        nextParentButtonElement.classList.remove('js-hide-after');
                    }

                    for (var _i2 = parentCollapseElement.parentNode.children.length; _i2--;) {
                        if (parentCollapseElement.parentNode.children[_i2].classList && parentCollapseElement.parentNode.children[_i2].classList.contains('nested-accordion__toggle-button')) {
                            if (!parentCollapseElement.previousElementSibling.isSameNode(parentCollapseElement.parentNode.children[_i2]) && !parentCollapseElement.previousElementSibling.parentNode.classList.contains('js-nested-accordion')) {
                                nextParentButtonElement.classList.remove('js-hide-after');
                                break;
                            }
                        }
                    }
                } else if (parentElement.classList && parentElement.classList.contains('js-nested-accordion')) {
                    if (targetIsLastButtonElement && targetIsExpanded) {
                        target.nextElementSibling.setAttribute('data-content', '');
                    } else if (targetIsLastButtonElement && !targetIsExpanded) {
                        target.nextElementSibling.removeAttribute('data-content');
                    }

                    if (target.nextElementSibling && target.nextElementSibling.nextElementSibling) {
                        if (target.nextElementSibling.nextElementSibling.classList && target.nextElementSibling.nextElementSibling.classList.contains('nested-accordion__toggle-button')) {
                            nextSiblingButton = target.nextElementSibling.nextElementSibling;

                            if (targetIsExpanded && nextSiblingButton.isSameNode(lastButtonElement) && nextSiblingButton.attributes.getNamedItem('aria-expanded').value === 'false') {
                                nextSiblingButton.classList.add('js-transparent-border');
                            } else if (!targetIsExpanded && nextSiblingButton.isSameNode(lastButtonElement) && nextSiblingButton.attributes.getNamedItem('aria-expanded').value === 'false') {
                                nextSiblingButton.classList.remove('js-transparent-border');
                            }
                        }
                    }
                }
            });
        }
    }
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// removes the href
setTimeout(function () {
    var links = document.querySelectorAll('div.tabs ul[role="tablist"] li.nav-item');

    for (var i = 0; i < links.length; i++) {
        links[i].setAttribute('role', 'none');
    }
}, 1000);

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    inserted: function inserted(el) {
        var allTabPanels = el.querySelectorAll('[role="tabpanel"]');
        var tabList = el.querySelector('[role="tablist"]');

        // The current version of bootstrap-vue being used (1.51.1) looks to have a misspelling when adding the 'aria-labelledby' attribute on the tabpanels causing an accessibility risk flag.  Removing the misspelled attribute and adding the correct spelling with the appropriate value here.
        allTabPanels.forEach(function (tabPanel) {
            window.setTimeout(function () {
                tabPanel.setAttribute('aria-labelledby', tabPanel.attributes.getNamedItem('aria-lablelledby').value);
                tabPanel.removeAttribute('aria-lablelledby');
                // To fix the Siteimprove suggestion, remove the "aria-expanded" attribute.
                tabPanel.removeAttribute('aria-expanded');
            }, 0);
        });

        // Move focus to the next tab in the tab list when tabbing from the last tabbable element within a tab panel on desktop with screen reader announcement.  Do not do this if it is the last tab panel.

        var _loop = function _loop(i) {
            var allTabbableElements = allTabPanels[i].querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
            var lastTabbableElement = allTabbableElements[allTabbableElements.length - 1];

            lastTabbableElement.addEventListener('keydown', function (e) {
                var allTabs = void 0;

                if (tabList) {
                    allTabs = tabList.querySelectorAll('.nav-item');
                }

                if (e.keyCode === 9 && !e.shiftKey && allTabs && window.innerWidth > 575) {
                    e.preventDefault();
                    allTabs[i + 1].querySelector('[role="tab"]').setAttribute('tabindex', '0');
                    allTabs[i + 1].querySelector('[role="tab"]').click();
                    allTabs[i + 1].querySelector('[role="tab"]').focus();
                    allTabs[i].querySelector('[role="tab"]').setAttribute('tabindex', '-1');
                }
            });
        };

        for (var i = 0; i < allTabPanels.length - 1; i++) {
            _loop(i);
        }

        // // Enable screen readers to announce the tabs while navigating them via arrow keys.  The current version of bootstrap-vue being used (1.51.1) does support this.  Navigating with the down arrow key is also broken because of a misspelling in file Project\Heart-FrontEnd\node_modules\bootstrap-vue\es\components\tabs\tabs.js on line 245 (KeyCodes.DWON).
        setTimeout(function () {
            if (tabList) {
                var initialActiveTab = tabList.querySelector('.active');
                var allListItems = tabList.querySelectorAll('li');

                allListItems.forEach(function (listItem) {
                    listItem.removeAttribute('role');
                });

                // Remove tabindex=0 on tab list
                if (tabList) {
                    tabList.removeAttribute('tabindex');
                }
                // Set tabindex=0 on the active tab when loaded
                if (initialActiveTab) {
                    initialActiveTab.setAttribute('tabindex', '0');
                }

                tabList.addEventListener('keydown', function (e) {
                    var currentTab = void 0;

                    if (e.target.classList.contains('nav-link') && (e.keyCode === 39 || e.keyCode === 40)) {
                        currentTab = e.target;
                        var nextTab = currentTab.parentNode.nextElementSibling ? currentTab.parentNode.nextElementSibling.querySelector('.nav-link') : null;

                        if (nextTab) {
                            currentTab.setAttribute('tabindex', '-1');
                            nextTab.setAttribute('tabindex', '0');
                            nextTab.click();
                            nextTab.focus();
                        }
                    } else if (e.target.classList.contains('nav-link') && (e.keyCode === 37 || e.keyCode === 38)) {
                        currentTab = e.target;
                        var previousTab = currentTab.parentNode.previousElementSibling ? currentTab.parentNode.previousElementSibling.querySelector('.nav-link') : null;

                        if (previousTab) {
                            currentTab.setAttribute('tabindex', '-1');
                            previousTab.setAttribute('tabindex', '0');
                            previousTab.click();
                            previousTab.focus();
                        }
                    }

                    // To fix the Siteimprove suggestion, remove the "aria-expanded" attribute.
                    allTabPanels.forEach(function (tabPanel) {
                        window.setTimeout(function () {
                            tabPanel.removeAttribute('aria-expanded');
                        }, 0);
                    });
                });
                // Set tabindex=0 on a tab when it is clicked and set tabindex=-1 on the currently active tab.  Listening to 'mouseup' as bootstrap-vue is preventing propagation of 'click' event in their Tab component.
                tabList.addEventListener('mouseup', function (e) {
                    var currentActiveTab = tabList.querySelector('.active');

                    // To fix the Siteimprove suggestion, remove the "aria-expanded" attribute.
                    allTabPanels.forEach(function (tabPanel) {
                        window.setTimeout(function () {
                            tabPanel.removeAttribute('aria-expanded');
                        }, 0);
                    });

                    if (currentActiveTab) {
                        currentActiveTab.setAttribute('tabindex', '-1');
                    }

                    if (e.target.classList.contains('nav-link')) {
                        e.target.setAttribute('tabindex', '0');
                    }
                });
            }
        }, 0);
    }
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    inserted: function inserted(el) {
        _inputEventbus2['default'].$emit('hiddenInputInit', el.value, el.id, el);
    }
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputEventbus = __webpack_require__(20);

var _inputEventbus2 = _interopRequireDefault(_inputEventbus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    bind: function bind(el, binding) {
        var type = el.type;
        var value = el.value;
        var id = el.id;
        var category = el.dataset.category;

        if (binding.modifiers.radio || binding.modifiers.checkbox) {
            id = binding.value;
            value = '';
        } else if (binding.value !== undefined) {
            id = binding.value;
        }

        if (type === 'checkbox') {
            value = el.checked;
        }

        if (type === 'text' || type === 'textarea') {
            el.addEventListener('input', function () {
                value = this.value;
                _inputEventbus2['default'].$emit('inputUpdated', value, id, el);
            });
        } else {
            el.addEventListener('change', function () {
                if (type === 'checkbox') {
                    value = el.checked;
                } else {
                    value = this.value;
                }
                _inputEventbus2['default'].$emit('inputUpdated', value, id, el, category);
            });
        }

        if (!binding.modifiers.flagged) {
            _inputEventbus2['default'].$emit('inputInit', value, id, el);
        } else {
            _inputEventbus2['default'].$emit('inputInitFlagged', value, id, el);
        }

        _inputEventbus2['default'].$on('inputCleared', function () {
            if (type === 'radio' || type === 'checkbox') {
                el.checked = false;
            } else {
                el.value = '';
            }
        });
    }
}; /* eslint-disable */

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _target = __webpack_require__(726);

var _target2 = _interopRequireDefault(_target);

var _dom = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var listenTypes = { click: true };

exports['default'] = {
    // eslint-disable-next-line no-shadow-restricted-names
    bind: function bind(el, binding, vnode) {
        (0, _target2['default'])(vnode, binding, listenTypes, function (_ref) {
            var targets = _ref.targets,
                vnode = _ref.vnode;

            targets.forEach(function (target) {
                vnode.context.$root.$emit('bv::show::modal', target, vnode.elm, binding.arg);
            });
        });
        if (el.tagName !== 'BUTTON') {
            // If element is not a button, we add `role="button"` for accessibility
            (0, _dom.setAttr)(el, 'role', 'button');
        }
    }
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    bind: function bind(el, binding, vnode) {

        vnode.context.$root.$on('bv::modal::shown', function (evt) {

            setTimeout(function () {
                var searchBoxes = document.querySelectorAll('.CoveoSearchInterface');
                // Iterate over each item and attach a click event listener
                searchBoxes.forEach(function (searchBox, index) {
                    var searchButton = 'CoveoSearchButton';
                    //console.log(searchBox, index)
                    var selectedSearchButton = document.querySelector('#' + searchBox.id + ' .' + searchButton);
                    //selectedSearchButton.addEventListener('click', function() {
                    //console.log('selectedSearchButton', selectedSearchButton)
                    //console.log('searchBox', searchBox)
                    if (searchBox && window.Coveo && typeof window.Coveo !== 'undefined') {
                        //console.log('window.Coveo', window.Coveo, typeof window.Coveo)
                        window.Coveo.$$(searchBox).on('newQuery', function (e) {
                            vnode.context.$root.$emit('bv::hide::modal', 'coveomodal1');
                            vnode.context.$root.$emit('bv::hide::modal', 'coveomobilemodal');
                        });
                    };
                    //})
                });
            }, 0);

            // get opend modal
            var modal = el.querySelector('.modal.fade.show');

            if (modal) {
                // add all the elements inside modal which you want to make focusable
                var focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                // get first element to be focused inside modal
                var firstFocusableElement = modal.querySelectorAll(focusableElements)[0];

                firstFocusableElement.focus();

                var focusableContent = modal.querySelectorAll(focusableElements);

                // get last element to be focused inside modal
                var lastFocusableElement = focusableContent[focusableContent.length - 1];

                document.addEventListener('keydown', function (e) {
                    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                    if (!isTabPressed) {
                        return;
                    }

                    // if shift key pressed for shift + tab combination
                    if (e.shiftKey) {
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus(); // add focus for the last focusable element
                            e.preventDefault();
                        }
                    } else {
                        // if tab key is pressed
                        // if focused has reached to last focusable element then focus first focusable element after pressing tab
                        if (document.activeElement === lastFocusableElement) {
                            // add focus for the first focusable element
                            firstFocusableElement.focus();
                            e.preventDefault();
                        }
                    }
                });
            }
        });
    }
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable */
/** Date: 7/20/2022 */
// Submit to email endpoint
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {
        var _this = this;

        console.log('el: ', el);
        console.log('binding: ', binding.value);
        console.log('node: ', vnode);

        // const url = binding.value;
        // const url = 'https://run.mocky.io/v3/a4720da8-ae94-470e-bfb5-0aeb5c970f6d?mocky-delay=500ms';
        var url = window.location.origin + '/aha-service/HeartCheckGroceryList/Email';
        console.log("endpoint: ", url);

        var loader = vnode.context.$el.querySelector('#GroceryListSpinner');

        var emailBtn = document.querySelector('.btn.btn-round.btn-primary.d-print-none');

        var sendToEmail = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var emailData, res, message, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                emailData = {};

                                emailData['recipients'] = el.querySelector('#email').value;
                                // emailData['EmailBody'] = vnode.context.$el.querySelector('#grocery-list-print-section').innerHTML;

                                //products
                                emailData['products'] = window.AHAItemsStorageAPI.itemsStorage.fetch('_aha-coveo-grocery-list');

                                console.log("Email Data Obj: ", emailData);

                                _context.prev = 4;
                                _context.next = 7;
                                return fetch(url, {
                                    method: "post",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": "token-value"
                                    },
                                    body: JSON.stringify(emailData, null, 2)
                                });

                            case 7:
                                res = _context.sent;

                                if (res.ok) {
                                    _context.next = 11;
                                    break;
                                }

                                message = 'An error has occurred: ' + res.status + ' - ' + res.statusText;
                                throw new Error(message);

                            case 11:
                                _context.next = 13;
                                return res.json();

                            case 13:
                                data = _context.sent;

                                // console.log("Response from server: ", data);
                                loader.classList.remove('show');
                                // this.loader.classList.remove('show');
                                // console.log(loader + " no this list")
                                // console.log(this.loader + " this list")
                                // console.log('loader removed')
                                document.getElementById("EmailConfirmationNotice").innerHTML = data.EmailConfirmationMessage;

                                _context.next = 21;
                                break;

                            case 18:
                                _context.prev = 18;
                                _context.t0 = _context['catch'](4);

                                console.error(_context.t0 + ' this error');

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[4, 18]]);
            }));

            return function sendToEmail() {
                return _ref.apply(this, arguments);
            };
        }();

        // Submit button for email form
        var submitBtn = el.querySelector('button[type="submit"]');
        submitBtn.addEventListener('click', function (e) {
            console.log('Button clicked');
            e.preventDefault();

            console.log(e);
            loader.classList.add('show');
            sendToEmail().then(function () {
                console.log("Resolved", 'binding', binding);
                binding.value = '';
                emailBtn.disabled = true;
                el.reset();
            })['catch'](function (error) {
                console.log("Error");
                console.log(error);
            });
        });

        var emailField = el.querySelector('input[type="email"]');
        emailField.addEventListener('input', function (e) {
            // console.log(e.target.value)
            if (e.target.value !== '') {
                document.getElementById("EmailConfirmationNotice").innerHTML = '';
            }
        });
    }
};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ahaCookie = __webpack_require__(54);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable */


// Voting action submit to email endpoint
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {
        var _this = this;

        // const url = binding.value;
        // const url = 'https://run.mocky.io/v3/a4720da8-ae94-470e-bfb5-0aeb5c970f6d?mocky-delay=500ms';
        var url = window.location.origin + '/aha-service/social/sendemailverification';

        var getVotingStageAPIURL = window.location.origin + '/aha-service/social/getvotingstage';

        var submitVoteAPIURL = window.location.origin + '/aha-service/social/submitvote';

        var getVotesCountAPIURL = window.location.origin + '/aha-service/social/getvotingcontestnomineevotecount';

        var contestantData = document.querySelector('.c-contestant-profile');

        var ItemId = contestantData && contestantData.getAttribute('data-itemid') ? contestantData.getAttribute('data-itemid') : null;

        var ContactId = contestantData && contestantData.getAttribute('data-contactid') ? contestantData.getAttribute('data-contactid') : null;

        var loader = document.querySelector('#voting-action-spinner');

        var emailSubmitBtn = document.querySelector('#emailSubmit');

        var actionFrom = document.querySelector('.c-voting-action-form');

        var votingActionStage = document.querySelector('.c-voting-action-stage');

        var inputEmail = document.querySelector('#email');

        var emailError = document.querySelector('#email-error');

        var votedNowErrorMessage = document.querySelector('#voted-now-error-message');

        var ContextItemId = document.querySelector('#hidContextPageId').value;

        emailSubmitBtn.disabled = true;

        var resetData = function resetData() {
            loader.classList.remove('show');
            emailSubmitBtn.disabled = true;
        };

        var setUserEmailCookie = function setUserEmailCookie(email) {
            var date = new Date();
            date.setTime(date.getTime() + 4 * 60 * 60 * 1000);
            var expires = "expires=" + date.toUTCString();
            var cookieValue = email + ' ; ' + expires;
            _ahaCookie.Cookie.setCookie('emailId', cookieValue);
        };

        var sendToEmail = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(Email) {
                var googleCaptchaToken, emailData, res, message, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                loader.classList.add('show');

                                googleCaptchaToken = document.querySelector('#googleCaptchaToken').value;
                                emailData = {
                                    Email: Email,
                                    ItemId: ItemId,
                                    ContactId: ContactId,
                                    ContextItemId: ContextItemId,
                                    GoogleCaptchaToken: googleCaptchaToken ? googleCaptchaToken : null,
                                    Voted: false
                                };
                                _context.prev = 3;
                                _context.next = 6;
                                return fetch(url, {
                                    method: "post",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": "token-value"
                                    },
                                    body: JSON.stringify(emailData, null, 2)
                                });

                            case 6:
                                res = _context.sent;

                                if (res.ok) {
                                    _context.next = 10;
                                    break;
                                }

                                message = 'An error has occurred: ' + res.status + ' - ' + res.statusText;
                                throw new Error(message);

                            case 10:
                                _context.next = 12;
                                return res.json();

                            case 12:
                                data = _context.sent;


                                resetData();
                                if (data.Success) {
                                    el.reset();
                                    reloadCaptcha();
                                    setUserEmailCookie(data.Email);
                                    actionFrom.classList.remove('d-block');
                                    votingActionStage.innerHTML = data.SuccessMessage;
                                    checkUpdatedDocument();
                                } else {
                                    emailError.innerHTML = '<span id="error_message">' + data.FailureMessage + '</span';
                                }
                                _context.next = 21;
                                break;

                            case 17:
                                _context.prev = 17;
                                _context.t0 = _context['catch'](3);

                                resetData();
                                emailError.innerHTML = '<span id="error_message">This does not appear to be a valid email address. Please try voting again using a valid email address.</span>';

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[3, 17]]);
            }));

            return function sendToEmail(_x) {
                return _ref.apply(this, arguments);
            };
        }();

        function checkUpdatedDocument() {

            var editEmail = document.querySelector('.edit-email');

            var resendEmailLink = document.querySelector('.resend-link');

            var voteNow = document.querySelector('.vote-now');

            if (editEmail) {
                ['keyup', 'click'].forEach(function (e) {
                    return editEmail.addEventListener(e, function (event) {
                        event.preventDefault();
                        if (event.code === 'Enter' || event.type === 'click') {
                            actionFrom.classList.add('d-block');
                            votingActionStage.innerHTML = '';
                            if (votedNowErrorMessage) {
                                votedNowErrorMessage.innerHTML = '';
                            }
                        }
                    });
                });
            }

            if (resendEmailLink) {
                ['keyup', 'click'].forEach(function (e) {
                    return resendEmailLink.addEventListener(e, function (event) {
                        event.preventDefault();
                        if (event.code === 'Enter' || event.type === 'click') {
                            var userEmailId = _ahaCookie.Cookie.getCookieValue('emailId');
                            sendToEmail(userEmailId ? userEmailId : '');
                        }
                    });
                });
            }

            if (voteNow) {
                ['keyup', 'click'].forEach(function (e) {
                    return voteNow.addEventListener(e, function (event) {
                        event.preventDefault();
                        if (event.code === 'Enter' || event.type === 'click') {
                            var userEmailId = _ahaCookie.Cookie.getCookieValue('emailId');
                            var pointerEvents = event.target.style.pointerEvents;
                            if (pointerEvents !== 'none') {
                                submitVote(userEmailId ? userEmailId : '');
                                event.target.style.pointerEvents = 'none';
                            }
                        }
                    });
                });
            }
        }

        // Submit button for email form
        emailSubmitBtn.addEventListener('click', function (e) {
            e.preventDefault();
            var email = inputEmail.value;
            var userEmailId = email ? email : '';
            sendToEmail(userEmailId);
        });

        // Doing email validation and showing an error message and disabled and enabled the submit button.
        inputEmail.addEventListener('keyup', function (e) {
            var emailRegex = /^([a-zA-Z0-9_\-.])+@([a-zA-Z0-9_\-.])+\.([a-zA-Z]{2,4})$/;
            // const regexWithoutSpecialCharacters = /^([a-zA-Z0-9._%+-])+@([a-zA-Z0-9.-])+\.([a-zA-Z]{2,})$/;
            if (emailRegex.test(this.value)) {
                emailError.innerHTML = '';
                emailSubmitBtn.disabled = false;
            }
        });

        // Doing email validation and showing an error message and disabled and enabled the submit button.
        inputEmail.addEventListener('focusout', function (e) {
            var emailRegex = /^([a-zA-Z0-9_\-.])+@([a-zA-Z0-9_\-.])+\.([a-zA-Z]{2,4})$/;
            // const regexWithoutSpecialCharacters = /^([a-zA-Z0-9._%+-])+@([a-zA-Z0-9.-])+\.([a-zA-Z]{2,})$/;
            if (!emailRegex.test(this.value)) {
                emailError.innerHTML = this.value !== '' ? '<span id="error_message">Invalid email address.</span>' : '<span id="error_message">Please enter your email address.</span>';
                emailSubmitBtn.disabled = true;
            } else {
                emailError.innerHTML = '';
                emailSubmitBtn.disabled = false;
            }
        });

        // function for submit the votes
        var submitVote = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(Email) {
                var _emailData;

                var googleCaptchaToken, hidContactId, hidIPAddress, hidInteractionId, hidSiteName, emailData, res, message, data;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                googleCaptchaToken = document.querySelector('#googleCaptchaToken').value;
                                hidContactId = document.querySelector('#hidContactId').value;
                                hidIPAddress = document.querySelector('#hidIPAddress').value;
                                hidInteractionId = document.querySelector('#hidInteractionId').value;
                                hidSiteName = document.querySelector('#hidSiteName').value;
                                emailData = (_emailData = {
                                    Email: Email,
                                    ItemId: ItemId,
                                    ContactId: ContactId,
                                    ContextItemId: ContextItemId,
                                    Voted: true
                                }, _defineProperty(_emailData, 'ContactId', hidContactId ? hidContactId : null), _defineProperty(_emailData, 'IPAddress', hidIPAddress ? hidIPAddress : null), _defineProperty(_emailData, 'InteractionId', hidInteractionId ? hidInteractionId : null), _defineProperty(_emailData, 'SiteName', hidSiteName ? hidSiteName : null), _defineProperty(_emailData, 'GoogleCaptchaToken', googleCaptchaToken ? googleCaptchaToken : null), _emailData);
                                _context2.prev = 6;
                                _context2.next = 9;
                                return fetch(submitVoteAPIURL, {
                                    method: "post",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": "token-value"
                                    },
                                    body: JSON.stringify(emailData, null, 2)
                                });

                            case 9:
                                res = _context2.sent;

                                if (res.ok) {
                                    _context2.next = 13;
                                    break;
                                }

                                message = 'An error has occurred: ' + res.status + ' - ' + res.statusText;
                                throw new Error(message);

                            case 13:
                                _context2.next = 15;
                                return res.json();

                            case 15:
                                data = _context2.sent;

                                reloadCaptcha();
                                if (data.Success) {
                                    votingActionStage.innerHTML = '<h2 aria-live="polite" role="alert">' + data.SuccessMessage + '</h2>';
                                    updatedVotingCount();
                                } else {
                                    votedNowErrorMessage.innerHTML = '<span>' + data.FailureMessage + '<span>';
                                }
                                _context2.next = 23;
                                break;

                            case 20:
                                _context2.prev = 20;
                                _context2.t0 = _context2['catch'](6);

                                console.log(error);

                            case 23:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this, [[6, 20]]);
            }));

            return function submitVote(_x2) {
                return _ref2.apply(this, arguments);
            };
        }();

        var updatedVotingCount = function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var contextItemId, res, message, data;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                contextItemId = document.querySelector('#hidContextPageId').value;
                                _context3.prev = 1;
                                _context3.next = 4;
                                return fetch(getVotesCountAPIURL + '/' + contextItemId, {
                                    method: "get",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": "token-value"
                                    }
                                });

                            case 4:
                                res = _context3.sent;

                                if (res.ok) {
                                    _context3.next = 8;
                                    break;
                                }

                                message = 'An error has occurred: ' + res.status + ' - ' + res.statusText;
                                throw new Error(message);

                            case 8:
                                _context3.next = 10;
                                return res.json();

                            case 10:
                                data = +_context3.sent;

                                document.querySelectorAll('.c-contestant-vote-count').forEach(function (el) {
                                    var voteCountElement = el.querySelector('.vote-count');
                                    var votesCount = +voteCountElement.innerText === data ? data + 1 : data;
                                    voteCountElement.innerHTML = votesCount;
                                    var voteText = voteCountElement.getAttribute('data-vote') ? voteCountElement.getAttribute('data-vote') : 'vote';
                                    var votesText = voteCountElement.getAttribute('data-votes') ? voteCountElement.getAttribute('data-votes') : 'votes';
                                    el.innerHTML = "";
                                    el.append(voteCountElement);
                                    voteCountElement.insertAdjacentHTML('afterend', votesCount === 1 ? ' ' + voteText : ' ' + votesText);
                                    el.style.display = votesCount >= 1 ? 'block' : 'd-none';
                                });
                                _context3.next = 17;
                                break;

                            case 14:
                                _context3.prev = 14;
                                _context3.t0 = _context3['catch'](1);

                                console.log(_context3.t0);

                            case 17:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this, [[1, 14]]);
            }));

            return function updatedVotingCount() {
                return _ref3.apply(this, arguments);
            };
        }();

        function queryString(url) {
            var str1 = url.split('?')[1];
            var params = {};

            if (str1) {
                var pairs = str1.split('&');
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var pair = _step.value;

                        var _pair$split = pair.split('='),
                            _pair$split2 = _slicedToArray(_pair$split, 2),
                            key = _pair$split2[0],
                            value = _pair$split2[1];

                        params[key] = decodeURIComponent(value.replace(/\+/g, ' '));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator['return']) {
                            _iterator['return']();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return params;
        }

        var getVotingStage = function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(Email) {
                var data, VerificationCode, emailData, res, message, _data;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                data = queryString(window.location.href);
                                VerificationCode = data['verificationcode'] ? data['verificationcode'] : null;
                                emailData = {
                                    Email: Email,
                                    ContextItemId: ContextItemId,
                                    VerificationCode: VerificationCode,
                                    ItemId: ItemId
                                };
                                _context4.prev = 3;
                                _context4.next = 6;
                                return fetch(getVotingStageAPIURL, {
                                    method: "post",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": "token-value"
                                    },
                                    body: JSON.stringify(emailData, null, 2)
                                });

                            case 6:
                                res = _context4.sent;

                                if (res.ok) {
                                    _context4.next = 10;
                                    break;
                                }

                                message = 'An error has occurred: ' + res.status + ' - ' + res.statusText;
                                throw new Error(message);

                            case 10:
                                _context4.next = 12;
                                return res.json();

                            case 12:
                                _data = _context4.sent;

                                setUserEmailCookie(_data.Email);
                                if (!_data.VotingStage && !_data.Success) {
                                    actionFrom.classList.add('d-block');
                                } else if (!_data.Success) {
                                    actionFrom.classList.remove('d-block');
                                    votingActionStage.innerHTML = '<p>' + _data.FailureMessage + '</p>';
                                } else if (+_data.VotingStage === 1 || +_data.VotingStage === 2 || _data.Success) {
                                    actionFrom.classList.remove('d-block');
                                    votingActionStage.innerHTML = _data.SuccessMessage;
                                    if (+_data.VotingStage === 2 || _data.Success) {
                                        votingActionStage.scrollTo({ top: votingActionStage.scrollHeight, behavior: 'smooth' });
                                    }
                                    checkUpdatedDocument();
                                }
                                _context4.next = 20;
                                break;

                            case 17:
                                _context4.prev = 17;
                                _context4.t0 = _context4['catch'](3);

                                actionFrom.classList.add('d-block');

                            case 20:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this, [[3, 17]]);
            }));

            return function getVotingStage(_x3) {
                return _ref4.apply(this, arguments);
            };
        }();

        document.addEventListener('DOMContentLoaded', function () {
            if (votedNowErrorMessage) {
                votedNowErrorMessage.innerHTML = '';
            }
            var userEmailId = _ahaCookie.Cookie.getCookieValue('emailId');
            getVotingStage(userEmailId ? userEmailId : '');
        }, false);
    }
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable */
// Voting marketing optedIn
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {
        var _this = this;

        // const url = binding.value;
        // const url = 'https://run.mocky.io/v3/a4720da8-ae94-470e-bfb5-0aeb5c970f6d?mocky-delay=500ms';
        var url = window.location.origin + '/aha-service/social/submitoptinform';

        var inputEmail = document.querySelector('#email');

        var marketingSignUp = document.querySelector('#marketing-sign-up');

        marketingSignUp.disabled = true;

        var firstName = document.querySelector('#first-name');
        var lastName = document.querySelector('#last-name');
        var zipcode = document.querySelector('#zipcode');
        var optedIn = document.querySelector('#opt-in-checkbox');

        var thankYouDiv = document.querySelector('#divThankYou');
        var thankyouMessage = document.querySelector('.thankyouMessage');
        var signupform = document.querySelector('.signupform');
        var newsLetterComponent = document.querySelector('.c-listing-header');

        thankYouDiv.classList.add('d-none');

        // Error messages
        var zipcodeError = document.querySelector('#zipcode-error');

        zipcode.setAttribute('aria-describedby', '');

        var checkRemainingFiledValidity = function checkRemainingFiledValidity(keyvalue, remainingFiledValidity) {
            if (keyvalue && remainingFiledValidity) {
                marketingSignUp.disabled = false;
            } else {
                marketingSignUp.disabled = true;
            }
        };

        // Doing zipcode validation and showing an error message and disabled and enabled the sign up button.
        zipcode.addEventListener('keyup', function (e) {
            var zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            var remainingFiledValidity = firstName.value && lastName.value && optedIn.checked;
            if (zipcodeRegex.test(this.value)) {
                zipcodeError.classList.add('d-none');
                zipcode.setAttribute('aria-describedby', '');
                if (remainingFiledValidity) {
                    marketingSignUp.disabled = false;
                }
            }
        });

        // Doing zipcode validation and showing an error message and disabled and enabled the sign up button.
        zipcode.addEventListener('focusout', function (e) {
            var zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            var remainingFiledValidity = firstName.value && lastName.value && optedIn.checked;
            if (!zipcodeRegex.test(this.value)) {
                zipcodeError.classList.remove('d-none');
                zipcode.setAttribute('aria-describedby', 'zipcode-error');
                marketingSignUp.disabled = true;
            } else {
                zipcodeError.classList.add('d-none');
                zipcode.setAttribute('aria-describedby', '');
                if (remainingFiledValidity) {
                    marketingSignUp.disabled = false;
                }
            }
        });

        firstName.addEventListener('keyup', function (e) {
            var zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            var remainingFiledValidity = lastName.value && zipcodeRegex.test(zipcode.value) && optedIn.checked;
            checkRemainingFiledValidity(this.value, remainingFiledValidity);
        });

        lastName.addEventListener('keyup', function (e) {
            var zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            var remainingFiledValidity = firstName.value && zipcodeRegex.test(zipcode.value) && optedIn.checked;
            checkRemainingFiledValidity(this.value, remainingFiledValidity);
        });

        optedIn.addEventListener('change', function (e) {
            var zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
            var remainingFiledValidity = firstName.value && lastName.value && zipcodeRegex.test(zipcode.value);
            checkRemainingFiledValidity(this.checked, remainingFiledValidity);
        });

        var signUp = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var payLoad, res, message, data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                payLoad = {
                                    FirstName: firstName.value,
                                    LastName: lastName.value,
                                    Email: inputEmail.value,
                                    Zipcode: zipcode.value,
                                    OptedIn: optedIn.checked,
                                    ContactId: document.querySelector('#hidContactId').value,
                                    ContextItemId: document.querySelector('#hidContextPageId').value,
                                    GoogleCaptchaToken: document.querySelector('#googleCaptchaToken').value
                                };
                                _context.prev = 1;
                                _context.next = 4;
                                return fetch(url, {
                                    method: 'post',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'x-access-token': 'token-value'
                                    },
                                    body: JSON.stringify(payLoad, null, 2)
                                });

                            case 4:
                                res = _context.sent;

                                if (res.ok) {
                                    _context.next = 8;
                                    break;
                                }

                                message = 'An error has occurred: ' + res.status + ' - ' + res.statusText;
                                throw new Error(message);

                            case 8:
                                _context.next = 10;
                                return res.json();

                            case 10:
                                data = _context.sent;

                                if (data.Success) {
                                    signupform.classList.add('d-none');
                                    newsLetterComponent.classList.add('d-none');
                                    thankYouDiv.classList.add('d-block');
                                    setTimeout(function () {
                                        thankyouMessage.innerHTML = data.SuccessMessage;
                                    }, 50);
                                }
                                _context.next = 17;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context['catch'](1);

                                console.log(_context.t0);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1, 14]]);
            }));

            return function signUp() {
                return _ref.apply(this, arguments);
            };
        }();

        // signup button
        marketingSignUp.addEventListener('click', function (e) {
            e.preventDefault();
            signUp();
        });
    }
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = setSpeedBumpClassLinks;
function setSpeedBumpClassLinks(speedBumpSelector, linkId) {
    var speedBumps = document.querySelectorAll(speedBumpSelector);
    var speedBumpLink = document.querySelector(linkId);

    window.activeSpeedBumpLink = null;

    Array.from(speedBumps).forEach(function (element, index) {
        if (!element.hasAttribute('speed-bump-set')) {
            element.addEventListener('click', function (event) {
                event.preventDefault();
                window.activeSpeedBumpLink = event.currentTarget;
                speedBumpLink.setAttribute('href', event.currentTarget.getAttribute('href'));

                // Call the hidden Vue speedbump
                speedBumpLink.click();
            });

            element.setAttribute('speed-bump-set', '');
        }
    });
}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = skipToLink;
function skipToLink(selector) {
    var skipLink = document.querySelector(selector);

    if (skipLink) {
        skipLink.addEventListener('click', function (evt) {
            evt.preventDefault();

            var target = document.querySelector(evt.target.getAttribute('href'));
            target.focus();
        });
    }
}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = initSelectAll;
function initSelectAll() {
    var selectAllCheckbox = document.querySelectorAll('[select-all]');

    var _loop = function _loop(i) {
        var parent = selectAllCheckbox[i].getAttribute('select-all');
        var checkboxGroup = document.querySelectorAll(parent + ' input[type=checkbox]');

        selectAllCheckbox[i].addEventListener('change', function (evt) {
            if (parent) {
                for (var j = 0; j < checkboxGroup.length; j++) {
                    checkboxGroup[j].checked = selectAllCheckbox[i].checked;
                }
            }
        });

        var _loop2 = function _loop2(j) {
            checkboxGroup[j].addEventListener('change', function (evt) {
                if (evt.target.checked === false) {
                    selectAllCheckbox[i].checked = checkboxGroup[j].checked;
                } else {
                    var checkedBoxes = document.querySelectorAll(parent + ' input[type=checkbox]:checked');
                    if (checkedBoxes.length === checkboxGroup.length - 1) {
                        selectAllCheckbox[i].checked = checkboxGroup[j].checked;
                    }
                }
            });
        };

        for (var j = 0; j < checkboxGroup.length; j++) {
            _loop2(j);
        }
    };

    for (var i = 0; i < selectAllCheckbox.length; i++) {
        _loop(i);
    }
}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = speedBumpTabbing;
function speedBumpTabbing() {
    var twoClickClass = document.getElementsByClassName('twoClick');
    var speedBumpTrapFocus = function speedBumpTrapFocus() {
        var el = document.getElementById('speed-bump');
        var focusableEls = el.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
        var firstFocusableEl = focusableEls[1];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        var KEYCODE_TAB = 9;

        el.addEventListener('keydown', function (e) {
            var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
            if (!isTabPressed) {
                return;
            }
            if (e.shiftKey) {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    };

    for (var i = 0; i < twoClickClass.length; i++) {
        twoClickClass[i].addEventListener('click', function () {
            speedBumpTrapFocus();
        }, false);
    }
}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = customEventPolyfill;
function customEventPolyfill() {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    var isStorage = false;
    try {
        isStorage = 'localStorage' in window && window.localStorage != null;
    } catch (e) {
        // console.log('no storage');
    }
    init(isStorage);
};

function init(isStorage) {
    if (!isStorage) {
        var Storage = function Storage() {};
        Storage.prototype.setItem = function (id, val) {
            this[id] = JSON.stringify(val);
        };
        Storage.prototype.getItem = function (id) {
            return this.hasOwnProperty(id) ? this[id] : null;
        };
        Storage.prototype.removeItem = function (id) {
            return delete this[id];
        };

        Storage.prototype.clear = function () {
            var self = this;
            Object.keys(this).map(function (key) {
                self.removeItem(key);
            });
        };

        window.localStorage = new Storage();
    }
}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modules = __webpack_require__(456);

var stores = _interopRequireWildcard(_modules);

var _lodash = __webpack_require__(23);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/* eslint-disable no-console */
exports['default'] = {
    inserted: function inserted(el, binding) {
        var redirectOnEmptyUrl = el.getAttribute('redirect-on-empty');

        if (!binding.arg || !(0, _lodash.isString)(binding.value)) {
            el.remove();
            return;
        }

        var storeName = (0, _lodash.startCase)(binding.arg).replace(' ', '') + 'Module';
        var store = (0, _lodash.isEmpty)(stores[storeName]) ? null : stores[storeName];

        if (!store || (0, _lodash.isEmpty)(store.state)) {
            return;
        }

        if ((0, _lodash.isFunction)(store.mutations.initializeStore)) {
            store.mutations.initializeStore();
        }

        var value = store.state[binding.value];

        if ((0, _lodash.isString)(value)) {
            el.value = value;
        }

        if ((0, _lodash.isArray)(value)) {
            value.forEach(function (v, i) {
                if (i === 0) {
                    el.value = v;
                } else {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = el.name;
                    input.value = v;
                    el.insertAdjacentElement('afterend', input);
                }
            });
        }

        if (redirectOnEmptyUrl && (0, _lodash.isEmpty)(value)) {
            window.location.href = redirectOnEmptyUrl;
        }
    }
};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardSelectorModule = undefined;

var _cardSelector = __webpack_require__(55);

var _cardSelector2 = _interopRequireDefault(_cardSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.CardSelectorModule = _cardSelector2['default'];

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(23);

var DEFAULT_PLACE_HOLDER = '_'; /* eslint-disable no-unused-vars */


var MaskTypes = {
    phone: {
        mask: [/[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
        validation: function validation(val) {
            return true;
        }
    },
    date: {
        mask: [/[0-1]/, /[0-9]/, '/', /[0-3]/, /[0-9]/, '/', /[12]/, /[0-9]/, /[0-9]/, /[0-9]/]
    }
};
var convertMask = function convertMask() {
    var mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var placeholderChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PLACE_HOLDER;

    if (!(0, _lodash.isArray)(mask)) {
        throw new Error('Text-mask:convertMaskToPlaceholder; The mask property must be an array.');
    }

    if (mask.indexOf(placeholderChar) !== -1) {
        throw new Error('Placeholder character must not be used as part of the mask. Please specify a character ' + 'that is not present in your mask as your placeholder character.\n\n' + ('The placeholder character that was received is: ' + JSON.stringify(placeholderChar) + '\n\n') + ('The mask that was received is: ' + JSON.stringify(mask)));
    }

    return mask.map(function (char) {
        return char instanceof RegExp ? placeholderChar : char;
    }).join('');
};

exports['default'] = {
    bind: function bind(el, binding, vnode) {
        if (MaskTypes[binding.value]) {
            var mask = MaskTypes[binding.value].mask;

            el.addEventListener('keydown', function (evt) {
                var key = evt.key;
                var pos = el.value.length;
                var oldValue = el.value;
                var keyCode = evt.which;

                if (keyCode === 9 || keyCode === 37 || keyCode === 39) {
                    return;
                }

                if (key === 'Backspace') {
                    el.value = el.value.substr(0, el.value.length - 1);
                    if (!(mask[el.value.length] instanceof RegExp)) {
                        el.value = el.value.substr(0, el.value.length - 1);
                    }
                    return evt.preventDefault();
                }

                if (pos >= mask.length) {
                    return evt.preventDefault();
                }

                var cancel = false;

                var val = mask.map(function (char, maskIndex) {
                    var isRexEx = char instanceof RegExp;

                    if (isRexEx) {
                        if (maskIndex < pos) {
                            var oldChar = oldValue.charAt(maskIndex);
                            if (char.test(oldChar)) {
                                return oldChar;
                            } else {
                                cancel = true;
                            }
                        }
                        if (maskIndex === pos) {
                            return (/\w/.test(key) ? key : ''
                            );
                        }
                    } else {
                        return char;
                    }

                    return DEFAULT_PLACE_HOLDER;
                });

                if (!mask[pos].test(evt.key)) {
                    evt.preventDefault();
                }
            });
            el.addEventListener('keyup', function (evt) {
                var pos = el.value.length;
                var key = evt.key;

                if (key === 'Backspace') {
                    if (pos > 1) {
                        var mapChar = mask[pos];
                        var isRexEx = mapChar instanceof RegExp;
                    }
                }

                if (pos < mask.length) {
                    var _mapChar = mask[pos];
                    var _isRexEx = _mapChar instanceof RegExp;
                    if (!_isRexEx) {
                        el.value += _mapChar;
                    }
                }
            });
            el.addEventListener('change', function (evt) {
                var phoneFormat = RegExp(/^(\d{3})-(\d{3})-(\d{4})$/);

                if (binding.value === 'phone') {
                    var isFormatted = phoneFormat.test(evt.target.value);

                    if (evt.target.value.length > 0 && !isFormatted) {
                        evt.target.value = evt.target.value.replace(/[^0-9]/g, '').replace(/^(\d{3})?(\d{3})?(\d{4})?/g, '$1-$2-$3');
                    }
                }
            });
        }
    }
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    inserted: function inserted(el, binding, vnode) {
        // const stickyPos = el.offsetTop;
        var stickyPos = 0;

        var Scroll = function Scroll() {
            if (window.pageYOffset > stickyPos) {
                el.classList.add('sticky');
                document.body.classList.add('has-sticky');
            } else {
                if (el.classList.contains('sticky')) {
                    el.classList.remove('sticky');
                    if (document.body.classList.contains('has-sticky')) {
                        document.body.classList.remove('has-sticky');
                    }
                }
            }
        };

        // detect if have child - sticky logo
        if (el.querySelector('.sticky__logo')) {
            var stickyParent = el.querySelector('.c-top-nav__logo');
            stickyParent.classList.add('does-fade-out');
            var stickylogo = el.querySelector('.sticky__logo img');
            stickylogo.style.cssText = 'display: block; opacity: 0;';
        }

        window.onscroll = Scroll;
    }
};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function () {
  document.addEventListener("DOMContentLoaded", function () {
    var API_TRIGGER_GOAL = window.location.origin + "/aha-service/analytics/TriggerGoal";
    var API_TRACK_EVENT = window.location.origin + "/aha-service/analytics/trackevent";
    var API_EXTERNAL_LINK = window.location.origin + "/aha-service/analytics/TrackPageVisitExternalLinks/";
    // D A T A  T R A C K I N G  A T T R I B U T E
    var trackingEls = document.querySelectorAll("[data-tracking]");
    // L O O P
    Array.prototype.forEach.call(trackingEls, function (el) {
      // CLICK HANDLER
      el.addEventListener("click", function (e) {
        if (e.currentTarget.getAttribute("data-tracking") === "") {
          return;
        }
        if (e.currentTarget.tagName === "A") {
          e.preventDefault();
          var _link = e.currentTarget.getAttribute("href");
          var _target = e.currentTarget.getAttribute("target");
          // get current target that has class twoClick and set it to a variable to use later
          var _twoClick = e.currentTarget.classList.contains("twoClick");
          // get the link in the modal that has the text that says "proceed" and set it to a variable to use later
          var _proceedLink = document.querySelector(".proceed");
        }
        var data = el.getAttribute("data-tracking");
        // Convert single quote to double quote, JSON format specific
        data = data.replace(/'/g, '"');
        var obj = JSON.parse(data);
        // Destructuring assignments

        var goalId = obj.goalId,
            pageEvent = _objectWithoutProperties(obj, ["goalId"]);

        var goalObj = { goalId: goalId };
        var trackEventObj = pageEvent;
        if (Object.keys(goalObj).length !== 0 && goalObj.constructor === Object) {
          postData(API_TRIGGER_GOAL, goalObj);
        }
        if (Object.keys(trackEventObj).length !== 0 && trackEventObj.constructor === Object) {
          postData(API_TRACK_EVENT, trackEventObj);
        }
        if (_twoClick) {
          _proceedLink.addEventListener("click", function () {
            if (_link !== "#") {
              setTimeout(function () {
                window.open(_link, _target);
              }, 250);
            }
          });
        }
        // commenting out to stop opening new tab and letting the link work as normal
        if (e.currentTarget.tagName === "A") {
          if (e.currentTarget.getAttribute("href") !== "#") {
            setTimeout(function () {
              // if target is null, open in same window else open in _target
              if (_target === null) {
                window.location.href = _link;
              } else {
                window.open(_link, _target);
              }
            }, 250);
          }
        }
      });
      //  handleExternalTrackingClick(e, API_EXTERNAL_LINK)
    });
    // E N D  L O O P
    /* eslint-disable-next-line */
    //data-external-tracking attribute globally, implemented on FE - Bharath and BE - Nicky - PHD only
    var dataTrackingEls = document.querySelectorAll("[data-external-tracking]");
    // Loop over each element with data-external-tracking
    Array.prototype.forEach.call(dataTrackingEls, function (el) {
      // Add click event listener
      el.addEventListener("click", function (e) {
        // Ensure e.currentTarget is not null before accessing properties
        if (!e.currentTarget || e.currentTarget.getAttribute("data-external-tracking") === "") {
          return;
        }
        // Check that e.currentTarget exists before using tagName
        if (e.currentTarget && e.currentTarget.tagName === "A") {
          e.preventDefault();
          var _link = e.currentTarget.getAttribute("href");
          var _target = e.currentTarget.getAttribute("target");
        }
        // Get and parse the data-external-tracking attribute
        var dataTrackingExternal = e.currentTarget.getAttribute("data-external-tracking");
        if (!dataTrackingExternal) {
          console.error("data-external-tracking attribute is missing");
          return;
        }
        try {
          // Replace single quotes with double quotes to parse the JSON
          dataTrackingExternal = dataTrackingExternal.replace(/'/g, '"');
          var objTracking = JSON.parse(dataTrackingExternal);
          // Extract itemId and remove curly braces
          var itemId = objTracking.itemId;
          if (!itemId) {
            console.error("itemId is missing in data-external-tracking JSON");
            return;
          }
          itemId = itemId.replace(/{|}/g, "");
          // Create globalItem and send it in API call
          var globalItem = { itemId: itemId };
          if (Object.keys(globalItem).length !== 0) {
            postData(API_EXTERNAL_LINK, globalItem);
          }
          if (e.currentTarget.tagName === "A") {
            if (e.currentTarget.getAttribute("href") !== "#") {
              setTimeout(function () {
                // if target is null, open in same window else open in _target
                if (_target === null) {
                  window.location.href = _link;
                } else {
                  window.open(_link, _target);
                }
              }, 250);
            }
          }
        } catch (error) {
          console.error("Error parsing data-external-tracking JSON:", error);
        }
      });
    });
    // E N D  L O O P DATA EXTERNAL TRACKING
    // P O S T
    function postData(api, dataObj) {
      /* eslint-disable-next-line */
      fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(dataObj)
      }).then(function (response) {
        // if there is a response from the server
        if (response) {
          return response.json();
        }
      }).then(function (result) {
        if (result) {
          // log response
          // console.log('RESPONSE', result);
        }
      })["catch"](function (error) {
        if (error.constructor === Object) {
          /* eslint-disable-next-line */
          console.error("ERROR:", error);
        }
      })["finally"](function () {
        // console.log('Promise done');
      });
    }
  });
};

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _jsCookie = __webpack_require__(91);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable */


function postData(api, dataObj) {
  /* eslint-disable-next-line */
  fetch(api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(dataObj)
  }).then(function (response) {
    // if there is a response from the server
    if (response) {
      return response.json();
    }
  }).then(function (result) {
    if (result) {
      // log response
      // console.log('RESPONSE', result);
    }
  })["catch"](function (error) {
    if (error.constructor === Object) {
      /* eslint-disable-next-line */
      console.error("ERROR:", error);
    }
  })["finally"](function () {
    // console.log('Promise done');
  });
}

// Function to add event listeners to elements with data-external-tracking
var API_EXTERNAL_LINK = window.location.origin + "/aha-service/analytics/TrackPageVisitExternalLinks/";
function attachEventListeners(dataTrackingEls) {
  Array.prototype.forEach.call(dataTrackingEls, function (el) {
    // Check if the event listener is already attached
    if (!el.dataset.trackingInitialized) {
      el.dataset.trackingInitialized = true; // Mark as initialized
      el.addEventListener("click", function (e) {
        // Ensure e.currentTarget is not null before accessing properties
        if (!e.currentTarget || e.currentTarget.getAttribute("data-external-tracking") === "") {
          return;
        }
        // Check that e.currentTarget exists before using tagName
        if (e.currentTarget && e.currentTarget.tagName === "A") {
          e.preventDefault();
          var _link = e.currentTarget.getAttribute("href");
          var _target = e.currentTarget.getAttribute("target");
        }
        // Get and parse the data-external-tracking attribute
        var dataTrackingExternal = e.currentTarget.getAttribute("data-external-tracking");
        if (!dataTrackingExternal) {
          console.error("data-external-tracking attribute is missing");
          return;
        }
        try {
          // Replace single quotes with double quotes to parse the JSON
          dataTrackingExternal = dataTrackingExternal.replace(/'/g, '"');
          var objTracking = JSON.parse(dataTrackingExternal);

          // Extract itemId and remove curly braces
          var itemId = objTracking.itemId || objTracking.itemid;
          if (!itemId) {
            console.error("itemId is missing in data-external-tracking JSON");
            return;
          }
          itemId = itemId.replace(/{|}/g, "");

          // Create globalItem and send it in API call
          var globalItem = { itemId: itemId };
          if (Object.keys(globalItem).length !== 0) {
            postData(API_EXTERNAL_LINK, globalItem);
          }
          if (e.currentTarget.tagName === "A") {
            if (e.currentTarget.getAttribute("href") !== "#") {
              setTimeout(function () {
                // if target is null, open in same window else open in _target
                if (_target === null) {
                  window.location.href = _link;
                } else {
                  window.open(_link, _target);
                }
              }, 250);
            }
          }
        } catch (error) {
          console.error("Error parsing data-external-tracking JSON:", error);
        }
      });
    }
  });
}

// Initialize MutationObserver
var observer = new MutationObserver(function (mutationsList) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var mutation = _step.value;

      if (mutation.type === "childList") {
        // Query newly added elements
        var newElements = document.querySelectorAll("[data-external-tracking]");
        attachEventListeners(newElements);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"]) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
});

// Start observing the document body for added nodes
observer.observe(document.body, {
  childList: true, // Look for added/removed nodes
  subtree: true // Monitor all descendants
});
// Run the function for any elements already present on the page
var existingElements = document.querySelectorAll("[data-external-tracking]");
if (existingElements.length > 0) {
  attachEventListeners(existingElements);
}
// Expose it globally
function handleAhaModalClose() {
  var modalVideo = document.getElementById("communityEmbedVideo");
  if (modalVideo) {
    modalVideo.src = "";
  }
}
function showVideoModal(e) {
  var videoid = e.currentTarget.getAttribute("videoid");
  var videotitle = e.currentTarget.getAttribute("videotitle");
  var videotypelink = e.currentTarget.getAttribute("videotypelink");
  var videofullcontentlink = e.currentTarget.getAttribute("videofullcontentlink");
  var videoteaser = e.currentTarget.getAttribute("videoteaser");
  var id = e.currentTarget.getAttribute("id");
  var videocategoryid = e.currentTarget.getAttribute("videoCategoryId");
  window.ahavm.$root.$emit("bv::show::modal", "communitiesVideoModal");
  var modalCategoryId = document.getElementById("videoCategoryId");
  modalCategoryId.Value = videocategoryid;
  var modalVideoItemId = document.getElementById("videoItemId");
  modalVideoItemId.Value = id;
  var modalVideo = document.getElementById("communityEmbedVideo");
  modalVideo.src = videotypelink.replace("{id}", videoid);
  var modalTitle = document.getElementById("modalTitle");
  modalTitle.innerText = videotitle;
  var modalTeaser = document.getElementById("modalTeaser");
  modalTeaser.innerText = videoteaser;
  var fullLink = document.getElementById("aFullContentLink");
  fullLink.href = videofullcontentlink + "?id=" + id;
  var newUrl = new URL(window.location);
  newUrl.searchParams.set("videoid", id);
  window.history.replaceState(null, "", newUrl);
  getVideoDetails(id, videocategoryid);
  if (videofullcontentlink.includes("$$CS$$")) {
    var link = videofullcontentlink.split("$$CS$$");
    fullLink.href = link[0];
    fullLink.target = link[1];
  }
}
window.handleAhaModalClose = handleAhaModalClose;
window.showVideoModal = showVideoModal;

function getVideoDetails(videoid, videocategoryid) {
  var videoDetails = {
    videoId: videoid,
    categoryId: videocategoryid
  };
  var uri = window.location.origin + "/aha-service/PHDApi/IsVideoSaved";
  _axios2["default"].post(uri, videoDetails).then(function (res) {
    if (res.data === null) {
      return;
    }
    var isSaved = res.data;
    window.dispatchEvent(new CustomEvent("globalFunctionTriggered", {
      detail: { data: res.data }
    }));
  })["catch"](function (err) {
    console.log(err);
  });
}

function getQueryParam(param) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

var videoID = getQueryParam("videoid");
var hostname = window.location.hostname;

var baseDomain = void 0;

if (hostname.includes("d1-cd-professional.sc.heart.org")) {
  baseDomain = "https://d1-cd-professional.sc.heart.org"; // Staging
} else if (hostname.includes("u1-cd-professional.sc.heart.org")) {
  baseDomain = "https://u1-cd-professional.sc.heart.org"; // UAT
} else if (hostname.includes("professional.heart.org")) {
  baseDomain = "https://professional.heart.org"; // Production
} else {
  baseDomain = "http://localhost:3000"; // Development
}

if (videoID) {
  window.onload = function () {
    var signupUri = {
      base: baseDomain + "/aha-service/PHDApi/LookUpVideoId?videoid=",
      "default": "",
      upgrade: ""
    };
    _axios2["default"].get("" + signupUri.base + videoID).then(function (res) {
      if (res.data === null) {
        window.ahavm.$root.$emit("bv::show::modal", "videoNotFoundModal");
        return;
      }
      var videoDetails = {
        id: videoID,
        typeLink: res.data.videotypelink,
        title: res.data.videotitle,
        teaser: res.data.videoteaser,
        fullContentLink: res.data.videofullcontentlink
      };
      // Populate modal elements
      var modalVideo = document.getElementById("communityEmbedVideo");
      if (modalVideo) {
        modalVideo.src = videoDetails.typeLink.replace("{id}", videoDetails.id);
      }
      var modalTitle = document.getElementById("modalTitle");
      if (modalTitle) {
        modalTitle.innerText = videoDetails.title;
      }
      var modalTeaser = document.getElementById("modalTeaser");
      if (modalTeaser) {
        modalTeaser.innerText = videoDetails.teaser;
      }
      var fullLink = document.getElementById("aFullContentLink");
      if (fullLink) {
        fullLink.href = videoDetails.fullContentLink.replace("{id}", videoDetails.id);

        // Adjust target if $$CS$$ is included
        if (videoDetails.fullContentLink.includes("$$CS$$")) {
          var link = videoDetails.fullContentLink.split("$$CS$$");
          fullLink.href = link[0];
          fullLink.target = link[1];
        }
      }
      // Show the modal
      window.ahavm.$root.$emit("bv::show::modal", "communitiesVideoModal");
    })["catch"](function (err) {
      console.log(err);
    });
  };
}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
exports['default'] = {
    inserted: function inserted(el) {
        // Append course id and zip code to provided form action
        el.onsubmit = function (e) {
            var courseIdEl = el.querySelector('#courseid');
            var courseZipCodeEl = el.querySelector('#zipcode');
            var originalFormAction = el.getAttribute('action');
            var newFormAction = originalFormAction;

            if (courseIdEl && courseIdEl.value) {
                newFormAction += '&courseid=' + courseIdEl.value;
                if (courseZipCodeEl && courseZipCodeEl.value) {
                    newFormAction += '&zipcode=' + courseZipCodeEl.value;
                }
            }

            el.action = encodeURI(newFormAction);
        };
    }
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
/** Date: 4/16/2021*/
/*PHD Pro Volunteer Search Form*/
exports['default'] = {
    inserted: function inserted(el) {
        var regionInput1 = document.getElementById('ahaRegionSelected'); // dropdown 1
        var regionInput2 = document.getElementById('domesticRegionSelected'); // dropdown 2
        var regionInput3 = document.getElementById('internationalRegionSelected'); // dropdown 3

        regionInput1.style.display = "block";
        regionInput2.style.display = "none";
        regionInput3.style.display = "none";

        document.addEventListener('click', function (event) {
            if (event.target.matches('input[name="region"]')) {
                var region = document.getElementsByName('region');

                var i;
                for (i = 0; i < region.length; i++) {
                    if (region[i].checked) {
                        if (region[i].value == 1) {
                            console.log("AHA Region");
                            regionInput1.style.display = "block";
                            regionInput2.style.display = "none";
                            regionInput3.style.display = "none";
                            break;
                        }
                        if (region[i].value == 2) {
                            console.log("Domestic");
                            regionInput1.style.display = "none";
                            regionInput2.style.display = "block";
                            regionInput3.style.display = "none";
                            break;
                        }
                        if (region[i].value == 3) {
                            console.log("International");
                            regionInput1.style.display = "none";
                            regionInput2.style.display = "none";
                            regionInput3.style.display = "block";
                            break;
                        }
                        region[i].addEventListener('click', function (event) {
                            console.log('clicked');
                        }, false);
                    }
                }
            }
        }, false);
    }
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable */
'use-strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dropdown = __webpack_require__(463);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _eventBus = __webpack_require__(156);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _EVENT_BUS = new _eventBus2['default']();

var _SELECTOR = 'vjs-dropdown';

// ES6 Symbols to hide private Class functions from public scope
var _externalClick = Symbol('externalClick');
var _externalClickHandler = Symbol('externalClickHandler');

var VJSDropdown = function () {
    function VJSDropdown() {
        var _this = this;

        _classCallCheck(this, VJSDropdown);

        this.elements = null;
        this.store = [];
        this.initialized = false;

        this[_externalClickHandler] = function (evt) {
            return _this[_externalClick](evt);
        };
    }

    /* START: Public */

    _createClass(VJSDropdown, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            // Select all _SELECTOR elements
            this.elements = document.querySelectorAll('[' + _SELECTOR + ']');
            // If this hasn't been initialized....
            if (!this.initialized) {
                // Loop through plugin elements and create and initialize a dropdown instance
                Array.prototype.forEach.call(this.elements, function (el) {
                    var target = document.getElementById(el.getAttribute(_SELECTOR));
                    if (target && target.nodeType) {
                        var dropdown = new _dropdown2['default']({ el: el, target: target });
                        dropdown.init();
                        _this2.store.push(dropdown);
                    }
                });
                // Add event listener to window to close all dropdowns on click outside of dropdown
                window.addEventListener('click', this[_externalClickHandler]);
                this.initialized = true;
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.store.forEach(function (dropdown) {
                return dropdown.destroy();
            });
            this.store = [];
            window.removeEventListener('click', this[_externalClickHandler]);
            _EVENT_BUS.emit('vjs-dropdown:open', { id: '' });
            this.initialized = false;
        }

        /* END: Public */

        /* START: Private */

        // Check if window click is a dropdown item

    }, {
        key: _externalClick,
        value: function value(evt) {
            var src = evt.srcElement;
            var isDropdown = false;
            var i = 0;
            do {
                if (this.elements[i]) {
                    var target = document.getElementById(this.elements[i].getAttribute(_SELECTOR));
                    if (target) {
                        if (this.elements[i] === src || target === src) {
                            isDropdown = true;
                        }
                    }
                }
                i++;
            } while (!isDropdown && i < this.elements.length);
            if (!isDropdown) {
                _EVENT_BUS.emit('vjs-dropdown:open', { id: '' });
            }
        }

        /* END: Private */

    }]);

    return VJSDropdown;
}();

exports['default'] = VJSDropdown;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use-strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uniqid = __webpack_require__(62);

var _uniqid2 = _interopRequireDefault(_uniqid);

var _popper = __webpack_require__(53);

var _popper2 = _interopRequireDefault(_popper);

var _eventBus = __webpack_require__(156);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _EVENT_BUS = new _eventBus2['default']();

var _POPPER_CONFIG = {
    placement: 'bottom',
    modifiers: {
        computeStyle: {
            gpuAcceleration: false
        },
        flip: {
            enabled: false
        },
        preventOverflow: {
            enabled: true,
            escapeWithReference: true
        }
    }
};

var _DROPDOWN_ROLE = 'listbox';
var _DROPDOWN_CHILD_ROLE = 'menuitem';
var _ITEM_SELECTOR = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]';
var _DOWN_ARROW = 40;
var _UP_ARROW = 38;

// ES6 Symbols to hide private Class functions from public scope
var _openMenu = Symbol('openMenu');
var _closeMenu = Symbol('closeMenu');
var _toggleAriaExpanded = Symbol('toggleAriaExpanded');
var _checkRoles = Symbol('checkRoles');
var _focusInit = Symbol('focusInit');
var _focusCtrl = Symbol('focusCtrl');
var _focusCtrlHandler = Symbol('focusCtrlHandler');
var _nextFocusable = Symbol('nextFocusable');
var _closeOnEvent = Symbol('closeOnEvent');
var _closeOnEventHandler = Symbol('closeOnEventHandler');
var _createPopper = Symbol('createPopper');
var _removePopper = Symbol('removePopper');

var Dropdown = function () {
    function Dropdown(_ref) {
        var _this2 = this;

        var el = _ref.el,
            target = _ref.target,
            _ref$toggleClass = _ref.toggleClass,
            toggleClass = _ref$toggleClass === undefined ? 'show' : _ref$toggleClass;

        _classCallCheck(this, Dropdown);

        var _this = this;

        this.uniqueId = (0, _uniqid2['default'])();
        this.el = el;
        this.target = target;
        this.focusable = target.querySelectorAll(_ITEM_SELECTOR);
        this.toggleClass = toggleClass;

        this.popper = null;

        this.open = false;
        this.initialized = false;

        this.toggleHandler = function () {
            return _this2.toggle();
        };

        this[_closeOnEventHandler] = function (evt) {
            return _this2[_closeOnEvent](evt);
        };
        this[_focusCtrlHandler] = function (evt) {
            _this[_focusCtrl](evt, this);
        };
    }

    /* START: Public */

    _createClass(Dropdown, [{
        key: 'init',
        value: function init() {
            this.el.addEventListener('click', this.toggleHandler);
            this.el.setAttribute('aria-haspopup', true);
            this[_toggleAriaExpanded]();
            this[_checkRoles]();
            this.initialized = true;
        }

        // Toggle dropdown visibility

    }, {
        key: 'toggle',
        value: function toggle() {
            this.target.classList.toggle(this.toggleClass);
            this.open = !this.open;
            this[_toggleAriaExpanded]();
            if (this.open) this[_openMenu]();else this[_closeMenu]();
        }

        // Destroy VanillaJS dropdown instance

    }, {
        key: 'destroy',
        value: function destroy() {
            this.el.removeEventListener('click', this.toggleHandler);
        }

        /* END: Public */

        /* START: Private */

        // Open/Close controls

    }, {
        key: _openMenu,
        value: function value() {
            this[_focusInit]();
            this[_createPopper]();
            _EVENT_BUS.emit('vjs-dropdown:open', { id: this.uniqueId });
            _EVENT_BUS.on('vjs-dropdown:open', this[_closeOnEventHandler]);
        }
    }, {
        key: _closeMenu,
        value: function value() {
            this[_removePopper]();
            _EVENT_BUS.off('vjs-dropdown:open', this[_closeOnEventHandler]);
        }

        // Toggle Aria controls

    }, {
        key: _toggleAriaExpanded,
        value: function value() {
            this.el.setAttribute('aria-expanded', this.open);
        }

        // Check role attribute on dropdown & children for accessibilty

    }, {
        key: _checkRoles,
        value: function value() {
            var children = this.target.children;
            this.target.setAttribute('role', _DROPDOWN_ROLE);
            Array.prototype.filter.call(children, function (child) {
                return child.setAttribute('role', _DROPDOWN_CHILD_ROLE);
            });
        }

        // Focus on first focusable item and initialize focus controls

    }, {
        key: _focusInit,
        value: function value() {
            var _this3 = this;

            this.focusable[0].focus();
            Array.prototype.forEach.call(this.focusable, function (item) {
                item.addEventListener('keydown', _this3[_focusCtrlHandler]);
            });
        }

        // Control focus in menu via arrow keys

    }, {
        key: _focusCtrl,
        value: function value(evt, el) {
            if (evt.keyCode === _DOWN_ARROW || evt.keyCode === _UP_ARROW) {
                evt.preventDefault();
                var next = this[_nextFocusable](el, evt.keyCode);
                if (next) {
                    next.focus();
                }
            }
        }

        // Select next focusable element

    }, {
        key: _nextFocusable,
        value: function value(el, keyCode) {
            return keyCode === _DOWN_ARROW ? el.nextElementSibling : el.previousElementSibling;
        }

        // Close when another Vanilla JS dropdown is opened

    }, {
        key: _closeOnEvent,
        value: function value(evt) {
            if (evt.detail.id !== this.uniqueId) {
                this.toggle();
            }
        }

        // Popper controls

    }, {
        key: _createPopper,
        value: function value() {
            if (typeof _popper2['default'] === 'undefined') {
                /* eslint-disable-next-line */
                console.log('vjs-dropdown: Popper.js not found. Falling back to CSS positioning.');
            } else {
                this[_removePopper]();
                this.popper = new _popper2['default'](this.el, this.target, { _POPPER_CONFIG: _POPPER_CONFIG });
            }
        }
    }, {
        key: _removePopper,
        value: function value() {
            if (this.popper) this.popper.destroy();
            this.popper = null;
        }

        /* END: Private */

    }]);

    return Dropdown;
}();

exports['default'] = Dropdown;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    document.addEventListener('DOMContentLoaded', function () {
        var cprSearchInterface = document.querySelectorAll('.CoveoSearchInterface');
        var cSearch = cprSearchInterface[cprSearchInterface.length - 1];
        if (window.Coveo && cSearch && typeof window.Coveo !== 'undefined') {
            setTimeout(function () {
                // Coveo dropdown
                window.VJSDropdown.destroy();
                window.VJSDropdown.init();
                window.Coveo.$$(cSearch).on('newResultsDisplayed', function (e, args) {
                    window.VJSDropdown.destroy();
                    window.VJSDropdown.init();
                });
            }, 1000);
        }
    });
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    document.addEventListener('DOMContentLoaded', function () {
        var SearchInterfaceID = '_185F67BF-1D73-4AEE-9564-FDE5B0EB24D9';
        var SearchInterface = document.querySelectorAll('#' + SearchInterfaceID);
        var cSearch = SearchInterface[SearchInterface.length - 1];
        var phdArchiveSearchInterface = document.querySelector('.c-expand-search--archive .coveo-search-section div');
        var impactMapSearchInterface = document.querySelector('.impact-map .CoveoSearchInterface');
        var coveoMainSection = document.querySelector('.coveo-main-section');
        var observerStarted = false;
        var observer = new window.MutationObserver(filtersButtonAddedObserver);

        if (window.Coveo && cSearch && typeof window.Coveo !== 'undefined') {
            window.Coveo.$$(cSearch).on('beforeInitialization', function (e, args) {
                // Add alert popup to notify user when showing archived content
                var phdArchiveTab = window.document.querySelector('.CoveoTab[data-caption="Archives"]');

                if (phdArchiveTab) {
                    phdArchiveTab.addEventListener('click', archiveTabListener);
                    phdArchiveTab.addEventListener('keyup', archiveTabListener);
                }

                function archiveTabListener(e) {
                    if (e.type === 'keyup' && e.keyCode !== 13) {
                        return;
                    }

                    if (!e.currentTarget.classList.contains('coveo-selected')) {
                        window.alert('By applying this filter, only archived content will be presented. This content is preserved for historical reasons only.');
                    }
                }
            });

            window.Coveo.$$(cSearch).on('afterInitialization', function (e, args) {
                // Set Publish Date Facet Slider to today's date if it exists
                var coveoFacetSlider = document.querySelector('.CoveoFacetSlider');
                var currentDate = new Date();

                if (coveoFacetSlider) {
                    var facetSliderInstance = window.Coveo.get(coveoFacetSlider);
                    currentDate.setHours(0);
                    currentDate.setMinutes(0);
                    currentDate.setSeconds(0);
                    currentDate.setMilliseconds(0);
                    facetSliderInstance.initialEndOfSlider = currentDate.getTime();
                }
            });

            window.Coveo.$$(cSearch).on('noResults', function (e, args) {
                // Make Filters button visible after noResults event fired
                setFiltersButtonVisible();

                setTimeout(function () {
                    setFiltersButtonVisible();
                }, 1000);

                if (!observerStarted && coveoMainSection) {
                    observer.observe(coveoMainSection, { childList: true, subtree: true });
                    observerStarted = true;
                }
            });

            setTimeout(function () {
                // No results found event
                window.Coveo.$$(cSearch).on('deferredQuerySuccess', function (e, args) {
                    if (args.results.totalCount === 0) {
                        var coveoQuerySummaryCancelLastElement = cSearch.querySelector('.coveo-query-summary-cancel-last');
                        if (coveoQuerySummaryCancelLastElement) {
                            coveoQuerySummaryCancelLastElement.setAttribute('tabindex', '0');
                            coveoQuerySummaryCancelLastElement.setAttribute('role', 'button');
                            window.Coveo.$$(coveoQuerySummaryCancelLastElement).on('keypress', function (e) {
                                var keycode = e.keyCode ? e.keyCode : e.which;
                                if (keycode === 13 || keycode === 32) {
                                    window.Coveo.$$(coveoQuerySummaryCancelLastElement).trigger('click');
                                }
                            });
                        }
                    }
                });
            }, 1000);
        }

        // For archive search pages, get the search input box and set the searchPageUri to point to the archive tab
        if (window.Coveo && phdArchiveSearchInterface && typeof window.Coveo !== 'undefined') {
            window.Coveo.$$(phdArchiveSearchInterface).on('afterInitialization', function () {
                var archivePageSearchBox = document.querySelectorAll('.c-expand-search--archive .CoveoSearchInterface');
                if (archivePageSearchBox.length > 0) {
                    var archivePageSearchBoxComponent = window.Coveo.get(archivePageSearchBox[0], window.Coveo.SearchInterface);
                    // Set custom searchPageUri, 'coveo5514054d' is the hard coded archive tab ID/data-id
                    archivePageSearchBoxComponent.options.searchPageUri = '/search#t=coveo5514054d&sort=relevancy';
                }
            });
        }

        // For Impact Map, add Filters button when it is not rendered by Coveo
        if (window.Coveo && impactMapSearchInterface && typeof window.Coveo !== 'undefined') {
            window.Coveo.$$(impactMapSearchInterface).on('afterInitialization', function () {
                var timeout = false;

                // Coveo does not add the Filters button on tablet sizes, so manually add it
                if (window.innerWidth > 847 && window.innerWidth < 992) {
                    appendCustomFiltersButton();
                }

                // Apply or remove the custom filters button based on screen size as needed
                window.addEventListener('resize', function () {
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        if (window.innerWidth > 847 && window.innerWidth < 992) {
                            appendCustomFiltersButton();
                        } else {
                            removeCustomFiltersButton();
                        }
                    }, 500);
                });
            });

            window.Coveo.$$(impactMapSearchInterface).on('deferredQuerySuccess', function () {
                var facetColumnElement = impactMapSearchInterface.querySelector('.coveo-facet-column');
                var customFiltersButtonElement = impactMapSearchInterface.querySelector('button.coveo-facet-dropdown-header.coveo-dropdown-header.coveo-accessible-button.impact-map__custom-filters-button');

                if (facetColumnElement && customFiltersButtonElement && facetColumnElement.className.indexOf('coveo-no-results') === -1) {
                    facetColumnElement.className = 'coveo-facet-column coveo-facet-dropdown-content coveo-dropdown-content';
                    customFiltersButtonElement.className += ' coveo-dropdown-header-active';
                }
            });
        }

        // Append custom filters button and container to DOM
        function appendCustomFiltersButton() {
            var coveoStateSearchElement = impactMapSearchInterface.querySelector('.coveo-search-section');
            var previouslyAppendedCustomFiltersButton = impactMapSearchInterface.querySelector('.impact-map__custom-filters-button-container');

            if (coveoStateSearchElement && previouslyAppendedCustomFiltersButton === null) {
                var newFiltersButtonContainer = createCustomFiltersButtonContainer();
                var newFiltersButton = createCustomFiltersButton();
                newFiltersButtonContainer.appendChild(newFiltersButton);
                coveoStateSearchElement.parentNode.insertBefore(newFiltersButtonContainer, coveoStateSearchElement.nextSibling);
            }
        }

        // Remove appended custom filters button and container from DOM
        function removeCustomFiltersButton() {
            var customFiltersButtonContainer = impactMapSearchInterface.querySelector('.impact-map__custom-filters-button-container');

            if (customFiltersButtonContainer) {
                customFiltersButtonContainer.parentNode.removeChild(customFiltersButtonContainer);
            }
        }

        // Create Filters button container for Impact Map
        function createCustomFiltersButtonContainer() {
            var newDropdownHeaderWrapper = document.createElement('DIV');
            newDropdownHeaderWrapper.className = 'coveo-dropdown-header-wrapper impact-map__custom-filters-button-container';
            return newDropdownHeaderWrapper;
        }

        // Create Filters button link for Impact Map
        function createCustomFiltersButton() {
            var newFiltersButton = document.createElement('BUTTON');
            var newFiltersButtonText = document.createElement('P');
            newFiltersButton.className = 'coveo-facet-dropdown-header coveo-dropdown-header coveo-accessible-button coveo-dropdown-header-active impact-map__custom-filters-button';
            newFiltersButton.setAttribute('role', 'button');
            newFiltersButton.setAttribute('aria-label', 'Filters');
            newFiltersButton.setAttribute('tabindex', '0');
            newFiltersButtonText.innerHTML = 'Filters';

            newFiltersButton.addEventListener('click', function (e) {
                var facetColumnElement = impactMapSearchInterface.querySelector('.coveo-facet-column');

                if (facetColumnElement) {
                    if (e.currentTarget.className.indexOf('coveo-dropdown-header-active') === -1) {
                        e.currentTarget.className += ' coveo-dropdown-header-active';
                        facetColumnElement.className = 'coveo-facet-column coveo-facet-dropdown-content coveo-dropdown-content';
                        facetColumnElement.style.display = 'block';
                    } else if (e.currentTarget.className.indexOf('coveo-dropdown-header-active') > -1) {
                        e.currentTarget.className = 'coveo-facet-dropdown-header coveo-dropdown-header coveo-accessible-button impact-map__custom-filters-button';
                        facetColumnElement.className = 'coveo-facet-column';
                        facetColumnElement.style.display = 'none';
                    }
                }
            });

            newFiltersButton.appendChild(newFiltersButtonText);
            return newFiltersButton;
        }
    });

    // Observer callback when Filters button markup is added, removes the 'coveo-hidden' class
    function filtersButtonAddedObserver(mutationList) {
        mutationList.forEach(function (mutationRecord) {
            if (mutationRecord.target.classList.contains('coveo-dropdown-header-wrapper')) {
                mutationRecord.addedNodes.forEach(function (node) {
                    if (node.classList.contains('coveo-hidden') && node.ariaLabel === 'Filters') {
                        node.classList.remove('coveo-hidden');
                    }
                });
            }
        });
    }

    // Remove coveo-hidden class for Filters button
    function setFiltersButtonVisible(event) {
        var filtersButton = window.document.querySelector('a[aria-label="Filters"]');
        if (filtersButton) {
            filtersButton.classList.remove('coveo-hidden');
        }
    }

    var targetNode = document.body; // Or another relevant parent node
    var observerOptions = {
        childList: true, // Observe direct children
        subtree: true // Observe all descendants
    };

    var observerCallback = function observerCallback(mutationsList) {
        var siteCoreInProgressClass = document.querySelector('.pagemode-edit');

        if (!siteCoreInProgressClass) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var mutation = _step.value;

                    if (mutation.type === 'childList') {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = mutation.addedNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var node = _step2.value;

                                if (node.matches && node.matches('.magic-box-input input')) {
                                    var allMeganavSearch = document.querySelectorAll('.magic-box-input input');
                                    var allCoveoOmniboxDiv = document.querySelectorAll('.CoveoOmnibox.magic-box');

                                    if (allMeganavSearch) {
                                        allMeganavSearch.forEach(function (search) {
                                            search.setAttribute('title', 'Insert a query. Press enter to search.');
                                            search.setAttribute('aria-label', 'Search input field');
                                            search.removeAttribute('role');
                                            // According to Siteimprove's recommendation, the aria-expanded attribute should be removed.
                                            search.removeAttribute('aria-expanded');
                                        });
                                    }

                                    // According to Siteimprove's recommendation, the aria-haspopup attribute should be removed.
                                    if (allCoveoOmniboxDiv) {
                                        allCoveoOmniboxDiv.forEach(function (search) {
                                            search.removeAttribute('aria-haspopup');
                                        });
                                    }
                                }
                                // Added the tabindex attribute to Coveo search suggestion options to accessible using TalkBack (mobiles).
                                if (node.matches && node.matches('.magic-box-suggestions .magic-box-suggestion')) {
                                    var allMagicBoxSuggestions = document.querySelectorAll('.magic-box-suggestions .magic-box-suggestion');
                                    if (allMagicBoxSuggestions) {
                                        allMagicBoxSuggestions.forEach(function (suggestion) {
                                            suggestion.setAttribute('tabindex', '1');
                                        });
                                    }
                                }

                                // According to Siteimprove's recommendation, Removing the dynamic `aria-expanded` attribute on the Coveo search box.
                                var coveoAllSearchBox = document.querySelectorAll('.CoveoSearchbox');
                                if (coveoAllSearchBox) {
                                    coveoAllSearchBox.forEach(function (searchElement) {
                                        var searchInputField = searchElement.querySelector('input');
                                        if (searchInputField) {
                                            searchInputField.removeAttribute('aria-expanded');
                                        }
                                    });
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                                    _iterator2['return']();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };

    var observer = new window.MutationObserver(observerCallback);
    observer.observe(targetNode, observerOptions);
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    if (typeof FundraiseUp !== 'undefined' && typeof FundraiseUp === 'function') {
        /* eslint-disable-next-line */
        // console.log('::::::::::::::::FUNDRAISE UP::::::::::::::::::::::::::::::::');
        // Object
        var FRUSitecore = {};
        // Endpoints
        FRUSitecore.donationEndpoint = window.location.origin + '/aha-service/fundraise/track';
        FRUSitecore.goalEndpoint = window.location.origin + '/aha-service/analytics/TriggerGoal';
        FRUSitecore.eventEndpoint = window.location.origin + '/aha-service/analytics/trackevent';

        FRUSitecore.mapData = function (vendorDataObj) {
            /* eslint-disable */
            // Destructuring assignments
            var campaign = vendorDataObj.campaign,
                supporter = vendorDataObj.supporter,
                donation = vendorDataObj.donation,
                tribute = vendorDataObj.tribute,
                customFields = vendorDataObj.customFields;
            var id = campaign.id;


            if (supporter === null && donation === null) {
                return;
            };

            var firstName = supporter.firstName,
                lastName = supporter.lastName,
                email = supporter.email,
                mailingListSubscribed = supporter.mailingListSubscribed,
                employer = supporter.employer,
                onBehalfOn = supporter.onBehalfOn;
            var amount = donation.amount,
                recurring = donation.recurring;


            var data = {
                FirstName: firstName,
                LastName: lastName,
                Email: email,
                Amount: amount,
                GiftType: tribute ? 2 : 1,
                ContributionType: recurring ? 2 : 1,
                CustomFields: JSON.stringify(customFields),
                Employer: employer || '',
                Corporate: onBehalfOn || '',
                Newsletter: mailingListSubscribed
            };

            // console.log('Mapped data: ');
            // console.log(data);

            return data;
        };

        FRUSitecore.sendData = function (endpoint, dataObj) {
            // P O S T
            /* eslint-disable-next-line */
            console.log("Data Obj: ", dataObj);
            fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataObj)
            }).then(function (response) {
                /* eslint-disable-next-line */
                // console.log(response.status + ' - ' + response.statusText);
                /*if(response) {
                    // return response.json();
                }*/
            }).then(function (result) {
                /*if(result) {
                    console.log('RESPONSE:', result);
                }*/
            })['catch'](function (error) {
                /* eslint-disable-next-line */
                console.log('ERROR:', error);
                if (error.constructor === Object) {
                    /* eslint-disable-next-line */
                    console.error('ERROR:', error);
                }
            });
        };

        FRUSitecore.triggerGoal = function (data) {
            /* eslint-disable-next-line */
            var _dataObj = data;
            _dataObj = _dataObj.replace(/'/g, '"');
            var obj = JSON.parse(_dataObj);

            var goalId = obj.goalId,
                pageEvent = _objectWithoutProperties(obj, ['goalId']);

            var goalObj = { 'goalId': goalId };
            // let pageEventObj = pageEvent;

            if (Object.keys(goalObj).length !== 0 && goalObj.constructor === Object) {
                FRUSitecore.sendData(FRUSitecore.goalEndpoint, goalObj);
            }

            // if(Object.keys(pageEventObj).length !== 0 && pageEventObj.constructor === Object) {
            //     FRUSitecore.sendData(FRUSitecore.eventEndpoint, pageEventObj);
            // }
        };

        // FRU Events
        FundraiseUp.on('checkoutOpen', function (details) {
            /* eslint-disable-next-line */
            console.log('CHECKOUT OPEN ::::::::::::::::::::');
            /* eslint-disable-next-line */
            console.log('Details: ', details);

            // Determine if its fru widget or button
            var _data = "";

            if (window.dataTrackingOpen == undefined) {
                return;
            }
            _data = window.dataTrackingOpen;

            // If is widget
            // FRUSitecore.triggerGoal('data-tracking-open');
            FRUSitecore.triggerGoal(_data);
            // else use the global data object
            // console.log('OPEN: Data tracking String: ', dataTrackingOpen);
        });

        FundraiseUp.on('checkoutClose', function (details) {
            /* eslint-disable-next-line */
            console.log('CHECKOUT CLOSE :::::::::::::::::::');
            /* eslint-disable-next-line */
            console.log("Close Details: ", details);
            var _data = "";

            _data = window.dataTrackingClose;
            // FRUSitecore.triggerGoal('data-tracking-close');
            FRUSitecore.triggerGoal(_data);
        });

        FundraiseUp.on('donationComplete', function (details) {
            /* eslint-disable-next-line */
            //console.log('DONATION COMPLETE ::::::::::::::::::'); // Donation complete
            /* eslint-disable-next-line */

            console.log('DONATION COMPLETE ::::::::::::::::::');
            console.log("Donation Details:", details);
            var _goalData = "";
            if (window.dataTrackingComplete == undefined) {
                return;
            }
            _goalData = window.dataTrackingComplete;
            FRUSitecore.triggerGoal(_goalData);
            FRUSitecore.sendData(FRUSitecore.donationEndpoint, FRUSitecore.mapData(details));
        });
    }
};

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    if (detectIOS() === true) {
        document.body.classList.add('iOS');
    }
    function detectIOS() {
        var _ua = window.navigator.userAgent;
        if (_ua.indexOf('iPhone') !== -1 || _ua.indexOf('iPad') !== -1 || _ua.indexOf('iPod') !== -1) {
            return true;
        } else {
            return false;
        }
    }
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function () {
    window.addEventListener('DOMContentLoaded', function (e) {
        setTimeout(function () {
            if (window.document.body.classList.contains('has-sticky') && window.location.hash !== '') {
                var el = document.querySelector('' + window.location.hash);
                var stickyHeight = window.document.querySelector('.l-header__top.sticky').getBoundingClientRect().height;
                var headerUtilityHeight = window.document.querySelector('.l-header__utility').getBoundingClientRect().height;
                var topPos = el.getBoundingClientRect().top + window.scrollY;
                window.scrollTo(0, topPos - (stickyHeight + headerUtilityHeight));
            }
        }, 1500);
    });

    window.addEventListener('click', function (e) {
        var oldURL = e.target.baseURI;

        setTimeout(function () {
            if (window.document.body.classList.contains('has-sticky') && window.location.hash !== '') {
                var exclusions = ['#tab', '#f-organiz122xationz32xtype', '#sort'];
                var hash = window.location.hash;
                var excluded = false;

                exclusions.forEach(function (exclusion) {
                    if (hash.toLowerCase().startsWith(exclusion.toLowerCase())) {
                        excluded = true;
                    }
                });

                var newURL = e.target.baseURI;

                if (oldURL && !excluded) {
                    if (oldURL === newURL) {
                        // console.log('oldURL === newURL');
                        e.preventDefault();
                    } else {
                        var el = document.querySelector('' + window.location.hash);
                        var stickyHeight = window.document.querySelector('.l-header__top.sticky').getBoundingClientRect().height;
                        var headerUtilityHeight = window.document.querySelector('.l-header__utility').getBoundingClientRect().height;
                        var topPos = el.getBoundingClientRect().top + window.pageYOffset;
                        window.scrollTo(0, topPos - (stickyHeight + headerUtilityHeight));
                    }
                }
                oldURL = newURL;
            }
        }, 100);
    });
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(470);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("33f6b632", content, true, {});

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-bbccf81e]{background-color:#d22338}.phd-bg--red-alt[data-v-bbccf81e]{background-color:#c0161d}.phd-bg--gray-light[data-v-bbccf81e]{background-color:#f1f1f1}.phd-bg--gray[data-v-bbccf81e]{background-color:#979797}.phd-bg--gray-mid[data-v-bbccf81e]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-bbccf81e]{background-color:#373737}.phd-bg--black[data-v-bbccf81e]{background-color:#000}.phd-bg--black-alt[data-v-bbccf81e]{background-color:#050606}.phd-bg--blue[data-v-bbccf81e]{background-color:#65baf5}.phd-bg--blue-alt[data-v-bbccf81e]{background-color:#034a80}.phd-bg--mustard[data-v-bbccf81e]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-bbccf81e]{background-color:#a7762d}.phd-bg--lime[data-v-bbccf81e]{background-color:#abd02e}.phd-bg--lime-alt[data-v-bbccf81e]{background-color:#6b831c}.phd-bg--seafoam[data-v-bbccf81e]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-bbccf81e]{background-color:#1d7164}.phd-font-color--red[data-v-bbccf81e]{color:#d22338}.phd-font-color--red-alt[data-v-bbccf81e]{color:#c0161d}.phd-font-color--gray-light[data-v-bbccf81e]{color:#f1f1f1}.phd-font-color--gray[data-v-bbccf81e]{color:#979797}.phd-font-color--gray-mid[data-v-bbccf81e]{color:#6d6e71}.phd-font-color--gray-dark[data-v-bbccf81e]{color:#373737}.phd-font-color--black[data-v-bbccf81e]{color:#000}.phd-font-color--black-alt[data-v-bbccf81e]{color:#050606}.phd-font-color--blue[data-v-bbccf81e]{color:#65baf5}.phd-font-color--blue-alt[data-v-bbccf81e]{color:#034a80}.phd-font-color--mustard[data-v-bbccf81e]{color:#f9b146}.phd-font-color--mustard-alt[data-v-bbccf81e]{color:#a7762d}.phd-font-color--lime[data-v-bbccf81e]{color:#abd02e}.phd-font-color--lime-alt[data-v-bbccf81e]{color:#6b831c}.phd-font-color--seafoam[data-v-bbccf81e]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-bbccf81e]{color:#1d7164}.phd-link-color--red[data-v-bbccf81e],.phd-link-color--red[data-v-bbccf81e]:hover{color:#d22338}.phd-link-color--red-alt[data-v-bbccf81e],.phd-link-color--red-alt[data-v-bbccf81e]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-bbccf81e],.phd-link-color--gray-light[data-v-bbccf81e]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-bbccf81e],.phd-link-color--gray[data-v-bbccf81e]:hover{color:#979797}.phd-link-color--gray-mid[data-v-bbccf81e],.phd-link-color--gray-mid[data-v-bbccf81e]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-bbccf81e],.phd-link-color--gray-dark[data-v-bbccf81e]:hover{color:#373737}.phd-link-color--black[data-v-bbccf81e],.phd-link-color--black[data-v-bbccf81e]:hover{color:#000}.phd-link-color--black-alt[data-v-bbccf81e],.phd-link-color--black-alt[data-v-bbccf81e]:hover{color:#050606}.phd-link-color--blue[data-v-bbccf81e],.phd-link-color--blue[data-v-bbccf81e]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-bbccf81e],.phd-link-color--blue-alt[data-v-bbccf81e]:hover{color:#034a80}.phd-link-color--mustard[data-v-bbccf81e],.phd-link-color--mustard[data-v-bbccf81e]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-bbccf81e],.phd-link-color--mustard-alt[data-v-bbccf81e]:hover{color:#a7762d}.phd-link-color--lime[data-v-bbccf81e],.phd-link-color--lime[data-v-bbccf81e]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-bbccf81e],.phd-link-color--lime-alt[data-v-bbccf81e]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-bbccf81e],.phd-link-color--seafoam[data-v-bbccf81e]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-bbccf81e],.phd-link-color--seafoam-alt[data-v-bbccf81e]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-bbccf81e]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-bbccf81e]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-bbccf81e]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-bbccf81e]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-bbccf81e]{background-color:#e71e26}.ecc-bg--loe-br[data-v-bbccf81e]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-bbccf81e]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-bbccf81e]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-bbccf81e]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-bbccf81e]{background-color:#bdd3ea}.ecc-bg--gray[data-v-bbccf81e]{background-color:#ebebeb}.ecc-bg--white[data-v-bbccf81e]{background-color:#fff}.ecc-bg--black[data-v-bbccf81e]{background-color:#000}.ecc-font-color--cor-1[data-v-bbccf81e]{color:#67bf80}.ecc-font-color--cor-2a[data-v-bbccf81e]{color:#ffd643}.ecc-font-color--cor-2b[data-v-bbccf81e]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-bbccf81e]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-bbccf81e]{color:#e71e26}.ecc-font-color--loe-br[data-v-bbccf81e]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-bbccf81e]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-bbccf81e]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-bbccf81e]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-bbccf81e]{color:#bdd3ea}.ecc-font-color--gray[data-v-bbccf81e]{color:#ebebeb}.ecc-font-color--white[data-v-bbccf81e]{color:#fff}.ecc-font-color--black[data-v-bbccf81e]{color:#000}.c-aha-form textarea[data-v-bbccf81e],textarea.form-control[data-v-bbccf81e]{padding:10px;min-height:100px}.lower[data-v-bbccf81e]{margin-top:45px}@media (min-width:576px){.lower[data-v-bbccf81e]{margin-top:50px}}a.icon[data-v-bbccf81e]{width:30px;height:30px;background:#c10e21;border-radius:50%;border:thin solid #c10e21;color:#fff;font-weight:700;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.modalName[data-v-bbccf81e]{color:#c10e21;font-weight:400;font-size:16px}a.icon[data-v-bbccf81e]:hover{color:#fff}#recommendation[data-v-bbccf81e],#risk[data-v-bbccf81e],.toolTip[data-v-bbccf81e]{background-color:#e9ecef;opacity:1;padding:1rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-clip:padding-box;border:1px solid #c4cacf;border-radius:2px;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.custom-space-result[data-v-bbccf81e]{margin-top:-10px}.redClass[data-v-bbccf81e]{color:#e60f00;font-weight:600}.oragneClass[data-v-bbccf81e]{color:#ad6500;font-weight:600}.greenClass[data-v-bbccf81e]{color:#008a02;font-weight:600!important}.lightRedClass[data-v-bbccf81e]{color:#cc4b00;font-weight:600}.normalClass[data-v-bbccf81e]{color:#222328}.custom-tooltip[data-v-bbccf81e]{margin-left:17px}.custom-result-radio-btn[data-v-bbccf81e],.custom-space[data-v-bbccf81e]{margin-left:-5px;margin-right:30px}", ""]);

// exports


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phd-risk-calculator"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 h-100"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.hcmCalculatorFormula.apply(null, arguments)}}},[_c('div',{staticClass:"form-group row mt-5"},[_c('div',{staticClass:"col-4 col-form-label"},[_vm._v("\n                                        Sex\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"male"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.sex_range),expression:"sex_range",modifiers:{"number":true}}],attrs:{"type":"radio","name":"male","id":"male","autocomplete":"off","value":"0","checked":"","aria-describedby":"male"},domProps:{"checked":_vm._q(_vm.sex_range,_vm._n("0"))},on:{"change":function($event){_vm.sex_range=_vm._n("0")}}}),_vm._v("\n                                                Male\n                                            ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"female"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.sex_range),expression:"sex_range",modifiers:{"number":true}}],attrs:{"type":"radio","name":"female","id":"female","autocomplete":"off","value":"1","aria-describedby":"female"},domProps:{"checked":_vm._q(_vm.sex_range,_vm._n("1"))},on:{"change":function($event){_vm.sex_range=_vm._n("1")}}}),_vm._v("\n                                                Female\n                                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"age"}},[_vm._v("Age\n                                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age_range.value
                                                    ),expression:"age_range.value\n                                                    "}],staticClass:"form-control",attrs:{"type":"text","id":"age","placeholder":"30-79","aria-describedby":"ageyears"},domProps:{"value":(_vm.age_range.value
                                                    )},on:{"blur":function($event){return _vm.validateAge($event)},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.age_range, "value", $event.target.value)},function($event){return _vm.handleUpperInput('year')}]}}),_vm._v(" "),(_vm.ageValidation)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" Age in years must be between 30-79 years")]):_vm._e(),_vm._v(" "),(_vm.isAgeRequried)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("Please enter the patient’s age")]):_vm._e(),_vm._v(" "),(_vm.ageIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Age must be between 30-79 years")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('p',{staticClass:"float-left",attrs:{"id":"ageyears"}},[_vm._v("\n                                                years\n                                            ")]),_vm._v(" "),_c('a',{key:"age-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.validateAge('info')}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalCholesterol_range.value),expression:"totalCholesterol_range.value"}],staticClass:"form-control",attrs:{"type":"text","id":"TotalCholesterol","placeholder":"130-320","aria-describedby":"Total Cholesterol"},domProps:{"value":(_vm.totalCholesterol_range.value)},on:{"blur":_vm.validateTotalCholesterol,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.totalCholesterol_range, "value", $event.target.value)},function($event){return _vm.handleUpperInput('total')}]}}),_vm._v(" "),(_vm.totalCholesterolRangeValidation)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("Total cholesterol levels can be fasting or non-fasting and must be between 130-320 mg/dL")]):_vm._e(),_vm._v(" "),(_vm.istotalCholesterolRequired)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("Please enter the total cholesterol value")]):_vm._e(),_vm._v(" "),(_vm.totalCholesteronIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Total cholesterol levels can be fasting or non-fasting and must be between 130-320 mg/dL")]):_vm._e()]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.validateTotalCholesterol('info')}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hdlCholesteron_range.value),expression:"hdlCholesteron_range.value"}],staticClass:"form-control",attrs:{"type":"text","id":"HDLCholesterol","placeholder":"20-100","aria-describedby":"HDL Cholesterol"},domProps:{"value":(_vm.hdlCholesteron_range.value)},on:{"blur":_vm.hdlCholesteronValidation,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.hdlCholesteron_range, "value", $event.target.value)},function($event){return _vm.handleUpperInput('hdl')}]}}),_vm._v(" "),(_vm.hdlCholesteronValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("HDL cholesterol levels can be fasting or non-fasting and must be between 20-100 mg/dL")]):_vm._e(),_vm._v(" "),(_vm.ishdlCholesteronRequired)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("Please enter the HDL cholesterol value")]):_vm._e(),_vm._v(" "),(_vm.hdlCholesteronIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("HDL cholesterol levels can be fasting or non-fasting and must be between 20-100 mg/dL")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('span',{staticClass:"float-left"},[_vm._v("mg/dL")]),_vm._v(" "),_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.hdlCholesteronValidation('info')}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-0 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sbp_range.value),expression:"sbp_range.value"}],staticClass:"form-control",attrs:{"type":"text","id":"SBPvalue","placeholder":"90-200","aria-describedby":"SBP value"},domProps:{"value":(_vm.sbp_range.value)},on:{"blur":_vm.sbpValidation,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.sbp_range, "value", $event.target.value)},function($event){return _vm.handleUpperInput('sbp')}]}}),_vm._v(" "),(_vm.spbValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                Systolic blood pressure must be between 90-200 mmHg\n                                            ")]):_vm._e(),_vm._v(" "),(_vm.isSbpRequired)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                Please enter the SBP value\n                                            ")]):_vm._e(),_vm._v(" "),(_vm.sbpIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Systolic blood pressure must be between 90-200 mmHg")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_vm._m(4),_vm._v(" "),_c('a',{key:"maxlvot-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.sbpValidation('info')}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bmi_range.value),expression:"bmi_range.value"}],staticClass:"form-control",attrs:{"type":"text","id":"BMI","placeholder":"18.5-39.9","aria-describedby":"BMI-value"},domProps:{"value":(_vm.bmi_range.value)},on:{"blur":_vm.BMIValidation,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.bmi_range, "value", $event.target.value)},function($event){return _vm.handleUpperInput('bmi')}]}}),_vm._v(" "),(_vm.validationBMI)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                    Body mass index (BMI) must be between 18.5 - 39.9 kg/m²\n                                                   \n                                                ")]):_vm._e(),_vm._v(" "),(_vm.isbmiRequired)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                    Please enter the BMI value\n                                                ")]):_vm._e(),_vm._v(" "),(_vm.bmiIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Body mass index (BMI) must be between 18.5 - 39.9 kg/m²")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.BMIValidation('info')}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.egfr_range.value),expression:"egfr_range.value"}],staticClass:"form-control",attrs:{"type":"text","id":"eGFR","placeholder":"15-140","aria-describedby":"eGFR-value"},domProps:{"value":(_vm.egfr_range.value)},on:{"blur":_vm.egfrValidation,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.egfr_range, "value", $event.target.value)},function($event){return _vm.handleUpperInput('efgr')}]}}),_vm._v(" "),(_vm.validationegfr)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                    Estimated glomerular filtration rate (eGFR) must be between 15 - 140 ml/min/1.73m"),_c('sup',[_vm._v("2")])]):_vm._e(),_vm._v(" "),(_vm.isegfrRequired)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                     Please enter the eGFR value\n                                                ")]):_vm._e(),_vm._v(" "),(_vm.egfrIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(" Estimated glomerular filtration rate (eGFR) must be between 15 - 140 ml/min/1.73m"),_c('sup',[_vm._v("2")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('span',{staticClass:"abbr float-left"}),_vm._v(" "),_c('a',{key:"maxlvot-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.egfrValidation('info')}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"NoDiabetes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.diabetes_range
                                                            ),expression:"diabetes_range\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":"NoDiabetes","id":"NoDiabetes","autocomplete":"off","aria-label":"Diabetes No","value":"0","checked":"","aria-describedby":"No Diabetes"},domProps:{"checked":_vm._q(_vm.diabetes_range
                                                            ,_vm._n("0"))},on:{"change":function($event){_vm.diabetes_range
                                                            =_vm._n("0")}}}),_vm._v("\n                                                    No\n                                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"yesDiabetes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.diabetes_range),expression:"diabetes_range",modifiers:{"number":true}}],attrs:{"type":"radio","name":"yesDiabetes","id":"yesDiabetes","autocomplete":"off","aria-label":"Diabetes Yes","value":"1","aria-describedby":"yesDiabetes"},domProps:{"checked":_vm._q(_vm.diabetes_range,_vm._n("1"))},on:{"change":function($event){_vm.diabetes_range=_vm._n("1")}}}),_vm._v("\n                                                    Yes\n                                                ")]),_vm._v(" "),_c('a',{key:"unexsy-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.alertMessage('diabetes')}}},[_vm._v("i")])])]),_vm._v(" "),(_vm.diabetesIcon)?_c('p',{staticClass:"toolTip col-6 mt-3 custom-tooltip",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.diabetesErrorMessage))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"CurrentSmoker_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentSmoker_range),expression:"currentSmoker_range",modifiers:{"number":true}}],attrs:{"type":"radio","name":"CurrentSmoker_no","id":"CurrentSmoker_no","autocomplete":"off","aria-label":"Current Smoker No","value":"0","checked":"","aria-describedby":"CurrentSmoker no"},domProps:{"checked":_vm._q(_vm.currentSmoker_range,_vm._n("0"))},on:{"change":function($event){_vm.currentSmoker_range=_vm._n("0")}}}),_vm._v("\n                                                    No\n                                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"CurrentSmoker_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentSmoker_range),expression:"currentSmoker_range",modifiers:{"number":true}}],attrs:{"type":"radio","name":"CurrentSmoker_yes","id":"CurrentSmoker_yes","aria-label":"Current Smoker Yes","autocomplete":"off","value":"1","aria-describedby":"CurrentSmoker_yes"},domProps:{"checked":_vm._q(_vm.currentSmoker_range,_vm._n("1"))},on:{"change":function($event){_vm.currentSmoker_range=_vm._n("1")}}}),_vm._v("\n                                                    Yes\n                                                ")]),_vm._v(" "),_c('a',{key:"unexsy-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.alertMessage('currentSmoker')}}},[_vm._v("i")])])]),_vm._v(" "),(_vm.currentSmokerIcon)?_c('p',{staticClass:"toolTip col-6 mt-3 custom-tooltip",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.currentSmokerErrorMessage))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-4 col-form-label",attrs:{"for":"Anti-hypertensive medication"}},[_vm._v("\n                                            Anti-hypertensive medication\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Anti_hypertensive_medication_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.htmlmeds_range
                                                            ),expression:"htmlmeds_range\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":"Anti_hypertensive_medication_no","id":"Anti_hypertensive_medication_no","autocomplete":"off","aria-label":"Anti hypertensive medication No","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.htmlmeds_range
                                                            ,_vm._n("0"))},on:{"change":function($event){_vm.htmlmeds_range
                                                            =_vm._n("0")}}}),_vm._v("\n                                                    No\n                                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Anti_hypertensive_medication_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.htmlmeds_range
                                                            ),expression:"htmlmeds_range\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":"Anti_hypertensive_medication_yes","id":"Anti_hypertensive_medication_yes","autocomplete":"off","aria-label":"Anti hypertensive medication Yes","value":"1"},domProps:{"checked":_vm._q(_vm.htmlmeds_range
                                                            ,_vm._n("1"))},on:{"change":function($event){_vm.htmlmeds_range
                                                            =_vm._n("1")}}}),_vm._v("\n                                                    Yes\n                                                ")]),_vm._v(" "),_c('a',{key:"unexsy-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.alertMessage('htnMeds')}}},[_vm._v("i")])])]),_vm._v(" "),(_vm.htnMedsIcon)?_c('p',{staticClass:"toolTip col-6 mt-3 custom-tooltip",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.htnMedsErrorMessage))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-4 col-form-label",attrs:{"for":"Lipid-lowering medication"}},[_vm._v("\n                                            Lipid-lowering medication\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Cholesterol treated with a statin\n                                            medication_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.cholesteronTreated_range
                                                            ),expression:"cholesteronTreated_range\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":"Cholesterol treated with a statin\n                                            medication","id":"Cholesterol treated with a statin\n                                            medication_no","aria-label":"Cholesterol treated with a statin\n                                            medication No","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.cholesteronTreated_range
                                                            ,_vm._n("0"))},on:{"change":function($event){_vm.cholesteronTreated_range
                                                            =_vm._n("0")}}}),_vm._v("\n                                                    No\n                                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Cholesterol treated with a statin\n                                            medication_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.cholesteronTreated_range),expression:"cholesteronTreated_range",modifiers:{"number":true}}],attrs:{"type":"radio","name":"Cholesterol treated with a statin\n                                            medication","id":"Cholesterol treated with a statin\n                                            medication_yes","aria-label":"Cholesterol treated with a statin\n                                            medication Yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.cholesteronTreated_range,_vm._n("1"))},on:{"change":function($event){_vm.cholesteronTreated_range=_vm._n("1")}}}),_vm._v("\n                                                    Yes\n                                                ")]),_vm._v(" "),_c('a',{key:"apan-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.alertMessage('ds')}}},[_vm._v("i")])])]),_vm._v(" "),(_vm.cholesteronTreatedIcon)?_c('p',{staticClass:"toolTip col-6 mt-3 custom-tooltip",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.CholesteroltreatedErrorMessage))]):_vm._e()]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"UACR_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.isShowUACR
                                                            ),expression:"isShowUACR\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":"UACR","id":"UACR_NO","aria-label":"UACR No","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.isShowUACR
                                                            ,_vm._n("0"))},on:{"click":function($event){return _vm.resetTheValueOnceUserYesOrNo('uacr')},"change":function($event){_vm.isShowUACR
                                                            =_vm._n("0")}}}),_vm._v("\n                                                    No\n                                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"UACR_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.isShowUACR),expression:"isShowUACR",modifiers:{"number":true}}],attrs:{"type":"radio","name":"UACR","id":"UACR_Yes","aria-label":"UACR Yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.isShowUACR,_vm._n("1"))},on:{"click":function($event){return _vm.resetTheValueOnceUserYesOrNo('uacr')},"change":function($event){_vm.isShowUACR=_vm._n("1")}}}),_vm._v("\n                                                    Yes\n                                                ")]),_vm._v(" "),_c('a',{key:"unexsy-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.latestIconsValidation('uacr')}}},[_vm._v("i")])])]),_vm._v(" "),(_vm.isShowUACR == 1)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uacr_range_front_end),expression:"uacr_range_front_end"}],staticClass:"form-control",attrs:{"type":"text","id":"UACR_Yes","placeholder":"0 to 25000"},domProps:{"value":(_vm.uacr_range_front_end)},on:{"blur":function($event){return _vm.latestValidation('uacr', $event)},"input":[function($event){if($event.target.composing){ return; }_vm.uacr_range_front_end=$event.target.value},function($event){return _vm.handleInput('uacr')}]}}),_vm._v(" "),(_vm.uacrValidation)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                    UACR must be between 0 - 25000 mg/g\n                                                ")]):_vm._e(),_vm._v(" "),(_vm.emptyUacrValidation)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                    Please enter the UACR value\n                                                ")]):_vm._e()]),_vm._v(" "),_vm._m(11)]):_vm._e(),_vm._v(" "),(_vm.iconUacrValidation)?_c('p',{staticClass:"toolTip col-6 mt-3 custom-tooltip",attrs:{"role":"alert"}},[_vm._v(" UACR is clinically indicated for individuals with chronic kidney disease, diabetes, or hypertension")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"HbA1C_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.isShowHbA1C
                                                            ),expression:"isShowHbA1C\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":"HbA1C","id":"HbA1C_No","aria-label":"HbA1C No","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.isShowHbA1C
                                                            ,_vm._n("0"))},on:{"click":function($event){return _vm.resetTheValueOnceUserYesOrNo('hba1c')},"change":function($event){_vm.isShowHbA1C
                                                            =_vm._n("0")}}}),_vm._v("\n                                                    No\n                                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"hhba1c_Yesba1c"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.isShowHbA1C),expression:"isShowHbA1C",modifiers:{"number":true}}],attrs:{"type":"radio","name":"hba1c","id":"hba1c_Yes","aria-label":"hba1c Yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.isShowHbA1C,_vm._n("1"))},on:{"click":function($event){return _vm.resetTheValueOnceUserYesOrNo('hba1c')},"change":function($event){_vm.isShowHbA1C=_vm._n("1")}}}),_vm._v("\n                                                    Yes\n                                                ")]),_vm._v(" "),_c('a',{key:"unexsy-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.latestIconsValidation('HbA1C')}}},[_vm._v("i")])])]),_vm._v(" "),(_vm.isShowHbA1C == 1)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.HbA1C_range),expression:"HbA1C_range"}],staticClass:"form-control",attrs:{"type":"text","id":"HbA1C","placeholder":"3 to 15"},domProps:{"value":(_vm.HbA1C_range)},on:{"blur":function($event){return _vm.latestValidation('HbA1C')},"input":[function($event){if($event.target.composing){ return; }_vm.HbA1C_range=$event.target.value},function($event){return _vm.handleInput('hb')}]}}),_vm._v(" "),(_vm.HbA1CValidation)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                    HbA1C must be between 3% - 15%\n                                                ")]):_vm._e(),_vm._v(" "),(_vm.emptyHbA1CValidation)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                    Please enter the HbA1C value\n                                                ")]):_vm._e()]),_vm._v(" "),_vm._m(13)]):_vm._e(),_vm._v(" "),(_vm.iconHbA1CValidation)?_c('p',{staticClass:"toolTip mt-3 col-6 custom-tooltip",attrs:{"role":"alert"}},[_vm._v("HbA1c is clinically indicated for individuals with diabetes, prediabetes, overweight, or obesity, or those with history of gestational diabetes")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"SID_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.isShowSID
                                                            ),expression:"isShowSID\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":"SID","id":"SID_No","autocomplete":"off","aria-label":"Zip Code No","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.isShowSID
                                                            ,_vm._n("0"))},on:{"click":function($event){return _vm.resetTheValueOnceUserYesOrNo('sid')},"change":function($event){_vm.isShowSID
                                                            =_vm._n("0")}}}),_vm._v("\n                                                    No\n                                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"SID_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.isShowSID),expression:"isShowSID",modifiers:{"number":true}}],attrs:{"type":"radio","name":"SID","id":"SID_Yes","aria-label":"Zip Code Yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.isShowSID,_vm._n("1"))},on:{"click":function($event){return _vm.resetTheValueOnceUserYesOrNo('sid')},"change":function($event){_vm.isShowSID=_vm._n("1")}}}),_vm._v("\n                                                    Yes\n                                                ")]),_vm._v(" "),_c('a',{key:"unexsy-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.latestIconsValidation('sid')}}},[_vm._v("i")])])]),_vm._v(" "),(_vm.isShowSID == 1)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SID_range),expression:"SID_range"}],staticClass:"form-control",attrs:{"type":"text","id":"SID","placeholder":"Enter zip code","maxlength":"5"},domProps:{"value":(_vm.SID_range)},on:{"blur":function($event){return _vm.latestValidation('sid', $event)},"input":[function($event){if($event.target.composing){ return; }_vm.SID_range=$event.target.value},function($event){return _vm.handleInput('SID_range')}]}}),_vm._v(" "),(_vm.SIDValidation)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                        Please enter a valid 5 digit zip code or click no that this information is not available\n                                                    ")]):_vm._e(),_vm._v(" "),(_vm.emptySIDValidation)?_c('i',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                                    Please enter a valid 5 digit zip code or click no that this information is not available\n                                                ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.iconSIDValidation)?_c('p',{staticClass:"toolTip col-6 mt-3 custom-tooltip",attrs:{"role":"alert"}},[_vm._v("A valid 5-digit zip code is needed to estimate social deprivation index [SDI]")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[(_vm.isLoading)?_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_vm._m(15),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})]):_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_c('input',{key:"submit",staticClass:"btn btn-primary",attrs:{"type":"submit","value":"Calculate"},on:{"click":_vm.formValidate}}),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-xs-12 col-12 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle col-xs-12",attrs:{"data-toggle":"buttons"}},[_c('label',{staticClass:"col-xs-12 mb-2 mr-4",attrs:{"for":" RiskofCVD"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.totalResult
                                                            ),expression:"totalResult\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":" Risk of CVD","id":" RiskofCVD","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.totalResult
                                                            ,_vm._n("0"))},on:{"change":function($event){_vm.totalResult
                                                            =_vm._n("0")}}}),_vm._v("\n                                                        Risk of CVD\n                                                ")]),_vm._v(" "),_c('label',{staticClass:"col-xs-12 mb-2 mr-4",attrs:{"for":"RiskofASCVD"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.totalResult
                                                            ),expression:"totalResult\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":"RiskofASCVD","id":"RiskofASCVD","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.totalResult
                                                            ,_vm._n("1"))},on:{"change":function($event){_vm.totalResult
                                                            =_vm._n("1")}}}),_vm._v("\n                                                        Risk of ASCVD\n                                                ")]),_vm._v(" "),_c('label',{staticClass:"col-xs-12 mb-2",attrs:{"for":"RiskofHeartFailure"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.totalResult
                                                            ),expression:"totalResult\n                                                            ",modifiers:{"number":true}}],attrs:{"type":"radio","name":"RiskofHeartFailure","id":"RiskofHeartFailure","autocomplete":"off","value":"2"},domProps:{"checked":_vm._q(_vm.totalResult
                                                            ,_vm._n("2"))},on:{"change":function($event){_vm.totalResult
                                                            =_vm._n("2")}}}),_vm._v("\n                                                        Risk of Heart Failure\n                                                ")])])])]),_vm._v(" "),(_vm.sex_range === 0 && _vm.totalValidation)?_c('div',{attrs:{"id":"targetElement"}},[(_vm.totalResult == 0)?_c('div',{staticClass:"custom-space-result",attrs:{"id":"targetElement"}},[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 10-year risk of CVD"),_vm._v(" = "+_vm._s(_vm.totalCVDMenValue)+"%")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.age_range.value < 60)?_c('div',[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 30-year risk of CVD"),_vm._v(" = "+_vm._s(_vm.thrityYearsCVDMen)+"% ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.totalResult == 1)?_c('div',{staticClass:"custom-space-result",attrs:{"id":"targetElement"}},[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 10-year risk of ASCVD"),_vm._v(" = "+_vm._s(_vm.totalAscdMenValue)+"% ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.age_range.value < 60)?_c('div',[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 30-year risk of ASCVD"),_vm._v(" = "+_vm._s(_vm.totalThirtyAscvdMenValue)+"% ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.totalResult == 2)?_c('div',{staticClass:"custom-space-result",attrs:{"id":"targetElement"}},[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v(" This individual has an estimated 10-year risk of Heart Failure"),_vm._v(" = "+_vm._s(_vm.totalHearFailureMenVlaue)+"% ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.age_range.value < 60)?_c('div',[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 30-year risk of Heart Failure"),_vm._v(" = "+_vm._s(_vm.totalThirtyHearFailureMenValue)+"% ")])]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.sex_range === 1 && _vm.totalValidation)?_c('div',{attrs:{"id":"targetElement"}},[(_vm.totalResult == 0)?_c('div',{staticClass:"custom-space-result"},[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 10-year risk of CVD"),_vm._v(" = "+_vm._s(_vm.totalCVDWomenValue)+"%")]),_vm._v(" "),(_vm.age_range.value < 60)?_c('div',[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 30-year risk of CVD"),_vm._v(" = "+_vm._s(_vm.totalThirtyYearsCVDWomenValue)+"% ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.totalResult == 1)?_c('div',{staticClass:"custom-space-result"},[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 10-year risk of ASCVD"),_vm._v(" = "+_vm._s(_vm.totalAscdWomenValue)+"% ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.age_range.value < 60)?_c('div',[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 30-year risk of ASCVD"),_vm._v(" = "+_vm._s(_vm.totalThirtyAscvdWomenValue)+"% ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.totalResult == 2)?_c('div',{staticClass:"custom-space-result"},[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v(" This individual has an estimated 10-year risk of Heart Failure"),_vm._v(" = "+_vm._s(_vm.totalHeartFailureWomenValues)+"% ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.age_range.value < 60)?_c('div',[_c('label',{staticClass:"col-form-label font-weight-bold",attrs:{"for":"risk"}},[_vm._v("This individual has an estimated 30-year risk of Heart Failure"),_vm._v(" = "+_vm._s(_vm.totalThirtyYearsHeartFailureWomen)+"% ")])]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.totalValidation)?_c('div',{staticClass:"modalName"},[_vm._v("The risk estimates were calculated using the "+_vm._s(_vm.ModelName))]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"TotalCholesterol"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v("Total Cholesterol\n                                                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mg/dL","title":"mg/dl"}},[_vm._v("mg/dL")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"HDLCholesterol"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"HDL Cholesterol"}},[_vm._v("HDL Cholesterol")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"SBPvalue"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"SBP value"}},[_vm._v("SBP")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr float-left"},[_c('div',{attrs:{"id":"mmHg-value","title":"mmHg "}},[_vm._v("mmHg")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label text-uppercase",attrs:{"for":"BMI"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"BMI"}},[_vm._v("BMI\n                                                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"eGFR"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"eGFR"}},[_vm._v("eGFR\n                                                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label"},[_c('span',{staticClass:"abbr"},[_c('label',{attrs:{"id":"Diabetes","title":"Diabetes","for":"Diabetes"}},[_vm._v("Diabetes")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label"},[_c('span',{staticClass:"abbr"},[_c('label',{attrs:{"id":"abbrnsvt","title":"Current Smoking","for":"Current Smoking"}},[_vm._v("Current Smoking")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-6 col-form-label"},[_c('b',[_vm._v("The following three predictors are optional for further personalization of risk assessment. When they are clinically indicated or available, please click on yes and enter the value")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label"},[_c('span',{staticClass:"abbr"},[_c('label',{attrs:{"id":"UACR","title":"UACR","for":"uacr"}},[_vm._v("UACR")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr float-left mt-2"},[_c('div',{attrs:{"id":"mmHg-value","title":"mmHg "}},[_vm._v("mg/g")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label"},[_c('span',{staticClass:"abbr"},[_c('label',{attrs:{"id":"HbA1C","title":"HbA1C","for":"hba1c"}},[_vm._v("HbA1C")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr float-left mt-2"},[_c('div',{attrs:{"id":"mmHg-value","title":"mmHg "}},[_vm._v("%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label"},[_c('span',{staticClass:"abbr"},[_c('label',{attrs:{"title":"SID","for":"Zip Code (for estimating social deprivation index [SDI])"}},[_vm._v("Zip Code (for estimating social deprivation index [SDI])")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"loadong","disabled":""}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                                        Loading...\n                                        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2b4043c0", content, true, {});

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".result{font-size:18px}.custom-input-box{background-color:#e9ecef;opacity:1;padding:.3rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-clip:padding-box;border:1px solid #c4cacf;border-radius:2px}.custom-btn{margin-left:-14px}", ""]);

// exports


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 h-100"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.hcfCalculatorFormula.apply(null, arguments)}}},[_c('div',{staticClass:"form-group row mt-4"},[_c('label',{staticClass:"col-3 col-form-label",attrs:{"for":"laDiameterLabel"}},[_vm._v("\n                        "+_vm._s(_vm.laDiameterLabel)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-4 pr-2 mt-2"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.laDiameterDrodownValue),expression:"laDiameterDrodownValue"}],staticClass:"form-control custom-select btn--select py-0",attrs:{"id":"laDiameterLabel"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.laDiameterDrodownValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.handleChange('laDiameterDrodownValue')}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Transverse LA Dimension")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("24-29")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("30-35")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("36-41")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("42-47")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("48-53")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("54-59")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("60-65")])]),_vm._v(" "),(_vm.laDiameterErrMsg)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.laDiameterErromessage))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-4"},[_c('label',{staticClass:"col-3 col-form-label",attrs:{"for":"ageHcmDiagnosisLabel"}},[_vm._v("\n                        "+_vm._s(_vm.ageHcmDiagnosisLabel)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-4 pr-2 mt-2"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ageHCMDropdDownValue),expression:"ageHCMDropdDownValue"}],staticClass:"form-control custom-select btn--select py-0",attrs:{"id":"ageHcmDiagnosisLabel"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ageHCMDropdDownValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.handleChange('ageHcmDiagnosisLabel')}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Age at HCM Diagnosis ")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("0-9")]),_vm._v(" "),_c('option',{attrs:{"value":"-2"}},[_vm._v("10-19")]),_vm._v(" "),_c('option',{attrs:{"value":"-4"}},[_vm._v("20-29")]),_vm._v(" "),_c('option',{attrs:{"value":"-6"}},[_vm._v("30-39")]),_vm._v(" "),_c('option',{attrs:{"value":"-8"}},[_vm._v("40-49")]),_vm._v(" "),_c('option',{attrs:{"value":"-10"}},[_vm._v("50-59")]),_vm._v(" "),_c('option',{attrs:{"value":"-12"}},[_vm._v("60-69")]),_vm._v(" "),_c('option',{attrs:{"value":"-14"}},[_vm._v("70-79")])]),_vm._v(" "),(_vm.ageHCMDErrMsg )?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.ageHcmDiagnosisErrormessage)+" ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-4"},[_c('label',{staticClass:"col-3 col-form-label",attrs:{"for":"ageClinicalEvaluationLabel"}},[_vm._v("\n                        "+_vm._s(_vm.ageClinicalEvaluationLabel)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-4 pr-2 mt-2"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ageClinicalEvaluationDropdownValue),expression:"ageClinicalEvaluationDropdownValue"}],staticClass:"form-control custom-select btn--select py-0",attrs:{"id":"ageClinicalEvaluationLabel"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ageClinicalEvaluationDropdownValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.handleChange('ageClinicalEvaluationLabel')}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Age at Clinical Evaluation")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("10-19")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("20-29")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("30-39")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("40-49")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("50-59")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("60-69")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("70-79")])]),_vm._v(" "),(_vm.ageClinicalErrMsg )?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.ageClinicalEvaluationErrormessage))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-4"},[_c('label',{staticClass:"col-3 col-form-label",attrs:{"for":"heartFailureSymptomsLabel"}},[_vm._v("\n                        "+_vm._s(_vm.heartFailureSymptomsLabel)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-4 pr-2 mt-2"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.heartFailureSymptoms),expression:"heartFailureSymptoms",modifiers:{"number":true}}],attrs:{"type":"radio","name":"no","id":"no","autocomplete":"off","value":"0","checked":"","aria-label":"NYHA Class II, III, or IV Heart Failure Symptoms No"},domProps:{"checked":_vm._q(_vm.heartFailureSymptoms,_vm._n("0"))},on:{"change":function($event){_vm.heartFailureSymptoms=_vm._n("0")}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.heartFailureSymptoms),expression:"heartFailureSymptoms",modifiers:{"number":true}}],attrs:{"type":"radio","name":"yes","id":"yes","autocomplete":"off","value":"3","aria-label":"NYHA Class II, III, or IV Heart Failure Symptoms Yes"},domProps:{"checked":_vm._q(_vm.heartFailureSymptoms,_vm._n("3"))},on:{"change":function($event){_vm.heartFailureSymptoms=_vm._n("3")}}}),_vm._v("\n                                    Yes\n                                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_c('input',{key:"submit",staticClass:"btn btn-primary custom-btn",attrs:{"type":"submit","value":"Calculate Score"},on:{"click":_vm.formValidate}}),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.reset}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-form-label mt-3",attrs:{"for":"HCMAFScore"}},[_vm._v(_vm._s(_vm.hcmAfScoreText)+" "),_vm._m(0)]),_vm._v(" "),_c('div',[_c('input',{staticClass:"col-md-8 custom-input-box",attrs:{"id":"HCMAFScore","type":"text","disabled":"","name":"totalValue"},domProps:{"value":_vm.totalValue}})]),_vm._v(" "),_c('label',{staticClass:"col-form-label mt-3",attrs:{"for":"twoYearRiskText"}},[_vm._v(_vm._s(_vm.twoYearRiskText)+" "),_vm._m(1)]),_vm._v(" "),_c('div',[_c('input',{staticClass:"col-md-8 custom-input-box",attrs:{"id":"twoYearRiskText","type":"text","disabled":"","name":"2%"},domProps:{"value":_vm.twoPersent}})]),_vm._v(" "),_c('label',{staticClass:"col-form-label mt-3",attrs:{"for":"fiveYearRiskText"}},[_vm._v(_vm._s(_vm.fiveYearRiskText)),_vm._m(2)]),_vm._v(" "),_c('div',[_c('input',{staticClass:"col-md-8 custom-input-box",attrs:{"id":"fiveYearRiskText","type":"text","disabled":"","name":"5%"},domProps:{"value":_vm.fivePersent}})])])]),_vm._v(" "),(_vm.btnTxt)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.bottomText)}}):_vm._e(),_vm._v(" "),(_vm.recommendationTxt)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.riskScoreLabel)}}):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"HCMAFScore","aria-label":"HCM-AF Score","title":"HCM-AF Score"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"twoYearRiskText","aria-label":"Risk of at 2 years(%)","title":"Risk of at 2 years(%)"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"fiveYearRiskText","aria-label":"Risk of at 5 years(%)","title":"Risk of at 5 years(%)"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(476);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d61be34a", content, true, {});

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".customer-success{color:green}.pmm-custom-dropdown .dropdown-toggle:after{float:right;margin-top:10px;position:relative;top:0;right:auto;left:0}.pmm-custom-dropdown .dropdown-toggle{background-color:transparent!important;border:1px solid #d1cccc;border-radius:4px;text-align:left;padding:12px}.pmm-custom-dropdown .dropdown-toggle.has-selected-items:after{top:-26px}.pmm-custom-dropdown .btn-primary{color:#000!important;background-color:transparent!important;width:400px;border:2px solid #d1cccc;height:auto;text-align:left}.pmm-custom-dropdown .btn-primary:active,.pmm-custom-dropdown .btn-primary:hover{color:#000;background-color:transparent!important;width:400px;border:2px solid #d1cccc}.badge-primary{background:#d22338;color:#fff;margin-left:10px!important;font-style:normal;margin-top:10px!important}.dropdown-menu{width:400px;padding-left:10px;width:100%;height:250px;overflow-y:auto}.dropdown-login-text{color:#d22338;font-weight:700}.icon-expand{margin-left:4px;margin-top:-10px;cursor:pointer}.icon-collapse{margin-left:4px;margin-top:-4px}.pmm-custom-dropdown .dropdown-toggle:after{content:\"\";display:inline-block;width:8px;height:10px;-webkit-transition:-webkit-transform .3s ease;transition:-webkit-transform .3s ease;transition:transform .3s ease;transition:transform .3s ease,-webkit-transform .3s ease}.pmm-custom-dropdown .dropdown-toggle.dropdown-collapse:after{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.pmm-custom-dropdown .dropdown-toggle.dropdown-expand:after{-webkit-transform:rotate(0deg);transform:rotate(0deg)}.icon-collapse:before{content:\"\\25BC\";font-size:1.2em}.icon-expand:before{content:\"\\25BA\";font-size:1.2em}.custom-checkbox{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:normal}.child-name,.parent-name{margin-top:4px;cursor:normal}.sub-child-name{cursor:normal}.custom-dropdown-checkbox{margin-top:-5px;cursor:pointer}.badge-section{-ms-flex-wrap:wrap;flex-wrap:wrap;gap:5px;max-width:100%;overflow-x:auto}.badge,.badge-section{display:-webkit-box;display:-ms-flexbox;display:flex}.badge{white-space:nowrap;padding:5px 10px;font-size:12px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.badge .close-button{margin-left:5px;cursor:pointer;font-size:12px;line-height:1}@media (max-width:576px){.badge-section{-ms-flex-wrap:wrap;flex-wrap:wrap;max-width:100%}.badge{max-width:100%;font-size:12px;margin-bottom:5px}.close-button{font-size:1rem}}", ""]);

// exports


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center flex-column"},[(_vm.sucessMsg)?_c('div',{ref:"alertBox",staticClass:"alert alert-success mt-3",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.saveSuccessMessage)}}):_vm._e(),_vm._v(" "),(_vm.validationError)?_c('div',{ref:"alertBox",staticClass:"alert alert-danger mt-3",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.saveErrorMessage)}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_vm._l((_vm.dropdowns),function(dropdown,index){return _c('div',{key:index},[_c('div',{staticClass:"container",attrs:{"id":("container" + index)}},[_c('label',{staticClass:"pmm-dropdown-header mt-3 h5",attrs:{"for":dropdown.Label}},[_vm._v(_vm._s(dropdown.Label))]),_vm._v(" "),_c('div',{staticClass:"dropdown pmm-custom-dropdown p-0 m-0 mt-2",class:{ 'dropdown-expanded': dropdown.IsDropdownOpen }},[_c('button',{staticClass:"w-100 dropdown-toggle",class:{
                        'has-selected-items':
                            dropdown.SelectedItems.length > 0,
                        'dropdown-collapse': dropdown.IsDropdownOpen,
                        'dropdown-expand': !dropdown.IsDropdownOpen,
                    },attrs:{"type":"button","aria-expanded":dropdown.IsDropdownOpen,"aria-labelledby":("dropdown-header-" + index),"id":dropdown.Label},on:{"click":function($event){return _vm.toggleDropdown(dropdown, index)}}},[(dropdown.SelectedItems.length > 0)?_c('span',{staticClass:"badge-section"},_vm._l((dropdown.SelectedItems),function(item,idx){return _c('span',{key:idx,staticClass:"badge badge-primary",attrs:{"aria-label":(item + " close button")}},[_c('span',{domProps:{"innerHTML":_vm._s(item)}}),_vm._v(" "),_c('span',{staticClass:"badge badge-light close-button",attrs:{"role":"button","tabindex":"0","aria-label":("Remove " + item + " from the dropdown")},on:{"click":function($event){$event.stopPropagation();return _vm.removeItem(dropdown, item)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.removeItem(dropdown, item)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.removeItem(dropdown, item)}]}},[_vm._v("×")])])}),0):_c('span',{attrs:{"for":dropdown.Label}},[_vm._v("Select Items")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu w-100",class:{ show: dropdown.IsDropdownOpen },attrs:{"aria-labelledby":("dropdown-header-" + index)}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dropdown.SearchQuery),expression:"dropdown.SearchQuery"}],staticClass:"searchInput form-control mb-2",attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(dropdown.SearchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dropdown, "SearchQuery", $event.target.value)}}}),_vm._v(" "),_c('form',{staticClass:"checkboxForm"},_vm._l((_vm.filteredOptions(
                                dropdown
                            )),function(option,optionIndex){return _c('div',{key:option.Value,staticClass:"form-check"},[_c('div',{staticClass:"custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dropdown.SelectedItems),expression:"dropdown.SelectedItems"}],staticClass:"form-check-input custom-dropdown-checkbox",attrs:{"type":"checkbox","id":option.Value,"aria-labelledby":("label-" + (option.Value))},domProps:{"value":option.Name,"checked":Array.isArray(dropdown.SelectedItems)?_vm._i(dropdown.SelectedItems,option.Name)>-1:(dropdown.SelectedItems)},on:{"change":[function($event){var $$a=dropdown.SelectedItems,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option.Name,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(dropdown, "SelectedItems", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(dropdown, "SelectedItems", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(dropdown, "SelectedItems", $$c)}},function($event){return _vm.handleParentCheckboxChange(option)}]}}),_vm._v(" "),_c('label',{staticClass:"parent-name",attrs:{"for":option.Name,"id":("label-" + (option.Value))},domProps:{"innerHTML":_vm._s(option.Name)}}),_vm._v(" "),(
                                        option.Children &&
                                        option.Children.length > 0
                                    )?_c('span',{class:option.expanded
                                            ? 'icon-collapse'
                                            : 'icon-expand',on:{"click":function($event){$event.stopPropagation();return _vm.toggleParent(option, dropdown)}}}):_vm._e()]),_vm._v(" "),(option.expanded)?_c('div',{staticStyle:{"padding-left":"20px"}},_vm._l((option.Children),function(childOption,childIndex){return _c('div',{key:childOption.Value,staticClass:"form-check"},[_c('div',{staticClass:"custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dropdown.SelectedItems),expression:"dropdown.SelectedItems"}],staticClass:"form-check-input custom-dropdown-checkbox",attrs:{"type":"checkbox","id":childOption.Value,"aria-labelledby":("label-" + (childOption.Value))},domProps:{"value":childOption.Name,"checked":Array.isArray(dropdown.SelectedItems)?_vm._i(dropdown.SelectedItems,childOption.Name)>-1:(dropdown.SelectedItems)},on:{"change":[function($event){var $$a=dropdown.SelectedItems,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=childOption.Name,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(dropdown, "SelectedItems", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(dropdown, "SelectedItems", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(dropdown, "SelectedItems", $$c)}},function($event){return _vm.handleSubCheckboxChange(
                                                    childOption,
                                                    option
                                                )}]}}),_vm._v(" "),_c('label',{staticClass:"child-name",attrs:{"for":childOption.Name,"id":("label-" + (childOption.Value))},domProps:{"innerHTML":_vm._s(childOption.Name)}}),_vm._v(" "),(
                                                childOption.Children &&
                                                childOption.Children
                                                    .length > 0
                                            )?_c('span',{class:childOption.expanded
                                                    ? 'icon-collapse'
                                                    : 'icon-expand',on:{"click":function($event){$event.stopPropagation();return _vm.toggleSub(
                                                    childOption,
                                                    dropdown
                                                )}}}):_vm._e()]),_vm._v(" "),(childOption.expanded)?_c('div',{staticStyle:{"padding-left":"20px"}},_vm._l((childOption.Children),function(subChildOption,subChildIndex){return _c('div',{key:subChildOption.Value,staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                                    dropdown.SelectedItems
                                                ),expression:"\n                                                    dropdown.SelectedItems\n                                                "}],staticClass:"form-check-input custom-dropdown-child",attrs:{"type":"checkbox","id":subChildOption.Value,"aria-labelledby":("label-" + (subChildOption.Value))},domProps:{"value":subChildOption.Name,"checked":Array.isArray(
                                                    dropdown.SelectedItems
                                                )?_vm._i(
                                                    dropdown.SelectedItems
                                                ,subChildOption.Name)>-1:(
                                                    dropdown.SelectedItems
                                                )},on:{"change":[function($event){var $$a=
                                                    dropdown.SelectedItems
                                                ,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=subChildOption.Name,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(dropdown, "SelectedItems", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(dropdown, "SelectedItems", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(dropdown, "SelectedItems", $$c)}},function($event){return _vm.handleSemiSubCheckboxChange(
                                                        subChildOption,
                                                        childOption
                                                    )}]}}),_vm._v(" "),_c('label',{staticClass:"sub-child-name",attrs:{"for":subChildOption.Name,"id":("label-" + (subChildOption.Value))},domProps:{"innerHTML":_vm._s(subChildOption.Name)}})])}),0):_vm._e()])}),0):_vm._e()])}),0)])])])])}),_vm._v(" "),_c('div',{staticClass:"modal-footer d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n            Submit\n        ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_primacy_calculator_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_primacy_calculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_primacy_calculator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_primacy_calculator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_primacy_calculator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d444118_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_primacy_calculator_vue__ = __webpack_require__(495);
function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_primacy_calculator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d444118_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_primacy_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(480);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a335cde8", content, true, {});

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".is-invalid{border-color:red!important}.c-hero-card-snackable__content{left:0!important}.cal-btn{border:2px solid #000}.custom-invalid-feedback{display:block}", ""]);

// exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(482);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("274f0075", content, true, {});

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-24a4697b]{background-color:#d22338}.phd-bg--red-alt[data-v-24a4697b]{background-color:#c0161d}.phd-bg--gray-light[data-v-24a4697b]{background-color:#f1f1f1}.phd-bg--gray[data-v-24a4697b]{background-color:#979797}.phd-bg--gray-mid[data-v-24a4697b]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-24a4697b]{background-color:#373737}.phd-bg--black[data-v-24a4697b]{background-color:#000}.phd-bg--black-alt[data-v-24a4697b]{background-color:#050606}.phd-bg--blue[data-v-24a4697b]{background-color:#65baf5}.phd-bg--blue-alt[data-v-24a4697b]{background-color:#034a80}.phd-bg--mustard[data-v-24a4697b]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-24a4697b]{background-color:#a7762d}.phd-bg--lime[data-v-24a4697b]{background-color:#abd02e}.phd-bg--lime-alt[data-v-24a4697b]{background-color:#6b831c}.phd-bg--seafoam[data-v-24a4697b]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-24a4697b]{background-color:#1d7164}.phd-font-color--red[data-v-24a4697b]{color:#d22338}.phd-font-color--red-alt[data-v-24a4697b]{color:#c0161d}.phd-font-color--gray-light[data-v-24a4697b]{color:#f1f1f1}.phd-font-color--gray[data-v-24a4697b]{color:#979797}.phd-font-color--gray-mid[data-v-24a4697b]{color:#6d6e71}.phd-font-color--gray-dark[data-v-24a4697b]{color:#373737}.phd-font-color--black[data-v-24a4697b]{color:#000}.phd-font-color--black-alt[data-v-24a4697b]{color:#050606}.phd-font-color--blue[data-v-24a4697b]{color:#65baf5}.phd-font-color--blue-alt[data-v-24a4697b]{color:#034a80}.phd-font-color--mustard[data-v-24a4697b]{color:#f9b146}.phd-font-color--mustard-alt[data-v-24a4697b]{color:#a7762d}.phd-font-color--lime[data-v-24a4697b]{color:#abd02e}.phd-font-color--lime-alt[data-v-24a4697b]{color:#6b831c}.phd-font-color--seafoam[data-v-24a4697b]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-24a4697b]{color:#1d7164}.phd-link-color--red[data-v-24a4697b],.phd-link-color--red[data-v-24a4697b]:hover{color:#d22338}.phd-link-color--red-alt[data-v-24a4697b],.phd-link-color--red-alt[data-v-24a4697b]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-24a4697b],.phd-link-color--gray-light[data-v-24a4697b]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-24a4697b],.phd-link-color--gray[data-v-24a4697b]:hover{color:#979797}.phd-link-color--gray-mid[data-v-24a4697b],.phd-link-color--gray-mid[data-v-24a4697b]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-24a4697b],.phd-link-color--gray-dark[data-v-24a4697b]:hover{color:#373737}.phd-link-color--black[data-v-24a4697b],.phd-link-color--black[data-v-24a4697b]:hover{color:#000}.phd-link-color--black-alt[data-v-24a4697b],.phd-link-color--black-alt[data-v-24a4697b]:hover{color:#050606}.phd-link-color--blue[data-v-24a4697b],.phd-link-color--blue[data-v-24a4697b]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-24a4697b],.phd-link-color--blue-alt[data-v-24a4697b]:hover{color:#034a80}.phd-link-color--mustard[data-v-24a4697b],.phd-link-color--mustard[data-v-24a4697b]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-24a4697b],.phd-link-color--mustard-alt[data-v-24a4697b]:hover{color:#a7762d}.phd-link-color--lime[data-v-24a4697b],.phd-link-color--lime[data-v-24a4697b]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-24a4697b],.phd-link-color--lime-alt[data-v-24a4697b]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-24a4697b],.phd-link-color--seafoam[data-v-24a4697b]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-24a4697b],.phd-link-color--seafoam-alt[data-v-24a4697b]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-24a4697b]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-24a4697b]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-24a4697b]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-24a4697b]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-24a4697b]{background-color:#e71e26}.ecc-bg--loe-br[data-v-24a4697b]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-24a4697b]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-24a4697b]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-24a4697b]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-24a4697b]{background-color:#bdd3ea}.ecc-bg--gray[data-v-24a4697b]{background-color:#ebebeb}.ecc-bg--white[data-v-24a4697b]{background-color:#fff}.ecc-bg--black[data-v-24a4697b]{background-color:#000}.ecc-font-color--cor-1[data-v-24a4697b]{color:#67bf80}.ecc-font-color--cor-2a[data-v-24a4697b]{color:#ffd643}.ecc-font-color--cor-2b[data-v-24a4697b]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-24a4697b]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-24a4697b]{color:#e71e26}.ecc-font-color--loe-br[data-v-24a4697b]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-24a4697b]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-24a4697b]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-24a4697b]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-24a4697b]{color:#bdd3ea}.ecc-font-color--gray[data-v-24a4697b]{color:#ebebeb}.ecc-font-color--white[data-v-24a4697b]{color:#fff}.ecc-font-color--black[data-v-24a4697b]{color:#000}.custom-recommedation-text[data-v-24a4697b]{font-weight:400!important}.custom-cal-link[data-v-24a4697b]{width:270px;margin-left:-20px;text-decoration:none;text-align:left}.custom-cal-link[data-v-24a4697b]:after{font-size:10px;margin-top:-5px}.custom-modal-cal[data-v-24a4697b]{width:310px!important;border-top:6px solid #ed0a22;background:#fff;-webkit-box-shadow:0 15px 30px 0 rgba(0,0,0,.2);box-shadow:0 15px 30px 0 rgba(0,0,0,.2);padding:48px 18px 36px;z-index:2}.custom-start-over[data-v-24a4697b]{border:1px solid #ed0a22!important;padding:10px 12px!important;border-radius:50px}.custom-modal-cal p[data-v-24a4697b]{color:#000!important;font-weight:600;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important;text-align:center!important}.c-aha-form textarea[data-v-24a4697b],textarea.form-control[data-v-24a4697b]{padding:10px;min-height:100px}.lower[data-v-24a4697b]{margin-top:45px}@media (min-width:576px){.lower[data-v-24a4697b]{margin-top:50px}}a.icon[data-v-24a4697b]{width:30px;height:30px;background:#ed0a22;border-radius:50%;border:thin solid #ed0a22;color:#fff!important;font-weight:700;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}a.icon[data-v-24a4697b]:hover{color:#fff}#recommendation[data-v-24a4697b],#risk[data-v-24a4697b],.toolTip[data-v-24a4697b]{background-color:#e9ecef;opacity:1;padding:1rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-clip:padding-box;border:1px solid #c4cacf;border-radius:2px;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.validation-modal-style[data-v-24a4697b]{color:#ed0a22;font-weight:600;font-size:12px}.validation-modal-header[data-v-24a4697b]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.help-width[data-v-24a4697b]{width:610px}.modal.show .modal-dialog-centered .modal-content[data-v-24a4697b]{overflow:hidden;word-wrap:break-word}@media (min-width:768px){.help-width[data-v-24a4697b]{width:610px}}@media (max-width:767.98px){.help-width[data-v-24a4697b]{width:300px}}", ""]);

// exports


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phd-risk-calculator"},[(!_vm.mainScreen)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"h3 mt-4"},[_vm._v("You entered age "+_vm._s(_vm.userAgeValue))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 h-100"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.hcmCalculatorFormula.apply(null, arguments)}}},[_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"la-size"}},[_c('span',{staticClass:"abbr",attrs:{"aria-label":"Left atrium"}},[_c('p',{attrs:{"title":"Left atrium"}},[_vm._v(_vm._s(_vm.laSizeLabel))])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.lasize_range.value),expression:"lasize_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"la-size","placeholder":"28 to 67","aria-describedby":"mm-value"},domProps:{"value":(_vm.lasize_range.value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.lasize_range, "value", _vm._n($event.target.value))},function($event){return _vm.handleUpperInput('lvpwd_mm')}],"blur":[_vm.validateLasize,function($event){return _vm.$forceUpdate()}]}}),_vm._v(" "),(_vm.isLasizeValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" LA Size must be between 28 and 67 mm")]):_vm._e(),_vm._v(" "),(_vm.isLasizeRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v("LA Size must be between 28 and 67 mm")]):_vm._e(),_vm._v(" "),(!_vm.lasizeToolTip)?_c('p',{staticClass:"toolTip mt-3 help-width",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.laSizeHelpText))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('span',{staticClass:"float-left"},[_vm._v("mm")]),_vm._v(" "),_c('a',{key:"lasize-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Left atrium diameter size"},on:{"click":function($event){_vm.lasizeToolTip = !_vm.lasizeToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"max-lvot"}},[_c('span',{staticClass:"abbr",attrs:{"aria-label":"Maximal left ventricular outflow tract gradient"}},[_c('p',{attrs:{"title":"Maximal left ventricular outflow tract gradient"}},[_vm._v(_vm._s(_vm.maxLvotGradientLabel))])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.maxlvot_range.value),expression:"maxlvot_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"max-lvot","placeholder":"2 to 154","aria-describedby":"mmHg-value"},domProps:{"value":(_vm.maxlvot_range.value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.maxlvot_range, "value", _vm._n($event.target.value))},function($event){return _vm.handleUpperInput('la_systole_mm')}],"blur":[_vm.validateMaxlovt,function($event){return _vm.$forceUpdate()}]}}),_vm._v(" "),(_vm.isMaxlovtValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("Max LVOT Gradient must be between 2 and 154 mmHg")]):_vm._e(),_vm._v(" "),(_vm.isMaxlvotRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v("Max LVOT Gradient must be between 2 and 154 mmHg")]):_vm._e(),_vm._v(" "),(!_vm.maxlvotToolTip)?_c('p',{staticClass:"toolTip mt-3 help-width",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.maxLvotGradientHelpText)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_vm._m(0),_vm._v(" "),_c('a',{key:"maxlvot-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Left ventricular outflow tract obstruction"},on:{"click":function($event){_vm.maxlvotToolTip = !_vm.maxlvotToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_c('label',{staticClass:"col-form-label text-uppercase",attrs:{"for":"mlvwt"}},[_c('span',{staticClass:"abbr"},[_c('p',{attrs:{"aria-label":"Maximal left ventricular wall thickness","title":"Maximal left ventricular wall thickness"}},[_vm._v(_vm._s(_vm.mlvwtLabel)+"\n                              ")])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.mlvwt_range.value),expression:"mlvwt_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"mlvwt","placeholder":"10 to 35","aria-describedby":"mm-value"},domProps:{"value":(_vm.mlvwt_range.value)},on:{"blur":[_vm.validateMlvwt,function($event){return _vm.$forceUpdate()}],"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.mlvwt_range, "value", _vm._n($event.target.value))},function($event){return _vm.handleUpperInput('ivsd_mm')}]}}),_vm._v(" "),(_vm.isMlvwtValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" MLVWT must be between 10 and 35 mm.")]):_vm._e(),_vm._v(" "),(_vm.isMlvwtRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v(" MLVWT must be between 10 and 35 mm.")]):_vm._e(),_vm._v(" "),(!_vm.mlvwtToolTip)?_c('p',{staticClass:"toolTip mt-3 help-width",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.mlvwtHelpText))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_vm._m(1),_vm._v(" "),_c('a',{key:"mlvwt-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Maximal left ventricular wall thickness"},on:{"click":function($event){_vm.mlvwtToolTip = !_vm.mlvwtToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('fieldset',{staticClass:"mt-5"},[_c('legend',{staticClass:"sr-only"},[_vm._v("Risk Factors for Sudden Cardiac Death")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label text-uppercase"},[_c('span',{staticClass:"abbr"},[_c('span',{attrs:{"id":"abbrfhscd","aria-label":"Family History of Sudden Cardiac Death","title":"Family History of Sudden Cardiac Death"}},[_vm._v(_vm._s(_vm.fhscdLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"fhscd_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fhscd_pick),expression:"fhscd_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"fhscd","id":"fhscd_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbrfhscd"},domProps:{"checked":_vm._q(_vm.fhscd_pick,_vm._n("0"))},on:{"change":function($event){_vm.fhscd_pick=_vm._n("0")}}}),_vm._v(" No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"fhscd_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fhscd_pick),expression:"fhscd_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"fhscd","id":"fhscd_yes","autocomplete":"off","value":"1","aria-describedby":"abbrfhscd"},domProps:{"checked":_vm._q(_vm.fhscd_pick,_vm._n("1"))},on:{"change":function($event){_vm.fhscd_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"fhscd-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Family History of Sudden Cardiac Death"},on:{"click":function($event){_vm.fhscdToolTip = !_vm.fhscdToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(!_vm.fhscdToolTip)?_c('p',{staticClass:"toolTip help-width",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.fhscdHelpText)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label text-uppercase"},[_c('span',{staticClass:"abbr"},[_c('span',{attrs:{"id":"abbrnsvt","aria-label":"Non-sustained ventricular tachycardia","title":"Non-sustained ventricular tachycardia"}},[_vm._v(_vm._s(_vm.nsvtLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"nsvt_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.nsvt_pick),expression:"nsvt_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"nsvt","id":"nsvt_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbrnsvt"},domProps:{"checked":_vm._q(_vm.nsvt_pick,_vm._n("0"))},on:{"change":function($event){_vm.nsvt_pick=_vm._n("0")}}}),_vm._v(" No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"nsvt_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.nsvt_pick),expression:"nsvt_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"nsvt","id":"nsvt_yes","autocomplete":"off","value":"1","aria-describedby":"abbrnsvt"},domProps:{"checked":_vm._q(_vm.nsvt_pick,_vm._n("1"))},on:{"change":function($event){_vm.nsvt_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"nsvt-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Non-sustained ventricular tachycardia"},on:{"click":function($event){_vm.nsvtToolTip = !_vm.nsvtToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(!_vm.nsvtToolTip)?_c('p',{staticClass:"toolTip help-width",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.nsvtHelpText)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label"},[_vm._v(" "+_vm._s(_vm.usLabel))]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"unexSy_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.unexSy_pick),expression:"unexSy_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"unexSy","id":"unexSy_no","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.unexSy_pick,_vm._n("0"))},on:{"change":function($event){_vm.unexSy_pick=_vm._n("0")}}}),_vm._v("\n                                        No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"unexSy_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.unexSy_pick),expression:"unexSy_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"unexSy","id":"unexSy_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.unexSy_pick,_vm._n("1"))},on:{"change":function($event){_vm.unexSy_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"unexsy-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Unexplained Syncope"},on:{"click":function($event){_vm.unexSyToolTip = !_vm.unexSyToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(!_vm.unexSyToolTip)?_c('p',{staticClass:"toolTip help-width",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.usHelpText)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label"},[_c('span',{staticClass:"abbr"},[_c('span',{attrs:{"id":"abbref","aria-label":"Ejection fraction","title":"Ejection fraction"},domProps:{"innerHTML":_vm._s(_vm.efLabel)}}),_vm._v(":")])]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"ef50_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.ef50_pick),expression:"ef50_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"ef50","id":"ef50_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbref"},domProps:{"checked":_vm._q(_vm.ef50_pick,_vm._n("0"))},on:{"change":function($event){_vm.ef50_pick=_vm._n("0")}}}),_vm._v(" No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"ef50_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.ef50_pick),expression:"ef50_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"ef50","id":"ef50_yes","autocomplete":"off","value":"1","aria-describedby":"abbref"},domProps:{"checked":_vm._q(_vm.ef50_pick,_vm._n("1"))},on:{"change":function($event){_vm.ef50_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"ef50-iput",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Ejection fraction"},on:{"click":function($event){_vm.ef50ToolTip = !_vm.ef50ToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(!_vm.ef50ToolTip)?_c('p',{staticClass:"toolTip help-width",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.efHelpText)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label"},[_vm._v(_vm._s(_vm.aaLabel))]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"apAn_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.apAn_pick),expression:"apAn_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"apAn","id":"apAn_no","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.apAn_pick,_vm._n("0"))},on:{"change":function($event){_vm.apAn_pick=_vm._n("0")}}}),_vm._v("\n                                        No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"apAn_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.apAn_pick),expression:"apAn_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"apAn","id":"apAn_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.apAn_pick,_vm._n("1"))},on:{"change":function($event){_vm.apAn_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"apan-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Apical Aneurysm"},on:{"click":function($event){_vm.apAnToolTip = !_vm.apAnToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(!_vm.apAnToolTip)?_c('p',{staticClass:"toolTip help-width",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.aaHelpText)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label"},[_c('span',{staticClass:"abbr"},[_c('span',{attrs:{"aria-label":"Late gadolinium enhancement","id":"abbr-elge","title":"Late gadolinium enhancement"}},[_vm._v(_vm._s(_vm.lgeLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"elge_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.elge_pick),expression:"elge_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"elge","id":"elge_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbr-elge"},domProps:{"checked":_vm._q(_vm.elge_pick,_vm._n("0"))},on:{"change":function($event){_vm.elge_pick=_vm._n("0")}}}),_vm._v(" No \n                                     ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"elge_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.elge_pick),expression:"elge_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"elge","id":"elge_yes","autocomplete":"off","value":"1","aria-describedby":"abbr-elge"},domProps:{"checked":_vm._q(_vm.elge_pick,_vm._n("1"))},on:{"change":function($event){_vm.elge_pick=_vm._n("1")}}}),_vm._v(" Yes \n                                  ")]),_vm._v(" "),_c('a',{key:"elge-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Extensive Late gadolinium enhancement"},on:{"click":function($event){_vm.elgeToolTip = !_vm.elgeToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(!_vm.elgeToolTip)?_c('p',{staticClass:"toolTip help-width",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.lgeHelpText)}}):_vm._e()])])]),_vm._v(" "),(_vm.validationModal)?_c('div',{staticClass:"c-hero-card__container col-6"},[_c('aha-modal',{ref:"validationModal",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"validationModal","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('div',{staticClass:"h3 text-left validation-modal-header",domProps:{"innerHTML":_vm._s(_vm.errorModalHeaderText)}}),_vm._v(" "),_c('div',{staticClass:"h4 text-left mt-4"},[_vm._v("HCM SCD Score")]),_vm._v(" "),_c('div',[(_vm.lasize_range.value === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA\n                                size field is missing")]):(_vm.lasize_range.value > 67 || _vm.lasize_range.value < 28)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA Size must be between 28\n                                and 67 mm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.maxlvot_range.value === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max\n                                LVOT Gradient field is missing")]):(_vm.maxlvot_range.value > 154 || _vm.maxlvot_range.value < 2)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient must be\n                                between 2 and 154 mmHg.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.mlvwt_range.value === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - MLVWT\n                                field is missing")]):(_vm.mlvwt_range.value> 35 || _vm.mlvwt_range.value < 10)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v("- MLVWT must be between 10 and 35 mm")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-3 h6 text-left",domProps:{"innerHTML":_vm._s(_vm.errorModalFooterText)}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mt-4"},[_c('div',{staticClass:"btn btn-outline-danger",on:{"click":_vm.validationBack}},[_vm._v("Back")]),_vm._v(" "),_c('div',{staticClass:"btn btn-primary",on:{"click":_vm.hcmCalculatorFormula}},[_vm._v("See Results")])])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_c('input',{key:"back",staticClass:"btn btn-primary",attrs:{"type":"button","value":"Back"},on:{"click":_vm.handleBackScreen}}),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('validationModal'),expression:"'validationModal'"}],key:"submit",staticClass:"btn btn-primary",attrs:{"href":"#","type":"submit","value":"Calculate"},on:{"click":_vm.formValidate}},[_vm._v("Submit")]),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between w-100 align-center"},[_c('p',{staticClass:"col-sm-12 col-md-6 c-daily-journey__slide-number mt-3"},[_vm._v("2 of 3")]),_vm._v(" "),_c('p',{staticClass:"p col-sm-12 col-md-6 mt-3",domProps:{"innerHTML":_vm._s(_vm.calculatorVersionText)}})])])])])]):_vm._e(),_vm._v(" "),(_vm.isShowModal)?_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"h4"},[_vm._v("Estimated risk of SCD at 5 years (%) for age "+_vm._s(_vm.userAgeValue))]),_vm._v(" "),_c('div',{staticClass:"p",domProps:{"innerHTML":_vm._s(_vm.riskHeaderText)}}),_vm._v(" "),_c('div',{staticClass:"row flex-column justify-content-center align-content-center mt-4"},[(_vm.hcmScdCalculatorResultValidatoin)?_c('div',{staticClass:"col-12 w-50 mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex justify-content-center text-center h4"},[_vm._v("HCM SCD Score")]),_vm._v(" "),_c('p',{staticClass:"c-hero-card__subheading h1 d-flex justify-content-center font-weight flex-column",domProps:{"innerHTML":_vm._s(_vm.risk.value + '%')}}),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('riskSCD'),expression:"'riskSCD'"}],staticClass:"c-cta c-cta--arrow h-theme--red custom-cal-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.hcmScdScoreLabel))])]),_vm._v(" "),_c('aha-modal',{ref:"riskSCD",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"riskSCD","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"Strip Down"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz align-self-start"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.hcmScdScoreDescription)}})])],1)])]}}],null,false,2347706727)})],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p mt-4 mb-4 ml-3",domProps:{"innerHTML":_vm._s(_vm.resultGuidelineTextAdult)}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-left align-center mt-4 h4"},[_vm._v("\n        "+_vm._s(_vm.patientSelectionLabel)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-center mt-4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.hcmRecommendationDescription)}})]),_vm._v(" "),(_vm.hcmScdCalculatorResultValidatoin)?_c('div',{staticClass:"col-12 w-50 mx-auto c-hero-card__container mt-4 d-flex justify-content-center"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex h4"},[_vm._v(_vm._s(_vm.hcmScdRecommendationLabel))]),_vm._v(" "),_c('p',{staticClass:"h5 d-flex justify-content-center custom-recommedation-text",domProps:{"innerHTML":_vm._s(_vm.recommendation)}})])]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number d-flex justify-content-center mt-4"},[_vm._v("3 of 3")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-3"},[_c('button',{staticClass:"p-0 my-4 bg-white border-0 custom-start-over",attrs:{"type":"button"},on:{"click":_vm.handleReload}},[_c('img',{attrs:{"src":"/assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("Start Over")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr float-left"},[_c('span',{attrs:{"id":"mmHg-value","aria-label":"millimetre of mercury ","title":"millimetre of mercury "}},[_vm._v("mmHg")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"float-left"},[_c('span',{attrs:{"id":"mm-value","aria-label":"millimetre","title":"millimetre"}},[_vm._v("mm")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(485);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("45b61c2a", content, true, {});

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".custom-recommedation-text{font-weight:400!important}.custom-cal-link{width:270px;margin-left:-20px;text-decoration:none;text-align:left}.custom-cal-link:after{font-size:10px;margin-top:-5px}.custom-modal-cal{width:310px!important;border-top:6px solid #ed0a22;background:#fff;-webkit-box-shadow:0 15px 30px 0 rgba(0,0,0,.2);box-shadow:0 15px 30px 0 rgba(0,0,0,.2);padding:48px 18px 36px;z-index:2}.custom-start-over{border:1px solid #ed0a22!important;padding:10px 12px!important;border-radius:50px}.custom-modal-cal p{color:#000!important;font-weight:600}.is-invalid{border-color:#ed0a22!important}.c-hero-card-snackable__content{left:0!important}.c-aha-form textarea,textarea.form-control{padding:10px;min-height:100px}.lower{margin-top:45px}@include media-breakpoint-up(sm){.lower{margin-top:50px}}a.icon{width:30px;height:30px;background:#ed0a22;border-radius:50%;border:thin solid #ed0a22;color:#fff!important;font-weight:700;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}a.icon:hover{color:#fff}#recommendation,#risk,.toolTip{background-color:#e9ecef;opacity:1;padding:1rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-clip:padding-box;border:1px solid #c4cacf;border-radius:2px;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.validation-modal-style{color:#ed0a22;font-weight:600;font-size:12px}.validation-modal-header{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.modal.show .modal-dialog-centered .modal-content{overflow:hidden;word-wrap:break-word}", ""]);

// exports


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[(!_vm.mainScreen)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"h3 mt-4"},[_vm._v("You entered age "+_vm._s(_vm.userAgeValue))]),_vm._v(" "),_c('div',{staticClass:"col-12 h-100"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.calculate_sdc_risk.apply(null, arguments)}}},[_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4 col-form-label"},[_vm._v("\n                        "+_vm._s(_vm.sexLabel)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',[_c('label',{attrs:{"for":"male"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex_range),expression:"sex_range"}],attrs:{"type":"radio","name":"sex","id":"male","autocomplete":"off","value":"0","aria-describedby":"male","aria-label":"Sex male","checked":""},domProps:{"checked":_vm._q(_vm.sex_range,"0")},on:{"change":function($event){_vm.sex_range="0"}}}),_vm._v("\n                                Male\n                            ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"female"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex_range),expression:"sex_range"}],attrs:{"type":"radio","name":"sex","id":"female","autocomplete":"off","value":"1","aria-describedby":"female","aria-label":"Sex female"},domProps:{"checked":_vm._q(_vm.sex_range,"1")},on:{"change":function($event){_vm.sex_range="1"}}}),_vm._v("\n                                Female\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"Height"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.heightLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hgt_cm),expression:"hgt_cm"}],staticClass:"form-control",attrs:{"type":"text","id":"Height","placeholder":"25 to 190","aria-describedby":"Height"},domProps:{"value":(_vm.hgt_cm)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.hgt_cm=$event.target.value},function($event){return _vm.handleUpperInput('height')}],"blur":function($event){return _vm.validationFiled('Height')}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.heightValidationError))]),_vm._v(" "),(_vm.heightRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Height must be between 25 and 190 cm.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"Weight"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.weightLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wgt_kg),expression:"wgt_kg"}],staticClass:"form-control",attrs:{"type":"text","id":"Weight","placeholder":"1 to 150","aria-describedby":"Weight"},domProps:{"value":(_vm.wgt_kg)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.wgt_kg=$event.target.value},function($event){return _vm.handleUpperInput('weight')}],"blur":function($event){return _vm.validationFiled('weight')}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.weightValidationError))]),_vm._v(" "),(_vm.weightRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Weight must be between 1 and 150 kg")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"la_systole_mm"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(" "+_vm._s(_vm.laSizeLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.la_systole_mm),expression:"la_systole_mm"}],staticClass:"form-control",attrs:{"type":"text","id":"la_systole_mm","placeholder":"3 to 80","aria-describedby":"Left atrial diameter at end-systole must be between 5 and 55 mm."},domProps:{"value":(_vm.la_systole_mm)},on:{"blur":function($event){return _vm.validationFiled('la_systole_mm')},"input":[function($event){if($event.target.composing){ return; }_vm.la_systole_mm=$event.target.value},function($event){return _vm.handleUpperInput('la_systole_mm')}]}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('la_systole_mm')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.la_systole_mm_validationError))]),_vm._v(" "),(_vm.la_systole_mmRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.laSizeHelpText))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"peak_grad_mmhg"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(" "+_vm._s(_vm.maxLvotGradientLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.peak_grad_mmhg),expression:"peak_grad_mmhg"}],staticClass:"form-control",attrs:{"type":"text","id":"peak_grad_mmhg","placeholder":"0 to 210","aria-describedby":"PeakLVoutflowtractgradient"},domProps:{"value":(_vm.peak_grad_mmhg)},on:{"blur":function($event){return _vm.validationFiled('peak_grad_mmhg')},"input":[function($event){if($event.target.composing){ return; }_vm.peak_grad_mmhg=$event.target.value},function($event){return _vm.handleUpperInput('peak_grad_mmhg')}]}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('peak_grad_mmhg')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.peak_grad_mmhg_validationError))]),_vm._v(" "),(_vm.peak_grad_mmhgRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.maxLvotGradientHelpText))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"lvpwd_mm"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"mlvwtLabel"}},[_vm._v(" "+_vm._s(_vm.mlvwtLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lvpwd_mm),expression:"lvpwd_mm"}],staticClass:"form-control",attrs:{"type":"text","id":"lvpwd_mm","placeholder":"4 to 70","aria-describedby":" Maximum left ventricular posterior wall diameter (mm):"},domProps:{"value":(_vm.lvpwd_mm)},on:{"blur":function($event){return _vm.validationFiled('lvpwd_mm')},"input":[function($event){if($event.target.composing){ return; }_vm.lvpwd_mm=$event.target.value},function($event){return _vm.handleUpperInput('lvpwd_mm')}]}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('lvpwd_mm')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.lvpwd_mm_validationError))]),_vm._v(" "),(_vm.lvpwd_mmRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.mlvwtHelpText))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"ivsd_mm"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.isdLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ivsd_mm),expression:"ivsd_mm"}],staticClass:"form-control",attrs:{"type":"text","id":"ivsd_mm","placeholder":"0.5 to 43","aria-describedby":"ivsd_mm"},domProps:{"value":(_vm.ivsd_mm)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.ivsd_mm=$event.target.value},function($event){return _vm.handleUpperInput('ivsd_mm')}],"blur":function($event){return _vm.validationFiled('ivsd_mm')}}}),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('ivsd_mm')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.ivsd_mm_validationError))]),_vm._v(" "),(_vm.ivsd_mmRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.isdHelpText))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"posterLVWall"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.posteriorLvLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.posterLVWall),expression:"posterLVWall"}],staticClass:"form-control",attrs:{"type":"text","id":"posterLVWall","placeholder":"0.5 to 60","aria-describedby":"posterLVWall"},domProps:{"value":(_vm.posterLVWall)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.posterLVWall=$event.target.value},function($event){return _vm.handleUpperInput('posterLVWall')}],"blur":function($event){return _vm.validationFiled('posterLVWall')}}}),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.posterLVWall_validationError))])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(" "+_vm._s(_vm.gsLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Genotype status Not Tested"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation),expression:"genotype_mutation"}],attrs:{"type":"radio","name":"Genotype status Not Tested","id":"NotTested","autocomplete":"off","aria-label":"Genotype status_Not Tested","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.genotype_mutation,"0")},on:{"change":[function($event){_vm.genotype_mutation="0"},function($event){return _vm.handleChange('notTested')}]}}),_vm._v("\n                                    Not Tested\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Genotype status_Tested"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation),expression:"genotype_mutation"}],attrs:{"type":"radio","name":"Genotype status_Tested","id":"Genotystatus_Tested","aria-label":"Genotype status Tested","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.genotype_mutation,"1")},on:{"change":[function($event){_vm.genotype_mutation="1"},_vm.handleChange]}}),_vm._v("\n                                    Tested\n                                ")])])]),_vm._v(" "),(_vm.GenotypestatusRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.gsHelpText))]):_vm._e()]),_vm._v(" "),(_vm.genoTypePossitive)?_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.gpLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Genotype possitive_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation_yes),expression:"genotype_mutation_yes"}],attrs:{"type":"radio","name":"Genotype possitive_no","id":"NotTested","autocomplete":"off","aria-label":"Genotype possitive_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.genotype_mutation_yes,"0")},on:{"change":function($event){_vm.genotype_mutation_yes="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Genotype possitive_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation_yes),expression:"genotype_mutation_yes"}],attrs:{"type":"radio","name":"Genotype possitive_yes","id":"Genotype _possitive_yes","aria-label":"Genotype possitive_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.genotype_mutation_yes,"1")},on:{"change":[function($event){_vm.genotype_mutation_yes="1"},_vm.handleChange]}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('Genotypepositive')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.GenotypepositiveRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.gpHelpText))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.nsvtLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Non-sustained ventricular tachycardia_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.non_vt),expression:"non_vt"}],attrs:{"type":"radio","name":"Non-sustained ventricular tachycardia_no","id":"NotTested","autocomplete":"off","aria-label":"Non-sustained ventricular tachycardia_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.non_vt,"0")},on:{"change":function($event){_vm.non_vt="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Non-sustained ventricular tachycardia_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.non_vt),expression:"non_vt"}],attrs:{"type":"radio","name":"Non-sustained ventricular tachycardia_yes","id":"Non-sustained ventricular tachycardia_yes","aria-label":"Non-sustained ventricular tachycardia_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.non_vt,"1")},on:{"change":function($event){_vm.non_vt="1"}}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('nonVt')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.nonVtRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.nsvtHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.usLabel)+":")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Unexplained syncope_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.un_sy),expression:"un_sy"}],attrs:{"type":"radio","name":"Unexplained syncope_no","id":"UnexplainedSyncope_no","autocomplete":"off","aria-label":"Unexplained syncope_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.un_sy,"0")},on:{"change":function($event){_vm.un_sy="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Unexplained syncope_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.un_sy),expression:"un_sy"}],attrs:{"type":"radio","name":"Unexplained syncope_yes","id":"Unexplained syncope_yes","aria-label":"Unexplained synco_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.un_sy,"1")},on:{"change":function($event){_vm.un_sy="1"}}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('UnexplainedSyncope')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.UnexplainedSyncopeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.usHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[(_vm.isLoading)?_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_vm._m(7),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})]):_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_c('input',{key:"back",staticClass:"btn btn-primary",attrs:{"type":"button","value":"Back"},on:{"click":_vm.handleBackScreen}}),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('validationModal'),expression:"'validationModal'"}],key:"submit",staticClass:"btn btn-primary",attrs:{"href":"#","type":"submit","value":"Calculate"},on:{"click":_vm.formValidate}},[_vm._v("Submit")]),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between w-100 align-center"},[_c('p',{staticClass:"col-sm-12 col-md-6 c-daily-journey__slide-number mt-3"},[_vm._v("2 of 3")]),_vm._v(" "),_c('p',{staticClass:"p col-sm-12 col-md-6 mt-3",domProps:{"innerHTML":_vm._s(_vm.calculatorVersionText)}})])])])])]):_vm._e(),_vm._v(" "),(_vm.validationModal)?_c('div',{staticClass:"c-hero-card__container col-6"},[_c('aha-modal',{ref:"validationModal",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"validationModal","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('div',{staticClass:"h3 text-left validation-modal-header",domProps:{"innerHTML":_vm._s(_vm.errorModalHeaderText)}}),_vm._v(" "),_c('div',{staticClass:"h4 text-left mt-4"},[_vm._v("HCM Risk Kids Score")]),_vm._v(" "),_c('div',[(_vm.wgt_kg === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Weight field is missing")]):(_vm.wgt_kg > 150 || _vm.wgt_kg < 2)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Weight must be between 2 and 150 kg.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.la_systole_mm === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA size field is missing")]):(_vm.la_systole_mm > 80 || _vm.la_systole_mm < 3)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA Size must be between 3 and 80 mm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.lvpwd_mm === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - MLVWT field is missing")]):(_vm.lvpwd_mm > 70 || _vm.lvpwd_mm < 4 )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v("- MLVWT must be between 4 and 70 mm")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.peak_grad_mmhg === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient field is missing")]):( _vm.peak_grad_mmhg > 200 || _vm.peak_grad_mmhg < 0)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient must be between 0 and 200 mmHg.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"h4 text-left mt-4"},[_vm._v("PRIMaCY Risk Kids Score")]),_vm._v(" "),_c('div',[(_vm.wgt_kg === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Weight field is missing")]):(_vm.wgt_kg > 150 || _vm.wgt_kg < 1)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Weight must be between 1 and 150 kg")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.hgt_cm === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Height field is missing")]):( _vm.hgt_cm > 190 || _vm.hgt_cm < 25)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Height must be between 25 and 190 cm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.la_systole_mm === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA size field is missing")]):( _vm.la_systole_mm > 55 || _vm.la_systole_mm < 5)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" -  LA Size must be between 5 and 55 mm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.ivsd_mm === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Interventricular Septal Diameter field is missing")]):( _vm.ivsd_mm > 43|| _vm.ivsd_mm < 0.5)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Interventricular Septal Diameter must be between 0.5 and 43 mm")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.peak_grad_mmhg === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient field is missing")]):( _vm.peak_grad_mmhg > 210 || _vm.peak_grad_mmhg < 0)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient must be between 0 and 210 mmHg.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.posterLVWall === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Posterior LV Wall Diameter field is missing")]):(_vm.posterLVWall > 60 || _vm.posterLVWall < 0.5)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Posterior LV Wall Diameter must be between 0.5 and 60 mm.")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-3 h6 text-left",domProps:{"innerHTML":_vm._s(_vm.errorModalFooterText)}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mt-4"},[_c('div',{staticClass:"btn btn-outline-danger",on:{"click":_vm.validationBack}},[_vm._v("Back")]),_vm._v(" "),_c('div',{staticClass:"btn btn-primary",on:{"click":_vm.calculate_sdc_risk}},[_vm._v("See Results")])])])],1):_vm._e(),_vm._v(" "),(_vm.isShowModal)?_c('div',[_c('div',{staticClass:"h4"},[_vm._v("Estimated risk of SCD at 5 years (%) for age "+_vm._s(_vm.userAgeValue))]),_vm._v(" "),_c('div',{staticClass:"p",domProps:{"innerHTML":_vm._s(_vm.riskHeaderText)}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-md-center justify-content-sm-center mt-4"},[(_vm.riskKidsCalculatorResultValidation && _vm.userAgeValue > 0)?_c('div',{staticClass:"col-md-6 col-sm-12 mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading h4 d-flex justify-content-center text-center"},[_vm._v("HCM Risk Kids Score")]),_vm._v(" "),_c('P',{staticClass:"c-hero-card__subheading h1 d-flex justify-content-center font-weight"},[_vm._v(_vm._s(_vm.RiskKidsTotalResult))]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('HCMRisk'),expression:"'HCMRisk'"}],staticClass:"c-cta c-cta--arrow h-theme--red custom-cal-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.hcmRiskKidsScoreLabel))])],1),_vm._v(" "),_c('aha-modal',{ref:"HCMRisk",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"HCMRisk","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz align-self-start"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.hcmRiskKidsScoreDescription)}})])])])],1):_vm._e(),_vm._v(" "),(_vm.primacyCalculatorResulatValidation)?_c('div',{staticClass:"col-md-6 col-sm-12 mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex h4 justify-content-center text-center"},[_vm._v("PRIMaCY Risk Score")]),_vm._v(" "),_c('P',{staticClass:"c-hero-card__subheading h1 d-flex justify-content-center font-weight"},[_vm._v(_vm._s(_vm.primacyTotalResult))]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('primacyCal'),expression:"'primacyCal'"}],staticClass:"c-cta c-cta--arrow h-theme--red custom-cal-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.primacyRiskScoreLabel))])],1),_vm._v(" "),_c('aha-modal',{ref:"primacyCal",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"primacyCal","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('div',{staticClass:"c-hero-card-snackable-full-quiz align-self-start"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.primacyRiskScoreDescription)}})])])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p mt-4 mb-4 ml-3",domProps:{"innerHTML":_vm._s(_vm.resultGuidelineText)}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-left align-center mt-4 h4"},[_vm._v("\n        "+_vm._s(_vm.patientSelectionLabel)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-center mt-4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.hcmRecommendationDescription)}})]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number d-flex justify-content-center mt-4"},[_vm._v("3 of 3")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-3"},[_c('button',{staticClass:"p-0 my-4 bg-white border-0 custom-start-over",attrs:{"type":"button","step-index":"1"},on:{"click":_vm.handleReload}},[_c('img',{attrs:{"src":"/assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("Start Over")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"cm","title":"cm"}},[_vm._v("cm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"kg","title":"kg"}},[_vm._v("kg")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mm","title":"mm"}},[_vm._v("mm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mmHg","title":"mmHg"}},[_vm._v("mmHg")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mm","title":"mm"}},[_vm._v("mm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mm","title":"mm"}},[_vm._v("mm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mm","title":"mm"}},[_vm._v("mm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"loadong","disabled":""}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                            Loading...\n                        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_hcm_primacy_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_hcm_primacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_hcm_primacy_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_hcm_primacy_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_hcm_primacy_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a9d98c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_risk_hcm_primacy_vue__ = __webpack_require__(490);
function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_hcm_primacy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16a9d98c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_risk_hcm_primacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(489);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("06c16667", content, true, {});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".custom-recommedation-text{font-weight:400!important}.custom-cal-link{width:270px;margin-left:-20px;text-decoration:none;text-align:left}.custom-cal-link:after{font-size:10px;margin-top:-5px}.hcm-scd-card .custom-modal-cal{margin-top:70px}.custom-modal-cal{width:310px!important;border-top:6px solid #ed0a22;background:#fff;-webkit-box-shadow:0 15px 30px 0 rgba(0,0,0,.2);box-shadow:0 15px 30px 0 rgba(0,0,0,.2);padding:48px 18px 36px;z-index:2}.custom-start-over{border:1px solid #ed0a22!important;padding:10px 12px!important;border-radius:50px}.custom-modal-cal p{color:#000!important;font-weight:600;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important;text-align:center!important}.is-invalid{border-color:#ed0a22!important}.c-hero-card-snackable__content{left:0!important}.c-aha-form textarea,textarea.form-control{padding:10px;min-height:100px}.lower{margin-top:45px}@include media-breakpoint-up(sm){.lower{margin-top:50px}}a.icon{width:30px;height:30px;background:#ed0a22;border-radius:50%;border:thin solid #ed0a22;color:#fff!important;font-weight:700;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}a.icon:hover{color:#fff}#recommendation,#risk,.toolTip{background-color:#e9ecef;opacity:1;padding:1rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-clip:padding-box;border:1px solid #c4cacf;border-radius:2px;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.validation-modal-style{color:#ed0a22;font-weight:600;font-size:12px}.validation-modal-header{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.modal.show .modal-dialog-centered .modal-content{overflow:hidden;word-wrap:break-word}", ""]);

// exports


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[(!_vm.mainScreen)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"h3 mt-4"},[_vm._v("You entered age "+_vm._s(_vm.userAgeValue))]),_vm._v(" "),_c('div',{staticClass:"col-12 h-100"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.calculate_sdc_risk.apply(null, arguments)}}},[_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4 col-form-label"},[_vm._v("\n                        Sex\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',[_c('label',{attrs:{"for":"male"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex_range),expression:"sex_range"}],attrs:{"type":"radio","name":"male","id":"male","autocomplete":"off","value":"0","aria-describedby":"male","aria-label":"Sex male","checked":""},domProps:{"checked":_vm._q(_vm.sex_range,"0")},on:{"change":function($event){_vm.sex_range="0"}}}),_vm._v("\n                                Male\n                            ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"female"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sex_range),expression:"sex_range"}],attrs:{"type":"radio","name":"female","id":"female","autocomplete":"off","value":"1","aria-describedby":"female","aria-label":"Sex female"},domProps:{"checked":_vm._q(_vm.sex_range,"1")},on:{"change":function($event){_vm.sex_range="1"}}}),_vm._v("\n                                Female\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"Weight"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.weightLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wgt_kg),expression:"wgt_kg"}],staticClass:"form-control",attrs:{"type":"text","id":"Weight","placeholder":"2 to 150","aria-describedby":"Weight"},domProps:{"value":(_vm.wgt_kg)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.wgt_kg=$event.target.value},function($event){return _vm.handleUpperInput('weight')}],"blur":function($event){return _vm.validationFiled('weight')}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.weightValidationError))]),_vm._v(" "),(_vm.weightRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Weight must be between 1 and\n                                150 kg.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"la_systole_mm"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.laSizeLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.la_systole_mm),expression:"la_systole_mm"}],staticClass:"form-control",attrs:{"type":"text","id":"la_systole_mm","placeholder":"3 to 80","aria-describedby":"Left atrial diameter at end-systole must be between 5 and 55 mm."},domProps:{"value":(_vm.la_systole_mm)},on:{"blur":function($event){return _vm.validationFiled('la_systole_mm')},"input":[function($event){if($event.target.composing){ return; }_vm.la_systole_mm=$event.target.value},function($event){return _vm.handleUpperInput('la_systole_mm')}]}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('la_systole_mm')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.la_systole_mm_validationError))]),_vm._v(" "),(_vm.la_systole_mmRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.laSizeHelpText)+"\n                            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"peak_grad_mmhg"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(" "+_vm._s(_vm.maxLvotGradientLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.peak_grad_mmhg),expression:"peak_grad_mmhg"}],staticClass:"form-control",attrs:{"type":"text","id":"peak_grad_mmhg","placeholder":"0 to 200","aria-describedby":"PeakLVoutflowtractgradient"},domProps:{"value":(_vm.peak_grad_mmhg)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.peak_grad_mmhg=$event.target.value},function($event){return _vm.handleUpperInput('peak_grad_mmhg')}],"blur":function($event){return _vm.validationFiled('peak_grad_mmhg')}}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('peak_grad_mmhg')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.peak_grad_mmhg_validationError))]),_vm._v(" "),(_vm.peak_grad_mmhgRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.maxLvotGradientHelpText))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"lvpwd_mm"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(" "+_vm._s(_vm.mlvwtLabel)+"\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lvpwd_mm),expression:"lvpwd_mm"}],staticClass:"form-control",attrs:{"type":"text","id":"lvpwd_mm","placeholder":"4 to 70","aria-describedby":" Maximum left ventricular posterior wall diameter (mm):"},domProps:{"value":(_vm.lvpwd_mm)},on:{"blur":function($event){return _vm.validationFiled('lvpwd_mm')},"input":[function($event){if($event.target.composing){ return; }_vm.lvpwd_mm=$event.target.value},function($event){return _vm.handleUpperInput('lvpwd_mm')}]}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('lvpwd_mm')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                "+_vm._s(_vm.lvpwd_mm_validationError))]),_vm._v(" "),(_vm.lvpwd_mmRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.mlvwtHelpText))]):_vm._e()])])]),_vm._v(" "),(_vm.genoTypePossitive)?_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.gpLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Genotype possitive_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation_yes),expression:"genotype_mutation_yes"}],attrs:{"type":"radio","name":"Genotype possitive_no","id":"NotTested","autocomplete":"off","aria-label":"Genotype possitive_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.genotype_mutation_yes,"0")},on:{"change":function($event){_vm.genotype_mutation_yes="0"}}}),_vm._v("\n                                No\n                            ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Genotype possitive_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation_yes),expression:"genotype_mutation_yes"}],attrs:{"type":"radio","name":"Genotype possitive_yes","id":"Genotype _possitive_yes","aria-label":"Genotype possitive_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.genotype_mutation_yes,"1")},on:{"change":[function($event){_vm.genotype_mutation_yes="1"},_vm.handleChange]}}),_vm._v("\n                                Yes\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('Genotypepositive')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.GenotypepositiveRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.gpHelpText))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.usLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Unexplained syncope_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.un_sy),expression:"un_sy"}],attrs:{"type":"radio","name":"Unexplained syncope_no","id":"UnexplainedSyncope_no","autocomplete":"off","aria-label":"Unexplained syncope_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.un_sy,"0")},on:{"change":function($event){_vm.un_sy="0"}}}),_vm._v("\n                                No\n                            ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Unexplained syncope_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.un_sy),expression:"un_sy"}],attrs:{"type":"radio","name":"Unexplained syncope_yes","id":"Unexplained syncope_yes","aria-label":"Unexplained synco_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.un_sy,"1")},on:{"change":function($event){_vm.un_sy="1"}}}),_vm._v("\n                                Yes\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('UnexplainedSyncope')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.UnexplainedSyncopeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.usHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.fhscdLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"fh scd_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fhscd_pick),expression:"fhscd_pick"}],attrs:{"type":"radio","name":"fh scd_no","id":"fhscd_no","autocomplete":"off","aria-label":"fh scd_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.fhscd_pick,"0")},on:{"change":function($event){_vm.fhscd_pick="0"}}}),_vm._v("\n                                No\n                            ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"fh scd_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fhscd_pick),expression:"fhscd_pick"}],attrs:{"type":"radio","name":"fh scd_yes","id":"fhscd_yes","aria-label":"fh scd_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.fhscd_pick,"1")},on:{"change":function($event){_vm.fhscd_pick="1"}}}),_vm._v("\n                                Yes\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('fhscdLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.fhscdIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.fhscdHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.nsvtLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"nsvt_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nsvt_pick),expression:"nsvt_pick"}],attrs:{"type":"radio","name":"nsvt_no","id":"nsvt_no","autocomplete":"off","aria-label":"nsvt_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.nsvt_pick,"0")},on:{"change":function($event){_vm.nsvt_pick="0"}}}),_vm._v("\n                                No\n                            ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"nsvt_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nsvt_pick),expression:"nsvt_pick"}],attrs:{"type":"radio","name":"nsvt_yes","id":"nsvt_yes","aria-label":"nsvt_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.nsvt_pick,"1")},on:{"change":function($event){_vm.nsvt_pick="1"}}}),_vm._v("\n                                Yes\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('nsvtLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.nsvtLabelRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.nsvtHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',{domProps:{"innerHTML":_vm._s(_vm.efLabel)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"EF_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ef50_pick),expression:"ef50_pick"}],attrs:{"type":"radio","name":"EF_no","id":"EF_no","autocomplete":"off","aria-label":"EF_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.ef50_pick,"0")},on:{"change":function($event){_vm.ef50_pick="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"EF_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ef50_pick),expression:"ef50_pick"}],attrs:{"type":"radio","name":"EF_yes","id":"EF_yes","aria-label":"EF_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.ef50_pick,"1")},on:{"change":function($event){_vm.ef50_pick="1"}}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('efLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.efLabelRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.efHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4 mt-3"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.aaLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"ApicalAneurysm_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apAn_pick),expression:"apAn_pick"}],attrs:{"type":"radio","name":"Apical Aneurysm_no","id":"Apical Aneurysm_no","autocomplete":"off","aria-label":"Apical Aneurysm_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.apAn_pick,"0")},on:{"change":function($event){_vm.apAn_pick="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Apical Aneurysm_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apAn_pick),expression:"apAn_pick"}],attrs:{"type":"radio","name":"Apical Aneurysm_yes","id":"Apical Aneurysm_yes","aria-label":"Apical Aneurysm_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.apAn_pick,"1")},on:{"change":function($event){_vm.apAn_pick="1"}}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('aaLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.aaLabelRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.aaHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-md-4 col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.lgeLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-5 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Extensive_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.elge_pick),expression:"elge_pick"}],attrs:{"type":"radio","name":"Extensive_no","id":"Apical Extensive_no","autocomplete":"off","aria-label":"Extensive _no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.elge_pick,"0")},on:{"change":function($event){_vm.elge_pick="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Extensive_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.elge_pick),expression:"elge_pick"}],attrs:{"type":"radio","name":"Extensive_yes","id":"Extensive_yes","aria-label":"Extensive_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.elge_pick,"1")},on:{"change":function($event){_vm.elge_pick="1"}}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-2 mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('lgeLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[(_vm.lgeLabelRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.lgeHelpText))]):_vm._e()])]),_vm._v(" "),(_vm.validationModal)?_c('div',{staticClass:"c-hero-card__container col-6"},[_c('aha-modal',{ref:"validationModal",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"validationModal","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('div',{staticClass:"h3 text-left validation-modal-header",domProps:{"innerHTML":_vm._s(_vm.errorModalHeaderText)}}),_vm._v(" "),_c('div',{staticClass:"h4 text-left mt-4"},[_vm._v("HCM Risk Kids Score")]),_vm._v(" "),_c('div',[(_vm.wgt_kg === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Weight field\n                                is missing")]):(_vm.wgt_kg > 150 || _vm.wgt_kg < 2)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Weight must be between 2 and 150 kg.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.la_systole_mm === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA\n                                size field is missing")]):(_vm.la_systole_mm > 80 || _vm.la_systole_mm < 3)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA Size must be between 3 and\n                                80 mm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.peak_grad_mmhg === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max\n                                LVOT Gradient field is missing")]):(_vm.peak_grad_mmhg > 200 || _vm.peak_grad_mmhg < 0)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v("- Max LVOT Gradient must be\n                                between 0 and 200 mmHg.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.lvpwd_mm === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - MLVWT\n                                field is missing")]):(_vm.lvpwd_mm > 70 || _vm.lvpwd_mm < 4)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v("- MLVWT must be between 4 and 70 mm")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"h4 text-left mt-4"},[_vm._v("HCM SCD Score")]),_vm._v(" "),_c('div',[(_vm.la_systole_mm === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA\n                                size field is missing")]):(_vm.la_systole_mm > 67 || _vm.la_systole_mm < 28)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA Size must be between 28\n                                and 67 mm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.peak_grad_mmhg === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max\n                                LVOT Gradient field is missing")]):(_vm.peak_grad_mmhg > 154 || _vm.peak_grad_mmhg < 2)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient must be\n                                between 2 and 154 mmHg.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.lvpwd_mm === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - MLVWT\n                                field is missing")]):(_vm.lvpwd_mm > 35 || _vm.lvpwd_mm < 10)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v("- MLVWT must be between 10 and 35 mm")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-3 h6 text-left",domProps:{"innerHTML":_vm._s(_vm.errorModalFooterText)}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mt-4"},[_c('div',{staticClass:"btn btn-outline-danger",on:{"click":_vm.validationBack}},[_vm._v("Back")]),_vm._v(" "),_c('div',{staticClass:"btn btn-primary",on:{"click":_vm.calculate_sdc_risk}},[_vm._v("See Results")])])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[(_vm.isLoading)?_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_vm._m(4),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})]):_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_c('input',{key:"back",staticClass:"btn btn-primary",attrs:{"type":"button","value":"Back"},on:{"click":_vm.handleBackScreen}}),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('validationModal'),expression:"'validationModal'"}],key:"submit",staticClass:"btn btn-primary",attrs:{"href":"#","type":"submit","value":"Calculate"},on:{"click":_vm.formValidate}},[_vm._v("Submit")]),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between w-100 align-center"},[_c('p',{staticClass:"col-sm-12 col-md-6 c-daily-journey__slide-number mt-3"},[_vm._v("2 of 3")]),_vm._v(" "),_c('p',{staticClass:"p col-sm-12 col-md-6 mt-3",domProps:{"innerHTML":_vm._s(_vm.calculatorVersionText)}})])])])])]):_vm._e(),_vm._v(" "),(_vm.isShowModal)?_c('div',[_c('div',{staticClass:"h4"},[_vm._v("Estimated risk of SCD at 5 years (%) for age "+_vm._s(_vm.userAgeValue))]),_vm._v(" "),_c('div',{staticClass:"p",domProps:{"innerHTML":_vm._s(_vm.riskHeaderText)}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-md-center justify-content-sm-center mt-4"},[(_vm.riskKidsCalculatorResultValidation)?_c('div',{staticClass:"col-md-6 col-sm-12 c-hero-card__container mb-4 d-flex justify-content-center align-items-center flex-column"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex h4 text-center"},[_vm._v("HCM Risk Kids Score")]),_vm._v(" "),_c('P',{staticClass:"c-hero-card__subheading h1 d-flex justify-content-center font-weight"},[_vm._v(_vm._s(_vm.RiskKidsTotalResult))]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('PrimacyRisk'),expression:"'PrimacyRisk'"}],staticClass:"c-cta c-cta--arrow h-theme--red custom-cal-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.hcmRiskKidsScoreLabel))])],1),_vm._v(" "),_c('aha-modal',{ref:"PrimacyRisk",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"PrimacyRisk","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"Strip Down"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz align-self-start"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.hcmRiskKidsScoreDescription)}})])],1)])]}}],null,false,3654466405)})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.hcmScdCalculatorResultValidatoin)?_c('div',{staticClass:"col-md-6 col-sm-12 c-hero-card__container mb-4 d-flex justify-content-center align-items-center flex-column"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex justify-content-center h4 text-center"},[_vm._v("HCM SCD Score")]),_vm._v(" "),_c('p',{staticClass:"c-hero-card__subheading h1 d-flex justify-content-center font-weight flex-column",domProps:{"innerHTML":_vm._s(_vm.risk.value + '%')}}),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('HCMSCD5'),expression:"'HCMSCD5'"}],staticClass:"c-cta c-cta--arrow h-theme--red custom-cal-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.hcmScdScoreLabel))])]),_vm._v(" "),_c('aha-modal',{ref:"HCMSCD5",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"HCMSCD5","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"Strip Down"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz align-self-start"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.hcmScdScoreDescription)}})])],1)])]}}],null,false,2347706727)})],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p mt-4 mb-4 ml-3",domProps:{"innerHTML":_vm._s(_vm.resultGuidelineTextSixteen)}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-left align-center mt-4 h4 col-12"},[_vm._v("\n        "+_vm._s(_vm.patientSelectionLabel)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-center mt-4 col-12"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.hcmRecommendationDescription)}})]),_vm._v(" "),(_vm.hcmScdCalculatorResultValidatoin)?_c('div',{staticClass:"col-md-6 col-sm-12 c-hero-card__container mt-4 d-flex justify-content-center align-items-center flex-column"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex h4 text-center"},[_vm._v(_vm._s(_vm.hcmScdRecommendationLabel))]),_vm._v(" "),_c('p',{staticClass:"h5 d-flex justify-content-center custom-recommedation-text",domProps:{"innerHTML":_vm._s(_vm.recommendation)}})]),_vm._v(" "),_c('aha-modal',{ref:"HCMSCD",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"HCMSCD","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"Strip Down"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz align-self-start"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.hcmScdRecommendationDescription)}})])],1)])]}}],null,false,1487279878)})],1)],1)],1):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number d-flex justify-content-center mt-4"},[_vm._v("3 of 3")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-3"},[_c('button',{staticClass:"p-0 my-4 bg-white border-0 custom-start-over",attrs:{"type":"button","step-index":"1"},on:{"click":_vm.handleReload}},[_c('img',{attrs:{"src":"/assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("Start Over")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"kg","title":"kg"}},[_vm._v("kg")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mm","title":"mm"}},[_vm._v("mm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mmHg","title":"mmHg"}},[_vm._v("mmHg")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mm","title":"mm"}},[_vm._v("mm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"loadong","disabled":""}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                            Loading...\n                        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_primacy_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_primacy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_primacy_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_primacy_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_primacy_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f808e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcm_primacy_vue__ = __webpack_require__(494);
function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcm_primacy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f808e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcm_primacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(493);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("40e780a7", content, true, {});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".custom-recommedation-text{font-weight:400!important}.custom-cal-link{width:270px;margin-left:-20px;text-decoration:none;text-align:left}.custom-cal-link:after{font-size:10px;margin-top:-5px}.hcm-scd-card .custom-modal-cal{margin-top:70px}.custom-modal-cal{width:310px!important;border-top:6px solid #ed0a22;background:#fff;-webkit-box-shadow:0 15px 30px 0 rgba(0,0,0,.2);box-shadow:0 15px 30px 0 rgba(0,0,0,.2);padding:48px 18px 36px;z-index:2}.custom-start-over{border:1px solid #ed0a22!important;padding:10px 12px!important;border-radius:50px}.custom-modal-cal p{color:#000!important;font-weight:600;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-orient:vertical!important;-webkit-box-direction:normal!important;-ms-flex-direction:column!important;flex-direction:column!important;text-align:center!important}.is-invalid{border-color:#ed0a22!important}.c-hero-card-snackable__content{left:0!important}.c-aha-form textarea,textarea.form-control{padding:10px;min-height:100px}.lower{margin-top:45px}@include media-breakpoint-up(sm){.lower{margin-top:50px}}a.icon{width:30px;height:30px;background:#ed0a22;border-radius:50%;border:thin solid #ed0a22;color:#fff!important;font-weight:700;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}a.icon:hover{color:#fff}#recommendation,#risk,.toolTip{background-color:#e9ecef;opacity:1;padding:1rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-clip:padding-box;border:1px solid #c4cacf;border-radius:2px;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.validation-modal-style{color:#ed0a22;font-weight:600;font-size:12px}.validation-modal-header{margin-top:-45px;width:500px}", ""]);

// exports


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[(!_vm.isShowModal)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"h3 mt-4"},[_vm._v("You entered age "+_vm._s(_vm.userAgeValue))]),_vm._v(" "),_c('div',{staticClass:"col-12 h-100"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.calculate_sdc_risk.apply(null, arguments)}}},[_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"Height"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.heightLabel)+"\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hgt_cm),expression:"hgt_cm"}],staticClass:"form-control",attrs:{"type":"text","id":"Height","placeholder":"25 to 190","aria-describedby":"Height"},domProps:{"value":(_vm.hgt_cm)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.hgt_cm=$event.target.value},function($event){return _vm.handleUpperInput('height')}],"blur":function($event){return _vm.validationFiled('Height')}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                    "+_vm._s(_vm.heightValidationError))]),_vm._v(" "),(_vm.heightRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("height should be 25cm and\n                                    190cm")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"Weight"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.weightLabel)+"\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wgt_kg),expression:"wgt_kg"}],staticClass:"form-control",attrs:{"type":"text","id":"Weight","placeholder":"1 to 150","aria-describedby":"Weight"},domProps:{"value":(_vm.wgt_kg)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.wgt_kg=$event.target.value},function($event){return _vm.handleUpperInput('weight')}],"blur":function($event){return _vm.validationFiled('weight')}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                    "+_vm._s(_vm.weightValidationError))]),_vm._v(" "),(_vm.weightRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Weight must be between 1 and\n                                    150 kg.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"la_systole_mm"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.laSizeLabel)+"\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.la_systole_mm),expression:"la_systole_mm"}],staticClass:"form-control",attrs:{"type":"text","id":"la_systole_mm","placeholder":"5 to 67","aria-describedby":"Left atrial diameter at end-systole must be between 5 and 55 mm."},domProps:{"value":(_vm.la_systole_mm)},on:{"blur":function($event){return _vm.validationFiled('la_systole_mm')},"input":[function($event){if($event.target.composing){ return; }_vm.la_systole_mm=$event.target.value},function($event){return _vm.handleUpperInput('la_systole_mm')}]}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('la_systole_mm')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                    "+_vm._s(_vm.la_systole_mm_validationError))]),_vm._v(" "),(_vm.la_systole_mmRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.laSizeHelpText))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"peak_grad_mmhg"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.maxLvotGradientLabel)+"\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.peak_grad_mmhg),expression:"peak_grad_mmhg"}],staticClass:"form-control",attrs:{"type":"text","id":"peak_grad_mmhg","placeholder":"0 to 210","aria-describedby":"PeakLVoutflowtractgradient"},domProps:{"value":(_vm.peak_grad_mmhg)},on:{"blur":function($event){return _vm.validationFiled('peak_grad_mmhg')},"input":[function($event){if($event.target.composing){ return; }_vm.peak_grad_mmhg=$event.target.value},function($event){return _vm.handleUpperInput('peak_grad_mmhg')}]}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('peak_grad_mmhg')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                    "+_vm._s(_vm.peak_grad_mmhg_validationError))]),_vm._v(" "),(_vm.peak_grad_mmhgRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.maxLvotGradientHelpText))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"lvpwd_mm"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(" "+_vm._s(_vm.mlvwtLabel)+"\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lvpwd_mm),expression:"lvpwd_mm"}],staticClass:"form-control",attrs:{"type":"text","id":"lvpwd_mm","placeholder":" 0.5 to 60","aria-describedby":" Maximum left ventricular posterior wall diameter (mm):"},domProps:{"value":(_vm.lvpwd_mm)},on:{"blur":function($event){return _vm.validationFiled('lvpwd_mm')},"input":[function($event){if($event.target.composing){ return; }_vm.lvpwd_mm=$event.target.value},function($event){return _vm.handleUpperInput('lvpwd_mm')}]}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('lvpwd_mm')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                    "+_vm._s(_vm.lvpwd_mm_validationError))]),_vm._v(" "),(_vm.lvpwd_mmRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.mlvwtHelpText))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-8 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"ivsd_mm"}},[_c('span',{staticClass:"abbr"},[_c('div',{attrs:{"title":"Total Cholesterol"}},[_vm._v(_vm._s(_vm.isdLabel)+"\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ivsd_mm),expression:"ivsd_mm"}],staticClass:"form-control",attrs:{"type":"text","id":"ivsd_mm","placeholder":"0.5 to 43","aria-describedby":"ivsd_mm"},domProps:{"value":(_vm.ivsd_mm)},on:{"blur":function($event){return _vm.validationFiled('ivsd_mm')},"input":[function($event){if($event.target.composing){ return; }_vm.ivsd_mm=$event.target.value},function($event){return _vm.handleUpperInput('ivsd_mm')}]}}),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower mt-1"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('ivsd_mm')}}},[_vm._v("i")])])]),_vm._v(" "),_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v("\n                                    "+_vm._s(_vm.ivsd_mm_validationError))]),_vm._v(" "),(_vm.ivsd_mmRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.isdHelpText))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(" "+_vm._s(_vm.gsLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Genotype status Not Tested"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation),expression:"genotype_mutation"}],attrs:{"type":"radio","name":"Genotype status Not Tested","id":"NotTested","autocomplete":"off","aria-label":"Genotype status_Not Tested","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.genotype_mutation,"0")},on:{"change":[function($event){_vm.genotype_mutation="0"},function($event){return _vm.handleChange('notTested')}]}}),_vm._v("\n                                    Not Tested\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Genotype status_Tested"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation),expression:"genotype_mutation"}],attrs:{"type":"radio","name":"Genotype status_Tested","id":"Genotystatus_Tested","aria-label":"Genotype status Tested","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.genotype_mutation,"1")},on:{"change":[function($event){_vm.genotype_mutation="1"},_vm.handleChange]}}),_vm._v("\n                                    Tested\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.GenotypestatusRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.gsHelpText))]):_vm._e()])]),_vm._v(" "),(_vm.genoTypePossitive)?_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.gpLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-3 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Genotype possitive_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation_yes),expression:"genotype_mutation_yes"}],attrs:{"type":"radio","name":"Genotype possitive_no","id":"NotTested","autocomplete":"off","aria-label":"Genotype possitive_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.genotype_mutation_yes,"0")},on:{"change":function($event){_vm.genotype_mutation_yes="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Genotype possitive_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.genotype_mutation_yes),expression:"genotype_mutation_yes"}],attrs:{"type":"radio","name":"Genotype possitive_yes","id":"Genotype _possitive_yes","aria-label":"Genotype possitive_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.genotype_mutation_yes,"1")},on:{"change":[function($event){_vm.genotype_mutation_yes="1"},_vm.handleChange]}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('Genotypepositive')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.GenotypepositiveRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.gpHelpText))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.usLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-3 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Unexplained syncope_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.un_sy),expression:"un_sy"}],attrs:{"type":"radio","name":"Unexplained syncope_no","id":"UnexplainedSyncope_no","autocomplete":"off","aria-label":"Unexplained syncope_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.un_sy,"0")},on:{"change":function($event){_vm.un_sy="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Unexplained syncope_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.un_sy),expression:"un_sy"}],attrs:{"type":"radio","name":"Unexplained syncope_yes","id":"Unexplained syncope_yes","aria-label":"Unexplained synco_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.un_sy,"1")},on:{"change":function($event){_vm.un_sy="1"}}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-2 float-left clearfix lower mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('UnexplainedSyncope')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.UnexplainedSyncopeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.usHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.fhscdLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-3 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"fh scd_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fhscd_pick),expression:"fhscd_pick"}],attrs:{"type":"radio","name":"fh scd_no","id":"fhscd_no","autocomplete":"off","aria-label":"fh scd_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.fhscd_pick,"0")},on:{"change":function($event){_vm.fhscd_pick="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"fh scd_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fhscd_pick),expression:"fhscd_pick"}],attrs:{"type":"radio","name":"fh scd_yes","id":"fhscd_yes","aria-label":"fh scd_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.fhscd_pick,"1")},on:{"change":function($event){_vm.fhscd_pick="1"}}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-2 float-left clearfix lower mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('fhscdLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.fhscdIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.fhscdHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.nsvtLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-3 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"nsvt_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nsvt_pick),expression:"nsvt_pick"}],attrs:{"type":"radio","name":"nsvt_no","id":"nsvt_no","autocomplete":"off","aria-label":"nsvt_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.nsvt_pick,"0")},on:{"change":function($event){_vm.nsvt_pick="0"}}}),_vm._v("\n                                    No\n                                ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"nsvt_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nsvt_pick),expression:"nsvt_pick"}],attrs:{"type":"radio","name":"nsvt_yes","id":"nsvt_yes","aria-label":"nsvt_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.nsvt_pick,"1")},on:{"change":function($event){_vm.nsvt_pick="1"}}}),_vm._v("\n                                    Yes\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-2 float-left clearfix lower mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('nsvtLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.nsvtLabelRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.nsvtHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',{domProps:{"innerHTML":_vm._s(_vm.efLabel)}})])]),_vm._v(" "),_c('div',{staticClass:"col-3 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"EF_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ef50_pick),expression:"ef50_pick"}],attrs:{"type":"radio","name":"EF_no","id":"EF_no","autocomplete":"off","aria-label":"EF_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.ef50_pick,"0")},on:{"change":function($event){_vm.ef50_pick="0"}}}),_vm._v("\n                                        No\n                                    ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"EF_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ef50_pick),expression:"ef50_pick"}],attrs:{"type":"radio","name":"EF_yes","id":"EF_yes","aria-label":"EF_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.ef50_pick,"1")},on:{"change":function($event){_vm.ef50_pick="1"}}}),_vm._v("\n                                        Yes\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-2 float-left clearfix lower mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('efLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.efLabelRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.efHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4 mt-3"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.aaLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-3 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"ApicalAneurysm_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apAn_pick),expression:"apAn_pick"}],attrs:{"type":"radio","name":"Apical Aneurysm_no","id":"Apical Aneurysm_no","autocomplete":"off","aria-label":"Apical Aneurysm_no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.apAn_pick,"0")},on:{"change":function($event){_vm.apAn_pick="0"}}}),_vm._v("\n                                        No\n                                    ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Apical Aneurysm_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apAn_pick),expression:"apAn_pick"}],attrs:{"type":"radio","name":"Apical Aneurysm_yes","id":"Apical Aneurysm_yes","aria-label":"Apical Aneurysm_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.apAn_pick,"1")},on:{"change":function($event){_vm.apAn_pick="1"}}}),_vm._v("\n                                        Yes\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-2 float-left clearfix lower mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('aaLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.aaLabelRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.aaHelpText))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row mt-3"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"d-flex justify-align-center"},[_c('label',[_vm._v(_vm._s(_vm.lgeLabel))])])]),_vm._v(" "),_c('div',{staticClass:"col-3 pr-2 mt-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"Extensive_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.elge_pick),expression:"elge_pick"}],attrs:{"type":"radio","name":"Extensive_no","id":"Apical Extensive_no","autocomplete":"off","aria-label":"Extensive _no","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.elge_pick,"0")},on:{"change":function($event){_vm.elge_pick="0"}}}),_vm._v("\n                                        No\n                                    ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"Extensive_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.elge_pick),expression:"elge_pick"}],attrs:{"type":"radio","name":"Extensive_yes","id":"Extensive_yes","aria-label":"Extensive_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.elge_pick,"1")},on:{"change":function($event){_vm.elge_pick="1"}}}),_vm._v("\n                                        Yes\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-2 float-left clearfix lower mt-0"},[_c('a',{key:"lasize-input",staticClass:"ml-4 icon",on:{"click":function($event){return _vm.handleIconValidatoin('lgeLabel')}}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[(_vm.lgeLabelRangeIcon)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.lgeHelpText))]):_vm._e()])]),_vm._v(" "),(_vm.validationModal)?_c('div',{staticClass:"c-hero-card__container col-6"},[_c('aha-modal',{ref:"validationModal",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"validationModal","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('div',{staticClass:"h3 text-left validation-modal-header",domProps:{"innerHTML":_vm._s(_vm.errorModalHeaderText)}}),_vm._v(" "),_c('div',{staticClass:"h4 text-left mt-4"},[_vm._v("PRIMaCY Risk Kids Score")]),_vm._v(" "),_c('div',[(_vm.wgt_kg === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Weight field is missing")]):(_vm.wgt_kg > 150 || _vm.wgt_kg < 1)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" -Weight must be between 1 and 150 kg")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.hgt_cm === '')?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Height field is missing")]):( _vm.hgt_cm > 190 || _vm.hgt_cm < 25)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Height must be between 25 and 190 cm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.la_systole_mm === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA size field is missing")]):( _vm.la_systole_mm > 55 || _vm.la_systole_mm < 5)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" -  LA Size must be between 5 and 55 mm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.peak_grad_mmhg === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient field is missing")]):( _vm.peak_grad_mmhg > 210 || _vm.peak_grad_mmhg < 0)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient must be between 0 and 210 mmHg.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.lvpwd_mm === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" -  MLVWT field is missing")]):( _vm.lvpwd_mm > 60 || _vm.lvpwd_mm < 0.5)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - MLVWT must be between 0.5 and 60 mm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.ivsd_mm === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Interventricular Septal Diameter field is missing")]):( _vm.ivsd_mm > 43|| _vm.ivsd_mm < 0.5)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Interventricular Septal Diameter must be between 0.5 and 43 mm")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"h4 text-left mt-4"},[_vm._v("HCM SCD Score")]),_vm._v(" "),_c('div',[(_vm.la_systole_mm === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - LA size field is missing")]):( _vm.la_systole_mm > 67 || _vm.la_systole_mm < 28)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" -  LA Size must be between 28 and 67 mm.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.peak_grad_mmhg === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient field is missing")]):( _vm.peak_grad_mmhg > 154 || _vm.peak_grad_mmhg < 2)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - Max LVOT Gradient must be between 2 and 154 mmHg.")]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.lvpwd_mm === '' )?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" -  MLVWT field is missing")]):(_vm.lvpwd_mm > 35 || _vm.lvpwd_mm < 10)?_c('div',{staticClass:"ml-3 text-left validation-modal-style"},[_vm._v(" - MLVWT must be between 10 and 35 mm.")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mt-3 h6 text-left",domProps:{"innerHTML":_vm._s(_vm.errorModalFooterText)}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mt-4"},[_c('div',{staticClass:"btn btn-outline-danger",on:{"click":_vm.validationBack}},[_vm._v("Back")]),_vm._v(" "),_c('div',{staticClass:"btn btn-primary",on:{"click":_vm.calculate_sdc_risk}},[_vm._v("See Results")])])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[(_vm.isLoading)?_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_vm._m(6),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})]):_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_c('input',{key:"back",staticClass:"btn btn-primary",attrs:{"type":"button","value":"Back"},on:{"click":_vm.handleBackScreen}}),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('validationModal'),expression:"'validationModal'"}],key:"submit",staticClass:"btn btn-primary",attrs:{"href":"#","type":"submit","value":"Calculate"},on:{"click":_vm.formValidate}},[_vm._v("Submit")]),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between w-100 align-center"},[_c('p',{staticClass:"c-daily-journey__slide-number mt-3 ml-3"},[_vm._v("2 of 3")]),_vm._v(" "),_c('p',{staticClass:"p",domProps:{"innerHTML":_vm._s(_vm.calculatorVersionText)}})])])])])]):_vm._e(),_vm._v(" "),(_vm.isShowModal)?_c('div',[_c('div',{staticClass:"h4"},[_vm._v("Estimated risk of SCD at 5 years (%) for age "+_vm._s(_vm.userAgeValue))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.riskHeaderText)}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-center align-content-center mt-4"},[(_vm.primacyCalculatorResulatValidation)?_c('div',{staticClass:"col-6 w-50 mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex justify-content-center h4 text-center"},[_vm._v("PRIMaCY Risk Score")]),_vm._v(" "),_c('P',{staticClass:"c-hero-card__subheading h1 d-flex justify-content-center font-weight h1"},[_vm._v(_vm._s(_vm.primacyTotalResult))]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('PrimacyRisk'),expression:"'PrimacyRisk'"}],staticClass:"c-cta c-cta--arrow h-theme--red custom-cal-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.primacyRiskScoreLabel))])],1),_vm._v(" "),_c('aha-modal',{ref:"PrimacyRisk",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"PrimacyRisk","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"Strip Down"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz align-self-start"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.primacyRiskScoreDescription)}})])],1)])]}}],null,false,1679916384)})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.hcmScdCalculatorResultValidatoin)?_c('div',{staticClass:"col-6 w-50 mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex justify-content-center text-center h4"},[_vm._v("HCM SCD Score")]),_vm._v(" "),_c('p',{staticClass:"c-hero-card__subheading h1 d-flex justify-content-center font-weight flex-column",domProps:{"innerHTML":_vm._s(_vm.risk.value + '%')}}),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('HCMSCD5'),expression:"'HCMSCD5'"}],staticClass:"c-cta c-cta--arrow h-theme--red custom-cal-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.hcmScdScoreLabel))])]),_vm._v(" "),_c('aha-modal',{ref:"HCMSCD5",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"HCMSCD5","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"Strip Down"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz align-self-start"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.hcmScdScoreDescription)}})])],1)])]}}],null,false,2347706727)})],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"h5 mt-4 mb-4 ml-3",domProps:{"innerHTML":_vm._s(_vm.resultGuidelineText)}}),_vm._v(" "),(_vm.primacyCalculatorResulatValidation)?_c('div',{staticClass:"col-6 w-50 mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex h4 justify-content-center text-center"},[_vm._v("PRIMaCY Risk Recommendation")]),_vm._v(" "),_c('P',{staticClass:"c-hero-card__subheading h5 d-flex justify-content-center font-weight text-center custom-recommedation-text"},[_vm._v("No formal recommendation for PRIMaCY")])],1)]):_vm._e(),_vm._v(" "),(_vm.hcmScdCalculatorResultValidatoin)?_c('div',{staticClass:"col-6 w-50 mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4"},[_c('div',{staticClass:"custom-modal-cal"},[_c('p',{staticClass:"c-hero-card__heading d-flex text-center h4"},[_vm._v(_vm._s(_vm.hcmScdRecommendationLabel))]),_vm._v(" "),_c('p',{staticClass:"h5 d-flex justify-content-center custom-recommedation-text",domProps:{"innerHTML":_vm._s(_vm.recommendation)}})]),_vm._v(" "),_c('aha-modal',{ref:"HCMSCD",staticClass:"c-modal--generic",attrs:{"interval":0,"id":"HCMSCD","title":"Modal Header","hide-footer":"","centered":"","scrollable":""}},[_c('aha-transition-group',{staticClass:"c-hero-card-snackable-full-quiz"},[_c('aha-transition-group-form',{attrs:{"error-step-key":7,"url":"/aha-service/grfw/Quiz","name":"Strip Down"},scopedSlots:_vm._u([{key:"default",fn:function(formCtrl){return [_c('div',{staticClass:"c-hero-card-snackable-full-quiz align-self-start"},[_c('div',{attrs:{"aria-live":"polite"}},[_c('aha-transition-step',{staticClass:"c-hero-card-snackable__transition",attrs:{"step-key":1}},[_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.hcmScdScoreDescription)}})])],1)])]}}],null,false,2347706727)})],1)],1)],1):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-4 d-flex justify-content-center"},[_vm._v("3 of 3")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-3"},[_c('button',{staticClass:"p-0 my-4 bg-white border-0 custom-start-over",attrs:{"type":"button","step-index":"1"},on:{"click":_vm.handleReload}},[_c('img',{attrs:{"src":"/assets/glyphs/retake-quiz-Icon.svg"}}),_vm._v(" "),_c('span',{staticClass:"text-primary"},[_vm._v("Start Over")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"cm","title":"cm"}},[_vm._v("cm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"kg","title":"kg"}},[_vm._v("kg")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mm","title":"mm"}},[_vm._v("mm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mmHg","title":"mmHg"}},[_vm._v("mmHg")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mm","title":"mm"}},[_vm._v("mm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-left clearfix lower ml-4 mt-2"},[_c('p',{staticClass:"float-left"}),_c('div',{attrs:{"id":"mm","title":"mm"}},[_vm._v("mm")]),_vm._v(" "),_c('p')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"loadong","disabled":""}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("\n                                Loading...\n                            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 h-100"},[(_vm.hideFirstScreen)?_c('div',[_c('div',{staticClass:"c-hero-card-snackable"},[_c('div',{staticClass:"c-hero-card-snackable__container"},[_c('div',{staticClass:"c-hero-card-snackable__content"},[_c('div',{staticClass:"c-single-field-prompt"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.ageSectionText)}}),_vm._v(" "),_c('div',{staticClass:"form-group row mt-5"},[_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"EnterYourAge"}},[_vm._v(_vm._s(_vm.ageLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userAgeValue),expression:"userAgeValue"}],staticClass:"form-control form-control-lg mt-2",class:{
                                                    'is-invalid':
                                                        _vm.ageValidation,
                                                },attrs:{"type":"text","id":"EnterYourAge","placeholder":"0 to 80","aria-describedby":"ageyears"},domProps:{"value":(_vm.userAgeValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.userAgeValue=$event.target.value},function($event){return _vm.handleUpperInput('year')}],"blur":_vm.handleValidation}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback custom-invalid-feedback",attrs:{"aria-live":"polite"}},[_vm._v("\n                                                \n                                                    "+_vm._s(_vm.ageValidationError)+"\n                                                \n                                            ")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-round btn-lg btn-danger w-50 cal-btn",attrs:{"type":"submit"},on:{"click":_vm.redirectNxtScreen}},[_vm._v("\n                                        Submit\n                                    ")]),_vm._v(" "),_c('p',{staticClass:"c-daily-journey__slide-number mt-3"},[_vm._v("\n                                        1 of 3\n                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"c-hero-card-snackable__media h-placeholder-image"},[_c('img',{directives:[{name:"lazy-img",rawName:"v-lazy-img",value:(
                                        '//placeimg.com/1200/600/any'),expression:"\n                                        '//placeimg.com/1200/600/any'"}],attrs:{"src":"assets/images/placeholder.gif","alt":""}})])])])]):_vm._e(),_vm._v(" "),(_vm.firstStep)?_c('div',[_c('RiskKidsPrimacy',{attrs:{"handleFirstScreen":_vm.handleFirstScreen,"userAgeValue":_vm.userAgeValue,"heightErrorMessage":_vm.heightErrorMessage,"weightErrorMessage":_vm.weightErrorMessage,"maxLvotGradientErrorMessage":_vm.maxLvotGradientErrorMessage,"sexLabel":_vm.sexLabel,"heightLabel":_vm.heightLabel,"weightLabel":_vm.weightLabel,"laSizeLabel":_vm.laSizeLabel,"maxLvotGradientLabel":_vm.maxLvotGradientLabel,"mlvwtLabel":_vm.mlvwtLabel,"isdLabel":_vm.isdLabel,"gpLabel":_vm.gpLabel,"usLabel":_vm.usLabel,"nsvtLabel":_vm.nsvtLabel,"gsLabel":_vm.gsLabel,"efLabel":_vm.efLabel,"fhscdLabel":_vm.fhscdLabel,"aaLabel":_vm.aaLabel,"lgeLabel":_vm.lgeLabel,"laSizeHelpText":_vm.laSizeHelpText,"maxLvotGradientHelpText":_vm.maxLvotGradientHelpText,"mlvwtHelpText":_vm.mlvwtHelpText,"isdHelpText":_vm.isdHelpText,"gpHelpText":_vm.gpHelpText,"usHelpText":_vm.usHelpText,"nsvtHelpText":_vm.nsvtHelpText,"gsHelpText":_vm.gsHelpText,"efHelpText":_vm.efHelpText,"fhscdHelpText":_vm.fhscdHelpText,"aaHelpText":_vm.aaHelpText,"lgeHelpText":_vm.lgeHelpText,"isdErrorMessage":_vm.isdErrorMessage,"mlvwtErrorMessage":_vm.mlvwtErrorMessage,"laSizeErrorMessage":_vm.laSizeErrorMessage,"hcmScdRecommendationLabel":_vm.hcmScdRecommendationLabel,"hcmScdRecommendationDescription":_vm.hcmScdRecommendationDescription,"hcmScdScoreLabel":_vm.hcmScdScoreLabel,"hcmScdScoreDescription":_vm.hcmScdScoreDescription,"hcmRiskKidsScoreLabel":_vm.hcmRiskKidsScoreLabel,"hcmRiskKidsScoreDescription":_vm.hcmRiskKidsScoreDescription,"primacyRiskScoreLabel":_vm.primacyRiskScoreLabel,"primacyRiskScoreDescription":_vm.primacyRiskScoreDescription,"lvmwtZScoreLabel":_vm.lvmwtZScoreLabel,"lvmwtZScoreDescription":_vm.lvmwtZScoreDescription,"laDiameterZScoreLabel":_vm.laDiameterZScoreLabel,"laDiameterZScoreDescription":_vm.laDiameterZScoreDescription,"prognosticIndexLabel":_vm.prognosticIndexLabel,"prognosticIndexDescription":_vm.prognosticIndexDescription,"errorModalHeaderText":_vm.errorModalHeaderText,"errorModalFooterText":_vm.errorModalFooterText,"calculatorVersionText":_vm.calculatorVersionText,"resultGuidelineText":_vm.resultGuidelineText,"riskHeaderText":_vm.riskHeaderText,"posteriorLvLabel":_vm.posteriorLvLabel,"posteriorLvErrorMessage":_vm.posteriorLvErrorMessage,"hcmRecommendationDescription":_vm.hcmRecommendationDescription,"patientSelectionLabel":_vm.patientSelectionLabel,"resultGuidelineTextSixteen":_vm.resultGuidelineTextSixteen,"resultGuidelineTextAdult":_vm.resultGuidelineTextAdult}})],1):_vm._e(),_vm._v(" "),(_vm.secondStep)?_c('div',[_c('RiskHCMPrimacy',{attrs:{"userAgeValue":_vm.userAgeValue,"heightErrorMessage":_vm.heightErrorMessage,"weightErrorMessage":_vm.weightErrorMessage,"maxLvotGradientErrorMessage":_vm.maxLvotGradientErrorMessage,"sexLabel":_vm.sexLabel,"heightLabel":_vm.heightLabel,"weightLabel":_vm.weightLabel,"laSizeLabel":_vm.laSizeLabel,"maxLvotGradientLabel":_vm.maxLvotGradientLabel,"mlvwtLabel":_vm.mlvwtLabel,"isdLabel":_vm.isdLabel,"gpLabel":_vm.gpLabel,"usLabel":_vm.usLabel,"nsvtLabel":_vm.nsvtLabel,"gsLabel":_vm.gsLabel,"efLabel":_vm.efLabel,"fhscdLabel":_vm.fhscdLabel,"aaLabel":_vm.aaLabel,"lgeLabel":_vm.lgeLabel,"laSizeHelpText":_vm.laSizeHelpText,"maxLvotGradientHelpText":_vm.maxLvotGradientHelpText,"mlvwtHelpText":_vm.mlvwtHelpText,"isdHelpText":_vm.isdHelpText,"gpHelpText":_vm.gpHelpText,"usHelpText":_vm.usHelpText,"nsvtHelpText":_vm.nsvtHelpText,"gsHelpText":_vm.gsHelpText,"efHelpText":_vm.efHelpText,"fhscdHelpText":_vm.fhscdHelpText,"aaHelpText":_vm.aaHelpText,"lgeHelpText":_vm.lgeHelpText,"handleSecondScree":_vm.handleSecondScree,"isdErrorMessage":_vm.isdErrorMessage,"mlvwtErrorMessage":_vm.mlvwtErrorMessage,"laSizeErrorMessage":_vm.laSizeErrorMessage,"hcmScdRecommendationLabel":_vm.hcmScdRecommendationLabel,"hcmScdRecommendationDescription":_vm.hcmScdRecommendationDescription,"hcmScdScoreLabel":_vm.hcmScdScoreLabel,"hcmScdScoreDescription":_vm.hcmScdScoreDescription,"hcmRiskKidsScoreLabel":_vm.hcmRiskKidsScoreLabel,"hcmRiskKidsScoreDescription":_vm.hcmRiskKidsScoreDescription,"primacyRiskScoreLabel":_vm.primacyRiskScoreLabel,"primacyRiskScoreDescription":_vm.primacyRiskScoreDescription,"lvmwtZScoreLabel":_vm.lvmwtZScoreLabel,"lvmwtZScoreDescription":_vm.lvmwtZScoreDescription,"laDiameterZScoreLabel":_vm.laDiameterZScoreLabel,"laDiameterZScoreDescription":_vm.laDiameterZScoreDescription,"prognosticIndexLabel":_vm.prognosticIndexLabel,"prognosticIndexDescription":_vm.prognosticIndexDescription,"errorModalHeaderText":_vm.errorModalHeaderText,"errorModalFooterText":_vm.errorModalFooterText,"calculatorVersionText":_vm.calculatorVersionText,"resultGuidelineText":_vm.resultGuidelineText,"riskHeaderText":_vm.riskHeaderText,"hcmRecommendationDescription":_vm.hcmRecommendationDescription,"patientSelectionLabel":_vm.patientSelectionLabel,"resultGuidelineTextSixteen":_vm.resultGuidelineTextSixteen,"resultGuidelineTextAdult":_vm.resultGuidelineTextAdult}})],1):_vm._e(),_vm._v(" "),(_vm.thirdStep)?_c('div',[_c('HcmScdCalculator',{attrs:{"userAgeValue":_vm.userAgeValue,"heightErrorMessage":_vm.heightErrorMessage,"weightErrorMessage":_vm.weightErrorMessage,"maxLvotGradientErrorMessage":_vm.maxLvotGradientErrorMessage,"sexLabel":_vm.sexLabel,"heightLabel":_vm.heightLabel,"weightLabel":_vm.weightLabel,"laSizeLabel":_vm.laSizeLabel,"maxLvotGradientLabel":_vm.maxLvotGradientLabel,"mlvwtLabel":_vm.mlvwtLabel,"isdLabel":_vm.isdLabel,"gpLabel":_vm.gpLabel,"usLabel":_vm.usLabel,"nsvtLabel":_vm.nsvtLabel,"gsLabel":_vm.gsLabel,"efLabel":_vm.efLabel,"fhscdLabel":_vm.fhscdLabel,"aaLabel":_vm.aaLabel,"lgeLabel":_vm.lgeLabel,"laSizeHelpText":_vm.laSizeHelpText,"maxLvotGradientHelpText":_vm.maxLvotGradientHelpText,"mlvwtHelpText":_vm.mlvwtHelpText,"isdHelpText":_vm.isdHelpText,"gpHelpText":_vm.gpHelpText,"usHelpText":_vm.usHelpText,"nsvtHelpText":_vm.nsvtHelpText,"gsHelpText":_vm.gsHelpText,"efHelpText":_vm.efHelpText,"fhscdHelpText":_vm.fhscdHelpText,"aaHelpText":_vm.aaHelpText,"lgeHelpText":_vm.lgeHelpText,"handleThirdScreen":_vm.handleThirdScreen,"isdErrorMessage":_vm.isdErrorMessage,"mlvwtErrorMessage":_vm.mlvwtErrorMessage,"laSizeErrorMessage":_vm.laSizeErrorMessage,"hcmScdRecommendationLabel":_vm.hcmScdRecommendationLabel,"hcmScdRecommendationDescription":_vm.hcmScdRecommendationDescription,"hcmScdScoreLabel":_vm.hcmScdScoreLabel,"hcmScdScoreDescription":_vm.hcmScdScoreDescription,"hcmRiskKidsScoreLabel":_vm.hcmRiskKidsScoreLabel,"hcmRiskKidsScoreDescription":_vm.hcmRiskKidsScoreDescription,"primacyRiskScoreLabel":_vm.primacyRiskScoreLabel,"primacyRiskScoreDescription":_vm.primacyRiskScoreDescription,"lvmwtZScoreLabel":_vm.lvmwtZScoreLabel,"lvmwtZScoreDescription":_vm.lvmwtZScoreDescription,"laDiameterZScoreLabel":_vm.laDiameterZScoreLabel,"laDiameterZScoreDescription":_vm.laDiameterZScoreDescription,"prognosticIndexLabel":_vm.prognosticIndexLabel,"prognosticIndexDescription":_vm.prognosticIndexDescription,"errorModalHeaderText":_vm.errorModalHeaderText,"errorModalFooterText":_vm.errorModalFooterText,"calculatorVersionText":_vm.calculatorVersionText,"resultGuidelineText":_vm.resultGuidelineText,"riskHeaderText":_vm.riskHeaderText,"hcmRecommendationDescription":_vm.hcmRecommendationDescription,"patientSelectionLabel":_vm.patientSelectionLabel,"resultGuidelineTextSixteen":_vm.resultGuidelineTextSixteen,"resultGuidelineTextAdult":_vm.resultGuidelineTextAdult}})],1):_vm._e(),_vm._v(" "),(_vm.fourthStep)?_c('div',[_c('HcmScdCalculator',{attrs:{"userAgeValue":_vm.userAgeValue,"heightErrorMessage":_vm.heightErrorMessage,"weightErrorMessage":_vm.weightErrorMessage,"maxLvotGradientErrorMessage":_vm.maxLvotGradientErrorMessage,"sexLabel":_vm.sexLabel,"heightLabel":_vm.heightLabel,"weightLabel":_vm.weightLabel,"laSizeLabel":_vm.laSizeLabel,"maxLvotGradientLabel":_vm.maxLvotGradientLabel,"mlvwtLabel":_vm.mlvwtLabel,"isdLabel":_vm.isdLabel,"gpLabel":_vm.gpLabel,"usLabel":_vm.usLabel,"nsvtLabel":_vm.nsvtLabel,"gsLabel":_vm.gsLabel,"efLabel":_vm.efLabel,"fhscdLabel":_vm.fhscdLabel,"aaLabel":_vm.aaLabel,"lgeLabel":_vm.lgeLabel,"laSizeHelpText":_vm.laSizeHelpText,"maxLvotGradientHelpText":_vm.maxLvotGradientHelpText,"mlvwtHelpText":_vm.mlvwtHelpText,"isdHelpText":_vm.isdHelpText,"gpHelpText":_vm.gpHelpText,"usHelpText":_vm.usHelpText,"nsvtHelpText":_vm.nsvtHelpText,"gsHelpText":_vm.gsHelpText,"efHelpText":_vm.efHelpText,"fhscdHelpText":_vm.fhscdHelpText,"aaHelpText":_vm.aaHelpText,"lgeHelpText":_vm.lgeHelpText,"handleFourthScreen":_vm.handleFourthScreen,"isdErrorMessage":_vm.isdErrorMessage,"mlvwtErrorMessage":_vm.mlvwtErrorMessage,"laSizeErrorMessage":_vm.laSizeErrorMessage,"hcmScdRecommendationLabel":_vm.hcmScdRecommendationLabel,"hcmScdRecommendationDescription":_vm.hcmScdRecommendationDescription,"hcmScdScoreLabel":_vm.hcmScdScoreLabel,"hcmScdScoreDescription":_vm.hcmScdScoreDescription,"calculatorVersionText":_vm.calculatorVersionText,"resultGuidelineText":_vm.resultGuidelineText,"riskHeaderText":_vm.riskHeaderText,"errorModalHeaderText":_vm.errorModalHeaderText,"errorModalFooterText":_vm.errorModalFooterText,"hcmRecommendationDescription":_vm.hcmRecommendationDescription,"patientSelectionLabel":_vm.patientSelectionLabel,"resultGuidelineTextSixteen":_vm.resultGuidelineTextSixteen,"resultGuidelineTextAdult":_vm.resultGuidelineTextAdult}})],1):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_video_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_video_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_video_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_video_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_video_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b01ef76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_save_video_vue__ = __webpack_require__(497);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_video_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b01ef76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_save_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.toggleSaveBtn)?_c('div',{staticClass:"d-flex align-items-center save-video-header p-2",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.handleSaveVideo('saveVideo')},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSaveVideo('saveVideo')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.handleSaveVideo('saveVideo')}]}},[_c('img',{attrs:{"src":__webpack_require__(498),"alt":"save video","width":"30"}}),_vm._v(" "),_c('div',{staticClass:"ml-3 h4 mt-2"},[_vm._v("\n            "+_vm._s(_vm.saveButtonText)+"\n        ")])]):_c('div',{staticClass:"d-flex align-items-center saved-video-header p-2",attrs:{"tabindex":"0"}},[_c('img',{attrs:{"src":__webpack_require__(499),"alt":"saved video","width":"30","height":"30"}}),_vm._v(" "),_c('div',{staticClass:"h4 ml-3 mt-2"},[_vm._v("\n            "+_vm._s(_vm.savedButtonText)+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iU3ZnanNTdmcxMDA2IiB3aWR0aD0iMjg4IiBoZWlnaHQ9IjI4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWxuczpzdmdqcz0iaHR0cDovL3N2Z2pzLmNvbS9zdmdqcyI+PGRlZnMgaWQ9IlN2Z2pzRGVmczEwMDciPjwvZGVmcz48ZyBpZD0iU3ZnanNHMTAwOCI+PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ny41IDQ3LjUiIHdpZHRoPSIyODgiIGhlaWdodD0iMjg4Ij48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGQ9Ik0wIDM4aDM4VjBIMHYzOFoiPjwvcGF0aD48L2NsaXBQYXRoPjwvZGVmcz48ZyBjbGlwLXBhdGg9InVybCgjYSkiIHRyYW5zZm9ybT0ibWF0cml4KDEuMjUgMCAwIC0xLjI1IDAgNDcuNSkiPjxwYXRoIGZpbGw9IiNkZDJlNDQiIGQ9Ik0zLjA2NyAyNS42OGMwIDguNzk5IDEyLjE4NCAxMi4wNiAxNS45MzMgMS44NzQgMy43NDkgMTAuMTg2IDE1LjkzMyA2LjkyNSAxNS45MzMtMS44NzRDMzQuOTMzIDE2LjEyIDE5IDMuOTk5IDE5IDMuOTk5UzMuMDY3IDE2LjEyIDMuMDY3IDI1LjY4IiBjbGFzcz0iY29sb3JkZDJlNDQgc3ZnU2hhcGUiPjwvcGF0aD48L2c+PC9zdmc+PC9nPjwvc3ZnPg=="

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_saved_videos_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_saved_videos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_saved_videos_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_saved_videos_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_saved_videos_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f32d9ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_saved_videos_vue__ = __webpack_require__(501);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_saved_videos_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f32d9ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_saved_videos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex flex-wrap justify-content-between align-items-center w-100"},[_c('div',{staticClass:"d-flex align-items-center justify-content-start"},[_c('div',{staticClass:"h4"},[_vm._v(_vm._s(_vm.componentTitle))]),_vm._v(" "),_c('div',{staticClass:"ml-3 d-flex align-items-center justify-content-center',"},[(_vm.editSection)?_c('button',{staticClass:"p-2 d-flex align-items-center saved-video-edit-remove-btn btn btn-primary",attrs:{"tabindex":"0"},on:{"click":_vm.toggleEditSection,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleEditSection.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.toggleEditSection.apply(null, arguments)}]}},[_vm._v("\n                    "+_vm._s(_vm.editLabel)+"\n                    "),_c('img',{staticClass:"ml-3",attrs:{"src":__webpack_require__(502),"alt":""}})]):_c('div',{staticClass:"d-flex align-items-center"},[_c('button',{staticClass:"saved-video-edit-remove-btn btn btn-primary text-white d-flex p-2",attrs:{"tabindex":"0"},on:{"click":_vm.handleRemoveVideos,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleRemoveVideos.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.handleRemoveVideos.apply(null, arguments)}]}},[_c('img',{staticClass:"mr-2",attrs:{"src":__webpack_require__(503),"alt":""}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.removeLabel))])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"saved-video-edit-remove-btn btn btn-primary ml-4",attrs:{"type":"button"},on:{"click":_vm.handelCancel,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handelCancel.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.handelCancel.apply(null, arguments)}]}},[_vm._v("\n                            Cancel\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-start"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v(_vm._s(_vm.filterLabel))]),_vm._v(" "),_c('p',{staticClass:"font-weight-bold"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"p-2 border border-text-muted",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"All","name":"All"}},[_vm._v(_vm._s(_vm.filterAllContent))]),_vm._v(" "),_vm._l((_vm.parsedDropdownValues),function(option,index){return _c('option',{key:index,attrs:{"name":option},domProps:{"value":option}},[_vm._v("\n                        "+_vm._s(option)+"\n                    ")])})],2)])])]),_vm._v(" "),(_vm.editSection)?_c('div',{staticClass:"row"},_vm._l((_vm.filteredVideos),function(video){return _c('div',{key:video.VideoId,staticClass:"col-12 col-md-6 col-lg-3 p-4",on:{"click":function($event){return _vm.openModal(video)}}},[_c('div',{staticClass:"c-article-card c-article-card--small c-article-card--video"},[_c('button',{staticClass:"c-article-card__background",attrs:{"type":"button","id":video.VideoItemId,"teaseritemid":video.VideoCategoryId,"videoid":video.VideoId,"videotitle":"What should a patient know before genome sequencing?","videotypelink":video.VideoId,"videofullcontentlink":"/en/videos/interpreting-incidentally-identified-variants-in-genes-associated-with-heritable-cardiac-disease","videoteaser":"Svati Shah, MD, MHS, Andrew Landstrom, MD, PhD, and Anwar Chahal, MD, PhD, FACC, MRCP, FESC discuss the importance of understanding incidental variants in genomic sequencing and what research participants and patients should know about exome or genome sequencing, the significance of informed consent, and how to engage in meaningful conversations with healthcare providers to ensure empowered decision-making.","videocategoryid":""},on:{"click":function($event){return _vm.openModal(video)}}},[_c('span',{staticClass:"h-placeholder-image h-placeholder-image--3-2"},[_c('img',{staticClass:"is-loaded",attrs:{"src":video.Thumbnail}})]),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"c-article-card__content"},[_c('h3',{staticClass:"c-article-card__title h6"},[_vm._v("\n                        "+_vm._s(video.Title)+"\n                    ")])])])])}),0):_c('div',[_c('div',{staticClass:"container"},_vm._l((_vm.filteredVideos),function(video){return _c('div',{key:video.VideoId,staticClass:"row justify-content-start align-items-center text-center w-100"},[_c('div',{staticClass:"col-12 col-md-1 d-flex flex-column align-items-center"},[_c('input',{staticClass:"saved-video-checkbox-large mb-2",staticStyle:{"cursor":"pointer","position":"relative"},attrs:{"width":"24px","height":"24px","type":"checkbox"},on:{"click":function($event){return _vm.handleSelectedVideos(
                                video.VideoItemId,
                                video.VideoCategoryId
                            )}}}),_vm._v(" "),_c('span',{staticClass:"text-dark font-weight-bold"},[_vm._v(_vm._s(_vm.selectLabel))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 p-4"},[_c('div',{staticClass:"c-article-card c-article-card--small c-article-card--video"},[_c('button',{staticClass:"c-article-card__background",attrs:{"type":"button","id":video.VideoItemId,"teaseritemid":video.VideoCategoryId,"videoid":video.VideoId,"videotitle":"What should a patient know before genome sequencing?","videotypelink":video.VideoId,"videofullcontentlink":"/en/videos/interpreting-incidentally-identified-variants-in-genes-associated-with-heritable-cardiac-disease","videoteaser":"Svati Shah, MD, MHS, Andrew Landstrom, MD, PhD, and Anwar Chahal, MD, PhD, FACC, MRCP, FESC discuss the importance of understanding incidental variants in genomic sequencing and what research participants and patients should know about exome or genome sequencing, the significance of informed consent, and how to engage in meaningful conversations with healthcare providers to ensure empowered decision-making.","videocategoryid":""},on:{"click":function($event){return _vm.openModal(video)}}},[_c('span',{staticClass:"h-placeholder-image h-placeholder-image--3-2"},[_c('img',{staticClass:"is-loaded",attrs:{"src":video.Thumbnail}})]),_vm._v(" "),_vm._m(1,true)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-7"},[_c('p',{staticClass:"text-left font-weight-bold mt-2 text-dark"},[_vm._v("\n                        "+_vm._s(video.Title)+"\n                    ")])])])}),0)]),_vm._v(" "),(_vm.filteredVideos.length === 0)?_c('div',{staticClass:"text-center text-muted mt-4"},[_c('div',{staticClass:"h3 d-flex justify-content-center align-center"},[_vm._v("\n            No videos found\n        ")])]):_vm._e(),_vm._v(" "),_c('aha-modal',{ref:"loadingModal",staticClass:"c-modal--aha",attrs:{"id":"save-video-modal","title":"Modal Header","size":"md","hide-footer":"","centered":""},on:{"@hide":_vm.handleAhaModalClose},model:{value:(_vm.isModalOpen),callback:function ($$v) {_vm.isModalOpen=$$v},expression:"isModalOpen"}},[_c('div',{staticClass:"loader-container",attrs:{"role":"alert","aria-live":"assertive"}},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])]),_vm._v(" "),(_vm.selectedVideoUrl)?_c('div',[_c('b-embed',{attrs:{"id":"communityEmbedVideo","type":"iframe","allow":"autoplay","aspect":"16by9","src":_vm.selectedVideoUrl,"allowfullscreen":""}}),_vm._v(" "),_c('div',{staticClass:"row align-items-center w-100 ml-0"},[_c('div',{staticClass:"col-lg-12 c-promotion__title__wrapper w-100 px-0"},[_c('div',{staticClass:"c-promotion__title w-100 text-center mb-3 saved-video-modal-title",style:({ fontSize: '18px' }),attrs:{"id":"modalTitle"}},[_vm._v("\n                        "+_vm._s(_vm.selectedVideoTitle)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"mx-auto d-flex justify-content-center",attrs:{"id":"modalTeaser"}},[_vm._v("\n                "+_vm._s(_vm.selectedVideoTeaser)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"mx-auto mt-3 c-promotion__modal-buttons d-flex justify-content-center"},[_c('a',{staticClass:"mb-lg-0 mb-3 mr-lg-5 mr-0 btn btn-lg btn-round btn-danger",attrs:{"id":"aFullContentLink","target":"_blank","href":_vm.videofullcontentlink}},[_vm._v("\n                    See Full Content\n                ")])])],1):_c('p',{staticClass:"text-center text-muted"},[_vm._v("No video selected")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-article-card__video-overlay"},[_c('span',{staticClass:"c-article-card__play"},[_c('img',{attrs:{"src":"/assets/glyphs/play.svg","alt":"play"}}),_vm._v("Watch Video")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-article-card__video-overlay"},[_c('span',{staticClass:"c-article-card__play"},[_c('img',{attrs:{"src":"/assets/glyphs/play.svg","alt":"play"}}),_vm._v("Watch Video")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktcGVuY2lsIiB2aWV3Qm94PSIwIDAgMTYgMTYiPg0KICA8cGF0aCBkPSJNMTIuMTQ2LjE0NmEuNS41IDAgMCAxIC43MDggMGwzIDNhLjUuNSAwIDAgMSAwIC43MDhsLTEwIDEwYS41LjUgMCAwIDEtLjE2OC4xMWwtNSAyYS41LjUgMCAwIDEtLjY1LS42NWwyLTVhLjUuNSAwIDAgMSAuMTEtLjE2OHpNMTEuMjA3IDIuNSAxMy41IDQuNzkzIDE0Ljc5MyAzLjUgMTIuNSAxLjIwN3ptMS41ODYgM0wxMC41IDMuMjA3IDQgOS43MDdWMTBoLjVhLjUuNSAwIDAgMSAuNS41di41aC41YS41LjUgMCAwIDEgLjUuNXYuNWguMjkzem0tOS43NjEgNS4xNzUtLjEwNi4xMDYtMS41MjggMy44MjEgMy44MjEtMS41MjguMTA2LS4xMDZBLjUuNSAwIDAgMSA1IDEyLjVWMTJoLS41YS41LjUgMCAwIDEtLjUtLjVWMTFoLS41YS41LjUgMCAwIDEtLjQ2OC0uMzI1Ii8+DQo8L3N2Zz4="

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktdHJhc2giIHZpZXdCb3g9IjAgMCAxNiAxNiI+DQogIDxwYXRoIGQ9Ik01LjUgNS41QS41LjUgMCAwIDEgNiA2djZhLjUuNSAwIDAgMS0xIDBWNmEuNS41IDAgMCAxIC41LS41bTIuNSAwYS41LjUgMCAwIDEgLjUuNXY2YS41LjUgMCAwIDEtMSAwVjZhLjUuNSAwIDAgMSAuNS0uNW0zIC41YS41LjUgMCAwIDAtMSAwdjZhLjUuNSAwIDAgMCAxIDB6Ii8+DQogIDxwYXRoIGQ9Ik0xNC41IDNhMSAxIDAgMCAxLTEgMUgxM3Y5YTIgMiAwIDAgMS0yIDJINWEyIDIgMCAwIDEtMi0yVjRoLS41YTEgMSAwIDAgMS0xLTFWMmExIDEgMCAwIDEgMS0xSDZhMSAxIDAgMCAxIDEtMWgyYTEgMSAwIDAgMSAxIDFoMy41YTEgMSAwIDAgMSAxIDF6TTQuMTE4IDQgNCA0LjA1OVYxM2ExIDEgMCAwIDAgMSAxaDZhMSAxIDAgMCAwIDEtMVY0LjA1OUwxMS44ODIgNHpNMi41IDNoMTFWMmgtMTF6Ii8+DQo8L3N2Zz4="

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_teaser_video_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_teaser_video_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_teaser_video_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_teaser_video_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_teaser_video_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c564b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_save_teaser_video_vue__ = __webpack_require__(505);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_save_teaser_video_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c564b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_save_teaser_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-round w-100 cta-hero__cta ml-2 mr-2",attrs:{"disabled":_vm.toggleSaveBtn},on:{"click":_vm.handleSaveVideo}},[_vm._v("\n        "+_vm._s(_vm.toggleSaveBtn ? _vm.savedButtonText : _vm.buttonText)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_reset_personalization_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_reset_personalization_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_reset_personalization_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_reset_personalization_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_reset_personalization_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1c194fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_reset_personalization_vue__ = __webpack_require__(507);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aha_reset_personalization_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1c194fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aha_reset_personalization_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Test content")]),_vm._v(" "),_c('div',{staticClass:"h3",domProps:{"innerHTML":_vm._s(_vm.resetContentText)}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-items-center w-100"},[_c('button',{staticClass:"btn btn-round btn-primary mx-auto mb-2 mt-2",domProps:{"innerHTML":_vm._s(_vm.resetContentButtonText)},on:{"click":_vm.handleAPICall}})]),_vm._v(" "),(_vm.successMsg)?_c('div',{staticClass:"alert alert-success mt-3",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.resetContentSuccessMessage)}}):_vm._e(),_vm._v(" "),(_vm.errorMesg)?_c('div',{staticClass:"alert alert-danger mt-3",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.resetContentErrorMessage)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(509);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4b344cd6", content, true, {});

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".selected-button{background-color:#e9ecef!important;color:#222328!important;border-color:#dee2e6!important}.btn-group .btn{margin-right:5px}.page-link{color:#000!important}.date-error-msg{margin-left:10px}.title-text{color:#c10e21;text-decoration:underline;margin-bottom:10px!important}.custom-clear-filter-btn{background-color:transparent!important;color:#c10e21!important;border:1px solid #c10e21!important}.item-title:hover{color:#c10e21;text-decoration:underline}.funding-opportunities .page-item.active .page-link{background-color:#dee2e6!important}", ""]);

// exports


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto container"},[_c('div',{staticClass:"row mt-4 ml-4"},[_c('div',{staticClass:"form-group col-lg-3"},[_c('label',{staticClass:"h5",attrs:{"for":"Search"}},[_vm._v(_vm._s(_vm.labelUpdated.searchTextLabel))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"id":"Search","value":"","name":"Search","type":"text","placeholder":_vm.labelUpdated.searchPlaceholderText},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-lg-3"},[_c('label',{staticClass:"h5",attrs:{"for":"Sort"}},[_vm._v(_vm._s(_vm.labelUpdated.dropdownLabel))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"custom-select btn--select form-control",attrs:{"id":"Sort","name":"Sort","aria-required":"true","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.parsedDropdownValues),function(option){return _c('option',{key:option.Value,domProps:{"value":option.Value}},[_vm._v("\n                    "+_vm._s(option.Text)+"\n                ")])})],2),_vm._v(" "),_c('p',{staticClass:"invalid-feedback",attrs:{"role":"alert"}},[_vm._v("\n                Course Selection Required\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-lg-3"},[_c('label',{staticClass:"h5",attrs:{"for":"Sort"}},[_vm._v(_vm._s(_vm.labelUpdated.fromDateLabel))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-lg-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDate),expression:"formDate"}],staticClass:"form-control",attrs:{"required":"","type":"text","placeholder":_vm.labelUpdated.fromDateLabel,"onfocus":"(this.type='date')"},domProps:{"value":(_vm.formDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.formDate=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-lg-3"},[_c('label',{staticClass:"h5 ml-3",attrs:{"for":"Sort"}},[_vm._v(_vm._s(_vm.labelUpdated.toDateLabel))]),_vm._v(" "),_c('div',{staticClass:"form-group col-lg-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.toDate),expression:"toDate"}],staticClass:"form-control",attrs:{"required":"","type":"text","placeholder":_vm.labelUpdated.toDateLabel,"onfocus":"(this.type='date')"},domProps:{"value":(_vm.toDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.toDate=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end mr-3"},[(_vm.validationDate)?_c('p',{staticClass:"text-danger date-error-msg"},[_vm._v("\n            Please verify that the "),_c('b',[_vm._v("'To date'")]),_vm._v(" is lesser than the\n            "),_c('b',[_vm._v("'From date")]),_vm._v(".\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-start ml-3"},[_c('div',{staticClass:"mr-3"},[_c('button',{staticClass:"btn btn-round btn-primary",attrs:{"type":"submit","data-analytics-campaign":"{\"id\":123, \"name\":\"search button\"}"},on:{"click":_vm.handleSearchResult}},[_vm._v("\n                "+_vm._s(_vm.labelUpdated.searchButtonText)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"ml-4"},[_c('button',{staticClass:"btn btn-round btn-outline-primary custom-clear-filter-btn",attrs:{"data-analytics-campaign":"{\"id\":123, \"name\":\"clear filter button\"}"},on:{"click":_vm.handleClearFilter}},[_vm._v("\n                "+_vm._s(_vm.labelUpdated.clearFiltersText)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row justify-content-start ml-1 mt-1 ml-3 p-4 flex-column"},_vm._l((_vm.paginatedResults),function(item,index){return _c('div',{key:index,staticClass:"mt-4"},[_c('div',{staticClass:"d-flex justify-content-start mt-3 font-weight-bold"},[_c('p',[_vm._v(_vm._s(item.Category))])]),_vm._v(" "),_c('a',{staticClass:"title-text h5 font-weight-bold item-title",attrs:{"href":item.Link || '',"target":item.LinkTarget || ''}},[_vm._v(_vm._s(item.Title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(item.Description)}}),_vm._v(" "),(item.PreProposalDate !== null)?_c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.labelUpdated.preProposalDeadline)+" "+_vm._s(item.PreProposalDate))])]):(item.ProposalDate !== null)?_c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.labelUpdated.proposalDate)+" "+_vm._s(item.ProposalDate))])]):_c('div',[_c('div',[_vm._v(_vm._s(_vm.labelUpdated.tbdLabel))])])])}),0),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[(_vm.totalLength > 0)?_c('div',[_c('nav',[_c('ul',{staticClass:"pagination pagination-lg pagination--page-count pagination--right funding-opportunities"},[_c('li',{staticClass:"page-item",class:{ disabled: _vm.currentPageNo === 1 }},[_c('button',{staticClass:"page-link",on:{"click":_vm.prevPage}},[_c('i',{staticClass:"icon-left-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_vm._v(" "),_vm._l((_vm.totalPages),function(page){return _c('li',{key:page,staticClass:"page-item",class:{ active: page === _vm.currentPageNo }},[_c('button',{staticClass:"page-link",on:{"click":function($event){return _vm.setPage(page)}}},[_vm._v("\n                            "+_vm._s(page)+"\n                        ")])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ disabled: _vm.currentPageNo === _vm.totalPages }},[_c('button',{staticClass:"page-link",on:{"click":_vm.nextPage}},[_c('i',{staticClass:"icon-right-arrow"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])],2)])]):_c('div',[_c('p',{staticClass:"mt-3 ml-4 pl-3 font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.noResultsMessage)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _clinicalTrialComponent = __webpack_require__(512);

var _clinicalTrialComponent2 = _interopRequireDefault(_clinicalTrialComponent);

var _communitiesEducation = __webpack_require__(514);

var _communitiesEducation2 = _interopRequireDefault(_communitiesEducation);

var _deviceDrugAlerts = __webpack_require__(516);

var _deviceDrugAlerts2 = _interopRequireDefault(_deviceDrugAlerts);

var _dailyRateComparison = __webpack_require__(518);

var _dailyRateComparison2 = _interopRequireDefault(_dailyRateComparison);

var _membershipRateComparison = __webpack_require__(520);

var _membershipRateComparison2 = _interopRequireDefault(_membershipRateComparison);

var _overallJournal = __webpack_require__(522);

var _overallJournal2 = _interopRequireDefault(_overallJournal);

var _leftNav = __webpack_require__(524);

var _leftNav2 = _interopRequireDefault(_leftNav);

var _navSecondaryTertiary = __webpack_require__(526);

var _navSecondaryTertiary2 = _interopRequireDefault(_navSecondaryTertiary);

var _scienceNewsBox = __webpack_require__(528);

var _scienceNewsBox2 = _interopRequireDefault(_scienceNewsBox);

var _memberTierSelector = __webpack_require__(530);

var _memberTierSelector2 = _interopRequireDefault(_memberTierSelector);

var _phdDisplayCheckbox = __webpack_require__(538);

var _phdDisplayCheckbox2 = _interopRequireDefault(_phdDisplayCheckbox);

var _educationActivitiesList = __webpack_require__(540);

var _educationActivitiesList2 = _interopRequireDefault(_educationActivitiesList);

var _riskCalculator = __webpack_require__(542);

var _riskCalculator2 = _interopRequireDefault(_riskCalculator);

var _ckmRiskCalculator = __webpack_require__(157);

var _ckmRiskCalculator2 = _interopRequireDefault(_ckmRiskCalculator);

var _hcfCalculator = __webpack_require__(159);

var _hcfCalculator2 = _interopRequireDefault(_hcfCalculator);

var _ahaSearchFundingOpportunities = __webpack_require__(172);

var _ahaSearchFundingOpportunities2 = _interopRequireDefault(_ahaSearchFundingOpportunities);

var _ahaSearchDropdown = __webpack_require__(161);

var _ahaSearchDropdown2 = _interopRequireDefault(_ahaSearchDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// PHD Components
_vue2['default'].component('clinical-trial-component', _clinicalTrialComponent2['default']);
_vue2['default'].component('communities-education', _communitiesEducation2['default']);
_vue2['default'].component('device-drug-alerts', _deviceDrugAlerts2['default']);
_vue2['default'].component('daily-rate-comparison', _dailyRateComparison2['default']);
_vue2['default'].component('phd-left-nav', _leftNav2['default']);
_vue2['default'].component('phd-nav-secondary-tertiary', _navSecondaryTertiary2['default']);
_vue2['default'].component('science-news-box', _scienceNewsBox2['default']);
_vue2['default'].component('membership-rate-comparison', _membershipRateComparison2['default']);
_vue2['default'].component('member-tier-selector', _memberTierSelector2['default']);
_vue2['default'].component('overall-journal', _overallJournal2['default']);
_vue2['default'].component('phd-display-checkbox', _phdDisplayCheckbox2['default']);
_vue2['default'].component('phd-education-activities-list', _educationActivitiesList2['default']);
_vue2['default'].component('risk-calculator', _riskCalculator2['default']);
_vue2['default'].component('Ckm-risk-calculator', _ckmRiskCalculator2['default']);
_vue2['default'].component('hcf-calculator', _hcfCalculator2['default']);

_vue2['default'].component('aha-search-funding-opportunities', _ahaSearchFundingOpportunities2['default']);

_vue2['default'].component('aha-search-dropdown', _ahaSearchDropdown2['default']);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7bbee8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clinical_trial_component_vue__ = __webpack_require__(513);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clinical_trial_component_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7bbee8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clinical_trial_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clinical-trial mb-5"},[_c('div',{staticClass:"container clinical-trial__container"},[_c('div',{staticClass:"clinical-trial__wrapper phd--shadow-border"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-4 clinical-trial__description"},_vm._l((_vm.tableData.table.sidebarContent),function(row,rowIndex){return _c('div',{key:rowIndex,staticClass:"clinical-trial__text-block"},[(row.title)?_c('div',{staticClass:"row-description",domProps:{"innerHTML":_vm._s(row.title)}}):_vm._e(),_vm._v(" "),(row.content)?_c('div',{staticClass:"row-description",domProps:{"innerHTML":_vm._s(row.content)}}):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"col-12 clinical-table__content-group d-md-none"},_vm._l((_vm.tableData.table.rows),function(row,rowIndex){return _c('div',{key:rowIndex,staticClass:"clinical-table general-endpoints",class:{'collapsed': !row.active}},[_c('div',{staticClass:"clinical-table__cell clinical-table__cell--head",on:{"click":function($event){row.active = !row.active}}},[_c('span',{staticClass:"row-title",domProps:{"innerHTML":_vm._s(row.name)}}),_vm._v(" "),(row.name)?_c('span',{staticClass:"row-description d-none d-md-block",domProps:{"innerHTML":_vm._s(row.name)}}):_vm._e()]),_vm._v(" "),_vm._l((row.colData),function(col,colIndex){return _c('span',{key:colIndex,staticClass:"clinical-table__cell"},[(col.values[colIndex])?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 md-d-none general-endpoints__mobile-label"},[(col.values[0])?[_c('span',{staticClass:"general-endpoints__mobile-label-top",domProps:{"innerHTML":_vm._s(col.titles[0])}}),_vm._v(" "),(col.names[0])?_c('span',{staticClass:"general-endpoints__mobile-label-bottom",domProps:{"innerHTML":_vm._s(col.names[0])}}):_vm._e()]:_vm._e(),_vm._v(" "),(col.values[1])?[_c('span',{staticClass:"general-endpoints__mobile-label-top",domProps:{"innerHTML":_vm._s(col.titles[1])}}),_vm._v(" "),(col.names[1])?_c('span',{staticClass:"general-endpoints__mobile-label-bottom",domProps:{"innerHTML":_vm._s(col.names[1])}}):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-6 general-endpoints__value text-right"},[_c('div',{staticClass:"row"},[(col.values[0])?_c('span',{staticClass:"col-12 general-endpoints__value",domProps:{"innerHTML":_vm._s(col.values[0])}}):_vm._e(),_vm._v(" "),(col.values[1])?_c('span',{staticClass:"col-12 general-endpoints__value-bottom",domProps:{"innerHTML":_vm._s(col.values[1])}}):_vm._e()])]),_vm._v(" "),(col.result)?_c('div',{staticClass:"col-12 general-endpoints__mobile-label-results",domProps:{"innerHTML":_vm._s(col.result)}}):_vm._e()]):_vm._e()])})],2)}),0),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-8"},[_c('div',{staticClass:"clinical-trial__table d-none d-md-block"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.tableData.table.rows),function(row,rowIndex){return _c('div',{key:rowIndex,staticClass:"row clinical-trial__table-colrows"},[_c('div',{staticClass:"col-12 col-md-4 collapse-trigger clinical-trial__table-name",domProps:{"innerHTML":_vm._s(row.name)}}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row clinical-trial__table-datarow"},[_c('span',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(row.colData[0].values[0]))]),_vm._v(" "),_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(row.colData[0].values[1]))]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-block col-md-2"})])]),_vm._v(" "),_c('span',{staticClass:"col-6"},[_c('div',{staticClass:"row"},[_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(row.colData[1].values[0]))]),_vm._v(" "),_c('span',{staticClass:"col-md-5"},[_vm._v(_vm._s(row.colData[1].values[1]))]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-block col-md-2"})])]),_vm._v(" "),_vm._l((row.colData),function(col,colIndex){return _c('span',{key:colIndex,staticClass:"col-12 col-md-6 clinical-trial__table-resultLabel text-right",class:{'clinical-trial__table-empty-trial': !col.resultsLabel[colIndex]}},[_vm._v("\n                                                    "+_vm._s(col.resultsLabel)+"\n                                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row clinical-trial__table-resultrow"},_vm._l((row.colData),function(col,colIndex){return _c('span',{key:colIndex,staticClass:"col-6 col-md-6"},[_vm._v("\n                                                    "+_vm._s(col.result)+"\n                                            ")])}),0)])])])])})],2),_vm._v(" "),_c('hr',{staticClass:"clinical-trial__results-divider mx-md-4 d-none d-md-block"}),_vm._v(" "),_vm._t("results")],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row d-none d-md-flex clinical-trial__table-colheaders"},[_c('div',{staticClass:"col-4"}),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_vm._v("\n                                        Vit D3\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_vm._v("\n                                        placebo\n                                    ")]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-block col-md-2"})])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_vm._v("\n                                        O3FA\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_vm._v("\n                                        placebo\n                                    ")]),_vm._v(" "),_c('span',{staticClass:"d-none d-md-block col-md-2"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351207a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_communities_education_vue__ = __webpack_require__(515);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_communities_education_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351207a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_communities_education_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD communities-education"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container container-fluid communities-education__wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row l-tier-selector"},[_c('div',{staticClass:"col-3 c-tier-selector__tabs communities-education__tabs"},[_c('div',{staticClass:"nav flex-column nav-pills",attrs:{"id":"v-pills-tab","role":"tablist","aria-orientation":"vertical"}},[_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('journals') },attrs:{"id":"v-pills-journals-tab","data-toggle":"pill","href":"#v-pills-journals","role":"tab","aria-controls":"v-pills-journals","aria-selected":[_vm.isActive('journals') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('journals')}}},[_vm._m(1)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('science-news') },attrs:{"id":"v-pills-science-news-tab","data-toggle":"pill","href":"#v-pills-science-news","role":"tab","aria-controls":"v-pills-science-news","aria-selected":[_vm.isActive('science-news') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('science-news')}}},[_vm._m(2)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('guidelines') },attrs:{"id":"v-pills-guidelines-tab","data-toggle":"pill","href":"#v-pills-guidelines","role":"tab","aria-controls":"v-pills-guidelines","aria-selected":[_vm.isActive('guidelines') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('guidelines')}}},[_vm._m(3)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('meetings') },attrs:{"id":"v-pills-meetings-tab","data-toggle":"pill","href":"#v-pills-meetings","role":"tab","aria-controls":"v-pills-meetings","aria-selected":[_vm.isActive('meetings') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('meetings')}}},[_vm._m(4)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('education') },attrs:{"id":"v-pills-education-tab","data-toggle":"pill","href":"#v-pills-education","role":"tab","aria-controls":"v-pills-education","aria-selected":[_vm.isActive('education') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('education')}}},[_vm._m(5)]),_vm._v(" "),_c('a',{staticClass:"nav-link communities-education__nav-link",class:{ active: _vm.isActive('council') },attrs:{"id":"v-pills-council-tab","data-toggle":"pill","href":"#v-pills-council","role":"tab","aria-controls":"v-pills-council","aria-selected":[_vm.isActive('council') ? true : false]},on:{"click":function($event){$event.preventDefault();return _vm.setActive('council')}}},[_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"col-9 c-tier-selector__tab-panels"},[_c('div',{staticClass:"tab-content communities-education__tab-content",attrs:{"id":"v-pills-tabContent"}},[_c('div',{staticClass:"tab-pane p-0",class:{ 'active show': _vm.isActive('journals') },attrs:{"id":"v-pills-journals","role":"tabpanel","aria-labelledby":"v-pills-journals-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-journals'),expression:"'panel-collapse-journals'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('journals') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('journals')}}},[_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-journals","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Journal Content")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View All Related Journal Content")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('science-news') },attrs:{"id":"v-pills-science-news","role":"tabpanel","aria-labelledby":"v-pills-science-news-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-science-news'),expression:"'panel-collapse-science-news'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('science-news') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('science-news')}}},[_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-science-news","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Science News")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Gender-Affirming Hormone Therapy, Vascular Health and Cardiovascular Disease in Transgender Adults")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Circulation")]),_vm._v(" | October 21, 2019")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View More Science News")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('guidelines') },attrs:{"id":"v-pills-guidelines","role":"tabpanel","aria-labelledby":"v-pills-guidelines-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-guidelines'),expression:"'panel-collapse-guidelines'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('guidelines') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('guidelines')}}},[_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-guidelines","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Guidelines & Statements")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("2019 AHA/ACC Clinical Performance and Quality Measures for Adults With High Blood Pressure: A Report of the American College of Cardiology/American Heart Association Task Force on Performance Measures")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("Published Nov 2019")])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View All Guidelines & Statements")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('meetings') },attrs:{"id":"v-pills-meetings","role":"tabpanel","aria-labelledby":"v-pills-meetings-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-meetings'),expression:"'panel-collapse-meetings'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('meetings') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('meetings')}}},[_vm._m(10)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-meetings","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Meetings")]),_vm._v(" "),_c('div',{staticClass:"c-phd-meeting"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 c-phd-meeting__image-container"},[_c('div',{staticClass:"h-placeholder-image h-placeholder-image--4-3"},[_c('img',{attrs:{"src":"assets/images/placeholder.gif","alt":"alt text"}}),_vm._v(" "),_c('span',{staticClass:"c-phd-meeting__image-title"},[_vm._v("Featured Session")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6 c-phd-meeting__metadata-container"},[_c('h3',[_vm._v("International Stroke Conference")]),_vm._v(" "),_c('p',{staticClass:"date"},[_vm._v("Precon & Nursing: Feb. 18 | Sessions: Feb. 19–21, 2020")]),_vm._v(" "),_c('p',{staticClass:"location"},[_vm._v("Los Angeles, Calif.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"c-phd-meeting__registration c-phd-meeting__registration--status"},[_vm._v("Registration now open")]),_vm._v(" "),_c('p',{staticClass:"c-phd-meeting__registration c-phd-meeting__registration--message"},[_vm._v("Get EARLY pricing through Dec. 31!")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 order-2 order-md-1 c-phd-meeting__content-container"},[_c('p',[_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo eveniet exercitationem esse architecto consequatur consequuntur sapiente, modi accusamus amet porro deserunt perferendis soluta sunt quisquam autem dolorem dolore! Vitae, natus.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ad ut nisi quia assumenda, voluptas incidunt quasi dolor. Neque, corporis a dolorum facilis facere qui quidem expedita ex id, aliquid exercitationem?")]),_vm._v(" "),_c('li',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus laboriosam culpa vitae! Optio possimus perspiciatis accusamus laborum odio quisquam reprehenderit vitae maiores quas est. Beatae incidunt blanditiis sit ut distinctio.")])]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga, labore aperiam. Minus hic ipsa ullam, consequatur doloribus rem distinctio aut adipisci facere! Fugiat, consequatur accusantium necessitatibus fuga sit consequuntur iste.")])]),_vm._v(" "),_c('ul',{staticClass:"col-12 order-1 order-lg-2 c-phd-meeting__buttons-list"},[_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn btn-outline",attrs:{"href":"#"}},[_vm._v("Housing & Transportation")])]),_vm._v(" "),_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn btn-outline",attrs:{"href":"#"}},[_vm._v("Submit Abstract")])]),_vm._v(" "),_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn btn-outline",attrs:{"href":"#"}},[_vm._v("View Programming")])]),_vm._v(" "),_c('li',{staticClass:"c-phd-meeting__buttons-list-item"},[_c('a',{staticClass:"btn",attrs:{"href":"#"}},[_vm._v("Register Now")])])])])])]),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View All Meetings")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('education') },attrs:{"id":"v-pills-education","role":"tabpanel","aria-labelledby":"v-pills-education-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-education'),expression:"'panel-collapse-education'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('education') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('education')}}},[_vm._m(11)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-education","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Continuing Education")]),_vm._v(" "),_c('phd-education-activities-list',{attrs:{"numbertoshow":3}}),_vm._v(" "),_c('div',{staticClass:"c-promo__actions c-promo__actions--divider communities-education__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--gray-dark",attrs:{"href":"#"}},[_vm._v("View More Education on Life Long Learning")])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"tab-pane p-0",class:{ 'show active': _vm.isActive('council') },attrs:{"id":"v-pills-council","role":"tabpanel","aria-labelledby":"v-pills-council-tab"}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('panel-collapse-council'),expression:"'panel-collapse-council'"}],staticClass:"btn btn-link-plain btn-white btn--select",class:{ active: _vm.isActive('council') },on:{"click":function($event){$event.preventDefault();return _vm.setActive('council')}}},[_vm._m(12)]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":"panel-collapse-council","visible":false},on:{"hidden":_vm.onHidden}},[_c('h2',{staticClass:"mt-4 mb-4"},[_vm._v("Related Scientific Councils")]),_vm._v(" "),_c('div',{staticClass:"c-phd-card"},[_c('div',{staticClass:"c-phd-card__background h-placeholder-image h-placeholder-image--4-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placehold.it/750x563/ddd/ccc?text=FPO","alt":"alt text"}})]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__content"},[_c('h3',{staticClass:"c-phd-card__heading"},[_vm._v("Cardiovascular and Stroke Nursing (CVSN)")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam interdum maximus turpis, nec malesuada augue interdum at. Ut sed elit mollis, sollicitudin nisi sed, congue diam. ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"c-phd-card__actions"},[_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Scientific Sessions")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Resuscitation Science Symposium")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("CVRI Council Awards")])])])])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card"},[_c('div',{staticClass:"c-phd-card__background h-placeholder-image h-placeholder-image--4-3"},[_c('img',{staticClass:"is-loaded",attrs:{"src":"//placehold.it/750x563/ddd/ccc?text=FPO","alt":"alt text"}})]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__content"},[_c('h3',{staticClass:"c-phd-card__heading"},[_vm._v("Cardiovascular and Stroke Nursing (CVSN)")]),_vm._v(" "),_c('p',{attrs:{"slot":"content"},slot:"content"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam interdum maximus turpis, nec malesuada augue interdum at. Ut sed elit mollis, sollicitudin nisi sed, congue diam. ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"c-phd-card__actions"},[_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Scientific Sessions")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("Resuscitation Science Symposium")])]),_vm._v(" "),_c('div',{staticClass:"c-phd-card__action"},[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("CVRI Council Awards")])])])])])])],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading"},[_vm._v("Communities Component - Education Tab")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v("General Cardiology")]),_vm._v(" "),_c('p',{staticClass:"mb-5"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur cumque sequi, veritatis animi aspernatur, nobis perferendis, necessitatibus corporis adipisci maxime ut. Deleniti voluptatum non quisquam doloremque nemo consectetur eaque! Pariatur.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Journals")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Science News")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Guidelines & Statements")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Meetings")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Education")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading communities-education__heading"},[_vm._v("Council")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Journals")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Science News")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Guidelines & Statements")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Meetings")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Education")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v("Council")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c572e8d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_device_drug_alerts_vue__ = __webpack_require__(517);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c572e8d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_device_drug_alerts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-drug-alert"},[_c('div',{staticClass:"container device-drug-alert__container"},[_c('div',{staticClass:"device-drug-alert__wrapper phd--shadow-border"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-9 order-1"},[_c('h2',{staticClass:"device-drug-alert__heading"},[_vm._v("Drug & Device Alerts")])]),_vm._v(" "),_c('div',{staticClass:"col-12 order-2 order-md-3 device-drug-alert__content"},[_c('div',{staticClass:"device-drug-alert__text-block"},[_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA approval: once a week semaglutide injection - indication to reduce risk of major adverse CV events in adults with CVD and T2DM")])]),_vm._v(" "),_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA: Stryker Launches Voluntary Field Action for Specific Units of The LIFEPAK® 15 Monitor/Defibrillator")])]),_vm._v(" "),_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA: Voluntary worldwide recall of Mavidon manufactured products, including Cardio Prep Single Use Cups Due to Burkholderia Cepacia Contamination")])]),_vm._v(" "),_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA approves first generics of Eliquis (apixaban)")])]),_vm._v(" "),_c('div',{staticClass:"device-drug-alert-container"},[_c('a',{staticClass:"device-drug-alert__alert-link",attrs:{"href":"#"}},[_vm._v("FDA Safety Alert: Mavidon Issues Voluntary Worldwide Recall of all Manufactured Products Due to Burkholderia cepacia Contamination")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4 col-lg-3 order-3 order-md-2 device-drug-alert__link-container"},[_c('a',{staticClass:"c-cta c-cta--arrow view-all-link device-drug-alert__link",attrs:{"href":"link.url"}},[_vm._v("View All Alerts")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a30d8e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_rate_comparison_vue__ = __webpack_require__(519);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_daily_rate_comparison_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a30d8e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_daily_rate_comparison_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-comparison"},[_c('div',{staticClass:"container daily-comparison__container"},[_c('div',{staticClass:"row"},_vm._l((_vm.theData),function(table,index){return _c('div',{key:index,staticClass:"col-12 col-md-6 daily-comparison__grid",class:{'is-active': table.active != false},on:{"click":function($event){table.active = !table.active}}},[_c('div',{staticClass:"daily-comparison__grid-titles"},[_c('span',{staticClass:"daily-comparison__grid-category",domProps:{"innerHTML":_vm._s(table.tableName.preTitle)}}),_vm._v(" "),_c('h2',{staticClass:"daily-comparison__grid-title",domProps:{"innerHTML":_vm._s(table.tableName.title)}}),_vm._v(" "),_c('h6',{staticClass:"daily-comparison__grid-day",domProps:{"innerHTML":_vm._s(table.tableName.day)}})]),_vm._v(" "),_c('div',{staticClass:"row daily-comparison__grid-data"},_vm._l((table.rates),function(item,rateIndex){return _c('div',{key:rateIndex,staticClass:"col-12 col-lg-4 daily-comparison__grid-data-item"},[_c('span',{staticClass:"daily-comparison__grid-rate-label",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('span',{staticClass:"daily-comparison__grid-rate-date",domProps:{"innerHTML":_vm._s(item.date)}}),_vm._v(" "),_c('span',{staticClass:"daily-comparison__grid-rate",domProps:{"innerHTML":_vm._s(item.rate)}})])}),0)])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454d536b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_membership_rate_comparison_vue__ = __webpack_require__(521);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_membership_rate_comparison_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454d536b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_membership_rate_comparison_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate-comparison",class:{'is-active': _vm.theData.active}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"rate-comparison__wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"flex-table general-membership"},[_c('span',{staticClass:"flex-table__cell flex-table__heading-cell",class:_vm.columnCountClass,on:{"click":function($event){_vm.theData.active = !_vm.theData.active}}},[(_vm.theData.tableName.preTitle)?_c('span',{staticClass:"flex-table__category-label",domProps:{"innerHTML":_vm._s(_vm.theData.tableName.preTitle)}}):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"flex-table__table-title",domProps:{"innerHTML":_vm._s(_vm.theData.tableName.title)}})]),_vm._v(" "),_vm._l((_vm.theData.rateText),function(item,index){return _c('span',{key:index,staticClass:"flex-table__cell flex-table__labels-cell"},[_c('span',{staticClass:"general-membership__rate-label",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('span',{staticClass:"general-membership__date-label",domProps:{"innerHTML":_vm._s(item.date)}})])})],2),_vm._v(" "),_c('div',{staticClass:"flex-table__content-group"},_vm._l((_vm.theData.rowData),function(tableRow,index){return _c('div',{key:index,staticClass:"flex-table general-membership",class:{'collapsed': !tableRow.active}},[_c('div',{staticClass:"flex-table__cell flex-table__cell--head",class:_vm.columnCountClass,on:{"click":function($event){tableRow.active = !tableRow.active}}},[_c('span',{staticClass:"row-title",domProps:{"innerHTML":_vm._s(tableRow.rowTitle)}}),_vm._v(" "),(tableRow.rowDescription)?_c('span',{staticClass:"row-description d-none d-md-block",domProps:{"innerHTML":_vm._s(tableRow.rowDescription)}}):_vm._e()]),_vm._v(" "),_vm._l((tableRow.rates),function(rate,rateIndex){return _c('span',{key:rateIndex,staticClass:"flex-table__cell"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 md-d-none general-membership__mobile-label"},[_c('span',{staticClass:"general-membership__mobile-label-top",domProps:{"innerHTML":_vm._s(_vm.theData.rateText[rateIndex].title)}}),_vm._v(" "),_c('span',{staticClass:"general-membership__mobile-label-bottom",domProps:{"innerHTML":_vm._s(_vm.theData.rateText[rateIndex].date)}})]),_vm._v(" "),_c('div',{staticClass:"general-membership__value",class:rate.gold ? 'col-3 col-md-6' : 'col-6 col-md-12'},[_vm._v("\n                                        "+_vm._s(rate.normal)+"\n                                    ")]),_vm._v(" "),(rate.gold)?_c('div',{staticClass:"col-3 col-md-6 general-membership__value general-membership__value--gold",class:{
                                            'show-label': index === 0 && rate.gold, 'm-show-label': rate.gold
                                            }},[_vm._v("\n                                        "+_vm._s(rate.gold)+"\n                                    ")]):_vm._e()])])})],2)}),0),_vm._v(" "),_vm._t("postTableContent")],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345d4486_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overall_journal_vue__ = __webpack_require__(523);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345d4486_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_overall_journal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"PHD"},[_c('div',{staticClass:"l-main"},[_c('div',{staticClass:"container container-fluid overall-journal__wrapper"},[_c('div',{staticClass:"l-promo--shadow"},[_c('div',{staticClass:"l-promo row"},[_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/170x300/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("ATVB")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 2020 - Vol 75, Issue 3")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore ATVB")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/140x310/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Circulation")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 3, 2020 - Vol 9, Issue 5")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore Circulation")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/200x280/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Circulation Research")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("February 2020 - Vol 51, Issue Suppl_1")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore Cardiovascular Research")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/700x700/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Hypertension")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 2020 - Vol 75, Issue 3")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore Hypertension")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/140x330/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Stroke")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 3, 2020 - Vol 9, Issue 5")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("Explore Stroke")])])])]),_vm._v(" "),_c('div',{staticClass:"l-promo__col col-sm-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"c-text-promo d-block overall-journal__container"},[_c('div',{staticClass:"c-text-promo__content"},[_c('div',{staticClass:"c-promo-enhanced__image overall-journal__image"},[_c('img',{staticClass:"is-loaded img-fluid",attrs:{"src":"//placehold.it/240x250/333333/666666?text=FPO"}})]),_vm._v(" "),_c('h2',{staticClass:"overall-journal__title"},[_vm._v("Circulation: Cardiovascular Imaging")]),_vm._v(" "),_c('div',{staticClass:"c-promo-enhanced__image-cta"},[_c('a',{attrs:{"href":"#"}},[_vm._v("March 9 2020 - Vol 75, Issue 3")])])]),_vm._v(" "),_c('div',{staticClass:"c-text-promo__actions overall-journal__link"},[_c('a',{staticClass:"c-cta c-cta--arrow h-theme--red",attrs:{"href":"#"}},[_vm._v("More on Circ: Cardiovascular Imaging")])])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4eb45e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_left_nav_vue__ = __webpack_require__(525);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_left_nav_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4eb45e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_left_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"left-nav",attrs:{"aria-label":"Side Navigation"}},[_c('div',{staticClass:"d-md-none"},[_c('aha-listbox',{attrs:{"dropdown-tag":"div","role":"navigation","default-value":_vm.findActiveItem(),"toggle-class":"btn btn-outline btn--select w-100"}},[_vm._l((_vm.menuData),function(mLink,mIndex){return _c('template',{slot:"dropdown"},[(!mLink.active)?[_c('aha-select-dropdown-item',{key:mIndex,attrs:{"href":mLink.url,"tag":"a","role":"","text":mLink.text,"target":mLink.target,"item-class":"c-select-dropdown__item"}},[_vm._v(_vm._s(mLink.text))])]:[_c('aha-select-dropdown-item',{key:mIndex,attrs:{"tag":"span","text":mLink.text,"item-class":"c-select-dropdown__item selected","selected":""}},[_vm._v(_vm._s(mLink.text))])]],2)})],2)],1),_vm._v(" "),_c('div',{staticClass:"d-none d-md-block"},[_vm._l((_vm.menuData),function(link,index){return [(!link.active)?[_c('a',{key:index,staticClass:"left-nav__item",attrs:{"href":link.url,"target":link.target},domProps:{"innerHTML":_vm._s(link.text)}})]:[_c('span',{key:index,staticClass:"left-nav__item is-active",domProps:{"innerHTML":_vm._s(link.text)}})]]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72817b56_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_secondary_tertiary_vue__ = __webpack_require__(527);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_secondary_tertiary_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72817b56_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_secondary_tertiary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideAll),expression:"hideAll"}],staticClass:"nav-secondary",class:{'all-open': _vm.theData.showAll},attrs:{"role":"navigation","aria-label":"Secondary Navigation"}},_vm._l((_vm.theData.navItems),function(item,index){return _c('div',{key:index,staticClass:"nav-secondary__item",class:{'is-open': item.open, 'is-active': _vm.findActiveChild(index)}},[(item.subNav)?[_c('button',{ref:'secondary-dropdown-' + index,refInFor:true,staticClass:"nav-secondary__link",class:{'is-active': _vm.findActiveChild(index)},attrs:{"id":'secondary-nav-button-' + index,"aria-haspopup":"true","aria-expanded":item.open ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();return _vm.handleSecondaryNavClick(index)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.closeAllTertiary.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }if(!$event.shiftKey){ return null; }return _vm.closeAllTertiary.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryUp(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryDown(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryPrevious(index, _vm.theData.navItems.length)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryNext(index, _vm.theData.navItems.length)}]}},[_vm._v(_vm._s(item.text))])]:[_c('a',{ref:'secondary-dropdown-' + index,refInFor:true,staticClass:"nav-secondary__link",attrs:{"href":item.url,"target":item.target},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryPrevious(index, _vm.theData.navItems.length)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleSecondaryNext(index, _vm.theData.navItems.length)}]}},[_vm._v(_vm._s(item.text))])],_vm._v(" "),(item.subNav)?[_c('transition',{attrs:{"name":"slide"}},[(item.open)?_c('div',{staticClass:"nav-tertiary",class:{'is-open': item.open},attrs:{"role":"menu","aria-label":"Tertiary Navigation","aria-labelledby":'secondary-nav-button-' + index}},_vm._l((item.subNav),function(link,subIndex){return _c('a',{key:subIndex,ref:'secondary-dropdown-' + index + '_tertiary-item-' + subIndex,refInFor:true,staticClass:"nav-tertiary__link",class:{'is-active': link.active},attrs:{"href":link.url,"target":link.target,"role":"menuitem"},domProps:{"innerHTML":_vm._s(link.text)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.handleEscape(index)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.handleTab(subIndex, item.subNav.length)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleTertiaryPrevious(index, item.subNav.length, subIndex)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleTertiaryNext(index, item.subNav.length, subIndex)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleTertiaryPrevious(index, item.subNav.length, subIndex)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }$event.preventDefault();return _vm.handleTertiaryNext(index, item.subNav.length, subIndex)}]}})}),0):_vm._e()])]:_vm._e()],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240f703c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_box_vue__ = __webpack_require__(529);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_science_news_box_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240f703c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_science_news_box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"science-news-box"},[(_vm.heading)?_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"science-news-box__container phd--shadow-border"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-9 order-1"},[_c('div',{staticClass:"h2 science-news-box__heading",attrs:{"role":"heading","aria-level":_vm.headingLevel},domProps:{"innerHTML":_vm._s(_vm.heading)}},[_vm._v("Heading Goes Here")]),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"title-description science-news-box__description",domProps:{"innerHTML":_vm._s(_vm.description)}},[_vm._v("Description Goes Here")]):_vm._e()]),_vm._v(" "),(_vm.link.url && _vm.link.text)?_c('div',{staticClass:"col-12 col-md-4 col-lg-3 order-2 d-none d-md-block science-news-box__link-container"},[_c('a',{staticClass:"c-cta c-cta--arrow view-all-link science-news-box__link",attrs:{"href":_vm.link.url},domProps:{"innerHTML":_vm._s(_vm.link.text)}},[_vm._v("link text here")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 order-2 order-md-3 science-news-box__content"},[_vm._t("default",function(){return [_c('p',[_vm._v("If you're seeing this message, you need to slot something into this component.")])]})],2),_vm._v(" "),(_vm.link.url && _vm.link.text)?_c('div',{staticClass:"col-12 col-md-4 col-lg-3 order-3 d-md-none science-news-box__link-container"},[_c('a',{staticClass:"c-cta c-cta--arrow view-all-link science-news-box__link",attrs:{"href":_vm.link.url},domProps:{"innerHTML":_vm._s(_vm.link.text)}},[_vm._v("link text here")])]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d602383_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_vue__ = __webpack_require__(537);
function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d602383_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4a7bb946", content, true, {});

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".link-member-icon{color:gray;font-weight:500;text-decoration:none!important}.footer-price-caption{font-size:12px;margin-left:16px;margin-top:10px;margin-left:2px}.footer-right-content{margin-top:2px;-webkit-box-align:self-start;-ms-flex-align:self-start;align-items:self-start;padding:0 12px}.footer-left-content,.footer-right-content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.footer-left-content{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.footer-member-tier{border-radius:4px;border:2px solid gray;margin-top:50px;margin-left:2px;width:100%}.footer-header{background-color:#636466;color:#fff;text-align:center;text-transform:uppercase;width:100%;font-weight:500}.new-tier-card{border-radius:2px;border:none;height:870px;margin:auto;position:relative}.new-tier-card,.newTierCardSelected{-webkit-box-shadow:5px 10px #fff;box-shadow:5px 10px #fff;width:274px;background-color:#fff;-webkit-box-shadow:5px 5px 10px rgba(0,0,0,.5);box-shadow:5px 5px 10px rgba(0,0,0,.5)}.newTierCardSelected{border-radius:6px;border:none;cursor:pointer;border:2px solid #c10e21}.new-tier-caption:nth-of-type(2){margin-top:10px;width:200px;margin-left:16px}.new-tier-img{width:274px;height:132px;background-color:gray;border-radius:6px;position:relative;margin-bottom:20px}.PP .new-tier-img{width:270px}.PP .new-tier-card{border:2px solid #d22338;border-radius:6px 6px 0 0}.PP .most-chosen-membership{font-size:10px;width:274px;background-color:#d22338;color:#fff;border:2px solid #d22338;position:absolute;top:-18px;border-radius:6px 6px 0 0;left:-2px}.new-tier-header h2,.PP .most-chosen-membership{font-weight:700;text-align:center;text-transform:uppercase}.new-tier-header h2{color:#c10e21;margin-top:60px;font-size:20px;padding:2px;line-height:24px}.PP .new-tier-caption{margin-top:18px}.GM .new-tier-header h2{margin-top:10px!important;color:#c10e21;text-transform:uppercase;text-align:center;font-weight:700;margin-top:60px;font-size:20px;padding:2px;line-height:24px}.PP .new-tier-header{margin-top:54px}.new-tier-caption{font-size:10px;font-weight:700;text-align:center;margin:20px 0;line-height:16px;padding:0 22px}.new-tier-price-tag{text-align:center;font-size:32px;font-weight:700;margin:20px 0 25px;text-decoration:none!important}.new-tier-price-tag-discount-price{text-align:center;font-size:32px;font-weight:700;margin:10px 0 25px}.new-tier-price-tag span{font-size:22px}.new-tier-feature{padding:0 8px}.new-tier-feature h3{font-size:18px}.new-tier-list{list-style-type:none;font-size:10px;padding:0}.new-tier-list li{margin-top:10px;color:#000;text-align:left}.new-tier-additional-benefits{font-size:12px;font-weight:700;cursor:pointer;margin-top:auto;position:absolute;bottom:0;text-align:center;width:100%;left:0}.new-tier-additional-benefits i{font-style:normal!important;color:#c10e21;cursor:pointer}.EC .new-tier-caption,.ST .new-tier-caption{margin-top:44px}.selected{background-color:#c10e21}.l-tier-selector a{color:#fff!important}.field-validation-error{color:#c10e21}.feature-benefits span{list-style:20px}.join-renew{width:170px;margin:auto}.join-renew-footer{width:170px;margin-left:16px}.join-renew a:focus{border:2px solid #000!important}.GM .new-tier-feature{height:220px;padding-top:30px}.GM .new-tier-feature h3{font-size:18px}.GM .new-tier-additional-benefits{text-align:justify}.flex-even{margin-top:20px}.GM .flex-even{padding-top:10px}.tier-header{font-size:22px}.ST .new-tier-additional-benefits{margin-top:44px}.custom-space{width:100%;margin:auto}.new-navigation-tier{padding-top:5%;padding-bottom:5%}#pills-tab{margin-top:30px;margin-left:10px}.flex-even{padding-left:0!important;margin-top:22px}.bg-primary{background-color:gray!important}.sub-header{font-size:14px;font-weight:500}.strikethrough span{text-decoration:line-through}.custom-btn-focus:focus{background-color:none!important;color:#000!important}.custom-active-focus:focus,.custom-btn-focus:focus{border:2px solid #000!important}#ecTwo-membership-featureBenfits-modal .modal-title,#gm-membership-featureBenfits-modal .modal-title,#pp-membership-featureBenfits-modal .modal-title,#ps-membership-featureBenfits-modal .modal-title,#st-membership-featureBenfits-modal .modal-title,.modal-title{display:none}", ""]);

// exports


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c85eaa9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_tab_vue__ = __webpack_require__(534);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_tab_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c85eaa9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-item nav-link h-100",class:{ active: _vm.$parent.isActive(String(_vm.tierid)) },attrs:{"id":("panel-" + _vm.tierid + "-tab"),"data-toggle":"pill","data-tier":("" + _vm.tiercode),"href":("panel-" + _vm.tierid),"role":"tab","aria-controls":("panel-" + _vm.tierid),"aria-selected":[_vm.$parent.isActive(String(_vm.tierid)) ? true : false],"tabindex":[_vm.$parent.isActive(String(_vm.tierid)) ? 0 : -1],"data-tier-id":("" + _vm.tierid)},on:{"click":function($event){$event.preventDefault();return _vm.setParentActive.apply(null, arguments)}}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23670438_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_panel_vue__ = __webpack_require__(536);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_member_tier_selector_panel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23670438_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_member_tier_selector_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane",class:{ 'active show': _vm.$parent.isActive(String(_vm.tierid)) },attrs:{"id":("panel-" + _vm.tierid),"role":"tabpanel","aria-labelledby":("panel-" + _vm.tierid + "-tab")}},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.collapseid),expression:"collapseid"}],staticClass:"btn btn--select",class:{ active: _vm.$parent.isActive(String(_vm.tierid)) },on:{"click":function($event){$event.preventDefault();return _vm.setParentActive.apply(null, arguments)},"keydown":_vm.openOnKeyDown}},[_c('div',{staticClass:"nav-link__wrapper"},[_c('div',{staticClass:"nav-link__content"},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.displayname))]),_vm._v(" "),(_vm.discountPrice !== null)?_c('div',{staticClass:"tier-price"},[_c('span',{staticClass:"full-price strikethrough"},[_vm._v("$"+_vm._s(_vm.price)+"/YR")]),_vm._v(" "),_c('span',{staticClass:"discounted-price"},[_vm._v("$"+_vm._s(_vm.discountPrice)+"/YR")])]):_c('div',[_c('span',{staticClass:"full-price"},[_vm._v("$"+_vm._s(_vm.price)+"/YR")])])])])]),_vm._v(" "),_c('div',{staticClass:"collapse-wrapper"},[_c('b-collapse',{attrs:{"id":_vm.collapseid},on:{"hidden":_vm.$parent.onHidden},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-member-tier-selector"},[(_vm.isLoading)?_c('div',[_c('b-alert',{attrs:{"show":"","variant":"danger text-center mt-4"}},[(_vm.errorMsg)?_c('div',[_c('p',[_vm._v("Sorry, something went wrong.")]),_vm._v(" "),_c('h4',{staticClass:"alert-heading mt-0"},[_vm._v(_vm._s(_vm.errorMsg))])]):_c('div',[_c('p',[_vm._v(_vm._s(_vm.loadingmsg))]),_vm._v(" "),_c('aha-loading-spinner',{staticClass:"small",attrs:{"is-loading":true}})],1)])],1):_c('div',[_c('aha-modal',{ref:"loadingModal",staticClass:"c-loadingModal",attrs:{"size":"md","id":"loadingModal","hide-footer":"","hide-header-close":"","no-close-on-esc":"","no-close-on-backdrop":"","centered":"","lazy":""}},[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"c-loadingModal__heading"},[_vm._v("\n                    "+_vm._s(_vm.promoModalHeader)+"\n                ")])]),_vm._v(" "),_c('aha-loading-spinner',{attrs:{"is-loading":true}}),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.promoModalMessage))])],2),_vm._v(" "),(_vm.warningmessage)?_c('div',{staticClass:"w-100 warning",domProps:{"innerHTML":_vm._s(_vm.warningmessage)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"promo-code-wrapper d-flex flex-column flex-lg-row justify-content-between"},[_c('div',{staticClass:"d-flex flex-column"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"sub-header"},[_vm._v("\n                    "+_vm._s(_vm.componentSubheader)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"pc-wrapper"},[(_vm.promoCode)?_c('div',{staticClass:"c-promo-code c-promo-code__display-wrapper"},[_c('div',{staticClass:"h-color--white c-promo-code__display px-3 w-100"},[(
                                _vm.isPromoCodeValid === false &&
                                _vm.promoMsgFromApi !== null
                            )?_c('span',[_vm._v(_vm._s(_vm.promoMsgFromApi))]):_c('div',[_vm._v("\n                            Promo applied: "),_c('strong',[_vm._v(_vm._s(_vm.promoCode))])]),_vm._v(" "),_c('span',{staticClass:"c-promo-code__close",attrs:{"role":"button"},on:{"click":_vm.closePromoCodeAppliedDisplay}},[_vm._v("×")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-promo-code"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-promo-code",modifiers:{"collapse-promo-code":true}}],staticClass:"c-promo-code__btn btn--select w-100",on:{"keydown":function($event){return _vm.onPromoCodeKeydown($event)}}},[_vm._v(_vm._s(_vm.promomsg))]),_vm._v(" "),_c('b-collapse',{staticClass:"c-promo-code__content",attrs:{"id":"collapse-promo-code"},model:{value:(_vm.promoVisible),callback:function ($$v) {_vm.promoVisible=$$v},expression:"promoVisible"}},[_c('form',{ref:"formpromo",staticClass:"form-inline",attrs:{"name":"form-promo-code","action":"","aria-autocomplete":"none"},on:{"submit":function($event){$event.preventDefault();return _vm.onPromoCodeSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"sr-only",attrs:{"for":"inputPromoCode"}},[_vm._v("Promo Code")]),_vm._v(" "),_c('input',{staticClass:"form-control input--small",attrs:{"type":"text","id":"inputPromoCode","placeholder":"Enter promo code","aria-autocomplete":"none","required":""}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                                Add\n                            ")])])])],1)])]),_vm._v(" "),_c('hr',{staticClass:"my-4 bg-primary mt-2 mb-2"}),_vm._v(" "),_c('div',{staticClass:"row d-block"},[_c('div',{staticClass:"col-sm"},[_c('div',{staticClass:"new-tier-navigation"},[_c('div',{staticClass:"row nav nav-pills nav-justified align-items-stretch justify-content-center",attrs:{"id":"pills-tab"}},_vm._l((_vm.tiers),function(tier,index){return _c('div',{key:tier.id,class:((tier.code) + " flex-even col-md-* com-sm-* col-xs-12"),style:({
                                display:
                                    tier.code === 'GM' ? 'none' : 'block',
                            }),attrs:{"tierid":tier.id,"tiercode":("" + (tier.code))},on:{"click":function($event){return _vm.handleSelectTier(tier.id)}}},[_c('div',{staticClass:"new-tier-card",attrs:{"tiercode":("" + (tier.code))}},[_c('div',{staticClass:"new-tier-img"},[_c('img',{attrs:{"src":tier.imageUrl,"alt":((tier.displayName) + " image")}}),_vm._v(" "),(tier.code === 'PP')?_c('div',{staticClass:"most-chosen-membership"},[_vm._v("\n                                        #1 Most Chosen membership\n                                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"new-tier-header"},[_c('h2',[_vm._v(_vm._s(tier.displayName))])]),_vm._v(" "),_c('div',{staticClass:"new-tier-caption"},[_vm._v("\n                                    "+_vm._s(tier.description)+"\n                                ")]),_vm._v(" "),(tier.discountPrice !== null)?_c('div',{staticClass:"new-tier-price-tag"},[_c('div',{staticClass:"strikethrough d-sm-block"},[_c('span',[_vm._v("$"+_vm._s(tier.price)+"/yr")])]),_vm._v(" "),_c('div',{staticClass:"new-tier-price-tag-discount-price"},[_c('sup',[_vm._v("$")]),_vm._v(_vm._s(tier.discountPrice)+"/"),_c('sub',[_vm._v("yr")])])]):_c('div',{staticClass:"new-tier-price-tag"},[_c('sup',[_vm._v("$")]),_vm._v(_vm._s(tier.price)+"/"),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper join-renew"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup mb-4",class:{
                                            disabled:
                                                _vm.orderinprogress ||
                                                _vm.disableSignup,
                                        },attrs:{"data-promo-code":("" + _vm.promoCode),"data-tier-id":("" + (tier.id)),"data-tier-code":("" + (tier.code)),"data-term-remaining":("" + (tier.termRemaining)),"href":((_vm.signupUri.base) + "?tierId=" + (tier.id) + "&promoCode=" + (_vm.isPromoCodeValid
                                                ? _vm.promoCode
                                                : null) + "&earlyCareerTerm=" + _vm.earlyCareerTerm + "&ru=" + _vm.referrer + "&flowType=" + _vm.flowType),"aria-disabled":_vm.orderinprogress},on:{"click":function($event){$event.preventDefault();return _vm.onSignUp.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.signUpButtonText))])]),_vm._v(" "),_c('div',{staticClass:"new-tier-feature"},[_c('h3',[_vm._v("Features & Benefits")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(tier.featuresBenefits)}})]),_vm._v(" "),_c('p',{staticClass:"new-tier-additional-benefits col-12",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleAdditionModalBenefits(
                                            tier.code,
                                            tier.benefitDescription,
                                            tier.name
                                        )},"click":function($event){return _vm.handleAdditionModalBenefits(
                                            tier.code,
                                            tier.benefitDescription,
                                            tier.name
                                        )}}},[_c('i',{attrs:{"tabindex":"0"}},[_vm._v("+ View Additional Benefits")])])])])}),0)]),_vm._v(" "),_vm._l((_vm.tiers),function(tier){return _c('div',{key:tier.id,class:((tier.code) + " flex-even"),attrs:{"tierid":tier.id,"tiercode":("" + (tier.code))},on:{"click":function($event){return _vm.handleSelectTier(tier.id)}}},[(tier.code === 'GM')?_c('div',{staticClass:"footer-member-tier row"},[_c('div',{staticClass:"footer-header"},[_vm._v("\n                            LOOKING FOR A BASIC PROFESSIONAL OPTION WITH\n                            LIMITED BENEFITS?\n                        ")]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center custom-space"},[_c('div',{staticClass:"footer-left-content col-xs-12 col-md-* col-sm-*"},[_c('div',{staticClass:"new-tier-header"},[_c('h2',[_vm._v(_vm._s(tier.displayName))])]),_vm._v(" "),_c('div',{staticClass:"new-tier-caption"},[_vm._v("\n                                    "+_vm._s(tier.description)+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"btn-wrapper join-renew"},[_c('a',{staticClass:"btn btn-primary btn-round btn-block btn--signup",class:{
                                            disabled:
                                                _vm.orderinprogress ||
                                                _vm.disableSignup,
                                        },attrs:{"data-promo-code":("" + _vm.promoCode),"data-tier-id":("" + (tier.id)),"data-tier-code":("" + (tier.code)),"data-term-remaining":("" + (tier.termRemaining)),"href":((_vm.signupUri.base) + "?tierId=" + (3) + "&promoCode=" + (_vm.isPromoCodeValid
                                                ? _vm.promoCode
                                                : null) + "&earlyCareerTerm=" + _vm.earlyCareerTerm + "&ru=" + _vm.referrer + "&flowType=" + _vm.flowType),"aria-disabled":_vm.orderinprogress},on:{"click":function($event){$event.preventDefault();return _vm.onSignUp.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.signUpButtonText))])]),_vm._v(" "),(tier.discountPrice !== null)?_c('div',[_c('div',{staticClass:"footer-price-caption d-sm-block strikethrough"},[_vm._v("\n                                        Annual fee of General Professional\n                                        membership is\n                                        "),_c('span',[_vm._v(" $"+_vm._s(tier.price)+"/yr ")]),_vm._v("  "),_c('b',[_vm._v("$"+_vm._s(tier.discountPrice)+"/"),_c('sub',[_vm._v("yr")])])])]):_c('div',[_c('div',{staticClass:"footer-price-caption"},[_vm._v("\n                                        Annual fee of General Professional\n                                        membership is $"+_vm._s(tier.price)+"/"),_c('span',[_vm._v("yr.")])])])]),_vm._v(" "),_c('div',{staticClass:"footer-right-content col-xs-12 col-md-6 col-sm-6"},[_c('div',{staticClass:"new-tier-feature"},[_c('h3',[_vm._v("Features & Benefits")]),_vm._v(" "),_c('div',{staticClass:"feature-benefits",domProps:{"innerHTML":_vm._s(tier.featuresBenefits)}})]),_vm._v(" "),_c('p',{staticClass:"new-tier-additional-benefits col-12",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleAdditionModalBenefits(
                                            tier.code,
                                            tier.benefitDescription,
                                            tier.name
                                        )},"click":function($event){return _vm.handleAdditionModalBenefits(
                                            tier.code,
                                            tier.benefitDescription,
                                            tier.name
                                        )}}},[_c('i',{attrs:{"tabindex":"0"}},[_vm._v("+ View Additional Benefits")])])])])]):_vm._e()])})],2)]),_vm._v(" "),_c('aha-modal',{staticClass:"st-membership-modal",attrs:{"id":"st-membership-modal","hide-footer":"","centered":"","title":"Student Trainee Modal"}},[_c('h2',{staticClass:"text-center"},[_vm._v("Student/Trainee")]),_vm._v(" "),_c('label',{staticClass:"mb-2 mt-2",attrs:{"for":"dropdown"}},[_vm._v("Please provide your graduation year or fellowship\n                completion year, whichever is latest.")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOption),expression:"selectedOption"}],staticClass:"custom-select btn--select",attrs:{"id":"dropdown"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedOption=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleDropdownChange]}},_vm._l((_vm.dropdownOptions),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v("\n                    "+_vm._s(option.label)+"\n                ")])}),0),_vm._v(" "),(_vm.studentModal)?_c('span',{staticClass:"field-validation-error"},[_vm._v("Please provide your graduation year or fellowship\n                completion year, whichever is latest.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('button',{staticClass:"btn btn-outline mr-2 w-100 custom-btn-focus",on:{"click":function($event){return _vm.$root.$emit(
                            'bv::hide::modal',
                            'st-membership-modal',
                            $event.target
                        )}}},[_vm._v("\n                    Go Back\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary w-100 checked-continue custom-btn-focus",attrs:{"href":_vm.studentModal ? '#' : _vm.signupUri.default},on:{"click":_vm.studentTraineeDropDown}},[_vm._v("Continue")])])]),_vm._v(" "),_c('aha-modal',{ref:"ec-modal",staticClass:"ec-membership-modal",attrs:{"id":"ec-membership-modal","hide-footer":"","centered":"","title":"Early Career Modal"}},[_c('h2',{staticClass:"text-center"},[_vm._v("Early Career")]),_vm._v(" "),_c('fieldset',[_c('legend',{staticClass:"h6"},[_vm._v("\n                    Please indicate number of years since completion of\n                    training:\n                ")]),_vm._v(" "),_vm._l((4),function(i){return _c('div',{key:i,staticClass:"custom-control custom-radio"},[_c('div',[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","id":("term" + i),"name":"earlyCareerTerm1"},domProps:{"value":i},on:{"change":function($event){return _vm.setEarlyCareerTerm(i)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("term" + i)}},[_vm._v(_vm._s(i))]),_vm._v(" "),(_vm.earlyCareerTermValidation)?_c('span',{staticClass:"field-validation-error"},[_vm._v("Please select the early career value")]):_vm._e()])])})],2),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('button',{staticClass:"btn btn-outline mr-2 w-100 custom-btn-focus",on:{"click":function($event){return _vm.$root.$emit(
                            'bv::hide::modal',
                            'ec-membership-modal',
                            $event.target
                        )}}},[_vm._v("\n                    Go Back\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary w-100 ec-continue custom-active-focus",attrs:{"href":_vm.earlyCareerTermValidation ? '#' : _vm.signupUri.default},on:{"click":_vm.earlyCarrerTermSelector}},[_vm._v("Continue")])])]),_vm._v(" "),_c('aha-modal',{staticClass:"gp-upgrade-modal",attrs:{"id":"gp-upgrade-modal","hide-footer":"","centered":"","title":"General Professional Upgrade Modal"}},[_c('h2',{staticClass:"text-center"},[_vm._v("Did You Know?")]),_vm._v(" "),_c('p',{},[_vm._v("\n                Select Premium Professional and receive even more benefits\n                including 11 free online journals and an additional council.\n            ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-4"},[_c('a',{staticClass:"btn btn-outline mr-2 w-100 custom-btn-focus",attrs:{"href":_vm.signupUri.default}},[_vm._v("No Thanks")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary w-100 custom-active-focus",attrs:{"href":_vm.signupUri.upgrade}},[_vm._v("Accept")])])])],1),_vm._v(" "),_c('aha-modal',{ref:"ec-modal",staticClass:"ec-membership-modal",attrs:{"id":"ecTwo-membership-featureBenfits-modal","hide-footer":"","centered":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.membershipContent)}})]),_vm._v(" "),_c('aha-modal',{ref:"ec-modal",staticClass:"ec-membership-modal",attrs:{"id":"ps-membership-featureBenfits-modal","hide-footer":"","centered":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.membershipContent)}})]),_vm._v(" "),_c('aha-modal',{ref:"ec-modal",staticClass:"ec-membership-modal",attrs:{"id":"pp-membership-featureBenfits-modal","hide-footer":"","centered":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.membershipContent)}})]),_vm._v(" "),_c('aha-modal',{ref:"ec-modal",staticClass:"ec-membership-modal",attrs:{"id":"gm-membership-featureBenfits-modal","hide-footer":"","centered":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.membershipContent)}})]),_vm._v(" "),_c('aha-modal',{ref:"ec-modal",staticClass:"ec-membership-modal",attrs:{"id":"st-membership-featureBenfits-modal","hide-footer":"","centered":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.membershipContent)}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('sub',[_vm._v("yr")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b793dd4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_display_checkbox_vue__ = __webpack_require__(539);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_phd_display_checkbox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b793dd4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_phd_display_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClasses,on:{"click":_vm.toggleChecked,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.toggleChecked.apply(null, arguments)}}},[_c('span',_vm._b({class:_vm.checkClass},'span',_vm.containerAttributes,false),[_c('i',{staticClass:"icon-check"})]),_vm._v(" "),_c('div',{attrs:{"id":_vm.checkboxId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a1d4ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_education_activities_list_vue__ = __webpack_require__(541);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_education_activities_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a1d4ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_education_activities_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PHD__article-link-container"},_vm._l((_vm.apiData.slice(0, _vm.numbertoshow)),function(item,index){return _c('div',{key:index,staticClass:"article-link__item"},[_c('a',{staticClass:"PHD__article-link PHD__article-link--large",attrs:{"href":item.eventLink},domProps:{"innerHTML":_vm._s(item.eventName)}},[_vm._v("linkText")]),_vm._v(" "),(item.eventName)?_c('p',{staticClass:"PHD__article-summary",domProps:{"innerHTML":_vm._s(item.eventDescription)}},[_vm._v("Description")]):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0c6dca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_risk_calculator_vue__ = __webpack_require__(545);
function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e0c6dca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_risk_calculator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0c6dca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_risk_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(544);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("fa509b6e", content, true, {});

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".phd-bg--red[data-v-5e0c6dca]{background-color:#d22338}.phd-bg--red-alt[data-v-5e0c6dca]{background-color:#c0161d}.phd-bg--gray-light[data-v-5e0c6dca]{background-color:#f1f1f1}.phd-bg--gray[data-v-5e0c6dca]{background-color:#979797}.phd-bg--gray-mid[data-v-5e0c6dca]{background-color:#6d6e71}.phd-bg--gray-dark[data-v-5e0c6dca]{background-color:#373737}.phd-bg--black[data-v-5e0c6dca]{background-color:#000}.phd-bg--black-alt[data-v-5e0c6dca]{background-color:#050606}.phd-bg--blue[data-v-5e0c6dca]{background-color:#65baf5}.phd-bg--blue-alt[data-v-5e0c6dca]{background-color:#034a80}.phd-bg--mustard[data-v-5e0c6dca]{background-color:#f9b146}.phd-bg--mustard-alt[data-v-5e0c6dca]{background-color:#a7762d}.phd-bg--lime[data-v-5e0c6dca]{background-color:#abd02e}.phd-bg--lime-alt[data-v-5e0c6dca]{background-color:#6b831c}.phd-bg--seafoam[data-v-5e0c6dca]{background-color:#30b6a1}.phd-bg--seafoam-alt[data-v-5e0c6dca]{background-color:#1d7164}.phd-font-color--red[data-v-5e0c6dca]{color:#d22338}.phd-font-color--red-alt[data-v-5e0c6dca]{color:#c0161d}.phd-font-color--gray-light[data-v-5e0c6dca]{color:#f1f1f1}.phd-font-color--gray[data-v-5e0c6dca]{color:#979797}.phd-font-color--gray-mid[data-v-5e0c6dca]{color:#6d6e71}.phd-font-color--gray-dark[data-v-5e0c6dca]{color:#373737}.phd-font-color--black[data-v-5e0c6dca]{color:#000}.phd-font-color--black-alt[data-v-5e0c6dca]{color:#050606}.phd-font-color--blue[data-v-5e0c6dca]{color:#65baf5}.phd-font-color--blue-alt[data-v-5e0c6dca]{color:#034a80}.phd-font-color--mustard[data-v-5e0c6dca]{color:#f9b146}.phd-font-color--mustard-alt[data-v-5e0c6dca]{color:#a7762d}.phd-font-color--lime[data-v-5e0c6dca]{color:#abd02e}.phd-font-color--lime-alt[data-v-5e0c6dca]{color:#6b831c}.phd-font-color--seafoam[data-v-5e0c6dca]{color:#30b6a1}.phd-font-color--seafoam-alt[data-v-5e0c6dca]{color:#1d7164}.phd-link-color--red[data-v-5e0c6dca],.phd-link-color--red[data-v-5e0c6dca]:hover{color:#d22338}.phd-link-color--red-alt[data-v-5e0c6dca],.phd-link-color--red-alt[data-v-5e0c6dca]:hover{color:#c0161d}.phd-link-color--gray-light[data-v-5e0c6dca],.phd-link-color--gray-light[data-v-5e0c6dca]:hover{color:#f1f1f1}.phd-link-color--gray[data-v-5e0c6dca],.phd-link-color--gray[data-v-5e0c6dca]:hover{color:#979797}.phd-link-color--gray-mid[data-v-5e0c6dca],.phd-link-color--gray-mid[data-v-5e0c6dca]:hover{color:#6d6e71}.phd-link-color--gray-dark[data-v-5e0c6dca],.phd-link-color--gray-dark[data-v-5e0c6dca]:hover{color:#373737}.phd-link-color--black[data-v-5e0c6dca],.phd-link-color--black[data-v-5e0c6dca]:hover{color:#000}.phd-link-color--black-alt[data-v-5e0c6dca],.phd-link-color--black-alt[data-v-5e0c6dca]:hover{color:#050606}.phd-link-color--blue[data-v-5e0c6dca],.phd-link-color--blue[data-v-5e0c6dca]:hover{color:#65baf5}.phd-link-color--blue-alt[data-v-5e0c6dca],.phd-link-color--blue-alt[data-v-5e0c6dca]:hover{color:#034a80}.phd-link-color--mustard[data-v-5e0c6dca],.phd-link-color--mustard[data-v-5e0c6dca]:hover{color:#f9b146}.phd-link-color--mustard-alt[data-v-5e0c6dca],.phd-link-color--mustard-alt[data-v-5e0c6dca]:hover{color:#a7762d}.phd-link-color--lime[data-v-5e0c6dca],.phd-link-color--lime[data-v-5e0c6dca]:hover{color:#abd02e}.phd-link-color--lime-alt[data-v-5e0c6dca],.phd-link-color--lime-alt[data-v-5e0c6dca]:hover{color:#6b831c}.phd-link-color--seafoam[data-v-5e0c6dca],.phd-link-color--seafoam[data-v-5e0c6dca]:hover{color:#30b6a1}.phd-link-color--seafoam-alt[data-v-5e0c6dca],.phd-link-color--seafoam-alt[data-v-5e0c6dca]:hover{color:#1d7164}.ecc-bg--cor-1[data-v-5e0c6dca]{background-color:#67bf80}.ecc-bg--cor-2a[data-v-5e0c6dca]{background-color:#ffd643}.ecc-bg--cor-2b[data-v-5e0c6dca]{background-color:#f1a63e}.ecc-bg--cor-3nobenefit[data-v-5e0c6dca]{background-color:#ef6e5d}.ecc-bg--cor-3harm[data-v-5e0c6dca]{background-color:#e71e26}.ecc-bg--loe-br[data-v-5e0c6dca]{background-color:#5c99cf}.ecc-bg--loe-cld[data-v-5e0c6dca]{background-color:#9cbfe2}.ecc-bg--loe-a[data-v-5e0c6dca]{background-color:#3776c8}.ecc-bg--loe-bnr[data-v-5e0c6dca]{background-color:#5b99d1}.ecc-bg--loe-ceo[data-v-5e0c6dca]{background-color:#bdd3ea}.ecc-bg--gray[data-v-5e0c6dca]{background-color:#ebebeb}.ecc-bg--white[data-v-5e0c6dca]{background-color:#fff}.ecc-bg--black[data-v-5e0c6dca]{background-color:#000}.ecc-font-color--cor-1[data-v-5e0c6dca]{color:#67bf80}.ecc-font-color--cor-2a[data-v-5e0c6dca]{color:#ffd643}.ecc-font-color--cor-2b[data-v-5e0c6dca]{color:#f1a63e}.ecc-font-color--cor-3nobenefit[data-v-5e0c6dca]{color:#ef6e5d}.ecc-font-color--cor-3harm[data-v-5e0c6dca]{color:#e71e26}.ecc-font-color--loe-br[data-v-5e0c6dca]{color:#5c99cf}.ecc-font-color--loe-cld[data-v-5e0c6dca]{color:#9cbfe2}.ecc-font-color--loe-a[data-v-5e0c6dca]{color:#3776c8}.ecc-font-color--loe-bnr[data-v-5e0c6dca]{color:#5b99d1}.ecc-font-color--loe-ceo[data-v-5e0c6dca]{color:#bdd3ea}.ecc-font-color--gray[data-v-5e0c6dca]{color:#ebebeb}.ecc-font-color--white[data-v-5e0c6dca]{color:#fff}.ecc-font-color--black[data-v-5e0c6dca]{color:#000}.c-aha-form textarea[data-v-5e0c6dca],textarea.form-control[data-v-5e0c6dca]{padding:10px;min-height:100px}.lower[data-v-5e0c6dca]{margin-top:45px}@media (min-width:576px){.lower[data-v-5e0c6dca]{margin-top:50px}}a.icon[data-v-5e0c6dca]{width:30px;height:30px;background:#c10e21;border-radius:50%;border:thin solid #c10e21;color:#fff;font-weight:700;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}a.icon[data-v-5e0c6dca]:hover{color:#fff}#recommendation[data-v-5e0c6dca],#risk[data-v-5e0c6dca],.toolTip[data-v-5e0c6dca]{background-color:#e9ecef;opacity:1;padding:1rem .75rem;font-size:1rem;line-height:1.5;color:#495057;background-clip:padding-box;border:1px solid #c4cacf;border-radius:2px;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}", ""]);

// exports


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phd-risk-calculator"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 h-100"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.hcmCalculatorFormula.apply(null, arguments)}}},[_c('h2',[_vm._v(" Hypertrophic Cardiomyopathy - Sudden Cardiac Death Risk Calculator")]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_c('label',{staticClass:"col-form-label",attrs:{"for":"age"}},[_vm._v("Age ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.age_range.value),expression:"age_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"age","placeholder":"16-80","aria-describedby":"ageyears"},domProps:{"value":(_vm.age_range.value)},on:{"blur":[_vm.validateAge,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.age_range, "value", _vm._n($event.target.value))}}}),_vm._v(" "),(_vm.isAgeValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.age_range.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.isAgeRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.age_range.requiredMessage))]):_vm._e(),_vm._v(" "),(!_vm.ageToolTip)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Age at evaluation in years (≥ 16 years of age).")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('p',{staticClass:"float-left",attrs:{"id":"ageyears"}},[_vm._v("years")]),_vm._v(" "),_c('a',{key:"age-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for age"},on:{"click":function($event){_vm.ageToolTip = !_vm.ageToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.mlvwt_range.value),expression:"mlvwt_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"mlvwt","placeholder":"10-35","aria-describedby":"mm-value"},domProps:{"value":(_vm.mlvwt_range.value)},on:{"blur":[_vm.validateMlvwt,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.mlvwt_range, "value", _vm._n($event.target.value))}}}),_vm._v(" "),(_vm.isMlvwtValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.mlvwt_range.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.isMlvwtRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.mlvwt_range.requiredMessage))]):_vm._e(),_vm._v(" "),(!_vm.mlvwtToolTip)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Wall thickness ≥ 30 millimeter in\n                                    any segment within the chamber by echocardiography or "),_vm._m(1),_vm._v(" imaging is\n                                    Massive "),_vm._m(2),_vm._v("; consideration\n                                    for this morphologic marker is also given to borderline values of ≥ 28 millimeter\n                                    in individual patients at the discretion of the treating cardiologist.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_vm._m(3),_vm._v(" "),_c('a',{key:"mlvwt-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Maximal left ventricular wall thickness"},on:{"click":function($event){_vm.mlvwtToolTip = !_vm.mlvwtToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.lasize_range.value),expression:"lasize_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"la-size","placeholder":"28-67","aria-describedby":"mm-value"},domProps:{"value":(_vm.lasize_range.value)},on:{"blur":[_vm.validateLasize,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lasize_range, "value", _vm._n($event.target.value))}}}),_vm._v(" "),(_vm.isLasizeValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.lasize_range.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.isLasizeRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.lasize_range.requiredMessage))]):_vm._e(),_vm._v(" "),(!_vm.lasizeToolTip)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Echocardiographic continuous-wave\n                                  Doppler technique for left atrial diameter size in millimeters.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_c('span',{staticClass:"float-left"},[_vm._v("mm")]),_vm._v(" "),_c('a',{key:"lasize-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Left atrium diameter size"},on:{"click":function($event){_vm.lasizeToolTip = !_vm.lasizeToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('div',{staticClass:"form-row mb-4 align-items-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-6 pl-0 float-left"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model:value.number",value:(_vm.maxlvot_range.value),expression:"maxlvot_range.value",arg:"value",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"max-lvot","placeholder":"2-154","aria-describedby":"mmHg-value"},domProps:{"value":(_vm.maxlvot_range.value)},on:{"blur":[_vm.validateMaxlovt,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.maxlvot_range, "value", _vm._n($event.target.value))}}}),_vm._v(" "),(_vm.isMaxlovtValidate)?_c('p',{staticClass:"text-danger errorMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.maxlvot_range.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.isMaxlvotRequired)?_c('p',{staticClass:"text-danger requiredMessage",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.maxlvot_range.requiredMessage))]):_vm._e(),_vm._v(" "),(!_vm.maxlvotToolTip)?_c('p',{staticClass:"toolTip mt-3",attrs:{"role":"alert"}},[_vm._v("Provocative maneuvers may be\n                                  necessary in patients with low or absent peak resting gradients (i.e., < 30 mm\n                                      Hg) to elicit the presence of "),_vm._m(6),_vm._v(",\n                                      particularly in patients with symptoms. Such maneuvers include standing,\n                                      Valsalva strain, amyl nitrite inhalation, or exercise (fasted or\n                                      postprandial), with simultaneous echocardiography performed using\n                                      continuous-wave Doppler technique to document the relation of the gradient\n                                      to occurrence of systolic anterior motion of the mitral valve.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-left clearfix lower"},[_vm._m(7),_vm._v(" "),_c('a',{key:"maxlvot-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Left ventricular outflow tract obstruction"},on:{"click":function($event){_vm.maxlvotToolTip = !_vm.maxlvotToolTip}}},[_vm._v("i")])])])]),_vm._v(" "),_c('fieldset',{staticClass:"mt-5"},[_c('legend',{staticClass:"sr-only"},[_vm._v("Risk Factors for Sudden Cardiac Death")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"fhscd_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fhscd_pick),expression:"fhscd_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"fhscd","id":"fhscd_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbrfhscd"},domProps:{"checked":_vm._q(_vm.fhscd_pick,_vm._n("0"))},on:{"change":function($event){_vm.fhscd_pick=_vm._n("0")}}}),_vm._v(" No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"fhscd_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.fhscd_pick),expression:"fhscd_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"fhscd","id":"fhscd_yes","autocomplete":"off","value":"1","aria-describedby":"abbrfhscd"},domProps:{"checked":_vm._q(_vm.fhscd_pick,_vm._n("1"))},on:{"change":function($event){_vm.fhscd_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"fhscd-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Family History of Sudden Cardiac Death"},on:{"click":function($event){_vm.fhscdToolTip = !_vm.fhscdToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.fhscdToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Sudden death judged definitively or likely\n                                      attributable to "),_vm._m(9),_vm._v(" in ≥ 1\n                                      first-degree or close relatives who are ≤ 50 years of age. Close relatives\n                                          would generally be second-degree relatives; however, multiple SCDs in\n                                          tertiary relatives should also be considered relevant.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"nsvt_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.nsvt_pick),expression:"nsvt_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"nsvt","id":"nsvt_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbrnsvt"},domProps:{"checked":_vm._q(_vm.nsvt_pick,_vm._n("0"))},on:{"change":function($event){_vm.nsvt_pick=_vm._n("0")}}}),_vm._v(" No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"nsvt_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.nsvt_pick),expression:"nsvt_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"nsvt","id":"nsvt_yes","autocomplete":"off","value":"1","aria-describedby":"abbrnsvt"},domProps:{"checked":_vm._q(_vm.nsvt_pick,_vm._n("1"))},on:{"change":function($event){_vm.nsvt_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"nsvt-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Non-sustained ventricular tachycardia"},on:{"click":function($event){_vm.nsvtToolTip = !_vm.nsvtToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.nsvtToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("It would seem most appropriate to place\n                                      greater weight on NSVT as a risk marker when runs are frequent (≥ 3), longer\n                                      (≥ 10 beats), and faster (≥ 200 bpm) occurring usually over 24 to 48 hours of\n                                      monitoring.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label"},[_vm._v(" Unexplained Syncope")]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"unexSy_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.unexSy_pick),expression:"unexSy_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"unexSy","id":"unexSy_no","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.unexSy_pick,_vm._n("0"))},on:{"change":function($event){_vm.unexSy_pick=_vm._n("0")}}}),_vm._v("\n                                          No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"unexSy_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.unexSy_pick),expression:"unexSy_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"unexSy","id":"unexSy_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.unexSy_pick,_vm._n("1"))},on:{"change":function($event){_vm.unexSy_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"unexsy-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Unexplained Syncope"},on:{"click":function($event){_vm.unexSyToolTip = !_vm.unexSyToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.unexSyToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Greater than or equal to 1 unexplained\n                                      episodes involving acute transient loss of consciousness, judged by history\n                                      unlikely to be of neurocardiogenic (vasovagal) etiology, nor attributable to\n                                      LVOTO, and especially when occurring within 6 months of evaluation (events\n                                      beyond 5 years in the past do not appear to have relevance).")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"ef50_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.ef50_pick),expression:"ef50_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"ef50","id":"ef50_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbref"},domProps:{"checked":_vm._q(_vm.ef50_pick,_vm._n("0"))},on:{"change":function($event){_vm.ef50_pick=_vm._n("0")}}}),_vm._v(" No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"ef50_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.ef50_pick),expression:"ef50_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"ef50","id":"ef50_yes","autocomplete":"off","value":"1","aria-describedby":"abbref"},domProps:{"checked":_vm._q(_vm.ef50_pick,_vm._n("1"))},on:{"change":function($event){_vm.ef50_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"ef50-iput",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Ejection fraction"},on:{"click":function($event){_vm.ef50ToolTip = !_vm.ef50ToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.ef50ToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Systolic dysfunction with EF ≤ 50% by\n                                          echocardiography or CMR.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-4 col-form-label"},[_vm._v("Apical Aneurysm")]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"apAn_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.apAn_pick),expression:"apAn_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"apAn","id":"apAn_no","autocomplete":"off","value":"0","checked":""},domProps:{"checked":_vm._q(_vm.apAn_pick,_vm._n("0"))},on:{"change":function($event){_vm.apAn_pick=_vm._n("0")}}}),_vm._v("\n                                          No ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"apAn_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.apAn_pick),expression:"apAn_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"apAn","id":"apAn_yes","autocomplete":"off","value":"1"},domProps:{"checked":_vm._q(_vm.apAn_pick,_vm._n("1"))},on:{"change":function($event){_vm.apAn_pick=_vm._n("1")}}}),_vm._v(" Yes ")]),_vm._v(" "),_c('a',{key:"apan-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Apical Aneurysm"},on:{"click":function($event){_vm.apAnToolTip = !_vm.apAnToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.apAnToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Discrete thin-walled dyskinetic or akinetic\n                                      segment of the most distal portion of the LV chamber; independent of size.\n                                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-8 pr-2"},[_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},[_c('label',{attrs:{"for":"elge_no"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.elge_pick),expression:"elge_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"elge","id":"elge_no","autocomplete":"off","value":"0","checked":"","aria-describedby":"abbr-elge"},domProps:{"checked":_vm._q(_vm.elge_pick,_vm._n("0"))},on:{"change":function($event){_vm.elge_pick=_vm._n("0")}}}),_vm._v(" No \n                                       ")]),_vm._v(" "),_c('label',{staticClass:"ml-4",attrs:{"for":"elge_yes"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.elge_pick),expression:"elge_pick",modifiers:{"number":true}}],attrs:{"type":"radio","name":"elge","id":"elge_yes","autocomplete":"off","value":"1","aria-describedby":"abbr-elge"},domProps:{"checked":_vm._q(_vm.elge_pick,_vm._n("1"))},on:{"change":function($event){_vm.elge_pick=_vm._n("1")}}}),_vm._v(" Yes \n                                    ")]),_vm._v(" "),_c('a',{key:"elge-input",staticClass:"ml-4 icon",attrs:{"aria-label":"tool tip for Extensive Late gadolinium enhancement"},on:{"click":function($event){_vm.elgeToolTip = !_vm.elgeToolTip}}},[_vm._v("i")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(!_vm.elgeToolTip)?_c('p',{staticClass:"toolTip",attrs:{"role":"alert"}},[_vm._v("Diffuse and extensive LGE, representing\n                                      fibrosis, either quantified or estimated by visual inspection, comprising ≥\n                                      15% of LV mass.")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(13),_vm._v(" "),_c('div',[_c('div',{attrs:{"id":"risk","aria-describedby":"abbr-scd"},domProps:{"innerHTML":_vm._s(_vm.risk.value)}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"recommendation"}},[_vm._v("Recommendation")]),_vm._v(" "),_c('div',{attrs:{"id":"recommendation"},domProps:{"innerHTML":_vm._s(_vm.recommendation)}})]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col col-md-12 text-center text-lg-left"},[_c('input',{key:"submit",staticClass:"btn btn-primary",attrs:{"type":"submit","value":"Submit"},on:{"click":_vm.formValidate}}),_vm._v(" "),_c('input',{key:"reset",staticClass:"btn btn-outline ml-3",attrs:{"type":"reset","value":"Reset"},on:{"click":_vm.resetForm}})])])])]),_vm._v(" "),_vm._m(14)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label text-uppercase",attrs:{"for":"mlvwt"}},[_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Maximal left ventricular wall thickness","title":"Maximal left ventricular wall thickness"}},[_vm._v("mlvwt\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Cardiovascular magnetic resonance","title":"Cardiovascular magnetic resonance"}},[_vm._v("CMR")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Left ventricular hypertrophy","title":"Left ventricular hypertrophy"}},[_vm._v("LVH")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"float-left"},[_c('abbr',{attrs:{"id":"mm-value","aria-label":"millimetre","title":"millimetre"}},[_vm._v("mm")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"la-size"}},[_c('span',{staticClass:"abbr",attrs:{"aria-label":"Left atrium"}},[_c('abbr',{attrs:{"title":"Left atrium"}},[_vm._v("LA")])]),_vm._v("\n                              Size\n                              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"max-lvot"}},[_c('span',{staticClass:"abbr",attrs:{"aria-label":"Maximal left ventricular outflow tract gradient"}},[_c('abbr',{attrs:{"title":"Maximal left ventricular outflow tract gradient"}},[_vm._v("Max LVOT\n                                          Gradient")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Left ventricular outflow tract obstruction","title":"Left ventricular outflow tract obstruction"}},[_vm._v("LVOTO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr float-left"},[_c('abbr',{attrs:{"id":"mmHg-value","aria-label":"millimetre of mercury ","title":"millimetre of mercury "}},[_vm._v("mmHg")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label text-uppercase"},[_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"abbrfhscd","aria-label":"Family History of Sudden Cardiac Death","title":"Family History of Sudden Cardiac Death"}},[_vm._v("fh scd")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Hypertrophic cardiomyopathy","title":"Hypertrophic cardiomyopathy"}},[_vm._v("HCM")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label text-uppercase"},[_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"abbrnsvt","aria-label":"Non-sustained ventricular tachycardia","title":"Non-sustained ventricular tachycardia"}},[_vm._v("nsvt")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label"},[_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"abbref","aria-label":"Ejection fraction","title":"Ejection fraction"}},[_vm._v("EF")])]),_vm._v("\n                                  ≤ 50% \n                              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-form-label"},[_vm._v("Extensive "),_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"aria-label":"Late gadolinium enhancement","id":"abbr-elge","title":"Late gadolinium enhancement"}},[_vm._v("LGE")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label",attrs:{"for":"risk"}},[_vm._v("Risk of "),_c('span',{staticClass:"abbr"},[_c('abbr',{attrs:{"id":"abbr-scd","aria-label":"Sudden Cardiac Death","title":"Sudden Cardiac Death"}},[_vm._v("SCD")])]),_vm._v(" at 5 years(%)")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('p',[_vm._v("This calculator is for use in patients with hypertrophic cardiomyopathy (HCM) who are ≥ 16 years of age with > 1 major SCD risk factors, estimating 5-year SCD risk may aid patients in understanding the magnitude of their individual risk for SCD to further assist in ICD decision-making.")]),_vm._v(" "),_c('p',[_vm._v("ICD decisions in pediatric patients with HCM are based on ≥ 1 of these major risk factors: family history of HCM SCD, NSVT on ambulatory monitor, massive left ventricular hypertrophy, and unexplained syncope.")]),_vm._v(" "),_c('p',[_vm._v("Children who are 16 to 18 years of age accounted for 2% of the cohort used for the adult-based risk calculator. The low representation of this age group should be considered if calculating risk estimates for patients in this age range.")]),_vm._v(" "),_c('p',[_vm._v("The HCM-SCD Calculator should not be used in:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Pediatric patients (< 16 years)")]),_vm._v(" "),_c('li',[_vm._v("Elite/competitive athletes")]),_vm._v(" "),_c('li',[_vm._v("HCM associated with metabolic diseases (e.g., Anderson-Fabry disease), and syndromes (e.g., Noonan syndrome).")]),_vm._v(" "),_c('li',[_vm._v("Patients with a previous history of aborted SCD or sustained ventricular arrhythmia who should be treated with an ICD for secondary prevention.")])]),_vm._v(" "),_c('p',[_vm._v("Caution should be exercised when assessing the SCD in patients following invasive reduction in left ventricular outflow tract obstruction with myectomy or alcohol septal ablation.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _eccReferences = __webpack_require__(547);

var _eccReferences2 = _interopRequireDefault(_eccReferences);

var _svgMap = __webpack_require__(549);

var _svgMap2 = _interopRequireDefault(_svgMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_vue2['default'].component('ecc-references', _eccReferences2['default']); // ECC Components

_vue2['default'].component('svg-map', _svgMap2['default']);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d63e218a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_references_vue__ = __webpack_require__(548);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ecc_references_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d63e218a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ecc_references_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"eccReferences",staticClass:"ecc-references"},[_c('div',{staticClass:"container ecc-references__container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',[_vm._v("References")]),_vm._v(" "),(_vm.references.length)?_c('ol',{staticClass:"ecc-references__list"},_vm._l((_vm.references),function(item){return _c('li',{key:item.id,ref:item.id,refInFor:true,staticClass:"ecc-references__list-item",class:{ active: _vm.activeId === item.id },attrs:{"id":item.id}},[_c('button',{staticClass:"ecc-references__list-item-button",attrs:{"aria-label":"Return to text."},on:{"click":_vm.returnToText}},[_c('img',{attrs:{"src":"/assets/icons/up-arrow.svg","aria-hidden":"true"}})]),_vm._v(" "),_c('div',[_c('span',{staticClass:"ecc-references__list-item-number"},[_vm._v(_vm._s(item.refnum)+".")]),_vm._v(" "),_c('div',{staticClass:"ecc-references__list-item-content",domProps:{"innerHTML":_vm._s(item.content)}})])])}),0):_c('p',[_vm._v("Empty data was passed to the 'references' property for this component.")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad40e14c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_svg_map_vue__ = __webpack_require__(550);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_svg_map_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad40e14c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_svg_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.amchartsPresent && _vm.mapDataPresent)?_c('div',{staticClass:"c-svg-map"},[(_vm.mapSettings.showAccessibleStateSelector)?_c('div',{staticClass:"d-flex pb-2"},[_c('select',{ref:"stateselector",staticClass:"c-svg-map__state-selector mr-3",attrs:{"id":"svg-map-state-selector","aria-label":"Select a state to display details."}},[_c('option',{attrs:{"value":""},domProps:{"innerHTML":_vm._s(_vm.mapSettings.blankSelectorOptionLabel)}}),_vm._v(" "),_vm._l((_vm.statesList),function(state){return _c('option',{key:state.id,domProps:{"value":state.id,"innerHTML":_vm._s(state.name)}})})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-primary c-svg-map__state-selector-button",on:{"click":_vm.selectState}},[_vm._v(_vm._s(_vm.mapSettings.selectorButtonLabel))])]):_vm._e(),_vm._v(" "),_c('div',{ref:"chartdiv",style:({ height: this.mapSettings.mapHeight })})]):(!_vm.amchartsPresent && _vm.mapDataPresent)?_c('div',{staticClass:"c-svg-map__error"},[_c('p',[_vm._v("JavaScript Mapping Code Not Present. Could not draw the map.")])]):(_vm.amchartsPresent && !_vm.mapDataPresent)?_c('div',{staticClass:"c-svg-map__error"},[_c('p',[_vm._v("Mapping data not present. Could not draw the map.")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _hcxfPublicationFacets = __webpack_require__(552);

var _hcxfPublicationFacets2 = _interopRequireDefault(_hcxfPublicationFacets);

var _hcxfPublicationSearchResults = __webpack_require__(556);

var _hcxfPublicationSearchResults2 = _interopRequireDefault(_hcxfPublicationSearchResults);

var _hcxfPublicationStatus = __webpack_require__(559);

var _hcxfPublicationStatus2 = _interopRequireDefault(_hcxfPublicationStatus);

var _hcxfPublicationHub = __webpack_require__(561);

var _hcxfPublicationHub2 = _interopRequireDefault(_hcxfPublicationHub);

var _hcxfPublicationDetails = __webpack_require__(568);

var _hcxfPublicationDetails2 = _interopRequireDefault(_hcxfPublicationDetails);

var _hcxfPractitionerMap = __webpack_require__(570);

var _hcxfPractitionerMap2 = _interopRequireDefault(_hcxfPractitionerMap);

var _hcxfPractitionerResults = __webpack_require__(572);

var _hcxfPractitionerResults2 = _interopRequireDefault(_hcxfPractitionerResults);

var _hcxfPractitionerHub = __webpack_require__(575);

var _hcxfPractitionerHub2 = _interopRequireDefault(_hcxfPractitionerHub);

var _hcxfPublicationDetailsFacets = __webpack_require__(581);

var _hcxfPublicationDetailsFacets2 = _interopRequireDefault(_hcxfPublicationDetailsFacets);

var _hcxfResearchFacets = __webpack_require__(583);

var _hcxfResearchFacets2 = _interopRequireDefault(_hcxfResearchFacets);

var _hcxfResearchHub = __webpack_require__(587);

var _hcxfResearchHub2 = _interopRequireDefault(_hcxfResearchHub);

var _hcxfResearchSearchResults = __webpack_require__(589);

var _hcxfResearchSearchResults2 = _interopRequireDefault(_hcxfResearchSearchResults);

var _hcxfResearchStatus = __webpack_require__(592);

var _hcxfResearchStatus2 = _interopRequireDefault(_hcxfResearchStatus);

var _hcxfResearchHubDetails = __webpack_require__(594);

var _hcxfResearchHubDetails2 = _interopRequireDefault(_hcxfResearchHubDetails);

var _hcxfNews = __webpack_require__(596);

var _hcxfNews2 = _interopRequireDefault(_hcxfNews);

var _hcxfNewsStatus = __webpack_require__(600);

var _hcxfNewsStatus2 = _interopRequireDefault(_hcxfNewsStatus);

var _hcxfNewsResults = __webpack_require__(602);

var _hcxfNewsResults2 = _interopRequireDefault(_hcxfNewsResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_vue2['default'].component('hcxf-publication-facets', _hcxfPublicationFacets2['default']);
_vue2['default'].component('hcxf-publication-search-results', _hcxfPublicationSearchResults2['default']);
_vue2['default'].component('hcxf-publication-status', _hcxfPublicationStatus2['default']);
_vue2['default'].component('hcxf-publication-hub', _hcxfPublicationHub2['default']);
_vue2['default'].component('hcxf-publication-details', _hcxfPublicationDetails2['default']);
_vue2['default'].component('hcxf-publication-details-facets', _hcxfPublicationDetailsFacets2['default']);

_vue2['default'].component('hcxf-practitioner-map', _hcxfPractitionerMap2['default']);
_vue2['default'].component('hcxf-practitioner-results', _hcxfPractitionerResults2['default']);
_vue2['default'].component('hcxf-practitioner-hub', _hcxfPractitionerHub2['default']);

_vue2['default'].component('hcxf-research-facets', _hcxfResearchFacets2['default']);
_vue2['default'].component('hcxf-research-hub', _hcxfResearchHub2['default']);
_vue2['default'].component('hcxf-research-search-results', _hcxfResearchSearchResults2['default']);
_vue2['default'].component('hcxf-research-status', _hcxfResearchStatus2['default']);
_vue2['default'].component('hcxf-research-hub-details', _hcxfResearchHubDetails2['default']);

_vue2['default'].component('hcxf-news', _hcxfNews2['default']);
_vue2['default'].component('hcxf-news-status', _hcxfNewsStatus2['default']);
_vue2['default'].component('hcxf-news-results', _hcxfNewsResults2['default']);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_facets_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_facets_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_facets_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_facets_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_facets_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba75f7fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_facets_vue__ = __webpack_require__(555);
function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_facets_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba75f7fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_facets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(554);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("100ebd2a", content, true, {});

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"facets"}},[_c('atomic-facet-manager',[_c('atomic-facet',{attrs:{"field":"publicationhubkeywords","label":"Keyword","display-values-as":"link"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_search_results_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_search_results_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_search_results_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_search_results_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_search_results_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3579211f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_search_results_vue__ = __webpack_require__(558);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_search_results_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3579211f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_search_results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = "<template>\r\n    <style>\r\n        .result-link {\r\n            a {\r\n                &:hover, &:visited {\r\n                    text-decoration: none;\r\n                    color: inherit;\r\n                }\r\n            }\r\n        }\r\n\r\n        .category {\r\n            text-transform: uppercase;\r\n            font-weight: 700;\r\n        }\r\n        \r\n        .category, .title {\r\n            color: var(--Accent-Accent-Blue, #042358);\r\n            font-family: Montserrat;\r\n            font-size: 13px;\r\n            font-style: normal;\r\n            line-height: normal;\r\n        }\r\n\r\n        .category::part(result-multi-value-text-list){\r\n            flex-wrap: wrap;\r\n        }\r\n\r\n        .description {\r\n            color: var(--Text-text-default, #000);\r\n            font-family: Montserrat;\r\n            font-size: 16px;\r\n            font-style: normal;\r\n            font-weight: 400;\r\n            line-height: 24px;\r\n        }\r\n\r\n        .title {\r\n            font-size: 20px;\r\n            font-weight: 600;\r\n        }\r\n\r\n        .card-container {\r\n            padding-inline: 10px;\r\n        }\r\n\r\n        @media (min-width: 768px) {\r\n            .card-container {\r\n                padding-inline: 0;\r\n            }\r\n        }\r\n    </style>\r\n    <atomic-result-link href-template='${clickUri}' class=\"result-link\" >\r\n        <div class=\"card-container\">\r\n            <atomic-result-fields-list>\r\n                <atomic-field-condition if-defined=\"publicationhubkeywords\">\r\n                    <atomic-result-multi-value-text class=\"category text-uppercase\"  field=\"publicationhubkeywords\"></atomic-result-text>\r\n                </atomic-field-condition>\r\n        \r\n                <atomic-field-condition if-defined=\"title\">\r\n                    <atomic-result-text class=\"title\"  field=\"title\"></atomic-result-text>\r\n                </atomic-field-condition>\r\n        \r\n                <atomic-field-condition if-defined=\"summary\">\r\n                    <atomic-result-text class=\"description\"  field=\"summary\"></atomic-result-text>\r\n                </atomic-field-condition>\r\n                <atomic-result-text class=\"isExternal\"  field=\"isez120xternallink\" hidden=\"hidden\"></atomic-result-text>\r\n            \r\n            </atomic-result-fields-list>\r\n        </div>\r\n    </atomic-result-link>\r\n</template>\r\n<template slot=\"link\">\r\n    \r\n</template>"

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"results"}},[_c('atomic-smart-snippet'),_vm._v(" "),_c('atomic-smart-snippet-suggestions'),_vm._v(" "),_c('atomic-result-list',{attrs:{"density":"compact","image-size":"none","display":"grid"}},[_c('atomic-result-template',{domProps:{"innerHTML":_vm._s(_vm.hcxfPublicationResultTemplate)}})],1),_vm._v(" "),_c('atomic-query-error'),_vm._v(" "),_c('atomic-no-results')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34432fd4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_status_vue__ = __webpack_require__(560);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34432fd4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"status"}},[_c('atomic-breadbox'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between py-3 align-items-center flex-column flex-md-row"},[_c('query-summary'),_vm._v(" "),_c('atomic-sort-dropdown',{staticClass:"pt-3 pt-md-0"},[_c('atomic-sort-expression',{attrs:{"label":"most-recent","expression":"date descending","state":"active"}}),_vm._v(" "),_c('atomic-sort-expression',{attrs:{"label":"relevance","expression":"relevancy"}})],1)],1),_vm._v(" "),_c('atomic-did-you-mean'),_vm._v(" "),_c('atomic-notifications')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_hub_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_hub_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_hub_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_hub_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_hub_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dea0b790_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_hub_vue__ = __webpack_require__(567);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_hub_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dea0b790_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_hub_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("c57e4c60", content, true, {});

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "atomic-search-interface{grid-template-areas:\". . atomic-section-search .\" \". atomic-section-main atomic-section-facets .\" \". atomic-section-facets . .\"}.container-fluid:has(>.c-listing-header){padding:0}.HCxF .c-listing-header{margin:0;padding:0;padding-top:30px;@media (min-width:768px){padding-top:30px}}", ""]);

// exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(565);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1b5fdf87", content, true, {});

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "atomic-pager::part(page-button){--atomic-primary:#c3c3c3}atomic-pager::part(next-button),atomic-pager::part(page-button),atomic-pager::part(previous-button){width:50px;height:50px;border:1px solid #c3c3c3}atomic-pager::part(active-page-button){--atomic-background:#042358;--atomic-primary:#fff;--atomic-on-background:#fff}atomic-pager::part(active-page-button):focus-visible{background-color:var(--atomic-background)}atomic-pager::part(next-button),atomic-pager::part(previous-button){--atomic-primary:#000}atomic-pager::part(buttons){gap:0}", ""]);

// exports


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"pagination"}},[_c('div',{staticClass:"pagination-container"},[_c('atomic-pager',{attrs:{"name":"pagination"}}),_vm._v(" "),_c('atomic-results-per-page',{staticClass:"d-none",attrs:{"choices-displayed":"12,30,45"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HCxF"},[_c('atomic-search-interface',{staticClass:"publication-hub",attrs:{"fields-to-include":"[\"publicationhubkeywords\", \"summary\",\"isez120xternallink\"]","search-hub":_vm.searchHub}},[_c('atomic-layout-section',{attrs:{"section":"search"}},[_c('div',{staticClass:"search-input-container"},[_c('label',{staticClass:"search-label",attrs:{"for":"search"}},[_vm._v("Search")]),_vm._v(" "),_c('atomic-search-box')],1)]),_vm._v(" "),_c('div',{staticClass:"tab-container"},[_c('custom-tab',{attrs:{"label":_vm.hcxfScienceTabName,"expression":"@publicationz32xassetz32xtype = \"HCxF Science\"","is-active":"true"}}),_vm._v(" "),_c('custom-tab',{attrs:{"label":_vm.ahaScienceTabName,"expression":"@publicationz32xassetz32xtype = \"AHA Science Assets\"","is-active":"false"}}),_vm._v(" "),_c('custom-tab',{attrs:{"label":_vm.evidenceLibraryTabName,"is-active":"false"}})],1),_vm._v(" "),(_vm.tabValue === 'HCXF Science')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.hcxfScienceDetail)}}):(_vm.tabValue === 'AHA Science Assets')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.ahaScienceDetail)}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.evidenceLibraryDetail)}}),_vm._v(" "),_c('div',{staticClass:"row py-4"},[_c('div',{staticClass:"col-lg-9 order-2 order-lg-1"},[_c('atomic-layout-section',{attrs:{"section":"main"}},[_c('hcxf-publication-status'),_vm._v(" "),_c('hcxf-publication-search-results'),_vm._v(" "),_c('div',{staticClass:"atomic-divider"}),_vm._v(" "),_c('coveoPagination')],1)],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 order-1 order-lg-2"},[_c('hcxf-publication-facets')],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e412f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_details_vue__ = __webpack_require__(569);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e412f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HCxF container container-fluid container-wide py-4"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"publication-details__main-content row gx-5"},[_vm._m(1),_vm._v(" "),_c('hcxf-publication-details-facets')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"publication-details__heading-container"},[_c('h1',{staticClass:"publication-details__heading"},[_vm._v("Lorem ipsum dolor sit amet consectetur.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"publication-details__content-container col-12 col-lg-9 order-2 order-lg-1"},[_c('h3',{staticClass:"publication-details__content-heading"},[_vm._v("Lorem ipsum dolor sit amet consectetur")]),_vm._v(" "),_c('section',{staticClass:"publication-details__content-item"},[_c('h2',{staticClass:"publication-details__content-item-heading"},[_vm._v("Lorem ipsum dolor sit amet consectetur.")]),_vm._v(" "),_c('p',{staticClass:"publication-details__content-item-description"},[_vm._v("\n          Lorem ipsum dolor sit amet consectetur. Cum in interdum nulla fermentum.\n          Nunc nisl urna metus lacus gravida. Phasellus est urna est fringilla.\n          Blandit pulvinar eleifend malesuada nibh neque amet. Sed ac nibh cursus\n          at. Fusce varius mauris nullam lacus volutpat. Sem vestibulum justo blandit vel in.\n        ")])]),_vm._v(" "),_c('section',{staticClass:"publication-details__content-item"},[_c('h2',{staticClass:"publication-details__content-item-heading"},[_vm._v("Lorem ipsum dolor sit amet consectetur.")]),_vm._v(" "),_c('p',{staticClass:"publication-details__content-item-description"},[_vm._v("\n          Lorem ipsum dolor sit amet consectetur. Cum in interdum nulla fermentum.\n          Nunc nisl urna metus lacus gravida. Phasellus est urna est fringilla.\n          Blandit pulvinar eleifend malesuada nibh neque amet. Sed ac nibh cursus\n          at. Fusce varius mauris nullam lacus volutpat. Sem vestibulum justo blandit vel in.\n        ")])]),_vm._v(" "),_c('a',{staticClass:"btn-link",attrs:{"href":"#"}},[_vm._v("Read the article")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94edf7b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_practitioner_map_vue__ = __webpack_require__(571);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94edf7b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_practitioner_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"map"}},[_c('div',{staticStyle:{"height":"600px","width":"100%"},attrs:{"id":"hcxf-map"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_results_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_results_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_results_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_results_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_results_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7d9a58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_practitioner_results_vue__ = __webpack_require__(574);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_results_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7d9a58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_practitioner_results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = "<template>\r\n    <style>\r\n        .organization-card {\r\n            border: 1px solid #ddd;\r\n            padding: 20px;\r\n            border-radius: 5px;\r\n            width: 300px;\r\n            background-color: #fff;\r\n            width: 100%;\r\n            padding-bottom: .5rem;\r\n            display: flex;\r\n            flex-direction: column;\r\n        }\r\n\r\n        atomic-result-fields-list {\r\n            flex-direction: column;\r\n            gap: 1rem;\r\n        }\r\n\r\n        atomic-result-fields-list>*::after {\r\n            display: none !important;\r\n        }\r\n\r\n        .active-card {\r\n            border: 1px solid var(--Outlines-Outline-dark, #042358);\r\n            box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.30);\r\n        }\r\n\r\n        .organization-header {\r\n            color: var(--Text-text-title-default, #042358);\r\n            font-family: Montserrat;\r\n            font-size: 18px;\r\n            font-style: normal;\r\n            font-weight: 600;\r\n            line-height: normal;\r\n        }\r\n\r\n        .organization-details, .practitioner-details {\r\n            width: 100%;\r\n            display: flex;\r\n            flex-direction: column;\r\n        }\r\n\r\n        .organization-type, .organization-email, .organization-phone {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: .25rem;\r\n            padding-bottom: 5px;\r\n        }\r\n\r\n        .orgnization-icon {\r\n            height: 24px;\r\n            width: 24px;\r\n        }\r\n\r\n        .remove-after {\r\n            &::after {\r\n                display: none;\r\n            }\r\n        }\r\n    </style>\r\n\r\n    <div class=\"organization-card\">\r\n        <atomic-result-fields-list>\r\n            <div class=\"remove-after\">\r\n                <atomic-result-section-title class=\"remove-after\">\r\n                    <atomic-result-link>\r\n                        <atomic-result-text class=\"organization-header\" field=\"organiz122xationz32xname\" />\r\n                    </atomic-result-link>\r\n                    <atomic-result-text field=\"uniqueId\" style=\"display: none;\" />\r\n                </atomic-result-section-title>\r\n                <div class=\"remove-after\">\r\n                    <atomic-field-condition if-defined=\"practitionerfulladdress\">\r\n                        <atomic-result-text class=\"address\" field=\"practitionerfulladdress\"></atomic-result-text>\r\n                    </atomic-field-condition>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"practitioner-details\">\r\n                <atomic-field-condition if-defined=\"contactz32xname\">\r\n                    <div class=\"remove-after\">\r\n                        <atomic-result-text class=\"name\" field=\"contactz32xname\"></atomic-result-text>\r\n                    </div>\r\n\r\n                    <atomic-field-condition if-defined=\"contactz32xtitle\">\r\n                        <div class=\"remove-after\">\r\n                            <atomic-result-text class=\"title\" field=\"contactz32xtitle\"></atomic-result-text>\r\n                        </div>\r\n                    </atomic-field-condition>\r\n                </atomic-field-condition>\r\n            </div>\r\n\r\n            <div class=\"organization-details\">\r\n                <atomic-field-condition if-defined=\"organiz122xationz32xtype\">\r\n                    <div class=\"organization-type\">\r\n                        <img src=\"-/media/Images/Icons/Dark/building 24\" class=\"orgnization-icon\" alt=\"orgnization-icon\"></img>\r\n                        <atomic-result-text field=\"organiz122xationz32xtype\"></atomic-result-text>\r\n                    </div>\r\n                </atomic-field-condition>\r\n                <atomic-field-condition if-defined=\"email\">\r\n                    <div class=\"organization-email\">\r\n                        <img src=\"-/media/Images/Icons/Dark/122\" class=\"orgnization-icon\"></img>\r\n                        <atomic-result-text class=\"email\" field=\"email\"></atomic-result-text>\r\n                    </div>\r\n                </atomic-field-condition>\r\n                <atomic-field-condition if-defined=\"phone\">\r\n                    <div class=\"organization-phone\">\r\n                        <img src=\"-/media/Project/HCxF/Icons/Phone Icon\" alt=\"phone\" class=\"orgnization-icon\"></img>\r\n                        <atomic-result-text class=\"phone\" field=\"phone\"></atomic-result-text>\r\n                    </div>\r\n                </atomic-field-condition>\r\n            </div>\r\n        </atomic-result-fields-list>\r\n    </div>\r\n</template>\r\n"

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"results"}},[_c('atomic-smart-snippet'),_vm._v(" "),_c('atomic-smart-snippet-suggestions'),_vm._v(" "),_c('atomic-result-list',{attrs:{"density":"compact","display":"list"}},[_c('atomic-result-template',{domProps:{"innerHTML":_vm._s(_vm.defaultResultTemplate)}})],1),_vm._v(" "),_c('atomic-query-error'),_vm._v(" "),_c('atomic-no-results')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_hub_vue__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_hub_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_hub_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_hub_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_hub_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c6f832_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_practitioner_hub_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46c6f832"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_practitioner_hub_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c6f832_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_practitioner_hub_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(577);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("64531bf2", content, true, {});

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "label[for=search][data-v-46c6f832]{color:#000;text-align:center;font-family:Montserrat;font-size:24px;font-style:normal;font-weight:600;line-height:normal;margin-bottom:1rem}", ""]);

// exports


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b3cf17_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_practitioner_facets_vue__ = __webpack_require__(579);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b3cf17_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_practitioner_facets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4"},[_c('atomic-layout-section',{attrs:{"section":"facets"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('dropdown-facet',{attrs:{"label":"Organization Type","field":"organiz122xationz32xtype"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('dropdown-facet',{attrs:{"label":"Territory","field":"practitionerterritory"}})],1)]),_vm._v(" "),_c('atomic-facet-manager',{staticClass:"d-none"},[_c('atomic-facet',{attrs:{"field":"organiz122xationz32xtype","label":"Organization Type","display-values-as":"checkbox"}}),_vm._v(" "),_c('atomic-facet',{attrs:{"field":"practitionerterritory","label":"Territory","display-values-as":"checkbox"}})],1),_vm._v(" "),_c('hr',{staticClass:"publication-search-divider"}),_vm._v(" "),_c('div',{},[_c('query-summary'),_vm._v(" "),_c('atomic-breadbox',{staticClass:"mt-2"})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HCxF"},[_c('atomic-search-interface',{staticClass:"publication-search",attrs:{"id":"searchInterface","fields-to-include":"[\"organiz122xationz32xname\", \"organiz122xationz32xtype\", \"practitionerterritory\", \"practitionerfulladdress\", \"city\", \"country\", \"territory\", \"phone\", \"email\", \"website\", \"contactz32xname\", \"contactz32xtitle\", \"latitude\", \"longitude\",\"z122xipz32xcode\"]","search-hub":_vm.searchHub}},[_c('atomic-layout-section',{attrs:{"section":"search"}},[_c('label',{attrs:{"for":"search"}},[_vm._v("Search")]),_vm._v(" "),_c('atomic-search-box')],1),_vm._v(" "),_c('PractitionerFacets'),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-lg-4"},[_c('hcxf-practitioner-results'),_vm._v(" "),_c('div',{staticClass:"atomic-divider"}),_vm._v(" "),_c('coveoPagination')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 d-none d-lg-block"},[_c('atomic-layout-section',{attrs:{"section":"main"}},[_c('hcxf-practitioner-map')],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_details_facets_vue__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_details_facets_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_details_facets_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_details_facets_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_details_facets_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_922b9d96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_details_facets_vue__ = __webpack_require__(582);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_publication_details_facets_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_922b9d96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_publication_details_facets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"col-lg-3 order-1 order-lg-2"},[_c('aside',{staticClass:"publication-details__sidebar sidebar--mobile d-lg-none"},[_c('label',{staticClass:"publication-details__sidebar-heading",attrs:{"for":"sidebar-heading"},on:{"click":_vm.toggleContent}},[_c('div',[_vm._v("\n            "+_vm._s(_vm.label)+"\n\n            "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M11.9998 4.80005L11.9998 19.2M19.1998 12L4.7998 12","stroke":"black","stroke-width":"2","stroke-linecap":"round"}})])])]),_vm._v(" "),_c('section',{staticClass:"publication-details__sidebar-container"},[(_vm.showContent)?_c('ul',{staticClass:"publication-details__list"},_vm._l((_vm.keywords),function(item,index){return _c('li',{key:index,staticClass:"publication-details__list-item"},[_vm._v(_vm._s(item)+"\n        ")])}),0):_vm._e()])]),_vm._v(" "),_c('aside',{staticClass:"publication-details__sidebar sidebar--desktop d-none d-lg-block"},[_c('label',{staticClass:"publication-details__sidebar-heading",attrs:{"for":"sidebar-heading"}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")]),_vm._v(" "),_c('section',{staticClass:"publication-details__sidebar-container"},[_c('ul',{staticClass:"publication-details__list"},_vm._l((_vm.keywords),function(item,index){return _c('li',{key:index,staticClass:"publication-details__list-item"},[_vm._v(_vm._s(item)+"\n            ")])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_facets_vue__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_facets_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_facets_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_facets_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_facets_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d99da8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_facets_vue__ = __webpack_require__(586);
function injectStyle (ssrContext) {
  __webpack_require__(584)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_facets_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d99da8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_facets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(585);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7100f1da", content, true, {});

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".research-facets-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:4px}", ""]);

// exports


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"facets"}},[_c('div',{staticClass:"research-facets-container"},[_c('atomic-facet',{attrs:{"field":"researchfocus","label":"Research Focus","display-values-as":"checkbox"}}),_vm._v(" "),_c('atomic-facet',{attrs:{"field":"studyz32xstatus","label":"Study Status","display-values-as":"checkbox"}}),_vm._v(" "),_c('atomic-facet',{staticClass:"d-none",attrs:{"field":"researchtype","label":"Research Type","display-values-as":"checkbox"}}),_vm._v(" "),_c('div',{},[_c('radio-facet',{attrs:{"label":"Research Type","field":"researchtype"}})],1),_vm._v(" "),_c('atomic-timeframe-facet',{attrs:{"field":"awardz32xtimelinez32xstartz32xdate","label":"Award Timeline","with-date-picker":""}}),_vm._v(" "),_c('div',{},[_c('atomic-facet',{attrs:{"field":"ResearchHubInstitutionNameWithState","label":"Location","display-values-as":"checkbox"}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_hub_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_hub_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_hub_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_hub_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_hub_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8ac7e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_hub_vue__ = __webpack_require__(588);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_hub_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8ac7e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_hub_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HCxF"},[_c('atomic-search-interface',{staticClass:"container container-fluid research-hub",attrs:{"fields-to-include":"[\"summary\", \"researchfocus\", \"researchtype\", \"studyz32xstatus\", \"awardz32xtimelinez32xstartz32xdate\", \"awardz32xtimelinez32xendz32xdate\",\"ResearchHubInstitutionNameWithState\",\"ResearchHubInstitutionDetail\"]","search-hub":_vm.searchHub}},[_c('atomic-layout-section',{attrs:{"section":"search"}},[_c('div',{staticClass:"search-input-container"},[_c('label',{staticClass:"search-label",attrs:{"for":"search"}},[_vm._v("Search")]),_vm._v(" "),_c('atomic-search-box',{attrs:{"clear-filters":"true"}})],1)]),_vm._v(" "),_c('hr',{staticClass:"research-hub-divider"}),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-lg-3"},[_c('hcxf-research-facets')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-9"},[_c('atomic-layout-section',{attrs:{"section":"main"}},[_c('hcxf-research-status'),_vm._v(" "),_c('hcxf-research-search-results'),_vm._v(" "),_c('coveoPagination')],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_search_results_vue__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_search_results_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_search_results_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_search_results_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_search_results_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f378112_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_search_results_vue__ = __webpack_require__(591);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_research_search_results_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f378112_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_search_results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = "<template>\r\n    <style>\r\n         .result-link {\r\n             a {\r\n                &:hover, &:visited {\r\n                    text-decoration: none;\r\n                    color: inherit;\r\n                }\r\n            }\r\n        }\r\n        .result-item {\r\n            padding-block: 30px;\r\n            border-bottom: 1px solid #c3c3c3;\r\n        }\r\n\r\n        .result-title {\r\n            color: var(--Text-text-title-default, #042358);\r\n            font-family: Montserrat;\r\n            font-size: 20px;\r\n            font-style: normal;\r\n            font-weight: 600;\r\n            line-height: normal;\r\n        }\r\n        \r\n        .result-summary {\r\n            color: var(--Text-text-default, #000);\r\n            font-family: Montserrat;\r\n            font-size: 16px;\r\n            font-style: normal;\r\n            font-weight: 400;\r\n            line-height: 24px;\r\n        }\r\n\r\n        .details-container {\r\n            padding: 10px;\r\n            background-color: #f5f5f5;\r\n            margin-top: 10px;\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 10px;\r\n\r\n            label {\r\n                color: #2E2A2B;\r\n                font-family: Montserrat;\r\n                font-size: 14px;\r\n                font-style: normal;\r\n                font-weight: 700;\r\n                line-height: 20px;\r\n            }\r\n        }\r\n\r\n        .result-pill {\r\n            padding: 4px;\r\n            border-radius: 4px;\r\n            display: flex;\r\n            gap: 5px;\r\n            align-items: center;\r\n            width: max-content;\r\n            margin-bottom: 10px;\r\n        }\r\n\r\n        .complete-pill {\r\n            background-color: #E6E9EE;\r\n        }\r\n\r\n        .active-pill {\r\n            background-color: #EDF6F0;\r\n        }\r\n\r\n        .pending-pill {\r\n            background-color: #FEF7E8;\r\n        }\r\n\r\n        .result-item-container {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 10px;\r\n            margin-bottom: 10px;\r\n        }\r\n\r\n        .row {\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            margin-right: -15px;\r\n            margin-left: -15px;\r\n        }\r\n\r\n        .col-lg-8 {\r\n            flex: 0 0 66.6667%;\r\n            max-width: 66.6667%;\r\n            padding-right: 15px;\r\n            padding-left: 15px;\r\n        }\r\n\r\n        .col-lg-4 {\r\n            flex: 0 0 33.3333%; \r\n            max-width: 33.3333%;\r\n            padding-right: 15px;\r\n            padding-left: 15px;\r\n        }\r\n\r\n        @media (max-width: 992px) {\r\n            .col-lg-8,\r\n            .col-lg-4 {\r\n                flex: 0 0 100%; \r\n                max-width: 100%;\r\n            }\r\n        }\r\n\r\n        custom-location {\r\n            &::part(content-container) {\r\n                color: #2E2A2B;\r\n                font-family: Montserrat;\r\n                font-size: 14px;\r\n                font-style: normal;\r\n                font-weight: 400;\r\n                line-height: 20px;\r\n                display: flex;\r\n                align-items: center;\r\n                flex-wrap: wrap;\r\n            }\r\n\r\n            &::part(container) {\r\n                display: flex;\r\n                flex-direction: column;\r\n            }\r\n\r\n            &::part(show-more-button), &::part(show-less-button) {\r\n                color: #2E2A2B;\r\n                font-family: Montserrat;\r\n                font-size: 14px;\r\n                font-style: italic;\r\n                font-weight: 400;\r\n                line-height: 20px;\r\n                border: none;\r\n                outline: none;\r\n                background-color: transparent;\r\n                cursor: pointer;\r\n                margin-left: 4px;\r\n            }\r\n\r\n            &::part(label) {\r\n                color: #2E2A2B;\r\n                font-family: Montserrat;\r\n                font-size: 14px;\r\n                font-style: normal;\r\n                font-weight: 700;\r\n                line-height: 20px;\r\n            }\r\n        }\r\n\r\n        .detail {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 8px;\r\n        }\r\n\r\n        atomic-result-multi-value-text {\r\n            &::part(result-multi-value-text-separator) {\r\n                display: none;\r\n            }\r\n\r\n            &::part(result-multi-value-text-list) {\r\n                flex-direction: column;\r\n            }\r\n        }\r\n        \r\n        @media (min-width: 768px) {\r\n            custom-location {\r\n                &::part(container){\r\n                    flex-direction: row;\r\n                    gap: 8px;\r\n                    align-items: center;\r\n                }\r\n            }\r\n\r\n            .details-container {\r\n                margin-top: 0;\r\n            }\r\n\r\n            .detail {\r\n                flex-direction: column;\r\n                align-items: start;\r\n                gap: 0;\r\n            }\r\n        }\r\n\r\n        </style>\r\n        <atomic-result-link href-template='${clickUri}' class=\"result-link\" >\r\n      <div class=\"result-item\">\r\n        <!-- Status Badge -->\r\n        <!-- <div class=\"status-badge mb-2\">\r\n          <atomic-result-badge field=\"status\"></atomic-result-badge>\r\n        </div> -->\r\n  \r\n        <!-- Title -->\r\n        <!-- <atomic-result-link class=\"result-title mb-2\">\r\n          <atomic-result-text class=\"result-title\" field=\"title\"></atomic-text>\r\n        </atomic-result-link> -->\r\n\r\n        <atomic-result-section-badges>\r\n\r\n            <!-- Condition for \"Published\" -->\r\n            <atomic-field-condition must-match-studyz32xstatus=\"Published\">\r\n                <div class=\"pending-pill result-pill\">\r\n                    <img src=\"-/media/Project/HCxF/Icons/Red Plus\" alt=\"\">\r\n                    <atomic-result-multi-value-text field=\"studyz32xstatus\"></atomic-result-multi-value-text>\r\n                </div>\r\n            </atomic-field-condition>\r\n\r\n            <!-- Condition for \"Completed\" -->\r\n            <atomic-field-condition must-match-studyz32xstatus=\"Completed\">\r\n                <div class=\"complete-pill result-pill\">\r\n                    <img src=\"-/media/Project/HCxF/Icons/Blue Tick\" alt=\"\">\r\n                    <atomic-result-multi-value-text field=\"studyz32xstatus\"></atomic-result-multi-value-text>\r\n                </div>\r\n            </atomic-field-condition>\r\n            \r\n            <!-- Condition for \"Active\" -->\r\n            <atomic-field-condition must-match-studyz32xstatus=\"Active\">\r\n                <div class=\"active-pill result-pill\">\r\n                    <img src=\"-/media/Project/HCxF/Icons/Green Tick\" alt=\"\">\r\n                    <atomic-result-multi-value-text field=\"studyz32xstatus\"></atomic-result-multi-value-text>\r\n                </div>\r\n            </atomic-field-condition>\r\n          \r\n            \r\n          </atomic-result-section-badges>\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-lg-8\">\r\n                <div class=\"result-item-container\">\r\n                    <atomic-result-text class=\"result-title\" field=\"title\"></atomic-result-text>\r\n                    <atomic-result-text class=\"result-summary\" field=\"summary\"></atomic-result-text>\r\n                    <atomic-result-text class=\"result-summary\"  field=\"bodyz32xtez120xt\"></a<atomic-result-text>\r\n                </div>\r\n                <custom-location label=\"Primary Location\" field=\"researchhubinstitutionnamewithstate\"></custom-location>\r\n            </div>\r\n            <div class=\"col-lg-4\">\r\n                <div class=\"details-container\">\r\n                    <div class=\"detail\">\r\n                        <label for=\"focus\">\r\n                            Research Focus\r\n                        </label>\r\n                        <atomic-result-multi-value-text class=\"researchfocus\" delimiter=\"null\" field=\"researchfocus\"></atomic-result-multi-value-text>\r\n                    </div>\r\n                    <div class=\"detail\">\r\n                        <label for=\"type\">\r\n                            Research Type\r\n                        </label>\r\n                        <atomic-result-multi-value-text field=\"researchtype\"></atomic-result-multi-value-text>\r\n                    </div>\r\n\r\n                    <div class=\"detail\">\r\n                        <label for=\"timeline\">\r\n                            Estimated Timeline\r\n                        </label>\r\n                        <div>\r\n                            <atomic-result-date format=\"MMM-YYYY\" field=\"awardz32xtimelinez32xstartz32xdate\"></atomic-result-date>\r\n                            -\r\n                            <atomic-result-date format=\"MMM-YYYY\" field=\"awardz32xtimelinez32xendz32xdate\"></atomic-result-date>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <!-- Primary Location -->\r\n        <!-- <div class=\"location mb-2\">\r\n          <atomic-show-more-less field=\"location\" maximum-length=\"50\">\r\n            <span class=\"fw-bold\">Primary Location</span>\r\n          </atomic-show-more-less>\r\n        </div> -->\r\n  \r\n        <!-- Research Details -->\r\n        <!-- <div class=\"details p-2 bg-light\">\r\n          <div class=\"detail-item\">\r\n            <span class=\"fw-bold\">Research Focus</span>: \r\n            <atomic-text field=\"researchFocus\"></atomic-text>\r\n          </div>\r\n          <div class=\"detail-item\">\r\n            <span class=\"fw-bold\">Research Type</span>: \r\n            <atomic-text field=\"researchType\"></atomic-text>\r\n          </div>\r\n          <div class=\"detail-item\">\r\n            <span class=\"fw-bold\">Timeline</span>: \r\n            <atomic-text field=\"timeline\"></atomic-text>\r\n          </div>\r\n          <div class=\"detail-item\">\r\n            <span class=\"fw-bold\">Study Status</span>: \r\n            <atomic-text field=\"studyStatus\"></atomic-text>\r\n          </div>\r\n        </div> -->\r\n      </div>\r\n    </atomic-result-link>\r\n  </template>\r\n"

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"results"}},[_c('atomic-smart-snippet'),_vm._v(" "),_c('atomic-smart-snippet-suggestions'),_vm._v(" "),_c('atomic-result-list',{attrs:{"density":"compact","image-size":"none","display":"list"}},[_c('atomic-result-template',{domProps:{"innerHTML":_vm._s(_vm.hcxfResearchResultTemplate)}})],1),_vm._v(" "),_c('atomic-query-error'),_vm._v(" "),_c('atomic-no-results')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d837bd70_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_status_vue__ = __webpack_require__(593);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d837bd70_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"status"}},[_c('atomic-breadbox'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between flex-column flex-md-row align-items-md-center"},[_c('query-summary'),_vm._v(" "),_c('atomic-sort-dropdown',{staticClass:"pt-3 pt-md-0"},[_c('atomic-sort-expression',{attrs:{"label":"most-recent","expression":"date descending"}}),_vm._v(" "),_c('atomic-sort-expression',{attrs:{"label":"relevance","expression":"studyz32xstatus ascending"}})],1)],1),_vm._v(" "),_c('atomic-did-you-mean'),_vm._v(" "),_c('atomic-notifications')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c632db70_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_hub_details_vue__ = __webpack_require__(595);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c632db70_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_research_hub_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-component',{attrs:{"title":"HCxF Research Hub Details"}},[_c('div',{staticClass:"HCxF"},[_c('div',{staticClass:"hcxf-research-hub-details"},[_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"c-promo--shadows"},[_c('div',[_c('div',{staticClass:"d-flex c-simple-tabs"},[_c('div',{staticClass:"col-sm-12"},[_c('b-tabs',{directives:[{name:"tabs-custom-tabbing",rawName:"v-tabs-custom-tabbing"}],attrs:{"vertical":"","nav-wrapper-class":"col-md-4 tabs__nav tabs__nav--phd-community","content-class":"tab-content--phd-community"}},[_c('b-tab',{attrs:{"title":"Overview","active":""}},[_c('simple-accordion',{attrs:{"title":"Overview","variant":"phd-community"}},[_c('h2',{staticClass:"h3"},[_vm._v("Overview")]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"PHD__article-link-container"},[_c('a',{staticClass:"PHD__article-link",attrs:{"href":"#"}},[_vm._v("Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping")]),_vm._v(" "),_c('span',{staticClass:"PHD__article-metadata"},[_vm._v("01/01/2020 | "),_c('a',{staticClass:"PHD__article-source-link",attrs:{"href":"#"}},[_vm._v("Hypertension")])])]),_vm._v(" "),_c('div',{staticClass:"news-link news-link--phd-community"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_c('a',{staticClass:"c-cta c-cta--arrow",attrs:{"href":"#"}},[_vm._v("VIEW ALL Related Journals Content")])])])])])])])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Project Aims"}},[_c('simple-accordion',{attrs:{"title":"Project Aims","variant":"phd-community"}},[_c('h2',{staticClass:"h3"},[_vm._v("Project Aims")]),_vm._v(" "),_c('div',{staticClass:"project-aims-container"},[_c('section',{staticClass:"project-aims-section"},[_c('h3',{staticClass:"title"},[_vm._v("Aim One")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("\n                                                Increase awareness of and advocate for FIM interventions, targeting healthcare systems, the media, and policy makers, that can improve nutrition security and increase health equity.\n                                            ")])]),_vm._v(" "),_c('section',{staticClass:"project-aims-section"},[_c('h3',{staticClass:"title"},[_vm._v("Aim One")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("\n                                                Increase awareness of and advocate for FIM interventions, targeting healthcare systems, the media, and policy makers, that can improve nutrition security and increase health equity.\n                                            ")])]),_vm._v(" "),_c('section',{staticClass:"project-aims-section"},[_c('h3',{staticClass:"title"},[_vm._v("Aim One")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v("\n                                                Increase awareness of and advocate for FIM interventions, targeting healthcare systems, the media, and policy makers, that can improve nutrition security and increase health equity.\n                                            ")])])])])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Project Details"}},[_c('simple-accordion',{attrs:{"title":"Project Details","variant":"phd-community"}},[_c('h2',{staticClass:"h3"},[_vm._v("Project Details")]),_vm._v(" "),_c('main',[_c('div',{staticClass:"project-details-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"project-detail-item"},[_c('h3',{staticClass:"title"},[_vm._v("Principal Investigator")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("\n                                        Dr.\n                                        Adrian\n                                        Hernandez\n                                    ")])]),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("Co_I")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("\n                                        Dr.\n                                        Beth\n                                        Nauman\n                                    ")])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("\n                                        Dr.\n                                        Bridget\n                                        Simon-Freidt\n                                    ")])]),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("Coordinator")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("\n                                        \n                                        Sarah\n                                        Palmer\n                                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"project-detail-item"},[_c('h3',{staticClass:"title"},[_vm._v("Founders")]),_vm._v(" "),_c('div',[_vm._v("\n                            Funder 1\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"project-detail-item"},[_c('h3',{staticClass:"title"},[_vm._v("TimeLine")]),_vm._v(" "),_c('div',[_vm._v("\n                        2023 -  2025\n                    ")])])])])])])])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Publications"}},[_c('simple-accordion',{attrs:{"title":"Publications","variant":"phd-community"}},[_c('h2',{staticClass:"h3"},[_vm._v("Publications")]),_vm._v(" "),_c('section',{staticClass:"publications-container"},[_c('section',{staticClass:"publication-item"},[_c('div',{staticClass:"title"},[_vm._v("\n                                                Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n                                                01/01/2020 | Hypertension\n                                            ")])]),_vm._v(" "),_c('section',{staticClass:"publication-item"},[_c('div',{staticClass:"title"},[_vm._v("\n                                                Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n                                                01/01/2020 | Hypertension\n                                            ")])]),_vm._v(" "),_c('section',{staticClass:"publication-item"},[_c('div',{staticClass:"title"},[_vm._v("\n                                                Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n                                                01/01/2020 | Hypertension\n                                            ")])]),_vm._v(" "),_c('section',{staticClass:"publication-item"},[_c('div',{staticClass:"title"},[_vm._v("\n                                                Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n                                                01/01/2020 | Hypertension\n                                            ")])]),_vm._v(" "),_c('section',{staticClass:"publication-item"},[_c('div',{staticClass:"title"},[_vm._v("\n                                                Comprehensive Analysis of Steroid Biomarkers for Guiding Primary Aldosteronism Subtyping\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n                                                01/01/2020 | Hypertension\n                                            ")])])])])],1)],1)],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f863f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_news_vue__ = __webpack_require__(599);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57f863f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(598);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b50ca1fe", content, true, {});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".HCxF .c-listing-header{margin:0;padding:0}.HCxF .c-listing-header__heading{margin-bottom:0}.heading-container .container-fluid{padding-inline:0}.HCxF .heading-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-bottom:4px}@media (min-width:768px){.HCxF .heading-container{padding-top:30px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}", ""]);

// exports


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HCxF"},[_c('atomic-search-interface',{staticClass:"container container-fluid research-hub",attrs:{"fields-to-include":"[\"bodyz32xtez120xt\",\"summary\",\"newsz32xpublishz32xdate\",\"isez120xternallink\"]","search-hub":_vm.searchHub}},[_c('div',{staticClass:"heading-container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.listingHeader)}}),_vm._v(" "),_c('hcxf-news-status')],1),_vm._v(" "),_c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-lg-9"},[_c('atomic-layout-section',{attrs:{"section":"main"}},[_c('hcxf-news-results'),_vm._v(" "),_c('coveoPagination')],1)],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59af63ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_news_status_vue__ = __webpack_require__(601);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59af63ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_news_status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"status"}},[_c('atomic-sort-dropdown',{staticClass:"pt-3 pt-md-0"},[_c('atomic-sort-expression',{attrs:{"label":"most-recent","expression":"date descending","state":"active"}}),_vm._v(" "),_c('atomic-sort-expression',{attrs:{"label":"relevance","expression":"relevancy"}})],1),_vm._v(" "),_c('atomic-did-you-mean'),_vm._v(" "),_c('atomic-notifications')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_results_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_results_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_results_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_results_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_results_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c26b4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_news_results_vue__ = __webpack_require__(604);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcxf_news_results_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c26b4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcxf_news_results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = "<template>\r\n    <style>\r\n        .result-link {\r\n             a {\r\n                &:hover, &:visited {\r\n                    text-decoration: none;\r\n                    color: inherit;\r\n                }\r\n            }\r\n        }\r\n\r\n        .result-item {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 4px;\r\n            padding-block: 16px;  \r\n            border-bottom: 1px solid #c3c3c3;\r\n            \r\n            @media (min-width : 768px) {\r\n                padding-block: 30px;\r\n            }\r\n        }\r\n\r\n        .result-title {\r\n            color: var(--Text-text-title-default, #042358);\r\n            font-family: Montserrat;\r\n            font-size: 24px;\r\n            font-style: normal;\r\n            font-weight: 600;\r\n            line-height: normal;\r\n        }\r\n\r\n        .result-source, .result-date  {\r\n            color: var(--Text-text-body-dark, #000);\r\n            font-family: Montserrat;\r\n            font-size: 16px;\r\n            font-style: normal;\r\n            font-weight: 400;\r\n            line-height: 24px;\r\n        }\r\n    </style>\r\n \r\n    <section class=\"result-item\">\r\n        <atomic-result-link href-template='${clickUri}' class=\"result-link\">\r\n            <atomic-result-text class=\"result-title\" field=\"bodyz32xtez120xt\"></atomic-result-text>\r\n        </atomic-result-link>\r\n\r\n        <div class=\"result-source\">\r\n            <strong>Source: </strong>\r\n            <atomic-result-text class=\"\" field=\"summary\"></atomic-result-text>\r\n        </div>\r\n        \r\n        <div class=\"result-date\">\r\n            <strong>Date: </strong>\r\n            <atomic-result-date format=\"MMMM DD, YYYY\" field=\"newsz32xpublishz32xdate\"></atomic-result-date>\r\n        </div>\r\n        <atomic-result-text class=\"isExternal\"  field=\"isez120xternallink\" hidden=\"hidden\"></atomic-result-text>\r\n            \r\n    </section>\r\n</template>\r\n<template slot=\"link\">\r\n    \r\n</template>"

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"results"}},[_c('atomic-smart-snippet'),_vm._v(" "),_c('atomic-smart-snippet-suggestions'),_vm._v(" "),_c('atomic-result-list',{attrs:{"density":"compact","image-size":"none","display":"list"}},[_c('atomic-result-template',{domProps:{"innerHTML":_vm._s(_vm.defaultResultTemplate)}})],1),_vm._v(" "),_c('atomic-query-error'),_vm._v(" "),_c('atomic-no-results')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _wbwbDashboardAlert = __webpack_require__(606);

var _wbwbDashboardAlert2 = _interopRequireDefault(_wbwbDashboardAlert);

var _wbwbEventList = __webpack_require__(608);

var _wbwbEventList2 = _interopRequireDefault(_wbwbEventList);

var _wbwbEventSearch = __webpack_require__(612);

var _wbwbEventSearch2 = _interopRequireDefault(_wbwbEventSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// WBWB Components
_vue2['default'].component('wbwb-dashboard-alert', _wbwbDashboardAlert2['default']);
_vue2['default'].component('wbwb-event-list', _wbwbEventList2['default']);
_vue2['default'].component('wbwb-event-search', _wbwbEventSearch2['default']);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_dashboard_alert_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_dashboard_alert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_dashboard_alert_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_dashboard_alert_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_dashboard_alert_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9bc23ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wbwb_dashboard_alert_vue__ = __webpack_require__(607);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_dashboard_alert_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9bc23ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wbwb_dashboard_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"c-dashboard__message",attrs:{"role":"alert"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n  "),_c('button',{staticClass:"c-dashboard__message__close",attrs:{"aria-label":"close"},on:{"click":_vm.hideMessage}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_list_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c1c78c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wbwb_event_list_vue__ = __webpack_require__(611);
function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c1c78c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wbwb_event_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(610);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0ebe4b09", content, true, {});

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".c-events-list{-webkit-padding-after:6rem;padding-block-end:6rem}", ""]);

// exports


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-events-list"},[_c('div',{staticClass:"c-events-list__wrapper"},[_c('div',{staticClass:"c-events-list__header"},[_c('h1',{staticClass:"c-events-list__heading"},[_vm._v("\n        "+_vm._s(_vm.translations.EventsListHeading)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"c-events-list__filters"},_vm._l((_vm.filters),function(filter){return _c('div',{key:filter.id,staticClass:"c-events-list__filter"},[_c('label',{attrs:{"for":filter.id}},[_c('span',[_vm._v(_vm._s(filter.label))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.checked),expression:"filter.checked"}],attrs:{"type":"checkbox","id":filter.id},domProps:{"checked":Array.isArray(filter.checked)?_vm._i(filter.checked,null)>-1:(filter.checked)},on:{"change":[function($event){var $$a=filter.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(filter, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(filter, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(filter, "checked", $$c)}},_vm.handleFilterChange]}})])])}),0)]),_vm._v(" "),_c('div',{attrs:{"aria-live":"polite"}},[(_vm.loading)?_c('div',{staticClass:"c-events-list__loading",staticStyle:{"padding":"3rem 0 0","text-align":"center"}},[_vm._v("\n        "+_vm._s(_vm.translations.LoadingText || "Loading...")+"\n      ")]):_c('ul',{staticClass:"c-events-list__events"},[(_vm.displayedEvents.length === 0)?_c('li',{staticClass:"c-events-list__event--no-results c-dashboard__card__no-events"},[_c('h3',[_vm._v(_vm._s(_vm.translations.NoEventsText || "No events found."))])]):_vm._l((_vm.displayedEvents),function(event){return _c('li',{key:event.id,staticClass:"c-events-list__event"},[_c('div',{staticClass:"c-events-list__event__info"},[_c('h2',[_c('a',{attrs:{"href":event.greeting_url,"target":"_blank","rel":"noopener noreferrer"},domProps:{"innerHTML":_vm._s(event.name)}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatDate(event.event_date)))])])])})],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_search_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_search_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_search_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_search_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_588ac64b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wbwb_event_search_vue__ = __webpack_require__(615);
function injectStyle (ssrContext) {
  __webpack_require__(613)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-588ac64b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wbwb_event_search_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_588ac64b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wbwb_event_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(614);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("20057285", content, true, {});

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".loading[data-v-588ac64b]{text-align:center;padding:2rem}.c-dashboard__card__form__action[data-v-588ac64b]:after,.c-dashboard__card__form__action[data-v-588ac64b]:before{display:none}button[data-v-588ac64b]:disabled{background:#222;cursor:not-allowed}.events-grid .event-card[data-v-588ac64b]:nth-child(5){display:none}.error-message[data-v-588ac64b]{color:#dc2626;font-size:1.25rem;margin-top:.5rem}.input-wrapper input[aria-invalid=true][data-v-588ac64b]{border-color:#dc2626}", ""]);

// exports


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-dashboard__card"},[_c('h2',{staticClass:"c-dashboard__card__title"},[_vm._v("\n    "+_vm._s(_vm.translations.HeartChallengeTitle)+"\n  ")]),_vm._v(" "),_c('h3',{staticClass:"c-dashboard__card__heading"},[_vm._v("\n    "+_vm._s(_vm.translations.HeartChallengeHeading)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"c-dashboard__card__body"},[_vm._v(_vm._s(_vm.translations.HeartChallengeBody))]),_vm._v(" "),_c('form',{staticClass:"c-dashboard__card__form",on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"c-dashboard__card__form__group"},[_c('div',{staticClass:"c-dashboard__card__form__field"},[_c('label',{attrs:{"for":"heart-challenge-distance"}},[_vm._v(_vm._s(_vm.translations.HeartChallengeDistanceLabel))]),_vm._v(" "),_c('div',{staticClass:"input-wrapper input-wrapper--select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.distance),expression:"formData.distance"}],attrs:{"id":"heart-challenge-distance"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "distance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.clearState]}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Select distance")]),_vm._v(" "),_vm._l((_vm.HeartChallengeMiles),function(dist){return _c('option',{key:dist.DistanceValue,domProps:{"value":dist.DistanceValue}},[_vm._v("\n              "+_vm._s(dist.DistanceText)+"\n            ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"c-dashboard__card__form__field"},[_c('label',{attrs:{"for":"heart-challenge-zip"}},[_vm._v("\n          "+_vm._s(_vm.translations.HeartChallengeZipcodeLabel)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.zipCode),expression:"formData.zipCode"}],attrs:{"type":"text","maxlength":"5","pattern":"[0-9]{5}","inputmode":"numeric","placeholder":"Enter ZIP code","id":"heart-challenge-zip","aria-invalid":_vm.zipCodeError !== '',"aria-errormessage":_vm.zipCodeError ? 'zip-error' : undefined},domProps:{"value":(_vm.formData.zipCode)},on:{"change":_vm.validateZipCode,"keypress":_vm.validateKeyPress,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "zipCode", $event.target.value)}}})]),_vm._v(" "),(_vm.zipCodeError)?_c('div',{staticClass:"error-message",attrs:{"id":"zip-error","role":"alert"}},[_vm._v("\n          "+_vm._s(_vm.zipCodeError)+"\n        ")]):_vm._e()]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"c-dashboard__card__form__field"},[_c('label',{attrs:{"for":"heart-challenge-state"}},[_vm._v(_vm._s(_vm.translations.HeartChallengeStateLabel))]),_vm._v(" "),_c('div',{staticClass:"input-wrapper input-wrapper--select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.state),expression:"formData.state"}],attrs:{"id":"heart-challenge-state"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.clearZipAndDistance]}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Select state")]),_vm._v(" "),_vm._l((_vm.HeartChallengeStates),function(state){return _c('option',{key:state.title,attrs:{"aria-label":state.title},domProps:{"value":state.code}},[_vm._v("\n              "+_vm._s(state.title)+"\n            ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"c-dashboard__card__form__action"},[_c('button',{staticClass:"c-dashboard__card__cta",attrs:{"type":"submit","disabled":!_vm.isFormValid}},[_vm._v("\n        "+_vm._s(_vm.translations.HeartChallengeCtaText)+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"c-dashboard__card__events",attrs:{"aria-live":"polite","role":"region","aria-label":"Event search results"}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Loading...")]):[(_vm.events.length)?_c('div',{staticClass:"c-dashboard__card__events-grid events-grid"},_vm._l((_vm.events),function(event,index){return _c('div',{key:event.id,staticClass:"event-card"},[_c('div',{staticClass:"event-card__header"},[_c('img',{staticClass:"event-card__image",attrs:{"src":_vm.getEventImagePath(event.name, index),"alt":event.name}}),_vm._v(" "),_c('div',{staticClass:"event-card__date"},[_c('span',[_vm._v(_vm._s(_vm.formatMonth(event.event_date)))]),_vm._v("\n              "+_vm._s(_vm.formatDay(event.event_date))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"event-card__body"},[_c('div',{staticClass:"event-card__info"},[_c('h3',[_c('a',{attrs:{"href":event.greeting_url},domProps:{"innerHTML":_vm._s(event.name)}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatFullDate(event.event_date)))])])])])}),0):_vm._e(),_vm._v(" "),(_vm.events.length && _vm.events.length > 4)?_c('div',{staticClass:"c-dashboard__card__events-cta"},[_c('a',{staticClass:"c-dashboard__card__events-cta",attrs:{"href":_vm.viewMoreUrl}},[_vm._v("\n          "+_vm._s(_vm.translations.HeartChallengeEventsCtaText)+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.searchPerformed && _vm.events.length === 0)?_c('div',{staticClass:"c-dashboard__card__no-events"},[_c('h3',[_vm._v(_vm._s(_vm.translations.HeartChallengeNoEventsText))])]):_vm._e()]],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-dashboard__card__form__separator"},[_c('span',[_vm._v("OR")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(221);

__webpack_require__(228);

__webpack_require__(730);

__webpack_require__(237);

__webpack_require__(634);

__webpack_require__(96);

__webpack_require__(238);

/***/ }),
/* 728 */,
/* 729 */,
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[727]);


// WEBPACK FOOTER //
// app.bundle.js